import * as x1 from "vue";
import { defineComponent as _, openBlock as b, createBlock as k, resolveDynamicComponent as Qt, withCtx as y, createElementVNode as O, normalizeClass as fe, unref as c, renderSlot as E, createElementBlock as D, computed as M, Fragment as Me, renderList as it, createCommentVNode as X, resolveDirective as $m, withDirectives as hr, ref as B, createVNode as x, useSlots as Nc, toDisplayString as U, createSlots as k2, createTextVNode as K, shallowRef as Da, watch as De, getCurrentScope as _2, onScopeDispose as S2, shallowReadonly as aa, getCurrentInstance as sn, toHandlerKey as E5, camelize as E2, toRef as Bo, Comment as O5, mergeProps as j, cloneVNode as T5, h as Yt, toRefs as at, nextTick as Be, onMounted as Ge, withKeys as ur, normalizeProps as Le, guardReactiveProps as Ve, reactive as Zo, withModifiers as At, watchEffect as vt, markRaw as wm, watchSyncEffect as A5, vShow as xm, isRef as Br, Teleport as Pc, onBeforeUnmount as xr, onBeforeMount as M5, normalizeStyle as Zi, effectScope as O2, onUnmounted as Qn, vModelSelect as N5, toRaw as P5, inject as Kn, provide as Jn, customRef as T2, readonly as od, onBeforeUpdate as D5, onUpdated as A2, mergeDefaults as M2, watchPostEffect as I5, createPropsRestProxy as R5, toValue as we, warn as N2, useId as B5, mergeModels as Mt, useModel as St, useAttrs as Dc, vModelDynamic as L5, render as C1, createStaticVNode as Cm, vModelText as P2, resolveComponent as F5 } from "vue";
import { useFocus as V5, createInjectionState as z5 } from "@vueuse/core";
function D2(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number")
    r += n;
  else if (typeof n == "object")
    if (Array.isArray(n)) {
      var o = n.length;
      for (e = 0; e < o; e++)
        n[e] && (t = D2(n[e])) && (r && (r += " "), r += t);
    } else
      for (t in n)
        n[t] && (r && (r += " "), r += t);
  return r;
}
function I2() {
  for (var n, e, t = 0, r = "", o = arguments.length; t < o; t++)
    (n = arguments[t]) && (e = D2(n)) && (r && (r += " "), r += e);
  return r;
}
const k1 = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, _1 = I2, tn = (n, e) => (t) => {
  var r;
  if (e?.variants == null)
    return _1(n, t?.class, t?.className);
  const { variants: o, defaultVariants: i } = e, a = Object.keys(o).map((d) => {
    const u = t?.[d], f = i?.[d];
    if (u === null)
      return null;
    const p = k1(u) || k1(f);
    return o[d][p];
  }), s = t && Object.entries(t).reduce((d, u) => {
    let [f, p] = u;
    return p === void 0 || (d[f] = p), d;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, u) => {
    let { class: f, className: p, ...h } = u;
    return Object.entries(h).every((m) => {
      let [g, v] = m;
      return Array.isArray(v) ? v.includes({
        ...i,
        ...s
      }[g]) : {
        ...i,
        ...s
      }[g] === v;
    }) ? [
      ...d,
      f,
      p
    ] : d;
  }, []);
  return _1(n, a, l, t?.class, t?.className);
}, Ns = {
  maxWidth: {
    "8xl": "120rem"
  },
  translate: {
    8.5: "2.129rem"
  },
  spacing: {
    // eslint-disable-next-line style/quote-props
    "5.5": "1.4rem",
    // eslint-disable-next-line style/quote-props
    "6.5": "1.75rem"
  },
  fontSize: {
    "fluid-xxxs": "var(--step--4)",
    "fluid-xxs": "var(--step--3)",
    "fluid-xs": "var(--step--2)",
    "fluid-sm": "var(--step--1)",
    "fluid-base": "var(--step-0)",
    "fluid-lg": "var(--step-1)",
    "fluid-xl": "var(--step-2)",
    "fluid-2xl": "var(--step-3)",
    "fluid-3xl": "var(--step-4)",
    "fluid-4xl": "var(--step-5)",
    "fluid-5xl": "var(--step-6)",
    "fluid-6xl": "var(--step-7)",
    "fluid-7xl": "var(--step-8)",
    "fluid-8xl": "var(--step-9)",
    "fluid-9xl": "var(--step-10)"
  },
  colors: {
    border: "hsl(var(--border) / <alpha-value>)",
    ring: "hsl(var(--ring) / <alpha-value>)",
    background: "hsl(var(--background) / <alpha-value>)",
    foreground: "hsl(var(--foreground) / <alpha-value>)",
    primary: {
      DEFAULT: "hsl(var(--primary) / <alpha-value>)",
      foreground: "hsl(var(--primary-foreground) / <alpha-value>)"
    },
    secondary: {
      DEFAULT: "hsl(var(--secondary) / <alpha-value>)",
      foreground: "hsl(var(--secondary-foreground) / <alpha-value>)"
    },
    destructive: {
      DEFAULT: "hsl(var(--destructive) / <alpha-value>)",
      foreground: "hsl(var(--destructive-foreground) / <alpha-value>)"
    },
    muted: {
      DEFAULT: "hsl(var(--muted) / <alpha-value>)",
      foreground: "hsl(var(--muted-foreground) / <alpha-value>)"
    },
    accent: {
      DEFAULT: "hsl(var(--accent) / <alpha-value>)",
      foreground: "hsl(var(--accent-foreground) / <alpha-value>)"
    },
    popover: {
      DEFAULT: "hsl(var(--popover) / <alpha-value>)",
      foreground: "hsl(var(--popover-foreground) / <alpha-value>)"
    },
    card: {
      DEFAULT: "hsl(var(--card) / <alpha-value>)",
      foreground: "hsl(var(--card-foreground) / <alpha-value>)"
    },
    info: {
      DEFAULT: "hsl(var(--info) / <alpha-value>)",
      foreground: "hsl(var(--info-foreground) / <alpha-value>)"
    },
    success: {
      DEFAULT: "hsl(var(--success) / <alpha-value>)",
      foreground: "hsl(var(--success-foreground) / <alpha-value>)"
    },
    warning: {
      DEFAULT: "hsl(var(--warning) / <alpha-value>)",
      foreground: "hsl(var(--warning-foreground) / <alpha-value>)"
    },
    error: {
      DEFAULT: "hsl(var(--error) / <alpha-value>)",
      foreground: "hsl(var(--error-foreground) / <alpha-value>)"
    }
  },
  borderRadius: {
    DEFAULT: "var(--radius)",
    xl: "var(--radius)",
    lg: "var(--radius)",
    md: "var(--radius-md)",
    sm: "var(--radius-sm)",
    xs: "var(--radius-xs)",
    checkbox: "min(var(--radius), 5px)",
    20: "var(--radius-20)"
  },
  boxShadow: {
    DEFAULT: "var(--shadow)"
  },
  keyframes: {
    "accordion-down": {
      from: { height: "0" },
      to: { height: "var(--radix-accordion-content-height)" }
    },
    "accordion-up": {
      from: { height: "var(--radix-accordion-content-height)" },
      to: { height: "0" }
    },
    "collapsible-down": {
      from: { height: "0" },
      to: { height: "var(--radix-collapsible-content-height)" }
    },
    "collapsible-up": {
      from: { height: "var(--radix-collapsible-content-height)" },
      to: { height: "0" }
    }
  },
  animation: {
    "accordion-down": "accordion-down 0.2s ease-out",
    "accordion-up": "accordion-up 0.2s ease-out",
    "collapsible-down": "collapsible-down 0.2s ease-in-out",
    "collapsible-up": "collapsible-up 0.2s ease-in-out"
  },
  containers: {
    "3xs": "12rem",
    "2xs": "16rem"
  }
}, km = "-", j5 = (n) => {
  const e = U5(n), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = n;
  return {
    getClassGroupId: (a) => {
      const s = a.split(km);
      return s[0] === "" && s.length !== 1 && s.shift(), R2(s, e) || H5(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const l = t[a] || [];
      return s && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, R2 = (n, e) => {
  if (n.length === 0)
    return e.classGroupId;
  const t = n[0], r = e.nextPart.get(t), o = r ? R2(n.slice(1), r) : void 0;
  if (o)
    return o;
  if (e.validators.length === 0)
    return;
  const i = n.join(km);
  return e.validators.find(({
    validator: a
  }) => a(i))?.classGroupId;
}, S1 = /^\[(.+)\]$/, H5 = (n) => {
  if (S1.test(n)) {
    const e = S1.exec(n)[1], t = e?.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, U5 = (n) => {
  const {
    theme: e,
    prefix: t
  } = n, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return W5(Object.entries(n.classGroups), t).forEach(([i, a]) => {
    qp(a, r, i, e);
  }), r;
}, qp = (n, e, t, r) => {
  n.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? e : E1(e, o);
      i.classGroupId = t;
      return;
    }
    if (typeof o == "function") {
      if (K5(o)) {
        qp(o(r), e, t, r);
        return;
      }
      e.validators.push({
        validator: o,
        classGroupId: t
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      qp(a, E1(e, i), t, r);
    });
  });
}, E1 = (n, e) => {
  let t = n;
  return e.split(km).forEach((r) => {
    t.nextPart.has(r) || t.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(r);
  }), t;
}, K5 = (n) => n.isThemeGetter, W5 = (n, e) => e ? n.map(([t, r]) => {
  const o = r.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [e + a, s])) : i);
  return [t, o];
}) : n, q5 = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    t.set(i, a), e++, e > n && (e = 0, r = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = t.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      t.has(i) ? t.set(i, a) : o(i, a);
    }
  };
}, B2 = "!", G5 = (n) => {
  const {
    separator: e,
    experimentalParseClassName: t
  } = n, r = e.length === 1, o = e[0], i = e.length, a = (s) => {
    const l = [];
    let d = 0, u = 0, f;
    for (let v = 0; v < s.length; v++) {
      let $ = s[v];
      if (d === 0) {
        if ($ === o && (r || s.slice(v, v + i) === e)) {
          l.push(s.slice(u, v)), u = v + i;
          continue;
        }
        if ($ === "/") {
          f = v;
          continue;
        }
      }
      $ === "[" ? d++ : $ === "]" && d--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(B2), m = h ? p.substring(1) : p, g = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: g
    };
  };
  return t ? (s) => t({
    className: s,
    parseClassName: a
  }) : a;
}, J5 = (n) => {
  if (n.length <= 1)
    return n;
  const e = [];
  let t = [];
  return n.forEach((r) => {
    r[0] === "[" ? (e.push(...t.sort(), r), t = []) : t.push(r);
  }), e.push(...t.sort()), e;
}, Z5 = (n) => ({
  cache: q5(n.cacheSize),
  parseClassName: G5(n),
  ...j5(n)
}), Y5 = /\s+/, X5 = (n, e) => {
  const {
    parseClassName: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = e, i = [], a = n.trim().split(Y5);
  let s = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const d = a[l], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = t(d);
    let m = !!h, g = r(m ? p.substring(0, h) : p);
    if (!g) {
      if (!m) {
        s = d + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = r(p), !g) {
        s = d + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const v = J5(u).join(":"), $ = f ? v + B2 : v, C = $ + g;
    if (i.includes(C))
      continue;
    i.push(C);
    const S = o(g, m);
    for (let w = 0; w < S.length; ++w) {
      const T = S[w];
      i.push($ + T);
    }
    s = d + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function Q5() {
  let n = 0, e, t, r = "";
  for (; n < arguments.length; )
    (e = arguments[n++]) && (t = L2(e)) && (r && (r += " "), r += t);
  return r;
}
const L2 = (n) => {
  if (typeof n == "string")
    return n;
  let e, t = "";
  for (let r = 0; r < n.length; r++)
    n[r] && (e = L2(n[r])) && (t && (t += " "), t += e);
  return t;
};
function O1(n, ...e) {
  let t, r, o, i = a;
  function a(l) {
    const d = e.reduce((u, f) => f(u), n());
    return t = Z5(d), r = t.cache.get, o = t.cache.set, i = s, s(l);
  }
  function s(l) {
    const d = r(l);
    if (d)
      return d;
    const u = X5(l, t);
    return o(l, u), u;
  }
  return function() {
    return i(Q5.apply(null, arguments));
  };
}
const bt = (n) => {
  const e = (t) => t[n] || [];
  return e.isThemeGetter = !0, e;
}, F2 = /^\[(?:([a-z-]+):)?(.+)\]$/i, ex = /^\d+\/\d+$/, tx = /* @__PURE__ */ new Set(["px", "full", "screen"]), nx = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, rx = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ox = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, ix = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ax = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Gr = (n) => ka(n) || tx.has(n) || ex.test(n), Oo = (n) => cs(n, "length", hx), ka = (n) => !!n && !Number.isNaN(Number(n)), Lf = (n) => cs(n, "number", ka), Cs = (n) => !!n && Number.isInteger(Number(n)), sx = (n) => n.endsWith("%") && ka(n.slice(0, -1)), He = (n) => F2.test(n), To = (n) => nx.test(n), lx = /* @__PURE__ */ new Set(["length", "size", "percentage"]), dx = (n) => cs(n, lx, V2), ux = (n) => cs(n, "position", V2), cx = /* @__PURE__ */ new Set(["image", "url"]), fx = (n) => cs(n, cx, gx), px = (n) => cs(n, "", mx), ks = () => !0, cs = (n, e, t) => {
  const r = F2.exec(n);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : t(r[2]) : !1;
}, hx = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  rx.test(n) && !ox.test(n)
), V2 = () => !1, mx = (n) => ix.test(n), gx = (n) => ax.test(n), T1 = () => {
  const n = bt("colors"), e = bt("spacing"), t = bt("blur"), r = bt("brightness"), o = bt("borderColor"), i = bt("borderRadius"), a = bt("borderSpacing"), s = bt("borderWidth"), l = bt("contrast"), d = bt("grayscale"), u = bt("hueRotate"), f = bt("invert"), p = bt("gap"), h = bt("gradientColorStops"), m = bt("gradientColorStopPositions"), g = bt("inset"), v = bt("margin"), $ = bt("opacity"), C = bt("padding"), S = bt("saturate"), w = bt("scale"), T = bt("sepia"), A = bt("skew"), N = bt("space"), z = bt("translate"), I = () => ["auto", "contain", "none"], P = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", He, e], H = () => [He, e], q = () => ["", Gr, Oo], Q = () => ["auto", ka, He], ae = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], de = () => ["solid", "dashed", "dotted", "double", "none"], ne = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ke = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], ee = () => ["", "0", He], be = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Ee = () => [ka, He];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [ks],
      spacing: [Gr, Oo],
      blur: ["none", "", To, He],
      brightness: Ee(),
      borderColor: [n],
      borderRadius: ["none", "", "full", To, He],
      borderSpacing: H(),
      borderWidth: q(),
      contrast: Ee(),
      grayscale: ee(),
      hueRotate: Ee(),
      invert: ee(),
      gap: H(),
      gradientColorStops: [n],
      gradientColorStopPositions: [sx, Oo],
      inset: L(),
      margin: L(),
      opacity: Ee(),
      padding: H(),
      saturate: Ee(),
      scale: Ee(),
      sepia: ee(),
      skew: Ee(),
      space: H(),
      translate: H()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", He]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [To]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": be()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": be()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...ae(), He]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: P()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": P()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": P()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Cs, He]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", He]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ee()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ee()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Cs, He]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ks]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Cs, He]
        }, He]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Q()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Q()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ks]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Cs, He]
        }, He]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Q()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Q()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...ke()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ke(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...ke(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [N]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [N]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", He, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [He, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [He, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [To]
        }, To]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [He, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [He, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [He, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [He, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", To, Oo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Lf]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ks]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", He]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ka, Lf]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Gr, He]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", He]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", He]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [n]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [$]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [n]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [$]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...de(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Gr, Oo]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Gr, He]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [n]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: H()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", He]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", He]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [$]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...ae(), ux]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", dx]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, fx]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [n]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [$]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...de(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [$]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: de()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...de()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Gr, He]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Gr, Oo]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [n]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: q()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [n]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [$]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Gr, Oo]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [n]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", To, px]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ks]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [$]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ne(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ne()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", To, He]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [d]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [T]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [d]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [$]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [T]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", He]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Ee()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", He]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Ee()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", He]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Cs, He]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [z]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [z]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", He]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", n]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", He]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [n]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": H()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": H()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": H()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": H()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": H()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": H()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": H()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": H()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": H()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": H()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": H()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": H()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": H()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": H()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": H()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": H()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": H()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": H()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", He]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [n, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Gr, Oo, Lf]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [n, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, vx = (n, {
  cacheSize: e,
  prefix: t,
  separator: r,
  experimentalParseClassName: o,
  extend: i = {},
  override: a = {}
}) => {
  Ps(n, "cacheSize", e), Ps(n, "prefix", t), Ps(n, "separator", r), Ps(n, "experimentalParseClassName", o);
  for (const s in a)
    yx(n[s], a[s]);
  for (const s in i)
    bx(n[s], i[s]);
  return n;
}, Ps = (n, e, t) => {
  t !== void 0 && (n[e] = t);
}, yx = (n, e) => {
  if (e)
    for (const t in e)
      Ps(n, t, e[t]);
}, bx = (n, e) => {
  if (e)
    for (const t in e) {
      const r = e[t];
      r !== void 0 && (n[t] = (n[t] || []).concat(r));
    }
}, $x = (n, ...e) => typeof n == "function" ? O1(T1, n, ...e) : O1(() => vx(T1(), n), ...e), Ia = [
  "focus-visible:outline",
  "focus-visible:outline-2",
  "focus-visible:outline-offset-2",
  "focus-visible:outline-primary",
  "focus:outline-none"
], wx = [
  "aria-[invalid=true]:border-destructive",
  "focus-visible:aria-[invalid=true]:outline-destructive"
];
function xx() {
  const n = [];
  for (const [e, t] of Object.entries(Ns.colors))
    if (typeof t == "string")
      n.push(e);
    else {
      const r = Object.keys(t).map(
        (o) => o === "DEFAULT" ? "" : o
      );
      n.push({ [e]: r });
    }
  return n;
}
const Cx = $x({
  extend: {
    theme: {
      colors: xx(),
      borderRadius: Object.keys(Ns.borderRadius),
      translate: Object.keys(Ns.translate)
    },
    classGroups: {
      "font-size": [
        {
          text: Object.keys(Ns.fontSize)
        }
      ],
      animate: [
        {
          animate: Object.keys(Ns.animation)
        }
      ]
    }
  }
});
function G(...n) {
  return Cx(I2(n));
}
const vl = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Card",
  props: {
    as: {},
    variant: {}
  },
  setup(n) {
    return (e, t) => (b(), k(Qt(e.as ?? "div"), { class: "h-full rounded-md @container" }, {
      default: y(() => [
        O("div", {
          class: fe(c(G)(c(Ax)({ variant: e.variant }), e.$attrs.class ?? ""))
        }, [
          E(e.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), Lo = /* @__PURE__ */ _({
  __name: "CardContent",
  props: {
    class: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(c(G)(`
      space-y-5 px-4
      @4xl:space-y-8 @4xl:px-20
    `, e.$props.class ?? ""))
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), z2 = /* @__PURE__ */ _({
  __name: "CardFooter",
  props: {
    class: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(c(G)(`
      rounded-b-md px-4
      @4xl:px-20
    `, e.$props.class ?? ""))
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), yl = /* @__PURE__ */ _({
  __name: "CardHeader",
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(c(G)(`
      flex flex-col space-y-4 rounded-t-md px-4 pt-8
      @4xl:space-y-8 @4xl:px-20 @4xl:pt-20
    `, e.$attrs.class ?? ""))
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), kx = ["media", "srcset", "width", "height"], _x = ["src", "width", "height", "srcset", "sizes", "alt", "loading", "fetchpriority"], ar = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Image",
  props: {
    image: {},
    width: {},
    height: {},
    fetchpriority: { default: "auto" },
    loading: { default: "lazy" },
    smart: { type: Boolean, default: !0 },
    responsive_widths: {},
    responsive_conditions: {},
    density_2x: { type: Boolean, default: !0 },
    density_3x: { type: Boolean, default: !0 },
    artDirection: {},
    wrapper_classes: {},
    proportionalCrop: {}
  },
  setup(n) {
    const e = M(() => n.image.alt ?? ""), t = M(() => n.image.focus), r = M(() => n.image.filename);
    function o(d, u) {
      return n.proportionalCrop === "width" ? { width: d, height: 0 } : n.proportionalCrop === "height" ? { width: 0, height: u } : { width: d, height: u };
    }
    function i(d) {
      const { source: u, width: f, height: p, focal: h } = d;
      if (!u)
        return "";
      const m = o(f, p);
      let g = `${u}/m/${m.width}x${m.height}`;
      return n.smart && !h && (g += "/smart"), h && (g += `/filters:focal(${h})`), g;
    }
    function a(d) {
      const { source: u, width: f, height: p, focal: h } = d, m = [
        `${i({ source: u, width: f, height: p, focal: h })} 1x`
      ];
      return n.density_2x && m.push(`${i({
        source: u,
        width: f * 2,
        height: p * 2,
        focal: h
      })} 2x`), n.density_3x && m.push(`${i({
        source: u,
        width: f * 3,
        height: p * 3,
        focal: h
      })} 3x`), m.join(", ");
    }
    function s(d) {
      if (!n.responsive_widths || !d)
        return "";
      const u = n.width / n.height;
      return n.responsive_widths.split(",").map((f) => {
        const p = Number(f), h = Math.round(p / u);
        return `${i({
          source: d,
          width: p,
          height: h,
          focal: t.value
        })} ${f}w`;
      }).join(", ");
    }
    const l = M(() => n.responsive_widths ? s(r.value) : a({
      source: r.value,
      width: n.width,
      height: n.height,
      focal: t.value
    }));
    return (d, u) => (b(), D("picture", {
      class: fe(d.wrapper_classes)
    }, [
      d.artDirection ? (b(!0), D(Me, { key: 0 }, it(d.artDirection, ({ image: f, media_condition: p, width: h, height: m }) => (b(), D("source", {
        key: f.id,
        media: p,
        srcset: a({
          source: f.filename,
          width: h,
          height: m,
          focal: f.focus
        }),
        width: h,
        height: m
      }, null, 8, kx))), 128)) : X("", !0),
      O("img", {
        src: i({
          source: r.value,
          width: d.width,
          height: d.height,
          focal: t.value
        }),
        width: d.width,
        height: d.height,
        srcset: l.value,
        sizes: d.responsive_conditions,
        alt: e.value ?? "",
        loading: d.loading ? d.loading : void 0,
        fetchpriority: d.fetchpriority,
        class: fe(d.$attrs.class)
      }, null, 10, _x)
    ], 2));
  }
}), Sx = { class: "aspect-video overflow-hidden rounded-md rounded-bl-none" }, Ex = {
  key: 1,
  class: "h-full bg-primary/50"
}, Ox = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CardImage",
  props: {
    image: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", Sx, [
      e.image ? (b(), k(c(ar), {
        key: 0,
        image: e.image,
        width: 580,
        height: 330,
        class: fe(c(G)(`
        size-full object-cover transition duration-300 ease-out
        group-hover:scale-105 group-hover:brightness-90
      `, e.$attrs.class ?? ""))
      }, null, 8, ["image", "class"])) : (b(), D("div", Ex))
    ]));
  }
}), ZG = /* @__PURE__ */ _({
  __name: "TypographyH1",
  setup(n) {
    return (e, t) => (b(), D("h1", {
      class: fe(c(G)(`
      hyphens-auto text-balance text-fluid-5xl font-bold text-foreground
    `, e.$attrs.class ?? "")),
      lang: "de"
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), YG = /* @__PURE__ */ _({
  __name: "TypographyH2",
  setup(n) {
    return (e, t) => (b(), D("h2", {
      class: fe(c(G)(`
      hyphens-auto text-balance text-fluid-3xl font-bold text-foreground
      [&:not(:first-child)]:mt-10
    `, e.$attrs.class ?? "")),
      lang: "de"
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), XG = /* @__PURE__ */ _({
  __name: "TypographyH3",
  setup(n) {
    return (e, t) => (b(), D("h3", {
      class: fe(c(G)(`
      hyphens-auto text-balance text-fluid-lg font-bold text-foreground
      [&:not(:first-child)]:mt-10
    `, e.$attrs.class ?? "")),
      lang: "de"
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), Tx = /* @__PURE__ */ _({
  __name: "TypographyP",
  setup(n) {
    return (e, t) => (b(), D("p", {
      class: fe(c(G)(`
      text-fluid-base font-medium text-foreground
      [&:not(:first-child)]:mt-5
      lg:[&:not(:first-child)]:mt-10
    `, e.$attrs.class ?? ""))
    }, [
      E(e.$slots, "default")
    ], 2));
  }
}), Oe = /* @__PURE__ */ _({
  __name: "Text",
  props: {
    tag: {},
    paragraph: {},
    class: {}
  },
  setup(n) {
    return (e, t) => {
      const r = $m("id");
      return hr((b(), k(Qt(e.tag), {
        class: fe(c(G)(c(Ic)({ tag: e.tag, paragraph: e.paragraph }), e.$props.class ?? "")),
        lang: "de"
      }, {
        default: y(() => [
          E(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"])), [
        [r]
      ]);
    };
  }
}), Ic = tn(
  "",
  {
    variants: {
      tag: {
        h1: `
          hyphens-auto text-balance text-fluid-5xl font-bold leading-tight
          text-primary
          print:text-2xl
        `,
        h2: `
          hyphens-auto text-balance text-fluid-3xl font-bold leading-tight
          text-primary
          [&:not(:first-child)]:mt-10
          print:text-xl
        `,
        h3: `
          hyphens-auto text-balance text-fluid-lg font-bold leading-tight
          text-primary
          [&:not(:first-child)]:mt-10
          print:text-lg
        `,
        h4: `
          hyphens-auto text-balance text-fluid-base font-bold leading-tight
          text-primary
          [&:not(:first-child)]:mt-10
          print:text-base
        `,
        h5: `
          hyphens-auto text-balance text-fluid-base font-bold leading-tight
          text-primary
          [&:not(:first-child)]:mt-10
          print:text-sm
        `,
        h6: `
          hyphens-auto text-balance text-fluid-base font-bold leading-tight
          text-primary
          [&:not(:first-child)]:mt-10
          print:text-xs
        `,
        p: "font-medium",
        span: "font-medium",
        li: `
          pl-4 text-fluid-base font-medium
          [&:not(li_li)]:first:mt-8
          [ol>&]:list-decimal
          [ul>&]:list-disc
          lg:[&:not(li_li)]:first:mt-10
          print:text-xs
        `
      },
      paragraph: {
        default: "",
        label: "text-fluid-xxs"
      }
    },
    compoundVariants: [
      {
        tag: "p",
        paragraph: "default",
        class: `
          text-fluid-base
          [&:not(:first-child)]:mt-5
          lg:[&:not(:first-child)]:mt-10
          print:text-xs
        `
      },
      {
        tag: "span",
        paragraph: "default",
        class: `
          text-fluid-base
          print:text-xs
        `
      }
    ],
    defaultVariants: {
      tag: "p",
      paragraph: "default"
    }
  }
), gu = /* @__PURE__ */ _({
  __name: "CardTitle",
  props: {
    level: { default: 0 }
  },
  setup(n) {
    const e = B(null), t = M(() => {
      switch (n.level) {
        case 2:
          return "h2";
        default:
          return "h3";
      }
    });
    return (r, o) => (b(), D("div", {
      ref_key: "cardTitle",
      ref: e
    }, [
      x(c(Oe), {
        tag: t.value,
        class: fe(r.$attrs.class ?? "")
      }, {
        default: y(() => [
          E(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["tag", "class"])
    ], 512));
  }
}), Ax = tn(
  [`
    space-y-6 rounded-md pb-8 text-card-foreground
    @4xl:space-y-8 @4xl:pb-20
  `],
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        muted: "bg-muted text-foreground",
        primary: `
          bg-primary text-primary-foreground
          dark:border dark:border-border dark:bg-card dark:text-card-foreground
        `
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Mx = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function Nx(n, e) {
  return b(), D("svg", Mx, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.877 7.5a6.623 6.623 0 1 1 13.246 0a6.623 6.623 0 0 1-13.246 0M7.5 1.827a5.673 5.673 0 0 0-4.193 9.494A4.97 4.97 0 0 1 7.5 9.025a4.97 4.97 0 0 1 4.193 2.296A5.673 5.673 0 0 0 7.5 1.827m3.482 10.152A4.02 4.02 0 0 0 7.5 9.975a4.02 4.02 0 0 0-3.482 2.004A5.65 5.65 0 0 0 7.5 13.173c1.312 0 2.52-.446 3.482-1.194M5.15 6.505a2.35 2.35 0 1 1 4.7 0a2.35 2.35 0 0 1-4.7 0m2.35-1.4a1.4 1.4 0 1 0 0 2.8a1.4 1.4 0 0 0 0-2.8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Px = { name: "radix-icons-avatar", render: Nx }, Dx = { class: "flex items-center gap-x-6" }, Ix = { class: "text-fluid-xxxs font-medium" }, Rx = { class: "mt-8 @4xl:mt-10" }, QG = /* @__PURE__ */ _({
  __name: "CardComment",
  props: {
    image: {},
    truncate: { type: Boolean },
    hideImage: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => (b(), k(c(vl), {
      variant: "muted",
      class: "overflow-visible"
    }, {
      default: y(() => [
        x(c(yl), { class: "speech-bubble rounded-t-md bg-primary py-8 text-primary-foreground @4xl:p-10" }, {
          default: y(() => [
            O("div", Dx, [
              e.image ? (b(), k(c(ar), {
                key: 0,
                image: e.image,
                width: 80,
                height: 80,
                class: "size-20 overflow-hidden rounded-full"
              }, null, 8, ["image"])) : e.hideImage ? X("", !0) : (b(), k(c(Px), {
                key: 1,
                class: "size-20 text-primary-foreground/50",
                "aria-hidden": "true"
              })),
              O("div", Ix, [
                E(e.$slots, "header")
              ])
            ])
          ]),
          _: 3
        }),
        x(c(Lo), null, {
          default: y(() => [
            O("div", Rx, [
              E(e.$slots, "content")
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Bx = /* @__PURE__ */ _({
  __name: "Grid",
  props: {
    cols: {}
  },
  setup(n) {
    const e = M(() => {
      let t = "";
      switch (n.cols) {
        case 1:
          t = "grid-cols-1";
          break;
        case 2:
          t = "grid-cols-1 sm:grid-cols-2";
          break;
        case 3:
          t = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
          break;
        case 4:
          t = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4";
          break;
        case 5:
          t = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5";
          break;
        default:
          t = "grid-cols-1";
          break;
      }
      return t;
    });
    return (t, r) => (b(), D("div", {
      class: fe(c(G)(`
      grid gap-x-6 gap-y-10
      lg:gap-y-20
    `, e.value, t.$attrs.class ?? ""))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), eJ = /* @__PURE__ */ _({
  __name: "CardGrid",
  setup(n) {
    return (e, t) => (b(), k(c(Bx), {
      cols: 3,
      class: "relative"
    }, {
      default: y(() => [
        E(e.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Lx = { class: "flex flex-col" }, Fx = ["href", "target", "aria-label"], Vx = { class: "ignore-header" }, zx = ["href"], j2 = /* @__PURE__ */ _({
  __name: "CardImageTeaser",
  props: {
    title: {},
    image: {},
    href: {},
    level: {},
    target: {}
  },
  setup(n) {
    const e = Nc();
    return (t, r) => (b(), k(c(vl), {
      class: "group relative flex h-full flex-col transition-shadow brutal:border has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-primary has-[.card-link:focus-visible]:outline hover:shadow hover:transition-shadow",
      as: "article"
    }, {
      default: y(() => [
        O("div", Lx, [
          x(c(yl), { class: "order-1 flex flex-none flex-col" }, {
            default: y(() => [
              O("a", {
                href: t.href,
                target: t.target || "_self",
                class: "order-1 cursor-pointer card-link after:absolute after:inset-0 focus-visible:outline-none",
                "aria-label": t.title
              }, [
                x(c(gu), {
                  class: "mt-2 text-primary",
                  level: t.level || 3
                }, {
                  default: y(() => [
                    O("span", Vx, U(t.title), 1)
                  ]),
                  _: 1
                }, 8, ["level"])
              ], 8, Fx),
              E(t.$slots, "header")
            ]),
            _: 3
          }),
          O("div", null, [
            O("a", {
              href: t.href,
              class: "after:absolute after:inset-0",
              "aria-hidden": "true",
              tabindex: "-1"
            }, [
              x(c(Ox), { image: t.image }, null, 8, ["image"])
            ], 8, zx)
          ])
        ]),
        c(e).content ? (b(), k(c(Lo), { key: 0 }, {
          default: y(() => [
            E(t.$slots, "content")
          ]),
          _: 3
        })) : X("", !0),
        c(e).footer ? (b(), k(c(z2), {
          key: 1,
          class: "flex grow flex-col justify-end"
        }, {
          default: y(() => [
            E(t.$slots, "footer")
          ]),
          _: 3
        })) : X("", !0)
      ]),
      _: 3
    }));
  }
}), Rc = tn(
  [`
    inline-flex items-center justify-center rounded-sm transition-colors
    disabled:pointer-events-none disabled:opacity-50
    focus-visible:outline-none
  `, ...Ia],
  {
    variants: {
      variant: {
        primary: `
          bg-primary text-primary-foreground
          dark:hover:bg-primary/80
          focus-visible:bg-accent focus-visible:text-accent-foreground
          hover:bg-accent hover:text-accent-foreground
        `,
        destructive: `
          bg-destructive text-destructive-foreground
          focus-visible:bg-destructive
          hover:bg-destructive/90
        `,
        outline: `
          border-[1.5px] border-primary/20 bg-transparent text-primary
          hover:border-primary
        `,
        secondary: `
          bg-secondary text-secondary-foreground
          hover:bg-secondary/80
        `,
        ghost: `
          bg-transparent text-primary
          dark:hover:text-white
          focus-visible:bg-accent focus-visible:text-accent-foreground
          hover:bg-accent hover:text-accent-foreground
        `,
        link: `
          bg-transparent text-primary underline-offset-4
          focus-visible:outline-dashed
          hover:text-foreground hover:underline
        `,
        inverted: `
          rounded-xs bg-primary-foreground text-primary
          focus-visible:bg-accent focus-visible:text-accent-foreground
          hover:bg-accent hover:text-accent-foreground
        `
      },
      size: {
        small: "px-4 py-2 text-fluid-xxxs font-bold",
        default: `
          p-4 text-fluid-xxxs font-bold
          @md:px-10 @md:py-5
        `,
        full: `
          w-full p-4 text-fluid-xxxs font-bold
          @md:px-10 @md:py-5
        `,
        large: "px-10 py-5 text-fluid-xxxs font-bold",
        fulllarge: "w-full px-10 py-5 text-fluid-xxxs font-bold",
        icon: "size-10"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    },
    compoundVariants: [
      {
        variant: "link",
        size: "default",
        className: "rounded-xs p-0"
      }
    ]
  }
), Re = /* @__PURE__ */ _({
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "default" },
    as: { default: "button" },
    type: {}
  },
  setup(n) {
    return (e, t) => (b(), k(Qt(e.as), {
      class: fe(c(G)(c(Rc)({ variant: e.variant, size: e.size }), e.$attrs.class ?? "")),
      type: !e.type && e.as === "button" ? "button" : e.type
    }, {
      default: y(() => [
        E(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "type"]));
  }
}), jx = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function Hx(n, e) {
  return b(), D("svg", jx, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 13.5V.5M10.5 4L7 .5L3.5 4"
    }, null, -1)
  ]));
}
const Ux = { name: "streamline-arrow-up-1", render: Hx }, Kx = {
  key: 0,
  class: "flex justify-end"
}, Wx = { class: "" }, tJ = /* @__PURE__ */ _({
  __name: "CardPageTeaser",
  props: {
    title: {},
    image: {},
    href: {},
    level: {},
    target: {},
    description: {},
    buttonText: {},
    buttonVariant: {}
  },
  setup(n) {
    return (e, t) => (b(), k(c(j2), {
      title: e.title,
      href: e.href,
      image: e.image,
      level: e.level,
      target: e.target ? e.target : void 0
    }, k2({
      content: y(() => [
        x(c(Oe), { tag: "p" }, {
          default: y(() => [
            K(U(e.description), 1)
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      e.buttonText ? {
        name: "footer",
        fn: y(() => [
          O("div", null, [
            e.buttonVariant === "ghost" ? (b(), D("div", Kx, [
              x(c(Re), {
                variant: e.buttonVariant,
                as: "a",
                href: e.href,
                class: "relative"
              }, {
                default: y(() => [
                  O("span", Wx, U(e.buttonText), 1),
                  x(c(Ux), { class: "ml-6 rotate-90" })
                ]),
                _: 1
              }, 8, ["variant", "href"])
            ])) : (b(), k(c(Re), {
              key: 1,
              class: "relative",
              as: "a",
              size: "full",
              href: e.href,
              variant: e.buttonVariant
            }, {
              default: y(() => [
                K(U(e.buttonText), 1)
              ]),
              _: 1
            }, 8, ["href", "variant"]))
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["title", "href", "image", "level", "target"]));
  }
}), qx = { class: "relative flex w-full flex-auto justify-center" }, Gx = { class: "hidden xl:relative xl:block xl:flex-none" }, Jx = { class: "sticky top-0 h-[calc(100vh-0rem)] overflow-y-auto overflow-x-hidden py-16 pr-0 has-[*]:w-72 xl:pr-0" }, nJ = /* @__PURE__ */ _({
  __name: "ContentLayout",
  setup(n) {
    return (e, t) => (b(), k(c(Ri), null, {
      default: y(() => [
        O("div", qx, [
          O("div", Gx, [
            O("div", Jx, [
              E(e.$slots, "left")
            ])
          ]),
          O("div", {
            class: fe(["min-w-0 flex-auto", e.$slots.left ? "xl:pl-12" : ""])
          }, [
            O("article", {
              class: fe(["w-[min(65ch,100%)] text-fluid-base", e.$slots.left ?? "mx-auto"])
            }, [
              E(e.$slots, "default")
            ], 2)
          ], 2)
        ])
      ]),
      _: 3
    }));
  }
}), Yi = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, o] of e)
    t[r] = o;
  return t;
}, Zx = {}, Yx = { class: "mb-[clamp(80px,6vw,160px)]" };
function Xx(n, e) {
  return b(), D("div", Yx, [
    E(n.$slots, "default")
  ]);
}
const rJ = /* @__PURE__ */ Yi(Zx, [["render", Xx]]), Qx = {}, e8 = { class: "mx-auto [--innerWidth:1920px] [--pad-inner:clamp(1.25rem,-0.1433rem-0.1433rem+6.3694vw,7.5rem)] [inline-size:min(100%-var(--pad-inner)*2,var(--innerWidth))]" };
function t8(n, e) {
  return b(), D("div", e8, [
    E(n.$slots, "default")
  ]);
}
const Ri = /* @__PURE__ */ Yi(Qx, [["render", t8]]), A1 = /* @__PURE__ */ _({
  __name: "Image",
  props: {
    image: {},
    imagePosition: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(["relative lg:col-span-5 xl:absolute xl:inset-0", [e.imagePosition === "right" ? `
      -order-1 mr-[calc(var(--pad-inner)*-1)]
      lg:order-none
      xl:left-1/2 xl:mr-0
    ` : `
      ml-[calc(var(--pad-inner)*-1)]
      xl:right-1/2 xl:ml-0
    `]])
    }, [
      x(c(ar), {
        width: 750,
        height: 600,
        class: fe(["aspect-[37/30] w-full object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full", [e.imagePosition === "right" ? `
        rounded-bl-[120px]
        lg:ml-0 lg:rounded-bl-[190px]
      ` : `
        rounded-tr-[120px]
        lg:mr-0 lg:rounded-tr-[190px]
      `]]),
        image: e.image,
        "art-direction": [
          {
            image: e.image,
            media_condition: "(max-width: 639px)",
            width: 600,
            height: 500
          },
          {
            image: e.image,
            media_condition: "(min-width: 768px) and (max-width: 1023px)",
            width: 1e3,
            height: 800
          },
          {
            image: e.image,
            media_condition: "(min-width: 1024px) and (max-width: 1279px)",
            width: 500,
            height: 500
          },
          {
            image: e.image,
            media_condition: "(min-width: 1280px) and (max-width: 1999px)",
            width: 1e3,
            height: 650
          },
          {
            image: e.image,
            media_condition: "(min-width: 2000px) and (max-width: 2560px)",
            width: 1280,
            height: 650
          },
          {
            image: e.image,
            media_condition: "(min-width: 2561px)",
            width: 1500,
            height: 650
          }
        ]
      }, null, 8, ["class", "image", "art-direction"])
    ], 2));
  }
}), n8 = { class: "mx-auto max-w-2xl space-y-6 lg:mx-0" }, r8 = { class: "flex items-center gap-x-6" }, o8 = /* @__PURE__ */ _({
  __name: "Text",
  props: {
    headline: {},
    description: {},
    button: {},
    imagePosition: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(["mt-8 lg:col-span-7 lg:mt-0 lg:py-24 lg:pb-16", [e.imagePosition === "right" ? "xl:col-span-6" : `
      xl:col-span-5 xl:col-start-8
    `]])
    }, [
      O("div", n8, [
        x(c(Oe), { tag: "h2" }, {
          default: y(() => [
            K(U(e.headline), 1)
          ]),
          _: 1
        }),
        e.description ? (b(), k(c(Oe), {
          key: 0,
          tag: "p"
        }, {
          default: y(() => [
            K(U(e.description), 1)
          ]),
          _: 1
        })) : X("", !0),
        O("div", r8, [
          x(c(Re), {
            as: "a",
            href: e.button.href,
            target: e.button.target || "_self",
            class: "w-full lg:w-auto"
          }, {
            default: y(() => [
              K(U(e.button.text), 1)
            ]),
            _: 1
          }, 8, ["href", "target"])
        ])
      ])
    ], 2));
  }
}), i8 = { class: "relative" }, oJ = /* @__PURE__ */ _({
  __name: "ImageLeftRightTeaser",
  props: {
    headline: {},
    description: {},
    image: {},
    button: {},
    imagePosition: { default: "right" }
  },
  setup(n) {
    return (e, t) => (b(), D("div", i8, [
      x(c(Ri), { class: "flex flex-col lg:grid lg:min-h-[500px] lg:grid-cols-12 lg:gap-x-8 xl:min-h-[650px]" }, {
        default: y(() => [
          e.imagePosition === "left" ? (b(), k(A1, {
            key: 0,
            image: e.image,
            "image-position": e.imagePosition
          }, null, 8, ["image", "image-position"])) : X("", !0),
          x(o8, {
            "image-position": e.imagePosition,
            headline: e.headline,
            description: e.description,
            button: e.button
          }, null, 8, ["image-position", "headline", "description", "button"]),
          e.imagePosition === "right" ? (b(), k(A1, {
            key: 1,
            image: e.image,
            "image-position": e.imagePosition
          }, null, 8, ["image", "image-position"])) : X("", !0)
        ]),
        _: 1
      })
    ]));
  }
}), a8 = { class: "min-[1000px]:hidden" }, s8 = { class: "bg-primary pt-8" }, l8 = { class: "py-8" }, d8 = { class: "relative flex h-[300px] flex-col bg-primary min-[300px]:h-[400px] min-[400px]:h-[500px] min-[500px]:h-[600px]" }, u8 = { class: "pointer-events-none absolute top-[-80px] flex w-full gap-4 px-8 min-[600px]:pl-[100px] min-[700px]:pl-[200px] min-[800px]:pl-[300px] min-[900px]:pl-[400px]" }, c8 = { class: "aspect-[2/3] w-2/3 translate-y-[80px] overflow-hidden rounded-md rounded-tl-none" }, f8 = { class: "flex w-1/3 flex-col gap-4" }, p8 = { class: "aspect-[2/3] overflow-hidden rounded-md rounded-br-none" }, h8 = { class: "aspect-[2/3] overflow-hidden rounded-md rounded-br-none" }, m8 = { class: "mb-[160px] hidden rounded-br-[190px] bg-primary pb-28 pt-32 text-primary-foreground min-[1000px]:block" }, g8 = { class: "grid grid-cols-12 gap-x-6" }, v8 = { class: "col-span-4 col-start-2 space-y-8" }, y8 = { class: "relative col-span-6 grid grid-cols-subgrid items-center" }, b8 = { class: "col-span-3 col-start-2 aspect-[2/3] overflow-hidden rounded-md rounded-tl-none" }, $8 = { class: "relative col-span-2 aspect-[2/3] overflow-hidden rounded-md rounded-br-none" }, w8 = { class: "absolute left-1/2 top-full aspect-[2/3] w-[150px] -translate-y-8 overflow-hidden rounded-lg rounded-br-none" }, iJ = /* @__PURE__ */ _({
  __name: "SpecialPageTeaser",
  props: {
    title: {},
    description: {},
    images: {},
    button: {}
  },
  setup(n) {
    return (e, t) => (b(), D(Me, null, [
      O("div", a8, [
        O("div", s8, [
          x(c(Ri), null, {
            default: y(() => [
              x(c(Oe), {
                tag: "h2",
                class: "text-primary-foreground"
              }, {
                default: y(() => [
                  K(U(e.title), 1)
                ]),
                _: 1
              }),
              e.description ? (b(), k(c(Oe), {
                key: 0,
                tag: "p",
                class: "text-primary-foreground"
              }, {
                default: y(() => [
                  K(U(e.description), 1)
                ]),
                _: 1
              })) : X("", !0),
              O("div", l8, [
                x(c(Re), {
                  as: "a",
                  href: e.button.href,
                  variant: "inverted"
                }, {
                  default: y(() => [
                    K(U(e.button.text), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ])
            ]),
            _: 1
          })
        ]),
        O("div", d8, [
          t[0] || (t[0] = O("div", { class: "h-1/3" }, null, -1)),
          t[1] || (t[1] = O("div", { class: "h-2/3 rounded-tl-[190px] bg-secondary dark:bg-background" }, null, -1)),
          O("div", u8, [
            O("div", c8, [
              x(c(ar), {
                width: 400,
                height: 600,
                image: e.images[0],
                class: "size-full object-cover"
              }, null, 8, ["image"])
            ]),
            O("div", f8, [
              O("div", p8, [
                x(c(ar), {
                  width: 200,
                  height: 300,
                  image: e.images[1],
                  class: "size-full object-cover"
                }, null, 8, ["image"])
              ]),
              O("div", h8, [
                x(c(ar), {
                  width: 200,
                  height: 300,
                  image: e.images[2],
                  class: "size-full object-cover"
                }, null, 8, ["image"])
              ])
            ])
          ])
        ])
      ]),
      t[3] || (t[3] = O("hr", null, null, -1)),
      O("div", m8, [
        x(c(Ri), null, {
          default: y(() => [
            O("div", g8, [
              O("div", v8, [
                x(c(Oe), {
                  tag: "h2",
                  class: "text-primary-foreground"
                }, {
                  default: y(() => [
                    K(U(e.title), 1)
                  ]),
                  _: 1
                }),
                x(c(Oe), { tag: "p" }, {
                  default: y(() => [
                    K(U(e.description), 1)
                  ]),
                  _: 1
                }),
                x(c(Re), {
                  as: "a",
                  href: e.button.href,
                  variant: "inverted"
                }, {
                  default: y(() => [
                    K(U(e.button.text), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              O("div", y8, [
                t[2] || (t[2] = O("div", { class: "absolute -bottom-64 -top-20 left-0 w-11/12 rounded-[190px] rounded-br-none rounded-tl-none bg-secondary dark:bg-background" }, null, -1)),
                O("div", b8, [
                  x(c(ar), {
                    width: 462,
                    height: 693,
                    image: e.images[0],
                    class: "relative size-full object-cover"
                  }, null, 8, ["image"])
                ]),
                O("div", $8, [
                  x(c(ar), {
                    width: 320,
                    height: 450,
                    image: e.images[1],
                    class: "size-full object-cover"
                  }, null, 8, ["image"])
                ]),
                O("div", w8, [
                  x(c(ar), {
                    width: 200,
                    height: 300,
                    image: e.images[2],
                    class: "size-full object-cover"
                  }, null, 8, ["image"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ], 64));
  }
});
function _a(n, e) {
  return n - e * Math.floor(n / e);
}
const H2 = 1721426;
function Ci(n, e, t, r) {
  e = id(n, e);
  let o = e - 1, i = -2;
  return t <= 2 ? i = 0 : zo(e) && (i = -1), H2 - 1 + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) + Math.floor((367 * t - 362) / 12 + i + r);
}
function zo(n) {
  return n % 4 === 0 && (n % 100 !== 0 || n % 400 === 0);
}
function id(n, e) {
  return n === "BC" ? 1 - e : e;
}
function Bc(n) {
  let e = "AD";
  return n <= 0 && (e = "BC", n = 1 - n), [
    e,
    n
  ];
}
const x8 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class mr {
  fromJulianDay(e) {
    let t = e, r = t - H2, o = Math.floor(r / 146097), i = _a(r, 146097), a = Math.floor(i / 36524), s = _a(i, 36524), l = Math.floor(s / 1461), d = _a(s, 1461), u = Math.floor(d / 365), f = o * 400 + a * 100 + l * 4 + u + (a !== 4 && u !== 4 ? 1 : 0), [p, h] = Bc(f), m = t - Ci(p, h, 1, 1), g = 2;
    t < Ci(p, h, 3, 1) ? g = 0 : zo(h) && (g = 1);
    let v = Math.floor(((m + g) * 12 + 373) / 367), $ = t - Ci(p, h, v, 1) + 1;
    return new Nt(p, h, v, $);
  }
  toJulianDay(e) {
    return Ci(e.era, e.year, e.month, e.day);
  }
  getDaysInMonth(e) {
    return x8[zo(e.year) ? "leapyear" : "standard"][e.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(e) {
    return 12;
  }
  getDaysInYear(e) {
    return zo(e.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(e) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(e) {
    return e.era === "BC";
  }
  balanceDate(e) {
    e.year <= 0 && (e.era = e.era === "BC" ? "AD" : "BC", e.year = 1 - e.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const C8 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Ra(n, e) {
  return e = Cn(e, n.calendar), n.era === e.era && n.year === e.year && n.month === e.month && n.day === e.day;
}
function k8(n, e) {
  return e = Cn(e, n.calendar), n = bl(n), e = bl(e), n.era === e.era && n.year === e.year && n.month === e.month;
}
function Ff(n, e) {
  return n.calendar.identifier === e.calendar.identifier && n.era === e.era && n.year === e.year && n.month === e.month && n.day === e.day;
}
function M1(n, e) {
  return n = bl(n), e = bl(e), n.calendar.identifier === e.calendar.identifier && n.era === e.era && n.year === e.year && n.month === e.month;
}
function _8(n, e) {
  return Ra(n, K2(e));
}
const S8 = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6
};
function U2(n, e, t) {
  let r = n.calendar.toJulianDay(n), o = t ? S8[t] : A8(e), i = Math.ceil(r + 1 - o) % 7;
  return i < 0 && (i += 7), i;
}
function E8(n) {
  return lo(Date.now(), n);
}
function K2(n) {
  return P8(E8(n));
}
function W2(n, e) {
  return n.calendar.toJulianDay(n) - e.calendar.toJulianDay(e);
}
function O8(n, e) {
  return N1(n) - N1(e);
}
function N1(n) {
  return n.hour * 36e5 + n.minute * 6e4 + n.second * 1e3 + n.millisecond;
}
let Vf = null;
function ad() {
  return Vf == null && (Vf = new Intl.DateTimeFormat().resolvedOptions().timeZone), Vf;
}
function bl(n) {
  return n.subtract({
    days: n.day - 1
  });
}
function P1(n) {
  return n.add({
    days: n.calendar.getDaysInMonth(n) - n.day
  });
}
const D1 = /* @__PURE__ */ new Map();
function T8(n) {
  if (Intl.Locale) {
    let t = D1.get(n);
    return t || (t = new Intl.Locale(n).maximize().region, t && D1.set(n, t)), t;
  }
  let e = n.split("-")[1];
  return e === "u" ? void 0 : e;
}
function A8(n) {
  let e = T8(n);
  return e && C8[e] || 0;
}
function Ba(n) {
  n = Cn(n, new mr());
  let e = id(n.era, n.year);
  return q2(e, n.month, n.day, n.hour, n.minute, n.second, n.millisecond);
}
function q2(n, e, t, r, o, i, a) {
  let s = /* @__PURE__ */ new Date();
  return s.setUTCHours(r, o, i, a), s.setUTCFullYear(n, e - 1, t), s.getTime();
}
function Gp(n, e) {
  if (e === "UTC")
    return 0;
  if (n > 0 && e === ad())
    return new Date(n).getTimezoneOffset() * -6e4;
  let { year: t, month: r, day: o, hour: i, minute: a, second: s } = G2(n, e);
  return q2(t, r, o, i, a, s, 0) - Math.floor(n / 1e3) * 1e3;
}
const I1 = /* @__PURE__ */ new Map();
function G2(n, e) {
  let t = I1.get(e);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: e,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), I1.set(e, t));
  let r = t.formatToParts(new Date(n)), o = {};
  for (let i of r)
    i.type !== "literal" && (o[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: o.era === "BC" || o.era === "B" ? -o.year + 1 : +o.year,
    month: +o.month,
    day: +o.day,
    hour: o.hour === "24" ? 0 : +o.hour,
    minute: +o.minute,
    second: +o.second
  };
}
const R1 = 864e5;
function M8(n, e, t, r) {
  return (t === r ? [
    t
  ] : [
    t,
    r
  ]).filter((i) => N8(n, e, i));
}
function N8(n, e, t) {
  let r = G2(t, e);
  return n.year === r.year && n.month === r.month && n.day === r.day && n.hour === r.hour && n.minute === r.minute && n.second === r.second;
}
function ao(n, e, t = "compatible") {
  let r = La(n);
  if (e === "UTC")
    return Ba(r);
  if (e === ad() && t === "compatible") {
    r = Cn(r, new mr());
    let l = /* @__PURE__ */ new Date(), d = id(r.era, r.year);
    return l.setFullYear(d, r.month - 1, r.day), l.setHours(r.hour, r.minute, r.second, r.millisecond), l.getTime();
  }
  let o = Ba(r), i = Gp(o - R1, e), a = Gp(o + R1, e), s = M8(r, e, o - i, o - a);
  if (s.length === 1)
    return s[0];
  if (s.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return s[0];
      case "later":
        return s[s.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(o - i, o - a);
    case "compatible":
    case "later":
      return Math.max(o - i, o - a);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function J2(n, e, t = "compatible") {
  return new Date(ao(n, e, t));
}
function lo(n, e) {
  let t = Gp(n, e), r = new Date(n + t), o = r.getUTCFullYear(), i = r.getUTCMonth() + 1, a = r.getUTCDate(), s = r.getUTCHours(), l = r.getUTCMinutes(), d = r.getUTCSeconds(), u = r.getUTCMilliseconds();
  return new Va(o < 1 ? "BC" : "AD", o < 1 ? -o + 1 : o, i, a, e, t, s, l, d, u);
}
function P8(n) {
  return new Nt(n.calendar, n.era, n.year, n.month, n.day);
}
function La(n, e) {
  let t = 0, r = 0, o = 0, i = 0;
  if ("timeZone" in n)
    ({ hour: t, minute: r, second: o, millisecond: i } = n);
  else if ("hour" in n && !e)
    return n;
  return e && ({ hour: t, minute: r, second: o, millisecond: i } = e), new Fa(n.calendar, n.era, n.year, n.month, n.day, t, r, o, i);
}
function Cn(n, e) {
  if (n.calendar.identifier === e.identifier)
    return n;
  let t = e.fromJulianDay(n.calendar.toJulianDay(n)), r = n.copy();
  return r.calendar = e, r.era = t.era, r.year = t.year, r.month = t.month, r.day = t.day, Bi(r), r;
}
function D8(n, e, t) {
  if (n instanceof Va)
    return n.timeZone === e ? n : R8(n, e);
  let r = ao(n, e, t);
  return lo(r, e);
}
function I8(n) {
  let e = Ba(n) - n.offset;
  return new Date(e);
}
function R8(n, e) {
  let t = Ba(n) - n.offset;
  return Cn(lo(t, e), n.calendar);
}
const _s = 36e5;
function Lc(n, e) {
  let t = n.copy(), r = "hour" in t ? V8(t, e) : 0;
  Jp(t, e.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, n), t.month += e.months || 0, Zp(t), Z2(t), t.day += (e.weeks || 0) * 7, t.day += e.days || 0, t.day += r, B8(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let o = t.calendar.getYearsInEra(t);
  if (t.year > o) {
    var i, a;
    let l = (i = (a = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(a, t);
    t.year = o, t.month = l ? 1 : t.calendar.getMonthsInYear(t), t.day = l ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let s = t.calendar.getMonthsInYear(t);
  return t.month > s && (t.month = s, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function Jp(n, e) {
  var t, r;
  !((t = (r = n.calendar).isInverseEra) === null || t === void 0) && t.call(r, n) && (e = -e), n.year += e;
}
function Zp(n) {
  for (; n.month < 1; )
    Jp(n, -1), n.month += n.calendar.getMonthsInYear(n);
  let e = 0;
  for (; n.month > (e = n.calendar.getMonthsInYear(n)); )
    n.month -= e, Jp(n, 1);
}
function B8(n) {
  for (; n.day < 1; )
    n.month--, Zp(n), n.day += n.calendar.getDaysInMonth(n);
  for (; n.day > n.calendar.getDaysInMonth(n); )
    n.day -= n.calendar.getDaysInMonth(n), n.month++, Zp(n);
}
function Z2(n) {
  n.month = Math.max(1, Math.min(n.calendar.getMonthsInYear(n), n.month)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day));
}
function Bi(n) {
  n.calendar.constrainDate && n.calendar.constrainDate(n), n.year = Math.max(1, Math.min(n.calendar.getYearsInEra(n), n.year)), Z2(n);
}
function Y2(n) {
  let e = {};
  for (let t in n)
    typeof n[t] == "number" && (e[t] = -n[t]);
  return e;
}
function X2(n, e) {
  return Lc(n, Y2(e));
}
function _m(n, e) {
  let t = n.copy();
  return e.era != null && (t.era = e.era), e.year != null && (t.year = e.year), e.month != null && (t.month = e.month), e.day != null && (t.day = e.day), Bi(t), t;
}
function vu(n, e) {
  let t = n.copy();
  return e.hour != null && (t.hour = e.hour), e.minute != null && (t.minute = e.minute), e.second != null && (t.second = e.second), e.millisecond != null && (t.millisecond = e.millisecond), F8(t), t;
}
function L8(n) {
  n.second += Math.floor(n.millisecond / 1e3), n.millisecond = Sd(n.millisecond, 1e3), n.minute += Math.floor(n.second / 60), n.second = Sd(n.second, 60), n.hour += Math.floor(n.minute / 60), n.minute = Sd(n.minute, 60);
  let e = Math.floor(n.hour / 24);
  return n.hour = Sd(n.hour, 24), e;
}
function F8(n) {
  n.millisecond = Math.max(0, Math.min(n.millisecond, 1e3)), n.second = Math.max(0, Math.min(n.second, 59)), n.minute = Math.max(0, Math.min(n.minute, 59)), n.hour = Math.max(0, Math.min(n.hour, 23));
}
function Sd(n, e) {
  let t = n % e;
  return t < 0 && (t += e), t;
}
function V8(n, e) {
  return n.hour += e.hours || 0, n.minute += e.minutes || 0, n.second += e.seconds || 0, n.millisecond += e.milliseconds || 0, L8(n);
}
function Sm(n, e, t, r) {
  let o = n.copy();
  switch (e) {
    case "era": {
      let s = n.calendar.getEras(), l = s.indexOf(n.era);
      if (l < 0)
        throw new Error("Invalid era: " + n.era);
      l = uo(l, t, 0, s.length - 1, r?.round), o.era = s[l], Bi(o);
      break;
    }
    case "year":
      var i, a;
      !((i = (a = o.calendar).isInverseEra) === null || i === void 0) && i.call(a, o) && (t = -t), o.year = uo(n.year, t, -1 / 0, 9999, r?.round), o.year === -1 / 0 && (o.year = 1), o.calendar.balanceYearMonth && o.calendar.balanceYearMonth(o, n);
      break;
    case "month":
      o.month = uo(n.month, t, 1, n.calendar.getMonthsInYear(n), r?.round);
      break;
    case "day":
      o.day = uo(n.day, t, 1, n.calendar.getDaysInMonth(n), r?.round);
      break;
    default:
      throw new Error("Unsupported field " + e);
  }
  return n.calendar.balanceDate && n.calendar.balanceDate(o), Bi(o), o;
}
function Q2(n, e, t, r) {
  let o = n.copy();
  switch (e) {
    case "hour": {
      let i = n.hour, a = 0, s = 23;
      if (r?.hourCycle === 12) {
        let l = i >= 12;
        a = l ? 12 : 0, s = l ? 23 : 11;
      }
      o.hour = uo(i, t, a, s, r?.round);
      break;
    }
    case "minute":
      o.minute = uo(n.minute, t, 0, 59, r?.round);
      break;
    case "second":
      o.second = uo(n.second, t, 0, 59, r?.round);
      break;
    case "millisecond":
      o.millisecond = uo(n.millisecond, t, 0, 999, r?.round);
      break;
    default:
      throw new Error("Unsupported field " + e);
  }
  return o;
}
function uo(n, e, t, r, o = !1) {
  if (o) {
    n += Math.sign(e), n < t && (n = r);
    let i = Math.abs(e);
    e > 0 ? n = Math.ceil(n / i) * i : n = Math.floor(n / i) * i, n > r && (n = t);
  } else
    n += e, n < t ? n = r - (t - n - 1) : n > r && (n = t + (n - r - 1));
  return n;
}
function eb(n, e) {
  let t;
  if (e.years != null && e.years !== 0 || e.months != null && e.months !== 0 || e.weeks != null && e.weeks !== 0 || e.days != null && e.days !== 0) {
    let o = Lc(La(n), {
      years: e.years,
      months: e.months,
      weeks: e.weeks,
      days: e.days
    });
    t = ao(o, n.timeZone);
  } else
    t = Ba(n) - n.offset;
  t += e.milliseconds || 0, t += (e.seconds || 0) * 1e3, t += (e.minutes || 0) * 6e4, t += (e.hours || 0) * 36e5;
  let r = lo(t, n.timeZone);
  return Cn(r, n.calendar);
}
function z8(n, e) {
  return eb(n, Y2(e));
}
function j8(n, e, t, r) {
  switch (e) {
    case "hour": {
      let o = 0, i = 23;
      if (r?.hourCycle === 12) {
        let m = n.hour >= 12;
        o = m ? 12 : 0, i = m ? 23 : 11;
      }
      let a = La(n), s = Cn(vu(a, {
        hour: o
      }), new mr()), l = [
        ao(s, n.timeZone, "earlier"),
        ao(s, n.timeZone, "later")
      ].filter((m) => lo(m, n.timeZone).day === s.day)[0], d = Cn(vu(a, {
        hour: i
      }), new mr()), u = [
        ao(d, n.timeZone, "earlier"),
        ao(d, n.timeZone, "later")
      ].filter((m) => lo(m, n.timeZone).day === d.day).pop(), f = Ba(n) - n.offset, p = Math.floor(f / _s), h = f % _s;
      return f = uo(p, t, Math.floor(l / _s), Math.floor(u / _s), r?.round) * _s + h, Cn(lo(f, n.timeZone), n.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Q2(n, e, t, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let o = Sm(La(n), e, t, r), i = ao(o, n.timeZone);
      return Cn(lo(i, n.timeZone), n.calendar);
    }
    default:
      throw new Error("Unsupported field " + e);
  }
}
function H8(n, e, t) {
  let r = La(n), o = vu(_m(r, e), e);
  if (o.compare(r) === 0)
    return n;
  let i = ao(o, n.timeZone, t);
  return Cn(lo(i, n.timeZone), n.calendar);
}
const U8 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
function B1(n) {
  let e = n.match(U8);
  if (!e)
    throw new Error("Invalid ISO 8601 date string: " + n);
  let t = new Nt(zf(e[1], 0, 9999), zf(e[2], 1, 12), 1);
  return t.day = zf(e[3], 0, t.calendar.getDaysInMonth(t)), t;
}
function zf(n, e, t) {
  let r = Number(n);
  if (r < e || r > t)
    throw new RangeError(`Value out of range: ${e} <= ${r} <= ${t}`);
  return r;
}
function K8(n) {
  return `${String(n.hour).padStart(2, "0")}:${String(n.minute).padStart(2, "0")}:${String(n.second).padStart(2, "0")}${n.millisecond ? String(n.millisecond / 1e3).slice(1) : ""}`;
}
function tb(n) {
  let e = Cn(n, new mr()), t;
  return e.era === "BC" ? t = e.year === 1 ? "0000" : "-" + String(Math.abs(1 - e.year)).padStart(6, "00") : t = String(e.year).padStart(4, "0"), `${t}-${String(e.month).padStart(2, "0")}-${String(e.day).padStart(2, "0")}`;
}
function nb(n) {
  return `${tb(n)}T${K8(n)}`;
}
function W8(n) {
  let e = Math.sign(n) < 0 ? "-" : "+";
  n = Math.abs(n);
  let t = Math.floor(n / 36e5), r = n % 36e5 / 6e4;
  return `${e}${String(t).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
function q8(n) {
  return `${nb(n)}${W8(n.offset)}[${n.timeZone}]`;
}
function G8(n, e) {
  if (e.has(n))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Em(n, e, t) {
  G8(n, e), e.set(n, t);
}
function Om(n) {
  let e = typeof n[0] == "object" ? n.shift() : new mr(), t;
  if (typeof n[0] == "string")
    t = n.shift();
  else {
    let a = e.getEras();
    t = a[a.length - 1];
  }
  let r = n.shift(), o = n.shift(), i = n.shift();
  return [
    e,
    t,
    r,
    o,
    i
  ];
}
var J8 = /* @__PURE__ */ new WeakMap();
class Nt {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Nt(this.calendar, this.era, this.year, this.month, this.day) : new Nt(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(e) {
    return Lc(this, e);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(e) {
    return X2(this, e);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(e) {
    return _m(this, e);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(e, t, r) {
    return Sm(this, e, t, r);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(e) {
    return J2(this, e);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return tb(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(e) {
    return W2(this, e);
  }
  constructor(...e) {
    Em(this, J8, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, i, a] = Om(e);
    this.calendar = t, this.era = r, this.year = o, this.month = i, this.day = a, Bi(this);
  }
}
var Z8 = /* @__PURE__ */ new WeakMap();
class Fa {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Fa(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Fa(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(e) {
    return Lc(this, e);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(e) {
    return X2(this, e);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(e) {
    return _m(vu(this, e), e);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(e, t, r) {
    switch (e) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Sm(this, e, t, r);
      default:
        return Q2(this, e, t, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(e, t) {
    return J2(this, e, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return nb(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(e) {
    let t = W2(this, e);
    return t === 0 ? O8(this, La(e)) : t;
  }
  constructor(...e) {
    Em(this, Z8, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, i, a] = Om(e);
    this.calendar = t, this.era = r, this.year = o, this.month = i, this.day = a, this.hour = e.shift() || 0, this.minute = e.shift() || 0, this.second = e.shift() || 0, this.millisecond = e.shift() || 0, Bi(this);
  }
}
var Y8 = /* @__PURE__ */ new WeakMap();
class Va {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Va(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Va(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(e) {
    return eb(this, e);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(e) {
    return z8(this, e);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(e, t) {
    return H8(this, e, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(e, t, r) {
    return j8(this, e, t, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return I8(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return q8(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(e) {
    return this.toDate().getTime() - D8(e, this.timeZone).toDate().getTime();
  }
  constructor(...e) {
    Em(this, Y8, {
      writable: !0,
      value: void 0
    });
    let [t, r, o, i, a] = Om(e), s = e.shift(), l = e.shift();
    this.calendar = t, this.era = r, this.year = o, this.month = i, this.day = a, this.timeZone = s, this.offset = l, this.hour = e.shift() || 0, this.minute = e.shift() || 0, this.second = e.shift() || 0, this.millisecond = e.shift() || 0, Bi(this);
  }
}
const Sa = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], X8 = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], Qd = [
  1867,
  1911,
  1925,
  1988,
  2018
], Po = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function L1(n) {
  const e = Sa.findIndex(([t, r, o]) => n.year < t || n.year === t && n.month < r || n.year === t && n.month === r && n.day < o);
  return e === -1 ? Sa.length - 1 : e === 0 ? 0 : e - 1;
}
function jf(n) {
  let e = Qd[Po.indexOf(n.era)];
  if (!e)
    throw new Error("Unknown era: " + n.era);
  return new Nt(n.year + e, n.month, n.day);
}
class Q8 extends mr {
  fromJulianDay(e) {
    let t = super.fromJulianDay(e), r = L1(t);
    return new Nt(this, Po[r], t.year - Qd[r], t.month, t.day);
  }
  toJulianDay(e) {
    return super.toJulianDay(jf(e));
  }
  balanceDate(e) {
    let t = jf(e), r = L1(t);
    Po[r] !== e.era && (e.era = Po[r], e.year = t.year - Qd[r]), this.constrainDate(e);
  }
  constrainDate(e) {
    let t = Po.indexOf(e.era), r = X8[t];
    if (r != null) {
      let [o, i, a] = r, s = o - Qd[t];
      e.year = Math.max(1, Math.min(s, e.year)), e.year === s && (e.month = Math.min(i, e.month), e.month === i && (e.day = Math.min(a, e.day)));
    }
    if (e.year === 1 && t >= 0) {
      let [, o, i] = Sa[t];
      e.month = Math.max(o, e.month), e.month === o && (e.day = Math.max(i, e.day));
    }
  }
  getEras() {
    return Po;
  }
  getYearsInEra(e) {
    let t = Po.indexOf(e.era), r = Sa[t], o = Sa[t + 1];
    if (o == null)
      return 9999 - r[0] + 1;
    let i = o[0] - r[0];
    return (e.month < o[1] || e.month === o[1] && e.day < o[2]) && i++, i;
  }
  getDaysInMonth(e) {
    return super.getDaysInMonth(jf(e));
  }
  getMinimumMonthInYear(e) {
    let t = F1(e);
    return t ? t[1] : 1;
  }
  getMinimumDayInMonth(e) {
    let t = F1(e);
    return t && e.month === t[1] ? t[2] : 1;
  }
  constructor(...e) {
    super(...e), this.identifier = "japanese";
  }
}
function F1(n) {
  if (n.year === 1) {
    let e = Po.indexOf(n.era);
    return Sa[e];
  }
}
const rb = -543;
class e6 extends mr {
  fromJulianDay(e) {
    let t = super.fromJulianDay(e), r = id(t.era, t.year);
    return new Nt(this, r - rb, t.month, t.day);
  }
  toJulianDay(e) {
    return super.toJulianDay(V1(e));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(e) {
    return super.getDaysInMonth(V1(e));
  }
  balanceDate() {
  }
  constructor(...e) {
    super(...e), this.identifier = "buddhist";
  }
}
function V1(n) {
  let [e, t] = Bc(n.year + rb);
  return new Nt(e, t, n.month, n.day);
}
const yu = 1911;
function ob(n) {
  return n.era === "minguo" ? n.year + yu : 1 - n.year + yu;
}
function z1(n) {
  let e = n - yu;
  return e > 0 ? [
    "minguo",
    e
  ] : [
    "before_minguo",
    1 - e
  ];
}
class t6 extends mr {
  fromJulianDay(e) {
    let t = super.fromJulianDay(e), r = id(t.era, t.year), [o, i] = z1(r);
    return new Nt(this, o, i, t.month, t.day);
  }
  toJulianDay(e) {
    return super.toJulianDay(j1(e));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(e) {
    let [t, r] = z1(ob(e));
    e.era = t, e.year = r;
  }
  isInverseEra(e) {
    return e.era === "before_minguo";
  }
  getDaysInMonth(e) {
    return super.getDaysInMonth(j1(e));
  }
  getYearsInEra(e) {
    return e.era === "before_minguo" ? 9999 : 9999 - yu;
  }
  constructor(...e) {
    super(...e), this.identifier = "roc";
  }
}
function j1(n) {
  let [e, t] = Bc(ob(n));
  return new Nt(e, t, n.month, n.day);
}
const H1 = 1948320, U1 = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class n6 {
  fromJulianDay(e) {
    let t = e - H1, r = 1 + Math.floor((33 * t + 3) / 12053), o = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), i = t - o, a = i < 216 ? Math.floor(i / 31) : Math.floor((i - 6) / 30), s = i - U1[a] + 1;
    return new Nt(this, r, a + 1, s);
  }
  toJulianDay(e) {
    let t = H1 - 1 + 365 * (e.year - 1) + Math.floor((8 * e.year + 21) / 33);
    return t += U1[e.month - 1], t += e.day, t;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(e) {
    return e.month <= 6 ? 31 : e.month <= 11 || _a(25 * e.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const Hf = 78, K1 = 80;
class r6 extends mr {
  fromJulianDay(e) {
    let t = super.fromJulianDay(e), r = t.year - Hf, o = e - Ci(t.era, t.year, 1, 1), i;
    o < K1 ? (r--, i = zo(t.year - 1) ? 31 : 30, o += i + 155 + 90 + 10) : (i = zo(t.year) ? 31 : 30, o -= K1);
    let a, s;
    if (o < i)
      a = 1, s = o + 1;
    else {
      let l = o - i;
      l < 155 ? (a = Math.floor(l / 31) + 2, s = l % 31 + 1) : (l -= 155, a = Math.floor(l / 30) + 7, s = l % 30 + 1);
    }
    return new Nt(this, r, a, s);
  }
  toJulianDay(e) {
    let t = e.year + Hf, [r, o] = Bc(t), i, a;
    return zo(o) ? (i = 31, a = Ci(r, o, 3, 21)) : (i = 30, a = Ci(r, o, 3, 22)), e.month === 1 ? a + e.day - 1 : (a += i + Math.min(e.month - 2, 5) * 31, e.month >= 8 && (a += (e.month - 7) * 30), a += e.day - 1, a);
  }
  getDaysInMonth(e) {
    return e.month === 1 && zo(e.year + Hf) || e.month >= 2 && e.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...e) {
    super(...e), this.identifier = "indian";
  }
}
const bu = 1948440, W1 = 1948439, jn = 1300, sa = 1600, o6 = 460322;
function $u(n, e, t, r) {
  return r + Math.ceil(29.5 * (t - 1)) + (e - 1) * 354 + Math.floor((3 + 11 * e) / 30) + n - 1;
}
function ib(n, e, t) {
  let r = Math.floor((30 * (t - e) + 10646) / 10631), o = Math.min(12, Math.ceil((t - (29 + $u(e, r, 1, 1))) / 29.5) + 1), i = t - $u(e, r, o, 1) + 1;
  return new Nt(n, r, o, i);
}
function q1(n) {
  return (14 + 11 * n) % 30 < 11;
}
class Tm {
  fromJulianDay(e) {
    return ib(this, bu, e);
  }
  toJulianDay(e) {
    return $u(bu, e.year, e.month, e.day);
  }
  getDaysInMonth(e) {
    let t = 29 + e.month % 2;
    return e.month === 12 && q1(e.year) && t++, t;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(e) {
    return q1(e.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class i6 extends Tm {
  fromJulianDay(e) {
    return ib(this, W1, e);
  }
  toJulianDay(e) {
    return $u(W1, e.year, e.month, e.day);
  }
  constructor(...e) {
    super(...e), this.identifier = "islamic-tbla";
  }
}
const a6 = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Yp, Ea;
function eu(n) {
  return o6 + Ea[n - jn];
}
function Ds(n, e) {
  let t = n - jn, r = 1 << 11 - (e - 1);
  return Yp[t] & r ? 30 : 29;
}
function G1(n, e) {
  let t = eu(n);
  for (let r = 1; r < e; r++)
    t += Ds(n, r);
  return t;
}
function J1(n) {
  return Ea[n + 1 - jn] - Ea[n - jn];
}
class s6 extends Tm {
  fromJulianDay(e) {
    let t = e - bu, r = eu(jn), o = eu(sa);
    if (t < r || t > o)
      return super.fromJulianDay(e);
    {
      let i = jn - 1, a = 1, s = 1;
      for (; s > 0; ) {
        i++, s = t - eu(i) + 1;
        let l = J1(i);
        if (s === l) {
          a = 12;
          break;
        } else if (s < l) {
          let d = Ds(i, a);
          for (a = 1; s > d; )
            s -= d, a++, d = Ds(i, a);
          break;
        }
      }
      return new Nt(this, i, a, t - G1(i, a) + 1);
    }
  }
  toJulianDay(e) {
    return e.year < jn || e.year > sa ? super.toJulianDay(e) : bu + G1(e.year, e.month) + (e.day - 1);
  }
  getDaysInMonth(e) {
    return e.year < jn || e.year > sa ? super.getDaysInMonth(e) : Ds(e.year, e.month);
  }
  getDaysInYear(e) {
    return e.year < jn || e.year > sa ? super.getDaysInYear(e) : J1(e.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Yp || (Yp = new Uint16Array(Uint8Array.from(atob(a6), (e) => e.charCodeAt(0)).buffer)), !Ea) {
      Ea = new Uint32Array(sa - jn + 1);
      let e = 0;
      for (let t = jn; t <= sa; t++) {
        Ea[t - jn] = e;
        for (let r = 1; r <= 12; r++)
          e += Ds(t, r);
      }
    }
  }
}
const Z1 = 347997, ab = 1080, sb = 24 * ab, l6 = 29, d6 = 12 * ab + 793, u6 = l6 * sb + d6;
function $i(n) {
  return _a(n * 7 + 1, 19) < 7;
}
function tu(n) {
  let e = Math.floor((235 * n - 234) / 19), t = 12084 + 13753 * e, r = e * 29 + Math.floor(t / 25920);
  return _a(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function c6(n) {
  let e = tu(n - 1), t = tu(n);
  return tu(n + 1) - t === 356 ? 2 : t - e === 382 ? 1 : 0;
}
function Zs(n) {
  return tu(n) + c6(n);
}
function lb(n) {
  return Zs(n + 1) - Zs(n);
}
function f6(n) {
  let e = lb(n);
  switch (e > 380 && (e -= 30), e) {
    case 353:
      return 0;
    case 354:
      return 1;
    case 355:
      return 2;
  }
}
function Ed(n, e) {
  if (e >= 6 && !$i(n) && e++, e === 4 || e === 7 || e === 9 || e === 11 || e === 13)
    return 29;
  let t = f6(n);
  return e === 2 ? t === 2 ? 30 : 29 : e === 3 ? t === 0 ? 29 : 30 : e === 6 ? $i(n) ? 30 : 0 : 30;
}
class p6 {
  fromJulianDay(e) {
    let t = e - Z1, r = t * sb / u6, o = Math.floor((19 * r + 234) / 235) + 1, i = Zs(o), a = Math.floor(t - i);
    for (; a < 1; )
      o--, i = Zs(o), a = Math.floor(t - i);
    let s = 1, l = 0;
    for (; l < a; )
      l += Ed(o, s), s++;
    s--, l -= Ed(o, s);
    let d = a - l;
    return new Nt(this, o, s, d);
  }
  toJulianDay(e) {
    let t = Zs(e.year);
    for (let r = 1; r < e.month; r++)
      t += Ed(e.year, r);
    return t + e.day + Z1;
  }
  getDaysInMonth(e) {
    return Ed(e.year, e.month);
  }
  getMonthsInYear(e) {
    return $i(e.year) ? 13 : 12;
  }
  getDaysInYear(e) {
    return lb(e.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(e, t) {
    t.year !== e.year && ($i(t.year) && !$i(e.year) && t.month > 6 ? e.month-- : !$i(t.year) && $i(e.year) && t.month > 6 && e.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Xp = 1723856, Y1 = 1824665, Qp = 5500;
function wu(n, e, t, r) {
  return n + 365 * e + Math.floor(e / 4) + 30 * (t - 1) + r - 1;
}
function Am(n, e) {
  let t = Math.floor(4 * (e - n) / 1461), r = 1 + Math.floor((e - wu(n, t, 1, 1)) / 30), o = e + 1 - wu(n, t, r, 1);
  return [
    t,
    r,
    o
  ];
}
function db(n) {
  return Math.floor(n % 4 / 3);
}
function ub(n, e) {
  return e % 13 !== 0 ? 30 : db(n) + 5;
}
class Mm {
  fromJulianDay(e) {
    let [t, r, o] = Am(Xp, e), i = "AM";
    return t <= 0 && (i = "AA", t += Qp), new Nt(this, i, t, r, o);
  }
  toJulianDay(e) {
    let t = e.year;
    return e.era === "AA" && (t -= Qp), wu(Xp, t, e.month, e.day);
  }
  getDaysInMonth(e) {
    return ub(e.year, e.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(e) {
    return 365 + db(e.year);
  }
  getYearsInEra(e) {
    return e.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class h6 extends Mm {
  fromJulianDay(e) {
    let [t, r, o] = Am(Xp, e);
    return t += Qp, new Nt(this, "AA", t, r, o);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...e) {
    super(...e), this.identifier = "ethioaa";
  }
}
class m6 extends Mm {
  fromJulianDay(e) {
    let [t, r, o] = Am(Y1, e), i = "CE";
    return t <= 0 && (i = "BCE", t = 1 - t), new Nt(this, i, t, r, o);
  }
  toJulianDay(e) {
    let t = e.year;
    return e.era === "BCE" && (t = 1 - t), wu(Y1, t, e.month, e.day);
  }
  getDaysInMonth(e) {
    let t = e.year;
    return e.era === "BCE" && (t = 1 - t), ub(t, e.month);
  }
  isInverseEra(e) {
    return e.era === "BCE";
  }
  balanceDate(e) {
    e.year <= 0 && (e.era = e.era === "BCE" ? "CE" : "BCE", e.year = 1 - e.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(e) {
    return e.era === "BCE" ? 9999 : 9715;
  }
  constructor(...e) {
    super(...e), this.identifier = "coptic";
  }
}
function g6(n) {
  switch (n) {
    case "buddhist":
      return new e6();
    case "ethiopic":
      return new Mm();
    case "ethioaa":
      return new h6();
    case "coptic":
      return new m6();
    case "hebrew":
      return new p6();
    case "indian":
      return new r6();
    case "islamic-civil":
      return new Tm();
    case "islamic-tbla":
      return new i6();
    case "islamic-umalqura":
      return new s6();
    case "japanese":
      return new Q8();
    case "persian":
      return new n6();
    case "roc":
      return new t6();
    case "gregory":
    default:
      return new mr();
  }
}
let Uf = /* @__PURE__ */ new Map();
class _r {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(e) {
    return this.formatter.format(e);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(e) {
    return this.formatter.formatToParts(e);
  }
  /** Formats a date range as a string. */
  formatRange(e, t) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(e, t);
    if (t < e)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(e)} – ${this.formatter.format(t)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(e, t) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(e, t);
    if (t < e)
      throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(e), o = this.formatter.formatToParts(t);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let e = this.formatter.resolvedOptions();
    return b6() && (this.resolvedHourCycle || (this.resolvedHourCycle = $6(e.locale, this.options)), e.hourCycle = this.resolvedHourCycle, e.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), e.calendar === "ethiopic-amete-alem" && (e.calendar = "ethioaa"), e;
  }
  constructor(e, t = {}) {
    this.formatter = cb(e, t), this.options = t;
  }
}
const v6 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function cb(n, e = {}) {
  if (typeof e.hour12 == "boolean" && y6()) {
    e = {
      ...e
    };
    let o = v6[String(e.hour12)][n.split("-")[0]], i = e.hour12 ? "h12" : "h23";
    e.hourCycle = o ?? i, delete e.hour12;
  }
  let t = n + (e ? Object.entries(e).sort((o, i) => o[0] < i[0] ? -1 : 1).join() : "");
  if (Uf.has(t))
    return Uf.get(t);
  let r = new Intl.DateTimeFormat(n, e);
  return Uf.set(t, r), r;
}
let Kf = null;
function y6() {
  return Kf == null && (Kf = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), Kf;
}
let Wf = null;
function b6() {
  return Wf == null && (Wf = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), Wf;
}
function $6(n, e) {
  if (!e.timeStyle && !e.hour)
    return;
  n = n.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), n += (n.includes("-u-") ? "" : "-u") + "-nu-latn";
  let t = cb(n, {
    ...e,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(t.formatToParts(new Date(2020, 2, 3, 0)).find((i) => i.type === "hour").value, 10), o = parseInt(t.formatToParts(new Date(2020, 2, 3, 23)).find((i) => i.type === "hour").value, 10);
  if (r === 0 && o === 23)
    return "h23";
  if (r === 24 && o === 23)
    return "h24";
  if (r === 0 && o === 11)
    return "h11";
  if (r === 12 && o === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
function w6(n, e) {
  const t = [];
  for (let r = 0; r < n.length; r += e)
    t.push(n.slice(r, r + e));
  return t;
}
function Nr(n, e = ad()) {
  return Nm(n) ? n.toDate() : n.toDate(e);
}
function x6(n) {
  return n instanceof Fa;
}
function Nm(n) {
  return n instanceof Va;
}
function C6(n) {
  return x6(n) || Nm(n);
}
function $l(n) {
  if (n instanceof Date) {
    const e = n.getFullYear(), t = n.getMonth() + 1;
    return new Date(e, t, 0).getDate();
  } else
    return n.set({ day: 100 }).day;
}
function Od(n, e) {
  return n.compare(e) < 0;
}
function Td(n, e) {
  return n.compare(e) > 0;
}
function k6(n, e, t) {
  const r = U2(n, t);
  return e > r ? n.subtract({ days: r + 7 - e }) : e === r ? n : n.subtract({ days: r - e });
}
function _6(n, e, t) {
  const r = U2(n, t), o = e === 0 ? 6 : e - 1;
  return r === o ? n : r > o ? n.add({ days: 7 - r + o }) : n.add({ days: o - r });
}
function X1(n, e) {
  const t = [];
  let r = n.add({ days: 1 });
  const o = e;
  for (; r.compare(o) < 0; )
    t.push(r), r = r.add({ days: 1 });
  return t;
}
function qf(n) {
  const { dateObj: e, weekStartsOn: t, fixedWeeks: r, locale: o } = n, i = $l(e), a = Array.from({ length: i }, (v, $) => e.set({ day: $ + 1 })), s = bl(e), l = P1(e), d = k6(s, t, o), u = _6(l, t, o), f = X1(d.subtract({ days: 1 }), s), p = X1(l, u.add({ days: 1 })), h = f.length + a.length + p.length;
  if (r && h < 42) {
    const v = 42 - h;
    let $ = p[p.length - 1];
    $ || ($ = P1(e));
    const C = Array.from({ length: v }, (S, w) => {
      const T = w + 1;
      return $.add({ days: T });
    });
    p.push(...C);
  }
  const m = f.concat(a, p), g = w6(m, 7);
  return {
    value: e,
    cells: m,
    rows: g
  };
}
function pi(n) {
  const { numberOfMonths: e, dateObj: t, ...r } = n, o = [];
  if (!e || e === 1)
    return o.push(
      qf({
        ...r,
        dateObj: t
      })
    ), o;
  o.push(
    qf({
      ...r,
      dateObj: t
    })
  );
  for (let i = 1; i < e; i++) {
    const a = t.add({ months: i });
    o.push(
      qf({
        ...r,
        dateObj: a
      })
    );
  }
  return o;
}
const S6 = ["top", "right", "bottom", "left"], Pr = Math.min, Mn = Math.max, xu = Math.round, Ad = Math.floor, Yo = (n) => ({
  x: n,
  y: n
}), E6 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, O6 = {
  start: "end",
  end: "start"
};
function eh(n, e, t) {
  return Mn(n, Pr(e, t));
}
function vo(n, e) {
  return typeof n == "function" ? n(e) : n;
}
function yo(n) {
  return n.split("-")[0];
}
function fs(n) {
  return n.split("-")[1];
}
function Pm(n) {
  return n === "x" ? "y" : "x";
}
function Dm(n) {
  return n === "y" ? "height" : "width";
}
function Xo(n) {
  return ["top", "bottom"].includes(yo(n)) ? "y" : "x";
}
function Im(n) {
  return Pm(Xo(n));
}
function T6(n, e, t) {
  t === void 0 && (t = !1);
  const r = fs(n), o = Im(n), i = Dm(o);
  let a = o === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (a = Cu(a)), [a, Cu(a)];
}
function A6(n) {
  const e = Cu(n);
  return [th(n), e, th(e)];
}
function th(n) {
  return n.replace(/start|end/g, (e) => O6[e]);
}
function M6(n, e, t) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return t ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? i : a;
    default:
      return [];
  }
}
function N6(n, e, t, r) {
  const o = fs(n);
  let i = M6(yo(n), t === "start", r);
  return o && (i = i.map((a) => a + "-" + o), e && (i = i.concat(i.map(th)))), i;
}
function Cu(n) {
  return n.replace(/left|right|bottom|top/g, (e) => E6[e]);
}
function P6(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function fb(n) {
  return typeof n != "number" ? P6(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function ku(n) {
  const {
    x: e,
    y: t,
    width: r,
    height: o
  } = n;
  return {
    width: r,
    height: o,
    top: t,
    left: e,
    right: e + r,
    bottom: t + o,
    x: e,
    y: t
  };
}
function Q1(n, e, t) {
  let {
    reference: r,
    floating: o
  } = n;
  const i = Xo(e), a = Im(e), s = Dm(a), l = yo(e), d = i === "y", u = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (fs(e)) {
    case "start":
      h[a] -= p * (t && d ? -1 : 1);
      break;
    case "end":
      h[a] += p * (t && d ? -1 : 1);
      break;
  }
  return h;
}
const D6 = async (n, e, t) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = t, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let d = await a.getElementRects({
    reference: n,
    floating: e,
    strategy: o
  }), {
    x: u,
    y: f
  } = Q1(d, r, l), p = r, h = {}, m = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: v,
      fn: $
    } = s[g], {
      x: C,
      y: S,
      data: w,
      reset: T
    } = await $({
      x: u,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: h,
      rects: d,
      platform: a,
      elements: {
        reference: n,
        floating: e
      }
    });
    u = C ?? u, f = S ?? f, h = {
      ...h,
      [v]: {
        ...h[v],
        ...w
      }
    }, T && m <= 50 && (m++, typeof T == "object" && (T.placement && (p = T.placement), T.rects && (d = T.rects === !0 ? await a.getElementRects({
      reference: n,
      floating: e,
      strategy: o
    }) : T.rects), {
      x: u,
      y: f
    } = Q1(d, p, l)), g = -1);
  }
  return {
    x: u,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: h
  };
};
async function wl(n, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = n, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = vo(e, n), m = fb(h), v = s[p ? f === "floating" ? "reference" : "floating" : f], $ = ku(await i.getClippingRect({
    element: (t = await (i.isElement == null ? void 0 : i.isElement(v))) == null || t ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: l
  })), C = f === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), w = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = ku(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: S,
    strategy: l
  }) : C);
  return {
    top: ($.top - T.top + m.top) / w.y,
    bottom: (T.bottom - $.bottom + m.bottom) / w.y,
    left: ($.left - T.left + m.left) / w.x,
    right: (T.right - $.right + m.right) / w.x
  };
}
const I6 = (n) => ({
  name: "arrow",
  options: n,
  async fn(e) {
    const {
      x: t,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = e, {
      element: d,
      padding: u = 0
    } = vo(n, e) || {};
    if (d == null)
      return {};
    const f = fb(u), p = {
      x: t,
      y: r
    }, h = Im(o), m = Dm(h), g = await a.getDimensions(d), v = h === "y", $ = v ? "top" : "left", C = v ? "bottom" : "right", S = v ? "clientHeight" : "clientWidth", w = i.reference[m] + i.reference[h] - p[h] - i.floating[m], T = p[h] - i.reference[h], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(d));
    let N = A ? A[S] : 0;
    (!N || !await (a.isElement == null ? void 0 : a.isElement(A))) && (N = s.floating[S] || i.floating[m]);
    const z = w / 2 - T / 2, I = N / 2 - g[m] / 2 - 1, P = Pr(f[$], I), L = Pr(f[C], I), H = P, q = N - g[m] - L, Q = N / 2 - g[m] / 2 + z, ae = eh(H, Q, q), de = !l.arrow && fs(o) != null && Q !== ae && i.reference[m] / 2 - (Q < H ? P : L) - g[m] / 2 < 0, ne = de ? Q < H ? Q - H : Q - q : 0;
    return {
      [h]: p[h] + ne,
      data: {
        [h]: ae,
        centerOffset: Q - ae - ne,
        ...de && {
          alignmentOffset: ne
        }
      },
      reset: de
    };
  }
}), R6 = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(e) {
      var t, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: d
      } = e, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = vo(n, e);
      if ((t = i.arrow) != null && t.alignmentOffset)
        return {};
      const $ = yo(o), C = Xo(s), S = yo(s) === s, w = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), T = p || (S || !g ? [Cu(s)] : A6(s)), A = m !== "none";
      !p && A && T.push(...N6(s, g, m, w));
      const N = [s, ...T], z = await wl(e, v), I = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && I.push(z[$]), f) {
        const Q = T6(o, a, w);
        I.push(z[Q[0]], z[Q[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: I
      }], !I.every((Q) => Q <= 0)) {
        var L, H;
        const Q = (((L = i.flip) == null ? void 0 : L.index) || 0) + 1, ae = N[Q];
        if (ae)
          return {
            data: {
              index: Q,
              overflows: P
            },
            reset: {
              placement: ae
            }
          };
        let de = (H = P.filter((ne) => ne.overflows[0] <= 0).sort((ne, ke) => ne.overflows[1] - ke.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!de)
          switch (h) {
            case "bestFit": {
              var q;
              const ne = (q = P.filter((ke) => {
                if (A) {
                  const ee = Xo(ke.placement);
                  return ee === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ee === "y";
                }
                return !0;
              }).map((ke) => [ke.placement, ke.overflows.filter((ee) => ee > 0).reduce((ee, be) => ee + be, 0)]).sort((ke, ee) => ke[1] - ee[1])[0]) == null ? void 0 : q[0];
              ne && (de = ne);
              break;
            }
            case "initialPlacement":
              de = s;
              break;
          }
        if (o !== de)
          return {
            reset: {
              placement: de
            }
          };
      }
      return {};
    }
  };
};
function eg(n, e) {
  return {
    top: n.top - e.height,
    right: n.right - e.width,
    bottom: n.bottom - e.height,
    left: n.left - e.width
  };
}
function tg(n) {
  return S6.some((e) => n[e] >= 0);
}
const B6 = function(n) {
  return n === void 0 && (n = {}), {
    name: "hide",
    options: n,
    async fn(e) {
      const {
        rects: t
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = vo(n, e);
      switch (r) {
        case "referenceHidden": {
          const i = await wl(e, {
            ...o,
            elementContext: "reference"
          }), a = eg(i, t.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: tg(a)
            }
          };
        }
        case "escaped": {
          const i = await wl(e, {
            ...o,
            altBoundary: !0
          }), a = eg(i, t.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: tg(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function L6(n, e) {
  const {
    placement: t,
    platform: r,
    elements: o
  } = n, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = yo(t), s = fs(t), l = Xo(t) === "y", d = ["left", "top"].includes(a) ? -1 : 1, u = i && l ? -1 : 1, f = vo(e, n);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * u,
    y: p * d
  } : {
    x: p * d,
    y: h * u
  };
}
const F6 = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(e) {
      var t, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = e, l = await L6(e, n);
      return a === ((t = s.offset) == null ? void 0 : t.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, V6 = function(n) {
  return n === void 0 && (n = {}), {
    name: "shift",
    options: n,
    async fn(e) {
      const {
        x: t,
        y: r,
        placement: o
      } = e, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: $,
              y: C
            } = v;
            return {
              x: $,
              y: C
            };
          }
        },
        ...l
      } = vo(n, e), d = {
        x: t,
        y: r
      }, u = await wl(e, l), f = Xo(yo(o)), p = Pm(f);
      let h = d[p], m = d[f];
      if (i) {
        const v = p === "y" ? "top" : "left", $ = p === "y" ? "bottom" : "right", C = h + u[v], S = h - u[$];
        h = eh(C, h, S);
      }
      if (a) {
        const v = f === "y" ? "top" : "left", $ = f === "y" ? "bottom" : "right", C = m + u[v], S = m - u[$];
        m = eh(C, m, S);
      }
      const g = s.fn({
        ...e,
        [p]: h,
        [f]: m
      });
      return {
        ...g,
        data: {
          x: g.x - t,
          y: g.y - r
        }
      };
    }
  };
}, z6 = function(n) {
  return n === void 0 && (n = {}), {
    options: n,
    fn(e) {
      const {
        x: t,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: d = !0
      } = vo(n, e), u = {
        x: t,
        y: r
      }, f = Xo(o), p = Pm(f);
      let h = u[p], m = u[f];
      const g = vo(s, e), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const S = p === "y" ? "height" : "width", w = i.reference[p] - i.floating[S] + v.mainAxis, T = i.reference[p] + i.reference[S] - v.mainAxis;
        h < w ? h = w : h > T && (h = T);
      }
      if (d) {
        var $, C;
        const S = p === "y" ? "width" : "height", w = ["top", "left"].includes(yo(o)), T = i.reference[f] - i.floating[S] + (w && (($ = a.offset) == null ? void 0 : $[f]) || 0) + (w ? 0 : v.crossAxis), A = i.reference[f] + i.reference[S] + (w ? 0 : ((C = a.offset) == null ? void 0 : C[f]) || 0) - (w ? v.crossAxis : 0);
        m < T ? m = T : m > A && (m = A);
      }
      return {
        [p]: h,
        [f]: m
      };
    }
  };
}, j6 = function(n) {
  return n === void 0 && (n = {}), {
    name: "size",
    options: n,
    async fn(e) {
      const {
        placement: t,
        rects: r,
        platform: o,
        elements: i
      } = e, {
        apply: a = () => {
        },
        ...s
      } = vo(n, e), l = await wl(e, s), d = yo(t), u = fs(t), f = Xo(t) === "y", {
        width: p,
        height: h
      } = r.floating;
      let m, g;
      d === "top" || d === "bottom" ? (m = d, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = d, m = u === "end" ? "top" : "bottom");
      const v = h - l.top - l.bottom, $ = p - l.left - l.right, C = Pr(h - l[m], v), S = Pr(p - l[g], $), w = !e.middlewareData.shift;
      let T = C, A = S;
      if (f ? A = u || w ? Pr(S, $) : $ : T = u || w ? Pr(C, v) : v, w && !u) {
        const z = Mn(l.left, 0), I = Mn(l.right, 0), P = Mn(l.top, 0), L = Mn(l.bottom, 0);
        f ? A = p - 2 * (z !== 0 || I !== 0 ? z + I : Mn(l.left, l.right)) : T = h - 2 * (P !== 0 || L !== 0 ? P + L : Mn(l.top, l.bottom));
      }
      await a({
        ...e,
        availableWidth: A,
        availableHeight: T
      });
      const N = await o.getDimensions(i.floating);
      return p !== N.width || h !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Xi(n) {
  return Rm(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function Dn(n) {
  var e;
  return (n == null || (e = n.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ko(n) {
  var e;
  return (e = (Rm(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : e.documentElement;
}
function Rm(n) {
  return n instanceof Node || n instanceof Dn(n).Node;
}
function gr(n) {
  return n instanceof Element || n instanceof Dn(n).Element;
}
function Lr(n) {
  return n instanceof HTMLElement || n instanceof Dn(n).HTMLElement;
}
function ng(n) {
  return typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof Dn(n).ShadowRoot;
}
function sd(n) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: r,
    display: o
  } = vr(n);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + t) && !["inline", "contents"].includes(o);
}
function H6(n) {
  return ["table", "td", "th"].includes(Xi(n));
}
function Fc(n) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return n.matches(e);
    } catch {
      return !1;
    }
  });
}
function Bm(n) {
  const e = Lm(), t = gr(n) ? vr(n) : n;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function U6(n) {
  let e = Qo(n);
  for (; Lr(e) && !za(e); ) {
    if (Bm(e))
      return e;
    if (Fc(e))
      return null;
    e = Qo(e);
  }
  return null;
}
function Lm() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function za(n) {
  return ["html", "body", "#document"].includes(Xi(n));
}
function vr(n) {
  return Dn(n).getComputedStyle(n);
}
function Vc(n) {
  return gr(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function Qo(n) {
  if (Xi(n) === "html")
    return n;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    ng(n) && n.host || // Fallback.
    ko(n)
  );
  return ng(e) ? e.host : e;
}
function pb(n) {
  const e = Qo(n);
  return za(e) ? n.ownerDocument ? n.ownerDocument.body : n.body : Lr(e) && sd(e) ? e : pb(e);
}
function xl(n, e, t) {
  var r;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const o = pb(n), i = o === ((r = n.ownerDocument) == null ? void 0 : r.body), a = Dn(o);
  if (i) {
    const s = nh(a);
    return e.concat(a, a.visualViewport || [], sd(o) ? o : [], s && t ? xl(s) : []);
  }
  return e.concat(o, xl(o, [], t));
}
function nh(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
function hb(n) {
  const e = vr(n);
  let t = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = Lr(n), i = o ? n.offsetWidth : t, a = o ? n.offsetHeight : r, s = xu(t) !== i || xu(r) !== a;
  return s && (t = i, r = a), {
    width: t,
    height: r,
    $: s
  };
}
function Fm(n) {
  return gr(n) ? n : n.contextElement;
}
function Oa(n) {
  const e = Fm(n);
  if (!Lr(e))
    return Yo(1);
  const t = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = hb(e);
  let a = (i ? xu(t.width) : t.width) / r, s = (i ? xu(t.height) : t.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const K6 = /* @__PURE__ */ Yo(0);
function mb(n) {
  const e = Dn(n);
  return !Lm() || !e.visualViewport ? K6 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function W6(n, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== Dn(n) ? !1 : e;
}
function Li(n, e, t, r) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const o = n.getBoundingClientRect(), i = Fm(n);
  let a = Yo(1);
  e && (r ? gr(r) && (a = Oa(r)) : a = Oa(n));
  const s = W6(i, t, r) ? mb(i) : Yo(0);
  let l = (o.left + s.x) / a.x, d = (o.top + s.y) / a.y, u = o.width / a.x, f = o.height / a.y;
  if (i) {
    const p = Dn(i), h = r && gr(r) ? Dn(r) : r;
    let m = p, g = nh(m);
    for (; g && r && h !== m; ) {
      const v = Oa(g), $ = g.getBoundingClientRect(), C = vr(g), S = $.left + (g.clientLeft + parseFloat(C.paddingLeft)) * v.x, w = $.top + (g.clientTop + parseFloat(C.paddingTop)) * v.y;
      l *= v.x, d *= v.y, u *= v.x, f *= v.y, l += S, d += w, m = Dn(g), g = nh(m);
    }
  }
  return ku({
    width: u,
    height: f,
    x: l,
    y: d
  });
}
function q6(n) {
  let {
    elements: e,
    rect: t,
    offsetParent: r,
    strategy: o
  } = n;
  const i = o === "fixed", a = ko(r), s = e ? Fc(e.floating) : !1;
  if (r === a || s && i)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Yo(1);
  const u = Yo(0), f = Lr(r);
  if ((f || !f && !i) && ((Xi(r) !== "body" || sd(a)) && (l = Vc(r)), Lr(r))) {
    const p = Li(r);
    d = Oa(r), u.x = p.x + r.clientLeft, u.y = p.y + r.clientTop;
  }
  return {
    width: t.width * d.x,
    height: t.height * d.y,
    x: t.x * d.x - l.scrollLeft * d.x + u.x,
    y: t.y * d.y - l.scrollTop * d.y + u.y
  };
}
function G6(n) {
  return Array.from(n.getClientRects());
}
function gb(n) {
  return Li(ko(n)).left + Vc(n).scrollLeft;
}
function J6(n) {
  const e = ko(n), t = Vc(n), r = n.ownerDocument.body, o = Mn(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), i = Mn(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -t.scrollLeft + gb(n);
  const s = -t.scrollTop;
  return vr(r).direction === "rtl" && (a += Mn(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function Z6(n, e) {
  const t = Dn(n), r = ko(n), o = t.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const d = Lm();
    (!d || d && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function Y6(n, e) {
  const t = Li(n, !0, e === "fixed"), r = t.top + n.clientTop, o = t.left + n.clientLeft, i = Lr(n) ? Oa(n) : Yo(1), a = n.clientWidth * i.x, s = n.clientHeight * i.y, l = o * i.x, d = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: d
  };
}
function rg(n, e, t) {
  let r;
  if (e === "viewport")
    r = Z6(n, t);
  else if (e === "document")
    r = J6(ko(n));
  else if (gr(e))
    r = Y6(e, t);
  else {
    const o = mb(n);
    r = {
      ...e,
      x: e.x - o.x,
      y: e.y - o.y
    };
  }
  return ku(r);
}
function vb(n, e) {
  const t = Qo(n);
  return t === e || !gr(t) || za(t) ? !1 : vr(t).position === "fixed" || vb(t, e);
}
function X6(n, e) {
  const t = e.get(n);
  if (t)
    return t;
  let r = xl(n, [], !1).filter((s) => gr(s) && Xi(s) !== "body"), o = null;
  const i = vr(n).position === "fixed";
  let a = i ? Qo(n) : n;
  for (; gr(a) && !za(a); ) {
    const s = vr(a), l = Bm(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || sd(a) && !l && vb(n, a)) ? r = r.filter((u) => u !== a) : o = s, a = Qo(a);
  }
  return e.set(n, r), r;
}
function Q6(n) {
  let {
    element: e,
    boundary: t,
    rootBoundary: r,
    strategy: o
  } = n;
  const a = [...t === "clippingAncestors" ? Fc(e) ? [] : X6(e, this._c) : [].concat(t), r], s = a[0], l = a.reduce((d, u) => {
    const f = rg(e, u, o);
    return d.top = Mn(f.top, d.top), d.right = Pr(f.right, d.right), d.bottom = Pr(f.bottom, d.bottom), d.left = Mn(f.left, d.left), d;
  }, rg(e, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function e9(n) {
  const {
    width: e,
    height: t
  } = hb(n);
  return {
    width: e,
    height: t
  };
}
function t9(n, e, t) {
  const r = Lr(e), o = ko(e), i = t === "fixed", a = Li(n, !0, i, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Yo(0);
  if (r || !r && !i)
    if ((Xi(e) !== "body" || sd(o)) && (s = Vc(e)), r) {
      const f = Li(e, !0, i, e);
      l.x = f.x + e.clientLeft, l.y = f.y + e.clientTop;
    } else
      o && (l.x = gb(o));
  const d = a.left + s.scrollLeft - l.x, u = a.top + s.scrollTop - l.y;
  return {
    x: d,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Gf(n) {
  return vr(n).position === "static";
}
function og(n, e) {
  return !Lr(n) || vr(n).position === "fixed" ? null : e ? e(n) : n.offsetParent;
}
function yb(n, e) {
  const t = Dn(n);
  if (Fc(n))
    return t;
  if (!Lr(n)) {
    let o = Qo(n);
    for (; o && !za(o); ) {
      if (gr(o) && !Gf(o))
        return o;
      o = Qo(o);
    }
    return t;
  }
  let r = og(n, e);
  for (; r && H6(r) && Gf(r); )
    r = og(r, e);
  return r && za(r) && Gf(r) && !Bm(r) ? t : r || U6(n) || t;
}
const n9 = async function(n) {
  const e = this.getOffsetParent || yb, t = this.getDimensions, r = await t(n.floating);
  return {
    reference: t9(n.reference, await e(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function r9(n) {
  return vr(n).direction === "rtl";
}
const o9 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: q6,
  getDocumentElement: ko,
  getClippingRect: Q6,
  getOffsetParent: yb,
  getElementRects: n9,
  getClientRects: G6,
  getDimensions: e9,
  getScale: Oa,
  isElement: gr,
  isRTL: r9
};
function i9(n, e) {
  let t = null, r;
  const o = ko(n);
  function i() {
    var s;
    clearTimeout(r), (s = t) == null || s.disconnect(), t = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: d,
      top: u,
      width: f,
      height: p
    } = n.getBoundingClientRect();
    if (s || e(), !f || !p)
      return;
    const h = Ad(u), m = Ad(o.clientWidth - (d + f)), g = Ad(o.clientHeight - (u + p)), v = Ad(d), C = {
      rootMargin: -h + "px " + -m + "px " + -g + "px " + -v + "px",
      threshold: Mn(0, Pr(1, l)) || 1
    };
    let S = !0;
    function w(T) {
      const A = T[0].intersectionRatio;
      if (A !== l) {
        if (!S)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      t = new IntersectionObserver(w, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(w, C);
    }
    t.observe(n);
  }
  return a(!0), i;
}
function a9(n, e, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, d = Fm(n), u = o || i ? [...d ? xl(d) : [], ...xl(e)] : [];
  u.forEach(($) => {
    o && $.addEventListener("scroll", t, {
      passive: !0
    }), i && $.addEventListener("resize", t);
  });
  const f = d && s ? i9(d, t) : null;
  let p = -1, h = null;
  a && (h = new ResizeObserver(($) => {
    let [C] = $;
    C && C.target === d && h && (h.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = h) == null || S.observe(e);
    })), t();
  }), d && !l && h.observe(d), h.observe(e));
  let m, g = l ? Li(n) : null;
  l && v();
  function v() {
    const $ = Li(n);
    g && ($.x !== g.x || $.y !== g.y || $.width !== g.width || $.height !== g.height) && t(), g = $, m = requestAnimationFrame(v);
  }
  return t(), () => {
    var $;
    u.forEach((C) => {
      o && C.removeEventListener("scroll", t), i && C.removeEventListener("resize", t);
    }), f?.(), ($ = h) == null || $.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const s9 = F6, l9 = V6, ig = R6, d9 = j6, u9 = B6, c9 = I6, f9 = z6, p9 = (n, e, t) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: o9,
    ...t
  }, i = {
    ...o.platform,
    _c: r
  };
  return D6(n, e, {
    ...o,
    platform: i
  });
};
function h9(n) {
  return n != null && typeof n == "object" && "$el" in n;
}
function rh(n) {
  if (h9(n)) {
    const e = n.$el;
    return Rm(e) && Xi(e) === "#comment" ? null : e;
  }
  return n;
}
function pa(n) {
  return typeof n == "function" ? n() : c(n);
}
function m9(n) {
  return {
    name: "arrow",
    options: n,
    fn(e) {
      const t = rh(pa(n.element));
      return t == null ? {} : c9({
        element: t,
        padding: n.padding
      }).fn(e);
    }
  };
}
function bb(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ag(n, e) {
  const t = bb(n);
  return Math.round(e * t) / t;
}
function g9(n, e, t) {
  t === void 0 && (t = {});
  const r = t.whileElementsMounted, o = M(() => {
    var N;
    return (N = pa(t.open)) != null ? N : !0;
  }), i = M(() => pa(t.middleware)), a = M(() => {
    var N;
    return (N = pa(t.placement)) != null ? N : "bottom";
  }), s = M(() => {
    var N;
    return (N = pa(t.strategy)) != null ? N : "absolute";
  }), l = M(() => {
    var N;
    return (N = pa(t.transform)) != null ? N : !0;
  }), d = M(() => rh(n.value)), u = M(() => rh(e.value)), f = B(0), p = B(0), h = B(s.value), m = B(a.value), g = Da({}), v = B(!1), $ = M(() => {
    const N = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return N;
    const z = ag(u.value, f.value), I = ag(u.value, p.value);
    return l.value ? {
      ...N,
      transform: "translate(" + z + "px, " + I + "px)",
      ...bb(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: z + "px",
      top: I + "px"
    };
  });
  let C;
  function S() {
    d.value == null || u.value == null || p9(d.value, u.value, {
      middleware: i.value,
      placement: a.value,
      strategy: s.value
    }).then((N) => {
      f.value = N.x, p.value = N.y, h.value = N.strategy, m.value = N.placement, g.value = N.middlewareData, v.value = !0;
    });
  }
  function w() {
    typeof C == "function" && (C(), C = void 0);
  }
  function T() {
    if (w(), r === void 0) {
      S();
      return;
    }
    if (d.value != null && u.value != null) {
      C = r(d.value, u.value, S);
      return;
    }
  }
  function A() {
    o.value || (v.value = !1);
  }
  return De([i, a, s], S, {
    flush: "sync"
  }), De([d, u], T, {
    flush: "sync"
  }), De(o, A, {
    flush: "sync"
  }), _2() && S2(w), {
    x: aa(f),
    y: aa(p),
    strategy: aa(h),
    placement: aa(m),
    middlewareData: aa(g),
    isPositioned: aa(v),
    floatingStyles: $,
    update: S
  };
}
function Xe(n, e) {
  const t = typeof n == "string" && !e ? `${n}Context` : e, r = Symbol(t);
  return [(o) => {
    const i = Kn(r, o);
    if (i || i === null)
      return i;
    throw new Error(
      `Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(n) ? `one of the following components: ${n.join(
        ", "
      )}` : `\`${n}\``}`
    );
  }, (o) => (Jn(r, o), o)];
}
function Vm(n, e, t) {
  const r = t.originalEvent.target, o = new CustomEvent(n, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  e && r.addEventListener(n, e, { once: !0 }), r.dispatchEvent(o);
}
function _u(n, e = Number.NEGATIVE_INFINITY, t = Number.POSITIVE_INFINITY) {
  return Math.min(t, Math.max(e, n));
}
function v9(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var y9 = function n(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var r, o, i;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length)
        return !1;
      for (o = r; o-- !== 0; )
        if (!n(e[o], t[o]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length)
      return !1;
    for (o = r; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[o]))
        return !1;
    for (o = r; o-- !== 0; ) {
      var a = i[o];
      if (!n(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
};
const ki = /* @__PURE__ */ v9(y9);
function nu(n) {
  return n == null;
}
function b9(n) {
  const { defaultValue: e, defaultPlaceholder: t, granularity: r = "day", locale: o = "en" } = n;
  if (Array.isArray(e) && e.length)
    return e.at(-1).copy();
  if (e && !Array.isArray(e))
    return e.copy();
  if (t)
    return t.copy();
  const i = /* @__PURE__ */ new Date(), a = i.getFullYear(), s = i.getMonth() + 1, l = i.getDate(), d = ["hour", "minute", "second"], u = new _r(o), f = g6(u.resolvedOptions().calendar);
  return d.includes(r ?? "day") ? Cn(new Fa(a, s, l, 0, 0, 0), f) : Cn(new Nt(a, s, l), f);
}
function $9(n) {
  const e = n.querySelector("[data-selected]");
  if (e)
    return e.focus();
  const t = n.querySelector("[data-today]");
  if (t)
    return t.focus();
  const r = n.querySelector("[data-radix-vue-calendar-day]");
  if (r)
    return r.focus();
}
function w9(n, e) {
  var t;
  const r = Da();
  return vt(() => {
    r.value = n();
  }, {
    ...e,
    flush: (t = void 0) != null ? t : "sync"
  }), od(r);
}
function Qi(n) {
  return _2() ? (S2(n), !0) : !1;
}
function x9() {
  const n = /* @__PURE__ */ new Set(), e = (t) => {
    n.delete(t);
  };
  return {
    on: (t) => {
      n.add(t);
      const r = () => e(t);
      return Qi(r), {
        off: r
      };
    },
    off: e,
    trigger: (...t) => Promise.all(Array.from(n).map((r) => r(...t)))
  };
}
function C9(n) {
  let e = !1, t;
  const r = O2(!0);
  return (...o) => (e || (t = r.run(() => n(...o)), e = !0), t);
}
function $b(n) {
  let e = 0, t, r;
  const o = () => {
    e -= 1, r && e <= 0 && (r.stop(), t = void 0, r = void 0);
  };
  return (...i) => (e += 1, t || (r = O2(!0), t = r.run(() => n(...i))), Qi(o), t);
}
function mo(n) {
  return typeof n == "function" ? n() : c(n);
}
const Kr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const k9 = (n) => typeof n < "u", _9 = (n) => n != null, S9 = Object.prototype.toString, E9 = (n) => S9.call(n) === "[object Object]", wb = () => {
}, sg = /* @__PURE__ */ O9();
function O9() {
  var n, e;
  return Kr && ((n = window?.navigator) == null ? void 0 : n.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window?.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function T9(n, e) {
  function t(...r) {
    return new Promise((o, i) => {
      Promise.resolve(n(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(o).catch(i);
    });
  }
  return t;
}
const xb = (n) => n();
function A9(n = xb) {
  const e = B(!0);
  function t() {
    e.value = !1;
  }
  function r() {
    e.value = !0;
  }
  const o = (...i) => {
    e.value && n(...i);
  };
  return { isActive: od(e), pause: t, resume: r, eventFilter: o };
}
function M9(n) {
  return sn();
}
function Cb(n, e = 1e4) {
  return T2((t, r) => {
    let o = mo(n), i;
    const a = () => setTimeout(() => {
      o = mo(n), r();
    }, mo(e));
    return Qi(() => {
      clearTimeout(i);
    }), {
      get() {
        return t(), o;
      },
      set(s) {
        o = s, r(), clearTimeout(i), i = a();
      }
    };
  });
}
function N9(n, e, t = {}) {
  const {
    eventFilter: r = xb,
    ...o
  } = t;
  return De(
    n,
    T9(
      r,
      e
    ),
    o
  );
}
function lg(n, e, t = {}) {
  const {
    eventFilter: r,
    ...o
  } = t, { eventFilter: i, pause: a, resume: s, isActive: l } = A9(r);
  return { stop: N9(
    n,
    e,
    {
      ...o,
      eventFilter: i
    }
  ), pause: a, resume: s, isActive: l };
}
function P9(n, e, ...[t]) {
  const {
    flush: r = "sync",
    deep: o = !1,
    immediate: i = !0,
    direction: a = "both",
    transform: s = {}
  } = t || {}, l = [], d = "ltr" in s && s.ltr || ((f) => f), u = "rtl" in s && s.rtl || ((f) => f);
  return (a === "both" || a === "ltr") && l.push(lg(
    n,
    (f) => {
      l.forEach((p) => p.pause()), e.value = d(f), l.forEach((p) => p.resume());
    },
    { flush: r, deep: o, immediate: i }
  )), (a === "both" || a === "rtl") && l.push(lg(
    e,
    (f) => {
      l.forEach((p) => p.pause()), n.value = u(f), l.forEach((p) => p.resume());
    },
    { flush: r, deep: o, immediate: i }
  )), () => {
    l.forEach((f) => f.stop());
  };
}
function D9(n, e) {
  M9() && xr(n, e);
}
function I9(n, e, t = {}) {
  const {
    immediate: r = !0
  } = t, o = B(!1);
  let i = null;
  function a() {
    i && (clearTimeout(i), i = null);
  }
  function s() {
    o.value = !1, a();
  }
  function l(...d) {
    a(), o.value = !0, i = setTimeout(() => {
      o.value = !1, i = null, n(...d);
    }, mo(e));
  }
  return r && (o.value = !0, Kr && l()), Qi(s), {
    isPending: od(o),
    start: l,
    stop: s
  };
}
function R9(n = 1e3, e = {}) {
  const {
    controls: t = !1,
    callback: r
  } = e, o = I9(
    r ?? wb,
    n,
    e
  ), i = M(() => !o.isPending.value);
  return t ? {
    ready: i,
    ...o
  } : i;
}
function Zn(n) {
  var e;
  const t = mo(n);
  return (e = t?.$el) != null ? e : t;
}
const ld = Kr ? window : void 0;
function ja(...n) {
  let e, t, r, o;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([t, r, o] = n, e = ld) : [e, t, r, o] = n, !e)
    return wb;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const i = [], a = () => {
    i.forEach((u) => u()), i.length = 0;
  }, s = (u, f, p, h) => (u.addEventListener(f, p, h), () => u.removeEventListener(f, p, h)), l = De(
    () => [Zn(e), mo(o)],
    ([u, f]) => {
      if (a(), !u)
        return;
      const p = E9(f) ? { ...f } : f;
      i.push(
        ...t.flatMap((h) => r.map((m) => s(u, h, m, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), a();
  };
  return Qi(d), d;
}
function B9(n) {
  return typeof n == "function" ? n : typeof n == "string" ? (e) => e.key === n : Array.isArray(n) ? (e) => n.includes(e.key) : () => !0;
}
function zm(...n) {
  let e, t, r = {};
  n.length === 3 ? (e = n[0], t = n[1], r = n[2]) : n.length === 2 ? typeof n[1] == "object" ? (e = !0, t = n[0], r = n[1]) : (e = n[0], t = n[1]) : (e = !0, t = n[0]);
  const {
    target: o = ld,
    eventName: i = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = r, l = B9(e);
  return ja(o, i, (d) => {
    d.repeat && mo(s) || l(d) && t(d);
  }, a);
}
function jm() {
  const n = B(!1), e = sn();
  return e && Ge(() => {
    n.value = !0;
  }, e), n;
}
function L9(n) {
  const e = jm();
  return M(() => (e.value, !!n()));
}
function F9(n, e, t = {}) {
  const { window: r = ld, ...o } = t;
  let i;
  const a = L9(() => r && "MutationObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, l = M(() => {
    const p = mo(n), h = (Array.isArray(p) ? p : [p]).map(Zn).filter(_9);
    return new Set(h);
  }), d = De(
    () => l.value,
    (p) => {
      s(), a.value && p.size && (i = new MutationObserver(e), p.forEach((h) => i.observe(h, o)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => i?.takeRecords(), f = () => {
    s(), d();
  };
  return Qi(f), {
    isSupported: a,
    stop: f,
    takeRecords: u
  };
}
function kb(n, e = {}) {
  const {
    immediate: t = !0,
    fpsLimit: r = void 0,
    window: o = ld
  } = e, i = B(!1), a = r ? 1e3 / r : null;
  let s = 0, l = null;
  function d(p) {
    if (!i.value || !o)
      return;
    s || (s = p);
    const h = p - s;
    if (a && h < a) {
      l = o.requestAnimationFrame(d);
      return;
    }
    s = p, n({ delta: h, timestamp: p }), l = o.requestAnimationFrame(d);
  }
  function u() {
    !i.value && o && (i.value = !0, s = 0, l = o.requestAnimationFrame(d));
  }
  function f() {
    i.value = !1, l != null && o && (o.cancelAnimationFrame(l), l = null);
  }
  return t && u(), Qi(f), {
    isActive: od(i),
    pause: f,
    resume: u
  };
}
function V9(n) {
  return JSON.parse(JSON.stringify(n));
}
function gt(n, e, t, r = {}) {
  var o, i, a;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: d,
    deep: u = !1,
    defaultValue: f,
    shouldEmit: p
  } = r, h = sn(), m = t || h?.emit || ((o = h?.$emit) == null ? void 0 : o.bind(h)) || ((a = (i = h?.proxy) == null ? void 0 : i.$emit) == null ? void 0 : a.bind(h?.proxy));
  let g = d;
  e || (e = "modelValue"), g = g || `update:${e.toString()}`;
  const v = (S) => s ? typeof s == "function" ? s(S) : V9(S) : S, $ = () => k9(n[e]) ? v(n[e]) : f, C = (S) => {
    p ? p(S) && m(g, S) : m(g, S);
  };
  if (l) {
    const S = $(), w = B(S);
    let T = !1;
    return De(
      () => n[e],
      (A) => {
        T || (T = !0, w.value = v(A), Be(() => T = !1));
      }
    ), De(
      w,
      (A) => {
        !T && (A !== n[e] || u) && C(A);
      },
      { deep: u }
    ), w;
  } else
    return M({
      get() {
        return $();
      },
      set(S) {
        C(S);
      }
    });
}
function zc(n) {
  return n ? n.flatMap((e) => e.type === Me ? zc(e.children) : [e]) : [];
}
function Bt() {
  let n = document.activeElement;
  if (n == null)
    return null;
  for (; n != null && n.shadowRoot != null && n.shadowRoot.activeElement != null; )
    n = n.shadowRoot.activeElement;
  return n;
}
const z9 = ["INPUT", "TEXTAREA"];
function _b(n, e, t, r = {}) {
  if (!e || r.enableIgnoredElement && z9.includes(e.nodeName))
    return null;
  const {
    arrowKeyOptions: o = "both",
    attributeName: i = "[data-radix-vue-collection-item]",
    itemsArray: a = [],
    loop: s = !0,
    dir: l = "ltr",
    preventScroll: d = !0,
    focus: u = !1
  } = r, [f, p, h, m, g, v] = [
    n.key === "ArrowRight",
    n.key === "ArrowLeft",
    n.key === "ArrowUp",
    n.key === "ArrowDown",
    n.key === "Home",
    n.key === "End"
  ], $ = h || m, C = f || p;
  if (!g && !v && (!$ && !C || o === "vertical" && C || o === "horizontal" && $))
    return null;
  const S = t ? Array.from(t.querySelectorAll(i)) : a;
  if (!S.length)
    return null;
  d && n.preventDefault();
  let w = null;
  return C || $ ? w = Sb(S, e, {
    goForward: $ ? m : l === "ltr" ? f : p,
    loop: s
  }) : g ? w = S.at(0) || null : v && (w = S.at(-1) || null), u && w?.focus(), w;
}
function Sb(n, e, t, r = n.length) {
  if (--r === 0)
    return null;
  const o = n.indexOf(e), i = t.goForward ? o + 1 : o - 1;
  if (!t.loop && (i < 0 || i >= n.length))
    return null;
  const a = (i + n.length) % n.length, s = n[a];
  return s ? s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false" ? Sb(
    n,
    s,
    t,
    r
  ) : s : null;
}
function Jf(n) {
  if (n === null || typeof n != "object")
    return !1;
  const e = Object.getPrototypeOf(n);
  return e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Symbol.iterator in n ? !1 : Symbol.toStringTag in n ? Object.prototype.toString.call(n) === "[object Module]" : !0;
}
function oh(n, e, t = ".", r) {
  if (!Jf(e))
    return oh(n, {}, t, r);
  const o = Object.assign({}, e);
  for (const i in n) {
    if (i === "__proto__" || i === "constructor")
      continue;
    const a = n[i];
    a != null && (r && r(o, i, a, t) || (Array.isArray(a) && Array.isArray(o[i]) ? o[i] = [...a, ...o[i]] : Jf(a) && Jf(o[i]) ? o[i] = oh(
      a,
      o[i],
      (t ? `${t}.` : "") + i.toString(),
      r
    ) : o[i] = a));
  }
  return o;
}
function j9(n) {
  return (...e) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    e.reduce((t, r) => oh(t, r, "", n), {})
  );
}
const H9 = j9(), [jc, aJ] = Xe("ConfigProvider");
let U9 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", K9 = (n = 21) => {
  let e = "", t = n;
  for (; t--; )
    e += U9[Math.random() * 64 | 0];
  return e;
};
const W9 = $b(() => {
  const n = B(/* @__PURE__ */ new Map()), e = B(), t = M(() => {
    for (const a of n.value.values())
      if (a)
        return !0;
    return !1;
  }), r = jc({
    scrollBody: B(!0)
  });
  let o = null;
  const i = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = e.value ?? "", sg && o?.(), e.value = void 0;
  };
  return De(t, (a, s) => {
    var l;
    if (!Kr)
      return;
    if (!a) {
      s && i();
      return;
    }
    e.value === void 0 && (e.value = document.body.style.overflow);
    const d = window.innerWidth - document.documentElement.clientWidth, u = { padding: d, margin: 0 }, f = (l = r.scrollBody) != null && l.value ? typeof r.scrollBody.value == "object" ? H9({
      padding: r.scrollBody.value.padding === !0 ? d : r.scrollBody.value.padding,
      margin: r.scrollBody.value.margin === !0 ? d : r.scrollBody.value.margin
    }, u) : u : { padding: 0, margin: 0 };
    d > 0 && (document.body.style.paddingRight = typeof f.padding == "number" ? `${f.padding}px` : String(f.padding), document.body.style.marginRight = typeof f.margin == "number" ? `${f.margin}px` : String(f.margin), document.body.style.setProperty("--scrollbar-width", `${d}px`), document.body.style.overflow = "hidden"), sg && (o = ja(
      document,
      "touchmove",
      (p) => q9(p),
      { passive: !1 }
    )), Be(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), n;
});
function dd(n) {
  const e = K9(6), t = W9();
  t.value.set(e, n ?? !1);
  const r = M({
    get: () => t.value.get(e) ?? !1,
    set: (o) => t.value.set(e, o)
  });
  return D9(() => {
    t.value.delete(e);
  }), r;
}
function Eb(n) {
  const e = window.getComputedStyle(n);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && n.clientWidth < n.scrollWidth || e.overflowY === "auto" && n.clientHeight < n.scrollHeight)
    return !0;
  {
    const t = n.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Eb(t);
  }
}
function q9(n) {
  const e = n || window.event, t = e.target;
  return t instanceof Element && Eb(t) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.cancelable && e.preventDefault(), !1);
}
const G9 = "data-radix-vue-collection-item";
function ps(n, e = G9) {
  const t = n ?? Symbol();
  return { createCollection: (r) => {
    const o = B([]);
    function i() {
      const a = Zn(r);
      return a ? o.value = Array.from(
        a.querySelectorAll(`[${e}]:not([data-disabled])`)
      ) : o.value = [];
    }
    return D5(() => {
      o.value = [];
    }), Ge(i), A2(i), De(() => r?.value, i, { immediate: !0 }), Jn(t, o), o;
  }, injectCollection: () => Kn(t, B([])) };
}
function J9(n) {
  const e = B(n);
  function t() {
    return e.value;
  }
  function r(g) {
    e.value = g;
  }
  function o(g, v) {
    return new _r(e.value, v).format(g);
  }
  function i(g, v = !0) {
    return C6(g) && v ? o(Nr(g), {
      dateStyle: "long",
      timeStyle: "long"
    }) : o(Nr(g), {
      dateStyle: "long"
    });
  }
  function a(g, v = {}) {
    return new _r(e.value, { month: "long", year: "numeric", ...v }).format(g);
  }
  function s(g, v = {}) {
    return new _r(e.value, { month: "long", ...v }).format(g);
  }
  function l() {
    const g = K2(ad());
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((v) => ({ label: s(Nr(g.set({ month: v }))), value: v }));
  }
  function d(g, v = {}) {
    return new _r(e.value, { year: "numeric", ...v }).format(g);
  }
  function u(g, v) {
    return Nm(g) ? new _r(e.value, {
      ...v,
      timeZone: g.timeZone
    }).formatToParts(Nr(g)) : new _r(e.value, v).formatToParts(Nr(g));
  }
  function f(g, v = "narrow") {
    return new _r(e.value, { weekday: v }).format(g);
  }
  function p(g) {
    var v;
    return ((v = new _r(e.value, {
      hour: "numeric",
      minute: "numeric"
    }).formatToParts(g).find(($) => $.type === "dayPeriod")) == null ? void 0 : v.value) === "PM" ? "PM" : "AM";
  }
  const h = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  function m(g, v, $ = {}) {
    const C = { ...h, ...$ }, S = u(g, C).find((w) => w.type === v);
    return S ? S.value : "";
  }
  return {
    setLocale: r,
    getLocale: t,
    fullMonth: s,
    fullYear: d,
    fullMonthAndYear: a,
    toParts: u,
    custom: o,
    part: m,
    dayPeriod: p,
    selectedDate: i,
    dayOfWeek: f,
    getMonths: l
  };
}
function Cr(n) {
  const e = jc({
    dir: B("ltr")
  });
  return M(() => {
    var t;
    return n?.value || ((t = e.dir) == null ? void 0 : t.value) || "ltr";
  });
}
function ea(n) {
  const e = sn(), t = e?.type.emits, r = {};
  return t != null && t.length || console.warn(
    `No emitted event found. Please check component: ${e?.type.__name}`
  ), t?.forEach((o) => {
    r[E5(E2(o))] = (...i) => n(o, ...i);
  }), r;
}
let Zf = 0;
function Hm() {
  vt((n) => {
    if (!Kr)
      return;
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      e[0] ?? dg()
    ), document.body.insertAdjacentElement(
      "beforeend",
      e[1] ?? dg()
    ), Zf++, n(() => {
      Zf === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Zf--;
    });
  });
}
function dg() {
  const n = document.createElement("span");
  return n.setAttribute("data-radix-focus-guard", ""), n.tabIndex = 0, n.style.outline = "none", n.style.opacity = "0", n.style.position = "fixed", n.style.pointerEvents = "none", n;
}
function hs(n) {
  return M(() => {
    var e;
    return mo(n) ? !!((e = Zn(n)) != null && e.closest("form")) : !0;
  });
}
function pt(n) {
  const e = sn(), t = Object.keys(e?.type.props ?? {}).reduce((o, i) => {
    const a = (e?.type.props[i]).default;
    return a !== void 0 && (o[i] = a), o;
  }, {}), r = Bo(n);
  return M(() => {
    const o = {}, i = e?.vnode.props ?? {};
    return Object.keys(i).forEach((a) => {
      o[E2(a)] = i[a];
    }), Object.keys({ ...t, ...o }).reduce((a, s) => (r.value[s] !== void 0 && (a[s] = r.value[s]), a), {});
  });
}
function je(n, e) {
  const t = pt(n), r = e ? ea(e) : {};
  return M(() => ({
    ...t.value,
    ...r
  }));
}
function ie() {
  const n = sn(), e = B(), t = M(() => {
    var a, s;
    return ["#text", "#comment"].includes((a = e.value) == null ? void 0 : a.$el.nodeName) ? (s = e.value) == null ? void 0 : s.$el.nextElementSibling : Zn(e);
  }), r = Object.assign({}, n.exposed), o = {};
  for (const a in n.props)
    Object.defineProperty(o, a, {
      enumerable: !0,
      configurable: !0,
      get: () => n.props[a]
    });
  if (Object.keys(r).length > 0)
    for (const a in r)
      Object.defineProperty(o, a, {
        enumerable: !0,
        configurable: !0,
        get: () => r[a]
      });
  Object.defineProperty(o, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => n.vnode.el
  }), n.exposed = o;
  function i(a) {
    e.value = a, !(a instanceof Element || !a) && (Object.defineProperty(o, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => a.$el
    }), n.exposed = o);
  }
  return { forwardRef: i, currentRef: e, currentElement: t };
}
function Z9(n, e) {
  const t = Cb(!1, 300), r = B(null), o = x9();
  function i() {
    r.value = null, t.value = !1;
  }
  function a(s, l) {
    const d = s.currentTarget, u = { x: s.clientX, y: s.clientY }, f = Y9(u, d.getBoundingClientRect()), p = X9(u, f), h = Q9(l.getBoundingClientRect()), m = tC([...p, ...h]);
    r.value = m, t.value = !0;
  }
  return vt((s) => {
    if (n.value && e.value) {
      const l = (u) => a(u, e.value), d = (u) => a(u, n.value);
      n.value.addEventListener("pointerleave", l), e.value.addEventListener("pointerleave", d), s(() => {
        var u, f;
        (u = n.value) == null || u.removeEventListener("pointerleave", l), (f = e.value) == null || f.removeEventListener("pointerleave", d);
      });
    }
  }), vt((s) => {
    var l;
    if (r.value) {
      const d = (u) => {
        var f, p;
        if (!r.value)
          return;
        const h = u.target, m = { x: u.clientX, y: u.clientY }, g = ((f = n.value) == null ? void 0 : f.contains(h)) || ((p = e.value) == null ? void 0 : p.contains(h)), v = !eC(m, r.value), $ = !!h.closest("[data-grace-area-trigger]");
        g ? i() : (v || $) && (i(), o.trigger());
      };
      (l = n.value) == null || l.ownerDocument.addEventListener("pointermove", d), s(() => {
        var u;
        return (u = n.value) == null ? void 0 : u.ownerDocument.removeEventListener("pointermove", d);
      });
    }
  }), {
    isPointerInTransit: t,
    onPointerExit: o.on
  };
}
function Y9(n, e) {
  const t = Math.abs(e.top - n.y), r = Math.abs(e.bottom - n.y), o = Math.abs(e.right - n.x), i = Math.abs(e.left - n.x);
  switch (Math.min(t, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case t:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function X9(n, e, t = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: n.x - t, y: n.y + t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "bottom":
      r.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x + t, y: n.y - t }
      );
      break;
    case "left":
      r.push(
        { x: n.x + t, y: n.y - t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "right":
      r.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x - t, y: n.y + t }
      );
      break;
  }
  return r;
}
function Q9(n) {
  const { top: e, right: t, bottom: r, left: o } = n;
  return [
    { x: o, y: e },
    { x: t, y: e },
    { x: t, y: r },
    { x: o, y: r }
  ];
}
function eC(n, e) {
  const { x: t, y: r } = n;
  let o = !1;
  for (let i = 0, a = e.length - 1; i < e.length; a = i++) {
    const s = e[i].x, l = e[i].y, d = e[a].x, u = e[a].y;
    l > r != u > r && t < (d - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function tC(n) {
  const e = n.slice();
  return e.sort((t, r) => t.x < r.x ? -1 : t.x > r.x ? 1 : t.y < r.y ? -1 : t.y > r.y ? 1 : 0), nC(e);
}
function nC(n) {
  if (n.length <= 1)
    return n.slice();
  const e = [];
  for (let r = 0; r < n.length; r++) {
    const o = n[r];
    for (; e.length >= 2; ) {
      const i = e[e.length - 1], a = e[e.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x))
        e.pop();
      else
        break;
    }
    e.push(o);
  }
  e.pop();
  const t = [];
  for (let r = n.length - 1; r >= 0; r--) {
    const o = n[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  return t.pop(), e.length === 1 && t.length === 1 && e[0].x === t[0].x && e[0].y === t[0].y ? e : e.concat(t);
}
var rC = function(n) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(n) ? n[0] : n;
  return e.ownerDocument.body;
}, la = /* @__PURE__ */ new WeakMap(), Md = /* @__PURE__ */ new WeakMap(), Nd = {}, Yf = 0, Ob = function(n) {
  return n && (n.host || Ob(n.parentNode));
}, oC = function(n, e) {
  return e.map(function(t) {
    if (n.contains(t))
      return t;
    var r = Ob(t);
    return r && n.contains(r) ? r : (console.error("aria-hidden", t, "in not contained inside", n, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, iC = function(n, e, t, r) {
  var o = oC(e, Array.isArray(n) ? n : [n]);
  Nd[t] || (Nd[t] = /* @__PURE__ */ new WeakMap());
  var i = Nd[t], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), d = function(f) {
    !f || s.has(f) || (s.add(f), d(f.parentNode));
  };
  o.forEach(d);
  var u = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (s.has(p))
        u(p);
      else
        try {
          var h = p.getAttribute(r), m = h !== null && h !== "false", g = (la.get(p) || 0) + 1, v = (i.get(p) || 0) + 1;
          la.set(p, g), i.set(p, v), a.push(p), g === 1 && m && Md.set(p, !0), v === 1 && p.setAttribute(t, "true"), m || p.setAttribute(r, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", p, $);
        }
    });
  };
  return u(e), s.clear(), Yf++, function() {
    a.forEach(function(f) {
      var p = la.get(f) - 1, h = i.get(f) - 1;
      la.set(f, p), i.set(f, h), p || (Md.has(f) || f.removeAttribute(r), Md.delete(f)), h || f.removeAttribute(t);
    }), Yf--, Yf || (la = /* @__PURE__ */ new WeakMap(), la = /* @__PURE__ */ new WeakMap(), Md = /* @__PURE__ */ new WeakMap(), Nd = {});
  };
}, aC = function(n, e, t) {
  t === void 0 && (t = "data-aria-hidden");
  var r = Array.from(Array.isArray(n) ? n : [n]), o = rC(n);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), iC(r, o, t, "aria-hidden")) : function() {
    return null;
  };
};
function ud(n) {
  let e;
  De(() => Zn(n), (t) => {
    t ? e = aC(t) : e && e();
  }), Qn(() => {
    e && e();
  });
}
let sC = 0;
function zt(n, e = "radix") {
  if (n)
    return n;
  const t = jc({ useId: void 0 });
  return x1.useId ? `${e}-${x1.useId()}` : t.useId ? `${e}-${t.useId()}` : `${e}-${++sC}`;
}
function Tb(n) {
  const e = B(), t = M(() => {
    var o;
    return ((o = e.value) == null ? void 0 : o.width) ?? 0;
  }), r = M(() => {
    var o;
    return ((o = e.value) == null ? void 0 : o.height) ?? 0;
  });
  return Ge(() => {
    const o = Zn(n);
    if (o) {
      e.value = { width: o.offsetWidth, height: o.offsetHeight };
      const i = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const s = a[0];
        let l, d;
        if ("borderBoxSize" in s) {
          const u = s.borderBoxSize, f = Array.isArray(u) ? u[0] : u;
          l = f.inlineSize, d = f.blockSize;
        } else
          l = o.offsetWidth, d = o.offsetHeight;
        e.value = { width: l, height: d };
      });
      return i.observe(o, { box: "border-box" }), () => i.unobserve(o);
    } else
      e.value = void 0;
  }), {
    width: t,
    height: r
  };
}
function lC(n, e) {
  const t = B(n);
  function r(o) {
    return e[t.value][o] ?? t.value;
  }
  return {
    state: t,
    dispatch: (o) => {
      t.value = r(o);
    }
  };
}
const dC = "data-item-text";
function Um(n) {
  const e = Cb("", 1e3);
  return {
    search: e,
    handleTypeaheadSearch: (t, r) => {
      if (!(n != null && n.value) && !r)
        return;
      e.value = e.value + t;
      const o = n?.value ?? r, i = Bt(), a = o.map((f) => {
        var p;
        return {
          ref: f,
          textValue: ((p = (f.querySelector(`[${dC}]`) ?? f).textContent) == null ? void 0 : p.trim()) ?? ""
        };
      }), s = a.find((f) => f.ref === i), l = a.map((f) => f.textValue), d = cC(l, e.value, s?.textValue), u = a.find((f) => f.textValue === d);
      return u && u.ref.focus(), u?.ref;
    },
    resetTypeahead: () => {
      e.value = "";
    }
  };
}
function uC(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
function cC(n, e, t) {
  const r = e.length > 1 && Array.from(e).every((s) => s === e[0]) ? e[0] : e, o = t ? n.indexOf(t) : -1;
  let i = uC(n, Math.max(o, 0));
  r.length === 1 && (i = i.filter((s) => s !== t));
  const a = i.find(
    (s) => s.toLowerCase().startsWith(r.toLowerCase())
  );
  return a !== t ? a : void 0;
}
function fC() {
  return {
    ALT: "Alt",
    ARROW_DOWN: "ArrowDown",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    ARROW_UP: "ArrowUp",
    BACKSPACE: "Backspace",
    CAPS_LOCK: "CapsLock",
    CONTROL: "Control",
    DELETE: "Delete",
    END: "End",
    ENTER: "Enter",
    ESCAPE: "Escape",
    F1: "F1",
    F10: "F10",
    F11: "F11",
    F12: "F12",
    F2: "F2",
    F3: "F3",
    F4: "F4",
    F5: "F5",
    F6: "F6",
    F7: "F7",
    F8: "F8",
    F9: "F9",
    HOME: "Home",
    META: "Meta",
    PAGE_DOWN: "PageDown",
    PAGE_UP: "PageUp",
    SHIFT: "Shift",
    SPACE: " ",
    TAB: "Tab",
    CTRL: "Control",
    ASTERISK: "*",
    SPACE_CODE: "Space"
  };
}
const Hc = _({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(n, { attrs: e, slots: t }) {
    return () => {
      var r, o;
      if (!t.default)
        return null;
      const i = zc(t.default()), a = i.findIndex((u) => u.type !== O5);
      if (a === -1)
        return i;
      const s = i[a];
      (r = s.props) == null || delete r.ref;
      const l = s.props ? j(e, s.props) : e;
      e.class && (o = s.props) != null && o.class && delete s.props.class;
      const d = T5(s, l);
      for (const u in l)
        u.startsWith("on") && (d.props || (d.props = {}), d.props[u] = l[u]);
      return i.length === 1 ? d : (i[a] = d, i);
    };
  }
}), le = _({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(n, { attrs: e, slots: t }) {
    const r = n.asChild ? "template" : n.as;
    return typeof r == "string" && ["area", "img", "input"].includes(r) ? () => Yt(r, e) : r !== "template" ? () => Yt(n.as, e, { default: t.default }) : () => Yt(Hc, e, { default: t.default });
  }
});
function Uc() {
  const n = B(), e = M(() => {
    var t, r;
    return ["#text", "#comment"].includes((t = n.value) == null ? void 0 : t.$el.nodeName) ? (r = n.value) == null ? void 0 : r.$el.nextElementSibling : Zn(n);
  });
  return {
    primitiveElement: n,
    currentElement: e
  };
}
const [Ab, pC] = Xe("CollapsibleRoot"), Mb = /* @__PURE__ */ _({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(n, { expose: e, emit: t }) {
    const r = n, o = gt(r, "open", t, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    }), i = gt(r, "disabled");
    return pC({
      contentId: "",
      disabled: i,
      open: o,
      onOpenToggle: () => {
        o.value = !o.value;
      }
    }), e({ open: o }), ie(), (a, s) => (b(), k(c(le), {
      as: a.as,
      "as-child": r.asChild,
      "data-state": c(o) ? "open" : "closed",
      "data-disabled": c(i) ? "" : void 0
    }, {
      default: y(() => [
        E(a.$slots, "default", { open: c(o) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), Nb = /* @__PURE__ */ _({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    ie();
    const t = Ab();
    return (r, o) => {
      var i, a;
      return b(), k(c(le), {
        type: r.as === "button" ? "button" : void 0,
        as: r.as,
        "as-child": e.asChild,
        "aria-controls": c(t).contentId,
        "aria-expanded": c(t).open.value,
        "data-state": c(t).open.value ? "open" : "closed",
        "data-disabled": (i = c(t).disabled) != null && i.value ? "" : void 0,
        disabled: (a = c(t).disabled) == null ? void 0 : a.value,
        onClick: c(t).onOpenToggle
      }, {
        default: y(() => [
          E(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function hC(n, e) {
  var t;
  const r = B({}), o = B("none"), i = B(n), a = n.value ? "mounted" : "unmounted";
  let s;
  const l = ((t = e.value) == null ? void 0 : t.ownerDocument.defaultView) ?? ld, { state: d, dispatch: u } = lC(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), f = (v) => {
    var $;
    if (Kr) {
      const C = new CustomEvent(v, { bubbles: !1, cancelable: !1 });
      ($ = e.value) == null || $.dispatchEvent(C);
    }
  };
  De(
    n,
    async (v, $) => {
      var C;
      const S = $ !== v;
      if (await Be(), S) {
        const w = o.value, T = Pd(e.value);
        v ? (u("MOUNT"), f("enter"), T === "none" && f("after-enter")) : T === "none" || ((C = r.value) == null ? void 0 : C.display) === "none" ? (u("UNMOUNT"), f("leave"), f("after-leave")) : $ && w !== T ? (u("ANIMATION_OUT"), f("leave")) : (u("UNMOUNT"), f("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const p = (v) => {
    const $ = Pd(e.value), C = $.includes(
      v.animationName
    ), S = d.value === "mounted" ? "enter" : "leave";
    if (v.target === e.value && C && (f(`after-${S}`), u("ANIMATION_END"), !i.value)) {
      const w = e.value.style.animationFillMode;
      e.value.style.animationFillMode = "forwards", s = l?.setTimeout(() => {
        var T;
        ((T = e.value) == null ? void 0 : T.style.animationFillMode) === "forwards" && (e.value.style.animationFillMode = w);
      });
    }
    v.target === e.value && $ === "none" && u("ANIMATION_END");
  }, h = (v) => {
    v.target === e.value && (o.value = Pd(e.value));
  }, m = De(
    e,
    (v, $) => {
      v ? (r.value = getComputedStyle(v), v.addEventListener("animationstart", h), v.addEventListener("animationcancel", p), v.addEventListener("animationend", p)) : (u("ANIMATION_END"), l?.clearTimeout(s), $?.removeEventListener("animationstart", h), $?.removeEventListener("animationcancel", p), $?.removeEventListener("animationend", p));
    },
    { immediate: !0 }
  ), g = De(d, () => {
    const v = Pd(e.value);
    o.value = d.value === "mounted" ? v : "none";
  });
  return Qn(() => {
    m(), g();
  }), {
    isPresent: M(
      () => ["mounted", "unmountSuspended"].includes(d.value)
    )
  };
}
function Pd(n) {
  return n && getComputedStyle(n).animationName || "none";
}
const Bn = _({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(n, { slots: e, expose: t }) {
    var r;
    const { present: o, forceMount: i } = at(n), a = B(), { isPresent: s } = hC(o, a);
    t({ present: s });
    let l = e.default({ present: s });
    l = zc(l || []);
    const d = sn();
    if (l && l?.length > 1) {
      const u = (r = d?.parent) != null && r.type.name ? `<${d.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${u}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((f) => `  - ${f}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => i.value || o.value || s.value ? Yt(e.default({ present: s })[0], {
      ref: (u) => {
        const f = Zn(u);
        return typeof f?.hasAttribute > "u" || (f != null && f.hasAttribute("data-radix-popper-content-wrapper") ? a.value = f.firstElementChild : a.value = f), f;
      }
    }) : null;
  }
}), Pb = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = Ab();
    t.contentId || (t.contentId = zt(void 0, "radix-vue-collapsible-content"));
    const r = B(), { forwardRef: o, currentElement: i } = ie(), a = B(0), s = B(0), l = M(() => t.open.value), d = B(l.value), u = B();
    return De(
      () => {
        var f;
        return [l.value, (f = r.value) == null ? void 0 : f.present];
      },
      async () => {
        await Be();
        const f = i.value;
        if (!f)
          return;
        u.value = u.value || {
          transitionDuration: f.style.transitionDuration,
          animationName: f.style.animationName
        }, f.style.transitionDuration = "0s", f.style.animationName = "none";
        const p = f.getBoundingClientRect();
        s.value = p.height, a.value = p.width, d.value || (f.style.transitionDuration = u.value.transitionDuration, f.style.animationName = u.value.animationName);
      },
      {
        immediate: !0
      }
    ), Ge(() => {
      requestAnimationFrame(() => {
        d.value = !1;
      });
    }), (f, p) => (b(), k(c(Bn), {
      ref_key: "presentRef",
      ref: r,
      present: f.forceMount || c(t).open.value,
      "force-mount": !0
    }, {
      default: y(() => {
        var h, m;
        return [
          x(c(le), j(f.$attrs, {
            id: c(t).contentId,
            ref: c(o),
            "as-child": e.asChild,
            as: f.as,
            "data-state": c(t).open.value ? "open" : "closed",
            "data-disabled": (h = c(t).disabled) != null && h.value ? "" : void 0,
            hidden: !((m = r.value) != null && m.present),
            style: {
              "--radix-collapsible-content-height": `${s.value}px`,
              "--radix-collapsible-content-width": `${a.value}px`
            }
          }), {
            default: y(() => {
              var g;
              return [
                (g = r.value) != null && g.present ? E(f.$slots, "default", { key: 0 }) : X("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function Db({ type: n, defaultValue: e, modelValue: t }) {
  const r = t || e;
  if (nu(n) && nu(t) && nu(e))
    throw new Error("Either the `type` or the `value` or `default-value` prop must be defined.");
  if (t !== void 0 && e !== void 0 && typeof t != typeof e)
    throw new Error(
      `Invalid prop \`value\` of value \`${t}\` supplied, should be the same type as the \`defaultValue\` prop, which is \`${e}\`. The \`value\` prop must be:
  ${n === "single" ? "- a string" : n === "multiple" ? "- an array of strings" : `- a string
- an array of strings`}
  - \`undefined\``
    );
  const o = t !== void 0 || e !== void 0;
  if (n && o) {
    const i = Array.isArray(t) || Array.isArray(e), a = t !== void 0 ? "modelValue" : "defaultValue", s = a === "modelValue" ? typeof t : typeof e;
    if (n === "single" && i)
      return console.error(`Invalid prop \`${a}\` of type ${s} supplied with type \`single\`. The \`modelValue\` prop must be a string or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${a} prop.`), "multiple";
    if (n === "multiple" && !i)
      return console.error(`Invalid prop \`${a}\` of type ${s} supplied with type \`multiple\`. The \`modelValue\` prop must be an array of strings or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${a} prop.`), "single";
  }
  return o ? Array.isArray(r) ? "multiple" : "single" : n;
}
function mC({ type: n, defaultValue: e, modelValue: t }) {
  return n || Db({ type: n, defaultValue: e, modelValue: t });
}
function gC({ type: n, defaultValue: e }) {
  return e !== void 0 ? e : n === "single" ? void 0 : [];
}
function Ib(n, e) {
  const t = B(mC(n)), r = gt(n, "modelValue", e, {
    defaultValue: gC(n),
    passive: n.modelValue === void 0,
    deep: !0
  });
  De(
    () => [n.type, n.modelValue, n.defaultValue],
    () => {
      const a = Db(n);
      t.value !== a && (t.value = a);
    },
    { immediate: !0 }
  );
  function o(a) {
    if (t.value === "single")
      r.value = a === r.value ? void 0 : a;
    else {
      const s = [...r.value || []];
      if (s.includes(a)) {
        const l = s.findIndex((d) => d === a);
        s.splice(l, 1);
      } else
        s.push(a);
      r.value = s;
    }
  }
  const i = M(() => t.value === "single");
  return {
    modelValue: r,
    type: t,
    changeModelValue: o,
    isSingle: i
  };
}
const [Kc, vC] = Xe("AccordionRoot"), yC = /* @__PURE__ */ _({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, { dir: o, disabled: i } = at(t), a = Cr(o), { modelValue: s, changeModelValue: l, isSingle: d } = Ib(t, r), { forwardRef: u, currentElement: f } = ie();
    return vC({
      disabled: i,
      direction: a,
      orientation: t.orientation,
      parentElement: f,
      isSingle: d,
      collapsible: t.collapsible,
      modelValue: s,
      changeModelValue: l
    }), (p, h) => (b(), k(c(le), {
      ref: c(u),
      "as-child": p.asChild,
      as: p.as
    }, {
      default: y(() => [
        E(p.$slots, "default", { modelValue: c(s) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [Km, bC] = Xe("AccordionItem"), $C = /* @__PURE__ */ _({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n, { expose: e }) {
    const t = n, r = Kc(), o = M(
      () => r.isSingle.value ? t.value === r.modelValue.value : Array.isArray(r.modelValue.value) && r.modelValue.value.includes(t.value)
    ), i = M(() => r.disabled.value || t.disabled), a = M(() => i.value ? "" : void 0), s = M(
      () => o.value ? "open" : "closed"
      /* Closed */
    );
    e({ open: o, dataDisabled: a });
    const { currentRef: l, currentElement: d } = ie();
    bC({
      open: o,
      dataState: s,
      disabled: i,
      dataDisabled: a,
      triggerId: "",
      currentRef: l,
      currentElement: d,
      value: M(() => t.value)
    });
    function u(f) {
      var p;
      const h = f.target;
      if (Array.from(((p = r.parentElement.value) == null ? void 0 : p.querySelectorAll("[data-radix-vue-collection-item]")) ?? []).findIndex((m) => m === h) === -1)
        return null;
      _b(
        f,
        d.value,
        r.parentElement.value,
        {
          arrowKeyOptions: r.orientation,
          dir: r.direction.value,
          focus: !0
        }
      );
    }
    return (f, p) => (b(), k(c(Mb), {
      "data-orientation": c(r).orientation,
      "data-disabled": a.value,
      "data-state": s.value,
      disabled: i.value,
      open: o.value,
      as: t.as,
      "as-child": t.asChild,
      onKeydown: ur(u, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: y(() => [
        E(f.$slots, "default", { open: o.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child"]));
  }
}), wC = /* @__PURE__ */ _({
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = Kc(), r = Km();
    return ie(), (o, i) => (b(), k(c(Pb), {
      role: "region",
      hidden: !c(r).open.value,
      "as-child": e.asChild,
      "force-mount": e.forceMount,
      "aria-labelledby": c(r).triggerId,
      "data-state": c(r).dataState.value,
      "data-disabled": c(r).dataDisabled.value,
      "data-orientation": c(t).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["hidden", "as-child", "force-mount", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), xC = /* @__PURE__ */ _({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(n) {
    const e = n, t = Kc(), r = Km();
    return ie(), (o, i) => (b(), k(c(le), {
      as: e.as,
      "as-child": e.asChild,
      "data-orientation": c(t).orientation,
      "data-state": c(r).dataState.value,
      "data-disabled": c(r).dataDisabled.value
    }, {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), CC = /* @__PURE__ */ _({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = Kc(), r = Km();
    r.triggerId || (r.triggerId = zt(void 0, "radix-vue-accordion-trigger"));
    function o() {
      const i = t.isSingle.value && r.open.value && !t.collapsible;
      r.disabled.value || i || t.changeModelValue(r.value.value);
    }
    return (i, a) => (b(), k(c(Nb), {
      id: c(r).triggerId,
      ref: c(r).currentRef,
      "data-radix-vue-collection-item": "",
      as: e.as,
      "as-child": e.asChild,
      "aria-disabled": c(r).disabled.value || void 0,
      "aria-expanded": c(r).open.value || !1,
      "data-disabled": c(r).dataDisabled.value,
      "data-orientation": c(t).orientation,
      "data-state": c(r).dataState.value,
      disabled: c(r).disabled.value,
      onClick: o
    }, {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [Wr, kC] = Xe("DialogRoot"), Wc = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = gt(t, "open", e, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), o = B(), i = B(), { modal: a } = at(t);
    return kC({
      open: r,
      modal: a,
      openModal: () => {
        r.value = !0;
      },
      onOpenChange: (s) => {
        r.value = s;
      },
      onOpenToggle: () => {
        r.value = !r.value;
      },
      contentId: "",
      titleId: "",
      descriptionId: "",
      triggerElement: o,
      contentElement: i
    }), (s, l) => E(s.$slots, "default", { open: c(r) });
  }
}), _C = /* @__PURE__ */ _({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = Wr(), { forwardRef: r, currentElement: o } = ie();
    return t.contentId || (t.contentId = zt(void 0, "radix-vue-dialog-content")), Ge(() => {
      t.triggerElement.value = o.value;
    }), (i, a) => (b(), k(c(le), j(e, {
      ref: c(r),
      type: i.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": c(t).open.value || !1,
      "aria-controls": c(t).open.value ? c(t).contentId : void 0,
      "data-state": c(t).open.value ? "open" : "closed",
      onClick: c(t).onOpenToggle
    }), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
}), cd = /* @__PURE__ */ _({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = jm();
    return (t, r) => c(e) || t.forceMount ? (b(), k(Pc, {
      key: 0,
      to: t.to,
      disabled: t.disabled
    }, [
      E(t.$slots, "default")
    ], 8, ["to", "disabled"])) : X("", !0);
  }
}), Wm = /* @__PURE__ */ _({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(cd), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SC = "dismissableLayer.pointerDownOutside", EC = "dismissableLayer.focusOutside";
function Rb(n, e) {
  const t = e.closest(
    "[data-dismissable-layer]"
  ), r = n.dataset.dismissableLayer === "" ? n : n.querySelector(
    "[data-dismissable-layer]"
  ), o = Array.from(
    n.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(t && r === t || o.indexOf(r) < o.indexOf(t));
}
function OC(n, e) {
  var t;
  const r = ((t = e?.value) == null ? void 0 : t.ownerDocument) ?? globalThis?.document, o = B(!1), i = B(() => {
  });
  return vt((a) => {
    if (!Kr)
      return;
    const s = async (d) => {
      const u = d.target;
      if (e != null && e.value) {
        if (Rb(e.value, u)) {
          o.value = !1;
          return;
        }
        if (d.target && !o.value) {
          let f = function() {
            Vm(
              SC,
              n,
              p
            );
          };
          const p = { originalEvent: d };
          d.pointerType === "touch" ? (r.removeEventListener("click", i.value), i.value = f, r.addEventListener("click", i.value, {
            once: !0
          })) : f();
        } else
          r.removeEventListener("click", i.value);
        o.value = !1;
      }
    }, l = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    a(() => {
      window.clearTimeout(l), r.removeEventListener("pointerdown", s), r.removeEventListener("click", i.value);
    });
  }), {
    onPointerDownCapture: () => o.value = !0
  };
}
function TC(n, e) {
  var t;
  const r = ((t = e?.value) == null ? void 0 : t.ownerDocument) ?? globalThis?.document, o = B(!1);
  return vt((i) => {
    if (!Kr)
      return;
    const a = async (s) => {
      e != null && e.value && (await Be(), !(!e.value || Rb(e.value, s.target)) && s.target && !o.value && Vm(
        EC,
        n,
        { originalEvent: s }
      ));
    };
    r.addEventListener("focusin", a), i(() => r.removeEventListener("focusin", a));
  }), {
    onFocusCapture: () => o.value = !0,
    onBlurCapture: () => o.value = !1
  };
}
const rr = Zo({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ms = /* @__PURE__ */ _({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(n, { emit: e }) {
    const t = n, r = e, { forwardRef: o, currentElement: i } = ie(), a = M(
      () => {
        var m;
        return ((m = i.value) == null ? void 0 : m.ownerDocument) ?? globalThis.document;
      }
    ), s = M(() => rr.layersRoot), l = M(() => i.value ? Array.from(s.value).indexOf(i.value) : -1), d = M(() => rr.layersWithOutsidePointerEventsDisabled.size > 0), u = M(() => {
      const m = Array.from(s.value), [g] = [...rr.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(g);
      return l.value >= v;
    }), f = OC(async (m) => {
      const g = [...rr.branches].some(
        (v) => v?.contains(m.target)
      );
      !u.value || g || (r("pointerDownOutside", m), r("interactOutside", m), await Be(), m.defaultPrevented || r("dismiss"));
    }, i), p = TC((m) => {
      [...rr.branches].some(
        (g) => g?.contains(m.target)
      ) || (r("focusOutside", m), r("interactOutside", m), m.defaultPrevented || r("dismiss"));
    }, i);
    zm("Escape", (m) => {
      l.value === s.value.size - 1 && (r("escapeKeyDown", m), m.defaultPrevented || r("dismiss"));
    });
    let h;
    return vt((m) => {
      i.value && (t.disableOutsidePointerEvents && (rr.layersWithOutsidePointerEventsDisabled.size === 0 && (h = a.value.body.style.pointerEvents, a.value.body.style.pointerEvents = "none"), rr.layersWithOutsidePointerEventsDisabled.add(i.value)), s.value.add(i.value), m(() => {
        t.disableOutsidePointerEvents && rr.layersWithOutsidePointerEventsDisabled.size === 1 && (a.value.body.style.pointerEvents = h);
      }));
    }), vt((m) => {
      m(() => {
        i.value && (s.value.delete(i.value), rr.layersWithOutsidePointerEventsDisabled.delete(i.value));
      });
    }), (m, g) => (b(), k(c(le), {
      ref: c(o),
      "as-child": m.asChild,
      as: m.as,
      "data-dismissable-layer": "",
      style: Zi({
        pointerEvents: d.value ? u.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: c(p).onFocusCapture,
      onBlurCapture: c(p).onBlurCapture,
      onPointerdownCapture: c(f).onPointerDownCapture
    }, {
      default: y(() => [
        E(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), AC = /* @__PURE__ */ _({
  __name: "DismissableLayerBranch",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { forwardRef: t, currentElement: r } = ie();
    return Ge(() => {
      rr.branches.add(r.value);
    }), Qn(() => {
      rr.branches.delete(r.value);
    }), (o, i) => (b(), k(c(le), j({ ref: c(t) }, e), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Xf = "focusScope.autoFocusOnMount", Qf = "focusScope.autoFocusOnUnmount", ug = { bubbles: !1, cancelable: !0 };
function ru(n, { select: e = !1 } = {}) {
  const t = Bt();
  for (const r of n)
    if (Mo(r, { select: e }), Bt() !== t)
      return !0;
}
function MC(n) {
  const e = qm(n), t = cg(e, n), r = cg(e.reverse(), n);
  return [t, r];
}
function qm(n) {
  const e = [], t = document.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); )
    e.push(t.currentNode);
  return e;
}
function cg(n, e) {
  for (const t of n)
    if (!NC(t, { upTo: e }))
      return t;
}
function NC(n, { upTo: e }) {
  if (getComputedStyle(n).visibility === "hidden")
    return !0;
  for (; n; ) {
    if (e !== void 0 && n === e)
      return !1;
    if (getComputedStyle(n).display === "none")
      return !0;
    n = n.parentElement;
  }
  return !1;
}
function PC(n) {
  return n instanceof HTMLInputElement && "select" in n;
}
function Mo(n, { select: e = !1 } = {}) {
  if (n && n.focus) {
    const t = Bt();
    n.focus({ preventScroll: !0 }), n !== t && PC(n) && e && n.select();
  }
}
const DC = C9(() => B([]));
function IC() {
  const n = DC();
  return {
    add(e) {
      const t = n.value[0];
      e !== t && t?.pause(), n.value = fg(n.value, e), n.value.unshift(e);
    },
    remove(e) {
      var t;
      n.value = fg(n.value, e), (t = n.value[0]) == null || t.resume();
    }
  };
}
function fg(n, e) {
  const t = [...n], r = t.indexOf(e);
  return r !== -1 && t.splice(r, 1), t;
}
function RC(n) {
  return n.filter((e) => e.tagName !== "A");
}
const qc = /* @__PURE__ */ _({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, { currentRef: o, currentElement: i } = ie(), a = B(null), s = IC(), l = Zo({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    vt((u) => {
      if (!Kr)
        return;
      const f = i.value;
      if (!t.trapped)
        return;
      function p(v) {
        if (l.paused || !f)
          return;
        const $ = v.target;
        f.contains($) ? a.value = $ : Mo(a.value, { select: !0 });
      }
      function h(v) {
        if (l.paused || !f)
          return;
        const $ = v.relatedTarget;
        $ !== null && (f.contains($) || Mo(a.value, { select: !0 }));
      }
      function m(v) {
        f.contains(a.value) || Mo(f);
      }
      document.addEventListener("focusin", p), document.addEventListener("focusout", h);
      const g = new MutationObserver(m);
      f && g.observe(f, { childList: !0, subtree: !0 }), u(() => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", h), g.disconnect();
      });
    }), vt(async (u) => {
      const f = i.value;
      if (await Be(), !f)
        return;
      s.add(l);
      const p = Bt();
      if (!f.contains(p)) {
        const h = new CustomEvent(Xf, ug);
        f.addEventListener(Xf, (m) => r("mountAutoFocus", m)), f.dispatchEvent(h), h.defaultPrevented || (ru(RC(qm(f)), {
          select: !0
        }), Bt() === p && Mo(f));
      }
      u(() => {
        f.removeEventListener(Xf, (g) => r("mountAutoFocus", g));
        const h = new CustomEvent(Qf, ug), m = (g) => {
          r("unmountAutoFocus", g);
        };
        f.addEventListener(Qf, m), f.dispatchEvent(h), setTimeout(() => {
          h.defaultPrevented || Mo(p ?? document.body, { select: !0 }), f.removeEventListener(Qf, m), s.remove(l);
        }, 0);
      });
    });
    function d(u) {
      if (!t.loop && !t.trapped || l.paused)
        return;
      const f = u.key === "Tab" && !u.altKey && !u.ctrlKey && !u.metaKey, p = Bt();
      if (f && p) {
        const h = u.currentTarget, [m, g] = MC(h);
        m && g ? !u.shiftKey && p === g ? (u.preventDefault(), t.loop && Mo(m, { select: !0 })) : u.shiftKey && p === m && (u.preventDefault(), t.loop && Mo(g, { select: !0 })) : p === h && u.preventDefault();
      }
    }
    return (u, f) => (b(), k(c(le), {
      ref_key: "currentRef",
      ref: o,
      tabindex: "-1",
      "as-child": u.asChild,
      as: u.as,
      onKeydown: d
    }, {
      default: y(() => [
        E(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), BC = "menu.itemSelect", ih = ["Enter", " "], LC = ["ArrowDown", "PageUp", "Home"], Bb = ["ArrowUp", "PageDown", "End"], FC = [...LC, ...Bb];
[...ih], [...ih];
function Lb(n) {
  return n ? "open" : "closed";
}
function Fb(n) {
  return n === "indeterminate";
}
function Vb(n) {
  return Fb(n) ? "indeterminate" : n ? "checked" : "unchecked";
}
function ah(n) {
  const e = Bt();
  for (const t of n)
    if (t === e || (t.focus(), Bt() !== e))
      return;
}
function VC(n, e) {
  const { x: t, y: r } = n;
  let o = !1;
  for (let i = 0, a = e.length - 1; i < e.length; a = i++) {
    const s = e[i].x, l = e[i].y, d = e[a].x, u = e[a].y;
    l > r != u > r && t < (d - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function zC(n, e) {
  if (!e)
    return !1;
  const t = { x: n.clientX, y: n.clientY };
  return VC(t, e);
}
function sh(n) {
  return n.pointerType === "mouse";
}
const jC = "DialogTitle", HC = "DialogContent";
function UC({
  titleName: n = jC,
  contentName: e = HC,
  componentLink: t = "dialog.html#title",
  titleId: r,
  descriptionId: o,
  contentElement: i
}) {
  const a = `Warning: \`${e}\` requires a \`${n}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/${t}`, s = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${e}.`;
  Ge(() => {
    var l;
    document.getElementById(r) || console.warn(a);
    const d = (l = i.value) == null ? void 0 : l.getAttribute("aria-describedby");
    o && d && (document.getElementById(o) || console.warn(s));
  });
}
const zb = /* @__PURE__ */ _({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Wr(), { forwardRef: i, currentElement: a } = ie();
    return o.titleId || (o.titleId = zt(void 0, "radix-vue-dialog-title")), o.descriptionId || (o.descriptionId = zt(void 0, "radix-vue-dialog-description")), Ge(() => {
      o.contentElement = a, Bt() !== document.body && (o.triggerElement.value = Bt());
    }), process.env.NODE_ENV !== "production" && UC({
      titleName: "DialogTitle",
      contentName: "DialogContent",
      componentLink: "dialog.html#title",
      titleId: o.titleId,
      descriptionId: o.descriptionId,
      contentElement: a
    }), (s, l) => (b(), k(c(qc), {
      "as-child": "",
      loop: "",
      trapped: t.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (d) => r("openAutoFocus", d)),
      onUnmountAutoFocus: l[6] || (l[6] = (d) => r("closeAutoFocus", d))
    }, {
      default: y(() => [
        x(c(ms), j({
          id: c(o).contentId,
          ref: c(i),
          as: s.as,
          "as-child": s.asChild,
          "disable-outside-pointer-events": s.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": c(o).descriptionId,
          "aria-labelledby": c(o).titleId,
          "data-state": c(Lb)(c(o).open.value)
        }, s.$attrs, {
          onDismiss: l[0] || (l[0] = (d) => c(o).onOpenChange(!1)),
          onEscapeKeyDown: l[1] || (l[1] = (d) => r("escapeKeyDown", d)),
          onFocusOutside: l[2] || (l[2] = (d) => r("focusOutside", d)),
          onInteractOutside: l[3] || (l[3] = (d) => r("interactOutside", d)),
          onPointerDownOutside: l[4] || (l[4] = (d) => r("pointerDownOutside", d))
        }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), KC = /* @__PURE__ */ _({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Wr(), i = ea(r), { forwardRef: a, currentElement: s } = ie();
    return ud(s), (l, d) => (b(), k(zb, j({ ...t, ...c(i) }, {
      ref: c(a),
      "trap-focus": c(o).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: d[0] || (d[0] = (u) => {
        var f;
        u.defaultPrevented || (u.preventDefault(), (f = c(o).triggerElement.value) == null || f.focus());
      }),
      onPointerDownOutside: d[1] || (d[1] = (u) => {
        const f = u.detail.originalEvent, p = f.button === 0 && f.ctrlKey === !0;
        (f.button === 2 || p) && u.preventDefault();
      }),
      onFocusOutside: d[2] || (d[2] = (u) => {
        u.preventDefault();
      })
    }), {
      default: y(() => [
        E(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), WC = /* @__PURE__ */ _({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = ea(e);
    ie();
    const o = Wr(), i = B(!1), a = B(!1);
    return (s, l) => (b(), k(zb, j({ ...t, ...c(r) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: l[0] || (l[0] = (d) => {
        var u;
        d.defaultPrevented || (i.value || (u = c(o).triggerElement.value) == null || u.focus(), d.preventDefault()), i.value = !1, a.value = !1;
      }),
      onInteractOutside: l[1] || (l[1] = (d) => {
        var u;
        d.defaultPrevented || (i.value = !0, d.detail.originalEvent.type === "pointerdown" && (a.value = !0));
        const f = d.target;
        (u = c(o).triggerElement.value) != null && u.contains(f) && d.preventDefault(), d.detail.originalEvent.type === "focusin" && a.value && d.preventDefault();
      })
    }), {
      default: y(() => [
        E(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Gm = /* @__PURE__ */ _({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Wr(), i = ea(r), { forwardRef: a } = ie();
    return (s, l) => (b(), k(c(Bn), {
      present: s.forceMount || c(o).open.value
    }, {
      default: y(() => [
        c(o).modal.value ? (b(), k(KC, j({
          key: 0,
          ref: c(a)
        }, { ...t, ...c(i), ...s.$attrs }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (b(), k(WC, j({
          key: 1,
          ref: c(a)
        }, { ...t, ...c(i), ...s.$attrs }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), qC = /* @__PURE__ */ _({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = Wr();
    return dd(!0), ie(), (t, r) => (b(), k(c(le), {
      as: t.as,
      "as-child": t.asChild,
      "data-state": c(e).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), Jm = /* @__PURE__ */ _({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = Wr(), { forwardRef: t } = ie();
    return (r, o) => {
      var i;
      return (i = c(e)) != null && i.modal.value ? (b(), k(c(Bn), {
        key: 0,
        present: r.forceMount || c(e).open.value
      }, {
        default: y(() => [
          x(qC, j(r.$attrs, {
            ref: c(t),
            as: r.as,
            "as-child": r.asChild
          }), {
            default: y(() => [
              E(r.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : X("", !0);
    };
  }
}), GC = /* @__PURE__ */ _({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n;
    ie();
    const t = Wr();
    return (r, o) => (b(), k(c(le), j(e, {
      type: r.as === "button" ? "button" : void 0,
      onClick: o[0] || (o[0] = (i) => c(t).onOpenChange(!1))
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), JC = /* @__PURE__ */ _({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: { default: "h2" }
  },
  setup(n) {
    const e = n, t = Wr();
    return ie(), (r, o) => (b(), k(c(le), j(e, {
      id: c(t).titleId
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), ZC = /* @__PURE__ */ _({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: { default: "p" }
  },
  setup(n) {
    const e = n;
    ie();
    const t = Wr();
    return (r, o) => (b(), k(c(le), j(e, {
      id: c(t).descriptionId
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
});
function YC(n) {
  function e(r) {
    return Array.isArray(n.date.value) ? n.date.value.some((o) => Ra(o, r)) : n.date.value ? Ra(n.date.value, r) : !1;
  }
  const t = M(
    () => {
      var r, o, i, a;
      if (Array.isArray(n.date.value)) {
        if (!n.date.value.length)
          return !1;
        for (const s of n.date.value)
          if ((r = n.isDateDisabled) != null && r.call(n, s) || (o = n.isDateUnavailable) != null && o.call(n, s))
            return !0;
      } else {
        if (!n.date.value)
          return !1;
        if ((i = n.isDateDisabled) != null && i.call(n, n.date.value) || (a = n.isDateUnavailable) != null && a.call(n, n.date.value))
          return !0;
      }
      return !1;
    }
  );
  return {
    isDateSelected: e,
    isInvalid: t
  };
}
function XC(n, e) {
  const t = e(n), r = t.compare(n), o = {};
  return r >= 7 && (o.day = 1), r >= $l(n) && (o.month = 1), t.set({ ...o });
}
function QC(n, e) {
  const t = e(n), r = n.compare(t), o = {};
  return r >= 7 && (o.day = 35), r >= $l(n) && (o.month = 13), t.set({ ...o });
}
function e7(n, e) {
  return e(n);
}
function t7(n, e) {
  return e(n);
}
function n7(n) {
  const e = J9(n.locale.value), t = M(() => {
    const g = {
      calendar: n.placeholder.value.calendar.identifier
    };
    return n.placeholder.value.calendar.identifier === "gregory" && n.placeholder.value.era === "BC" && (g.era = "short"), g;
  }), r = B(pi({
    dateObj: n.placeholder.value,
    weekStartsOn: n.weekStartsOn.value,
    locale: n.locale.value,
    fixedWeeks: n.fixedWeeks.value,
    numberOfMonths: n.numberOfMonths.value
  })), o = M(() => r.value.map((g) => g.value));
  function i(g) {
    return !o.value.some((v) => M1(g, v));
  }
  const a = (g = "month", v) => {
    if (!n.maxValue.value || !r.value.length)
      return !1;
    if (n.disabled.value)
      return !0;
    const $ = r.value[r.value.length - 1].value;
    if (v || n.nextPage.value) {
      const S = XC($, v || n.nextPage.value);
      return Td(S, n.maxValue.value);
    }
    if (g === "year") {
      const S = $.add({ years: 1 }).set({ day: 1, month: 1 });
      return Td(S, n.maxValue.value);
    }
    const C = $.add({ months: 1 }).set({ day: 1 });
    return Td(C, n.maxValue.value);
  }, s = (g = "month", v) => {
    if (!n.minValue.value || !r.value.length)
      return !1;
    if (n.disabled.value)
      return !0;
    const $ = r.value[0].value;
    if (v || n.prevPage.value) {
      const S = QC($, v || n.prevPage.value);
      return Od(S, n.minValue.value);
    }
    if (g === "year") {
      const S = $.subtract({ years: 1 }).set({ day: 35, month: 13 });
      return Od(S, n.minValue.value);
    }
    const C = $.subtract({ months: 1 }).set({ day: 35 });
    return Od(C, n.minValue.value);
  };
  function l(g) {
    var v;
    return !!((v = n.isDateDisabled) != null && v.call(n, g) || n.disabled.value || n.maxValue.value && Td(g, n.maxValue.value) || n.minValue.value && Od(g, n.minValue.value));
  }
  const d = (g) => {
    var v;
    return !!((v = n.isDateUnavailable) != null && v.call(n, g));
  }, u = M(() => r.value.length ? r.value[0].rows[0].map((g) => e.dayOfWeek(Nr(g), n.weekdayFormat.value)) : []), f = (g = "month", v) => {
    const $ = r.value[0].value;
    if (v || n.nextPage.value) {
      const w = e7($, v || n.nextPage.value), T = pi({
        dateObj: w,
        weekStartsOn: n.weekStartsOn.value,
        locale: n.locale.value,
        fixedWeeks: n.fixedWeeks.value,
        numberOfMonths: n.numberOfMonths.value
      });
      r.value = T;
      const A = {};
      if (!v) {
        const N = T[0].value.compare($);
        N >= $l($) && (A.day = 1), N >= 365 && (A.month = 1);
      }
      n.placeholder.value = T[0].value.set({ ...A });
      return;
    }
    const C = g === "month" ? $.add({ months: n.pagedNavigation.value ? n.numberOfMonths.value : 1 }) : $.add({ years: 1 }), S = pi({
      dateObj: C,
      weekStartsOn: n.weekStartsOn.value,
      locale: n.locale.value,
      fixedWeeks: n.fixedWeeks.value,
      numberOfMonths: n.numberOfMonths.value
    });
    r.value = S, n.placeholder.value = S[0].value.set({ day: 1 });
  }, p = (g = "month", v) => {
    const $ = r.value[0].value;
    if (v || n.prevPage.value) {
      const w = t7($, v || n.prevPage.value), T = pi({
        dateObj: w,
        weekStartsOn: n.weekStartsOn.value,
        locale: n.locale.value,
        fixedWeeks: n.fixedWeeks.value,
        numberOfMonths: n.numberOfMonths.value
      });
      r.value = T;
      const A = {};
      if (!v) {
        const N = $.compare(T[0].value);
        N >= $l($) && (A.day = 1), N >= 365 && (A.month = 1);
      }
      n.placeholder.value = T[0].value.set({ ...A });
      return;
    }
    const C = g === "month" ? $.subtract({ months: n.pagedNavigation.value ? n.numberOfMonths.value : 1 }) : $.subtract({ years: 1 }), S = pi({
      dateObj: C,
      weekStartsOn: n.weekStartsOn.value,
      locale: n.locale.value,
      fixedWeeks: n.fixedWeeks.value,
      numberOfMonths: n.numberOfMonths.value
    });
    r.value = S, n.placeholder.value = S[0].value.set({ day: 1 });
  };
  De(n.placeholder, (g) => {
    o.value.some((v) => M1(v, g)) || (r.value = pi({
      dateObj: g,
      weekStartsOn: n.weekStartsOn.value,
      locale: n.locale.value,
      fixedWeeks: n.fixedWeeks.value,
      numberOfMonths: n.numberOfMonths.value
    }));
  }), De([n.locale, n.weekStartsOn, n.fixedWeeks, n.numberOfMonths], () => {
    r.value = pi({
      dateObj: n.placeholder.value,
      weekStartsOn: n.weekStartsOn.value,
      locale: n.locale.value,
      fixedWeeks: n.fixedWeeks.value,
      numberOfMonths: n.numberOfMonths.value
    });
  });
  const h = M(() => {
    if (!r.value.length)
      return "";
    if (n.locale.value !== e.getLocale() && e.setLocale(n.locale.value), r.value.length === 1) {
      const T = r.value[0].value;
      return `${e.fullMonthAndYear(Nr(T), t.value)}`;
    }
    const g = Nr(r.value[0].value), v = Nr(r.value[r.value.length - 1].value), $ = e.fullMonth(g, t.value), C = e.fullMonth(v, t.value), S = e.fullYear(g, t.value), w = e.fullYear(v, t.value);
    return S === w ? `${$} - ${C} ${w}` : `${$} ${S} - ${C} ${w}`;
  }), m = M(() => `${n.calendarLabel.value ?? "Event Date"}, ${h.value}`);
  return {
    isDateDisabled: l,
    isDateUnavailable: d,
    isNextButtonDisabled: a,
    isPrevButtonDisabled: s,
    grid: r,
    weekdays: u,
    visibleView: o,
    isOutsideVisibleView: i,
    formatter: e,
    nextPage: f,
    prevPage: p,
    headingValue: h,
    fullCalendarLabel: m
  };
}
const r7 = { style: { border: "0px", clip: "rect(0px, 0px, 0px, 0px)", "clip-path": "inset(50%)", height: "1px", margin: "-1px", overflow: "hidden", padding: "0px", position: "absolute", "white-space": "nowrap", width: "1px" } }, o7 = {
  role: "heading",
  "aria-level": "2"
}, [gs, i7] = Xe("CalendarRoot"), a7 = /* @__PURE__ */ _({
  __name: "CalendarRoot",
  props: {
    modelValue: {},
    multiple: { type: Boolean, default: !1 },
    defaultValue: { default: void 0 },
    defaultPlaceholder: {},
    placeholder: { default: void 0 },
    pagedNavigation: { type: Boolean, default: !1 },
    preventDeselect: { type: Boolean, default: !1 },
    weekStartsOn: { default: 0 },
    weekdayFormat: { default: "narrow" },
    calendarLabel: {},
    fixedWeeks: { type: Boolean, default: !1 },
    maxValue: {},
    minValue: {},
    locale: { default: "en" },
    numberOfMonths: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    initialFocus: { type: Boolean, default: !1 },
    isDateDisabled: { type: Function, default: void 0 },
    isDateUnavailable: { type: Function, default: void 0 },
    dir: {},
    nextPage: {},
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  emits: ["update:modelValue", "update:placeholder"],
  setup(n, { emit: e }) {
    const t = n, r = e, {
      locale: o,
      disabled: i,
      readonly: a,
      initialFocus: s,
      pagedNavigation: l,
      weekStartsOn: d,
      weekdayFormat: u,
      fixedWeeks: f,
      multiple: p,
      minValue: h,
      maxValue: m,
      numberOfMonths: g,
      preventDeselect: v,
      isDateDisabled: $,
      isDateUnavailable: C,
      calendarLabel: S,
      defaultValue: w,
      nextPage: T,
      prevPage: A,
      dir: N
    } = at(t), { primitiveElement: z, currentElement: I } = Uc(), P = Cr(N), L = gt(t, "modelValue", r, {
      defaultValue: w.value,
      passive: t.modelValue === void 0
    }), H = b9({
      defaultPlaceholder: t.placeholder,
      defaultValue: L.value,
      locale: t.locale
    }), q = gt(t, "placeholder", r, {
      defaultValue: t.defaultPlaceholder ?? H.copy(),
      passive: t.placeholder === void 0
    });
    function Q(ye) {
      q.value = ye.copy();
    }
    const {
      fullCalendarLabel: ae,
      headingValue: de,
      isDateDisabled: ne,
      isDateUnavailable: ke,
      isNextButtonDisabled: ee,
      isPrevButtonDisabled: be,
      weekdays: Ee,
      isOutsideVisibleView: nt,
      nextPage: ct,
      prevPage: Ne,
      formatter: st,
      grid: ce
    } = n7({
      locale: o,
      placeholder: q,
      weekStartsOn: d,
      fixedWeeks: f,
      numberOfMonths: g,
      minValue: h,
      maxValue: m,
      disabled: i,
      weekdayFormat: u,
      pagedNavigation: l,
      isDateDisabled: $.value,
      isDateUnavailable: C.value,
      calendarLabel: S,
      nextPage: T,
      prevPage: A
    }), {
      isInvalid: he,
      isDateSelected: ve
    } = YC({
      date: L,
      isDateDisabled: ne,
      isDateUnavailable: ke
    });
    De(L, (ye) => {
      if (Array.isArray(ye) && ye.length) {
        const Se = ye[ye.length - 1];
        Se && !Ff(q.value, Se) && Q(Se);
      } else
        !Array.isArray(ye) && ye && !Ff(q.value, ye) && Q(ye);
    });
    function _e(ye) {
      if (p.value) {
        if (!L.value)
          L.value = [ye.copy()];
        else if (Array.isArray(L.value)) {
          if (L.value.findIndex((Se) => Ra(Se, ye)) === -1)
            L.value = [...L.value, ye];
          else if (!v.value) {
            const Se = L.value.filter((se) => !Ra(se, ye));
            if (!Se.length) {
              q.value = ye.copy(), L.value = void 0;
              return;
            }
            L.value = Se.map((se) => se.copy());
          }
        }
      } else {
        if (!L.value) {
          L.value = ye.copy();
          return;
        }
        !v.value && Ff(L.value, ye) ? (q.value = ye.copy(), L.value = void 0) : L.value = ye.copy();
      }
    }
    return Ge(() => {
      s.value && $9(I.value);
    }), i7({
      isDateUnavailable: ke,
      dir: P,
      isDateDisabled: ne,
      locale: o,
      formatter: st,
      modelValue: L,
      placeholder: q,
      disabled: i,
      initialFocus: s,
      pagedNavigation: l,
      weekStartsOn: d,
      weekdayFormat: u,
      fixedWeeks: f,
      multiple: p,
      numberOfMonths: g,
      readonly: a,
      preventDeselect: v,
      fullCalendarLabel: ae,
      headingValue: de,
      isInvalid: he,
      isDateSelected: ve,
      isNextButtonDisabled: ee,
      isPrevButtonDisabled: be,
      isOutsideVisibleView: nt,
      nextPage: ct,
      prevPage: Ne,
      parentElement: I,
      onPlaceholderChange: Q,
      onDateChange: _e
    }), (ye, Se) => (b(), k(c(le), {
      ref_key: "primitiveElement",
      ref: z,
      as: ye.as,
      "as-child": ye.asChild,
      role: "application",
      "aria-label": c(ae),
      "data-readonly": c(a) ? "" : void 0,
      "data-disabled": c(i) ? "" : void 0,
      "data-invalid": c(he) ? "" : void 0,
      dir: c(P)
    }, {
      default: y(() => [
        E(ye.$slots, "default", {
          date: c(q),
          grid: c(ce),
          weekDays: c(Ee),
          weekStartsOn: c(d),
          locale: c(o),
          fixedWeeks: c(f)
        }),
        O("div", r7, [
          O("div", o7, U(c(ae)), 1)
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "aria-label", "data-readonly", "data-disabled", "data-invalid", "dir"]));
  }
}), s7 = /* @__PURE__ */ _({
  __name: "CalendarHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), l7 = /* @__PURE__ */ _({
  __name: "CalendarHeading",
  props: {
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(n) {
    const e = n, t = gs();
    return (r, o) => (b(), k(c(le), j(e, {
      "data-disabled": c(t).disabled.value ? "" : void 0
    }), {
      default: y(() => [
        E(r.$slots, "default", {
          headingValue: c(t).headingValue.value
        }, () => [
          K(U(c(t).headingValue.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["data-disabled"]));
  }
}), d7 = /* @__PURE__ */ _({
  __name: "CalendarGrid",
  props: {
    asChild: { type: Boolean },
    as: { default: "table" }
  },
  setup(n) {
    const e = n, t = gs(), r = M(() => t.disabled.value ? !0 : void 0), o = M(() => t.readonly.value ? !0 : void 0);
    return (i, a) => (b(), k(c(le), j(e, {
      tabindex: "-1",
      role: "grid",
      "aria-readonly": o.value,
      "aria-disabled": r.value,
      "data-readonly": o.value && "",
      "data-disabled": r.value && ""
    }), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-readonly", "aria-disabled", "data-readonly", "data-disabled"]));
  }
}), u7 = /* @__PURE__ */ _({
  __name: "CalendarCell",
  props: {
    date: {},
    asChild: { type: Boolean },
    as: { default: "td" }
  },
  setup(n) {
    const e = gs();
    return (t, r) => {
      var o, i;
      return b(), k(c(le), {
        as: t.as,
        "as-child": t.asChild,
        role: "gridcell",
        "aria-selected": c(e).isDateSelected(t.date) ? !0 : void 0,
        "aria-disabled": c(e).isDateDisabled(t.date) || ((i = (o = c(e)).isDateUnavailable) == null ? void 0 : i.call(o, t.date)),
        "data-disabled": c(e).isDateDisabled(t.date) ? "" : void 0
      }, {
        default: y(() => [
          E(t.$slots, "default")
        ]),
        _: 3
      }, 8, ["as", "as-child", "aria-selected", "aria-disabled", "data-disabled"]);
    };
  }
}), c7 = /* @__PURE__ */ _({
  __name: "CalendarHeadCell",
  props: {
    asChild: { type: Boolean },
    as: { default: "th" }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), f7 = /* @__PURE__ */ _({
  __name: "CalendarNext",
  props: {
    step: { default: "month" },
    nextPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = M(() => r.disabled.value || r.isNextButtonDisabled(e.step, e.nextPage)), r = gs();
    return (o, i) => (b(), k(c(le), {
      as: e.as,
      "as-child": e.asChild,
      "aria-label": "Next page",
      type: o.as === "button" ? "button" : void 0,
      "aria-disabled": t.value || void 0,
      "data-disabled": t.value || void 0,
      disabled: t.value,
      onClick: i[0] || (i[0] = (a) => c(r).nextPage(e.step, e.nextPage))
    }, {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          K("Next page")
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), p7 = /* @__PURE__ */ _({
  __name: "CalendarPrev",
  props: {
    step: { default: "month" },
    prevPage: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = M(() => r.disabled.value || r.isPrevButtonDisabled(e.step, e.prevPage)), r = gs();
    return (o, i) => (b(), k(c(le), {
      "aria-label": "Previous page",
      as: e.as,
      "as-child": e.asChild,
      type: o.as === "button" ? "button" : void 0,
      "aria-disabled": t.value || void 0,
      "data-disabled": t.value || void 0,
      disabled: t.value,
      onClick: i[0] || (i[0] = (a) => c(r).prevPage(e.step, e.prevPage))
    }, {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          K("Prev page")
        ])
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "aria-disabled", "data-disabled", "disabled"]));
  }
}), h7 = /* @__PURE__ */ _({
  __name: "CalendarGridHead",
  props: {
    asChild: { type: Boolean },
    as: { default: "thead" }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), j(e, { "aria-hidden": "true" }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), m7 = /* @__PURE__ */ _({
  __name: "CalendarGridBody",
  props: {
    asChild: { type: Boolean },
    as: { default: "tbody" }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), g7 = /* @__PURE__ */ _({
  __name: "CalendarGridRow",
  props: {
    asChild: { type: Boolean },
    as: { default: "tr" }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), v7 = /* @__PURE__ */ _({
  __name: "CalendarCellTrigger",
  props: {
    day: {},
    month: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(n) {
    const e = n, t = fC(), r = gs(), { primitiveElement: o, currentElement: i } = Uc(), a = M(() => e.day.day.toLocaleString(r.locale.value)), s = M(() => r.formatter.custom(Nr(e.day), {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    })), l = M(() => r.isDateDisabled(e.day)), d = M(
      () => {
        var S;
        return (S = r.isDateUnavailable) == null ? void 0 : S.call(r, e.day);
      }
    ), u = M(() => _8(e.day, ad())), f = M(() => !k8(e.day, e.month)), p = M(
      () => r.isOutsideVisibleView(e.day)
    ), h = M(() => !r.disabled.value && Ra(e.day, r.placeholder.value)), m = M(() => r.isDateSelected(e.day)), g = "[data-radix-vue-calendar-cell-trigger]:not([data-disabled]):not([data-outside-month]):not([data-outside-visible-months])";
    function v(S) {
      var w;
      r.readonly.value || r.isDateDisabled(S) || (w = r.isDateUnavailable) != null && w.call(r, S) || r.onDateChange(S);
    }
    function $() {
      v(e.day);
    }
    function C(S) {
      S.preventDefault(), S.stopPropagation();
      const w = r.parentElement.value, T = w ? Array.from(w.querySelectorAll(g)) : [];
      let A = T.indexOf(i.value);
      const N = 7, z = r.dir.value === "rtl" ? -1 : 1;
      switch (S.code) {
        case t.ARROW_RIGHT:
          A += z;
          break;
        case t.ARROW_LEFT:
          A -= z;
          break;
        case t.ARROW_UP:
          A -= N;
          break;
        case t.ARROW_DOWN:
          A += N;
          break;
        case t.ENTER:
        case t.SPACE_CODE:
          v(e.day);
          return;
        default:
          return;
      }
      if (A >= 0 && A < T.length) {
        T[A].focus();
        return;
      }
      if (A < 0) {
        if (r.isPrevButtonDisabled("month"))
          return;
        r.prevPage(), Be(() => {
          const I = w ? Array.from(w.querySelectorAll(g)) : [];
          I[I.length - Math.abs(A)].focus();
        });
        return;
      }
      if (A >= T.length) {
        if (r.isNextButtonDisabled("month"))
          return;
        r.nextPage(), Be(() => {
          (w ? Array.from(w.querySelectorAll(g)) : [])[A - T.length].focus();
        });
      }
    }
    return (S, w) => (b(), k(c(le), j({
      ref_key: "primitiveElement",
      ref: o
    }, e, {
      role: "button",
      "aria-label": s.value,
      "data-radix-vue-calendar-cell-trigger": "",
      "aria-disabled": f.value || l.value || d.value ? !0 : void 0,
      "data-selected": m.value ? !0 : void 0,
      "data-value": S.day.toString(),
      "data-disabled": l.value || f.value ? "" : void 0,
      "data-unavailable": d.value ? "" : void 0,
      "data-today": u.value ? "" : void 0,
      "data-outside-view": f.value ? "" : void 0,
      "data-outside-visible-view": p.value ? "" : void 0,
      "data-focused": h.value ? "" : void 0,
      tabindex: h.value ? 0 : f.value || l.value ? void 0 : -1,
      onClick: $,
      onKeydown: [
        ur(C, ["up", "down", "left", "right", "space", "enter"]),
        w[0] || (w[0] = ur(At(() => {
        }, ["prevent"]), ["enter"]))
      ]
    }), {
      default: y(() => [
        E(S.$slots, "default", { dayValue: a.value }, () => [
          K(U(a.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-disabled", "data-selected", "data-value", "data-disabled", "data-unavailable", "data-today", "data-outside-view", "data-outside-visible-view", "data-focused", "tabindex"]));
  }
});
function Su(n) {
  return n === "indeterminate";
}
function jb(n) {
  return Su(n) ? "indeterminate" : n ? "checked" : "unchecked";
}
const y7 = ["value", "checked", "name", "disabled", "required"], [b7, $7] = Xe("CheckboxRoot"), w7 = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CheckboxRoot",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: [Boolean, String], default: void 0 },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    value: { default: "on" },
    id: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  emits: ["update:checked"],
  setup(n, { emit: e }) {
    const t = n, r = e, { disabled: o } = at(t), i = gt(t, "checked", r, {
      defaultValue: t.defaultChecked,
      passive: t.checked === void 0
    }), { forwardRef: a, currentElement: s } = ie(), l = hs(s), d = M(() => {
      var u;
      return t.id && s.value ? (u = document.querySelector(`[for="${t.id}"]`)) == null ? void 0 : u.innerText : void 0;
    });
    return $7({
      disabled: o,
      state: i
    }), (u, f) => (b(), D(Me, null, [
      x(c(le), j(u.$attrs, {
        id: u.id,
        ref: c(a),
        role: "checkbox",
        "as-child": t.asChild,
        as: u.as,
        type: u.as === "button" ? "button" : void 0,
        "aria-checked": c(Su)(c(i)) ? "mixed" : c(i),
        "aria-required": !1,
        "aria-label": u.$attrs["aria-label"] || d.value,
        "data-state": c(jb)(c(i)),
        "data-disabled": c(o) ? "" : void 0,
        disabled: c(o),
        onKeydown: ur(At(() => {
        }, ["prevent"]), ["enter"]),
        onClick: f[0] || (f[0] = (p) => i.value = c(Su)(c(i)) ? !0 : !c(i))
      }), {
        default: y(() => [
          E(u.$slots, "default", { checked: c(i) })
        ]),
        _: 3
      }, 16, ["id", "as-child", "as", "type", "aria-checked", "aria-label", "data-state", "data-disabled", "disabled", "onKeydown"]),
      c(l) ? (b(), D("input", {
        key: 0,
        type: "checkbox",
        tabindex: "-1",
        "aria-hidden": "true",
        value: u.value,
        checked: !!c(i),
        name: t.name,
        disabled: t.disabled,
        required: t.required,
        style: {
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }, null, 8, y7)) : X("", !0)
    ], 64));
  }
}), x7 = /* @__PURE__ */ _({
  __name: "CheckboxIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const { forwardRef: e } = ie(), t = b7();
    return (r, o) => (b(), k(c(Bn), {
      present: r.forceMount || c(Su)(c(t).state.value) || c(t).state.value === !0
    }, {
      default: y(() => [
        x(c(le), j({
          ref: c(e),
          "data-state": c(jb)(c(t).state.value),
          "data-disabled": c(t).disabled.value ? "" : void 0,
          style: { pointerEvents: "none" },
          "as-child": r.asChild,
          as: r.as
        }, r.$attrs), {
          default: y(() => [
            E(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "data-disabled", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [Hb, C7] = Xe("PopperRoot"), fd = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(n) {
    const e = B();
    return C7({
      anchor: e,
      onAnchorChange: (t) => e.value = t
    }), (t, r) => E(t.$slots, "default");
  }
}), Gc = /* @__PURE__ */ _({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { forwardRef: t, currentElement: r } = ie(), o = Hb();
    return vt(() => {
      o.onAnchorChange(e.element ?? r.value);
    }), (i, a) => (b(), k(c(le), {
      ref: c(t),
      as: i.as,
      "as-child": i.asChild
    }, {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function k7(n) {
  return n !== null;
}
function _7(n) {
  return {
    name: "transformOrigin",
    options: n,
    fn(e) {
      var t, r, o;
      const { placement: i, rects: a, middlewareData: s } = e, l = ((t = s.arrow) == null ? void 0 : t.centerOffset) !== 0, d = l ? 0 : n.arrowWidth, u = l ? 0 : n.arrowHeight, [f, p] = lh(i), h = { start: "0%", center: "50%", end: "100%" }[p], m = (((r = s.arrow) == null ? void 0 : r.x) ?? 0) + d / 2, g = (((o = s.arrow) == null ? void 0 : o.y) ?? 0) + u / 2;
      let v = "", $ = "";
      return f === "bottom" ? (v = l ? h : `${m}px`, $ = `${-u}px`) : f === "top" ? (v = l ? h : `${m}px`, $ = `${a.floating.height + u}px`) : f === "right" ? (v = `${-u}px`, $ = l ? h : `${g}px`) : f === "left" && (v = `${a.floating.width + u}px`, $ = l ? h : `${g}px`), { data: { x: v, y: $ } };
    }
  };
}
function lh(n) {
  const [e, t = "center"] = n.split("-");
  return [e, t];
}
const Ub = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [sJ, S7] = Xe("PopperContent"), Ha = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ M2({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...Ub
  }),
  emits: ["placed"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Hb(), { forwardRef: i, currentElement: a } = ie(), s = B(), l = B(), { width: d, height: u } = Tb(l), f = M(
      () => t.side + (t.align !== "center" ? `-${t.align}` : "")
    ), p = M(() => typeof t.collisionPadding == "number" ? t.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...t.collisionPadding }), h = M(() => Array.isArray(t.collisionBoundary) ? t.collisionBoundary : [t.collisionBoundary]), m = M(() => ({
      padding: p.value,
      boundary: h.value.filter(k7),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: h.value.length > 0
    })), g = w9(() => [
      s9({
        mainAxis: t.sideOffset + u.value,
        alignmentAxis: t.alignOffset
      }),
      t.prioritizePosition && t.avoidCollisions && ig({
        ...m.value
      }),
      t.avoidCollisions && l9({
        mainAxis: !0,
        crossAxis: !!t.prioritizePosition,
        limiter: t.sticky === "partial" ? f9() : void 0,
        ...m.value
      }),
      !t.prioritizePosition && t.avoidCollisions && ig({
        ...m.value
      }),
      d9({
        ...m.value,
        apply: ({ elements: P, rects: L, availableWidth: H, availableHeight: q }) => {
          const { width: Q, height: ae } = L.reference, de = P.floating.style;
          de.setProperty(
            "--radix-popper-available-width",
            `${H}px`
          ), de.setProperty(
            "--radix-popper-available-height",
            `${q}px`
          ), de.setProperty(
            "--radix-popper-anchor-width",
            `${Q}px`
          ), de.setProperty(
            "--radix-popper-anchor-height",
            `${ae}px`
          );
        }
      }),
      l.value && m9({ element: l.value, padding: t.arrowPadding }),
      _7({
        arrowWidth: d.value,
        arrowHeight: u.value
      }),
      t.hideWhenDetached && u9({ strategy: "referenceHidden", ...m.value })
    ]), { floatingStyles: v, placement: $, isPositioned: C, middlewareData: S } = g9(
      o.anchor,
      s,
      {
        strategy: "fixed",
        placement: f,
        whileElementsMounted: (...P) => a9(...P, {
          animationFrame: t.updatePositionStrategy === "always"
        }),
        middleware: g
      }
    ), w = M(
      () => lh($.value)[0]
    ), T = M(
      () => lh($.value)[1]
    );
    I5(() => {
      C.value && r("placed");
    });
    const A = M(
      () => {
        var P;
        return ((P = S.value.arrow) == null ? void 0 : P.centerOffset) !== 0;
      }
    ), N = B("");
    vt(() => {
      a.value && (N.value = window.getComputedStyle(a.value).zIndex);
    });
    const z = M(() => {
      var P;
      return ((P = S.value.arrow) == null ? void 0 : P.x) ?? 0;
    }), I = M(() => {
      var P;
      return ((P = S.value.arrow) == null ? void 0 : P.y) ?? 0;
    });
    return S7({
      placedSide: w,
      onArrowChange: (P) => l.value = P,
      arrowX: z,
      arrowY: I,
      shouldHideArrow: A
    }), (P, L) => {
      var H, q, Q;
      return b(), D("div", {
        ref_key: "floatingRef",
        ref: s,
        "data-radix-popper-content-wrapper": "",
        style: Zi({
          ...c(v),
          transform: c(C) ? c(v).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: N.value,
          "--radix-popper-transform-origin": [
            (H = c(S).transformOrigin) == null ? void 0 : H.x,
            (q = c(S).transformOrigin) == null ? void 0 : q.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = c(S).hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        x(c(le), j({ ref: c(i) }, P.$attrs, {
          "as-child": t.asChild,
          as: P.as,
          "data-side": w.value,
          "data-align": T.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: c(C) ? void 0 : "none"
          }
        }), {
          default: y(() => [
            E(P.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), Jc = /* @__PURE__ */ _({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    return ie(), (e, t) => (b(), k(c(le), {
      as: e.as,
      "as-child": e.asChild,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: y(() => [
        E(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), E7 = /* @__PURE__ */ _({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(n) {
    const e = n, t = M(() => typeof e.value == "string" || typeof e.value == "number" || typeof e.value == "boolean" ? [{ name: e.name, value: e.value }] : typeof e.value == "object" && Array.isArray(e.value) ? e.value.flatMap((r, o) => typeof r == "object" ? Object.entries(r).map(([i, a]) => ({ name: `[${o}][${e.name}][${i}]`, value: a })) : { name: `[${e.name}][${o}]`, value: r }) : e.value !== null && typeof e.value == "object" && !Array.isArray(e.value) ? Object.entries(e.value).map(([r, o]) => ({ name: `[${e.name}][${r}]`, value: o })) : []);
    return (r, o) => (b(!0), D(Me, null, it(t.value, (i) => (b(), k(Jc, {
      key: i.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: i.name,
      value: i.value,
      required: r.required,
      disabled: r.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
}), O7 = "data-radix-vue-collection-item", [Zm, T7] = Xe("CollectionProvider");
function Ym(n = O7) {
  const e = B(/* @__PURE__ */ new Map()), t = B(), r = T7({
    collectionRef: t,
    itemMap: e,
    attrName: n
  }), { getItems: o } = Qm(r), i = M(() => Array.from(r.itemMap.value.values())), a = M(() => r.itemMap.value.size);
  return { getItems: o, reactiveItems: i, itemMapSize: a };
}
const Xm = _({
  name: "CollectionSlot",
  setup(n, { slots: e }) {
    const t = Zm(), { primitiveElement: r, currentElement: o } = Uc();
    return De(o, () => {
      t.collectionRef.value = o.value;
    }), () => Yt(Hc, { ref: r }, e);
  }
}), Zc = _({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(n, { slots: e, attrs: t }) {
    const r = Zm(), { primitiveElement: o, currentElement: i } = Uc();
    return vt((a) => {
      if (i.value) {
        const s = wm(i.value);
        r.itemMap.value.set(s, { ref: i.value, value: n.value }), a(() => r.itemMap.value.delete(s));
      }
    }), () => Yt(Hc, { ...t, [r.attrName]: "", ref: o }, e);
  }
});
function Qm(n) {
  const e = n ?? Zm();
  return { getItems: () => {
    const t = e.collectionRef.value;
    if (!t)
      return [];
    const r = Array.from(t.querySelectorAll(`[${e.attrName}]`));
    return Array.from(e.itemMap.value.values()).sort(
      (o, i) => r.indexOf(o.ref) - r.indexOf(i.ref)
    );
  } };
}
const [vs, A7] = Xe("ComboboxRoot"), M7 = /* @__PURE__ */ _({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    resetSearchTermOnSelect: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, { multiple: o, disabled: i, dir: a } = at(t), s = Cr(a), l = gt(t, "searchTerm", r, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: t.searchTerm === void 0
    }), d = gt(t, "modelValue", r, {
      // @ts-expect-error ignore the type error here
      defaultValue: t.defaultValue ?? o.value ? [] : void 0,
      passive: t.modelValue === void 0,
      deep: !0
    }), u = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), f = gt(t, "selectedValue", r, {
      defaultValue: void 0,
      passive: t.selectedValue === void 0
    });
    async function p(ee) {
      var be, Ee;
      u.value = ee, await Be(), ee ? (d.value && (Array.isArray(d.value) && o.value ? f.value = (be = S().find((nt) => {
        var ct, Ne;
        return ((Ne = (ct = nt.ref) == null ? void 0 : ct.dataset) == null ? void 0 : Ne.state) === "checked";
      })) == null ? void 0 : be.value : f.value = d.value), await Be(), (Ee = g.value) == null || Ee.focus(), q()) : (m.value = !1, t.resetSearchTermOnBlur && z("blur"));
    }
    function h(ee) {
      if (Array.isArray(d.value) && o.value) {
        const be = d.value.findIndex((nt) => ki(nt, ee)), Ee = [...d.value];
        be === -1 ? Ee.push(ee) : Ee.splice(be, 1), d.value = Ee;
      } else
        d.value = ee, p(!1);
    }
    const m = B(!1), g = B(), v = B(), { forwardRef: $, currentElement: C } = ie(), { getItems: S, reactiveItems: w, itemMapSize: T } = Ym("data-radix-vue-combobox-item"), A = B([]);
    De(() => T.value, () => {
      A.value = S().map((ee) => ee.value);
    }, {
      immediate: !0,
      flush: "post"
    });
    const N = M(() => {
      if (m.value) {
        if (t.filterFunction)
          return t.filterFunction(A.value, l.value);
        const ee = A.value.filter((be) => typeof be == "string");
        if (ee.length)
          return ee.filter((be) => {
            var Ee;
            return be.toLowerCase().includes((Ee = l.value) == null ? void 0 : Ee.toLowerCase());
          });
      }
      return A.value;
    });
    function z(ee) {
      const be = ee === "blur" || ee === "select" && t.resetSearchTermOnSelect;
      !o.value && d.value && !Array.isArray(d.value) ? t.displayValue ? l.value = t.displayValue(d.value) : typeof d.value != "object" ? l.value = d.value.toString() : be && (l.value = "") : be && (l.value = "");
    }
    const I = M(() => N.value.findIndex((ee) => ki(ee, f.value))), P = M(() => {
      var ee;
      return (ee = w.value.find((be) => ki(be.value, f.value))) == null ? void 0 : ee.ref;
    }), L = M(() => JSON.stringify(d.value));
    De(L, async () => {
      await Be(), await Be(), z("select");
    }, {
      // If searchTerm is provided with value during initialization, we don't reset it immediately
      immediate: !t.searchTerm
    }), De(() => [N.value.length, l.value.length], async ([ee, be], [Ee, nt]) => {
      await Be(), await Be(), ee && (nt > be || I.value === -1) && (f.value = N.value[0]);
    });
    const H = hs(C);
    function q() {
      var ee;
      P.value instanceof Element && ((ee = P.value) == null || ee.scrollIntoView({ block: "nearest" }));
    }
    function Q() {
      P.value instanceof Element && P.value.focus && P.value.focus();
    }
    const ae = B(!1);
    function de() {
      ae.value = !0;
    }
    function ne() {
      requestAnimationFrame(() => {
        ae.value = !1;
      });
    }
    async function ke(ee) {
      var be;
      N.value.length && f.value && P.value instanceof Element && (ee.preventDefault(), ee.stopPropagation(), ae.value || (be = P.value) == null || be.click());
    }
    return A7({
      searchTerm: l,
      modelValue: d,
      // @ts-expect-error ignoring
      onValueChange: h,
      isUserInputted: m,
      multiple: o,
      disabled: i,
      open: u,
      onOpenChange: p,
      filteredOptions: N,
      contentId: "",
      inputElement: g,
      selectedElement: P,
      onInputElementChange: (ee) => g.value = ee,
      onInputNavigation: async (ee) => {
        const be = I.value;
        be === 0 && ee === "up" || be === N.value.length - 1 && ee === "down" || (be === -1 && N.value.length || ee === "home" ? f.value = N.value[0] : ee === "end" ? f.value = N.value[N.value.length - 1] : f.value = N.value[ee === "up" ? be - 1 : be + 1], await Be(), q(), Q(), Be(() => {
          var Ee;
          return (Ee = g.value) == null ? void 0 : Ee.focus({ preventScroll: !0 });
        }));
      },
      onInputEnter: ke,
      onCompositionEnd: ne,
      onCompositionStart: de,
      selectedValue: f,
      onSelectedValueChange: (ee) => f.value = ee,
      parentElement: C,
      contentElement: v,
      onContentElementChange: (ee) => v.value = ee
    }), (ee, be) => (b(), k(c(fd), null, {
      default: y(() => [
        x(c(le), j({
          ref: c($),
          style: {
            pointerEvents: c(u) ? "auto" : void 0
          },
          as: ee.as,
          "as-child": ee.asChild,
          dir: c(s)
        }, ee.$attrs), {
          default: y(() => [
            E(ee.$slots, "default", {
              open: c(u),
              modelValue: c(d)
            }),
            c(H) && t.name ? (b(), k(c(E7), {
              key: 0,
              name: t.name,
              value: c(d)
            }, null, 8, ["name", "value"])) : X("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), N7 = /* @__PURE__ */ _({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(n) {
    const e = n, t = vs(), { forwardRef: r, currentElement: o } = ie();
    Ge(() => {
      const u = o.value.nodeName === "INPUT" ? o.value : o.value.querySelector("input");
      u && (t.onInputElementChange(u), setTimeout(() => {
        e.autoFocus && u?.focus();
      }, 1));
    });
    const i = M(() => e.disabled || t.disabled.value || !1), a = B();
    A5(() => {
      var u;
      return a.value = (u = t.selectedElement.value) == null ? void 0 : u.id;
    });
    function s(u) {
      t.open.value ? t.onInputNavigation(u.key === "ArrowUp" ? "up" : "down") : t.onOpenChange(!0);
    }
    function l(u) {
      t.open.value && t.onInputNavigation(u.key === "Home" ? "home" : "end");
    }
    function d(u) {
      var f;
      t.searchTerm.value = (f = u.target) == null ? void 0 : f.value, t.open.value || t.onOpenChange(!0), t.isUserInputted.value = !0;
    }
    return (u, f) => (b(), k(c(le), {
      ref: c(r),
      as: u.as,
      "as-child": u.asChild,
      type: u.type,
      disabled: i.value,
      value: c(t).searchTerm.value,
      "aria-expanded": c(t).open.value,
      "aria-controls": c(t).contentId,
      "aria-disabled": i.value ?? void 0,
      "aria-activedescendant": a.value,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: d,
      onKeydown: [
        ur(At(s, ["prevent"]), ["down", "up"]),
        ur(c(t).onInputEnter, ["enter"]),
        ur(At(l, ["prevent"]), ["home", "end"])
      ],
      onCompositionstart: c(t).onCompositionStart,
      onCompositionend: c(t).onCompositionEnd
    }, {
      default: y(() => [
        E(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "disabled", "value", "aria-expanded", "aria-controls", "aria-disabled", "aria-activedescendant", "onKeydown", "onCompositionstart", "onCompositionend"]));
  }
}), [Kb, P7] = Xe("ComboboxGroup"), D7 = /* @__PURE__ */ _({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { currentRef: t, currentElement: r } = ie(), o = zt(void 0, "radix-vue-combobox-group"), i = vs(), a = B(!1);
    function s() {
      if (!r.value)
        return;
      const l = r.value.querySelectorAll("[data-radix-vue-combobox-item]:not([data-hidden])");
      a.value = !!l.length;
    }
    return F9(r, () => {
      Be(() => {
        s();
      });
    }, { childList: !0 }), De(() => i.searchTerm.value, () => {
      Be(() => {
        s();
      });
    }, { immediate: !0 }), P7({
      id: o
    }), (l, d) => hr((b(), k(c(le), j(e, {
      ref_key: "currentRef",
      ref: t,
      role: "group",
      "aria-labelledby": c(o)
    }), {
      default: y(() => [
        E(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [xm, a.value]
    ]);
  }
}), I7 = /* @__PURE__ */ _({
  __name: "ComboboxLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(n) {
    const e = n;
    ie();
    const t = Kb({ id: "" });
    return (r, o) => (b(), k(c(le), j(e, {
      id: c(t).id
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [lJ, R7] = Xe("ComboboxContent"), B7 = /* @__PURE__ */ _({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = n, r = e, { position: o } = at(t), i = vs();
    dd(t.bodyLock);
    const { forwardRef: a, currentElement: s } = ie();
    ud(i.parentElement);
    const l = M(() => t.position === "popper" ? t : {}), d = pt(l.value);
    function u(p) {
      i.onSelectedValueChange("");
    }
    Ge(() => {
      i.onContentElementChange(s.value);
    });
    const f = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return R7({ position: o }), (p, h) => (b(), k(c(Xm), null, {
      default: y(() => [
        p.dismissable ? (b(), k(c(ms), {
          key: 0,
          "as-child": "",
          "disable-outside-pointer-events": p.disableOutsidePointerEvents,
          onDismiss: h[0] || (h[0] = (m) => c(i).onOpenChange(!1)),
          onFocusOutside: h[1] || (h[1] = (m) => {
            var g;
            (g = c(i).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), r("focusOutside", m);
          }),
          onInteractOutside: h[2] || (h[2] = (m) => r("interactOutside", m)),
          onEscapeKeyDown: h[3] || (h[3] = (m) => r("escapeKeyDown", m)),
          onPointerDownOutside: h[4] || (h[4] = (m) => {
            var g;
            (g = c(i).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), r("pointerDownOutside", m);
          })
        }, {
          default: y(() => [
            (b(), k(Qt(c(o) === "popper" ? c(Ha) : c(le)), j({ ...p.$attrs, ...c(d) }, {
              id: c(i).contentId,
              ref: c(a),
              role: "listbox",
              "data-state": c(i).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...c(o) === "popper" ? f : {}
              },
              onPointerleave: u
            }), {
              default: y(() => [
                E(p.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])) : (b(), k(Qt(c(o) === "popper" ? c(Ha) : c(le)), j({ key: 1 }, { ...p.$attrs, ...l.value }, {
          id: c(i).contentId,
          ref: c(a),
          role: "listbox",
          "data-state": c(i).open.value ? "open" : "closed",
          style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...c(o) === "popper" ? f : {}
          },
          onPointerleave: u
        }), {
          default: y(() => [
            E(p.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "data-state", "style"]))
      ]),
      _: 3
    }));
  }
}), L7 = /* @__PURE__ */ _({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = je(n, e), { forwardRef: r } = ie(), o = vs();
    return o.contentId || (o.contentId = zt(void 0, "radix-vue-combobox-content")), (i, a) => (b(), k(c(Bn), {
      present: i.forceMount || c(o).open.value
    }, {
      default: y(() => [
        x(B7, j({ ...c(t), ...i.$attrs }, { ref: c(r) }), {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), F7 = /* @__PURE__ */ _({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    ie();
    const t = vs(), r = M(() => t.filteredOptions.value.length === 0);
    return (o, i) => r.value ? (b(), k(c(le), Le(j({ key: 0 }, e)), {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          K("No options")
        ])
      ]),
      _: 3
    }, 16)) : X("", !0);
  }
});
function V7(n) {
  const e = jc({
    nonce: B()
  });
  return M(() => {
    var t;
    return n?.value || ((t = e.nonce) == null ? void 0 : t.value);
  });
}
const [dJ, z7] = Xe("ComboboxItem"), j7 = "combobox.select", H7 = /* @__PURE__ */ _({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = e, { disabled: o } = at(t), i = vs();
    Kb({ id: "", options: B([]) });
    const { forwardRef: a } = ie(), s = M(
      () => {
        var g, v;
        return i.multiple.value && Array.isArray(i.modelValue.value) ? (g = i.modelValue.value) == null ? void 0 : g.some(($) => ki($, t.value)) : ki((v = i.modelValue) == null ? void 0 : v.value, t.value);
      }
    ), l = M(() => ki(i.selectedValue.value, t.value)), d = zt(void 0, "radix-vue-combobox-item"), u = zt(void 0, "radix-vue-combobox-option"), f = M(() => i.isUserInputted.value ? i.searchTerm.value === "" || !!i.filteredOptions.value.find((g) => ki(g, t.value)) : !0);
    async function p(g) {
      r("select", g), !(g != null && g.defaultPrevented) && !o.value && g && i.onValueChange(t.value);
    }
    function h(g) {
      if (!g)
        return;
      const v = { originalEvent: g, value: t.value };
      Vm(j7, p, v);
    }
    async function m(g) {
      await Be(), !g.defaultPrevented && i.onSelectedValueChange(t.value);
    }
    if (t.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    return z7({
      isSelected: s
    }), (g, v) => (b(), k(c(Zc), { value: g.value }, {
      default: y(() => [
        hr(x(c(le), {
          id: c(u),
          ref: c(a),
          role: "option",
          tabindex: "-1",
          "aria-labelledby": c(d),
          "data-highlighted": l.value ? "" : void 0,
          "aria-selected": s.value,
          "data-state": s.value ? "checked" : "unchecked",
          "aria-disabled": c(o) || void 0,
          "data-disabled": c(o) ? "" : void 0,
          as: g.as,
          "as-child": g.asChild,
          "data-hidden": f.value ? void 0 : !0,
          onClick: h,
          onPointermove: m
        }, {
          default: y(() => [
            E(g.$slots, "default", {}, () => [
              K(U(g.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child", "data-hidden"]), [
          [xm, f.value]
        ])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), U7 = /* @__PURE__ */ _({
  __name: "ComboboxSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(le), j(e, { "aria-hidden": "true" }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), K7 = /* @__PURE__ */ _({
  __name: "MenuAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(Gc), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function W7() {
  const n = B(!1);
  return Ge(() => {
    ja("keydown", () => {
      n.value = !0;
    }, { capture: !0, passive: !0 }), ja(["pointerdown", "pointermove"], () => {
      n.value = !1;
    }, { capture: !0, passive: !0 });
  }), n;
}
const q7 = $b(W7), [Yc, G7] = Xe(["MenuRoot", "MenuSub"], "MenuContext"), [e0, J7] = Xe("MenuRoot"), Z7 = /* @__PURE__ */ _({
  __name: "MenuRoot",
  props: {
    open: { type: Boolean, default: !1 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, { modal: o, dir: i } = at(t), a = Cr(i), s = gt(t, "open", r), l = B(), d = q7();
    return G7({
      open: s,
      onOpenChange: (u) => {
        s.value = u;
      },
      content: l,
      onContentChange: (u) => {
        l.value = u;
      }
    }), J7({
      onClose: () => {
        s.value = !1;
      },
      isUsingKeyboardRef: d,
      dir: a,
      modal: o
    }), (u, f) => (b(), k(c(fd), null, {
      default: y(() => [
        E(u.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Y7 = "rovingFocusGroup.onEntryFocus", X7 = { bubbles: !1, cancelable: !0 }, Q7 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ek(n, e) {
  return e !== "rtl" ? n : n === "ArrowLeft" ? "ArrowRight" : n === "ArrowRight" ? "ArrowLeft" : n;
}
function tk(n, e, t) {
  const r = ek(n.key, t);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return Q7[r];
}
function Wb(n, e = !1) {
  const t = Bt();
  for (const r of n)
    if (r === t || (r.focus({ preventScroll: e }), Bt() !== t))
      return;
}
function nk(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
const [rk, ok] = Xe("RovingFocusGroup"), Xc = /* @__PURE__ */ _({
  __name: "RovingFocusGroup",
  props: {
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !1 },
    currentTabStopId: {},
    defaultCurrentTabStopId: {},
    preventScrollOnEntryFocus: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["entryFocus", "update:currentTabStopId"],
  setup(n, { expose: e, emit: t }) {
    const r = n, o = t, { loop: i, orientation: a, dir: s } = at(r), l = Cr(s), d = gt(r, "currentTabStopId", o, {
      defaultValue: r.defaultCurrentTabStopId,
      passive: r.currentTabStopId === void 0
    }), u = B(!1), f = B(!1), p = B(0), { getItems: h } = Ym();
    function m(v) {
      const $ = !f.value;
      if (v.currentTarget && v.target === v.currentTarget && $ && !u.value) {
        const C = new CustomEvent(Y7, X7);
        if (v.currentTarget.dispatchEvent(C), o("entryFocus", C), !C.defaultPrevented) {
          const S = h().map((N) => N.ref).filter((N) => N.dataset.disabled !== ""), w = S.find((N) => N.getAttribute("data-active") === "true"), T = S.find(
            (N) => N.id === d.value
          ), A = [w, T, ...S].filter(
            Boolean
          );
          Wb(A, r.preventScrollOnEntryFocus);
        }
      }
      f.value = !1;
    }
    function g() {
      setTimeout(() => {
        f.value = !1;
      }, 1);
    }
    return e({
      getItems: h
    }), ok({
      loop: i,
      dir: l,
      orientation: a,
      currentTabStopId: d,
      onItemFocus: (v) => {
        d.value = v;
      },
      onItemShiftTab: () => {
        u.value = !0;
      },
      onFocusableItemAdd: () => {
        p.value++;
      },
      onFocusableItemRemove: () => {
        p.value--;
      }
    }), (v, $) => (b(), k(c(Xm), null, {
      default: y(() => [
        x(c(le), {
          tabindex: u.value || p.value === 0 ? -1 : 0,
          "data-orientation": c(a),
          as: v.as,
          "as-child": v.asChild,
          dir: c(l),
          style: { outline: "none" },
          onMousedown: $[0] || ($[0] = (C) => f.value = !0),
          onMouseup: g,
          onFocus: m,
          onBlur: $[1] || ($[1] = (C) => u.value = !1)
        }, {
          default: y(() => [
            E(v.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), t0 = /* @__PURE__ */ _({
  __name: "RovingFocusItem",
  props: {
    tabStopId: {},
    focusable: { type: Boolean, default: !0 },
    active: { type: Boolean, default: !0 },
    allowShiftKey: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = n, t = rk(), r = M(() => e.tabStopId || zt()), o = M(
      () => t.currentTabStopId.value === r.value
    ), { getItems: i } = Qm();
    Ge(() => {
      e.focusable && t.onFocusableItemAdd();
    }), Qn(() => {
      e.focusable && t.onFocusableItemRemove();
    });
    function a(s) {
      if (s.key === "Tab" && s.shiftKey) {
        t.onItemShiftTab();
        return;
      }
      if (s.target !== s.currentTarget)
        return;
      const l = tk(
        s,
        t.orientation.value,
        t.dir.value
      );
      if (l !== void 0) {
        if (s.metaKey || s.ctrlKey || s.altKey || !e.allowShiftKey && s.shiftKey)
          return;
        s.preventDefault();
        let d = [...i().map((u) => u.ref).filter((u) => u.dataset.disabled !== "")];
        if (l === "last")
          d.reverse();
        else if (l === "prev" || l === "next") {
          l === "prev" && d.reverse();
          const u = d.indexOf(
            s.currentTarget
          );
          d = t.loop.value ? nk(d, u + 1) : d.slice(u + 1);
        }
        Be(() => Wb(d));
      }
    }
    return (s, l) => (b(), k(c(Zc), null, {
      default: y(() => [
        x(c(le), {
          tabindex: o.value ? 0 : -1,
          "data-orientation": c(t).orientation.value,
          "data-active": s.active,
          "data-disabled": s.focusable ? void 0 : "",
          as: s.as,
          "as-child": s.asChild,
          onMousedown: l[0] || (l[0] = (d) => {
            s.focusable ? c(t).onItemFocus(r.value) : d.preventDefault();
          }),
          onFocus: l[1] || (l[1] = (d) => c(t).onItemFocus(r.value)),
          onKeydown: a
        }, {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "data-active", "data-disabled", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), [qb, ik] = Xe("MenuContent"), Gb = /* @__PURE__ */ _({
  __name: "MenuContentImpl",
  props: /* @__PURE__ */ M2({
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...Ub
  }),
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus", "dismiss"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Yc(), i = e0(), { trapFocus: a, disableOutsidePointerEvents: s, loop: l } = at(t);
    Hm(), dd(s.value);
    const d = B(""), u = B(0), f = B(0), p = B(null), h = B("right"), m = B(0), g = B(null), { createCollection: v } = ps(), { forwardRef: $, currentElement: C } = ie(), S = v(C);
    De(C, (P) => {
      o.onContentChange(P);
    });
    const { handleTypeaheadSearch: w } = Um(S);
    Qn(() => {
      window.clearTimeout(u.value);
    });
    function T(P) {
      var L, H;
      return h.value === ((L = p.value) == null ? void 0 : L.side) && zC(P, (H = p.value) == null ? void 0 : H.area);
    }
    async function A(P) {
      var L;
      r("openAutoFocus", P), !P.defaultPrevented && (P.preventDefault(), (L = C.value) == null || L.focus({
        preventScroll: !0
      }));
    }
    function N(P) {
      if (P.defaultPrevented)
        return;
      const L = P.target.closest("[data-radix-menu-content]") === P.currentTarget, H = P.ctrlKey || P.altKey || P.metaKey, q = P.key.length === 1, Q = _b(
        P,
        Bt(),
        C.value,
        {
          loop: l.value,
          arrowKeyOptions: "vertical",
          dir: i?.dir.value,
          focus: !0,
          attributeName: "[data-radix-vue-collection-item]:not([data-disabled])"
        }
      );
      if (Q)
        return Q?.focus();
      if (P.code === "Space" || (L && (P.key === "Tab" && P.preventDefault(), !H && q && w(P.key)), P.target !== C.value) || !FC.includes(P.key))
        return;
      P.preventDefault();
      const ae = S.value;
      Bb.includes(P.key) && ae.reverse(), ah(ae);
    }
    function z(P) {
      var L, H;
      (H = (L = P?.currentTarget) == null ? void 0 : L.contains) != null && H.call(L, P.target) || (window.clearTimeout(u.value), d.value = "");
    }
    function I(P) {
      var L;
      if (!sh(P))
        return;
      const H = P.target, q = m.value !== P.clientX;
      if ((L = P?.currentTarget) != null && L.contains(H) && q) {
        const Q = P.clientX > m.value ? "right" : "left";
        h.value = Q, m.value = P.clientX;
      }
    }
    return ik({
      onItemEnter: (P) => !!T(P),
      onItemLeave: (P) => {
        var L;
        T(P) || ((L = C.value) == null || L.focus(), g.value = null);
      },
      onTriggerLeave: (P) => !!T(P),
      searchRef: d,
      pointerGraceTimerRef: f,
      onPointerGraceIntentChange: (P) => {
        p.value = P;
      }
    }), (P, L) => (b(), k(c(qc), {
      "as-child": "",
      trapped: c(a),
      onMountAutoFocus: A,
      onUnmountAutoFocus: L[7] || (L[7] = (H) => r("closeAutoFocus", H))
    }, {
      default: y(() => [
        x(c(ms), {
          "as-child": "",
          "disable-outside-pointer-events": c(s),
          onEscapeKeyDown: L[2] || (L[2] = (H) => r("escapeKeyDown", H)),
          onPointerDownOutside: L[3] || (L[3] = (H) => r("pointerDownOutside", H)),
          onFocusOutside: L[4] || (L[4] = (H) => r("focusOutside", H)),
          onInteractOutside: L[5] || (L[5] = (H) => r("interactOutside", H)),
          onDismiss: L[6] || (L[6] = (H) => r("dismiss"))
        }, {
          default: y(() => [
            x(c(Xc), {
              "current-tab-stop-id": g.value,
              "onUpdate:currentTabStopId": L[0] || (L[0] = (H) => g.value = H),
              "as-child": "",
              orientation: "vertical",
              dir: c(i).dir.value,
              loop: c(l),
              onEntryFocus: L[1] || (L[1] = (H) => {
                r("entryFocus", H), c(i).isUsingKeyboardRef.value || H.preventDefault();
              })
            }, {
              default: y(() => [
                x(c(Ha), {
                  ref: c($),
                  role: "menu",
                  as: P.as,
                  "as-child": P.asChild,
                  "aria-orientation": "vertical",
                  "data-radix-menu-content": "",
                  "data-state": c(Lb)(c(o).open.value),
                  dir: c(i).dir.value,
                  side: P.side,
                  "side-offset": P.sideOffset,
                  align: P.align,
                  "align-offset": P.alignOffset,
                  "avoid-collisions": P.avoidCollisions,
                  "collision-boundary": P.collisionBoundary,
                  "collision-padding": P.collisionPadding,
                  "arrow-padding": P.arrowPadding,
                  "prioritize-position": P.prioritizePosition,
                  sticky: P.sticky,
                  "hide-when-detached": P.hideWhenDetached,
                  onKeydown: N,
                  onBlur: z,
                  onPointermove: I
                }, {
                  default: y(() => [
                    E(P.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["as", "as-child", "data-state", "dir", "side", "side-offset", "align", "align-offset", "avoid-collisions", "collision-boundary", "collision-padding", "arrow-padding", "prioritize-position", "sticky", "hide-when-detached"])
              ]),
              _: 3
            }, 8, ["current-tab-stop-id", "dir", "loop"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), ak = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "MenuItemImpl",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = qb(), { forwardRef: r } = ie(), o = B(!1);
    async function i(s) {
      if (!s.defaultPrevented && sh(s)) {
        if (e.disabled)
          t.onItemLeave(s);
        else if (!t.onItemEnter(s)) {
          const l = s.currentTarget;
          l?.focus({ preventScroll: !0 });
        }
      }
    }
    async function a(s) {
      await Be(), !s.defaultPrevented && sh(s) && t.onItemLeave(s);
    }
    return (s, l) => (b(), k(c(Zc), {
      value: { textValue: s.textValue }
    }, {
      default: y(() => [
        x(c(le), j({
          ref: c(r),
          role: "menuitem",
          tabindex: "-1"
        }, s.$attrs, {
          as: s.as,
          "as-child": s.asChild,
          "data-radix-vue-collection-item": "",
          "aria-disabled": s.disabled || void 0,
          "data-disabled": s.disabled ? "" : void 0,
          "data-highlighted": o.value ? "" : void 0,
          onPointermove: i,
          onPointerleave: a,
          onFocus: l[0] || (l[0] = async (d) => {
            await Be(), !(d.defaultPrevented || s.disabled) && (o.value = !0);
          }),
          onBlur: l[1] || (l[1] = async (d) => {
            await Be(), !d.defaultPrevented && (o.value = !1);
          })
        }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "aria-disabled", "data-disabled", "data-highlighted"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), Jb = /* @__PURE__ */ _({
  __name: "MenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = e, { forwardRef: o, currentElement: i } = ie(), a = e0(), s = qb(), l = B(!1);
    async function d() {
      const u = i.value;
      if (!t.disabled && u) {
        const f = new CustomEvent(BC, {
          bubbles: !0,
          cancelable: !0
        });
        r("select", f), await Be(), f.defaultPrevented ? l.value = !1 : a.onClose();
      }
    }
    return (u, f) => (b(), k(ak, j(t, {
      ref: c(o),
      onClick: d,
      onPointerdown: f[0] || (f[0] = () => {
        l.value = !0;
      }),
      onPointerup: f[1] || (f[1] = async (p) => {
        var h;
        await Be(), !p.defaultPrevented && (l.value || (h = p.currentTarget) == null || h.click());
      }),
      onKeydown: f[2] || (f[2] = async (p) => {
        const h = c(s).searchRef.value !== "";
        u.disabled || h && p.key === " " || c(ih).includes(p.key) && (p.currentTarget.click(), p.preventDefault());
      })
    }), {
      default: y(() => [
        E(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [sk, lk] = Xe(
  ["MenuCheckboxItem", "MenuRadioItem"],
  "MenuItemIndicatorContext"
), dk = /* @__PURE__ */ _({
  __name: "MenuItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = sk({
      checked: B(!1)
    });
    return (t, r) => (b(), k(c(Bn), {
      present: t.forceMount || c(Fb)(c(e).checked.value) || c(e).checked.value === !0
    }, {
      default: y(() => [
        x(c(le), {
          as: t.as,
          "as-child": t.asChild,
          "data-state": c(Vb)(c(e).checked.value)
        }, {
          default: y(() => [
            E(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "data-state"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), uk = /* @__PURE__ */ _({
  __name: "MenuRootContentModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = je(t, r), i = Yc(), { forwardRef: a, currentElement: s } = ie();
    return ud(s), (l, d) => (b(), k(Gb, j(c(o), {
      ref: c(a),
      "trap-focus": c(i).open.value,
      "disable-outside-pointer-events": c(i).open.value,
      "disable-outside-scroll": !0,
      onDismiss: d[0] || (d[0] = (u) => c(i).onOpenChange(!1)),
      onFocusOutside: d[1] || (d[1] = At((u) => r("focusOutside", u), ["prevent"]))
    }), {
      default: y(() => [
        E(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus", "disable-outside-pointer-events"]));
  }
}), ck = /* @__PURE__ */ _({
  __name: "MenuRootContentNonModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = je(n, e), r = Yc();
    return (o, i) => (b(), k(Gb, j(c(t), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      "disable-outside-scroll": !1,
      onDismiss: i[0] || (i[0] = (a) => c(r).onOpenChange(!1))
    }), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), fk = /* @__PURE__ */ _({
  __name: "MenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = je(n, e), r = Yc(), o = e0();
    return (i, a) => (b(), k(c(Bn), {
      present: i.forceMount || c(r).open.value
    }, {
      default: y(() => [
        c(o).modal.value ? (b(), k(uk, Le(j({ key: 0 }, { ...i.$attrs, ...c(t) })), {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 16)) : (b(), k(ck, Le(j({ key: 1 }, { ...i.$attrs, ...c(t) })), {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), pk = /* @__PURE__ */ _({
  __name: "MenuGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), j({ role: "group" }, e), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), hk = /* @__PURE__ */ _({
  __name: "MenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(cd), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [mk, gk] = Xe("MenuRadioGroup"), vk = /* @__PURE__ */ _({
  __name: "MenuRadioGroup",
  props: {
    modelValue: { default: "" },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = gt(t, "modelValue", e);
    return gk({
      modelValue: r,
      onValueChange: (o) => {
        r.value = o;
      }
    }), (o, i) => (b(), k(pk, Le(Ve(t)), {
      default: y(() => [
        E(o.$slots, "default", { modelValue: c(r) })
      ]),
      _: 3
    }, 16));
  }
}), yk = /* @__PURE__ */ _({
  __name: "MenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = e, { value: o } = at(t), i = mk(), a = M(
      () => i.modelValue.value === o?.value
    );
    return lk({ checked: a }), (s, l) => (b(), k(Jb, j({ role: "menuitemradio" }, t, {
      "aria-checked": a.value,
      "data-state": c(Vb)(a.value),
      onSelect: l[0] || (l[0] = async (d) => {
        r("select", d), c(i).onValueChange(c(o));
      })
    }), {
      default: y(() => [
        E(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-checked", "data-state"]));
  }
}), bk = /* @__PURE__ */ _({
  __name: "MenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(le), j(e, {
      role: "separator",
      "aria-orientation": "horizontal"
    }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [Zb, $k] = Xe("DropdownMenuRoot"), wk = /* @__PURE__ */ _({
  __name: "DropdownMenuRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean, default: void 0 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    ie();
    const o = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), i = B(), { modal: a, dir: s } = at(t), l = Cr(s);
    return $k({
      open: o,
      onOpenChange: (d) => {
        o.value = d;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      triggerId: "",
      triggerElement: i,
      contentId: "",
      modal: a,
      dir: l
    }), (d, u) => (b(), k(c(Z7), {
      open: c(o),
      "onUpdate:open": u[0] || (u[0] = (f) => Br(o) ? o.value = f : null),
      dir: c(l),
      modal: c(a)
    }, {
      default: y(() => [
        E(d.$slots, "default", { open: c(o) })
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
}), xk = /* @__PURE__ */ _({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = Zb(), { forwardRef: r, currentElement: o } = ie();
    return Ge(() => {
      t.triggerElement = o;
    }), t.triggerId || (t.triggerId = zt(void 0, "radix-vue-dropdown-menu-trigger")), (i, a) => (b(), k(c(K7), { "as-child": "" }, {
      default: y(() => [
        x(c(le), {
          id: c(t).triggerId,
          ref: c(r),
          type: i.as === "button" ? "button" : void 0,
          "as-child": e.asChild,
          as: i.as,
          "aria-haspopup": "menu",
          "aria-expanded": c(t).open.value,
          "aria-controls": c(t).open.value ? c(t).contentId : void 0,
          "data-disabled": i.disabled ? "" : void 0,
          disabled: i.disabled,
          "data-state": c(t).open.value ? "open" : "closed",
          onClick: a[0] || (a[0] = async (s) => {
            var l;
            !i.disabled && s.button === 0 && s.ctrlKey === !1 && ((l = c(t)) == null || l.onOpenToggle(), await Be(), c(t).open.value && s.preventDefault());
          }),
          onKeydown: a[1] || (a[1] = ur(
            (s) => {
              i.disabled || (["Enter", " "].includes(s.key) && c(t).onOpenToggle(), s.key === "ArrowDown" && c(t).onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
            },
            ["enter", "space", "arrow-down"]
          ))
        }, {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as-child", "as", "aria-expanded", "aria-controls", "data-disabled", "disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), Ck = /* @__PURE__ */ _({
  __name: "DropdownMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(hk), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), kk = /* @__PURE__ */ _({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = je(n, e);
    ie();
    const r = Zb(), o = B(!1);
    function i(a) {
      a.defaultPrevented || (o.value || setTimeout(() => {
        var s;
        (s = r.triggerElement.value) == null || s.focus();
      }, 0), o.value = !1, a.preventDefault());
    }
    return r.contentId || (r.contentId = zt(void 0, "radix-vue-dropdown-menu-content")), (a, s) => {
      var l;
      return b(), k(c(fk), j(c(t), {
        id: c(r).contentId,
        "aria-labelledby": (l = c(r)) == null ? void 0 : l.triggerId,
        style: {
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        },
        onCloseAutoFocus: i,
        onInteractOutside: s[0] || (s[0] = (d) => {
          var u;
          if (d.defaultPrevented)
            return;
          const f = d.detail.originalEvent, p = f.button === 0 && f.ctrlKey === !0, h = f.button === 2 || p;
          (!c(r).modal.value || h) && (o.value = !0), (u = c(r).triggerElement.value) != null && u.contains(d.target) && d.preventDefault();
        })
      }), {
        default: y(() => [
          E(a.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "aria-labelledby"]);
    };
  }
}), _k = /* @__PURE__ */ _({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = ea(e);
    return ie(), (o, i) => (b(), k(c(Jb), Le(Ve({ ...t, ...c(r) })), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Sk = /* @__PURE__ */ _({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(bk), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ek = /* @__PURE__ */ _({
  __name: "DropdownMenuItemIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(dk), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ok = /* @__PURE__ */ _({
  __name: "DropdownMenuRadioGroup",
  props: {
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = ea(e);
    return ie(), (o, i) => (b(), k(c(vk), Le(Ve({ ...t, ...c(r) })), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Tk = /* @__PURE__ */ _({
  __name: "DropdownMenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = je(n, e);
    return ie(), (r, o) => (b(), k(c(yk), Le(Ve(c(t))), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [n0, Ak] = Xe("HoverCardRoot"), Mk = /* @__PURE__ */ _({
  __name: "HoverCardRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    openDelay: { default: 700 },
    closeDelay: { default: 300 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, { openDelay: o, closeDelay: i } = at(t);
    ie();
    const a = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), s = B(0), l = B(0), d = B(!1), u = B(!1), f = B(!1), p = B();
    function h() {
      clearTimeout(l.value), s.value = window.setTimeout(() => a.value = !0, o.value);
    }
    function m() {
      clearTimeout(s.value), !d.value && !u.value && (l.value = window.setTimeout(() => a.value = !1, i.value));
    }
    function g() {
      a.value = !1;
    }
    return Ak({
      open: a,
      onOpenChange(v) {
        a.value = v;
      },
      onOpen: h,
      onClose: m,
      onDismiss: g,
      hasSelectionRef: d,
      isPointerDownOnContentRef: u,
      isPointerInTransitRef: f,
      triggerElement: p
    }), (v, $) => (b(), k(c(fd), null, {
      default: y(() => [
        E(v.$slots, "default", { open: c(a) })
      ]),
      _: 3
    }));
  }
});
function dh(n) {
  return (e) => e.pointerType === "touch" ? void 0 : n();
}
function Nk(n) {
  const e = [], t = document.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; t.nextNode(); )
    e.push(t.currentNode);
  return e;
}
const Pk = /* @__PURE__ */ _({
  __name: "HoverCardTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "a" }
  },
  setup(n) {
    const { forwardRef: e, currentElement: t } = ie(), r = n0();
    r.triggerElement = t;
    function o() {
      setTimeout(() => {
        !r.isPointerInTransitRef.value && !r.open.value && r.onClose();
      }, 0);
    }
    return (i, a) => (b(), k(c(Gc), { "as-child": "" }, {
      default: y(() => [
        x(c(le), {
          ref: c(e),
          "as-child": i.asChild,
          as: i.as,
          "data-state": c(r).open.value ? "open" : "closed",
          "data-grace-area-trigger": "",
          onPointerenter: a[0] || (a[0] = (s) => c(dh)(c(r).onOpen)(s)),
          onPointerleave: a[1] || (a[1] = (s) => c(dh)(o)(s)),
          onFocus: a[2] || (a[2] = (s) => c(r).onOpen()),
          onBlur: a[3] || (a[3] = (s) => c(r).onClose())
        }, {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as", "data-state"])
      ]),
      _: 3
    }));
  }
}), Dk = /* @__PURE__ */ _({
  __name: "HoverCardPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(cd), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Ik = /* @__PURE__ */ _({
  __name: "HoverCardContentImpl",
  props: {
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = pt(t), { forwardRef: i, currentElement: a } = ie(), s = n0(), { isPointerInTransit: l, onPointerExit: d } = Z9(s.triggerElement, a);
    P9(s.isPointerInTransitRef, l, { direction: "rtl" }), d(() => {
      s.onClose();
    });
    const u = B(!1);
    let f;
    vt((h) => {
      if (u.value) {
        const m = document.body;
        f = m.style.userSelect || m.style.webkitUserSelect, m.style.userSelect = "none", m.style.webkitUserSelect = "none", h(() => {
          m.style.userSelect = f, m.style.webkitUserSelect = f;
        });
      }
    });
    function p() {
      u.value = !1, s.isPointerDownOnContentRef.value = !1, Be(() => {
        var h;
        ((h = document.getSelection()) == null ? void 0 : h.toString()) !== "" && (s.hasSelectionRef.value = !0);
      });
    }
    return Ge(() => {
      a.value && (document.addEventListener("pointerup", p), Nk(a.value).forEach((h) => h.setAttribute("tabindex", "-1")));
    }), Qn(() => {
      document.removeEventListener("pointerup", p), s.hasSelectionRef.value = !1, s.isPointerDownOnContentRef.value = !1;
    }), (h, m) => (b(), k(c(ms), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: m[1] || (m[1] = (g) => r("escapeKeyDown", g)),
      onPointerDownOutside: m[2] || (m[2] = (g) => r("pointerDownOutside", g)),
      onFocusOutside: m[3] || (m[3] = At((g) => r("focusOutside", g), ["prevent"])),
      onDismiss: c(s).onDismiss
    }, {
      default: y(() => [
        x(c(Ha), j({ ...c(o), ...h.$attrs }, {
          ref: c(i),
          "data-state": c(s).open.value ? "open" : "closed",
          style: {
            userSelect: u.value ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: u.value ? "text" : void 0,
            // re-namespace exposed content custom properties
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          },
          onPointerdown: m[0] || (m[0] = (g) => {
            g.currentTarget.contains(g.target) && (u.value = !0), c(s).hasSelectionRef.value = !1, c(s).isPointerDownOnContentRef.value = !0;
          })
        }), {
          default: y(() => [
            E(h.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "style"])
      ]),
      _: 3
    }, 8, ["onDismiss"]));
  }
}), Rk = /* @__PURE__ */ _({
  __name: "HoverCardContent",
  props: {
    forceMount: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = je(n, e), { forwardRef: r } = ie(), o = n0();
    return (i, a) => (b(), k(c(Bn), {
      present: i.forceMount || c(o).open.value
    }, {
      default: y(() => [
        x(Ik, j(c(t), {
          ref: c(r),
          onPointerenter: a[0] || (a[0] = (s) => c(dh)(c(o).onOpen)(s))
        }), {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Bk = /* @__PURE__ */ _({
  __name: "Label",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "label" }
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(le), j(e, {
      onMousedown: r[0] || (r[0] = (o) => {
        !o.defaultPrevented && o.detail > 1 && o.preventDefault();
      })
    }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [pd, Lk] = Xe("PopoverRoot"), Fk = /* @__PURE__ */ _({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, { modal: o } = at(t), i = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), a = B(), s = B(!1);
    return Lk({
      contentId: "",
      modal: o,
      open: i,
      onOpenChange: (l) => {
        i.value = l;
      },
      onOpenToggle: () => {
        i.value = !i.value;
      },
      triggerElement: a,
      hasCustomAnchor: s
    }), (l, d) => (b(), k(c(fd), null, {
      default: y(() => [
        E(l.$slots, "default", { open: c(i) })
      ]),
      _: 3
    }));
  }
}), Vk = /* @__PURE__ */ _({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = pd(), { forwardRef: r, currentElement: o } = ie();
    return Ge(() => {
      t.triggerElement.value = o.value;
    }), (i, a) => (b(), k(Qt(c(t).hasCustomAnchor.value ? c(le) : c(Gc)), { "as-child": "" }, {
      default: y(() => [
        x(c(le), {
          ref: c(r),
          type: i.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": c(t).open.value,
          "aria-controls": c(t).contentId,
          "data-state": c(t).open.value ? "open" : "closed",
          as: i.as,
          "as-child": e.asChild,
          onClick: c(t).onOpenToggle
        }, {
          default: y(() => [
            E(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), zk = /* @__PURE__ */ _({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(cd), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Yb = /* @__PURE__ */ _({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = pt(t), { forwardRef: i } = ie(), a = pd();
    return Hm(), (s, l) => (b(), k(c(qc), {
      "as-child": "",
      loop: "",
      trapped: s.trapFocus,
      onMountAutoFocus: l[5] || (l[5] = (d) => r("openAutoFocus", d)),
      onUnmountAutoFocus: l[6] || (l[6] = (d) => r("closeAutoFocus", d))
    }, {
      default: y(() => [
        x(c(ms), {
          "as-child": "",
          "disable-outside-pointer-events": s.disableOutsidePointerEvents,
          onPointerDownOutside: l[0] || (l[0] = (d) => r("pointerDownOutside", d)),
          onInteractOutside: l[1] || (l[1] = (d) => r("interactOutside", d)),
          onEscapeKeyDown: l[2] || (l[2] = (d) => r("escapeKeyDown", d)),
          onFocusOutside: l[3] || (l[3] = (d) => r("focusOutside", d)),
          onDismiss: l[4] || (l[4] = (d) => c(a).onOpenChange(!1))
        }, {
          default: y(() => [
            x(c(Ha), j(c(o), {
              id: c(a).contentId,
              ref: c(i),
              "data-state": c(a).open.value ? "open" : "closed",
              role: "dialog",
              style: {
                "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
              }
            }), {
              default: y(() => [
                E(s.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), jk = /* @__PURE__ */ _({
  __name: "PopoverContentModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = pd(), i = B(!1);
    dd(!0);
    const a = je(t, r), { forwardRef: s, currentElement: l } = ie();
    return ud(l), (d, u) => (b(), k(Yb, j(c(a), {
      ref: c(s),
      "trap-focus": c(o).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: u[0] || (u[0] = At(
        (f) => {
          var p;
          r("closeAutoFocus", f), i.value || (p = c(o).triggerElement.value) == null || p.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: u[1] || (u[1] = (f) => {
        r("pointerDownOutside", f);
        const p = f.detail.originalEvent, h = p.button === 0 && p.ctrlKey === !0, m = p.button === 2 || h;
        i.value = m;
      }),
      onFocusOutside: u[2] || (u[2] = At(() => {
      }, ["prevent"]))
    }), {
      default: y(() => [
        E(d.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), Hk = /* @__PURE__ */ _({
  __name: "PopoverContentNonModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = pd(), i = B(!1), a = B(!1), s = je(t, r);
    return (l, d) => (b(), k(Yb, j(c(s), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: d[0] || (d[0] = (u) => {
        var f;
        r("closeAutoFocus", u), u.defaultPrevented || (i.value || (f = c(o).triggerElement.value) == null || f.focus(), u.preventDefault()), i.value = !1, a.value = !1;
      }),
      onInteractOutside: d[1] || (d[1] = async (u) => {
        var f;
        r("interactOutside", u), u.defaultPrevented || (i.value = !0, u.detail.originalEvent.type === "pointerdown" && (a.value = !0));
        const p = u.target;
        (f = c(o).triggerElement.value) != null && f.contains(p) && u.preventDefault(), u.detail.originalEvent.type === "focusin" && a.value && u.preventDefault();
      })
    }), {
      default: y(() => [
        E(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Uk = /* @__PURE__ */ _({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = pd(), i = je(t, r), { forwardRef: a } = ie();
    return o.contentId || (o.contentId = zt(void 0, "radix-vue-popover-content")), (s, l) => (b(), k(c(Bn), {
      present: s.forceMount || c(o).open.value
    }, {
      default: y(() => [
        c(o).modal.value ? (b(), k(jk, j({ key: 0 }, c(i), { ref: c(a) }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16)) : (b(), k(Hk, j({ key: 1 }, c(i), { ref: c(a) }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [Kk, Wk] = Xe("RadioGroupRoot"), qk = /* @__PURE__ */ _({
  __name: "RadioGroupRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    disabled: { type: Boolean, default: !1 },
    name: {},
    required: { type: Boolean, default: !1 },
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, { forwardRef: o } = ie(), i = gt(t, "modelValue", r, {
      defaultValue: t.defaultValue,
      passive: t.modelValue === void 0
    }), { disabled: a, loop: s, orientation: l, name: d, required: u, dir: f } = at(t), p = Cr(f);
    return Wk({
      modelValue: i,
      changeModelValue: (h) => {
        i.value = h;
      },
      disabled: a,
      loop: s,
      orientation: l,
      name: d?.value,
      required: u
    }), (h, m) => (b(), k(c(Xc), {
      "as-child": "",
      orientation: c(l),
      dir: c(p),
      loop: c(s)
    }, {
      default: y(() => [
        x(c(le), {
          ref: c(o),
          role: "radiogroup",
          "data-disabled": c(a) ? "" : void 0,
          "as-child": h.asChild,
          as: h.as,
          required: c(u),
          "aria-orientation": c(l),
          "aria-required": c(u),
          dir: c(p),
          name: c(d)
        }, {
          default: y(() => [
            E(h.$slots, "default", { modelValue: c(i) })
          ]),
          _: 3
        }, 8, ["data-disabled", "as-child", "as", "required", "aria-orientation", "aria-required", "dir", "name"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), Gk = ["value", "checked", "name", "disabled", "required"], Jk = /* @__PURE__ */ _({
  __name: "Radio",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean },
    checked: { type: Boolean, default: void 0 },
    name: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  emits: ["update:checked"],
  setup(n, { emit: e }) {
    const t = n, r = gt(t, "checked", e, {
      passive: t.checked === void 0
    }), { value: o } = at(t), { forwardRef: i, currentElement: a } = ie(), s = hs(a), l = M(() => {
      var u;
      return t.id && a.value ? ((u = document.querySelector(`[for="${t.id}"]`)) == null ? void 0 : u.innerText) ?? t.value : void 0;
    });
    function d(u) {
      r.value = !0, s.value && u.stopPropagation();
    }
    return (u, f) => (b(), k(c(le), j(u.$attrs, {
      id: u.id,
      ref: c(i),
      role: "radio",
      type: u.as === "button" ? "button" : void 0,
      as: u.as,
      "aria-checked": c(r),
      "aria-label": l.value,
      "as-child": u.asChild,
      disabled: u.disabled ? "" : void 0,
      "data-state": c(r) ? "checked" : "unchecked",
      "data-disabled": u.disabled ? "" : void 0,
      value: c(o),
      required: u.required,
      name: u.name,
      onClick: At(d, ["stop"])
    }), {
      default: y(() => [
        E(u.$slots, "default", { checked: c(r) }),
        c(s) ? (b(), D("input", {
          key: 0,
          type: "radio",
          tabindex: "-1",
          "aria-hidden": "true",
          value: c(o),
          checked: !!c(r),
          name: u.name,
          disabled: u.disabled,
          required: u.required,
          style: {
            transform: "translateX(-100%)",
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
          }
        }, null, 8, Gk)) : X("", !0)
      ]),
      _: 3
    }, 16, ["id", "type", "as", "aria-checked", "aria-label", "as-child", "disabled", "data-state", "data-disabled", "value", "required", "name"]));
  }
}), [Zk, Yk] = Xe("RadioGroupItem"), Xk = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "RadioGroupItem",
  props: {
    id: {},
    value: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean },
    name: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, { forwardRef: t, currentElement: r } = ie(), o = Kk(), i = M(() => o.disabled.value || e.disabled), a = M(() => o.required.value || e.required), s = M(() => {
      var f;
      return ((f = o.modelValue) == null ? void 0 : f.value) === e.value;
    });
    Yk({ disabled: i, checked: s });
    const l = B(!1), d = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    ja("keydown", (f) => {
      d.includes(f.key) && (l.value = !0);
    }), ja("keyup", () => {
      l.value = !1;
    });
    function u() {
      setTimeout(() => {
        var f;
        l.value && ((f = r.value) == null || f.click());
      }, 0);
    }
    return (f, p) => (b(), k(c(t0), {
      checked: s.value,
      disabled: i.value,
      "as-child": "",
      focusable: !i.value,
      active: s.value
    }, {
      default: y(() => [
        x(Jk, j({ ...f.$attrs, ...e }, {
          ref: c(t),
          checked: s.value,
          required: a.value,
          disabled: i.value,
          "onUpdate:checked": p[0] || (p[0] = (h) => c(o).changeModelValue(f.value)),
          onKeydown: p[1] || (p[1] = ur(At(() => {
          }, ["prevent"]), ["enter"])),
          onFocus: u
        }), {
          default: y(() => [
            E(f.$slots, "default")
          ]),
          _: 3
        }, 16, ["checked", "required", "disabled"])
      ]),
      _: 3
    }, 8, ["checked", "disabled", "focusable", "active"]));
  }
}), Qk = /* @__PURE__ */ _({
  __name: "RadioGroupIndicator",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const { forwardRef: e } = ie(), t = Zk();
    return (r, o) => (b(), k(c(Bn), {
      present: r.forceMount || c(t).checked.value
    }, {
      default: y(() => [
        x(c(le), j({
          ref: c(e),
          "data-state": c(t).checked.value ? "checked" : "unchecked",
          "data-disabled": c(t).disabled.value ? "" : void 0,
          "as-child": r.asChild,
          as: r.as
        }, r.$attrs), {
          default: y(() => [
            E(r.$slots, "default")
          ]),
          _: 3
        }, 16, ["data-state", "data-disabled", "as-child", "as"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), e_ = ["default-value"], t_ = /* @__PURE__ */ _({
  __name: "BubbleSelect",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    form: {},
    multiple: { type: Boolean },
    name: {},
    required: { type: Boolean },
    size: {},
    value: {}
  },
  setup(n) {
    const e = n, { value: t } = at(e), r = B();
    return (o, i) => (b(), k(c(Jc), { "as-child": "" }, {
      default: y(() => [
        hr(O("select", j({
          ref_key: "selectElement",
          ref: r
        }, e, {
          "onUpdate:modelValue": i[0] || (i[0] = (a) => Br(t) ? t.value = a : null),
          "default-value": c(t)
        }), [
          E(o.$slots, "default")
        ], 16, e_), [
          [N5, c(t)]
        ])
      ]),
      _: 3
    }));
  }
}), n_ = {
  key: 0,
  value: ""
}, [ta, Xb] = Xe("SelectRoot"), [r_, o_] = Xe("SelectRoot"), i_ = /* @__PURE__ */ _({
  __name: "SelectRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    defaultValue: { default: "" },
    modelValue: { default: void 0 },
    dir: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = gt(t, "modelValue", r, {
      defaultValue: t.defaultValue,
      passive: t.modelValue === void 0
    }), i = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), a = B(), s = B(), l = B({
      x: 0,
      y: 0
    }), d = B(!1), { required: u, disabled: f, dir: p } = at(t), h = Cr(p);
    Xb({
      triggerElement: a,
      onTriggerChange: ($) => {
        a.value = $;
      },
      valueElement: s,
      onValueElementChange: ($) => {
        s.value = $;
      },
      valueElementHasChildren: d,
      onValueElementHasChildrenChange: ($) => {
        d.value = $;
      },
      contentId: "",
      modelValue: o,
      onValueChange: ($) => {
        o.value = $;
      },
      open: i,
      required: u,
      onOpenChange: ($) => {
        i.value = $;
      },
      dir: h,
      triggerPointerDownPosRef: l,
      disabled: f
    });
    const m = hs(a), g = B(/* @__PURE__ */ new Set()), v = M(() => Array.from(g.value).map(($) => {
      var C;
      return (C = $.props) == null ? void 0 : C.value;
    }).join(";"));
    return o_({
      onNativeOptionAdd: ($) => {
        g.value.add($);
      },
      onNativeOptionRemove: ($) => {
        g.value.delete($);
      }
    }), ($, C) => (b(), k(c(fd), null, {
      default: y(() => [
        E($.$slots, "default", {
          modelValue: c(o),
          open: c(i)
        }),
        c(m) ? (b(), k(t_, j({ key: v.value }, $.$attrs, {
          "aria-hidden": "true",
          tabindex: "-1",
          required: c(u),
          name: $.name,
          autocomplete: $.autocomplete,
          disabled: c(f),
          value: c(o),
          onChange: C[0] || (C[0] = (S) => o.value = S.target.value)
        }), {
          default: y(() => [
            c(o) === void 0 ? (b(), D("option", n_)) : X("", !0),
            (b(!0), D(Me, null, it(Array.from(g.value), (S) => (b(), k(Qt(S), j({ ref_for: !0 }, S.props, {
              key: S.key ?? ""
            }), null, 16))), 128))
          ]),
          _: 1
        }, 16, ["required", "name", "autocomplete", "disabled", "value"])) : X("", !0)
      ]),
      _: 3
    }));
  }
}), a_ = [" ", "Enter", "ArrowUp", "ArrowDown"], s_ = [" ", "Enter"], or = 10;
function Qb(n) {
  return n === "" || nu(n);
}
const e3 = /* @__PURE__ */ _({
  __name: "SelectTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = ta(), r = M(() => {
      var h;
      return ((h = t.disabled) == null ? void 0 : h.value) || e.disabled;
    }), { forwardRef: o, currentElement: i } = ie();
    t.contentId || (t.contentId = zt(void 0, "radix-vue-select-content")), Ge(() => {
      t.triggerElement = i;
    });
    const { injectCollection: a } = ps(), s = a(), { search: l, handleTypeaheadSearch: d, resetTypeahead: u } = Um(s);
    function f() {
      r.value || (t.onOpenChange(!0), u());
    }
    function p(h) {
      f(), t.triggerPointerDownPosRef.value = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      };
    }
    return (h, m) => (b(), k(c(Gc), { "as-child": "" }, {
      default: y(() => {
        var g, v, $, C;
        return [
          x(c(le), {
            ref: c(o),
            role: "combobox",
            type: h.as === "button" ? "button" : void 0,
            "aria-controls": c(t).contentId,
            "aria-expanded": c(t).open.value || !1,
            "aria-required": (g = c(t).required) == null ? void 0 : g.value,
            "aria-autocomplete": "none",
            disabled: r.value,
            dir: (v = c(t)) == null ? void 0 : v.dir.value,
            "data-state": ($ = c(t)) != null && $.open.value ? "open" : "closed",
            "data-disabled": r.value ? "" : void 0,
            "data-placeholder": c(Qb)((C = c(t).modelValue) == null ? void 0 : C.value) ? "" : void 0,
            "as-child": h.asChild,
            as: h.as,
            onClick: m[0] || (m[0] = (S) => {
              var w;
              (w = S?.currentTarget) == null || w.focus();
            }),
            onPointerdown: m[1] || (m[1] = (S) => {
              if (S.pointerType === "touch")
                return S.preventDefault();
              const w = S.target;
              w.hasPointerCapture(S.pointerId) && w.releasePointerCapture(S.pointerId), S.button === 0 && S.ctrlKey === !1 && (p(S), S.preventDefault());
            }),
            onPointerup: m[2] || (m[2] = At(
              (S) => {
                S.pointerType === "touch" && p(S);
              },
              ["prevent"]
            )),
            onKeydown: m[3] || (m[3] = (S) => {
              const w = c(l) !== "";
              !(S.ctrlKey || S.altKey || S.metaKey) && S.key.length === 1 && w && S.key === " " || (c(d)(S.key), c(a_).includes(S.key) && (f(), S.preventDefault()));
            })
          }, {
            default: y(() => [
              E(h.$slots, "default")
            ]),
            _: 3
          }, 8, ["type", "aria-controls", "aria-expanded", "aria-required", "disabled", "dir", "data-state", "data-disabled", "data-placeholder", "as-child", "as"])
        ];
      }),
      _: 3
    }));
  }
}), l_ = /* @__PURE__ */ _({
  __name: "SelectPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(cd), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [r0, d_] = Xe("SelectItemAlignedPosition"), u_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectItemAlignedPosition",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["placed"],
  setup(n, { emit: e }) {
    const t = n, r = e, { injectCollection: o } = ps(), i = ta(), a = na(), s = o(), l = B(!1), d = B(!0), u = B(), { forwardRef: f, currentElement: p } = ie(), { viewport: h, selectedItem: m, selectedItemText: g, focusSelectedItem: v } = a;
    function $() {
      if (i.triggerElement.value && i.valueElement.value && u.value && p.value && h != null && h.value && m != null && m.value && g != null && g.value) {
        const w = i.triggerElement.value.getBoundingClientRect(), T = p.value.getBoundingClientRect(), A = i.valueElement.value.getBoundingClientRect(), N = g.value.getBoundingClientRect();
        if (i.dir.value !== "rtl") {
          const he = N.left - T.left, ve = A.left - he, _e = w.left - ve, ye = w.width + _e, Se = Math.max(ye, T.width), se = window.innerWidth - or, Ke = _u(ve, or, Math.max(or, se - Se));
          u.value.style.minWidth = `${ye}px`, u.value.style.left = `${Ke}px`;
        } else {
          const he = T.right - N.right, ve = window.innerWidth - A.right - he, _e = window.innerWidth - w.right - ve, ye = w.width + _e, Se = Math.max(ye, T.width), se = window.innerWidth - or, Ke = _u(
            ve,
            or,
            Math.max(or, se - Se)
          );
          u.value.style.minWidth = `${ye}px`, u.value.style.right = `${Ke}px`;
        }
        const z = s.value, I = window.innerHeight - or * 2, P = h.value.scrollHeight, L = window.getComputedStyle(p.value), H = Number.parseInt(
          L.borderTopWidth,
          10
        ), q = Number.parseInt(L.paddingTop, 10), Q = Number.parseInt(
          L.borderBottomWidth,
          10
        ), ae = Number.parseInt(
          L.paddingBottom,
          10
        ), de = H + q + P + ae + Q, ne = Math.min(
          m.value.offsetHeight * 5,
          de
        ), ke = window.getComputedStyle(h.value), ee = Number.parseInt(ke.paddingTop, 10), be = Number.parseInt(
          ke.paddingBottom,
          10
        ), Ee = w.top + w.height / 2 - or, nt = I - Ee, ct = m.value.offsetHeight / 2, Ne = m.value.offsetTop + ct, st = H + q + Ne, ce = de - st;
        if (st <= Ee) {
          const he = m.value === z[z.length - 1];
          u.value.style.bottom = "0px";
          const ve = p.value.clientHeight - h.value.offsetTop - h.value.offsetHeight, _e = Math.max(
            nt,
            ct + (he ? be : 0) + ve + Q
          ), ye = st + _e;
          u.value.style.height = `${ye}px`;
        } else {
          const he = m.value === z[0];
          u.value.style.top = "0px";
          const ve = Math.max(
            Ee,
            H + h.value.offsetTop + (he ? ee : 0) + ct
          ) + ce;
          u.value.style.height = `${ve}px`, h.value.scrollTop = st - Ee + h.value.offsetTop;
        }
        u.value.style.margin = `${or}px 0`, u.value.style.minHeight = `${ne}px`, u.value.style.maxHeight = `${I}px`, r("placed"), requestAnimationFrame(() => l.value = !0);
      }
    }
    const C = B("");
    Ge(async () => {
      await Be(), $(), p.value && (C.value = window.getComputedStyle(p.value).zIndex);
    });
    function S(w) {
      w && d.value === !0 && ($(), v?.(), d.value = !1);
    }
    return d_({
      contentWrapper: u,
      shouldExpandOnScrollRef: l,
      onScrollButtonChange: S
    }), (w, T) => (b(), D("div", {
      ref_key: "contentWrapperElement",
      ref: u,
      style: Zi({
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        zIndex: C.value
      })
    }, [
      x(c(le), j({
        ref: c(f),
        style: {
          // When we get the height of the content, it includes borders. If we were to set
          // the height without having `boxSizing: 'border-box'` it would be too big.
          boxSizing: "border-box",
          // We need to ensure the content doesn't get taller than the wrapper
          maxHeight: "100%"
        }
      }, { ...w.$attrs, ...t }), {
        default: y(() => [
          E(w.$slots, "default")
        ]),
        _: 3
      }, 16)
    ], 4));
  }
}), c_ = /* @__PURE__ */ _({
  __name: "SelectPopperPosition",
  props: {
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: { default: or },
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = pt(n);
    return (t, r) => (b(), k(c(Ha), j(c(e), { style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    } }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ys = {
  onViewportChange: () => {
  },
  itemTextRefCallback: () => {
  },
  itemRefCallback: () => {
  }
}, [na, f_] = Xe("SelectContent"), p_ = /* @__PURE__ */ _({
  __name: "SelectContentImpl",
  props: {
    position: { default: "item-aligned" },
    bodyLock: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: { default: "start" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = ta();
    Hm(), dd(t.bodyLock);
    const { createCollection: i } = ps(), a = B();
    ud(a);
    const s = i(a), { search: l, handleTypeaheadSearch: d } = Um(s), u = B(), f = B(), p = B(), h = B(!1), m = B(!1);
    function g() {
      f.value && a.value && ah([f.value, a.value]);
    }
    De(h, () => {
      g();
    });
    const { onOpenChange: v, triggerPointerDownPosRef: $ } = o;
    vt((T) => {
      if (!a.value)
        return;
      let A = { x: 0, y: 0 };
      const N = (I) => {
        var P, L;
        A = {
          x: Math.abs(
            Math.round(I.pageX) - (((P = $.value) == null ? void 0 : P.x) ?? 0)
          ),
          y: Math.abs(
            Math.round(I.pageY) - (((L = $.value) == null ? void 0 : L.y) ?? 0)
          )
        };
      }, z = (I) => {
        var P;
        I.pointerType !== "touch" && (A.x <= 10 && A.y <= 10 ? I.preventDefault() : (P = a.value) != null && P.contains(I.target) || v(!1), document.removeEventListener("pointermove", N), $.value = null);
      };
      $.value !== null && (document.addEventListener("pointermove", N), document.addEventListener("pointerup", z, {
        capture: !0,
        once: !0
      })), T(() => {
        document.removeEventListener("pointermove", N), document.removeEventListener("pointerup", z, {
          capture: !0
        });
      });
    });
    function C(T) {
      const A = T.ctrlKey || T.altKey || T.metaKey;
      if (T.key === "Tab" && T.preventDefault(), !A && T.key.length === 1 && d(T.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(T.key)) {
        let N = s.value;
        if (["ArrowUp", "End"].includes(T.key) && (N = N.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(T.key)) {
          const z = T.target, I = N.indexOf(z);
          N = N.slice(I + 1);
        }
        setTimeout(() => ah(N)), T.preventDefault();
      }
    }
    const S = M(() => t.position === "popper" ? t : {}), w = pt(S.value);
    return f_({
      content: a,
      viewport: u,
      onViewportChange: (T) => {
        u.value = T;
      },
      itemRefCallback: (T, A, N) => {
        var z, I;
        const P = !m.value && !N;
        (((z = o.modelValue) == null ? void 0 : z.value) !== void 0 && ((I = o.modelValue) == null ? void 0 : I.value) === A || P) && (f.value = T, P && (m.value = !0));
      },
      selectedItem: f,
      selectedItemText: p,
      onItemLeave: () => {
        var T;
        (T = a.value) == null || T.focus();
      },
      itemTextRefCallback: (T, A, N) => {
        var z, I;
        const P = !m.value && !N;
        (((z = o.modelValue) == null ? void 0 : z.value) !== void 0 && ((I = o.modelValue) == null ? void 0 : I.value) === A || P) && (p.value = T);
      },
      focusSelectedItem: g,
      position: t.position,
      isPositioned: h,
      searchRef: l
    }), (T, A) => (b(), k(c(qc), {
      "as-child": "",
      onMountAutoFocus: A[6] || (A[6] = At(() => {
      }, ["prevent"])),
      onUnmountAutoFocus: A[7] || (A[7] = (N) => {
        var z;
        r("closeAutoFocus", N), !N.defaultPrevented && ((z = c(o).triggerElement.value) == null || z.focus({ preventScroll: !0 }), N.preventDefault());
      })
    }, {
      default: y(() => [
        x(c(ms), {
          "as-child": "",
          "disable-outside-pointer-events": "",
          onFocusOutside: A[2] || (A[2] = At(() => {
          }, ["prevent"])),
          onDismiss: A[3] || (A[3] = (N) => c(o).onOpenChange(!1)),
          onEscapeKeyDown: A[4] || (A[4] = (N) => r("escapeKeyDown", N)),
          onPointerDownOutside: A[5] || (A[5] = (N) => r("pointerDownOutside", N))
        }, {
          default: y(() => [
            (b(), k(Qt(
              T.position === "popper" ? c_ : u_
            ), j({ ...T.$attrs, ...c(w) }, {
              id: c(o).contentId,
              ref: (N) => {
                a.value = c(Zn)(N);
              },
              role: "listbox",
              "data-state": c(o).open.value ? "open" : "closed",
              dir: c(o).dir.value,
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none"
              },
              onContextmenu: A[0] || (A[0] = At(() => {
              }, ["prevent"])),
              onPlaced: A[1] || (A[1] = (N) => h.value = !0),
              onKeydown: C
            }), {
              default: y(() => [
                E(T.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "dir", "onKeydown"]))
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), h_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectProvider",
  props: {
    context: {}
  },
  setup(n) {
    return Xb(n.context), (e, t) => E(e.$slots, "default");
  }
}), m_ = { key: 1 }, g_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(n, { emit: e }) {
    const t = n, r = je(t, e), o = ta(), i = B();
    Ge(() => {
      i.value = new DocumentFragment();
    });
    const a = B(), s = M(() => t.forceMount || o.open.value);
    return (l, d) => {
      var u;
      return s.value ? (b(), k(c(Bn), {
        key: 0,
        ref_key: "presenceRef",
        ref: a,
        present: !0
      }, {
        default: y(() => [
          x(p_, Le(Ve({ ...c(r), ...l.$attrs })), {
            default: y(() => [
              E(l.$slots, "default")
            ]),
            _: 3
          }, 16)
        ]),
        _: 3
      }, 512)) : !((u = a.value) != null && u.present) && i.value ? (b(), D("div", m_, [
        (b(), k(Pc, { to: i.value }, [
          x(h_, { context: c(o) }, {
            default: y(() => [
              E(l.$slots, "default")
            ]),
            _: 3
          }, 8, ["context"])
        ], 8, ["to"]))
      ])) : X("", !0);
    };
  }
}), [v_, y_] = Xe("SelectItem"), b_ = /* @__PURE__ */ _({
  __name: "SelectItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { disabled: t } = at(e), r = ta(), o = na(ys), { forwardRef: i, currentElement: a } = ie(), s = M(() => {
      var g;
      return ((g = r.modelValue) == null ? void 0 : g.value) === e.value;
    }), l = B(!1), d = B(e.textValue ?? ""), u = zt(void 0, "radix-vue-select-item-text");
    async function f(g) {
      await Be(), !(g != null && g.defaultPrevented) && (t.value || (r.onValueChange(e.value), r.onOpenChange(!1)));
    }
    async function p(g) {
      var v;
      await Be(), !g.defaultPrevented && (t.value ? (v = o.onItemLeave) == null || v.call(o) : g.currentTarget.focus({ preventScroll: !0 }));
    }
    async function h(g) {
      var v;
      await Be(), !g.defaultPrevented && g.currentTarget === Bt() && ((v = o.onItemLeave) == null || v.call(o));
    }
    async function m(g) {
      var v;
      await Be(), !(g.defaultPrevented || ((v = o.searchRef) == null ? void 0 : v.value) !== "" && g.key === " ") && (s_.includes(g.key) && f(), g.key === " " && g.preventDefault());
    }
    if (e.value === "")
      throw new Error(
        "A <SelectItem /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return Ge(() => {
      a.value && o.itemRefCallback(
        a.value,
        e.value,
        e.disabled
      );
    }), y_({
      value: e.value,
      disabled: t,
      textId: u,
      isSelected: s,
      onItemTextChange: (g) => {
        d.value = ((d.value || g?.textContent) ?? "").trim();
      }
    }), (g, v) => (b(), k(c(le), {
      ref: c(i),
      role: "option",
      "data-radix-vue-collection-item": "",
      "aria-labelledby": c(u),
      "data-highlighted": l.value ? "" : void 0,
      "aria-selected": s.value,
      "data-state": s.value ? "checked" : "unchecked",
      "aria-disabled": c(t) || void 0,
      "data-disabled": c(t) ? "" : void 0,
      tabindex: c(t) ? void 0 : -1,
      as: g.as,
      "as-child": g.asChild,
      onFocus: v[0] || (v[0] = ($) => l.value = !0),
      onBlur: v[1] || (v[1] = ($) => l.value = !1),
      onPointerup: f,
      onPointerdown: v[2] || (v[2] = ($) => {
        $.currentTarget.focus({ preventScroll: !0 });
      }),
      onTouchend: v[3] || (v[3] = At(() => {
      }, ["prevent", "stop"])),
      onPointermove: p,
      onPointerleave: h,
      onKeydown: m
    }, {
      default: y(() => [
        E(g.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "tabindex", "as", "as-child"]));
  }
}), [$_, w_] = Xe("SelectGroup"), x_ = /* @__PURE__ */ _({
  __name: "SelectGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = zt(void 0, "radix-vue-select-group");
    return w_({ id: t }), (r, o) => (b(), k(c(le), j({ role: "group" }, e, { "aria-labelledby": c(t) }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"]));
  }
}), C_ = /* @__PURE__ */ _({
  __name: "SelectLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(n) {
    const e = n, t = $_({ id: "" });
    return (r, o) => (b(), k(c(le), j(e, {
      id: c(t).id
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), k_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectItemText",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = n, t = ta(), r = na(ys), o = r_(), i = v_(), { forwardRef: a, currentElement: s } = ie(), l = M(() => {
      var d;
      return Yt("option", {
        key: i.value,
        value: i.value,
        disabled: i.disabled.value,
        textContent: (d = s.value) == null ? void 0 : d.textContent
      });
    });
    return Ge(() => {
      s.value && (i.onItemTextChange(s.value), r.itemTextRefCallback(
        s.value,
        i.value,
        i.disabled.value
      ), o.onNativeOptionAdd(l.value));
    }), xr(() => {
      o.onNativeOptionRemove(l.value);
    }), (d, u) => (b(), D(Me, null, [
      x(c(le), j({
        id: c(i).textId,
        ref: c(a)
      }, { ...e, ...d.$attrs }, { "data-item-text": "" }), {
        default: y(() => [
          E(d.$slots, "default")
        ]),
        _: 3
      }, 16, ["id"]),
      c(i).isSelected.value && c(t).valueElement.value && !c(t).valueElementHasChildren.value ? (b(), k(Pc, {
        key: 0,
        to: c(t).valueElement.value
      }, [
        E(d.$slots, "default")
      ], 8, ["to"])) : X("", !0)
    ], 64));
  }
}), __ = /* @__PURE__ */ _({
  __name: "SelectViewport",
  props: {
    nonce: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { nonce: t } = at(e), r = V7(t), o = na(ys), i = o.position === "item-aligned" ? r0() : void 0, { forwardRef: a, currentElement: s } = ie();
    Ge(() => {
      o?.onViewportChange(s.value);
    });
    const l = B(0);
    function d(u) {
      const f = u.currentTarget, { shouldExpandOnScrollRef: p, contentWrapper: h } = i ?? {};
      if (p != null && p.value && h != null && h.value) {
        const m = Math.abs(l.value - f.scrollTop);
        if (m > 0) {
          const g = window.innerHeight - or * 2, v = Number.parseFloat(
            h.value.style.minHeight
          ), $ = Number.parseFloat(h.value.style.height), C = Math.max(v, $);
          if (C < g) {
            const S = C + m, w = Math.min(g, S), T = S - w;
            h.value.style.height = `${w}px`, h.value.style.bottom === "0px" && (f.scrollTop = T > 0 ? T : 0, h.value.style.justifyContent = "flex-end");
          }
        }
      }
      l.value = f.scrollTop;
    }
    return (u, f) => (b(), D(Me, null, [
      x(c(le), j({
        ref: c(a),
        "data-radix-select-viewport": "",
        role: "presentation"
      }, { ...u.$attrs, ...e }, {
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          overflow: "hidden auto"
        },
        onScroll: d
      }), {
        default: y(() => [
          E(u.$slots, "default")
        ]),
        _: 3
      }, 16),
      x(c(le), {
        as: "style",
        nonce: c(r)
      }, {
        default: y(() => [
          K(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-select-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-radix-select-viewport]::-webkit-scrollbar { display: none; } ")
        ]),
        _: 1
      }, 8, ["nonce"])
    ], 64));
  }
}), t3 = /* @__PURE__ */ _({
  __name: "SelectScrollButtonImpl",
  emits: ["autoScroll"],
  setup(n, { emit: e }) {
    const t = e, { injectCollection: r } = ps(), o = r(), i = na(ys), a = B(null);
    function s() {
      a.value !== null && (window.clearInterval(a.value), a.value = null);
    }
    vt(() => {
      const u = o.value.find(
        (f) => f === Bt()
      );
      u?.scrollIntoView({ block: "nearest" });
    });
    function l() {
      a.value === null && (a.value = window.setInterval(() => {
        t("autoScroll");
      }, 50));
    }
    function d() {
      var u;
      (u = i.onItemLeave) == null || u.call(i), a.value === null && (a.value = window.setInterval(() => {
        t("autoScroll");
      }, 50));
    }
    return xr(() => s()), (u, f) => {
      var p;
      return b(), k(c(le), j({
        "aria-hidden": "true",
        style: {
          flexShrink: 0
        }
      }, (p = u.$parent) == null ? void 0 : p.$props, {
        onPointerdown: l,
        onPointermove: d,
        onPointerleave: f[0] || (f[0] = () => {
          s();
        })
      }), {
        default: y(() => [
          E(u.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
}), S_ = /* @__PURE__ */ _({
  __name: "SelectScrollUpButton",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = na(ys), t = e.position === "item-aligned" ? r0() : void 0, { forwardRef: r, currentElement: o } = ie(), i = B(!1);
    return vt((a) => {
      var s, l;
      if ((s = e.viewport) != null && s.value && (l = e.isPositioned) != null && l.value) {
        let d = function() {
          i.value = u.scrollTop > 0;
        };
        const u = e.viewport.value;
        d(), u.addEventListener("scroll", d), a(() => u.removeEventListener("scroll", d));
      }
    }), De(o, () => {
      o.value && t?.onScrollButtonChange(o.value);
    }), (a, s) => i.value ? (b(), k(t3, {
      key: 0,
      ref: c(r),
      onAutoScroll: s[0] || (s[0] = () => {
        const { viewport: l, selectedItem: d } = c(e);
        l != null && l.value && d != null && d.value && (l.value.scrollTop = l.value.scrollTop - d.value.offsetHeight);
      })
    }, {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 512)) : X("", !0);
  }
}), E_ = /* @__PURE__ */ _({
  __name: "SelectScrollDownButton",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = na(ys), t = e.position === "item-aligned" ? r0() : void 0, { forwardRef: r, currentElement: o } = ie(), i = B(!1);
    return vt((a) => {
      var s, l;
      if ((s = e.viewport) != null && s.value && (l = e.isPositioned) != null && l.value) {
        let d = function() {
          const f = u.scrollHeight - u.clientHeight;
          i.value = Math.ceil(u.scrollTop) < f;
        };
        const u = e.viewport.value;
        d(), u.addEventListener("scroll", d), a(() => u.removeEventListener("scroll", d));
      }
    }), De(o, () => {
      o.value && t?.onScrollButtonChange(o.value);
    }), (a, s) => i.value ? (b(), k(t3, {
      key: 0,
      ref: c(r),
      onAutoScroll: s[0] || (s[0] = () => {
        const { viewport: l, selectedItem: d } = c(e);
        l != null && l.value && d != null && d.value && (l.value.scrollTop = l.value.scrollTop + d.value.offsetHeight);
      })
    }, {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 512)) : X("", !0);
  }
}), n3 = /* @__PURE__ */ _({
  __name: "SelectValue",
  props: {
    placeholder: { default: "" },
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const { forwardRef: e, currentElement: t } = ie(), r = ta(), o = Nc();
    return M5(() => {
      var i;
      const a = !!zc((i = o?.default) == null ? void 0 : i.call(o)).length;
      r.onValueElementHasChildrenChange(a);
    }), Ge(() => {
      r.valueElement = t;
    }), (i, a) => (b(), k(c(le), {
      ref: c(e),
      as: i.as,
      "as-child": i.asChild,
      style: { pointerEvents: "none" }
    }, {
      default: y(() => {
        var s;
        return [
          c(Qb)((s = c(r).modelValue) == null ? void 0 : s.value) ? (b(), D(Me, { key: 0 }, [
            K(U(i.placeholder), 1)
          ], 64)) : E(i.$slots, "default", { key: 1 })
        ];
      }),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function O_(n = [], e, t) {
  const r = [...n];
  return r[t] = e, r.sort((o, i) => o - i);
}
function r3(n, e, t) {
  const r = 100 / (t - e) * (n - e);
  return _u(r, 0, 100);
}
function T_(n, e) {
  return e > 2 ? `Value ${n + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][n] : void 0;
}
function A_(n, e) {
  if (n.length === 1)
    return 0;
  const t = n.map((o) => Math.abs(o - e)), r = Math.min(...t);
  return t.indexOf(r);
}
function M_(n, e, t) {
  const r = n / 2, o = o0([0, 50], [0, r]);
  return (r - o(e) * t) * t;
}
function N_(n) {
  return n.slice(0, -1).map((e, t) => n[t + 1] - e);
}
function P_(n, e) {
  if (e > 0) {
    const t = N_(n);
    return Math.min(...t) >= e;
  }
  return !0;
}
function o0(n, e) {
  return (t) => {
    if (n[0] === n[1] || e[0] === e[1])
      return e[0];
    const r = (e[1] - e[0]) / (n[1] - n[0]);
    return e[0] + r * (t - n[0]);
  };
}
function D_(n) {
  return (String(n).split(".")[1] || "").length;
}
function I_(n, e) {
  const t = 10 ** e;
  return Math.round(n * t) / t;
}
const o3 = ["PageUp", "PageDown"], i3 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], a3 = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, [s3, l3] = Xe(["SliderVertical", "SliderHorizontal"]), d3 = /* @__PURE__ */ _({
  __name: "SliderImpl",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  emits: ["slideStart", "slideMove", "slideEnd", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = Qc();
    return (i, a) => (b(), k(c(le), j({ "data-slider-impl": "" }, t, {
      onKeydown: a[0] || (a[0] = (s) => {
        s.key === "Home" ? (r("homeKeyDown", s), s.preventDefault()) : s.key === "End" ? (r("endKeyDown", s), s.preventDefault()) : c(o3).concat(c(i3)).includes(s.key) && (r("stepKeyDown", s), s.preventDefault());
      }),
      onPointerdown: a[1] || (a[1] = (s) => {
        const l = s.target;
        l.setPointerCapture(s.pointerId), s.preventDefault(), c(o).thumbElements.value.includes(l) ? l.focus() : r("slideStart", s);
      }),
      onPointermove: a[2] || (a[2] = (s) => {
        s.target.hasPointerCapture(s.pointerId) && r("slideMove", s);
      }),
      onPointerup: a[3] || (a[3] = (s) => {
        const l = s.target;
        l.hasPointerCapture(s.pointerId) && (l.releasePointerCapture(s.pointerId), r("slideEnd", s));
      })
    }), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), R_ = /* @__PURE__ */ _({
  __name: "SliderHorizontal",
  props: {
    dir: {},
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(n, { emit: e }) {
    const t = n, r = e, { max: o, min: i, dir: a, inverted: s } = at(t), { forwardRef: l, currentElement: d } = ie(), u = B(), f = M(() => a?.value === "ltr" && !s.value || a?.value !== "ltr" && s.value);
    function p(h) {
      const m = u.value || d.value.getBoundingClientRect(), g = [0, m.width], v = f.value ? [i.value, o.value] : [o.value, i.value], $ = o0(g, v);
      return u.value = m, $(h - m.left);
    }
    return l3({
      startEdge: f.value ? "left" : "right",
      endEdge: f.value ? "right" : "left",
      direction: f.value ? 1 : -1,
      size: "width"
    }), (h, m) => (b(), k(d3, {
      ref: c(l),
      dir: c(a),
      "data-orientation": "horizontal",
      style: {
        "--radix-slider-thumb-transform": "translateX(-50%)"
      },
      onSlideStart: m[0] || (m[0] = (g) => {
        const v = p(g.clientX);
        r("slideStart", v);
      }),
      onSlideMove: m[1] || (m[1] = (g) => {
        const v = p(g.clientX);
        r("slideMove", v);
      }),
      onSlideEnd: m[2] || (m[2] = () => {
        u.value = void 0, r("slideEnd");
      }),
      onStepKeyDown: m[3] || (m[3] = (g) => {
        const v = f.value ? "from-left" : "from-right", $ = c(a3)[v].includes(g.key);
        r("stepKeyDown", g, $ ? -1 : 1);
      }),
      onEndKeyDown: m[4] || (m[4] = (g) => r("endKeyDown", g)),
      onHomeKeyDown: m[5] || (m[5] = (g) => r("homeKeyDown", g))
    }, {
      default: y(() => [
        E(h.$slots, "default")
      ]),
      _: 3
    }, 8, ["dir"]));
  }
}), B_ = /* @__PURE__ */ _({
  __name: "SliderVertical",
  props: {
    min: {},
    max: {},
    inverted: { type: Boolean }
  },
  emits: ["slideEnd", "slideStart", "slideMove", "homeKeyDown", "endKeyDown", "stepKeyDown"],
  setup(n, { emit: e }) {
    const t = n, r = e, { max: o, min: i, inverted: a } = at(t), { forwardRef: s, currentElement: l } = ie(), d = B(), u = M(() => !a.value);
    function f(p) {
      const h = d.value || l.value.getBoundingClientRect(), m = [0, h.height], g = u.value ? [o.value, i.value] : [i.value, o.value], v = o0(m, g);
      return d.value = h, v(p - h.top);
    }
    return l3({
      startEdge: u.value ? "bottom" : "top",
      endEdge: u.value ? "top" : "bottom",
      size: "height",
      direction: u.value ? 1 : -1
    }), (p, h) => (b(), k(d3, {
      ref: c(s),
      "data-orientation": "vertical",
      style: {
        "--radix-slider-thumb-transform": "translateY(50%)"
      },
      onSlideStart: h[0] || (h[0] = (m) => {
        const g = f(m.clientY);
        r("slideStart", g);
      }),
      onSlideMove: h[1] || (h[1] = (m) => {
        const g = f(m.clientY);
        r("slideMove", g);
      }),
      onSlideEnd: h[2] || (h[2] = () => {
        d.value = void 0, r("slideEnd");
      }),
      onStepKeyDown: h[3] || (h[3] = (m) => {
        const g = u.value ? "from-bottom" : "from-top", v = c(a3)[g].includes(m.key);
        r("stepKeyDown", m, v ? -1 : 1);
      }),
      onEndKeyDown: h[4] || (h[4] = (m) => r("endKeyDown", m)),
      onHomeKeyDown: h[5] || (h[5] = (m) => r("homeKeyDown", m))
    }, {
      default: y(() => [
        E(p.$slots, "default")
      ]),
      _: 3
    }, 512));
  }
}), L_ = ["value", "name", "disabled", "step"], [Qc, F_] = Xe("SliderRoot"), V_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SliderRoot",
  props: {
    name: {},
    defaultValue: { default: () => [0] },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    orientation: { default: "horizontal" },
    dir: {},
    inverted: { type: Boolean, default: !1 },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minStepsBetweenThumbs: { default: 0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "valueCommit"],
  setup(n, { emit: e }) {
    const t = n, r = e, { min: o, max: i, step: a, minStepsBetweenThumbs: s, orientation: l, disabled: d, dir: u } = at(t), f = Cr(u), { forwardRef: p, currentElement: h } = ie(), m = hs(h);
    Ym();
    const g = gt(t, "modelValue", r, {
      defaultValue: t.defaultValue,
      passive: t.modelValue === void 0
    }), v = B(0), $ = B(g.value);
    function C(N) {
      const z = A_(g.value, N);
      T(N, z);
    }
    function S(N) {
      T(N, v.value);
    }
    function w() {
      const N = $.value[v.value];
      g.value[v.value] !== N && r("valueCommit", P5(g.value));
    }
    function T(N, z, { commit: I } = { commit: !1 }) {
      var P;
      const L = D_(a.value), H = I_(Math.round((N - o.value) / a.value) * a.value + o.value, L), q = _u(H, o.value, i.value), Q = O_(g.value, q, z);
      if (P_(Q, s.value * a.value)) {
        v.value = Q.indexOf(q);
        const ae = String(Q) !== String(g.value);
        ae && I && r("valueCommit", Q), ae && ((P = A.value[v.value]) == null || P.focus(), g.value = Q);
      }
    }
    const A = B([]);
    return F_({
      modelValue: g,
      valueIndexToChangeRef: v,
      thumbElements: A,
      orientation: l,
      min: o,
      max: i,
      disabled: d
    }), (N, z) => (b(), D(Me, null, [
      x(c(Xm), null, {
        default: y(() => [
          (b(), k(Qt(c(l) === "horizontal" ? R_ : B_), j(N.$attrs, {
            ref: c(p),
            "as-child": N.asChild,
            as: N.as,
            min: c(o),
            max: c(i),
            dir: c(f),
            inverted: N.inverted,
            "aria-disabled": c(d),
            "data-disabled": c(d) ? "" : void 0,
            onPointerdown: z[0] || (z[0] = () => {
              c(d) || ($.value = c(g));
            }),
            onSlideStart: z[1] || (z[1] = (I) => !c(d) && C(I)),
            onSlideMove: z[2] || (z[2] = (I) => !c(d) && S(I)),
            onSlideEnd: z[3] || (z[3] = (I) => !c(d) && w()),
            onHomeKeyDown: z[4] || (z[4] = (I) => !c(d) && T(c(o), 0, { commit: !0 })),
            onEndKeyDown: z[5] || (z[5] = (I) => !c(d) && T(c(i), c(g).length - 1, { commit: !0 })),
            onStepKeyDown: z[6] || (z[6] = (I, P) => {
              if (!c(d)) {
                const L = c(o3).includes(I.key) || I.shiftKey && c(i3).includes(I.key) ? 10 : 1, H = v.value, q = c(g)[H], Q = c(a) * L * P;
                T(q + Q, H, { commit: !0 });
              }
            })
          }), {
            default: y(() => [
              E(N.$slots, "default", { modelValue: c(g) })
            ]),
            _: 3
          }, 16, ["as-child", "as", "min", "max", "dir", "inverted", "aria-disabled", "data-disabled"]))
        ]),
        _: 3
      }),
      c(m) ? (b(!0), D(Me, { key: 0 }, it(c(g), (I, P) => (b(), D("input", {
        key: P,
        value: I,
        type: "number",
        style: { display: "none" },
        name: N.name ? N.name + (c(g).length > 1 ? "[]" : "") : void 0,
        disabled: c(d),
        step: c(a)
      }, null, 8, L_))), 128)) : X("", !0)
    ], 64));
  }
}), z_ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SliderThumbImpl",
  props: {
    index: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = Qc(), r = s3(), { forwardRef: o, currentElement: i } = ie(), a = M(() => {
      var h, m;
      return (m = (h = t.modelValue) == null ? void 0 : h.value) == null ? void 0 : m[e.index];
    }), s = M(() => a.value === void 0 ? 0 : r3(a.value, t.min.value ?? 0, t.max.value ?? 100)), l = M(() => {
      var h, m;
      return T_(e.index, ((m = (h = t.modelValue) == null ? void 0 : h.value) == null ? void 0 : m.length) ?? 0);
    }), d = Tb(i), u = M(() => d[r.size].value), f = M(() => u.value ? M_(u.value, s.value, r.direction) : 0), p = jm();
    return Ge(() => {
      t.thumbElements.value.push(i.value);
    }), Qn(() => {
      const h = t.thumbElements.value.findIndex((m) => m === i.value) ?? -1;
      t.thumbElements.value.splice(h, 1);
    }), (h, m) => (b(), k(c(Zc), null, {
      default: y(() => [
        x(c(le), j(h.$attrs, {
          ref: c(o),
          role: "slider",
          "data-radix-vue-collection-item": "",
          tabindex: c(t).disabled.value ? void 0 : 0,
          "aria-label": h.$attrs["aria-label"] || l.value,
          "data-disabled": c(t).disabled.value ? "" : void 0,
          "data-orientation": c(t).orientation.value,
          "aria-valuenow": a.value,
          "aria-valuemin": c(t).min.value,
          "aria-valuemax": c(t).max.value,
          "aria-orientation": c(t).orientation.value,
          "as-child": h.asChild,
          as: h.as,
          style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [c(r).startEdge]: `calc(${s.value}% + ${f.value}px)`,
            /**
             * There will be no value on initial render while we work out the index so we hide thumbs
             * without a value, otherwise SSR will render them in the wrong position before they
             * snap into the correct position during hydration which would be visually jarring for
             * slower connections.
             */
            display: !c(p) && a.value === void 0 ? "none" : void 0
          },
          onFocus: m[0] || (m[0] = () => {
            c(t).valueIndexToChangeRef.value = h.index;
          })
        }), {
          default: y(() => [
            E(h.$slots, "default")
          ]),
          _: 3
        }, 16, ["tabindex", "aria-label", "data-disabled", "data-orientation", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-orientation", "as-child", "as", "style"])
      ]),
      _: 3
    }));
  }
}), j_ = /* @__PURE__ */ _({
  __name: "SliderThumb",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { getItems: t } = Qm(), { forwardRef: r, currentElement: o } = ie(), i = M(() => o.value ? t().findIndex((a) => a.ref === o.value) : -1);
    return (a, s) => (b(), k(z_, j({ ref: c(r) }, e, { index: i.value }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["index"]));
  }
}), H_ = /* @__PURE__ */ _({
  __name: "SliderTrack",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = Qc();
    return ie(), (t, r) => (b(), k(c(le), {
      "as-child": t.asChild,
      as: t.as,
      "data-disabled": c(e).disabled.value ? "" : void 0,
      "data-orientation": c(e).orientation.value
    }, {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "data-disabled", "data-orientation"]));
  }
}), U_ = /* @__PURE__ */ _({
  __name: "SliderRange",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = Qc(), t = s3();
    ie();
    const r = M(() => {
      var a, s;
      return (s = (a = e.modelValue) == null ? void 0 : a.value) == null ? void 0 : s.map(
        (l) => r3(l, e.min.value, e.max.value)
      );
    }), o = M(() => e.modelValue.value.length > 1 ? Math.min(...r.value) : 0), i = M(() => 100 - Math.max(...r.value));
    return (a, s) => (b(), k(c(le), {
      "data-disabled": c(e).disabled.value ? "" : void 0,
      "data-orientation": c(e).orientation.value,
      "as-child": a.asChild,
      as: a.as,
      style: Zi({
        [c(t).startEdge]: `${o.value}%`,
        [c(t).endEdge]: `${i.value}%`
      })
    }, {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-disabled", "data-orientation", "as-child", "as", "style"]));
  }
});
function K_() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
K_();
const W_ = ["name", "disabled", "required", "value", "checked", "data-state", "data-disabled"], [q_, G_] = Xe("SwitchRoot"), u3 = /* @__PURE__ */ _({
  __name: "SwitchRoot",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    id: {},
    value: { default: "on" },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  emits: ["update:checked"],
  setup(n, { emit: e }) {
    const t = n, r = e, { disabled: o } = at(t), i = gt(t, "checked", r, {
      defaultValue: t.defaultChecked,
      passive: t.checked === void 0
    });
    function a() {
      o.value || (i.value = !i.value);
    }
    const { forwardRef: s, currentElement: l } = ie(), d = hs(l), u = M(() => {
      var f;
      return t.id && l.value ? (f = document.querySelector(`[for="${t.id}"]`)) == null ? void 0 : f.innerText : void 0;
    });
    return G_({
      checked: i,
      toggleCheck: a,
      disabled: o
    }), (f, p) => (b(), D(Me, null, [
      x(c(le), j(f.$attrs, {
        id: f.id,
        ref: c(s),
        role: "switch",
        type: f.as === "button" ? "button" : void 0,
        value: f.value,
        "aria-label": f.$attrs["aria-label"] || u.value,
        "aria-checked": c(i),
        "aria-required": f.required,
        "data-state": c(i) ? "checked" : "unchecked",
        "data-disabled": c(o) ? "" : void 0,
        "as-child": f.asChild,
        as: f.as,
        disabled: c(o),
        onClick: a,
        onKeydown: ur(At(a, ["prevent"]), ["enter"])
      }), {
        default: y(() => [
          E(f.$slots, "default", { checked: c(i) })
        ]),
        _: 3
      }, 16, ["id", "type", "value", "aria-label", "aria-checked", "aria-required", "data-state", "data-disabled", "as-child", "as", "disabled", "onKeydown"]),
      c(d) ? (b(), D("input", {
        key: 0,
        type: "checkbox",
        name: f.name,
        tabindex: "-1",
        "aria-hidden": "true",
        disabled: c(o),
        required: f.required,
        value: f.value,
        checked: !!c(i),
        "data-state": c(i) ? "checked" : "unchecked",
        "data-disabled": c(o) ? "" : void 0,
        style: {
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }, null, 8, W_)) : X("", !0)
    ], 64));
  }
}), c3 = /* @__PURE__ */ _({
  __name: "SwitchThumb",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(n) {
    const e = q_();
    return ie(), (t, r) => {
      var o;
      return b(), k(c(le), {
        "data-state": (o = c(e).checked) != null && o.value ? "checked" : "unchecked",
        "data-disabled": c(e).disabled.value ? "" : void 0,
        "as-child": t.asChild,
        as: t.as
      }, {
        default: y(() => [
          E(t.$slots, "default")
        ]),
        _: 3
      }, 8, ["data-state", "data-disabled", "as-child", "as"]);
    };
  }
}), [i0, J_] = Xe("TabsRoot"), Z_ = /* @__PURE__ */ _({
  __name: "TabsRoot",
  props: {
    defaultValue: {},
    orientation: { default: "horizontal" },
    dir: {},
    activationMode: { default: "automatic" },
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, { orientation: o, dir: i } = at(t), a = Cr(i);
    ie();
    const s = gt(t, "modelValue", r, {
      defaultValue: t.defaultValue,
      passive: t.modelValue === void 0
    }), l = B();
    return J_({
      modelValue: s,
      changeModelValue: (d) => {
        s.value = d;
      },
      orientation: o,
      dir: a,
      activationMode: t.activationMode,
      baseId: zt(void 0, "radix-vue-tabs"),
      tabsList: l
    }), (d, u) => (b(), k(c(le), {
      dir: c(a),
      "data-orientation": c(o),
      "as-child": d.asChild,
      as: d.as
    }, {
      default: y(() => [
        E(d.$slots, "default", { modelValue: c(s) })
      ]),
      _: 3
    }, 8, ["dir", "data-orientation", "as-child", "as"]));
  }
}), Y_ = /* @__PURE__ */ _({
  __name: "TabsList",
  props: {
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { loop: t } = at(e), { forwardRef: r, currentElement: o } = ie(), i = i0();
    return i.tabsList = o, (a, s) => (b(), k(c(Xc), {
      "as-child": "",
      orientation: c(i).orientation.value,
      dir: c(i).dir.value,
      loop: c(t)
    }, {
      default: y(() => [
        x(c(le), {
          ref: c(r),
          role: "tablist",
          "as-child": a.asChild,
          as: a.as,
          "aria-orientation": c(i).orientation.value
        }, {
          default: y(() => [
            E(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["as-child", "as", "aria-orientation"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
});
function f3(n, e) {
  return `${n}-trigger-${e}`;
}
function p3(n, e) {
  return `${n}-content-${e}`;
}
const X_ = /* @__PURE__ */ _({
  __name: "TabsContent",
  props: {
    value: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, { forwardRef: t } = ie(), r = i0(), o = M(() => f3(r.baseId, e.value)), i = M(() => p3(r.baseId, e.value)), a = M(() => e.value === r.modelValue.value), s = B(a.value);
    return Ge(() => {
      requestAnimationFrame(() => {
        s.value = !1;
      });
    }), (l, d) => (b(), k(c(Bn), {
      present: a.value,
      "force-mount": ""
    }, {
      default: y(({ present: u }) => [
        x(c(le), {
          id: i.value,
          ref: c(t),
          "as-child": l.asChild,
          as: l.as,
          role: "tabpanel",
          "data-state": a.value ? "active" : "inactive",
          "data-orientation": c(r).orientation.value,
          "aria-labelledby": o.value,
          hidden: !u.value,
          tabindex: "0",
          style: Zi({
            animationDuration: s.value ? "0s" : void 0
          })
        }, {
          default: y(() => [
            l.forceMount || a.value ? E(l.$slots, "default", { key: 0 }) : X("", !0)
          ]),
          _: 2
        }, 1032, ["id", "as-child", "as", "data-state", "data-orientation", "aria-labelledby", "hidden", "style"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), Q_ = /* @__PURE__ */ _({
  __name: "TabsTrigger",
  props: {
    value: {},
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, { forwardRef: t } = ie(), r = i0(), o = M(() => f3(r.baseId, e.value)), i = M(() => p3(r.baseId, e.value)), a = M(() => e.value === r.modelValue.value);
    return (s, l) => (b(), k(c(t0), {
      "as-child": "",
      focusable: !s.disabled,
      active: a.value
    }, {
      default: y(() => [
        x(c(le), {
          id: o.value,
          ref: c(t),
          role: "tab",
          type: s.as === "button" ? "button" : void 0,
          as: s.as,
          "as-child": s.asChild,
          "aria-selected": a.value ? "true" : "false",
          "aria-controls": i.value,
          "data-state": a.value ? "active" : "inactive",
          disabled: s.disabled,
          "data-disabled": s.disabled ? "" : void 0,
          "data-orientation": c(r).orientation.value,
          onMousedown: l[0] || (l[0] = At((d) => {
            !s.disabled && d.ctrlKey === !1 ? c(r).changeModelValue(s.value) : d.preventDefault();
          }, ["left"])),
          onKeydown: l[1] || (l[1] = ur((d) => c(r).changeModelValue(s.value), ["enter", "space"])),
          onFocus: l[2] || (l[2] = () => {
            const d = c(r).activationMode !== "manual";
            !a.value && !s.disabled && d && c(r).changeModelValue(s.value);
          })
        }, {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as", "as-child", "aria-selected", "aria-controls", "data-state", "disabled", "data-disabled", "data-orientation"])
      ]),
      _: 3
    }, 8, ["focusable", "active"]));
  }
}), [ef, eS] = Xe("ToastProvider"), tS = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "ToastProvider",
  props: {
    label: { default: "Notification" },
    duration: { default: 5e3 },
    swipeDirection: { default: "right" },
    swipeThreshold: { default: 50 }
  },
  setup(n) {
    const e = n, { label: t, duration: r, swipeDirection: o, swipeThreshold: i } = at(e), a = B(), s = B(0), l = B(!1), d = B(!1);
    if (e.label && typeof e.label == "string" && !e.label.trim()) {
      const u = "Invalid prop `label` supplied to `ToastProvider`. Expected non-empty `string`.";
      throw new Error(u);
    }
    return eS({
      label: t,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: s,
      viewport: a,
      onViewportChange(u) {
        a.value = u;
      },
      onToastAdd() {
        s.value++;
      },
      onToastRemove() {
        s.value--;
      },
      isFocusedToastEscapeKeyDownRef: l,
      isClosePausedRef: d
    }), (u, f) => E(u.$slots, "default");
  }
}), nS = "toast.swipeStart", rS = "toast.swipeMove", oS = "toast.swipeCancel", iS = "toast.swipeEnd", uh = "toast.viewportPause", ch = "toast.viewportResume";
function Dd(n, e, t) {
  const r = t.originalEvent.currentTarget, o = new CustomEvent(n, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  e && r.addEventListener(n, e, { once: !0 }), r.dispatchEvent(o);
}
function pg(n, e, t = 0) {
  const r = Math.abs(n.x), o = Math.abs(n.y), i = r > o;
  return e === "left" || e === "right" ? i && r > t : !i && o > t;
}
function aS(n) {
  return n.nodeType === n.ELEMENT_NODE;
}
function h3(n) {
  const e = [];
  return Array.from(n.childNodes).forEach((t) => {
    if (t.nodeType === t.TEXT_NODE && t.textContent && e.push(t.textContent), aS(t)) {
      const r = t.ariaHidden || t.hidden || t.style.display === "none", o = t.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (o) {
          const i = t.dataset.radixToastAnnounceAlt;
          i && e.push(i);
        } else
          e.push(...h3(t));
    }
  }), e;
}
const sS = /* @__PURE__ */ _({
  __name: "ToastAnnounce",
  setup(n) {
    const e = ef(), t = R9(1e3), r = B(!1);
    return kb(() => {
      r.value = !0;
    }), (o, i) => c(t) || r.value ? (b(), k(c(Jc), { key: 0 }, {
      default: y(() => [
        K(U(c(e).label.value) + " ", 1),
        E(o.$slots, "default")
      ]),
      _: 3
    })) : X("", !0);
  }
}), [lS, dS] = Xe("ToastRoot"), uS = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "ToastRootImpl",
  props: {
    type: {},
    open: { type: Boolean, default: !1 },
    duration: {},
    asChild: { type: Boolean },
    as: { default: "li" }
  },
  emits: ["close", "escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd"],
  setup(n, { emit: e }) {
    const t = n, r = e, { forwardRef: o, currentElement: i } = ie(), a = ef(), s = B(null), l = B(null), d = M(
      () => typeof t.duration == "number" ? t.duration : a.duration.value
    ), u = B(0), f = B(d.value), p = B(0), h = B(d.value), m = kb(() => {
      const C = (/* @__PURE__ */ new Date()).getTime() - u.value;
      h.value = Math.max(f.value - C, 0);
    }, { fpsLimit: 60 });
    function g(C) {
      C <= 0 || C === Number.POSITIVE_INFINITY || Kr && (window.clearTimeout(p.value), u.value = (/* @__PURE__ */ new Date()).getTime(), p.value = window.setTimeout(v, C));
    }
    function v() {
      var C, S;
      (C = i.value) != null && C.contains(Bt()) && ((S = a.viewport.value) == null || S.focus()), a.isClosePausedRef.value = !1, r("close");
    }
    const $ = M(() => i.value ? h3(i.value) : null);
    if (t.type && !["foreground", "background"].includes(t.type)) {
      const C = "Invalid prop `type` supplied to `Toast`. Expected `foreground | background`.";
      throw new Error(C);
    }
    return vt((C) => {
      const S = a.viewport.value;
      if (S) {
        const w = () => {
          g(f.value), m.resume(), r("resume");
        }, T = () => {
          const A = (/* @__PURE__ */ new Date()).getTime() - u.value;
          f.value = f.value - A, window.clearTimeout(p.value), m.pause(), r("pause");
        };
        return S.addEventListener(uh, T), S.addEventListener(ch, w), () => {
          S.removeEventListener(uh, T), S.removeEventListener(ch, w);
        };
      }
    }), De(() => [t.open, d.value], () => {
      f.value = d.value, t.open && !a.isClosePausedRef.value && g(d.value);
    }, { immediate: !0 }), zm("Escape", (C) => {
      r("escapeKeyDown", C), C.defaultPrevented || (a.isFocusedToastEscapeKeyDownRef.value = !0, v());
    }), Ge(() => {
      a.onToastAdd();
    }), Qn(() => {
      a.onToastRemove();
    }), dS({ onClose: v }), (C, S) => (b(), D(Me, null, [
      $.value ? (b(), k(sS, {
        key: 0,
        role: "alert",
        "aria-live": C.type === "foreground" ? "assertive" : "polite",
        "aria-atomic": "true"
      }, {
        default: y(() => [
          K(U($.value), 1)
        ]),
        _: 1
      }, 8, ["aria-live"])) : X("", !0),
      c(a).viewport.value ? (b(), k(Pc, {
        key: 1,
        to: c(a).viewport.value
      }, [
        x(c(le), j({
          ref: c(o),
          role: "alert",
          "aria-live": "off",
          "aria-atomic": "true",
          tabindex: "0",
          "data-radix-vue-collection-item": ""
        }, C.$attrs, {
          as: C.as,
          "as-child": C.asChild,
          "data-state": C.open ? "open" : "closed",
          "data-swipe-direction": c(a).swipeDirection.value,
          style: { userSelect: "none", touchAction: "none" },
          onPointerdown: S[0] || (S[0] = At((w) => {
            s.value = { x: w.clientX, y: w.clientY };
          }, ["left"])),
          onPointermove: S[1] || (S[1] = (w) => {
            if (!s.value)
              return;
            const T = w.clientX - s.value.x, A = w.clientY - s.value.y, N = !!l.value, z = ["left", "right"].includes(c(a).swipeDirection.value), I = ["left", "up"].includes(c(a).swipeDirection.value) ? Math.min : Math.max, P = z ? I(0, T) : 0, L = z ? 0 : I(0, A), H = w.pointerType === "touch" ? 10 : 2, q = { x: P, y: L }, Q = { originalEvent: w, delta: q };
            N ? (l.value = q, c(Dd)(c(rS), (ae) => r("swipeMove", ae), Q)) : c(pg)(q, c(a).swipeDirection.value, H) ? (l.value = q, c(Dd)(c(nS), (ae) => r("swipeStart", ae), Q), w.target.setPointerCapture(w.pointerId)) : (Math.abs(T) > H || Math.abs(A) > H) && (s.value = null);
          }),
          onPointerup: S[2] || (S[2] = (w) => {
            const T = l.value, A = w.target;
            if (A.hasPointerCapture(w.pointerId) && A.releasePointerCapture(w.pointerId), l.value = null, s.value = null, T) {
              const N = w.currentTarget, z = { originalEvent: w, delta: T };
              c(pg)(T, c(a).swipeDirection.value, c(a).swipeThreshold.value) ? c(Dd)(c(iS), (I) => r("swipeEnd", I), z) : c(Dd)(c(oS), (I) => r("swipeCancel", I), z), N?.addEventListener("click", (I) => I.preventDefault(), {
                once: !0
              });
            }
          })
        }), {
          default: y(() => [
            E(C.$slots, "default", {
              remaining: h.value,
              duration: d.value
            })
          ]),
          _: 3
        }, 16, ["as", "as-child", "data-state", "data-swipe-direction"])
      ], 8, ["to"])) : X("", !0)
    ], 64));
  }
}), cS = /* @__PURE__ */ _({
  __name: "ToastRoot",
  props: {
    defaultOpen: { type: Boolean, default: !0 },
    forceMount: { type: Boolean },
    type: { default: "foreground" },
    open: { type: Boolean, default: void 0 },
    duration: {},
    asChild: { type: Boolean },
    as: { default: "li" }
  },
  emits: ["escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd", "update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, { forwardRef: o } = ie(), i = gt(t, "open", r, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    });
    return (a, s) => (b(), k(c(Bn), {
      present: a.forceMount || c(i)
    }, {
      default: y(() => [
        x(uS, j({
          ref: c(o),
          open: c(i),
          type: a.type,
          as: a.as,
          "as-child": a.asChild,
          duration: a.duration
        }, a.$attrs, {
          onClose: s[0] || (s[0] = (l) => i.value = !1),
          onPause: s[1] || (s[1] = (l) => r("pause")),
          onResume: s[2] || (s[2] = (l) => r("resume")),
          onEscapeKeyDown: s[3] || (s[3] = (l) => r("escapeKeyDown", l)),
          onSwipeStart: s[4] || (s[4] = (l) => {
            r("swipeStart", l), l.currentTarget.setAttribute("data-swipe", "start");
          }),
          onSwipeMove: s[5] || (s[5] = (l) => {
            const { x: d, y: u } = l.detail.delta, f = l.currentTarget;
            f.setAttribute("data-swipe", "move"), f.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), f.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
          }),
          onSwipeCancel: s[6] || (s[6] = (l) => {
            const d = l.currentTarget;
            d.setAttribute("data-swipe", "cancel"), d.style.removeProperty("--radix-toast-swipe-move-x"), d.style.removeProperty("--radix-toast-swipe-move-y"), d.style.removeProperty("--radix-toast-swipe-end-x"), d.style.removeProperty("--radix-toast-swipe-end-y");
          }),
          onSwipeEnd: s[7] || (s[7] = (l) => {
            const { x: d, y: u } = l.detail.delta, f = l.currentTarget;
            f.setAttribute("data-swipe", "end"), f.style.removeProperty("--radix-toast-swipe-move-x"), f.style.removeProperty("--radix-toast-swipe-move-y"), f.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), f.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), i.value = !1;
          })
        }), {
          default: y(({ remaining: l, duration: d }) => [
            E(a.$slots, "default", {
              remaining: l,
              duration: d,
              open: c(i)
            })
          ]),
          _: 3
        }, 16, ["open", "type", "as", "as-child", "duration"])
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), m3 = /* @__PURE__ */ _({
  __name: "ToastAnnounceExclude",
  props: {
    altText: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    return (e, t) => (b(), k(c(le), {
      as: e.as,
      "as-child": e.asChild,
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": e.altText || void 0
    }, {
      default: y(() => [
        E(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-radix-toast-announce-alt"]));
  }
}), g3 = /* @__PURE__ */ _({
  __name: "ToastClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = lS(), { forwardRef: r } = ie();
    return (o, i) => (b(), k(m3, { "as-child": "" }, {
      default: y(() => [
        x(c(le), j(e, {
          ref: c(r),
          type: o.as === "button" ? "button" : void 0,
          onClick: i[0] || (i[0] = (a) => c(t).onClose())
        }), {
          default: y(() => [
            E(o.$slots, "default")
          ]),
          _: 3
        }, 16, ["type"])
      ]),
      _: 3
    }));
  }
}), fS = /* @__PURE__ */ _({
  __name: "ToastAction",
  props: {
    altText: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    if (!n.altText)
      throw new Error("Missing prop `altText` expected on `ToastAction`");
    const { forwardRef: e } = ie();
    return (t, r) => t.altText ? (b(), k(m3, {
      key: 0,
      "alt-text": t.altText,
      "as-child": ""
    }, {
      default: y(() => [
        x(g3, {
          ref: c(e),
          as: t.as,
          "as-child": t.asChild
        }, {
          default: y(() => [
            E(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child"])
      ]),
      _: 3
    }, 8, ["alt-text"])) : X("", !0);
  }
}), hg = /* @__PURE__ */ _({
  __name: "FocusProxy",
  emits: ["focusFromOutsideViewport"],
  setup(n, { emit: e }) {
    const t = e, r = ef();
    return (o, i) => (b(), k(c(Jc), {
      "aria-hidden": "true",
      tabindex: "0",
      style: { position: "fixed" },
      onFocus: i[0] || (i[0] = (a) => {
        var s;
        const l = a.relatedTarget;
        !((s = c(r).viewport.value) != null && s.contains(l)) && t("focusFromOutsideViewport");
      })
    }, {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }));
  }
}), pS = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "ToastViewport",
  props: {
    hotkey: { default: () => ["F8"] },
    label: { type: [String, Function], default: "Notifications ({hotkey})" },
    asChild: { type: Boolean },
    as: { default: "ol" }
  },
  setup(n) {
    const e = n, { hotkey: t, label: r } = at(e), { forwardRef: o, currentElement: i } = ie(), { createCollection: a } = ps(), s = a(i), l = ef(), d = M(() => l.toastCount.value > 0), u = B(), f = B(), p = M(() => t.value.join("+").replace(/Key/g, "").replace(/Digit/g, ""));
    zm(t.value, () => {
      i.value.focus();
    }), Ge(() => {
      l.onViewportChange(i.value);
    }), vt((m) => {
      const g = i.value;
      if (d.value && g) {
        const v = () => {
          if (!l.isClosePausedRef.value) {
            const T = new CustomEvent(uh);
            g.dispatchEvent(T), l.isClosePausedRef.value = !0;
          }
        }, $ = () => {
          if (l.isClosePausedRef.value) {
            const T = new CustomEvent(ch);
            g.dispatchEvent(T), l.isClosePausedRef.value = !1;
          }
        }, C = (T) => {
          !g.contains(T.relatedTarget) && $();
        }, S = () => {
          g.contains(Bt()) || $();
        }, w = (T) => {
          var A, N, z;
          const I = T.altKey || T.ctrlKey || T.metaKey;
          if (T.key === "Tab" && !I) {
            const P = Bt(), L = T.shiftKey;
            if (T.target === g && L) {
              (A = u.value) == null || A.focus();
              return;
            }
            const H = h({ tabbingDirection: L ? "backwards" : "forwards" }), q = H.findIndex((Q) => Q === P);
            ru(H.slice(q + 1)) ? T.preventDefault() : L ? (N = u.value) == null || N.focus() : (z = f.value) == null || z.focus();
          }
        };
        g.addEventListener("focusin", v), g.addEventListener("focusout", C), g.addEventListener("pointermove", v), g.addEventListener("pointerleave", S), g.addEventListener("keydown", w), window.addEventListener("blur", v), window.addEventListener("focus", $), m(() => {
          g.removeEventListener("focusin", v), g.removeEventListener("focusout", C), g.removeEventListener("pointermove", v), g.removeEventListener("pointerleave", S), g.removeEventListener("keydown", w), window.removeEventListener("blur", v), window.removeEventListener("focus", $);
        });
      }
    });
    function h({ tabbingDirection: m }) {
      const g = s.value.map((v) => {
        const $ = [v, ...qm(v)];
        return m === "forwards" ? $ : $.reverse();
      });
      return (m === "forwards" ? g.reverse() : g).flat();
    }
    return (m, g) => (b(), k(c(AC), {
      role: "region",
      "aria-label": typeof c(r) == "string" ? c(r).replace("{hotkey}", p.value) : c(r)(p.value),
      tabindex: "-1",
      style: Zi({
        // incase list has size when empty (e.g. padding), we remove pointer events so
        // it doesn't prevent interactions with page elements that it overlays
        pointerEvents: d.value ? void 0 : "none"
      })
    }, {
      default: y(() => [
        d.value ? (b(), k(hg, {
          key: 0,
          ref: (v) => {
            u.value = c(Zn)(v);
          },
          onFocusFromOutsideViewport: g[0] || (g[0] = () => {
            const v = h({
              tabbingDirection: "forwards"
            });
            c(ru)(v);
          })
        }, null, 512)) : X("", !0),
        x(c(le), j({
          ref: c(o),
          tabindex: "-1",
          as: m.as,
          "as-child": m.asChild
        }, m.$attrs), {
          default: y(() => [
            E(m.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child"]),
        d.value ? (b(), k(hg, {
          key: 1,
          ref: (v) => {
            f.value = c(Zn)(v);
          },
          onFocusFromOutsideViewport: g[1] || (g[1] = () => {
            const v = h({
              tabbingDirection: "backwards"
            });
            c(ru)(v);
          })
        }, null, 512)) : X("", !0)
      ]),
      _: 3
    }, 8, ["aria-label", "style"]));
  }
}), hS = /* @__PURE__ */ _({
  __name: "ToastTitle",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), mS = /* @__PURE__ */ _({
  __name: "ToastDescription",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return ie(), (t, r) => (b(), k(c(le), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), v3 = /* @__PURE__ */ _({
  __name: "Toggle",
  props: {
    defaultValue: { type: Boolean },
    pressed: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  emits: ["update:pressed"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    ie();
    const o = gt(t, "pressed", r, {
      defaultValue: t.defaultValue,
      passive: t.pressed === void 0
    });
    function i() {
      o.value = !o.value;
    }
    const a = M(() => o.value ? "on" : "off");
    return (s, l) => (b(), k(c(le), {
      type: s.as === "button" ? "button" : void 0,
      "as-child": t.asChild,
      as: s.as,
      "aria-pressed": c(o),
      "data-state": a.value,
      "data-disabled": s.disabled ? "" : void 0,
      disabled: s.disabled,
      onClick: i
    }, {
      default: y(() => [
        E(s.$slots, "default", { pressed: c(o) })
      ]),
      _: 3
    }, 8, ["type", "as-child", "as", "aria-pressed", "data-state", "data-disabled", "disabled"]));
  }
}), [gS, vS] = Xe("ToggleGroupRoot"), yS = /* @__PURE__ */ _({
  __name: "ToggleGroupRoot",
  props: {
    rovingFocus: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    orientation: {},
    dir: {},
    loop: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, { loop: o, rovingFocus: i, disabled: a, dir: s } = at(t), l = Cr(s), { forwardRef: d } = ie(), { modelValue: u, changeModelValue: f, isSingle: p } = Ib(t, r);
    return vS({
      isSingle: p,
      modelValue: u,
      changeModelValue: f,
      dir: l,
      orientation: t.orientation,
      loop: o,
      rovingFocus: i,
      disabled: a
    }), (h, m) => (b(), k(Qt(c(i) ? c(Xc) : c(le)), {
      "as-child": "",
      orientation: c(i) ? h.orientation : void 0,
      dir: c(l),
      loop: c(i) ? c(o) : void 0
    }, {
      default: y(() => [
        x(c(le), {
          ref: c(d),
          role: "group",
          "as-child": h.asChild,
          as: h.as
        }, {
          default: y(() => [
            E(h.$slots, "default", { modelValue: c(u) })
          ]),
          _: 3
        }, 8, ["as-child", "as"])
      ]),
      _: 3
    }, 8, ["orientation", "dir", "loop"]));
  }
}), bS = /* @__PURE__ */ _({
  __name: "ToggleGroupItem",
  props: {
    value: {},
    defaultValue: { type: Boolean },
    pressed: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(n) {
    const e = n, t = gS(), r = M(() => {
      var s;
      return ((s = t.disabled) == null ? void 0 : s.value) || e.disabled;
    }), o = M(() => {
      var s;
      return (s = t.modelValue.value) == null ? void 0 : s.includes(e.value);
    }), i = M(() => {
      var s;
      return t.isSingle.value ? t.modelValue.value === e.value : (s = t.modelValue.value) == null ? void 0 : s.includes(e.value);
    }), { forwardRef: a } = ie();
    return (s, l) => (b(), k(Qt(c(t).rovingFocus.value ? c(t0) : c(le)), {
      "as-child": "",
      focusable: !r.value,
      active: o.value
    }, {
      default: y(() => [
        x(c(v3), j(e, {
          ref: c(a),
          disabled: r.value,
          pressed: i.value,
          "onUpdate:pressed": l[0] || (l[0] = (d) => c(t).changeModelValue(s.value))
        }), {
          default: y(() => [
            E(s.$slots, "default")
          ]),
          _: 3
        }, 16, ["disabled", "pressed"])
      ]),
      _: 3
    }, 8, ["focusable", "active"]));
  }
}), tf = /* @__PURE__ */ _({
  __name: "Badge",
  props: {
    variant: {},
    as: {},
    asChild: { type: Boolean },
    class: {}
  },
  setup(n) {
    const e = R5(n, ["class", "as", "asChild", "variant"]);
    return (t, r) => (b(), k(c(le), j(e, {
      as: t.as,
      "as-child": t.asChild,
      class: c(G)(c($S)({ variant: t.variant }), t.$props.class ?? "")
    }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["as", "as-child", "class"]));
  }
}), $S = tn(
  `
    inline-flex min-w-fit items-center rounded-full border px-4 py-1.5 text-sm
    font-medium transition-colors
    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
    focus-visible:outline-primary
  `,
  {
    variants: {
      variant: {
        default: `
            border-transparent bg-primary text-primary-foreground
            [&:is(a,button)]:hover:bg-primary/80
          `,
        secondary: `
            border-transparent bg-secondary text-secondary-foreground
            [&:is(a,button)]:hover:bg-secondary/80
          `,
        destructive: `
            border-transparent bg-destructive text-destructive-foreground
            [&:is(a,button)]:hover:bg-destructive/80
          `,
        outline: `
          bg-transparent text-primary
          [&:is(a,button)]:hover:bg-primary/10
          dark:text-white
        `,
        ghost: `
          border-transparent bg-transparent text-primary
          [&:is(a,button)]:hover:text-foreground
        `
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), wS = { class: "!mt-0 flex items-center justify-between" }, xS = { class: "text-fluid-xxxs font-medium" }, CS = { class: "flex flex-wrap gap-2" }, uJ = /* @__PURE__ */ _({
  __name: "CardPostTeaser",
  props: {
    title: {},
    image: {},
    href: {},
    level: {},
    target: {},
    id: {},
    tags: {},
    date: {},
    readingTime: {},
    bookmarked: { type: Boolean }
  },
  emits: ["toggleBookmark"],
  setup(n) {
    return (e, t) => (b(), k(c(j2), {
      title: e.title,
      href: e.href,
      image: e.image,
      level: e.level
    }, {
      header: y(() => [
        O("div", wS, [
          O("p", xS, U(e.date) + " - " + U(e.readingTime), 1)
        ])
      ]),
      footer: y(() => [
        O("div", CS, [
          (b(!0), D(Me, null, it(e.tags, (r) => (b(), k(c(tf), {
            key: r.name,
            variant: "outline",
            href: r.href,
            as: "a",
            class: fe(c(G)("relative", !r.name.length && "hidden"))
          }, {
            default: y(() => [
              t[0] || (t[0] = O("span", { class: "sr-only" }, "Alle Artikel in", -1)),
              K(" " + U(r.name), 1)
            ]),
            _: 2
          }, 1032, ["href", "class"]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["title", "href", "image", "level"]));
  }
}), mg = [
  {
    id: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/sozialinfo-ch/mycompany/"
  },
  {
    id: "facebook",
    label: "facebook",
    url: "https://www.facebook.com/sozialinfo"
  },
  {
    id: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/sozialinfo.ch/"
  }
];
function ep(n) {
  return {
    quicklinks: {
      title: "Quicklinks",
      items: [
        {
          title: "Stelle suchen",
          url: "/arbeitsmarkt/stellenportal"
        },
        {
          title: "Stelle publizieren",
          url: n
        },
        {
          title: "DigitalCheck",
          url: "/digitalisierung/digitalcheck"
        },
        {
          title: "Rechtsfrage stellen",
          url: n
        },
        {
          title: "Bildungsangebote",
          url: "/arbeitsmarkt/bildungsangebote"
        }
      ]
    },
    orgs: {
      title: "Für Organisationen",
      url: "/fuer-organisationen",
      items: [
        {
          title: "Preise und Leistungen",
          url: "/fuer-organisationen/preise"
        },
        {
          title: "Mitglied werden",
          url: "/fuer-organisationen/verein/mitgliedschaft"
        },
        {
          title: "Werbung schalten",
          url: "/fuer-organisationen/werbeschaltungen"
        }
      ]
    },
    about: {
      title: "Über uns",
      url: "/ueber-uns",
      items: [
        {
          title: "Weshalb es uns gibt",
          url: "/fuer-organisationen/verein/"
        },
        {
          title: "Vorstand und Mitarbeitende",
          url: "/ueber-uns/vorstand-und-mitarbeitende"
        },
        {
          title: "Prix Sozialinfo",
          url: "/ueber-uns/prix-sozialinfo"
        },
        {
          title: "Jubiläum",
          url: "/ueber-uns/jubilaeum"
        },
        {
          title: "Jahresbericht",
          url: "https://jahresbericht.sozialinfo.ch/"
        },
        {
          title: "Kooperationen und Engagements",
          url: " /ueber-uns/kooperationen-und-engagements"
        }
        /* TODO: set correct url, after Go-Live Q1 2025
        {
          title: 'Jobs bei Sozialinfo',
          url: '',
        },
        */
      ]
    }
  };
}
function kS(n) {
  return [
    {
      title: "Stelle suchen",
      url: "/arbeitsmarkt/stellenportal"
    },
    {
      title: "Stelle publizieren",
      url: n
    },
    {
      title: "DigitalCheck",
      url: "/digitalisierung/digitalcheck"
    },
    {
      title: "Rechtsfrage stellen",
      url: n
    },
    {
      title: "Bildungsangebote",
      url: "/arbeitsmarkt/bildungsangebote"
    }
  ];
}
const _S = [
  {
    title: "Kontakt",
    url: "/kontakt"
  },
  {
    title: "Datenschutz",
    url: "/ueber-uns/datenschutzerklaerung"
  },
  {
    title: "AGB",
    url: "/ueber-uns/allgemeine-geschaeftsbedingungen"
  },
  {
    title: "Impressum",
    url: "/ueber-uns/impressum"
  }
], SS = {
  id: "footer",
  class: "relative z-50 flow-root print:hidden"
}, ES = { class: "bg-background" }, OS = { class: "flex flex-col gap-8 pb-8 lg:hidden" }, TS = ["href"], AS = { class: "max-w-96" }, MS = { class: "hidden gap-8 pb-16 2xl:grid 2xl:grid-cols-8 lg:block" }, NS = { class: "grid grid-cols-2 gap-8 2xl:col-span-6" }, PS = { class: "flex flex-col-reverse gap-8 xl:grid xl:grid-cols-2" }, DS = { class: "flex flex-col gap-8 xl:grid xl:grid-cols-2" }, IS = { class: "flex flex-row pt-16 2xl:col-span-2 2xl:justify-end 2xl:pt-0" }, cJ = /* @__PURE__ */ _({
  __name: "Footer",
  props: {
    portalUrl: {}
  },
  setup(n) {
    const t = n.portalUrl || "https://portal-int.sozialinfo.ch";
    return (r, o) => (b(), D("footer", SS, [
      o[0] || (o[0] = O("div", {
        id: "footer-heading",
        class: "sr-only",
        role: "heading",
        "aria-level": "2"
      }, " Footer ", -1)),
      O("div", ES, [
        x(c(Ri), { class: "pt-8 lg:pt-16" }, {
          default: y(() => [
            O("div", OS, [
              O("ul", null, [
                (b(!0), D(Me, null, it(c(kS)(c(t)), (i, a) => (b(), D("li", {
                  key: a,
                  class: "pb-4 text-base font-bold text-primary last:pb-0"
                }, [
                  O("a", {
                    href: i.url
                  }, U(i.title), 9, TS)
                ]))), 128))
              ]),
              O("div", AS, [
                E(r.$slots, "newsletter")
              ]),
              x(c(gg), {
                class: "pb-4 lg:hidden",
                social: c(mg)
              }, null, 8, ["social"])
            ]),
            O("div", MS, [
              O("div", NS, [
                O("div", PS, [
                  x(c(gg), { social: c(mg) }, null, 8, ["social"]),
                  x(c(tp), {
                    group: c(ep)(c(t)).quicklinks
                  }, null, 8, ["group"])
                ]),
                O("div", DS, [
                  x(c(tp), {
                    group: c(ep)(c(t)).orgs
                  }, null, 8, ["group"]),
                  x(c(tp), {
                    group: c(ep)(c(t)).about
                  }, null, 8, ["group"])
                ])
              ]),
              O("div", IS, [
                E(r.$slots, "newsletter")
              ])
            ])
          ]),
          _: 3
        }),
        E(r.$slots, "secondary")
      ])
    ]));
  }
}), RS = { class: "mt-10 sm:mt-0" }, BS = {
  role: "list",
  class: "space-y-4"
}, LS = { class: "font-bold text-primary" }, FS = ["href"], VS = ["href"], tp = /* @__PURE__ */ _({
  __name: "FooterBlock",
  props: {
    group: {}
  },
  setup(n) {
    return (e, t) => (b(), D("div", RS, [
      O("ul", BS, [
        O("li", LS, [
          e.group.url ? (b(), D("a", {
            key: 0,
            href: e.group.url
          }, U(e.group.title), 9, FS)) : (b(), D(Me, { key: 1 }, [
            K(U(e.group.title), 1)
          ], 64))
        ]),
        (b(!0), D(Me, null, it(e.group.items, (r, o) => (b(), D("li", { key: o }, [
          O("a", {
            href: r.url
          }, U(r.title), 9, VS)
        ]))), 128))
      ])
    ]));
  }
}), zS = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function jS(n, e) {
  return b(), D("svg", zS, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      d: "M0 12.923V1.077A1.077 1.077 0 0 1 1.077 0h11.846A1.077 1.077 0 0 1 14 1.077v11.846A1.077 1.077 0 0 1 12.923 14h-3.23V8.895h.764a.657.657 0 0 0 .657-.657V7.41a.655.655 0 0 0-.657-.657h-.722V5.74c0-.905.41-.905.819-.905h.527a.6.6 0 0 0 .464-.193a.63.63 0 0 0 .194-.464v-.796a.67.67 0 0 0-.647-.69H9.854a2.498 2.498 0 0 0-2.574 2.8v1.26h-.69a.657.657 0 0 0-.667.657v.83a.657.657 0 0 0 .668.656h.689V14H1.077A1.077 1.077 0 0 1 0 12.923"
    }, null, -1)
  ]));
}
const HS = { name: "streamline-facebook-1-solid", render: jS }, US = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function KS(n, e) {
  return b(), D("svg", US, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.39.787A2.604 2.604 0 0 0 .786 3.39v6.944a2.604 2.604 0 0 0 2.604 2.604h6.944a2.604 2.604 0 0 0 2.603-2.604V3.39A2.604 2.604 0 0 0 10.334.787zm7.693 2.607a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0m-4.22 1.388a2.08 2.08 0 1 0 0 4.16a2.08 2.08 0 0 0 0-4.16m-3.081 2.08a3.08 3.08 0 1 1 6.16 0a3.08 3.08 0 0 1-6.16 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const WS = { name: "streamline-instagram-solid", render: KS }, qS = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function GS(n, e) {
  return b(), D("svg", qS, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.913 2.362c.26-.268.403-.626.4-.998A1.417 1.417 0 0 0 1.928 0A1.43 1.43 0 0 0 .532 1.364a1.45 1.45 0 0 0 1.396 1.428a1.42 1.42 0 0 0 .985-.43M1.67 4.63c-.587-.013-.987-.022-.987.696v7.992c0 .703.382.689.932.668q.15-.007.314-.008q.165.001.314.008c.548.02.922.035.922-.668V5.327c0-.718-.392-.71-.976-.696a11 11 0 0 1-.519 0Zm4.084.015c-.266.053-.437.223-.437.681v7.992c0 .703.367.689.918.668q.15-.007.318-.008q.168.001.319.008c.554.02.928.035.928-.668V9.056a1.545 1.545 0 0 1 1.577-1.695a1.534 1.534 0 0 1 1.62 1.663v4.261c0 .704.366.69.917.669q.15-.007.318-.008q.168.001.319.008c.551.02.917.035.917-.668V7.83a3.195 3.195 0 0 0-3.388-3.335a2.67 2.67 0 0 0-2.387 1.066c.011-.394-.117-.916-.436-.916c-.092 0-.233-.005-.393-.01c-.4-.012-.92-.028-1.11.01",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const JS = { name: "streamline-linkedin-solid", render: GS }, ZS = {
  role: "list",
  class: ""
}, YS = { class: "flex gap-2" }, XS = { class: "sr-only" }, QS = "https://maps.app.goo.gl/phnWhTi2FSuCiR1a8", gg = /* @__PURE__ */ _({
  __name: "FooterContact",
  props: {
    social: {}
  },
  setup(n) {
    const e = {
      facebook: HS,
      instagram: WS,
      linkedin: JS
    };
    return (t, r) => (b(), D("ul", ZS, [
      r[1] || (r[1] = O("li", { class: "font-bold text-primary" }, " Geschäftsstelle Sozialinfo ", -1)),
      O("li", { class: "whitespace-nowrap pb-4" }, [
        O("a", {
          href: QS,
          target: "_blank"
        }, r[0] || (r[0] = [
          K(" Schwarztorstrasse 26"),
          O("br", null, null, -1),
          K(" 3007 Bern ")
        ]))
      ]),
      r[2] || (r[2] = O("li", null, [
        O("a", { href: "tel:+41313808310" }, " +41 31 380 83 10 ")
      ], -1)),
      r[3] || (r[3] = O("li", { class: "pb-6" }, [
        O("a", { href: "mailto:geschaeftsstelle@sozialinfo.ch" }, " geschaeftsstelle@sozialinfo.ch ")
      ], -1)),
      O("li", null, [
        O("div", YS, [
          (b(!0), D(Me, null, it(t.social, (o) => (b(), k(c(Re), {
            key: o.id,
            as: "a",
            href: o.url,
            variant: "outline",
            class: "rounded-full border p-2 text-primary",
            rel: "noopener",
            target: "_blank"
          }, {
            default: y(() => [
              O("span", XS, U(o.label), 1),
              (b(), k(Qt(e[o.id]), {
                "size-6": "",
                "aria-hidden": "true"
              }))
            ]),
            _: 2
          }, 1032, ["href"]))), 128))
        ])
      ])
    ]));
  }
}), eE = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function tE(n, e) {
  return b(), D("svg", eE, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.9.5a.4.4 0 0 0-.8 0v.6h-.6a.4.4 0 1 0 0 .8h.6v.6a.4.4 0 1 0 .8 0v-.6h.6a.4.4 0 0 0 0-.8h-.6zm3 3a.4.4 0 1 0-.8 0v.6h-.6a.4.4 0 1 0 0 .8h.6v.6a.4.4 0 1 0 .8 0v-.6h.6a.4.4 0 0 0 0-.8h-.6zm-4 3a.4.4 0 1 0-.8 0v.6H.5a.4.4 0 1 0 0 .8h.6v.6a.4.4 0 0 0 .8 0v-.6h.6a.4.4 0 0 0 0-.8h-.6zM8.544.982l-.298-.04c-.213-.024-.34.224-.217.4q.211.305.389.632A6.602 6.602 0 0 1 2.96 11.69c-.215.012-.334.264-.184.417q.103.105.21.206l.072.066l.26.226l.188.148l.121.09l.187.131l.176.115q.18.115.37.217l.264.135l.26.12l.303.122l.244.086a6.6 6.6 0 0 0 1.103.26l.317.04l.267.02q.19.011.384.011a6.6 6.6 0 0 0 6.56-7.339l-.038-.277a6.6 6.6 0 0 0-.384-1.415l-.113-.268l-.077-.166l-.074-.148a6.6 6.6 0 0 0-.546-.883l-.153-.2l-.199-.24l-.163-.18l-.12-.124l-.16-.158l-.223-.2l-.32-.26l-.245-.177l-.292-.19l-.321-.186l-.328-.165l-.113-.052l-.24-.101l-.276-.104l-.252-.082l-.325-.09l-.265-.06zm1.86 4.318a7.6 7.6 0 0 0-.572-2.894a5.601 5.601 0 1 1-4.748 10.146a7.6 7.6 0 0 0 3.66-2.51a.749.749 0 0 0 1.355-.442a.75.75 0 0 0-.584-.732q.093-.174.178-.355A1.25 1.25 0 1 0 10.35 6.2q.052-.442.052-.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const nE = { name: "radix-icons-moon", render: tE }, rE = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function oE(n, e) {
  return b(), D("svg", rE, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5M2.197 2.197a.5.5 0 0 1 .707 0L4.318 3.61a.5.5 0 0 1-.707.707L2.197 2.904a.5.5 0 0 1 0-.707M.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm1.697 5.803a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 1 1 .707.707l-1.414 1.414a.5.5 0 0 1-.707 0M12.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm-1.818-2.682a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 1 1 .707.707L11.39 4.318a.5.5 0 0 1-.707 0M8 12.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm2.682-1.818a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707l-1.414-1.414a.5.5 0 0 1 0-.707M5.5 7.5a2 2 0 1 1 4 0a2 2 0 0 1-4 0m2-3a3 3 0 1 0 0 6a3 3 0 0 0 0-6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const iE = { name: "radix-icons-sun", render: oE }, aE = { class: "border-sm inline-flex rounded-md border-muted bg-muted" }, sE = /* @__PURE__ */ _({
  __name: "ThemeSwitch",
  setup(n) {
    const e = B(!1);
    Ge(() => {
      document.documentElement.getAttribute("data-theme") === "dark" ? e.value = !0 : e.value = !1;
    });
    function t(r) {
      const o = document.documentElement;
      e.value = r, o.setAttribute("data-theme", r ? "dark" : "light");
      const i = window.location.hostname.toLowerCase().includes("sozialinfo.ch") ? ".sozialinfo.ch" : window.location.hostname;
      document.cookie = `theme=${r ? "dark" : "light"}; path=/; domain=${i}; max-age=${60 * 60 * 24 * 365}`;
    }
    return (r, o) => {
      const i = $m("id");
      return hr((b(), D("div", aE, [
        x(c(u3), {
          checked: e.value,
          class: "group peer relative inline-flex h-8 w-16 shrink-0 cursor-pointer items-center rounded-full border transition-colors",
          "onUpdate:checked": o[0] || (o[0] = (a) => t(a))
        }, {
          default: y(() => [
            x(c(iE), {
              class: "pointer-events-none absolute left-[8px] z-10 size-4 text-white",
              "aria-label": "light mode"
            }),
            x(c(nE), {
              class: "pointer-events-none absolute right-[7px] z-10 size-4 text-white",
              "aria-label": "dark mode"
            }),
            x(c(c3), { class: "pointer-events-none block size-6 rounded-full bg-primary shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-8.5 data-[state=unchecked]:translate-x-1" })
          ]),
          _: 1
        }, 8, ["checked"])
      ])), [
        [i]
      ]);
    };
  }
}), lE = { class: "bg-muted" }, dE = { class: "w-full py-8 md:py-12" }, uE = { class: "flex flex-wrap justify-center gap-4 md:justify-between" }, cE = { class: "flex flex-wrap justify-center gap-4 md:gap-8" }, fE = { class: "flex w-full justify-center md:w-auto" }, fJ = /* @__PURE__ */ _({
  __name: "FooterSecondary",
  setup(n) {
    const e = B(!1);
    return (t, r) => (b(), D("div", lE, [
      x(c(Ri), null, {
        default: y(() => [
          O("div", dE, [
            O("div", uE, [
              O("div", cE, [
                (b(!0), D(Me, null, it(c(_S), (o, i) => (b(), D("div", { key: i }, [
                  x(c(Re), {
                    as: "a",
                    variant: "link",
                    href: o.url,
                    class: "text-sm text-foreground md:text-base"
                  }, {
                    default: y(() => [
                      K(U(o.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]))), 128))
              ]),
              O("div", fE, [
                x(c(sE), {
                  checked: e.value,
                  "onUpdate:checked": r[0] || (r[0] = (o) => e.value = o)
                }, null, 8, ["checked"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]));
  }
}), pE = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function hE(n, e) {
  return b(), D("svg", pE, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.637 1.198a1 1 0 0 1 .134 1.408l-8.04 9.73l-.003.002a1.92 1.92 0 0 1-1.5.693a1.92 1.92 0 0 1-1.499-.748l-.001-.002L.21 9.045a1 1 0 1 1 1.578-1.228l2.464 3.167l7.976-9.652a1 1 0 0 1 1.408-.134Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mE = { name: "streamline-check-solid", render: hE }, nf = /* @__PURE__ */ _({
  __name: "Checkbox",
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: [Boolean, String] },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    value: {},
    id: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["update:checked"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(w7), j(c(i), {
      class: c(G)(
        `
        peer size-7 flex-none rounded-checkbox border border-primary/20
        data-[state=checked]:border-primary data-[state=checked]:bg-primary
        data-[state=unchecked]:aria-[invalid=true]:border-destructive
        disabled:bg-muted disabled:opacity-30
      `,
        ...c(Ia),
        t.class
      )
    }), {
      default: y(() => [
        x(c(x7), { class: "flex items-center justify-center text-primary-foreground" }, {
          default: y(() => [
            x(c(mE), { class: "size-3" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function pJ(n, e = "Please check the fields in this group") {
  return n.refine(
    (t) => {
      try {
        return n.parse(t), !0;
      } catch {
        return !1;
      }
    },
    {
      message: e
      // Note: No path specified so error applies to entire schema
    }
  );
}
/**
  * vee-validate v4.15.0
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
function Zt(n) {
  return typeof n == "function";
}
function y3(n) {
  return n == null;
}
const ei = (n) => n !== null && !!n && typeof n == "object" && !Array.isArray(n);
function a0(n) {
  return Number(n) >= 0;
}
function gE(n) {
  const e = parseFloat(n);
  return isNaN(e) ? n : e;
}
function vE(n) {
  return typeof n == "object" && n !== null;
}
function yE(n) {
  return n == null ? n === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(n);
}
function vg(n) {
  if (!vE(n) || yE(n) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(n) === null)
    return !0;
  let e = n;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(n) === e;
}
function Cl(n, e) {
  return Object.keys(e).forEach((t) => {
    if (vg(e[t]) && vg(n[t])) {
      n[t] || (n[t] = {}), Cl(n[t], e[t]);
      return;
    }
    n[t] = e[t];
  }), n;
}
function Is(n) {
  const e = n.split(".");
  if (!e.length)
    return "";
  let t = String(e[0]);
  for (let r = 1; r < e.length; r++) {
    if (a0(e[r])) {
      t += `[${e[r]}]`;
      continue;
    }
    t += `.${e[r]}`;
  }
  return t;
}
const bE = {};
function $E(n) {
  return bE[n];
}
function yg(n, e, t) {
  typeof t.value == "object" && (t.value = dt(t.value)), !t.enumerable || t.get || t.set || !t.configurable || !t.writable || e === "__proto__" ? Object.defineProperty(n, e, t) : n[e] = t.value;
}
function dt(n) {
  if (typeof n != "object")
    return n;
  var e = 0, t, r, o, i = Object.prototype.toString.call(n);
  if (i === "[object Object]" ? o = Object.create(n.__proto__ || null) : i === "[object Array]" ? o = Array(n.length) : i === "[object Set]" ? (o = /* @__PURE__ */ new Set(), n.forEach(function(a) {
    o.add(dt(a));
  })) : i === "[object Map]" ? (o = /* @__PURE__ */ new Map(), n.forEach(function(a, s) {
    o.set(dt(s), dt(a));
  })) : i === "[object Date]" ? o = /* @__PURE__ */ new Date(+n) : i === "[object RegExp]" ? o = new RegExp(n.source, n.flags) : i === "[object DataView]" ? o = new n.constructor(dt(n.buffer)) : i === "[object ArrayBuffer]" ? o = n.slice(0) : i.slice(-6) === "Array]" && (o = new n.constructor(n)), o) {
    for (r = Object.getOwnPropertySymbols(n); e < r.length; e++)
      yg(o, r[e], Object.getOwnPropertyDescriptor(n, r[e]));
    for (e = 0, r = Object.getOwnPropertyNames(n); e < r.length; e++)
      Object.hasOwnProperty.call(o, t = r[e]) && o[t] === n[t] || yg(o, t, Object.getOwnPropertyDescriptor(n, t));
  }
  return o || n;
}
const bs = Symbol("vee-validate-form"), wE = Symbol("vee-validate-form-context"), rf = Symbol("vee-validate-field-instance"), Eu = Symbol("Default empty value"), b3 = typeof window < "u";
function fh(n) {
  return Zt(n) && !!n.__locatorRef;
}
function lr(n) {
  return !!n && Zt(n.parse) && n.__type === "VVTypedSchema";
}
function Ou(n) {
  return !!n && Zt(n.validate);
}
function hd(n) {
  return n === "checkbox" || n === "radio";
}
function xE(n) {
  return ei(n) || Array.isArray(n);
}
function CE(n) {
  return Array.isArray(n) ? n.length === 0 : ei(n) && Object.keys(n).length === 0;
}
function md(n) {
  return /^\[.+\]$/i.test(n);
}
function kE(n) {
  return $3(n) && n.multiple;
}
function $3(n) {
  return n.tagName === "SELECT";
}
function _E(n, e) {
  const t = ![!1, null, void 0, 0].includes(e.multiple) && !Number.isNaN(e.multiple);
  return n === "select" && "multiple" in e && t;
}
function SE(n, e) {
  return !_E(n, e) && e.type !== "file" && !hd(e.type);
}
function w3(n) {
  return s0(n) && n.target && "submit" in n.target;
}
function s0(n) {
  return n ? !!(typeof Event < "u" && Zt(Event) && n instanceof Event || n && n.srcElement) : !1;
}
function bg(n, e) {
  return e in n && n[e] !== Eu;
}
function pn(n, e) {
  if (n === e)
    return !0;
  if (n && e && typeof n == "object" && typeof e == "object") {
    if (n.constructor !== e.constructor)
      return !1;
    var t, r, o;
    if (Array.isArray(n)) {
      if (t = n.length, t != e.length)
        return !1;
      for (r = t; r-- !== 0; )
        if (!pn(n[r], e[r]))
          return !1;
      return !0;
    }
    if (n instanceof Map && e instanceof Map) {
      if (n.size !== e.size)
        return !1;
      for (r of n.entries())
        if (!e.has(r[0]))
          return !1;
      for (r of n.entries())
        if (!pn(r[1], e.get(r[0])))
          return !1;
      return !0;
    }
    if (wg(n) && wg(e))
      return !(n.size !== e.size || n.name !== e.name || n.lastModified !== e.lastModified || n.type !== e.type);
    if (n instanceof Set && e instanceof Set) {
      if (n.size !== e.size)
        return !1;
      for (r of n.entries())
        if (!e.has(r[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(n) && ArrayBuffer.isView(e)) {
      if (t = n.length, t != e.length)
        return !1;
      for (r = t; r-- !== 0; )
        if (n[r] !== e[r])
          return !1;
      return !0;
    }
    if (n.constructor === RegExp)
      return n.source === e.source && n.flags === e.flags;
    if (n.valueOf !== Object.prototype.valueOf)
      return n.valueOf() === e.valueOf();
    if (n.toString !== Object.prototype.toString)
      return n.toString() === e.toString();
    if (o = Object.keys(n), t = o.length - $g(n, o), t !== Object.keys(e).length - $g(e, Object.keys(e)))
      return !1;
    for (r = t; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, o[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      var i = o[r];
      if (!pn(n[i], e[i]))
        return !1;
    }
    return !0;
  }
  return n !== n && e !== e;
}
function $g(n, e) {
  let t = 0;
  for (let o = e.length; o-- !== 0; ) {
    var r = e[o];
    n[r] === void 0 && t++;
  }
  return t;
}
function wg(n) {
  return b3 ? n instanceof File : !1;
}
function of(n) {
  return md(n) ? n.replace(/\[|\]/gi, "") : n;
}
function xn(n, e, t) {
  return n ? md(e) ? n[of(e)] : (e || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((o, i) => xE(o) && i in o ? o[i] : t, n) : t;
}
function Sr(n, e, t) {
  if (md(e)) {
    n[of(e)] = t;
    return;
  }
  const r = e.split(/\.|\[(\d+)\]/).filter(Boolean);
  let o = n;
  for (let i = 0; i < r.length; i++) {
    if (i === r.length - 1) {
      o[r[i]] = t;
      return;
    }
    (!(r[i] in o) || y3(o[r[i]])) && (o[r[i]] = a0(r[i + 1]) ? [] : {}), o = o[r[i]];
  }
}
function np(n, e) {
  if (Array.isArray(n) && a0(e)) {
    n.splice(Number(e), 1);
    return;
  }
  ei(n) && delete n[e];
}
function xg(n, e) {
  if (md(e)) {
    delete n[of(e)];
    return;
  }
  const t = e.split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = n;
  for (let i = 0; i < t.length; i++) {
    if (i === t.length - 1) {
      np(r, t[i]);
      break;
    }
    if (!(t[i] in r) || y3(r[t[i]]))
      break;
    r = r[t[i]];
  }
  const o = t.map((i, a) => xn(n, t.slice(0, a).join(".")));
  for (let i = o.length - 1; i >= 0; i--)
    if (CE(o[i])) {
      if (i === 0) {
        np(n, t[0]);
        continue;
      }
      np(o[i - 1], t[i - 1]);
    }
}
function bn(n) {
  return Object.keys(n);
}
function af(n, e = void 0) {
  const t = sn();
  return t?.provides[n] || Kn(n, e);
}
function EE(n) {
  N2(`[vee-validate]: ${n}`);
}
function Cg(n, e, t) {
  if (Array.isArray(n)) {
    const r = [...n], o = r.findIndex((i) => pn(i, e));
    return o >= 0 ? r.splice(o, 1) : r.push(e), r;
  }
  return pn(n, e) ? t : e;
}
function OE(n, e) {
  let t, r;
  return function(...o) {
    const i = this;
    return t || (t = !0, setTimeout(() => t = !1, e), r = n.apply(i, o)), r;
  };
}
function kg(n, e = 0) {
  let t = null, r = [];
  return function(...o) {
    return t && clearTimeout(t), t = setTimeout(() => {
      const i = n(...o);
      r.forEach((a) => a(i)), r = [];
    }, e), new Promise((i) => r.push(i));
  };
}
function TE(n, e) {
  return ei(e) && e.number ? gE(n) : n;
}
function ph(n, e) {
  let t;
  return async function(...o) {
    const i = n(...o);
    t = i;
    const a = await i;
    return i !== t ? a : (t = void 0, e(a, o));
  };
}
function hh(n) {
  return Array.isArray(n) ? n : n ? [n] : [];
}
function l0(n) {
  const e = af(bs), t = n ? M(() => e?.getPathState(we(n))) : void 0, r = n ? void 0 : Kn(rf);
  return !r && !t?.value && process.env.NODE_ENV !== "production" && EE(`field with name ${we(n)} was not found`), t || r;
}
function Id(n, e) {
  const t = {};
  for (const r in n)
    e.includes(r) || (t[r] = n[r]);
  return t;
}
function AE(n) {
  let e = null, t = [];
  return function(...r) {
    const o = Be(() => {
      if (e !== o)
        return;
      const i = n(...r);
      t.forEach((a) => a(i)), t = [], e = null;
    });
    return e = o, new Promise((i) => t.push(i));
  };
}
function d0(n, e, t) {
  return e.slots.default ? typeof n == "string" || !n ? e.slots.default(t()) : {
    default: () => {
      var r, o;
      return (o = (r = e.slots).default) === null || o === void 0 ? void 0 : o.call(r, t());
    }
  } : e.slots.default;
}
function rp(n) {
  if (x3(n))
    return n._value;
}
function x3(n) {
  return "_value" in n;
}
function ME(n) {
  return n.type === "number" || n.type === "range" ? Number.isNaN(n.valueAsNumber) ? n.value : n.valueAsNumber : n.value;
}
function Tu(n) {
  if (!s0(n))
    return n;
  const e = n.target;
  if (hd(e.type) && x3(e))
    return rp(e);
  if (e.type === "file" && e.files) {
    const t = Array.from(e.files);
    return e.multiple ? t : t[0];
  }
  if (kE(e))
    return Array.from(e.options).filter((t) => t.selected && !t.disabled).map(rp);
  if ($3(e)) {
    const t = Array.from(e.options).find((r) => r.selected);
    return t ? rp(t) : e.value;
  }
  return ME(e);
}
function C3(n) {
  const e = {};
  return Object.defineProperty(e, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), n ? ei(n) && n._$$isNormalized ? n : ei(n) ? Object.keys(n).reduce((t, r) => {
    const o = NE(n[r]);
    return n[r] !== !1 && (t[r] = _g(o)), t;
  }, e) : typeof n != "string" ? e : n.split("|").reduce((t, r) => {
    const o = PE(r);
    return o.name && (t[o.name] = _g(o.params)), t;
  }, e) : e;
}
function NE(n) {
  return n === !0 ? [] : Array.isArray(n) || ei(n) ? n : [n];
}
function _g(n) {
  const e = (t) => typeof t == "string" && t[0] === "@" ? DE(t.slice(1)) : t;
  return Array.isArray(n) ? n.map(e) : n instanceof RegExp ? [n] : Object.keys(n).reduce((t, r) => (t[r] = e(n[r]), t), {});
}
const PE = (n) => {
  let e = [];
  const t = n.split(":")[0];
  return n.includes(":") && (e = n.split(":").slice(1).join(":").split(",")), { name: t, params: e };
};
function DE(n) {
  const e = (t) => {
    var r;
    return (r = xn(t, n)) !== null && r !== void 0 ? r : t[n];
  };
  return e.__locatorRef = n, e;
}
function IE(n) {
  return Array.isArray(n) ? n.filter(fh) : bn(n).filter((e) => fh(n[e])).map((e) => n[e]);
}
const RE = {
  generateMessage: ({ field: n }) => `${n} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let mh = Object.assign({}, RE);
const _i = () => mh, BE = (n) => {
  mh = Object.assign(Object.assign({}, mh), n);
}, LE = BE;
async function k3(n, e, t = {}) {
  const r = t?.bails, o = {
    name: t?.name || "{field}",
    rules: e,
    label: t?.label,
    bails: r ?? !0,
    formData: t?.values || {}
  }, i = await FE(o, n);
  return Object.assign(Object.assign({}, i), { valid: !i.errors.length });
}
async function FE(n, e) {
  const t = n.rules;
  if (lr(t) || Ou(t))
    return zE(e, Object.assign(Object.assign({}, n), { rules: t }));
  if (Zt(t) || Array.isArray(t)) {
    const s = {
      field: n.label || n.name,
      name: n.name,
      label: n.label,
      form: n.formData,
      value: e
    }, l = Array.isArray(t) ? t : [t], d = l.length, u = [];
    for (let f = 0; f < d; f++) {
      const p = l[f], h = await p(e, s);
      if (!(typeof h != "string" && !Array.isArray(h) && h)) {
        if (Array.isArray(h))
          u.push(...h);
        else {
          const g = typeof h == "string" ? h : S3(s);
          u.push(g);
        }
        if (n.bails)
          return {
            errors: u
          };
      }
    }
    return {
      errors: u
    };
  }
  const r = Object.assign(Object.assign({}, n), { rules: C3(t) }), o = [], i = Object.keys(r.rules), a = i.length;
  for (let s = 0; s < a; s++) {
    const l = i[s], d = await jE(r, e, {
      name: l,
      params: r.rules[l]
    });
    if (d.error && (o.push(d.error), n.bails))
      return {
        errors: o
      };
  }
  return {
    errors: o
  };
}
function VE(n) {
  return !!n && n.name === "ValidationError";
}
function _3(n) {
  return {
    __type: "VVTypedSchema",
    async parse(t, r) {
      var o;
      try {
        return {
          output: await n.validate(t, { abortEarly: !1, context: r?.formData || {} }),
          errors: []
        };
      } catch (i) {
        if (!VE(i))
          throw i;
        if (!(!((o = i.inner) === null || o === void 0) && o.length) && i.errors.length)
          return { errors: [{ path: i.path, errors: i.errors }] };
        const a = i.inner.reduce((s, l) => {
          const d = l.path || "";
          return s[d] || (s[d] = { errors: [], path: d }), s[d].errors.push(...l.errors), s;
        }, {});
        return { errors: Object.values(a) };
      }
    }
  };
}
async function zE(n, e) {
  const r = await (lr(e.rules) ? e.rules : _3(e.rules)).parse(n, { formData: e.formData }), o = [];
  for (const i of r.errors)
    i.errors.length && o.push(...i.errors);
  return {
    value: r.value,
    errors: o
  };
}
async function jE(n, e, t) {
  const r = $E(t.name);
  if (!r)
    throw new Error(`No such validator '${t.name}' exists.`);
  const o = HE(t.params, n.formData), i = {
    field: n.label || n.name,
    name: n.name,
    label: n.label,
    value: e,
    form: n.formData,
    rule: Object.assign(Object.assign({}, t), { params: o })
  }, a = await r(e, o, i);
  return typeof a == "string" ? {
    error: a
  } : {
    error: a ? void 0 : S3(i)
  };
}
function S3(n) {
  const e = _i().generateMessage;
  return e ? e(n) : "Field is invalid";
}
function HE(n, e) {
  const t = (r) => fh(r) ? r(e) : r;
  return Array.isArray(n) ? n.map(t) : Object.keys(n).reduce((r, o) => (r[o] = t(n[o]), r), {});
}
async function UE(n, e) {
  const r = await (lr(n) ? n : _3(n)).parse(dt(e), { formData: dt(e) }), o = {}, i = {};
  for (const a of r.errors) {
    const s = a.errors, l = (a.path || "").replace(/\["(\d+)"\]/g, (d, u) => `[${u}]`);
    o[l] = { valid: !s.length, errors: s }, s.length && (i[l] = s[0]);
  }
  return {
    valid: !r.errors.length,
    results: o,
    errors: i,
    values: r.value,
    source: "schema"
  };
}
async function KE(n, e, t) {
  const o = bn(n).map(async (d) => {
    var u, f, p;
    const h = (u = t?.names) === null || u === void 0 ? void 0 : u[d], m = await k3(xn(e, d), n[d], {
      name: h?.name || d,
      label: h?.label,
      values: e,
      bails: (p = (f = t?.bailsMap) === null || f === void 0 ? void 0 : f[d]) !== null && p !== void 0 ? p : !0
    });
    return Object.assign(Object.assign({}, m), { path: d });
  });
  let i = !0;
  const a = await Promise.all(o), s = {}, l = {};
  for (const d of a)
    s[d.path] = {
      valid: d.valid,
      errors: d.errors
    }, d.valid || (i = !1, l[d.path] = d.errors[0]);
  return {
    valid: i,
    results: s,
    errors: l,
    source: "schema"
  };
}
let Sg = 0;
function WE(n, e) {
  const { value: t, initialValue: r, setInitialValue: o } = qE(n, e.modelValue, e.form);
  if (!e.form) {
    let p = function(h) {
      var m;
      "value" in h && (t.value = h.value), "errors" in h && d(h.errors), "touched" in h && (f.touched = (m = h.touched) !== null && m !== void 0 ? m : f.touched), "initialValue" in h && o(h.initialValue);
    };
    const { errors: l, setErrors: d } = ZE(), u = Sg >= Number.MAX_SAFE_INTEGER ? 0 : ++Sg, f = JE(t, r, l, e.schema);
    return {
      id: u,
      path: n,
      value: t,
      initialValue: r,
      meta: f,
      flags: { pendingUnmount: { [u]: !1 }, pendingReset: !1 },
      errors: l,
      setState: p
    };
  }
  const i = e.form.createPathState(n, {
    bails: e.bails,
    label: e.label,
    type: e.type,
    validate: e.validate,
    schema: e.schema
  }), a = M(() => i.errors);
  function s(l) {
    var d, u, f;
    "value" in l && (t.value = l.value), "errors" in l && ((d = e.form) === null || d === void 0 || d.setFieldError(c(n), l.errors)), "touched" in l && ((u = e.form) === null || u === void 0 || u.setFieldTouched(c(n), (f = l.touched) !== null && f !== void 0 ? f : !1)), "initialValue" in l && o(l.initialValue);
  }
  return {
    id: Array.isArray(i.id) ? i.id[i.id.length - 1] : i.id,
    path: n,
    value: t,
    errors: a,
    meta: i,
    initialValue: r,
    flags: i.__flags,
    setState: s
  };
}
function qE(n, e, t) {
  const r = B(c(e));
  function o() {
    return t ? xn(t.initialValues.value, c(n), c(r)) : c(r);
  }
  function i(d) {
    if (!t) {
      r.value = d;
      return;
    }
    t.setFieldInitialValue(c(n), d, !0);
  }
  const a = M(o);
  if (!t)
    return {
      value: B(o()),
      initialValue: a,
      setInitialValue: i
    };
  const s = GE(e, t, a, n);
  return t.stageInitialValue(c(n), s, !0), {
    value: M({
      get() {
        return xn(t.values, c(n));
      },
      set(d) {
        t.setFieldValue(c(n), d, !1);
      }
    }),
    initialValue: a,
    setInitialValue: i
  };
}
function GE(n, e, t, r) {
  return Br(n) ? c(n) : n !== void 0 ? n : xn(e.values, c(r), c(t));
}
function JE(n, e, t, r) {
  const o = M(() => {
    var a, s, l;
    return (l = (s = (a = we(r)) === null || a === void 0 ? void 0 : a.describe) === null || s === void 0 ? void 0 : s.call(a).required) !== null && l !== void 0 ? l : !1;
  }), i = Zo({
    touched: !1,
    pending: !1,
    valid: !0,
    required: o,
    validated: !!c(t).length,
    initialValue: M(() => c(e)),
    dirty: M(() => !pn(c(n), c(e)))
  });
  return De(t, (a) => {
    i.valid = !a.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), i;
}
function ZE() {
  const n = B([]);
  return {
    errors: n,
    setErrors: (e) => {
      n.value = hh(e);
    }
  };
}
const Ys = {}, Xs = {}, Qs = "vee-validate-inspector", $n = {
  error: 12405579,
  success: 448379,
  unknown: 5522283,
  white: 16777215,
  black: 0,
  blue: 218007,
  purple: 12157168,
  orange: 16099682,
  gray: 12304330
};
let Dt = null, ro;
async function E3(n) {
  if (process.env.NODE_ENV !== "production") {
    if (!b3)
      return;
    (await import("./index-e5909cd0.js")).setupDevtoolsPlugin({
      id: "vee-validate-devtools-plugin",
      label: "VeeValidate Plugin",
      packageName: "vee-validate",
      homepage: "https://vee-validate.logaretm.com/v4",
      app: n,
      logo: "https://vee-validate.logaretm.com/v4/logo.png"
    }, (t) => {
      ro = t, t.addInspector({
        id: Qs,
        icon: "rule",
        label: "vee-validate",
        noSelectionText: "Select a vee-validate node to inspect",
        actions: [
          {
            icon: "done_outline",
            tooltip: "Validate selected item",
            action: async () => {
              if (!Dt) {
                console.error("There is not a valid selected vee-validate node or component");
                return;
              }
              if (Dt.type === "field") {
                await Dt.field.validate();
                return;
              }
              if (Dt.type === "form") {
                await Dt.form.validate();
                return;
              }
              Dt.type === "pathState" && await Dt.form.validateField(Dt.state.path);
            }
          },
          {
            icon: "delete_sweep",
            tooltip: "Clear validation state of the selected item",
            action: () => {
              if (!Dt) {
                console.error("There is not a valid selected vee-validate node or component");
                return;
              }
              if (Dt.type === "field") {
                Dt.field.resetField();
                return;
              }
              Dt.type === "form" && Dt.form.resetForm(), Dt.type === "pathState" && Dt.form.resetField(Dt.state.path);
            }
          }
        ]
      }), t.on.getInspectorTree((r) => {
        if (r.inspectorId !== Qs)
          return;
        const o = Object.values(Ys), i = Object.values(Xs);
        r.rootNodes = [
          ...o.map(QE),
          ...i.map((a) => tO(a))
        ];
      }), t.on.getInspectorState((r) => {
        if (r.inspectorId !== Qs)
          return;
        const { form: o, field: i, state: a, type: s } = nO(r.nodeId);
        if (t.unhighlightElement(), o && s === "form") {
          r.state = rO(o), Dt = { type: "form", form: o }, t.highlightElement(o._vm);
          return;
        }
        if (a && s === "pathState" && o) {
          r.state = Eg(a), Dt = { type: "pathState", state: a, form: o };
          return;
        }
        if (i && s === "field") {
          r.state = Eg({
            errors: i.errors.value,
            dirty: i.meta.dirty,
            valid: i.meta.valid,
            touched: i.meta.touched,
            value: i.value.value,
            initialValue: i.meta.initialValue
          }), Dt = { field: i, type: "field" }, t.highlightElement(i._vm);
          return;
        }
        Dt = null, t.unhighlightElement();
      });
    });
  }
}
const Ua = OE(() => {
  setTimeout(async () => {
    await Be(), ro?.sendInspectorState(Qs), ro?.sendInspectorTree(Qs);
  }, 100);
}, 100);
function YE(n) {
  const e = sn();
  if (!ro) {
    const t = e?.appContext.app;
    if (!t)
      return;
    E3(t);
  }
  Ys[n.formId] = Object.assign({}, n), Ys[n.formId]._vm = e, Qn(() => {
    delete Ys[n.formId], Ua();
  }), Ua();
}
function XE(n) {
  const e = sn();
  if (!ro) {
    const t = e?.appContext.app;
    if (!t)
      return;
    E3(t);
  }
  Xs[n.id] = Object.assign({}, n), Xs[n.id]._vm = e, Qn(() => {
    delete Xs[n.id], Ua();
  }), Ua();
}
function QE(n) {
  const { textColor: e, bgColor: t } = T3(n.meta.value.valid), r = {};
  Object.values(n.getAllPathStates()).forEach((a) => {
    Sr(r, we(a.path), eO(a, n));
  });
  function o(a, s = []) {
    const l = [...s].pop();
    return "id" in a ? Object.assign(Object.assign({}, a), { label: l || a.label }) : ei(a) ? {
      id: `${s.join(".")}`,
      label: l || "",
      children: Object.keys(a).map((d) => o(a[d], [...s, d]))
    } : Array.isArray(a) ? {
      id: `${s.join(".")}`,
      label: `${l}[]`,
      children: a.map((d, u) => o(d, [...s, String(u)]))
    } : { id: "", label: "", children: [] };
  }
  const { children: i } = o(r);
  return {
    id: u0(n),
    label: n.name,
    children: i,
    tags: [
      {
        label: "Form",
        textColor: e,
        backgroundColor: t
      },
      {
        label: `${n.getAllPathStates().length} fields`,
        textColor: $n.white,
        backgroundColor: $n.unknown
      }
    ]
  };
}
function eO(n, e) {
  return {
    id: u0(e, n),
    label: we(n.path),
    tags: O3(n.multiple, n.fieldsCount, n.type, n.valid, e)
  };
}
function tO(n, e) {
  return {
    id: u0(e, n),
    label: c(n.name),
    tags: O3(!1, 1, n.type, n.meta.valid, e)
  };
}
function O3(n, e, t, r, o) {
  const { textColor: i, bgColor: a } = T3(r);
  return [
    n ? void 0 : {
      label: "Field",
      textColor: i,
      backgroundColor: a
    },
    o ? void 0 : {
      label: "Standalone",
      textColor: $n.black,
      backgroundColor: $n.gray
    },
    t === "checkbox" ? {
      label: "Checkbox",
      textColor: $n.white,
      backgroundColor: $n.blue
    } : void 0,
    t === "radio" ? {
      label: "Radio",
      textColor: $n.white,
      backgroundColor: $n.purple
    } : void 0,
    n ? {
      label: "Multiple",
      textColor: $n.black,
      backgroundColor: $n.orange
    } : void 0
  ].filter(Boolean);
}
function u0(n, e) {
  const t = e ? "path" in e ? "pathState" : "field" : "form", r = e ? "path" in e ? e?.path : we(e?.name) : "", o = { f: n?.formId, ff: e?.id || r, type: t };
  return btoa(encodeURIComponent(JSON.stringify(o)));
}
function nO(n) {
  try {
    const e = JSON.parse(decodeURIComponent(atob(n))), t = Ys[e.f];
    if (!t && e.ff) {
      const o = Xs[e.ff];
      return o ? {
        type: e.type,
        field: o
      } : {};
    }
    if (!t)
      return {};
    const r = t.getPathState(e.ff);
    return {
      type: e.type,
      form: t,
      state: r
    };
  } catch {
  }
  return {};
}
function Eg(n) {
  return {
    "Field state": [
      { key: "errors", value: n.errors },
      {
        key: "initialValue",
        value: n.initialValue
      },
      {
        key: "currentValue",
        value: n.value
      },
      {
        key: "touched",
        value: n.touched
      },
      {
        key: "dirty",
        value: n.dirty
      },
      {
        key: "valid",
        value: n.valid
      }
    ]
  };
}
function rO(n) {
  const { errorBag: e, meta: t, values: r, isSubmitting: o, isValidating: i, submitCount: a } = n;
  return {
    "Form state": [
      {
        key: "submitCount",
        value: a.value
      },
      {
        key: "isSubmitting",
        value: o.value
      },
      {
        key: "isValidating",
        value: i.value
      },
      {
        key: "touched",
        value: t.value.touched
      },
      {
        key: "dirty",
        value: t.value.dirty
      },
      {
        key: "valid",
        value: t.value.valid
      },
      {
        key: "initialValues",
        value: t.value.initialValues
      },
      {
        key: "currentValues",
        value: r
      },
      {
        key: "errors",
        value: bn(e.value).reduce((s, l) => {
          var d;
          const u = (d = e.value[l]) === null || d === void 0 ? void 0 : d[0];
          return u && (s[l] = u), s;
        }, {})
      }
    ]
  };
}
function T3(n) {
  return {
    bgColor: n ? $n.success : $n.error,
    textColor: n ? $n.black : $n.white
  };
}
function oO(n, e, t) {
  return hd(t?.type) ? aO(n, e, t) : A3(n, e, t);
}
function A3(n, e, t) {
  const { initialValue: r, validateOnMount: o, bails: i, type: a, checkedValue: s, label: l, validateOnValueUpdate: d, uncheckedValue: u, controlled: f, keepValueOnUnmount: p, syncVModel: h, form: m } = iO(t), g = f ? af(bs) : void 0, v = m || g, $ = M(() => Is(we(n))), C = M(() => {
    if (we(v?.schema))
      return;
    const he = c(e);
    return Ou(he) || lr(he) || Zt(he) || Array.isArray(he) ? he : C3(he);
  }), S = !Zt(C.value) && lr(we(e)), { id: w, value: T, initialValue: A, meta: N, setState: z, errors: I, flags: P } = WE($, {
    modelValue: r,
    form: v,
    bails: i,
    label: l,
    type: a,
    validate: C.value ? de : void 0,
    schema: S ? e : void 0
  }), L = M(() => I.value[0]);
  h && sO({
    value: T,
    prop: h,
    handleChange: ne,
    shouldValidate: () => d && !P.pendingReset
  });
  const H = (ce, he = !1) => {
    N.touched = !0, he && Q();
  };
  async function q(ce) {
    var he, ve;
    if (v?.validateSchema) {
      const { results: _e } = await v.validateSchema(ce);
      return (he = _e[we($)]) !== null && he !== void 0 ? he : { valid: !0, errors: [] };
    }
    return C.value ? k3(T.value, C.value, {
      name: we($),
      label: we(l),
      values: (ve = v?.values) !== null && ve !== void 0 ? ve : {},
      bails: i
    }) : { valid: !0, errors: [] };
  }
  const Q = ph(async () => (N.pending = !0, N.validated = !0, q("validated-only")), (ce) => (P.pendingUnmount[Ne.id] || (z({ errors: ce.errors }), N.pending = !1, N.valid = ce.valid), ce)), ae = ph(async () => q("silent"), (ce) => (N.valid = ce.valid, ce));
  function de(ce) {
    return ce?.mode === "silent" ? ae() : Q();
  }
  function ne(ce, he = !0) {
    const ve = Tu(ce);
    Ee(ve, he);
  }
  Ge(() => {
    if (o)
      return Q();
    (!v || !v.validateSchema) && ae();
  });
  function ke(ce) {
    N.touched = ce;
  }
  function ee(ce) {
    var he;
    const ve = ce && "value" in ce ? ce.value : A.value;
    z({
      value: dt(ve),
      initialValue: dt(ve),
      touched: (he = ce?.touched) !== null && he !== void 0 ? he : !1,
      errors: ce?.errors || []
    }), N.pending = !1, N.validated = !1, ae();
  }
  const be = sn();
  function Ee(ce, he = !0) {
    T.value = be && h ? TE(ce, be.props.modelModifiers) : ce, (he ? Q : ae)();
  }
  function nt(ce) {
    z({ errors: Array.isArray(ce) ? ce : [ce] });
  }
  const ct = M({
    get() {
      return T.value;
    },
    set(ce) {
      Ee(ce, d);
    }
  }), Ne = {
    id: w,
    name: $,
    label: l,
    value: ct,
    meta: N,
    errors: I,
    errorMessage: L,
    type: a,
    checkedValue: s,
    uncheckedValue: u,
    bails: i,
    keepValueOnUnmount: p,
    resetField: ee,
    handleReset: () => ee(),
    validate: de,
    handleChange: ne,
    handleBlur: H,
    setState: z,
    setTouched: ke,
    setErrors: nt,
    setValue: Ee
  };
  if (Jn(rf, Ne), Br(e) && typeof c(e) != "function" && De(e, (ce, he) => {
    pn(ce, he) || (N.validated ? Q() : ae());
  }, {
    deep: !0
  }), process.env.NODE_ENV !== "production" && (Ne._vm = sn(), De(() => Object.assign(Object.assign({ errors: I.value }, N), { value: T.value }), Ua, {
    deep: !0
  }), v || XE(Ne)), !v)
    return Ne;
  const st = M(() => {
    const ce = C.value;
    return !ce || Zt(ce) || Ou(ce) || lr(ce) || Array.isArray(ce) ? {} : Object.keys(ce).reduce((he, ve) => {
      const _e = IE(ce[ve]).map((ye) => ye.__locatorRef).reduce((ye, Se) => {
        const se = xn(v.values, Se) || v.values[Se];
        return se !== void 0 && (ye[Se] = se), ye;
      }, {});
      return Object.assign(he, _e), he;
    }, {});
  });
  return De(st, (ce, he) => {
    if (!Object.keys(ce).length)
      return;
    !pn(ce, he) && (N.validated ? Q() : ae());
  }), xr(() => {
    var ce;
    const he = (ce = we(Ne.keepValueOnUnmount)) !== null && ce !== void 0 ? ce : we(v.keepValuesOnUnmount), ve = we($);
    if (he || !v || P.pendingUnmount[Ne.id]) {
      v?.removePathState(ve, w);
      return;
    }
    P.pendingUnmount[Ne.id] = !0;
    const _e = v.getPathState(ve);
    if (Array.isArray(_e?.id) && _e?.multiple ? _e?.id.includes(Ne.id) : _e?.id === Ne.id) {
      if (_e?.multiple && Array.isArray(_e.value)) {
        const Se = _e.value.findIndex((se) => pn(se, we(Ne.checkedValue)));
        if (Se > -1) {
          const se = [..._e.value];
          se.splice(Se, 1), v.setFieldValue(ve, se);
        }
        Array.isArray(_e.id) && _e.id.splice(_e.id.indexOf(Ne.id), 1);
      } else
        v.unsetPathValue(we($));
      v.removePathState(ve, w);
    }
  }), Ne;
}
function iO(n) {
  const e = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: void 0,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    syncVModel: !1,
    controlled: !0
  }), t = !!n?.syncVModel, r = typeof n?.syncVModel == "string" ? n.syncVModel : n?.modelPropName || "modelValue", o = t && !("initialValue" in (n || {})) ? gh(sn(), r) : n?.initialValue;
  if (!n)
    return Object.assign(Object.assign({}, e()), { initialValue: o });
  const i = "valueProp" in n ? n.valueProp : n.checkedValue, a = "standalone" in n ? !n.standalone : n.controlled, s = n?.modelPropName || n?.syncVModel || !1;
  return Object.assign(Object.assign(Object.assign({}, e()), n || {}), {
    initialValue: o,
    controlled: a ?? !0,
    checkedValue: i,
    syncVModel: s
  });
}
function aO(n, e, t) {
  const r = t?.standalone ? void 0 : af(bs), o = t?.checkedValue, i = t?.uncheckedValue;
  function a(s) {
    const l = s.handleChange, d = M(() => {
      const f = we(s.value), p = we(o);
      return Array.isArray(f) ? f.findIndex((h) => pn(h, p)) >= 0 : pn(p, f);
    });
    function u(f, p = !0) {
      var h, m;
      if (d.value === ((h = f?.target) === null || h === void 0 ? void 0 : h.checked)) {
        p && s.validate();
        return;
      }
      const g = we(n), v = r?.getPathState(g), $ = Tu(f);
      let C = (m = we(o)) !== null && m !== void 0 ? m : $;
      r && v?.multiple && v.type === "checkbox" ? C = Cg(xn(r.values, g) || [], C, void 0) : t?.type === "checkbox" && (C = Cg(we(s.value), C, we(i))), l(C, p);
    }
    return Object.assign(Object.assign({}, s), {
      checked: d,
      checkedValue: o,
      uncheckedValue: i,
      handleChange: u
    });
  }
  return a(A3(n, e, t));
}
function sO({ prop: n, value: e, handleChange: t, shouldValidate: r }) {
  const o = sn();
  if (!o || !n) {
    process.env.NODE_ENV !== "production" && console.warn("Failed to setup model events because `useField` was not called in setup.");
    return;
  }
  const i = typeof n == "string" ? n : "modelValue", a = `update:${i}`;
  i in o.props && (De(e, (s) => {
    pn(s, gh(o, i)) || o.emit(a, s);
  }), De(() => gh(o, i), (s) => {
    if (s === Eu && e.value === void 0)
      return;
    const l = s === Eu ? void 0 : s;
    pn(l, e.value) || t(l, r());
  }));
}
function gh(n, e) {
  if (n)
    return n.props[e];
}
const lO = /* @__PURE__ */ _({
  name: "Field",
  inheritAttrs: !1,
  props: {
    as: {
      type: [String, Object],
      default: void 0
    },
    name: {
      type: String,
      required: !0
    },
    rules: {
      type: [Object, String, Function],
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    validateOnBlur: {
      type: Boolean,
      default: void 0
    },
    validateOnChange: {
      type: Boolean,
      default: void 0
    },
    validateOnInput: {
      type: Boolean,
      default: void 0
    },
    validateOnModelUpdate: {
      type: Boolean,
      default: void 0
    },
    bails: {
      type: Boolean,
      default: () => _i().bails
    },
    label: {
      type: String,
      default: void 0
    },
    uncheckedValue: {
      type: null,
      default: void 0
    },
    modelValue: {
      type: null,
      default: Eu
    },
    modelModifiers: {
      type: null,
      default: () => ({})
    },
    "onUpdate:modelValue": {
      type: null,
      default: void 0
    },
    standalone: {
      type: Boolean,
      default: !1
    },
    keepValue: {
      type: Boolean,
      default: void 0
    }
  },
  setup(n, e) {
    const t = Bo(n, "rules"), r = Bo(n, "name"), o = Bo(n, "label"), i = Bo(n, "uncheckedValue"), a = Bo(n, "keepValue"), { errors: s, value: l, errorMessage: d, validate: u, handleChange: f, handleBlur: p, setTouched: h, resetField: m, handleReset: g, meta: v, checked: $, setErrors: C, setValue: S } = oO(r, t, {
      validateOnMount: n.validateOnMount,
      bails: n.bails,
      standalone: n.standalone,
      type: e.attrs.type,
      initialValue: uO(n, e),
      // Only for checkboxes and radio buttons
      checkedValue: e.attrs.value,
      uncheckedValue: i,
      label: o,
      validateOnValueUpdate: n.validateOnModelUpdate,
      keepValueOnUnmount: a,
      syncVModel: !0
    }), w = function(P, L = !0) {
      f(P, L);
    }, T = M(() => {
      const { validateOnInput: I, validateOnChange: P, validateOnBlur: L, validateOnModelUpdate: H } = dO(n);
      function q(ne) {
        p(ne, L), Zt(e.attrs.onBlur) && e.attrs.onBlur(ne);
      }
      function Q(ne) {
        w(ne, I), Zt(e.attrs.onInput) && e.attrs.onInput(ne);
      }
      function ae(ne) {
        w(ne, P), Zt(e.attrs.onChange) && e.attrs.onChange(ne);
      }
      const de = {
        name: n.name,
        onBlur: q,
        onInput: Q,
        onChange: ae
      };
      return de["onUpdate:modelValue"] = (ne) => w(ne, H), de;
    }), A = M(() => {
      const I = Object.assign({}, T.value);
      hd(e.attrs.type) && $ && (I.checked = $.value);
      const P = Og(n, e);
      return SE(P, e.attrs) && (I.value = l.value), I;
    }), N = M(() => Object.assign(Object.assign({}, T.value), { modelValue: l.value }));
    function z() {
      return {
        field: A.value,
        componentField: N.value,
        value: l.value,
        meta: v,
        errors: s.value,
        errorMessage: d.value,
        validate: u,
        resetField: m,
        handleChange: w,
        handleInput: (I) => w(I, !1),
        handleReset: g,
        handleBlur: T.value.onBlur,
        setTouched: h,
        setErrors: C,
        setValue: S
      };
    }
    return e.expose({
      value: l,
      meta: v,
      errors: s,
      errorMessage: d,
      setErrors: C,
      setTouched: h,
      setValue: S,
      reset: m,
      validate: u,
      handleChange: f
    }), () => {
      const I = Qt(Og(n, e)), P = d0(I, e, z);
      return I ? Yt(I, Object.assign(Object.assign({}, e.attrs), A.value), P) : P;
    };
  }
});
function Og(n, e) {
  let t = n.as || "";
  return !n.as && !e.slots.default && (t = "input"), t;
}
function dO(n) {
  var e, t, r, o;
  const { validateOnInput: i, validateOnChange: a, validateOnBlur: s, validateOnModelUpdate: l } = _i();
  return {
    validateOnInput: (e = n.validateOnInput) !== null && e !== void 0 ? e : i,
    validateOnChange: (t = n.validateOnChange) !== null && t !== void 0 ? t : a,
    validateOnBlur: (r = n.validateOnBlur) !== null && r !== void 0 ? r : s,
    validateOnModelUpdate: (o = n.validateOnModelUpdate) !== null && o !== void 0 ? o : l
  };
}
function uO(n, e) {
  return hd(e.attrs.type) ? bg(n, "modelValue") ? n.modelValue : void 0 : bg(n, "modelValue") ? n.modelValue : e.attrs.value;
}
const yr = lO;
let cO = 0;
const Rd = ["bails", "fieldsCount", "id", "multiple", "type", "validate"];
function M3(n) {
  const e = n?.initialValues || {}, t = Object.assign({}, we(e)), r = c(n?.validationSchema);
  return r && lr(r) && Zt(r.cast) ? dt(r.cast(t) || {}) : dt(t);
}
function fO(n) {
  var e;
  const t = cO++, r = n?.name || "Form";
  let o = 0;
  const i = B(!1), a = B(!1), s = B(0), l = [], d = Zo(M3(n)), u = B([]), f = B({}), p = B({}), h = AE(() => {
    p.value = u.value.reduce((V, F) => (V[Is(we(F.path))] = F, V), {});
  });
  function m(V, F) {
    const Z = ne(V);
    if (!Z) {
      typeof V == "string" && (f.value[Is(V)] = hh(F));
      return;
    }
    if (typeof V == "string") {
      const R = Is(V);
      f.value[R] && delete f.value[R];
    }
    Z.errors = hh(F), Z.valid = !Z.errors.length;
  }
  function g(V) {
    bn(V).forEach((F) => {
      m(F, V[F]);
    });
  }
  n?.initialErrors && g(n.initialErrors);
  const v = M(() => {
    const V = u.value.reduce((F, Z) => (Z.errors.length && (F[we(Z.path)] = Z.errors), F), {});
    return Object.assign(Object.assign({}, f.value), V);
  }), $ = M(() => bn(v.value).reduce((V, F) => {
    const Z = v.value[F];
    return Z?.length && (V[F] = Z[0]), V;
  }, {})), C = M(() => u.value.reduce((V, F) => (V[we(F.path)] = { name: we(F.path) || "", label: F.label || "" }, V), {})), S = M(() => u.value.reduce((V, F) => {
    var Z;
    return V[we(F.path)] = (Z = F.bails) !== null && Z !== void 0 ? Z : !0, V;
  }, {})), w = Object.assign({}, n?.initialErrors || {}), T = (e = n?.keepValuesOnUnmount) !== null && e !== void 0 ? e : !1, { initialValues: A, originalInitialValues: N, setInitialValues: z } = hO(u, d, n), I = pO(u, d, N, $), P = M(() => u.value.reduce((V, F) => {
    const Z = xn(d, we(F.path));
    return Sr(V, we(F.path), Z), V;
  }, {})), L = n?.validationSchema;
  function H(V, F) {
    var Z, R;
    const J = M(() => xn(A.value, we(V))), oe = p.value[we(V)], ue = F?.type === "checkbox" || F?.type === "radio";
    if (oe && ue) {
      oe.multiple = !0;
      const Ft = o++;
      return Array.isArray(oe.id) ? oe.id.push(Ft) : oe.id = [oe.id, Ft], oe.fieldsCount++, oe.__flags.pendingUnmount[Ft] = !1, oe;
    }
    const xe = M(() => xn(d, we(V))), Ze = we(V), lt = ee.findIndex((Ft) => Ft === Ze);
    lt !== -1 && ee.splice(lt, 1);
    const tt = M(() => {
      var Ft, Tn, An, ci;
      const fi = we(L);
      if (lr(fi))
        return (Tn = (Ft = fi.describe) === null || Ft === void 0 ? void 0 : Ft.call(fi, we(V)).required) !== null && Tn !== void 0 ? Tn : !1;
      const Eo = we(F?.schema);
      return lr(Eo) && (ci = (An = Eo.describe) === null || An === void 0 ? void 0 : An.call(Eo).required) !== null && ci !== void 0 ? ci : !1;
    }), Et = o++, yt = Zo({
      id: Et,
      path: V,
      touched: !1,
      pending: !1,
      valid: !0,
      validated: !!(!((Z = w[Ze]) === null || Z === void 0) && Z.length),
      required: tt,
      initialValue: J,
      errors: Da([]),
      bails: (R = F?.bails) !== null && R !== void 0 ? R : !1,
      label: F?.label,
      type: F?.type || "default",
      value: xe,
      multiple: !1,
      __flags: {
        pendingUnmount: { [Et]: !1 },
        pendingReset: !1
      },
      fieldsCount: 1,
      validate: F?.validate,
      dirty: M(() => !pn(c(xe), c(J)))
    });
    return u.value.push(yt), p.value[Ze] = yt, h(), $.value[Ze] && !w[Ze] && Be(() => {
      et(Ze, { mode: "silent" });
    }), Br(V) && De(V, (Ft) => {
      h();
      const Tn = dt(xe.value);
      p.value[Ft] = yt, Be(() => {
        Sr(d, Ft, Tn);
      });
    }), yt;
  }
  const q = kg(cn, 5), Q = kg(cn, 5), ae = ph(async (V) => await (V === "silent" ? q() : Q()), (V, [F]) => {
    const Z = bn(he.errorBag.value), J = [
      .../* @__PURE__ */ new Set([...bn(V.results), ...u.value.map((oe) => oe.path), ...Z])
    ].sort().reduce((oe, ue) => {
      var xe;
      const Ze = ue, lt = ne(Ze) || ke(Ze), tt = ((xe = V.results[Ze]) === null || xe === void 0 ? void 0 : xe.errors) || [], Et = we(lt?.path) || Ze, yt = mO({ errors: tt, valid: !tt.length }, oe.results[Et]);
      return oe.results[Et] = yt, yt.valid || (oe.errors[Et] = yt.errors[0]), lt && f.value[Et] && delete f.value[Et], lt ? (lt.valid = yt.valid, F === "silent" || F === "validated-only" && !lt.validated || m(lt, yt.errors), oe) : (m(Et, tt), oe);
    }, {
      valid: V.valid,
      results: {},
      errors: {},
      source: V.source
    });
    return V.values && (J.values = V.values, J.source = V.source), bn(J.results).forEach((oe) => {
      var ue;
      const xe = ne(oe);
      xe && F !== "silent" && (F === "validated-only" && !xe.validated || m(xe, (ue = J.results[oe]) === null || ue === void 0 ? void 0 : ue.errors));
    }), J;
  });
  function de(V) {
    u.value.forEach(V);
  }
  function ne(V) {
    const F = typeof V == "string" ? Is(V) : V;
    return typeof F == "string" ? p.value[F] : F;
  }
  function ke(V) {
    return u.value.filter((Z) => V.startsWith(we(Z.path))).reduce((Z, R) => Z ? R.path.length > Z.path.length ? R : Z : R, void 0);
  }
  let ee = [], be;
  function Ee(V) {
    return ee.push(V), be || (be = Be(() => {
      [...ee].sort().reverse().forEach((Z) => {
        xg(d, Z);
      }), ee = [], be = null;
    })), be;
  }
  function nt(V) {
    return function(Z, R) {
      return function(oe) {
        return oe instanceof Event && (oe.preventDefault(), oe.stopPropagation()), de((ue) => ue.touched = !0), i.value = !0, s.value++, rt().then((ue) => {
          const xe = dt(d);
          if (ue.valid && typeof Z == "function") {
            const Ze = dt(P.value);
            let lt = V ? Ze : xe;
            return ue.values && (lt = ue.source === "schema" ? ue.values : Object.assign({}, lt, ue.values)), Z(lt, {
              evt: oe,
              controlledValues: Ze,
              setErrors: g,
              setFieldError: m,
              setTouched: Pe,
              setFieldTouched: se,
              setValues: ye,
              setFieldValue: ve,
              resetForm: Je,
              resetField: Qe
            });
          }
          !ue.valid && typeof R == "function" && R({
            values: xe,
            evt: oe,
            errors: ue.errors,
            results: ue.results
          });
        }).then((ue) => (i.value = !1, ue), (ue) => {
          throw i.value = !1, ue;
        });
      };
    };
  }
  const Ne = nt(!1);
  Ne.withControlled = nt(!0);
  function st(V, F) {
    const Z = u.value.findIndex((J) => J.path === V && (Array.isArray(J.id) ? J.id.includes(F) : J.id === F)), R = u.value[Z];
    if (!(Z === -1 || !R)) {
      if (Be(() => {
        et(V, { mode: "silent", warn: !1 });
      }), R.multiple && R.fieldsCount && R.fieldsCount--, Array.isArray(R.id)) {
        const J = R.id.indexOf(F);
        J >= 0 && R.id.splice(J, 1), delete R.__flags.pendingUnmount[F];
      }
      (!R.multiple || R.fieldsCount <= 0) && (u.value.splice(Z, 1), ht(V), h(), delete p.value[V]);
    }
  }
  function ce(V) {
    bn(p.value).forEach((F) => {
      F.startsWith(V) && delete p.value[F];
    }), u.value = u.value.filter((F) => !F.path.startsWith(V)), Be(() => {
      h();
    });
  }
  const he = {
    name: r,
    formId: t,
    values: d,
    controlledValues: P,
    errorBag: v,
    errors: $,
    schema: L,
    submitCount: s,
    meta: I,
    isSubmitting: i,
    isValidating: a,
    fieldArrays: l,
    keepValuesOnUnmount: T,
    validateSchema: c(L) ? ae : void 0,
    validate: rt,
    setFieldError: m,
    validateField: et,
    setFieldValue: ve,
    setValues: ye,
    setErrors: g,
    setFieldTouched: se,
    setTouched: Pe,
    resetForm: Je,
    resetField: Qe,
    handleSubmit: Ne,
    useFieldModel: Fn,
    defineInputBinds: kr,
    defineComponentBinds: tr,
    defineField: Kt,
    stageInitialValue: nn,
    unsetInitialValue: ht,
    setFieldInitialValue: Pt,
    createPathState: H,
    getPathState: ne,
    unsetPathValue: Ee,
    removePathState: st,
    initialValues: A,
    getAllPathStates: () => u.value,
    destroyPath: ce,
    isFieldTouched: Ke,
    isFieldDirty: ut,
    isFieldValid: me
  };
  function ve(V, F, Z = !0) {
    const R = dt(F), J = typeof V == "string" ? V : V.path;
    ne(J) || H(J), Sr(d, J, R), Z && et(J);
  }
  function _e(V, F = !0) {
    bn(d).forEach((Z) => {
      delete d[Z];
    }), bn(V).forEach((Z) => {
      ve(Z, V[Z], !1);
    }), F && rt();
  }
  function ye(V, F = !0) {
    Cl(d, V), l.forEach((Z) => Z && Z.reset()), F && rt();
  }
  function Se(V, F) {
    const Z = ne(we(V)) || H(V);
    return M({
      get() {
        return Z.value;
      },
      set(R) {
        var J;
        const oe = we(V);
        ve(oe, R, (J = we(F)) !== null && J !== void 0 ? J : !1);
      }
    });
  }
  function se(V, F) {
    const Z = ne(V);
    Z && (Z.touched = F);
  }
  function Ke(V) {
    const F = ne(V);
    return F ? F.touched : u.value.filter((Z) => Z.path.startsWith(V)).some((Z) => Z.touched);
  }
  function ut(V) {
    const F = ne(V);
    return F ? F.dirty : u.value.filter((Z) => Z.path.startsWith(V)).some((Z) => Z.dirty);
  }
  function me(V) {
    const F = ne(V);
    return F ? F.valid : u.value.filter((Z) => Z.path.startsWith(V)).every((Z) => Z.valid);
  }
  function Pe(V) {
    if (typeof V == "boolean") {
      de((F) => {
        F.touched = V;
      });
      return;
    }
    bn(V).forEach((F) => {
      se(F, !!V[F]);
    });
  }
  function Qe(V, F) {
    var Z;
    const R = F && "value" in F ? F.value : xn(A.value, V), J = ne(V);
    J && (J.__flags.pendingReset = !0), Pt(V, dt(R), !0), ve(V, R, !1), se(V, (Z = F?.touched) !== null && Z !== void 0 ? Z : !1), m(V, F?.errors || []), Be(() => {
      J && (J.__flags.pendingReset = !1);
    });
  }
  function Je(V, F) {
    let Z = dt(V?.values ? V.values : N.value);
    Z = F?.force ? Z : Cl(N.value, Z), Z = lr(L) && Zt(L.cast) ? L.cast(Z) : Z, z(Z, { force: F?.force }), de((R) => {
      var J;
      R.__flags.pendingReset = !0, R.validated = !1, R.touched = ((J = V?.touched) === null || J === void 0 ? void 0 : J[we(R.path)]) || !1, ve(we(R.path), xn(Z, we(R.path)), !1), m(we(R.path), void 0);
    }), F?.force ? _e(Z, !1) : ye(Z, !1), g(V?.errors || {}), s.value = V?.submitCount || 0, Be(() => {
      rt({ mode: "silent" }), de((R) => {
        R.__flags.pendingReset = !1;
      });
    });
  }
  async function rt(V) {
    const F = V?.mode || "force";
    if (F === "force" && de((ue) => ue.validated = !0), he.validateSchema)
      return he.validateSchema(F);
    a.value = !0;
    const Z = await Promise.all(u.value.map((ue) => ue.validate ? ue.validate(V).then((xe) => ({
      key: we(ue.path),
      valid: xe.valid,
      errors: xe.errors,
      value: xe.value
    })) : Promise.resolve({
      key: we(ue.path),
      valid: !0,
      errors: [],
      value: void 0
    })));
    a.value = !1;
    const R = {}, J = {}, oe = {};
    for (const ue of Z)
      R[ue.key] = {
        valid: ue.valid,
        errors: ue.errors
      }, ue.value && Sr(oe, ue.key, ue.value), ue.errors.length && (J[ue.key] = ue.errors[0]);
    return {
      valid: Z.every((ue) => ue.valid),
      results: R,
      errors: J,
      values: oe,
      source: "fields"
    };
  }
  async function et(V, F) {
    var Z;
    const R = ne(V);
    if (R && F?.mode !== "silent" && (R.validated = !0), L) {
      const { results: oe } = await ae(F?.mode || "validated-only");
      return oe[V] || { errors: [], valid: !0 };
    }
    return R?.validate ? R.validate(F) : (!R && ((Z = F?.warn) !== null && Z !== void 0 ? Z : !0) && process.env.NODE_ENV !== "production" && N2(`field with path ${V} was not found`), Promise.resolve({ errors: [], valid: !0 }));
  }
  function ht(V) {
    xg(A.value, V);
  }
  function nn(V, F, Z = !1) {
    Pt(V, F), Sr(d, V, F), Z && !n?.initialValues && Sr(N.value, V, dt(F));
  }
  function Pt(V, F, Z = !1) {
    Sr(A.value, V, dt(F)), Z && Sr(N.value, V, dt(F));
  }
  async function cn() {
    const V = c(L);
    if (!V)
      return { valid: !0, results: {}, errors: {}, source: "none" };
    a.value = !0;
    const F = Ou(V) || lr(V) ? await UE(V, d) : await KE(V, d, {
      names: C.value,
      bailsMap: S.value
    });
    return a.value = !1, F;
  }
  const Ln = Ne((V, { evt: F }) => {
    w3(F) && F.target.submit();
  });
  Ge(() => {
    if (n?.initialErrors && g(n.initialErrors), n?.initialTouched && Pe(n.initialTouched), n?.validateOnMount) {
      rt();
      return;
    }
    he.validateSchema && he.validateSchema("silent");
  }), Br(L) && De(L, () => {
    var V;
    (V = he.validateSchema) === null || V === void 0 || V.call(he, "validated-only");
  }), Jn(bs, he), process.env.NODE_ENV !== "production" && (YE(he), De(() => Object.assign(Object.assign({ errors: v.value }, I.value), { values: d, isSubmitting: i.value, isValidating: a.value, submitCount: s.value }), Ua, {
    deep: !0
  }));
  function Kt(V, F) {
    const Z = Zt(F) ? void 0 : F?.label, R = ne(we(V)) || H(V, { label: Z }), J = () => Zt(F) ? F(Id(R, Rd)) : F || {};
    function oe() {
      var tt;
      R.touched = !0, ((tt = J().validateOnBlur) !== null && tt !== void 0 ? tt : _i().validateOnBlur) && et(we(R.path));
    }
    function ue() {
      var tt;
      ((tt = J().validateOnInput) !== null && tt !== void 0 ? tt : _i().validateOnInput) && Be(() => {
        et(we(R.path));
      });
    }
    function xe() {
      var tt;
      ((tt = J().validateOnChange) !== null && tt !== void 0 ? tt : _i().validateOnChange) && Be(() => {
        et(we(R.path));
      });
    }
    const Ze = M(() => {
      const tt = {
        onChange: xe,
        onInput: ue,
        onBlur: oe
      };
      return Zt(F) ? Object.assign(Object.assign({}, tt), F(Id(R, Rd)).props || {}) : F?.props ? Object.assign(Object.assign({}, tt), F.props(Id(R, Rd))) : tt;
    });
    return [Se(V, () => {
      var tt, Et, yt;
      return (yt = (tt = J().validateOnModelUpdate) !== null && tt !== void 0 ? tt : (Et = _i()) === null || Et === void 0 ? void 0 : Et.validateOnModelUpdate) !== null && yt !== void 0 ? yt : !0;
    }), Ze];
  }
  function Fn(V) {
    return Array.isArray(V) ? V.map((F) => Se(F, !0)) : Se(V);
  }
  function kr(V, F) {
    const [Z, R] = Kt(V, F);
    function J() {
      R.value.onBlur();
    }
    function oe(xe) {
      const Ze = Tu(xe);
      ve(we(V), Ze, !1), R.value.onInput();
    }
    function ue(xe) {
      const Ze = Tu(xe);
      ve(we(V), Ze, !1), R.value.onChange();
    }
    return M(() => Object.assign(Object.assign({}, R.value), {
      onBlur: J,
      onInput: oe,
      onChange: ue,
      value: Z.value
    }));
  }
  function tr(V, F) {
    const [Z, R] = Kt(V, F), J = ne(we(V));
    function oe(ue) {
      Z.value = ue;
    }
    return M(() => {
      const ue = Zt(F) ? F(Id(J, Rd)) : F || {};
      return Object.assign({ [ue.model || "modelValue"]: Z.value, [`onUpdate:${ue.model || "modelValue"}`]: oe }, R.value);
    });
  }
  const On = Object.assign(Object.assign({}, he), { values: od(d), handleReset: () => Je(), submitForm: Ln });
  return Jn(wE, On), On;
}
function pO(n, e, t, r) {
  const o = {
    touched: "some",
    pending: "some",
    valid: "every"
  }, i = M(() => !pn(e, c(t)));
  function a() {
    const l = n.value;
    return bn(o).reduce((d, u) => {
      const f = o[u];
      return d[u] = l[f]((p) => p[u]), d;
    }, {});
  }
  const s = Zo(a());
  return vt(() => {
    const l = a();
    s.touched = l.touched, s.valid = l.valid, s.pending = l.pending;
  }), M(() => Object.assign(Object.assign({ initialValues: c(t) }, s), { valid: s.valid && !bn(r.value).length, dirty: i.value }));
}
function hO(n, e, t) {
  const r = M3(t), o = B(r), i = B(dt(r));
  function a(s, l) {
    l?.force ? (o.value = dt(s), i.value = dt(s)) : (o.value = Cl(dt(o.value) || {}, dt(s)), i.value = Cl(dt(i.value) || {}, dt(s))), l?.updateFields && n.value.forEach((d) => {
      if (d.touched)
        return;
      const f = xn(o.value, we(d.path));
      Sr(e, we(d.path), dt(f));
    });
  }
  return {
    initialValues: o,
    originalInitialValues: i,
    setInitialValues: a
  };
}
function mO(n, e) {
  return e ? {
    valid: n.valid && e.valid,
    errors: [...n.errors, ...e.errors]
  } : n;
}
const gO = /* @__PURE__ */ _({
  name: "Form",
  inheritAttrs: !1,
  props: {
    as: {
      type: null,
      default: "form"
    },
    validationSchema: {
      type: Object,
      default: void 0
    },
    initialValues: {
      type: Object,
      default: void 0
    },
    initialErrors: {
      type: Object,
      default: void 0
    },
    initialTouched: {
      type: Object,
      default: void 0
    },
    validateOnMount: {
      type: Boolean,
      default: !1
    },
    onSubmit: {
      type: Function,
      default: void 0
    },
    onInvalidSubmit: {
      type: Function,
      default: void 0
    },
    keepValues: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "Form"
    }
  },
  setup(n, e) {
    const t = Bo(n, "validationSchema"), r = Bo(n, "keepValues"), { errors: o, errorBag: i, values: a, meta: s, isSubmitting: l, isValidating: d, submitCount: u, controlledValues: f, validate: p, validateField: h, handleReset: m, resetForm: g, handleSubmit: v, setErrors: $, setFieldError: C, setFieldValue: S, setValues: w, setFieldTouched: T, setTouched: A, resetField: N } = fO({
      validationSchema: t.value ? t : void 0,
      initialValues: n.initialValues,
      initialErrors: n.initialErrors,
      initialTouched: n.initialTouched,
      validateOnMount: n.validateOnMount,
      keepValuesOnUnmount: r,
      name: n.name
    }), z = v((de, { evt: ne }) => {
      w3(ne) && ne.target.submit();
    }, n.onInvalidSubmit), I = n.onSubmit ? v(n.onSubmit, n.onInvalidSubmit) : z;
    function P(de) {
      s0(de) && de.preventDefault(), m(), typeof e.attrs.onReset == "function" && e.attrs.onReset();
    }
    function L(de, ne) {
      return v(typeof de == "function" && !ne ? de : ne, n.onInvalidSubmit)(de);
    }
    function H() {
      return dt(a);
    }
    function q() {
      return dt(s.value);
    }
    function Q() {
      return dt(o.value);
    }
    function ae() {
      return {
        meta: s.value,
        errors: o.value,
        errorBag: i.value,
        values: a,
        isSubmitting: l.value,
        isValidating: d.value,
        submitCount: u.value,
        controlledValues: f.value,
        validate: p,
        validateField: h,
        handleSubmit: L,
        handleReset: m,
        submitForm: z,
        setErrors: $,
        setFieldError: C,
        setFieldValue: S,
        setValues: w,
        setFieldTouched: T,
        setTouched: A,
        resetForm: g,
        resetField: N,
        getValues: H,
        getMeta: q,
        getErrors: Q
      };
    }
    return e.expose({
      setFieldError: C,
      setErrors: $,
      setFieldValue: S,
      setValues: w,
      setFieldTouched: T,
      setTouched: A,
      resetForm: g,
      validate: p,
      validateField: h,
      resetField: N,
      getValues: H,
      getMeta: q,
      getErrors: Q,
      values: a,
      meta: s,
      errors: o
    }), function() {
      const ne = n.as === "form" ? n.as : n.as ? Qt(n.as) : null, ke = d0(ne, e, ae);
      return ne ? Yt(ne, Object.assign(Object.assign(Object.assign({}, ne === "form" ? {
        // Disables native validation as vee-validate will handle it.
        novalidate: !0
      } : {}), e.attrs), { onSubmit: I, onReset: P }), ke) : ke;
    };
  }
}), hJ = gO, vO = /* @__PURE__ */ _({
  name: "ErrorMessage",
  props: {
    as: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      required: !0
    }
  },
  setup(n, e) {
    const t = Kn(bs, void 0), r = M(() => t?.errors.value[n.name]);
    function o() {
      return {
        message: r.value
      };
    }
    return () => {
      if (!r.value)
        return;
      const i = n.as ? Qt(n.as) : n.as, a = d0(i, e, o), s = Object.assign({ role: "alert" }, e.attrs);
      return !i && (Array.isArray(a) || !a) && a?.length ? a : (Array.isArray(a) || !a) && !a?.length ? Yt(i || "span", s, r.value) : Yt(i, s, a);
    };
  }
}), N3 = vO;
function yO(n) {
  const e = l0(n);
  return M(() => {
    var t, r;
    return e && (r = "meta" in e ? e.meta.dirty : (t = e?.value) === null || t === void 0 ? void 0 : t.dirty) !== null && r !== void 0 ? r : !1;
  });
}
function bO(n) {
  const e = l0(n);
  return M(() => {
    var t, r;
    return e && (r = "meta" in e ? e.meta.touched : (t = e?.value) === null || t === void 0 ? void 0 : t.touched) !== null && r !== void 0 ? r : !1;
  });
}
function $O(n) {
  const e = l0(n);
  return M(() => {
    var t, r;
    return e && (r = "meta" in e ? e.meta.valid : (t = e?.value) === null || t === void 0 ? void 0 : t.valid) !== null && r !== void 0 ? r : !1;
  });
}
function Tg(n) {
  const e = af(bs), t = n ? void 0 : Kn(rf);
  return M(() => n ? e?.errors.value[we(n)] : t?.errorMessage.value);
}
const P3 = Symbol(), D3 = Symbol();
LE({
  validateOnModelUpdate: !1
});
function sf() {
  const n = Kn(rf), e = Kn(P3), t = Kn(D3, void 0);
  if (!n)
    throw new Error("useFormField should be used within <FormField>");
  const { name: r } = n, o = e, i = {
    valid: $O(r),
    isDirty: yO(r),
    isTouched: bO(r),
    error: Tg(r),
    groupError: Tg(t?.groupName ?? ""),
    groupErrorId: t?.groupErrorId,
    isInGroup: !!t
  };
  return {
    id: o,
    name: r,
    formItemId: `${o}-form-item`,
    formDescriptionId: `${o}-form-item-description`,
    formMessageId: `${o}-form-item-message`,
    ...i
  };
}
const Fr = /* @__PURE__ */ _({
  __name: "FormControl",
  setup(n) {
    const { error: e, groupError: t, groupErrorId: r, formItemId: o, formDescriptionId: i, formMessageId: a } = sf(), s = M(() => !!e.value || !!t.value), l = M(() => {
      const d = [];
      return i && d.push(i), r && t.value && d.push(r), a && e.value && d.push(a), d.length > 0 ? d.join(" ") : void 0;
    });
    return (d, u) => (b(), k(c(Hc), {
      id: c(o),
      "aria-describedby": l.value,
      "aria-invalid": s.value
    }, {
      default: y(() => [
        E(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "aria-describedby", "aria-invalid"]));
  }
}), wO = ["id"], _o = /* @__PURE__ */ _({
  __name: "FormDescription",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, { formDescriptionId: t } = sf();
    return (r, o) => (b(), D("p", {
      id: c(t),
      class: fe(c(G)("text-fluid-xxxs text-muted-foreground", e.class))
    }, [
      E(r.$slots, "default")
    ], 10, wO));
  }
}), xO = ["aria-invalid", "aria-describedby"], CO = {
  key: 0,
  class: "mb-2"
}, kO = {
  key: 1,
  class: "mb-4 text-sm text-muted-foreground"
}, _O = { class: "space-y-4" }, mJ = /* @__PURE__ */ _({
  __name: "FormFieldGroup",
  props: {
    name: {},
    label: {},
    description: {},
    fieldNames: {}
  },
  setup(n) {
    const e = n, r = `${zt()}-group-error`;
    return Jn(D3, {
      groupName: e.name,
      groupErrorId: r,
      fieldNames: e.fieldNames
    }), (o, i) => (b(), k(c(yr), {
      name: e.name
    }, {
      default: y(({ errorMessage: a }) => [
        O("fieldset", {
          class: fe(c(G)("w-full", a && `
        rounded-md border border-destructive p-4
      `)),
          "aria-invalid": !!a,
          "aria-describedby": a ? r : void 0
        }, [
          o.label ? (b(), D("legend", CO, [
            x(c(Oe), {
              tag: "h3",
              class: "text-wrap"
            }, {
              default: y(() => [
                K(U(o.label), 1)
              ]),
              _: 1
            })
          ])) : X("", !0),
          o.description ? (b(), D("div", kO, U(o.description), 1)) : X("", !0),
          O("div", _O, [
            E(o.$slots, "default", {
              hasError: !!a,
              errorId: r
            })
          ]),
          a ? (b(), k(c(N3), {
            key: 2,
            id: r,
            as: "div",
            name: we(o.name),
            class: "mt-2 inline-flex items-center justify-center rounded-xs bg-destructive px-4 py-1.5 text-fluid-xxxs text-destructive-foreground"
          }, null, 8, ["name"])) : X("", !0)
        ], 10, xO)
      ]),
      _: 3
    }, 8, ["name"]));
  }
}), I3 = /* @__PURE__ */ new Set(), kn = /* @__PURE__ */ new WeakMap(), Ka = /* @__PURE__ */ new WeakMap(), Fi = /* @__PURE__ */ new WeakMap(), vh = /* @__PURE__ */ new WeakMap(), SO = /* @__PURE__ */ new WeakMap(), Wa = /* @__PURE__ */ new WeakMap(), Au = /* @__PURE__ */ new WeakMap(), Rs = /* @__PURE__ */ new WeakSet();
let ti, c0 = 0, f0 = 0;
const co = "__aa_tgt", kl = "__aa_del", Mu = "__aa_new", EO = (n) => {
  const e = PO(n);
  e && e.forEach((t) => DO(t));
}, OO = (n) => {
  n.forEach((e) => {
    e.target === ti && AO(), kn.has(e.target) && ra(e.target);
  });
};
function TO(n) {
  const e = vh.get(n);
  e?.disconnect();
  let t = kn.get(n), r = 0;
  const o = 5;
  t || (t = qa(n), kn.set(n, t));
  const { offsetWidth: i, offsetHeight: a } = ti, l = [
    t.top - o,
    i - (t.left + o + t.width),
    a - (t.top + o + t.height),
    t.left - o
  ].map((u) => `${-1 * Math.floor(u)}px`).join(" "), d = new IntersectionObserver(() => {
    ++r > 1 && ra(n);
  }, {
    root: ti,
    threshold: 1,
    rootMargin: l
  });
  d.observe(n), vh.set(n, d);
}
function ra(n) {
  clearTimeout(Au.get(n));
  const e = lf(n), t = _l(e) ? 500 : e.duration;
  Au.set(n, setTimeout(async () => {
    const r = Fi.get(n);
    try {
      await r?.finished, kn.set(n, qa(n)), TO(n);
    } catch {
    }
  }, t));
}
function AO() {
  clearTimeout(Au.get(ti)), Au.set(ti, setTimeout(() => {
    I3.forEach((n) => F3(n, (e) => R3(() => ra(e))));
  }, 100));
}
function MO(n) {
  setTimeout(() => {
    SO.set(n, setInterval(() => R3(ra.bind(null, n)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function R3(n) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => n()) : requestAnimationFrame(() => n());
}
let yh, $a;
const NO = typeof window < "u" && "ResizeObserver" in window;
NO && (ti = document.documentElement, yh = new MutationObserver(EO), $a = new ResizeObserver(OO), window.addEventListener("scroll", () => {
  f0 = window.scrollY, c0 = window.scrollX;
}), $a.observe(ti));
function PO(n) {
  return n.reduce((r, o) => [
    ...r,
    ...Array.from(o.addedNodes),
    ...Array.from(o.removedNodes)
  ], []).every((r) => r.nodeName === "#comment") ? !1 : n.reduce((r, o) => {
    if (r === !1)
      return !1;
    if (o.target instanceof Element) {
      if (op(o.target), !r.has(o.target)) {
        r.add(o.target);
        for (let i = 0; i < o.target.children.length; i++) {
          const a = o.target.children.item(i);
          if (a) {
            if (kl in a)
              return !1;
            op(o.target, a), r.add(a);
          }
        }
      }
      if (o.removedNodes.length)
        for (let i = 0; i < o.removedNodes.length; i++) {
          const a = o.removedNodes[i];
          if (kl in a)
            return !1;
          a instanceof Element && (r.add(a), op(o.target, a), Ka.set(a, [
            o.previousSibling,
            o.nextSibling
          ]));
        }
    }
    return r;
  }, /* @__PURE__ */ new Set());
}
function op(n, e) {
  !e && !(co in n) ? Object.defineProperty(n, co, { value: n }) : e && !(co in e) && Object.defineProperty(e, co, { value: n });
}
function DO(n) {
  var e;
  const t = n.isConnected, r = kn.has(n);
  t && Ka.has(n) && Ka.delete(n), Fi.has(n) && ((e = Fi.get(n)) === null || e === void 0 || e.cancel()), Mu in n ? Ag(n) : r && t ? RO(n) : r && !t ? BO(n) : Ag(n);
}
function Er(n) {
  return Number(n.replace(/[^0-9.\-]/g, ""));
}
function IO(n) {
  let e = n.parentElement;
  for (; e; ) {
    if (e.scrollLeft || e.scrollTop)
      return { x: e.scrollLeft, y: e.scrollTop };
    e = e.parentElement;
  }
  return { x: 0, y: 0 };
}
function qa(n) {
  const e = n.getBoundingClientRect(), { x: t, y: r } = IO(n);
  return {
    top: e.top + r,
    left: e.left + t,
    width: e.width,
    height: e.height
  };
}
function B3(n, e, t) {
  let r = e.width, o = e.height, i = t.width, a = t.height;
  const s = getComputedStyle(n);
  if (s.getPropertyValue("box-sizing") === "content-box") {
    const d = Er(s.paddingTop) + Er(s.paddingBottom) + Er(s.borderTopWidth) + Er(s.borderBottomWidth), u = Er(s.paddingLeft) + Er(s.paddingRight) + Er(s.borderRightWidth) + Er(s.borderLeftWidth);
    r -= u, i -= u, o -= d, a -= d;
  }
  return [r, i, o, a].map(Math.round);
}
function lf(n) {
  return co in n && Wa.has(n[co]) ? Wa.get(n[co]) : { duration: 250, easing: "ease-in-out" };
}
function L3(n) {
  if (co in n)
    return n[co];
}
function p0(n) {
  const e = L3(n);
  return e ? Rs.has(e) : !1;
}
function F3(n, ...e) {
  e.forEach((t) => t(n, Wa.has(n)));
  for (let t = 0; t < n.children.length; t++) {
    const r = n.children.item(t);
    r && e.forEach((o) => o(r, Wa.has(r)));
  }
}
function h0(n) {
  return Array.isArray(n) ? n : [n];
}
function _l(n) {
  return typeof n == "function";
}
function RO(n) {
  const e = kn.get(n), t = qa(n);
  if (!p0(n))
    return kn.set(n, t);
  let r;
  if (!e)
    return;
  const o = lf(n);
  if (typeof o != "function") {
    const i = e.left - t.left, a = e.top - t.top, [s, l, d, u] = B3(n, e, t), f = {
      transform: `translate(${i}px, ${a}px)`
    }, p = {
      transform: "translate(0, 0)"
    };
    s !== l && (f.width = `${s}px`, p.width = `${l}px`), d !== u && (f.height = `${d}px`, p.height = `${u}px`), r = n.animate([f, p], {
      duration: o.duration,
      easing: o.easing
    });
  } else {
    const [i] = h0(o(n, "remain", e, t));
    r = new Animation(i), r.play();
  }
  Fi.set(n, r), kn.set(n, t), r.addEventListener("finish", ra.bind(null, n));
}
function Ag(n) {
  Mu in n && delete n[Mu];
  const e = qa(n);
  kn.set(n, e);
  const t = lf(n);
  if (!p0(n))
    return;
  let r;
  if (typeof t != "function")
    r = n.animate([
      { transform: "scale(.98)", opacity: 0 },
      { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
      { transform: "scale(1)", opacity: 1 }
    ], {
      duration: t.duration * 1.5,
      easing: "ease-in"
    });
  else {
    const [o] = h0(t(n, "add", e));
    r = new Animation(o), r.play();
  }
  Fi.set(n, r), r.addEventListener("finish", ra.bind(null, n));
}
function Mg(n, e) {
  var t;
  n.remove(), kn.delete(n), Ka.delete(n), Fi.delete(n), (t = vh.get(n)) === null || t === void 0 || t.disconnect(), setTimeout(() => {
    if (kl in n && delete n[kl], Object.defineProperty(n, Mu, { value: !0, configurable: !0 }), e && n instanceof HTMLElement)
      for (const r in e)
        n.style[r] = "";
  }, 0);
}
function BO(n) {
  var e;
  if (!Ka.has(n) || !kn.has(n))
    return;
  const [t, r] = Ka.get(n);
  Object.defineProperty(n, kl, { value: !0, configurable: !0 });
  const o = window.scrollX, i = window.scrollY;
  if (r && r.parentNode && r.parentNode instanceof Element ? r.parentNode.insertBefore(n, r) : t && t.parentNode ? t.parentNode.appendChild(n) : (e = L3(n)) === null || e === void 0 || e.appendChild(n), !p0(n))
    return Mg(n);
  const [a, s, l, d] = FO(n), u = lf(n), f = kn.get(n);
  (o !== c0 || i !== f0) && LO(n, o, i, u);
  let p, h = {
    position: "absolute",
    top: `${a}px`,
    left: `${s}px`,
    width: `${l}px`,
    height: `${d}px`,
    margin: "0",
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: "100"
  };
  if (!_l(u))
    Object.assign(n.style, h), p = n.animate([
      {
        transform: "scale(1)",
        opacity: 1
      },
      {
        transform: "scale(.98)",
        opacity: 0
      }
    ], { duration: u.duration, easing: "ease-out" });
  else {
    const [m, g] = h0(u(n, "remove", f));
    g?.styleReset !== !1 && (h = g?.styleReset || h, Object.assign(n.style, h)), p = new Animation(m), p.play();
  }
  Fi.set(n, p), p.addEventListener("finish", Mg.bind(null, n, h));
}
function LO(n, e, t, r) {
  const o = c0 - e, i = f0 - t, a = document.documentElement.style.scrollBehavior;
  if (getComputedStyle(ti).scrollBehavior === "smooth" && (document.documentElement.style.scrollBehavior = "auto"), window.scrollTo(window.scrollX + o, window.scrollY + i), !n.parentElement)
    return;
  const l = n.parentElement;
  let d = l.clientHeight, u = l.clientWidth;
  const f = performance.now();
  function p() {
    requestAnimationFrame(() => {
      if (!_l(r)) {
        const h = d - l.clientHeight, m = u - l.clientWidth;
        f + r.duration > performance.now() ? (window.scrollTo({
          left: window.scrollX - m,
          top: window.scrollY - h
        }), d = l.clientHeight, u = l.clientWidth, p()) : document.documentElement.style.scrollBehavior = a;
      }
    });
  }
  p();
}
function FO(n) {
  const e = kn.get(n), [t, , r] = B3(n, e, qa(n));
  let o = n.parentElement;
  for (; o && (getComputedStyle(o).position === "static" || o instanceof HTMLBodyElement); )
    o = o.parentElement;
  o || (o = document.body);
  const i = getComputedStyle(o), a = kn.get(o) || qa(o), s = Math.round(e.top - a.top) - Er(i.borderTopWidth), l = Math.round(e.left - a.left) - Er(i.borderLeftWidth);
  return [s, l, t, r];
}
function VO(n, e = {}) {
  return yh && $a && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && !_l(e) && !e.disrespectUserMotionPreference || (Rs.add(n), getComputedStyle(n).position === "static" && Object.assign(n.style, { position: "relative" }), F3(n, ra, MO, (o) => $a?.observe(o)), _l(e) ? Wa.set(n, e) : Wa.set(n, { duration: 250, easing: "ease-in-out", ...e }), yh.observe(n, { childList: !0 }), I3.add(n))), Object.freeze({
    parent: n,
    enable: () => {
      Rs.add(n);
    },
    disable: () => {
      Rs.delete(n);
    },
    isEnabled: () => Rs.has(n)
  });
}
const zO = {
  mounted: (n, e) => {
    VO(n, e.value || {});
  },
  // ignore ssr see #96:
  getSSRProps: () => ({})
}, jO = zO, br = /* @__PURE__ */ _({
  __name: "FormItem",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, t = B5();
    return Jn(P3, t), (r, o) => hr((b(), D("div", {
      class: fe(c(G)(e.class))
    }, [
      E(r.$slots, "default")
    ], 2)), [
      [c(jO)]
    ]);
  }
}), HO = /* @__PURE__ */ _({
  __name: "Label",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(Bk), j(t.value, {
      class: c(G)(
        `
        leading-none
        peer-disabled:cursor-not-allowed peer-disabled:opacity-30
      `,
        e.class
      )
    }), {
      default: y(() => [
        x(c(Oe), {
          tag: "span",
          paragraph: "label"
        }, {
          default: y(() => [
            E(r.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), m0 = /* @__PURE__ */ _({
  __name: "FormLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, { error: t, formItemId: r } = sf();
    return (o, i) => (b(), k(c(HO), {
      class: fe(c(G)(
        c(t) && "text-destructive",
        e.class
      )),
      for: c(r)
    }, {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "for"]));
  }
}), So = /* @__PURE__ */ _({
  __name: "FormMessage",
  setup(n) {
    const { name: e, formMessageId: t } = sf();
    return (r, o) => (b(), k(c(N3), {
      id: c(t),
      as: "span",
      name: we(c(e)),
      class: "mb-2 inline-flex items-center justify-center rounded-xs bg-destructive px-4 py-1.5 text-fluid-xxxs text-destructive-foreground"
    }, null, 8, ["id", "name"]));
  }
});
var ot;
(function(n) {
  n.assertEqual = (o) => o;
  function e(o) {
  }
  n.assertIs = e;
  function t(o) {
    throw new Error();
  }
  n.assertNever = t, n.arrayToEnum = (o) => {
    const i = {};
    for (const a of o)
      i[a] = a;
    return i;
  }, n.getValidEnumValues = (o) => {
    const i = n.objectKeys(o).filter((s) => typeof o[o[s]] != "number"), a = {};
    for (const s of i)
      a[s] = o[s];
    return n.objectValues(a);
  }, n.objectValues = (o) => n.objectKeys(o).map(function(i) {
    return o[i];
  }), n.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const i = [];
    for (const a in o)
      Object.prototype.hasOwnProperty.call(o, a) && i.push(a);
    return i;
  }, n.find = (o, i) => {
    for (const a of o)
      if (i(a))
        return a;
  }, n.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  function r(o, i = " | ") {
    return o.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  n.joinValues = r, n.jsonStringifyReplacer = (o, i) => typeof i == "bigint" ? i.toString() : i;
})(ot || (ot = {}));
var bh;
(function(n) {
  n.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(bh || (bh = {}));
const ge = ot.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), oo = (n) => {
  switch (typeof n) {
    case "undefined":
      return ge.undefined;
    case "string":
      return ge.string;
    case "number":
      return isNaN(n) ? ge.nan : ge.number;
    case "boolean":
      return ge.boolean;
    case "function":
      return ge.function;
    case "bigint":
      return ge.bigint;
    case "symbol":
      return ge.symbol;
    case "object":
      return Array.isArray(n) ? ge.array : n === null ? ge.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? ge.promise : typeof Map < "u" && n instanceof Map ? ge.map : typeof Set < "u" && n instanceof Set ? ge.set : typeof Date < "u" && n instanceof Date ? ge.date : ge.object;
    default:
      return ge.unknown;
  }
}, te = ot.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), UO = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class In extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, o = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(o);
        else if (a.code === "invalid_return_type")
          o(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          o(a.argumentsError);
        else if (a.path.length === 0)
          r._errors.push(t(a));
        else {
          let s = r, l = 0;
          for (; l < a.path.length; ) {
            const d = a.path[l];
            l === a.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(t(a))) : s[d] = s[d] || { _errors: [] }, s = s[d], l++;
          }
        }
    };
    return o(this), r;
  }
  static assert(e) {
    if (!(e instanceof In))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ot.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const o of this.issues)
      o.path.length > 0 ? (t[o.path[0]] = t[o.path[0]] || [], t[o.path[0]].push(e(o))) : r.push(e(o));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
In.create = (n) => new In(n);
const Ga = (n, e) => {
  let t;
  switch (n.code) {
    case te.invalid_type:
      n.received === ge.undefined ? t = "Required" : t = `Expected ${n.expected}, received ${n.received}`;
      break;
    case te.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(n.expected, ot.jsonStringifyReplacer)}`;
      break;
    case te.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${ot.joinValues(n.keys, ", ")}`;
      break;
    case te.invalid_union:
      t = "Invalid input";
      break;
    case te.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${ot.joinValues(n.options)}`;
      break;
    case te.invalid_enum_value:
      t = `Invalid enum value. Expected ${ot.joinValues(n.options)}, received '${n.received}'`;
      break;
    case te.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case te.invalid_return_type:
      t = "Invalid function return type";
      break;
    case te.invalid_date:
      t = "Invalid date";
      break;
    case te.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (t = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? t = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? t = `Invalid input: must end with "${n.validation.endsWith}"` : ot.assertNever(n.validation) : n.validation !== "regex" ? t = `Invalid ${n.validation}` : t = "Invalid";
      break;
    case te.too_small:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : t = "Invalid input";
      break;
    case te.too_big:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? t = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : t = "Invalid input";
      break;
    case te.custom:
      t = "Invalid input";
      break;
    case te.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case te.not_multiple_of:
      t = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case te.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, ot.assertNever(n);
  }
  return { message: t };
};
let V3 = Ga;
function KO(n) {
  V3 = n;
}
function Nu() {
  return V3;
}
const Pu = (n) => {
  const { data: e, path: t, errorMaps: r, issueData: o } = n, i = [...t, ...o.path || []], a = {
    ...o,
    path: i
  };
  if (o.message !== void 0)
    return {
      ...o,
      path: i,
      message: o.message
    };
  let s = "";
  const l = r.filter((d) => !!d).slice().reverse();
  for (const d of l)
    s = d(a, { data: e, defaultError: s }).message;
  return {
    ...o,
    path: i,
    message: s
  };
}, WO = [];
function pe(n, e) {
  const t = Nu(), r = Pu({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      // contextual error map is first priority
      n.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === Ga ? void 0 : Ga
      // then global default map
    ].filter((o) => !!o)
  });
  n.common.issues.push(r);
}
class ln {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const o of t) {
      if (o.status === "aborted")
        return Ie;
      o.status === "dirty" && e.dirty(), r.push(o.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const o of t) {
      const i = await o.key, a = await o.value;
      r.push({
        key: i,
        value: a
      });
    }
    return ln.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const o of t) {
      const { key: i, value: a } = o;
      if (i.status === "aborted" || a.status === "aborted")
        return Ie;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || o.alwaysSet) && (r[i.value] = a.value);
    }
    return { status: e.value, value: r };
  }
}
const Ie = Object.freeze({
  status: "aborted"
}), wa = (n) => ({ status: "dirty", value: n }), hn = (n) => ({ status: "valid", value: n }), $h = (n) => n.status === "aborted", wh = (n) => n.status === "dirty", Vi = (n) => n.status === "valid", Sl = (n) => typeof Promise < "u" && n instanceof Promise;
function Du(n, e, t, r) {
  if (t === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? n !== e || !r : !e.has(n))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? r : t === "a" ? r.call(n) : r ? r.value : e.get(n);
}
function z3(n, e, t, r, o) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !o)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? n !== e || !o : !e.has(n))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? o.call(n, t) : o ? o.value = t : e.set(n, t), t;
}
var Ce;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e?.message;
})(Ce || (Ce = {}));
var Bs, Ls;
class Vr {
  constructor(e, t, r, o) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Ng = (n, e) => {
  if (Vi(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new In(n.common.issues);
      return this._error = t, this._error;
    }
  };
};
function ze(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: o } = n;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: o } : { errorMap: (a, s) => {
    var l, d;
    const { message: u } = n;
    return a.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? r) !== null && l !== void 0 ? l : s.defaultError } : a.code !== "invalid_type" ? { message: s.defaultError } : { message: (d = u ?? t) !== null && d !== void 0 ? d : s.defaultError };
  }, description: o };
}
class qe {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return oo(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: oo(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ln(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: oo(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Sl(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    var r;
    const o = {
      common: {
        issues: [],
        async: (r = t?.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: t?.errorMap
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: oo(e)
    }, i = this._parseSync({ data: e, path: o.path, parent: o });
    return Ng(o, i);
  }
  "~validate"(e) {
    var t, r;
    const o = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: oo(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: o });
        return Vi(i) ? {
          value: i.value
        } : {
          issues: o.common.issues
        };
      } catch (i) {
        !((r = (t = i?.message) === null || t === void 0 ? void 0 : t.toLowerCase()) === null || r === void 0) && r.includes("encountered") && (this["~standard"].async = !0), o.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: o }).then((i) => Vi(i) ? {
      value: i.value
    } : {
      issues: o.common.issues
    });
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t?.errorMap,
        async: !0
      },
      path: t?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: oo(e)
    }, o = this._parse({ data: e, path: r.path, parent: r }), i = await (Sl(o) ? o : Promise.resolve(o));
    return Ng(r, i);
  }
  refine(e, t) {
    const r = (o) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(o) : t;
    return this._refinement((o, i) => {
      const a = e(o), s = () => i.addIssue({
        code: te.custom,
        ...r(o)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((l) => l ? !0 : (s(), !1)) : a ? !0 : (s(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, o) => e(r) ? !0 : (o.addIssue(typeof t == "function" ? t(r, o) : t), !1));
  }
  _refinement(e) {
    return new $r({
      schema: this,
      typeName: Ae.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return Ir.create(this, this._def);
  }
  nullable() {
    return ii.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return cr.create(this);
  }
  promise() {
    return Za.create(this, this._def);
  }
  or(e) {
    return Al.create([this, e], this._def);
  }
  and(e) {
    return Ml.create(this, e, this._def);
  }
  transform(e) {
    return new $r({
      ...ze(this._def),
      schema: this,
      typeName: Ae.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Ya({
      ...ze(this._def),
      innerType: this,
      defaultValue: t,
      typeName: Ae.ZodDefault
    });
  }
  brand() {
    return new g0({
      typeName: Ae.ZodBranded,
      type: this,
      ...ze(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new Rl({
      ...ze(this._def),
      innerType: this,
      catchValue: t,
      typeName: Ae.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return gd.create(this, e);
  }
  readonly() {
    return Bl.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const qO = /^c[^\s-]{8,}$/i, GO = /^[0-9a-z]+$/, JO = /^[0-9A-HJKMNP-TV-Z]{26}$/i, ZO = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, YO = /^[a-z0-9_-]{21}$/i, XO = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, QO = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, eT = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, tT = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ip;
const nT = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rT = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, oT = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, iT = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, aT = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, sT = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, j3 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", lT = new RegExp(`^${j3}$`);
function H3(n) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return n.precision ? e = `${e}\\.\\d{${n.precision}}` : n.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function dT(n) {
  return new RegExp(`^${H3(n)}$`);
}
function U3(n) {
  let e = `${j3}T${H3(n)}`;
  const t = [];
  return t.push(n.local ? "Z?" : "Z"), n.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function uT(n, e) {
  return !!((e === "v4" || !e) && nT.test(n) || (e === "v6" || !e) && oT.test(n));
}
function cT(n, e) {
  if (!XO.test(n))
    return !1;
  try {
    const [t] = n.split("."), r = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), o = JSON.parse(atob(r));
    return !(typeof o != "object" || o === null || !o.typ || !o.alg || e && o.alg !== e);
  } catch {
    return !1;
  }
}
function fT(n, e) {
  return !!((e === "v4" || !e) && rT.test(n) || (e === "v6" || !e) && iT.test(n));
}
class dr extends qe {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== ge.string) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: te.invalid_type,
        expected: ge.string,
        received: i.parsedType
      }), Ie;
    }
    const r = new ln();
    let o;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, s = e.data.length < i.value;
        (a || s) && (o = this._getOrReturnCtx(e, o), a ? pe(o, {
          code: te.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && pe(o, {
          code: te.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        eT.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "email",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        ip || (ip = new RegExp(tT, "u")), ip.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "emoji",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        ZO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "uuid",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "nanoid")
        YO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "nanoid",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        qO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "cuid",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        GO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "cuid2",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        JO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "ulid",
          code: te.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          o = this._getOrReturnCtx(e, o), pe(o, {
            validation: "url",
            code: te.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "regex",
          code: te.invalid_string,
          message: i.message
        }), r.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), r.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "datetime" ? U3(i).test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: "datetime",
          message: i.message
        }), r.dirty()) : i.kind === "date" ? lT.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: "date",
          message: i.message
        }), r.dirty()) : i.kind === "time" ? dT(i).test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          code: te.invalid_string,
          validation: "time",
          message: i.message
        }), r.dirty()) : i.kind === "duration" ? QO.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "duration",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : i.kind === "ip" ? uT(e.data, i.version) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "ip",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : i.kind === "jwt" ? cT(e.data, i.alg) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "jwt",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : i.kind === "cidr" ? fT(e.data, i.version) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "cidr",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : i.kind === "base64" ? aT.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "base64",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : i.kind === "base64url" ? sT.test(e.data) || (o = this._getOrReturnCtx(e, o), pe(o, {
          validation: "base64url",
          code: te.invalid_string,
          message: i.message
        }), r.dirty()) : ot.assertNever(i);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((o) => e.test(o), {
      validation: t,
      code: te.invalid_string,
      ...Ce.errToObj(r)
    });
  }
  _addCheck(e) {
    return new dr({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Ce.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Ce.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Ce.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Ce.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Ce.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Ce.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Ce.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Ce.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Ce.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Ce.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Ce.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Ce.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Ce.errToObj(e) });
  }
  datetime(e) {
    var t, r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (t = e?.offset) !== null && t !== void 0 ? t : !1,
      local: (r = e?.local) !== null && r !== void 0 ? r : !1,
      ...Ce.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...Ce.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Ce.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Ce.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t?.position,
      ...Ce.errToObj(t?.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Ce.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Ce.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Ce.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Ce.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Ce.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Ce.errToObj(e));
  }
  trim() {
    return new dr({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new dr({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new dr({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
dr.create = (n) => {
  var e;
  return new dr({
    checks: [],
    typeName: Ae.ZodString,
    coerce: (e = n?.coerce) !== null && e !== void 0 ? e : !1,
    ...ze(n)
  });
};
function pT(n, e) {
  const t = (n.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, o = t > r ? t : r, i = parseInt(n.toFixed(o).replace(".", "")), a = parseInt(e.toFixed(o).replace(".", ""));
  return i % a / Math.pow(10, o);
}
class ni extends qe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== ge.number) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: te.invalid_type,
        expected: ge.number,
        received: i.parsedType
      }), Ie;
    }
    let r;
    const o = new ln();
    for (const i of this._def.checks)
      i.kind === "int" ? ot.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), o.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), o.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), o.dirty()) : i.kind === "multipleOf" ? pT(e.data, i.value) !== 0 && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), o.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.not_finite,
        message: i.message
      }), o.dirty()) : ot.assertNever(i);
    return { status: o.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, Ce.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, Ce.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, Ce.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, Ce.toString(t));
  }
  setLimit(e, t, r, o) {
    return new ni({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: Ce.toString(o)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ni({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Ce.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ce.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ce.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ce.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ce.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Ce.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Ce.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ce.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ce.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ot.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
ni.create = (n) => new ni({
  checks: [],
  typeName: Ae.ZodNumber,
  coerce: n?.coerce || !1,
  ...ze(n)
});
class ri extends qe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== ge.bigint)
      return this._getInvalidInput(e);
    let r;
    const o = new ln();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), o.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), o.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), pe(r, {
        code: te.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), o.dirty()) : ot.assertNever(i);
    return { status: o.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return pe(t, {
      code: te.invalid_type,
      expected: ge.bigint,
      received: t.parsedType
    }), Ie;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, Ce.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, Ce.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, Ce.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, Ce.toString(t));
  }
  setLimit(e, t, r, o) {
    return new ri({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: Ce.toString(o)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ri({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ce.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ce.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ce.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ce.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Ce.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
ri.create = (n) => {
  var e;
  return new ri({
    checks: [],
    typeName: Ae.ZodBigInt,
    coerce: (e = n?.coerce) !== null && e !== void 0 ? e : !1,
    ...ze(n)
  });
};
class El extends qe {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== ge.boolean) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.boolean,
        received: r.parsedType
      }), Ie;
    }
    return hn(e.data);
  }
}
El.create = (n) => new El({
  typeName: Ae.ZodBoolean,
  coerce: n?.coerce || !1,
  ...ze(n)
});
class zi extends qe {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== ge.date) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: te.invalid_type,
        expected: ge.date,
        received: i.parsedType
      }), Ie;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: te.invalid_date
      }), Ie;
    }
    const r = new ln();
    let o;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (o = this._getOrReturnCtx(e, o), pe(o, {
        code: te.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (o = this._getOrReturnCtx(e, o), pe(o, {
        code: te.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : ot.assertNever(i);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new zi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Ce.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Ce.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
zi.create = (n) => new zi({
  checks: [],
  coerce: n?.coerce || !1,
  typeName: Ae.ZodDate,
  ...ze(n)
});
class Iu extends qe {
  _parse(e) {
    if (this._getType(e) !== ge.symbol) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.symbol,
        received: r.parsedType
      }), Ie;
    }
    return hn(e.data);
  }
}
Iu.create = (n) => new Iu({
  typeName: Ae.ZodSymbol,
  ...ze(n)
});
class Ol extends qe {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.undefined,
        received: r.parsedType
      }), Ie;
    }
    return hn(e.data);
  }
}
Ol.create = (n) => new Ol({
  typeName: Ae.ZodUndefined,
  ...ze(n)
});
class Tl extends qe {
  _parse(e) {
    if (this._getType(e) !== ge.null) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.null,
        received: r.parsedType
      }), Ie;
    }
    return hn(e.data);
  }
}
Tl.create = (n) => new Tl({
  typeName: Ae.ZodNull,
  ...ze(n)
});
class Ja extends qe {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return hn(e.data);
  }
}
Ja.create = (n) => new Ja({
  typeName: Ae.ZodAny,
  ...ze(n)
});
class Ti extends qe {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return hn(e.data);
  }
}
Ti.create = (n) => new Ti({
  typeName: Ae.ZodUnknown,
  ...ze(n)
});
class bo extends qe {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return pe(t, {
      code: te.invalid_type,
      expected: ge.never,
      received: t.parsedType
    }), Ie;
  }
}
bo.create = (n) => new bo({
  typeName: Ae.ZodNever,
  ...ze(n)
});
class Ru extends qe {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.void,
        received: r.parsedType
      }), Ie;
    }
    return hn(e.data);
  }
}
Ru.create = (n) => new Ru({
  typeName: Ae.ZodVoid,
  ...ze(n)
});
class cr extends qe {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), o = this._def;
    if (t.parsedType !== ge.array)
      return pe(t, {
        code: te.invalid_type,
        expected: ge.array,
        received: t.parsedType
      }), Ie;
    if (o.exactLength !== null) {
      const a = t.data.length > o.exactLength.value, s = t.data.length < o.exactLength.value;
      (a || s) && (pe(t, {
        code: a ? te.too_big : te.too_small,
        minimum: s ? o.exactLength.value : void 0,
        maximum: a ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && t.data.length < o.minLength.value && (pe(t, {
      code: te.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && t.data.length > o.maxLength.value && (pe(t, {
      code: te.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((a, s) => o.type._parseAsync(new Vr(t, a, t.path, s)))).then((a) => ln.mergeArray(r, a));
    const i = [...t.data].map((a, s) => o.type._parseSync(new Vr(t, a, t.path, s)));
    return ln.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new cr({
      ...this._def,
      minLength: { value: e, message: Ce.toString(t) }
    });
  }
  max(e, t) {
    return new cr({
      ...this._def,
      maxLength: { value: e, message: Ce.toString(t) }
    });
  }
  length(e, t) {
    return new cr({
      ...this._def,
      exactLength: { value: e, message: Ce.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
cr.create = (n, e) => new cr({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ae.ZodArray,
  ...ze(e)
});
function ha(n) {
  if (n instanceof wt) {
    const e = {};
    for (const t in n.shape) {
      const r = n.shape[t];
      e[t] = Ir.create(ha(r));
    }
    return new wt({
      ...n._def,
      shape: () => e
    });
  } else
    return n instanceof cr ? new cr({
      ...n._def,
      type: ha(n.element)
    }) : n instanceof Ir ? Ir.create(ha(n.unwrap())) : n instanceof ii ? ii.create(ha(n.unwrap())) : n instanceof zr ? zr.create(n.items.map((e) => ha(e))) : n;
}
class wt extends qe {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = ot.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== ge.object) {
      const d = this._getOrReturnCtx(e);
      return pe(d, {
        code: te.invalid_type,
        expected: ge.object,
        received: d.parsedType
      }), Ie;
    }
    const { status: r, ctx: o } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof bo && this._def.unknownKeys === "strip"))
      for (const d in o.data)
        a.includes(d) || s.push(d);
    const l = [];
    for (const d of a) {
      const u = i[d], f = o.data[d];
      l.push({
        key: { status: "valid", value: d },
        value: u._parse(new Vr(o, f, o.path, d)),
        alwaysSet: d in o.data
      });
    }
    if (this._def.catchall instanceof bo) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: o.data[u] }
          });
      else if (d === "strict")
        s.length > 0 && (pe(o, {
          code: te.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (d !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const u of s) {
        const f = o.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: d._parse(
            new Vr(o, f, o.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const u of l) {
        const f = await u.key, p = await u.value;
        d.push({
          key: f,
          value: p,
          alwaysSet: u.alwaysSet
        });
      }
      return d;
    }).then((d) => ln.mergeObjectSync(r, d)) : ln.mergeObjectSync(r, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Ce.errToObj, new wt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var o, i, a, s;
          const l = (a = (i = (o = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(o, t, r).message) !== null && a !== void 0 ? a : r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: (s = Ce.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new wt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new wt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new wt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new wt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Ae.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new wt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    return ot.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    }), new wt({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    return ot.objectKeys(this.shape).forEach((r) => {
      e[r] || (t[r] = this.shape[r]);
    }), new wt({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ha(this);
  }
  partial(e) {
    const t = {};
    return ot.objectKeys(this.shape).forEach((r) => {
      const o = this.shape[r];
      e && !e[r] ? t[r] = o : t[r] = o.optional();
    }), new wt({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    return ot.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof Ir; )
          i = i._def.innerType;
        t[r] = i;
      }
    }), new wt({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return K3(ot.objectKeys(this.shape));
  }
}
wt.create = (n, e) => new wt({
  shape: () => n,
  unknownKeys: "strip",
  catchall: bo.create(),
  typeName: Ae.ZodObject,
  ...ze(e)
});
wt.strictCreate = (n, e) => new wt({
  shape: () => n,
  unknownKeys: "strict",
  catchall: bo.create(),
  typeName: Ae.ZodObject,
  ...ze(e)
});
wt.lazycreate = (n, e) => new wt({
  shape: n,
  unknownKeys: "strip",
  catchall: bo.create(),
  typeName: Ae.ZodObject,
  ...ze(e)
});
class Al extends qe {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function o(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return t.common.issues.push(...s.ctx.common.issues), s.result;
      const a = i.map((s) => new In(s.ctx.common.issues));
      return pe(t, {
        code: te.invalid_union,
        unionErrors: a
      }), Ie;
    }
    if (t.common.async)
      return Promise.all(r.map(async (i) => {
        const a = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: a
          }),
          ctx: a
        };
      })).then(o);
    {
      let i;
      const a = [];
      for (const l of r) {
        const d = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: t.data,
          path: t.path,
          parent: d
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: d }), d.common.issues.length && a.push(d.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const s = a.map((l) => new In(l));
      return pe(t, {
        code: te.invalid_union,
        unionErrors: s
      }), Ie;
    }
  }
  get options() {
    return this._def.options;
  }
}
Al.create = (n, e) => new Al({
  options: n,
  typeName: Ae.ZodUnion,
  ...ze(e)
});
const Qr = (n) => n instanceof Pl ? Qr(n.schema) : n instanceof $r ? Qr(n.innerType()) : n instanceof Dl ? [n.value] : n instanceof oi ? n.options : n instanceof Il ? ot.objectValues(n.enum) : n instanceof Ya ? Qr(n._def.innerType) : n instanceof Ol ? [void 0] : n instanceof Tl ? [null] : n instanceof Ir ? [void 0, ...Qr(n.unwrap())] : n instanceof ii ? [null, ...Qr(n.unwrap())] : n instanceof g0 || n instanceof Bl ? Qr(n.unwrap()) : n instanceof Rl ? Qr(n._def.innerType) : [];
class df extends qe {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== ge.object)
      return pe(t, {
        code: te.invalid_type,
        expected: ge.object,
        received: t.parsedType
      }), Ie;
    const r = this.discriminator, o = t.data[r], i = this.optionsMap.get(o);
    return i ? t.common.async ? i._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : i._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (pe(t, {
      code: te.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Ie);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, r) {
    const o = /* @__PURE__ */ new Map();
    for (const i of t) {
      const a = Qr(i.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of a) {
        if (o.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        o.set(s, i);
      }
    }
    return new df({
      typeName: Ae.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: o,
      ...ze(r)
    });
  }
}
function xh(n, e) {
  const t = oo(n), r = oo(e);
  if (n === e)
    return { valid: !0, data: n };
  if (t === ge.object && r === ge.object) {
    const o = ot.objectKeys(e), i = ot.objectKeys(n).filter((s) => o.indexOf(s) !== -1), a = { ...n, ...e };
    for (const s of i) {
      const l = xh(n[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      a[s] = l.data;
    }
    return { valid: !0, data: a };
  } else if (t === ge.array && r === ge.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const o = [];
    for (let i = 0; i < n.length; i++) {
      const a = n[i], s = e[i], l = xh(a, s);
      if (!l.valid)
        return { valid: !1 };
      o.push(l.data);
    }
    return { valid: !0, data: o };
  } else
    return t === ge.date && r === ge.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class Ml extends qe {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), o = (i, a) => {
      if ($h(i) || $h(a))
        return Ie;
      const s = xh(i.value, a.value);
      return s.valid ? ((wh(i) || wh(a)) && t.dirty(), { status: t.value, value: s.data }) : (pe(r, {
        code: te.invalid_intersection_types
      }), Ie);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([i, a]) => o(i, a)) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Ml.create = (n, e, t) => new Ml({
  left: n,
  right: e,
  typeName: Ae.ZodIntersection,
  ...ze(t)
});
class zr extends qe {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ge.array)
      return pe(r, {
        code: te.invalid_type,
        expected: ge.array,
        received: r.parsedType
      }), Ie;
    if (r.data.length < this._def.items.length)
      return pe(r, {
        code: te.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ie;
    !this._def.rest && r.data.length > this._def.items.length && (pe(r, {
      code: te.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const i = [...r.data].map((a, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Vr(r, a, r.path, s)) : null;
    }).filter((a) => !!a);
    return r.common.async ? Promise.all(i).then((a) => ln.mergeArray(t, a)) : ln.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new zr({
      ...this._def,
      rest: e
    });
  }
}
zr.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new zr({
    items: n,
    typeName: Ae.ZodTuple,
    rest: null,
    ...ze(e)
  });
};
class Nl extends qe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ge.object)
      return pe(r, {
        code: te.invalid_type,
        expected: ge.object,
        received: r.parsedType
      }), Ie;
    const o = [], i = this._def.keyType, a = this._def.valueType;
    for (const s in r.data)
      o.push({
        key: i._parse(new Vr(r, s, r.path, s)),
        value: a._parse(new Vr(r, r.data[s], r.path, s)),
        alwaysSet: s in r.data
      });
    return r.common.async ? ln.mergeObjectAsync(t, o) : ln.mergeObjectSync(t, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, r) {
    return t instanceof qe ? new Nl({
      keyType: e,
      valueType: t,
      typeName: Ae.ZodRecord,
      ...ze(r)
    }) : new Nl({
      keyType: dr.create(),
      valueType: e,
      typeName: Ae.ZodRecord,
      ...ze(t)
    });
  }
}
class Bu extends qe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ge.map)
      return pe(r, {
        code: te.invalid_type,
        expected: ge.map,
        received: r.parsedType
      }), Ie;
    const o = this._def.keyType, i = this._def.valueType, a = [...r.data.entries()].map(([s, l], d) => ({
      key: o._parse(new Vr(r, s, r.path, [d, "key"])),
      value: i._parse(new Vr(r, l, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const d = await l.key, u = await l.value;
          if (d.status === "aborted" || u.status === "aborted")
            return Ie;
          (d.status === "dirty" || u.status === "dirty") && t.dirty(), s.set(d.value, u.value);
        }
        return { status: t.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of a) {
        const d = l.key, u = l.value;
        if (d.status === "aborted" || u.status === "aborted")
          return Ie;
        (d.status === "dirty" || u.status === "dirty") && t.dirty(), s.set(d.value, u.value);
      }
      return { status: t.value, value: s };
    }
  }
}
Bu.create = (n, e, t) => new Bu({
  valueType: e,
  keyType: n,
  typeName: Ae.ZodMap,
  ...ze(t)
});
class ji extends qe {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== ge.set)
      return pe(r, {
        code: te.invalid_type,
        expected: ge.set,
        received: r.parsedType
      }), Ie;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (pe(r, {
      code: te.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), t.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (pe(r, {
      code: te.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function a(l) {
      const d = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ie;
        u.status === "dirty" && t.dirty(), d.add(u.value);
      }
      return { status: t.value, value: d };
    }
    const s = [...r.data.values()].map((l, d) => i._parse(new Vr(r, l, r.path, d)));
    return r.common.async ? Promise.all(s).then((l) => a(l)) : a(s);
  }
  min(e, t) {
    return new ji({
      ...this._def,
      minSize: { value: e, message: Ce.toString(t) }
    });
  }
  max(e, t) {
    return new ji({
      ...this._def,
      maxSize: { value: e, message: Ce.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ji.create = (n, e) => new ji({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: Ae.ZodSet,
  ...ze(e)
});
class Ta extends qe {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== ge.function)
      return pe(t, {
        code: te.invalid_type,
        expected: ge.function,
        received: t.parsedType
      }), Ie;
    function r(s, l) {
      return Pu({
        data: s,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          Nu(),
          Ga
        ].filter((d) => !!d),
        issueData: {
          code: te.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function o(s, l) {
      return Pu({
        data: s,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          Nu(),
          Ga
        ].filter((d) => !!d),
        issueData: {
          code: te.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: t.common.contextualErrorMap }, a = t.data;
    if (this._def.returns instanceof Za) {
      const s = this;
      return hn(async function(...l) {
        const d = new In([]), u = await s._def.args.parseAsync(l, i).catch((h) => {
          throw d.addIssue(r(l, h)), d;
        }), f = await Reflect.apply(a, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((h) => {
          throw d.addIssue(o(f, h)), d;
        });
      });
    } else {
      const s = this;
      return hn(function(...l) {
        const d = s._def.args.safeParse(l, i);
        if (!d.success)
          throw new In([r(l, d.error)]);
        const u = Reflect.apply(a, this, d.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new In([o(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Ta({
      ...this._def,
      args: zr.create(e).rest(Ti.create())
    });
  }
  returns(e) {
    return new Ta({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, r) {
    return new Ta({
      args: e || zr.create([]).rest(Ti.create()),
      returns: t || Ti.create(),
      typeName: Ae.ZodFunction,
      ...ze(r)
    });
  }
}
class Pl extends qe {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
Pl.create = (n, e) => new Pl({
  getter: n,
  typeName: Ae.ZodLazy,
  ...ze(e)
});
class Dl extends qe {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return pe(t, {
        received: t.data,
        code: te.invalid_literal,
        expected: this._def.value
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Dl.create = (n, e) => new Dl({
  value: n,
  typeName: Ae.ZodLiteral,
  ...ze(e)
});
function K3(n, e) {
  return new oi({
    values: n,
    typeName: Ae.ZodEnum,
    ...ze(e)
  });
}
class oi extends qe {
  constructor() {
    super(...arguments), Bs.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return pe(t, {
        expected: ot.joinValues(r),
        received: t.parsedType,
        code: te.invalid_type
      }), Ie;
    }
    if (Du(this, Bs, "f") || z3(this, Bs, new Set(this._def.values), "f"), !Du(this, Bs, "f").has(e.data)) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return pe(t, {
        received: t.data,
        code: te.invalid_enum_value,
        options: r
      }), Ie;
    }
    return hn(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return oi.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return oi.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...t
    });
  }
}
Bs = /* @__PURE__ */ new WeakMap();
oi.create = K3;
class Il extends qe {
  constructor() {
    super(...arguments), Ls.set(this, void 0);
  }
  _parse(e) {
    const t = ot.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== ge.string && r.parsedType !== ge.number) {
      const o = ot.objectValues(t);
      return pe(r, {
        expected: ot.joinValues(o),
        received: r.parsedType,
        code: te.invalid_type
      }), Ie;
    }
    if (Du(this, Ls, "f") || z3(this, Ls, new Set(ot.getValidEnumValues(this._def.values)), "f"), !Du(this, Ls, "f").has(e.data)) {
      const o = ot.objectValues(t);
      return pe(r, {
        received: r.data,
        code: te.invalid_enum_value,
        options: o
      }), Ie;
    }
    return hn(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ls = /* @__PURE__ */ new WeakMap();
Il.create = (n, e) => new Il({
  values: n,
  typeName: Ae.ZodNativeEnum,
  ...ze(e)
});
class Za extends qe {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== ge.promise && t.common.async === !1)
      return pe(t, {
        code: te.invalid_type,
        expected: ge.promise,
        received: t.parsedType
      }), Ie;
    const r = t.parsedType === ge.promise ? t.data : Promise.resolve(t.data);
    return hn(r.then((o) => this._def.type.parseAsync(o, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
Za.create = (n, e) => new Za({
  type: n,
  typeName: Ae.ZodPromise,
  ...ze(e)
});
class $r extends qe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ae.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), o = this._def.effect || null, i = {
      addIssue: (a) => {
        pe(r, a), a.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), o.type === "preprocess") {
      const a = o.transform(r.data, i);
      if (r.common.async)
        return Promise.resolve(a).then(async (s) => {
          if (t.value === "aborted")
            return Ie;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: r.path,
            parent: r
          });
          return l.status === "aborted" ? Ie : l.status === "dirty" || t.value === "dirty" ? wa(l.value) : l;
        });
      {
        if (t.value === "aborted")
          return Ie;
        const s = this._def.schema._parseSync({
          data: a,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? Ie : s.status === "dirty" || t.value === "dirty" ? wa(s.value) : s;
      }
    }
    if (o.type === "refinement") {
      const a = (s) => {
        const l = o.refinement(s, i);
        if (r.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? Ie : (s.status === "dirty" && t.dirty(), a(s.value), { status: t.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => s.status === "aborted" ? Ie : (s.status === "dirty" && t.dirty(), a(s.value).then(() => ({ status: t.value, value: s.value }))));
    }
    if (o.type === "transform")
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Vi(a))
          return a;
        const s = o.transform(a.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => Vi(a) ? Promise.resolve(o.transform(a.value, i)).then((s) => ({ status: t.value, value: s })) : a);
    ot.assertNever(o);
  }
}
$r.create = (n, e, t) => new $r({
  schema: n,
  typeName: Ae.ZodEffects,
  effect: e,
  ...ze(t)
});
$r.createWithPreprocess = (n, e, t) => new $r({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: Ae.ZodEffects,
  ...ze(t)
});
class Ir extends qe {
  _parse(e) {
    return this._getType(e) === ge.undefined ? hn(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ir.create = (n, e) => new Ir({
  innerType: n,
  typeName: Ae.ZodOptional,
  ...ze(e)
});
class ii extends qe {
  _parse(e) {
    return this._getType(e) === ge.null ? hn(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ii.create = (n, e) => new ii({
  innerType: n,
  typeName: Ae.ZodNullable,
  ...ze(e)
});
class Ya extends qe {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === ge.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ya.create = (n, e) => new Ya({
  innerType: n,
  typeName: Ae.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...ze(e)
});
class Rl extends qe {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Sl(o) ? o.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new In(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new In(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Rl.create = (n, e) => new Rl({
  innerType: n,
  typeName: Ae.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...ze(e)
});
class Lu extends qe {
  _parse(e) {
    if (this._getType(e) !== ge.nan) {
      const r = this._getOrReturnCtx(e);
      return pe(r, {
        code: te.invalid_type,
        expected: ge.nan,
        received: r.parsedType
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
}
Lu.create = (n) => new Lu({
  typeName: Ae.ZodNaN,
  ...ze(n)
});
const hT = Symbol("zod_brand");
class g0 extends qe {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class gd extends qe {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? Ie : i.status === "dirty" ? (t.dirty(), wa(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? Ie : o.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new gd({
      in: e,
      out: t,
      typeName: Ae.ZodPipeline
    });
  }
}
class Bl extends qe {
  _parse(e) {
    const t = this._def.innerType._parse(e), r = (o) => (Vi(o) && (o.value = Object.freeze(o.value)), o);
    return Sl(t) ? t.then((o) => r(o)) : r(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Bl.create = (n, e) => new Bl({
  innerType: n,
  typeName: Ae.ZodReadonly,
  ...ze(e)
});
function W3(n, e = {}, t) {
  return n ? Ja.create().superRefine((r, o) => {
    var i, a;
    if (!n(r)) {
      const s = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, l = (a = (i = s.fatal) !== null && i !== void 0 ? i : t) !== null && a !== void 0 ? a : !0, d = typeof s == "string" ? { message: s } : s;
      o.addIssue({ code: "custom", ...d, fatal: l });
    }
  }) : Ja.create();
}
const mT = {
  object: wt.lazycreate
};
var Ae;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline", n.ZodReadonly = "ZodReadonly";
})(Ae || (Ae = {}));
const gT = (n, e = {
  message: `Input not instance of ${n.name}`
}) => W3((t) => t instanceof n, e), q3 = dr.create, G3 = ni.create, vT = Lu.create, yT = ri.create, J3 = El.create, bT = zi.create, $T = Iu.create, wT = Ol.create, xT = Tl.create, CT = Ja.create, kT = Ti.create, _T = bo.create, ST = Ru.create, ET = cr.create, OT = wt.create, TT = wt.strictCreate, AT = Al.create, MT = df.create, NT = Ml.create, PT = zr.create, DT = Nl.create, IT = Bu.create, RT = ji.create, BT = Ta.create, LT = Pl.create, FT = Dl.create, VT = oi.create, zT = Il.create, jT = Za.create, Pg = $r.create, HT = Ir.create, UT = ii.create, KT = $r.createWithPreprocess, WT = gd.create, qT = () => q3().optional(), GT = () => G3().optional(), JT = () => J3().optional(), ZT = {
  string: (n) => dr.create({ ...n, coerce: !0 }),
  number: (n) => ni.create({ ...n, coerce: !0 }),
  boolean: (n) => El.create({
    ...n,
    coerce: !0
  }),
  bigint: (n) => ri.create({ ...n, coerce: !0 }),
  date: (n) => zi.create({ ...n, coerce: !0 })
}, YT = Ie;
var gJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Ga,
  setErrorMap: KO,
  getErrorMap: Nu,
  makeIssue: Pu,
  EMPTY_PATH: WO,
  addIssueToContext: pe,
  ParseStatus: ln,
  INVALID: Ie,
  DIRTY: wa,
  OK: hn,
  isAborted: $h,
  isDirty: wh,
  isValid: Vi,
  isAsync: Sl,
  get util() {
    return ot;
  },
  get objectUtil() {
    return bh;
  },
  ZodParsedType: ge,
  getParsedType: oo,
  ZodType: qe,
  datetimeRegex: U3,
  ZodString: dr,
  ZodNumber: ni,
  ZodBigInt: ri,
  ZodBoolean: El,
  ZodDate: zi,
  ZodSymbol: Iu,
  ZodUndefined: Ol,
  ZodNull: Tl,
  ZodAny: Ja,
  ZodUnknown: Ti,
  ZodNever: bo,
  ZodVoid: Ru,
  ZodArray: cr,
  ZodObject: wt,
  ZodUnion: Al,
  ZodDiscriminatedUnion: df,
  ZodIntersection: Ml,
  ZodTuple: zr,
  ZodRecord: Nl,
  ZodMap: Bu,
  ZodSet: ji,
  ZodFunction: Ta,
  ZodLazy: Pl,
  ZodLiteral: Dl,
  ZodEnum: oi,
  ZodNativeEnum: Il,
  ZodPromise: Za,
  ZodEffects: $r,
  ZodTransformer: $r,
  ZodOptional: Ir,
  ZodNullable: ii,
  ZodDefault: Ya,
  ZodCatch: Rl,
  ZodNaN: Lu,
  BRAND: hT,
  ZodBranded: g0,
  ZodPipeline: gd,
  ZodReadonly: Bl,
  custom: W3,
  Schema: qe,
  ZodSchema: qe,
  late: mT,
  get ZodFirstPartyTypeKind() {
    return Ae;
  },
  coerce: ZT,
  any: CT,
  array: ET,
  bigint: yT,
  boolean: J3,
  date: bT,
  discriminatedUnion: MT,
  effect: Pg,
  enum: VT,
  function: BT,
  instanceof: gT,
  intersection: NT,
  lazy: LT,
  literal: FT,
  map: IT,
  nan: vT,
  nativeEnum: zT,
  never: _T,
  null: xT,
  nullable: UT,
  number: G3,
  object: OT,
  oboolean: JT,
  onumber: GT,
  optional: HT,
  ostring: qT,
  pipeline: WT,
  preprocess: KT,
  promise: jT,
  record: DT,
  set: RT,
  strictObject: TT,
  string: q3,
  symbol: $T,
  transformer: Pg,
  tuple: PT,
  undefined: wT,
  union: AT,
  unknown: kT,
  void: ST,
  NEVER: YT,
  ZodIssueCode: te,
  quotelessJson: UO,
  ZodError: In
});
/**
  * vee-validate v4.15.0
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
const Dg = (n) => n !== null && !!n && typeof n == "object" && !Array.isArray(n);
function Z3(n) {
  return Number(n) >= 0;
}
function XT(n) {
  return typeof n == "object" && n !== null;
}
function QT(n) {
  return n == null ? n === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(n);
}
function Ig(n) {
  if (!XT(n) || QT(n) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(n) === null)
    return !0;
  let e = n;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(n) === e;
}
function Y3(n, e) {
  return Object.keys(e).forEach((t) => {
    if (Ig(e[t]) && Ig(n[t])) {
      n[t] || (n[t] = {}), Y3(n[t], e[t]);
      return;
    }
    n[t] = e[t];
  }), n;
}
function eA(n) {
  const e = n.split(".");
  if (!e.length)
    return "";
  let t = String(e[0]);
  for (let r = 1; r < e.length; r++) {
    if (Z3(e[r])) {
      t += `[${e[r]}]`;
      continue;
    }
    t += `.${e[r]}`;
  }
  return t;
}
function vJ(n, e) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      const o = await n.safeParseAsync(r, e);
      if (o.success)
        return {
          value: o.data,
          errors: []
        };
      const i = {};
      return X3(o.error.issues, i), {
        errors: Object.values(i)
      };
    },
    cast(r) {
      try {
        return n.parse(r);
      } catch {
        const i = Q3(n);
        return Dg(i) && Dg(r) ? Y3(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return {
            required: !n.isOptional(),
            exists: !0
          };
        const o = tA(r, n);
        return o ? {
          required: !o.isOptional(),
          exists: !0
        } : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function X3(n, e) {
  n.forEach((t) => {
    const r = eA(t.path.join("."));
    t.code === "invalid_union" && (X3(t.unionErrors.flatMap((o) => o.issues), e), !r) || (e[r] || (e[r] = { errors: [], path: r }), e[r].errors.push(t.message));
  });
}
function Q3(n) {
  if (n instanceof wt)
    return Object.fromEntries(Object.entries(n.shape).map(([e, t]) => t instanceof Ya ? [e, t._def.defaultValue()] : t instanceof wt ? [e, Q3(t)] : [e, void 0]));
}
function tA(n, e) {
  if (!Rg(e))
    return null;
  if (md(n))
    return e.shape[of(n)];
  const t = (n || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = e;
  for (let o = 0; o <= t.length; o++) {
    const i = t[o];
    if (!i || !r)
      return r;
    if (Rg(r)) {
      r = r.shape[i] || null;
      continue;
    }
    Z3(i) && nA(r) && (r = r._def.type);
  }
  return null;
}
function e$(n) {
  return n._def.typeName;
}
function nA(n) {
  return e$(n) === Ae.ZodArray;
}
function Rg(n) {
  return e$(n) === Ae.ZodObject;
}
const rA = ["aria-label"], oA = {
  key: 0,
  class: "mb-2"
}, yJ = /* @__PURE__ */ _({
  __name: "FormCheckboxGroup",
  props: /* @__PURE__ */ Mt({
    items: {},
    name: {},
    layout: { default: "vertical" },
    label: {}
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue"), t = tn(
      ["gap-4"],
      {
        variants: {
          layout: {
            grid: `
          grid grid-cols-1 gap-4
          md:grid-cols-2
        `,
            horizontal: `
          flex flex-col flex-wrap items-start space-y-0
          sm:flex-row sm:items-center
        `,
            vertical: "flex flex-col items-start"
          }
        },
        defaultVariants: {
          layout: "vertical"
        }
      }
    );
    return (r, o) => (b(), D("fieldset", {
      "aria-label": r.label ? void 0 : "Gruppe von Checkboxen, Mehrfachauswahl möglich"
    }, [
      r.label ? (b(), D("legend", oA, [
        x(c(Oe), {
          tag: "span",
          paragraph: "label"
        }, {
          default: y(() => [
            K(U(r.label), 1)
          ]),
          _: 1
        })
      ])) : X("", !0),
      x(c(yr), {
        modelValue: e.value,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => e.value = i),
        name: r.name
      }, {
        default: y(() => [
          x(c(br), null, {
            default: y(() => [
              x(c(So)),
              O("div", {
                class: fe(c(G)(c(t)({ layout: r.layout })))
              }, [
                (b(!0), D(Me, null, it(r.items, (i) => (b(), k(c(yr), {
                  key: i.value,
                  type: "checkbox",
                  value: i.value,
                  "unchecked-value": !1,
                  "checked-value": !0,
                  name: r.name
                }, {
                  default: y(({ value: a, handleChange: s }) => [
                    x(c(br), null, {
                      default: y(() => [
                        O("div", {
                          class: fe(["flex flex-row space-x-4 space-y-0", i.description ? "items-start" : "items-center"])
                        }, [
                          x(c(Fr), null, {
                            default: y(() => [
                              x(c(nf), {
                                checked: a.includes(i.value),
                                "onUpdate:checked": s
                              }, null, 8, ["checked", "onUpdate:checked"])
                            ]),
                            _: 2
                          }, 1024),
                          O("div", null, [
                            x(c(m0), null, {
                              default: y(() => [
                                K(U(i.label), 1)
                              ]),
                              _: 2
                            }, 1024),
                            x(c(_o), {
                              class: fe(i.description && "mt-2 text-foreground")
                            }, {
                              default: y(() => [
                                K(U(i.description), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value", "name"]))), 128))
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "name"])
    ], 8, rA));
  }
}), bJ = /* @__PURE__ */ _({
  __name: "FormCheckboxSingle",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {},
    disabled: { type: Boolean }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return (t, r) => (b(), k(c(yr), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      type: "checkbox",
      name: t.name
    }, {
      default: y(({ value: o, handleChange: i, componentField: a }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            O("div", {
              class: fe(["flex flex-row space-x-4 space-y-0", t.description ? "items-start" : "items-center"])
            }, [
              x(c(Fr), null, {
                default: y(() => [
                  x(c(nf), j({
                    checked: o,
                    disabled: t.disabled
                  }, a, { "onUpdate:checked": i }), null, 16, ["checked", "disabled", "onUpdate:checked"])
                ]),
                _: 2
              }, 1024),
              O("div", null, [
                t.$props?.label || t.$slots?.label ? (b(), k(c(m0), { key: 0 }, {
                  default: y(() => [
                    E(t.$slots, "label", {}, () => [
                      K(U(t.label), 1)
                    ])
                  ]),
                  _: 3
                })) : X("", !0),
                t.$props?.description ? (b(), k(c(_o), {
                  key: 1,
                  class: fe([t.label && "mt-2", t.description && "text-foreground"])
                }, {
                  default: y(() => [
                    K(U(t.description), 1)
                  ]),
                  _: 1
                }, 8, ["class"])) : X("", !0)
              ])
            ], 2)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["modelValue", "name"]));
  }
}), iA = { class: "mt-4 flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 sm:gap-y-0" }, aA = /* @__PURE__ */ _({
  __name: "Calendar",
  props: {
    class: {},
    modelValue: {},
    multiple: { type: Boolean },
    defaultValue: {},
    defaultPlaceholder: {},
    placeholder: {},
    pagedNavigation: { type: Boolean },
    preventDeselect: { type: Boolean },
    weekStartsOn: {},
    weekdayFormat: {},
    calendarLabel: {},
    fixedWeeks: { type: Boolean },
    maxValue: {},
    minValue: {},
    locale: {},
    numberOfMonths: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    initialFocus: { type: Boolean },
    isDateDisabled: { type: Function },
    isDateUnavailable: { type: Function },
    dir: {},
    nextPage: { type: Function },
    prevPage: { type: Function },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:placeholder"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(a7), j({
      class: c(G)("p-3", t.class)
    }, c(i), {
      locale: "de-CH",
      "aria-label": "Kalender"
    }), {
      default: y(({ grid: l, weekDays: d }) => [
        x(c(pA), null, {
          default: y(() => [
            x(c(xA)),
            x(c(hA)),
            x(c(yA))
          ]),
          _: 1
        }),
        O("div", iA, [
          (b(!0), D(Me, null, it(l, (u) => (b(), k(c(dA), {
            key: u.value.toString()
          }, {
            default: y(() => [
              x(c(cA), null, {
                default: y(() => [
                  x(c(Bg), null, {
                    default: y(() => [
                      (b(!0), D(Me, null, it(d, (f) => (b(), k(c(fA), { key: f }, {
                        default: y(() => [
                          K(U(f), 1)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              x(c(uA), null, {
                default: y(() => [
                  (b(!0), D(Me, null, it(u.rows, (f, p) => (b(), k(c(Bg), {
                    key: `weekDate-${p}`,
                    class: "mt-2 w-full"
                  }, {
                    default: y(() => [
                      (b(!0), D(Me, null, it(f, (h) => (b(), k(c(sA), {
                        key: h.toString(),
                        date: h
                      }, {
                        default: y(() => [
                          x(c(lA), {
                            day: h,
                            month: u.value
                          }, null, 8, ["day", "month"])
                        ]),
                        _: 2
                      }, 1032, ["date"]))), 128))
                    ]),
                    _: 2
                  }, 1024))), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))), 128))
        ])
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), sA = /* @__PURE__ */ _({
  __name: "CalendarCell",
  props: {
    date: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(u7), j({
      class: c(G)(`
      relative size-9 p-0 text-center text-sm
      [&:has([data-selected])]:rounded-md [&:has([data-selected])]:bg-accent
      [&:has([data-selected][data-outside-view])]:bg-accent/50
      focus-within:relative focus-within:z-20
    `, e.class)
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), lA = /* @__PURE__ */ _({
  __name: "CalendarCellTrigger",
  props: {
    day: {},
    month: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(v7), j({
      class: c(G)(
        c(Rc)({ variant: "ghost" }),
        "size-9 p-0 font-normal",
        `
        [&[data-today]:not([data-selected])]:bg-accent
        [&[data-today]:not([data-selected])]:text-accent-foreground
      `,
        // Selected
        `
        data-[selected]:bg-primary data-[selected]:text-primary-foreground
        data-[selected]:opacity-100 data-[selected]:hover:bg-primary
        data-[selected]:hover:text-primary-foreground
        data-[selected]:focus:bg-primary
        data-[selected]:focus:text-primary-foreground
      `,
        // Disabled
        "data-[disabled]:text-muted-foreground data-[disabled]:opacity-50",
        // Unavailable
        `
        data-[unavailable]:text-destructive-foreground
        data-[unavailable]:line-through
      `,
        // Outside months
        `
        [&[data-outside-view][data-selected]]:bg-accent/50
        [&[data-outside-view][data-selected]]:text-muted-foreground
        [&[data-outside-view][data-selected]]:opacity-30
        data-[outside-view]:text-muted-foreground data-[outside-view]:opacity-50
      `,
        e.class
      )
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), dA = /* @__PURE__ */ _({
  __name: "CalendarGrid",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(d7), j({
      class: c(G)("w-full border-collapse space-y-1", e.class)
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), uA = /* @__PURE__ */ _({
  __name: "CalendarGridBody",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(m7), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), cA = /* @__PURE__ */ _({
  __name: "CalendarGridHead",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(h7), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Bg = /* @__PURE__ */ _({
  __name: "CalendarGridRow",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(g7), j({
      class: c(G)("flex", e.class)
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), fA = /* @__PURE__ */ _({
  __name: "CalendarHeadCell",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(c7), j({
      class: c(G)("w-9 rounded-md text-[0.8rem] font-normal text-muted-foreground", e.class)
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), pA = /* @__PURE__ */ _({
  __name: "CalendarHeader",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(s7), j({
      class: c(G)("relative flex w-full items-center justify-between pt-1", e.class)
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), hA = /* @__PURE__ */ _({
  __name: "CalendarHeading",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(l7), j({
      class: c(G)("text-sm font-medium", e.class)
    }, c(r)), {
      default: y(({ headingValue: a }) => [
        K(U(a), 1)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), mA = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function gA(n, e) {
  return b(), D("svg", mA, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.158 3.135a.5.5 0 0 1 .707.023l3.75 4a.5.5 0 0 1 0 .684l-3.75 4a.5.5 0 1 1-.73-.684L9.566 7.5l-3.43-3.658a.5.5 0 0 1 .023-.707",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const vA = { name: "radix-icons-chevron-right", render: gA }, yA = /* @__PURE__ */ _({
  __name: "CalendarNextButton",
  props: {
    step: {},
    nextPage: { type: Function },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(f7), j({
      class: c(G)(
        c(Rc)({ variant: "outline" }),
        `
        size-7 bg-transparent p-0 opacity-50
        hover:opacity-100
      `,
        e.class
      )
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          x(c(vA), { class: "size-4" })
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), bA = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function $A(n, e) {
  return b(), D("svg", bA, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.842 3.135a.5.5 0 0 1 .023.707L5.435 7.5l3.43 3.658a.5.5 0 0 1-.73.684l-3.75-4a.5.5 0 0 1 0-.684l3.75-4a.5.5 0 0 1 .707-.023",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const wA = { name: "radix-icons-chevron-left", render: $A }, xA = /* @__PURE__ */ _({
  __name: "CalendarPrevButton",
  props: {
    step: {},
    prevPage: { type: Function },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(p7), j({
      class: c(G)(
        c(Rc)({ variant: "outline" }),
        `
        size-7 bg-transparent p-0 opacity-50
        hover:opacity-100
      `,
        e.class
      )
    }, c(r)), {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          x(c(wA), { class: "size-4" })
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), CA = { class: "absolute left-6 top-5 @lg:top-6" }, kA = ["id", "type", "placeholder", "modelModifiers"], _A = ["for"], Rt = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Input",
  props: /* @__PURE__ */ Mt({
    id: {},
    type: {},
    name: {},
    class: {},
    label: {},
    wrapperClass: {},
    labelClass: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, [t, r] = St(n, "modelValue"), o = Dc(), i = M(() => {
      const { class: s, type: l, id: d, ...u } = e;
      return {
        ...o,
        ...u
      };
    }), a = M(() => e.id ?? e.label.toLowerCase().replace(/[^a-z0-9]/g, ""));
    return (s, l) => (b(), D("div", {
      class: fe(c(G)("relative", s.wrapperClass))
    }, [
      O("span", CA, [
        E(s.$slots, "default")
      ]),
      hr(O("input", j(i.value, {
        id: a.value,
        "onUpdate:modelValue": l[0] || (l[0] = (d) => Br(t) ? t.value = d : null),
        type: s.type ?? "text",
        class: c(G)(c(v0)({ type: s.type ?? "text" }), s.$slots.default ? `
        pl-14
      ` : "", e.class ?? ""),
        placeholder: s.label,
        modelModifiers: c(r)
      }), null, 16, kA), [
        [L5, c(t)]
      ]),
      O("label", {
        class: fe(c(G)(c(t$), s.type === "hidden" ? "hidden" : "", s.$slots.default ? `
        left-14
      ` : "", s.labelClass)),
        for: a.value
      }, U(s.label), 11, _A),
      E(s.$slots, "inlineButton")
    ], 2));
  }
}), hi = `
  [&[readonly]]:text-foreground/65 [&[readonly]]:cursor-default [&[readonly]]:border-none [&[readonly]]:px-0
  placeholder:text-transparent placeholder-shown:pt-4 placeholder-shown:pb-4
  peer w-full rounded-sm px-4 pt-6 pb-2 transition-all
  focus:pt-6 focus:pb-2 focus:outline-none
  @lg:pt-7 @lg:pb-3 @lg:placeholder-shown:pt-5 @lg:placeholder-shown:pb-5 @lg:focus:pt-7 @lg:focus:pb-3`, v0 = tn(
  ["flex", "border", "border-border", "bg-background", "text-base", ...Ia, ...wx, `
    disabled:cursor-not-allowed
  `, "disabled:opacity-50"],
  {
    variants: {
      type: {
        text: hi,
        button: hi,
        tel: hi,
        password: hi,
        email: hi,
        number: hi,
        search: hi,
        hidden: ""
      }
    }
  }
), t$ = "peer-[&[readonly]]:left-0 peer-[&[readonly]]:text-base peer-[&[readonly]]:top-0 peer-focus:text-xs peer-focus:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:top-5 hover:cursor-text transition-all text-muted-foreground text-xs top-2 left-4 absolute @lg:peer-focus:text-xs @lg:peer-focus:top-3 @lg:top-3 @lg:peer-placeholder-shown:text-base", uf = /* @__PURE__ */ _({
  __name: "Popover",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(Fk), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), cf = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: { default: 4 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean },
    class: {},
    ariaLabel: {},
    to: {},
    disabled: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(zk), {
      to: a.to ? a.to : void 0
    }, {
      default: y(() => [
        x(c(Uk), j({ ...c(i), ...a.$attrs }, {
          class: c(G)(
            `
            z-50 w-72 rounded-sm border bg-popover p-4 text-popover-foreground
            shadow-md outline-none
            data-[side=bottom]:slide-in-from-top-2
            data-[side=left]:slide-in-from-right-2
            data-[side=right]:slide-in-from-left-2
            data-[side=top]:slide-in-from-bottom-2
            data-[state=closed]:animate-out data-[state=closed]:fade-out-0
            data-[state=closed]:zoom-out-95
            data-[state=open]:animate-in data-[state=open]:fade-in-0
            data-[state=open]:zoom-in-95
          `,
            t.class
          ),
          "aria-label": a.ariaLabel
        }), {
          default: y(() => [
            E(a.$slots, "default")
          ]),
          _: 3
        }, 16, ["class", "aria-label"])
      ]),
      _: 3
    }, 8, ["to"]));
  }
}), ff = /* @__PURE__ */ _({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(Vk), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SA = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function EA(n, e) {
  return b(), D("svg", SA, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 1a.5.5 0 0 1 .5.5V2h5v-.5a.5.5 0 0 1 1 0V2h1.5A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 12.5v-9A1.5 1.5 0 0 1 2.5 2H4v-.5a.5.5 0 0 1 .5-.5M10 3v.5a.5.5 0 0 0 1 0V3h1.5a.5.5 0 0 1 .5.5V5H2V3.5a.5.5 0 0 1 .5-.5H4v.5a.5.5 0 0 0 1 0V3zM2 6v6.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V6zm5 1.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0M9.5 7a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m1.5.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0m.5 1.5a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M9 9.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0M7.5 9a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M5 9.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0M3.5 9a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1M3 11.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0m2.5-.5a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1m1.5.5a.5.5 0 1 1 1 0a.5.5 0 0 1-1 0m2.5-.5a.5.5 0 1 0 0 1a.5.5 0 0 0 0-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const OA = { name: "radix-icons-calendar", render: EA }, TA = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function AA(n, e) {
  return b(), D("svg", TA, e[0] || (e[0] = [
    O("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      O("path", { d: "M9.12 4.88L4.88 9.12m0-4.24l4.24 4.24" }),
      O("circle", {
        cx: "7",
        cy: "7",
        r: "6.5"
      })
    ], -1)
  ]));
}
const MA = { name: "streamline-interface-delete-circle-button-delete-remove-add-circle-buttons", render: AA }, NA = { class: "relative" }, PA = '[id^="calendar-"]', DA = /* @__PURE__ */ _({
  __name: "DatePicker",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    id: {},
    inputPlaceholderText: {},
    class: {},
    to: {},
    ariaInvalid: { type: Boolean },
    ariaDescribedby: {},
    disabled: { type: Boolean },
    minValue: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Mt(["blur", "input", "change"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, [o, i] = St(n, "modelValue", {
      set(m) {
        if (m) {
          if (i.unix) {
            const g = new Date(m);
            return s(g.toISOString()) ? g.getTime() / 1e3 : void 0;
          }
          return new Date(m).toISOString().split("T")[0];
        }
      },
      get(m) {
        if (m) {
          if (i.unix) {
            if (!l(m)) {
              console.warn("[kompass:DatePicker] Invalid Unix timestamp:", m);
              return;
            }
            return new Date(m * 1e3).toISOString().split("T")[0];
          }
          if (!s(m)) {
            console.warn("[kompass:DatePicker] Invalid date:", m);
            return;
          }
          return new Date(m).toISOString().split("T")[0];
        }
      }
    }), a = M(() => {
      try {
        return B1(t.minValue);
      } catch (m) {
        console.error("Error parsing minValue:", m);
        return;
      }
    });
    function s(m) {
      if (!m || typeof m != "string")
        return !1;
      const g = new Date(m);
      return !(g.toString() === "Invalid Date" || Number.isNaN(g.getTime()));
    }
    function l(m) {
      const g = typeof m == "string" ? Number(m) : m;
      if (Number.isNaN(g))
        return !1;
      const v = 0, $ = 4102444800;
      return Number.isInteger(g) && g >= v && g <= $;
    }
    function d(m, g, v) {
      const $ = new CustomEvent(m, { detail: g, bubbles: !0, composed: !0 });
      return Object.defineProperty($, "target", { value: v, enumerable: !0 }), Object.defineProperty($, "target", { value: v, enumerable: !0 }), $;
    }
    const u = B(null), f = B(), p = new _r("de-CH", {
      dateStyle: "long"
    });
    vt(() => {
      if (!o.value)
        return f.value = void 0;
      try {
        f.value = B1(o.value);
      } catch (m) {
        console.warn("Failed to parse date:", m), f.value = void 0;
      }
    });
    function h(m) {
      if (!m)
        return o.value = void 0;
      try {
        o.value = m.toString().split("T")[0];
      } catch (g) {
        console.warn("Failed to update calendar:", g), o.value = void 0;
      }
    }
    return (m, g) => {
      const v = $m("id");
      return b(), k(c(uf), {
        "onUpdate:open": g[4] || (g[4] = ($) => {
          $ === !1 && r("blur", d("blur", f.value?.toString() || "", u.value?.querySelector(PA)));
        })
      }, {
        default: y(() => [
          O("div", NA, [
            x(c(ff), { "as-child": "" }, {
              default: y(() => [
                x(c(Rt), {
                  id: m.id,
                  name: m.name,
                  label: m.label,
                  type: "button",
                  class: fe(c(G)(
                    !c(o) && "text-muted-foreground",
                    `
              relative py-5 text-left
              focus:py-5
            `,
                    t.class
                  )),
                  disabled: m.disabled,
                  "model-value": c(o) ? c(p).format(new Date(c(o))) : m.inputPlaceholderText ?? m.label,
                  onChange: g[0] || (g[0] = ($) => r("change", $)),
                  onInput: g[1] || (g[1] = ($) => r("input", $))
                }, null, 8, ["id", "name", "label", "class", "disabled", "model-value"]),
                x(c(OA), {
                  "aria-hidden": "true",
                  role: "img",
                  class: "absolute right-5 top-1/2 size-6 -translate-y-1/2 transform p-0 text-primary"
                }),
                hr(x(c(Re), {
                  size: "icon",
                  variant: "ghost",
                  class: "absolute right-14 top-1/2 -translate-y-1/2 transform p-0",
                  "aria-label": "Eingabe löschen",
                  onClick: g[2] || (g[2] = ($) => o.value = void 0)
                }, {
                  default: y(() => [
                    x(c(MA), { class: "size-4 opacity-60" })
                  ]),
                  _: 1
                }, 512), [
                  [xm, c(o) && !m.disabled]
                ])
              ]),
              _: 1
            })
          ]),
          x(c(cf), {
            to: m.to ? m.to : void 0,
            class: "w-auto p-0",
            "aria-label": "Kalender, Datum auswählen",
            "aria-invalid": m.ariaInvalid,
            "aria-describedby": m.ariaDescribedby
          }, {
            default: y(() => [
              O("div", {
                ref_key: "wrapper",
                ref: u
              }, [
                hr(x(c(aA), {
                  modelValue: f.value,
                  "onUpdate:modelValue": [
                    g[3] || (g[3] = ($) => f.value = $),
                    h
                  ],
                  "calendar-label": m.label,
                  "initial-focus": "",
                  "min-value": a.value
                }, null, 8, ["modelValue", "calendar-label", "min-value"]), [
                  [v, "calendar", "prefix"]
                ])
              ], 512)
            ]),
            _: 1
          }, 8, ["to", "aria-invalid", "aria-describedby"])
        ]),
        _: 1
      });
    };
  }
}), $J = /* @__PURE__ */ _({
  __name: "FormDatePicker",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {},
    placeholder: {},
    disabled: { type: Boolean },
    minValue: {},
    class: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const [e, t] = St(n, "modelValue");
    return (r, o) => (b(), k(c(yr), {
      modelValue: c(e),
      "onUpdate:modelValue": o[0] || (o[0] = (i) => Br(e) ? e.value = i : null),
      "model-modifiers": c(t),
      name: r.name
    }, {
      default: y(({ componentField: i, errorMessage: a }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            x(c(Fr), null, {
              default: y(() => [
                x(c(DA), j({
                  class: c(G)(a ? `
            border-destructive
            [&>svg]:text-destructive
          ` : "", r.$props.class),
                  label: r.label,
                  "input-placeholder-text": r.placeholder,
                  "model-modifiers": c(t),
                  "min-value": r.minValue,
                  disabled: r.disabled
                }, i), null, 16, ["class", "label", "input-placeholder-text", "model-modifiers", "min-value", "disabled"])
              ]),
              _: 2
            }, 1024),
            x(c(_o), null, {
              default: y(() => [
                K(U(r.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue", "model-modifiers", "name"]));
  }
}), n$ = /* @__PURE__ */ _({
  __name: "FormInput",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {},
    type: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return (t, r) => (b(), k(c(yr), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      name: t.name
    }, {
      default: y(({ componentField: o }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            x(c(Fr), null, {
              default: y(() => [
                E(t.$slots, "input", {
                  componentField: o,
                  disabled: t.disabled
                }, () => [
                  x(c(Rt), j({
                    label: t.label,
                    type: t.type ?? "text"
                  }, o, { disabled: t.disabled }), null, 16, ["label", "type", "disabled"])
                ])
              ]),
              _: 2
            }, 1024),
            x(c(_o), null, {
              default: y(() => [
                K(U(t.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["modelValue", "name"]));
  }
}), r$ = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function IA(n, e) {
  var t = Array.prototype.slice.call(e);
  return t.push(r$), n.apply(this, t);
}
function Ch(n) {
  "@babel/helpers - typeof";
  return Ch = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ch(n);
}
function Lg(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function RA(n, e, t) {
  return e && Lg(n.prototype, e), t && Lg(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function BA(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LA(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && Ll(n, e);
}
function FA(n) {
  var e = i$();
  return function() {
    var r = Fl(n), o;
    if (e) {
      var i = Fl(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return VA(this, o);
  };
}
function VA(n, e) {
  if (e && (Ch(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return o$(n);
}
function o$(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function kh(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return kh = function(r) {
    if (r === null || !zA(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(r))
        return e.get(r);
      e.set(r, o);
    }
    function o() {
      return ou(r, arguments, Fl(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), Ll(o, r);
  }, kh(n);
}
function ou(n, e, t) {
  return i$() ? ou = Reflect.construct : ou = function(o, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(o, s), d = new l();
    return a && Ll(d, a.prototype), d;
  }, ou.apply(null, arguments);
}
function i$() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zA(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function Ll(n, e) {
  return Ll = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Ll(n, e);
}
function Fl(n) {
  return Fl = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Fl(n);
}
var io = /* @__PURE__ */ function(n) {
  LA(t, n);
  var e = FA(t);
  function t(r) {
    var o;
    return BA(this, t), o = e.call(this, r), Object.setPrototypeOf(o$(o), t.prototype), o.name = o.constructor.name, o;
  }
  return RA(t);
}(/* @__PURE__ */ kh(Error)), y0 = 2, jA = 17, HA = 3, mn = "0-9０-９٠-٩۰-۹", UA = "-‐-―−ー－", KA = "／/", WA = "．.", qA = "  ­​⁠　", GA = "()（）［］\\[\\]", JA = "~⁓∼～", fr = "".concat(UA).concat(KA).concat(WA).concat(qA).concat(GA).concat(JA), pf = "+＋";
function Fg(n, e) {
  n = n.split("-"), e = e.split("-");
  for (var t = n[0].split("."), r = e[0].split("."), o = 0; o < 3; o++) {
    var i = Number(t[o]), a = Number(r[o]);
    if (i > a)
      return 1;
    if (a > i)
      return -1;
    if (!isNaN(i) && isNaN(a))
      return 1;
    if (isNaN(i) && !isNaN(a))
      return -1;
  }
  return n[1] && e[1] ? n[1] > e[1] ? 1 : n[1] < e[1] ? -1 : 0 : !n[1] && e[1] ? 1 : n[1] && !e[1] ? -1 : 0;
}
var ZA = {}.constructor;
function el(n) {
  return n != null && n.constructor === ZA;
}
function _h(n) {
  "@babel/helpers - typeof";
  return _h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _h(n);
}
function hf(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Vg(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function mf(n, e, t) {
  return e && Vg(n.prototype, e), t && Vg(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var YA = "1.2.0", XA = "1.7.35", zg = " ext. ", QA = /^\d+$/, en = /* @__PURE__ */ function() {
  function n(e) {
    hf(this, n), rM(e), this.metadata = e, a$.call(this, e);
  }
  return mf(n, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && QA.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new jg(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new jg(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[t];
        if (o)
          return o;
      } else {
        var i = this.countryCallingCodes()[t];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), n;
}(), jg = /* @__PURE__ */ function() {
  function n(e, t) {
    hf(this, n), this.globalMetadataObject = t, this.metadata = e, a$.call(this, t.metadata);
  }
  return mf(n, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(o) {
        return new eM(o, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Hg(this.types(), t))
        return new nM(Hg(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? zg : this.metadata[13] || zg;
    }
  }]), n;
}(), eM = /* @__PURE__ */ function() {
  function n(e, t) {
    hf(this, n), this._format = e, this.metadata = t;
  }
  return mf(n, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !tM.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), n;
}(), tM = /^\(?\$1\)?$/, nM = /* @__PURE__ */ function() {
  function n(e, t) {
    hf(this, n), this.type = e, this.metadata = t;
  }
  return mf(n, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), n;
}();
function Hg(n, e) {
  switch (e) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function rM(n) {
  if (!n)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!el(n) || !el(n.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(el(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + oM(n) + ": " + n, "."));
}
var oM = function(e) {
  return _h(e);
};
function b0(n, e) {
  if (e = new en(e), e.hasCountry(n))
    return e.country(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function iM(n, e) {
  return e.countries.hasOwnProperty(n);
}
function a$(n) {
  var e = n.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? Fg(e, YA) === -1 ? this.v2 = !0 : Fg(e, XA) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var aM = ";ext=", da = function(e) {
  return "([".concat(mn, "]{1,").concat(e, "})");
};
function s$(n) {
  var e = "20", t = "15", r = "9", o = "6", i = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", f = "[  \\t]*", p = "(?:,{2}|;)", h = aM + da(e), m = i + l + a + da(e) + s, g = i + d + a + da(r) + s, v = u + da(o) + "#", $ = f + p + a + da(t) + s, C = f + "(?:,)+" + a + da(r) + s;
  return h + "|" + m + "|" + g + "|" + v + "|" + $ + "|" + C;
}
var sM = "[" + mn + "]{" + y0 + "}", lM = "[" + pf + "]{0,1}(?:[" + fr + "]*[" + mn + "]){3,}[" + fr + mn + "]*", dM = new RegExp("^[" + pf + "]{0,1}(?:[" + fr + "]*[" + mn + "]){1,2}$", "i"), uM = lM + // Phone number extensions
"(?:" + s$() + ")?", cM = new RegExp(
  // Either a short two-digit-only phone number
  "^" + sM + "$|^" + uM + "$",
  "i"
);
function fM(n) {
  return n.length >= y0 && cM.test(n);
}
function pM(n) {
  return dM.test(n);
}
var Ug = new RegExp("(?:" + s$() + ")$", "i");
function hM(n) {
  var e = n.search(Ug);
  if (e < 0)
    return {};
  for (var t = n.slice(0, e), r = n.match(Ug), o = 1; o < r.length; ) {
    if (r[o])
      return {
        number: t,
        ext: r[o]
      };
    o++;
  }
}
function mM(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = gM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gM(n, e) {
  if (n) {
    if (typeof n == "string")
      return Kg(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Kg(n, e);
  }
}
function Kg(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
var vM = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function l$(n) {
  return vM[n];
}
function Fu(n) {
  for (var e = "", t = mM(n.split("")), r; !(r = t()).done; ) {
    var o = r.value, i = l$(o);
    i && (e += i);
  }
  return e;
}
function yM(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = bM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bM(n, e) {
  if (n) {
    if (typeof n == "string")
      return Wg(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Wg(n, e);
  }
}
function Wg(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function qg(n) {
  for (var e = "", t = yM(n.split("")), r; !(r = t()).done; ) {
    var o = r.value;
    e += $M(o, e) || "";
  }
  return e;
}
function $M(n, e, t) {
  if (n === "+") {
    if (e) {
      typeof t == "function" && t("end");
      return;
    }
    return "+";
  }
  return l$(n);
}
function wM(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = xM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xM(n, e) {
  if (n) {
    if (typeof n == "string")
      return Gg(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Gg(n, e);
  }
}
function Gg(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function CM(n, e) {
  for (var t = n.slice(), r = wM(e), o; !(o = r()).done; ) {
    var i = o.value;
    n.indexOf(i) < 0 && t.push(i);
  }
  return t.sort(function(a, s) {
    return a - s;
  });
}
function gf(n, e) {
  return d$(n, void 0, e);
}
function d$(n, e, t) {
  var r = t.type(e), o = r && r.possibleLengths() || t.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  if (e === "FIXED_LINE_OR_MOBILE") {
    if (!t.type("FIXED_LINE"))
      return d$(n, "MOBILE", t);
    var i = t.type("MOBILE");
    i && (o = CM(o, i.possibleLengths()));
  } else if (e && !r)
    return "INVALID_LENGTH";
  var a = n.length, s = o[0];
  return s === a ? "IS_POSSIBLE" : s > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function kM(n, e, t) {
  if (e === void 0 && (e = {}), t = new en(t), e.v2) {
    if (!n.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(n.countryCallingCode);
  } else {
    if (!n.phone)
      return !1;
    if (n.country) {
      if (!t.hasCountry(n.country))
        throw new Error("Unknown country: ".concat(n.country));
      t.country(n.country);
    } else {
      if (!n.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(n.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return u$(n.phone || n.nationalNumber, t);
  if (n.countryCallingCode && t.isNonGeographicCallingCode(n.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function u$(n, e) {
  switch (gf(n, e)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function $o(n, e) {
  return n = n || "", new RegExp("^(?:" + e + ")$").test(n);
}
function _M(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = SM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SM(n, e) {
  if (n) {
    if (typeof n == "string")
      return Jg(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Jg(n, e);
  }
}
function Jg(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
var EM = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function $0(n, e, t) {
  if (e = e || {}, !(!n.country && !n.countryCallingCode)) {
    t = new en(t), t.selectNumberingPlan(n.country, n.countryCallingCode);
    var r = e.v2 ? n.nationalNumber : n.phone;
    if ($o(r, t.nationalNumberPattern())) {
      if (ap(r, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || ap(r, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = _M(EM), i; !(i = o()).done; ) {
        var a = i.value;
        if (ap(r, a, t))
          return a;
      }
    }
  }
}
function ap(n, e, t) {
  return e = t.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(n.length) < 0 ? !1 : $o(n, e.pattern());
}
function OM(n, e, t) {
  if (e = e || {}, t = new en(t), t.selectNumberingPlan(n.country, n.countryCallingCode), t.hasTypes())
    return $0(n, e, t.metadata) !== void 0;
  var r = e.v2 ? n.nationalNumber : n.phone;
  return $o(r, t.nationalNumberPattern());
}
function TM(n, e, t) {
  var r = new en(t), o = r.getCountryCodesForCallingCode(n);
  return o ? o.filter(function(i) {
    return AM(e, i, t);
  }) : [];
}
function AM(n, e, t) {
  var r = new en(t);
  return r.selectNumberingPlan(e), r.numberingPlan.possibleLengths().indexOf(n.length) >= 0;
}
function c$(n) {
  return n.replace(new RegExp("[".concat(fr, "]+"), "g"), " ").trim();
}
var f$ = /(\$\d)/;
function p$(n, e, t) {
  var r = t.useInternationalFormat, o = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var i = n.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && e.nationalPrefixFormattingRule() ? e.format().replace(f$, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return r ? c$(i) : i;
}
var MM = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function NM(n, e, t) {
  var r = new en(t);
  if (r.selectNumberingPlan(n, e), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (MM.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function PM(n) {
  var e = n.number, t = n.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(t ? ";ext=" + t : "");
}
function DM(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = IM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IM(n, e) {
  if (n) {
    if (typeof n == "string")
      return Zg(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Zg(n, e);
  }
}
function Zg(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function Yg(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Xg(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Yg(Object(t), !0).forEach(function(r) {
      RM(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Yg(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function RM(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
var Qg = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function BM(n, e, t, r) {
  if (t ? t = Xg(Xg({}, Qg), t) : t = Qg, r = new en(r), n.country && n.country !== "001") {
    if (!r.hasCountry(n.country))
      throw new Error("Unknown country: ".concat(n.country));
    r.country(n.country);
  } else if (n.countryCallingCode)
    r.selectNumberingPlan(n.countryCallingCode);
  else
    return n.phone || "";
  var o = r.countryCallingCode(), i = t.v2 ? n.nationalNumber : n.phone, a;
  switch (e) {
    case "NATIONAL":
      return i ? (a = Vu(i, n.carrierCode, "NATIONAL", r, t), sp(a, n.ext, r, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (a = Vu(i, null, "INTERNATIONAL", r, t), a = "+".concat(o, " ").concat(a), sp(a, n.ext, r, t.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(i);
    case "RFC3966":
      return PM({
        number: "+".concat(o).concat(i),
        ext: n.ext
      });
    case "IDD":
      if (!t.fromCountry)
        return;
      var s = FM(i, n.carrierCode, o, t.fromCountry, r);
      return sp(s, n.ext, r, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function Vu(n, e, t, r, o) {
  var i = LM(r.formats(), n);
  return i ? p$(n, i, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: e,
    metadata: r
  }) : n;
}
function LM(n, e) {
  for (var t = DM(n), r; !(r = t()).done; ) {
    var o = r.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var i = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (e.search(i) !== 0)
        continue;
    }
    if ($o(e, o.pattern()))
      return o;
  }
}
function sp(n, e, t, r) {
  return e ? r(n, e, t) : n;
}
function FM(n, e, t, r, o) {
  var i = b0(r, o.metadata);
  if (i === t) {
    var a = Vu(n, e, "NATIONAL", o);
    return t === "1" ? t + " " + a : a;
  }
  var s = NM(r, void 0, o.metadata);
  if (s)
    return "".concat(s, " ").concat(t, " ").concat(Vu(n, null, "INTERNATIONAL", o));
}
function ev(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function tv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ev(Object(t), !0).forEach(function(r) {
      VM(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ev(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function VM(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function zM(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function nv(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function jM(n, e, t) {
  return e && nv(n.prototype, e), t && nv(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var h$ = /* @__PURE__ */ function() {
  function n(e, t, r) {
    if (zM(this, n), !e)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!t)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var o = UM(e, r), i = o.country, a = o.countryCallingCode;
    this.country = i, this.countryCallingCode = a, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return jM(n, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : TM(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return kM(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return OM(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new en(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return $0(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return BM(this, t, r ? tv(tv({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), n;
}(), HM = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function UM(n, e) {
  var t, r, o = new en(e);
  return HM(n) ? (t = n, o.selectNumberingPlan(t), r = o.countryCallingCode()) : r = n, {
    country: t,
    countryCallingCode: r
  };
}
var KM = new RegExp("([" + mn + "])");
function m$(n, e, t, r) {
  if (e) {
    var o = new en(r);
    o.selectNumberingPlan(e, t);
    var i = new RegExp(o.IDDPrefix());
    if (n.search(i) === 0) {
      n = n.slice(n.match(i)[0].length);
      var a = n.match(KM);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return n;
    }
  }
}
function Sh(n, e) {
  if (n && e.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), r = t.exec(n);
    if (r) {
      var o, i, a = r.length - 1, s = a > 0 && r[a];
      if (e.nationalPrefixTransformRule() && s)
        o = n.replace(t, e.nationalPrefixTransformRule()), a > 1 && (i = r[1]);
      else {
        var l = r[0];
        o = n.slice(l.length), s && (i = r[1]);
      }
      var d;
      if (s) {
        var u = n.indexOf(r[1]), f = n.slice(0, u);
        f === e.numberingPlan.nationalPrefix() && (d = e.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: d,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: n
  };
}
function Eh(n, e) {
  var t = Sh(n, e), r = t.carrierCode, o = t.nationalNumber;
  if (o !== n) {
    if (!WM(n, o, e))
      return {
        nationalNumber: n
      };
    if (e.possibleLengths() && !qM(o, e))
      return {
        nationalNumber: n
      };
  }
  return {
    nationalNumber: o,
    carrierCode: r
  };
}
function WM(n, e, t) {
  return !($o(n, t.nationalNumberPattern()) && !$o(e, t.nationalNumberPattern()));
}
function qM(n, e) {
  switch (gf(n, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function g$(n, e, t, r) {
  var o = e ? b0(e, r) : t;
  if (n.indexOf(o) === 0) {
    r = new en(r), r.selectNumberingPlan(e, t);
    var i = n.slice(o.length), a = Eh(i, r), s = a.nationalNumber, l = Eh(n, r), d = l.nationalNumber;
    if (!$o(d, r.nationalNumberPattern()) && $o(s, r.nationalNumberPattern()) || gf(d, r) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: i
      };
  }
  return {
    number: n
  };
}
function v$(n, e, t, r) {
  if (!n)
    return {};
  var o;
  if (n[0] !== "+") {
    var i = m$(n, e, t, r);
    if (i && i !== n)
      o = !0, n = "+" + i;
    else {
      if (e || t) {
        var a = g$(n, e, t, r), s = a.countryCallingCode, l = a.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: n
      };
    }
  }
  if (n[1] === "0")
    return {};
  r = new en(r);
  for (var d = 2; d - 1 <= HA && d <= n.length; ) {
    var u = n.slice(1, d);
    if (r.hasCallingCode(u))
      return r.selectNumberingPlan(u), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: n.slice(d)
      };
    d++;
  }
  return {};
}
function GM(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = JM(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JM(n, e) {
  if (n) {
    if (typeof n == "string")
      return rv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return rv(n, e);
  }
}
function rv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function y$(n, e) {
  var t = e.countries;
  e.defaultCountry;
  var r = e.metadata;
  r = new en(r);
  for (var o = GM(t), i; !(i = o()).done; ) {
    var a = i.value;
    if (r.country(a), r.leadingDigits()) {
      if (n && n.search(r.leadingDigits()) === 0)
        return a;
    } else if ($0({
      phone: n,
      country: a
    }, void 0, r.metadata))
      return a;
  }
}
var ZM = !1;
function b$(n, e) {
  var t = e.nationalNumber, r = e.defaultCountry, o = e.metadata;
  if (ZM && o.isNonGeographicCallingCode(n))
    return "001";
  var i = o.getCountryCodesForCallingCode(n);
  if (i)
    return i.length === 1 ? i[0] : y$(t, {
      countries: i,
      defaultCountry: r,
      metadata: o.metadata
    });
}
var $$ = "+", YM = "[\\-\\.\\(\\)]?", ov = "([" + mn + "]|" + YM + ")", XM = "^\\" + $$ + ov + "*[" + mn + "]" + ov + "*$", QM = new RegExp(XM, "g"), Oh = mn, eN = "[" + Oh + "]+((\\-)*[" + Oh + "])*", tN = "a-zA-Z", nN = "[" + tN + "]+((\\-)*[" + Oh + "])*", rN = "^(" + eN + "\\.)*" + nN + "\\.?$", oN = new RegExp(rN, "g"), iv = "tel:", Th = ";phone-context=", iN = ";isub=";
function aN(n) {
  var e = n.indexOf(Th);
  if (e < 0)
    return null;
  var t = e + Th.length;
  if (t >= n.length)
    return "";
  var r = n.indexOf(";", t);
  return r >= 0 ? n.substring(t, r) : n.substring(t);
}
function sN(n) {
  return n === null ? !0 : n.length === 0 ? !1 : QM.test(n) || oN.test(n);
}
function lN(n, e) {
  var t = e.extractFormattedPhoneNumber, r = aN(n);
  if (!sN(r))
    throw new io("NOT_A_NUMBER");
  var o;
  if (r === null)
    o = t(n) || "";
  else {
    o = "", r.charAt(0) === $$ && (o += r);
    var i = n.indexOf(iv), a;
    i >= 0 ? a = i + iv.length : a = 0;
    var s = n.indexOf(Th);
    o += n.substring(a, s);
  }
  var l = o.indexOf(iN);
  if (l > 0 && (o = o.substring(0, l)), o !== "")
    return o;
}
var dN = 250, uN = new RegExp("[" + pf + mn + "]"), cN = new RegExp("[^" + mn + "#]+$");
function fN(n, e, t) {
  if (e = e || {}, t = new en(t), e.defaultCountry && !t.hasCountry(e.defaultCountry))
    throw e.v2 ? new io("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var r = hN(n, e.v2, e.extract), o = r.number, i = r.ext, a = r.error;
  if (!o) {
    if (e.v2)
      throw a === "TOO_SHORT" ? new io("TOO_SHORT") : new io("NOT_A_NUMBER");
    return {};
  }
  var s = gN(o, e.defaultCountry, e.defaultCallingCode, t), l = s.country, d = s.nationalNumber, u = s.countryCallingCode, f = s.countryCallingCodeSource, p = s.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new io("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < y0) {
    if (e.v2)
      throw new io("TOO_SHORT");
    return {};
  }
  if (d.length > jA) {
    if (e.v2)
      throw new io("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var h = new h$(u, d, t.metadata);
    return l && (h.country = l), p && (h.carrierCode = p), i && (h.ext = i), h.__countryCallingCodeSource = f, h;
  }
  var m = (e.extended ? t.hasSelectedNumberingPlan() : l) ? $o(d, t.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: p,
    valid: m,
    possible: m ? !0 : !!(e.extended === !0 && t.possibleLengths() && u$(d, t)),
    phone: d,
    ext: i
  } : m ? mN(l, d, i) : {};
}
function pN(n, e, t) {
  if (n) {
    if (n.length > dN) {
      if (t)
        throw new io("TOO_LONG");
      return;
    }
    if (e === !1)
      return n;
    var r = n.search(uN);
    if (!(r < 0))
      return n.slice(r).replace(cN, "");
  }
}
function hN(n, e, t) {
  var r = lN(n, {
    extractFormattedPhoneNumber: function(a) {
      return pN(a, t, e);
    }
  });
  if (!r)
    return {};
  if (!fM(r))
    return pM(r) ? {
      error: "TOO_SHORT"
    } : {};
  var o = hM(r);
  return o.ext ? o : {
    number: r
  };
}
function mN(n, e, t) {
  var r = {
    country: n,
    phone: e
  };
  return t && (r.ext = t), r;
}
function gN(n, e, t, r) {
  var o = v$(qg(n), e, t, r.metadata), i = o.countryCallingCodeSource, a = o.countryCallingCode, s = o.number, l;
  if (a)
    r.selectNumberingPlan(a);
  else if (s && (e || t))
    r.selectNumberingPlan(e, t), e && (l = e), a = t || b0(e, r.metadata);
  else
    return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: a
    };
  var d = Eh(qg(s), r), u = d.nationalNumber, f = d.carrierCode, p = b$(a, {
    nationalNumber: u,
    defaultCountry: e,
    metadata: r
  });
  return p && (l = p, p === "001" || r.country(l)), {
    country: l,
    countryCallingCode: a,
    countryCallingCodeSource: i,
    nationalNumber: u,
    carrierCode: f
  };
}
function av(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function sv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? av(Object(t), !0).forEach(function(r) {
      vN(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : av(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function vN(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function yN(n, e, t) {
  return fN(n, sv(sv({}, e), {}, {
    v2: !0
  }), t);
}
function lv(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function bN(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lv(Object(t), !0).forEach(function(r) {
      $N(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : lv(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function $N(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function wN(n, e) {
  return _N(n) || kN(n, e) || CN(n, e) || xN();
}
function xN() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CN(n, e) {
  if (n) {
    if (typeof n == "string")
      return dv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return dv(n, e);
  }
}
function dv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function kN(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], o = !0, i = !1, a, s;
    try {
      for (t = t.call(n); !(o = (a = t.next()).done) && (r.push(a.value), !(e && r.length === e)); o = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return r;
  }
}
function _N(n) {
  if (Array.isArray(n))
    return n;
}
function SN(n) {
  var e = Array.prototype.slice.call(n), t = wN(e, 4), r = t[0], o = t[1], i = t[2], a = t[3], s, l, d;
  if (typeof r == "string")
    s = r;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    a ? (l = i, d = a) : (l = void 0, d = i), o && (l = bN({
      defaultCountry: o
    }, l));
  else if (el(o))
    i ? (l = o, d = i) : d = o;
  else
    throw new Error("Invalid second argument: ".concat(o));
  return {
    text: s,
    options: l,
    metadata: d
  };
}
function uv(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function cv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? uv(Object(t), !0).forEach(function(r) {
      EN(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : uv(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function EN(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function ON(n, e, t) {
  e && e.defaultCountry && !iM(e.defaultCountry, t) && (e = cv(cv({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return yN(n, e, t);
  } catch (r) {
    if (!(r instanceof io))
      throw r;
  }
}
function TN() {
  var n = SN(arguments), e = n.text, t = n.options, r = n.metadata;
  return ON(e, t, r);
}
function AN(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fv(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function MN(n, e, t) {
  return e && fv(n.prototype, e), t && fv(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var NN = /* @__PURE__ */ function() {
  function n(e) {
    var t = e.onCountryChange, r = e.onCallingCodeChange;
    AN(this, n), this.onCountryChange = t, this.onCallingCodeChange = r;
  }
  return MN(n, [{
    key: "reset",
    value: function(t) {
      var r = t.country, o = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, o);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, o = Object.keys(t); r < o.length; r++) {
        var i = o[r];
        this[i] = t[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), n;
}();
function PN(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = DN(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DN(n, e) {
  if (n) {
    if (typeof n == "string")
      return pv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return pv(n, e);
  }
}
function pv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
var ir = "x", lp = new RegExp(ir);
function iu(n, e) {
  if (e < 1)
    return "";
  for (var t = ""; e > 1; )
    e & 1 && (t += n), e >>= 1, n += n;
  return t + n;
}
function hv(n, e) {
  return n[e] === ")" && e++, IN(n.slice(0, e));
}
function IN(n) {
  for (var e = [], t = 0; t < n.length; )
    n[t] === "(" ? e.push(t) : n[t] === ")" && e.pop(), t++;
  var r = 0, o = "";
  e.push(n.length);
  for (var i = 0, a = e; i < a.length; i++) {
    var s = a[i];
    o += n.slice(r, s), r = s + 1;
  }
  return o;
}
function RN(n, e, t) {
  for (var r = PN(t.split("")), o; !(o = r()).done; ) {
    var i = o.value;
    if (n.slice(e + 1).search(lp) < 0)
      return;
    e = n.search(lp), n = n.replace(lp, i);
  }
  return [n, e];
}
function BN(n, e, t) {
  var r = t.metadata, o = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, a = new RegExp("^(?:".concat(e.pattern(), ")$"));
  if (a.test(n.nationalSignificantNumber))
    return FN(n, e, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: i
    });
}
function LN(n, e) {
  return gf(n, e) === "IS_POSSIBLE";
}
function FN(n, e, t) {
  var r = t.metadata, o = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix;
  if (n.nationalSignificantNumber, n.international, n.nationalPrefix, n.carrierCode, o(e)) {
    var a = mv(n, e, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: r
    });
    if (a)
      return a;
  }
  return mv(n, e, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: r
  });
}
function mv(n, e, t) {
  var r = t.metadata, o = t.useNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, a = p$(n.nationalSignificantNumber, e, {
    carrierCode: n.carrierCode,
    useInternationalFormat: n.international,
    withNationalPrefix: o,
    metadata: r
  });
  if (o || (n.nationalPrefix ? a = n.nationalPrefix + i(e) + a : n.complexPrefixBeforeNationalSignificantNumber && (a = n.complexPrefixBeforeNationalSignificantNumber + " " + a)), VN(a, n))
    return a;
}
function VN(n, e) {
  return Fu(n) === e.getNationalDigits();
}
function zN(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gv(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function jN(n, e, t) {
  return e && gv(n.prototype, e), t && gv(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var HN = /* @__PURE__ */ function() {
  function n() {
    zN(this, n);
  }
  return jN(n, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], o = r.branches, i = r.instructions;
      if (o)
        return {
          op: "|",
          args: o.concat([dp(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(WN);
      if (!r) {
        if (KN.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var o = r[1], i = t.slice(0, r.index), a = t.slice(r.index + o.length);
      switch (o) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), l = s.branches;
          l.push(dp(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(dp(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: UN(i)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(o));
      }
      a && this.parsePattern(a);
    }
  }]), n;
}();
function UN(n) {
  for (var e = [], t = 0; t < n.length; ) {
    if (n[t] === "-") {
      if (t === 0 || t === n.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(n));
      for (var r = n[t - 1].charCodeAt(0) + 1, o = n[t + 1].charCodeAt(0) - 1, i = r; i <= o; )
        e.push(String.fromCharCode(i)), i++;
    } else
      e.push(n[t]);
    t++;
  }
  return e;
}
var KN = /[\(\)\[\]\?\:\|]/, WN = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function dp(n) {
  return n.length === 1 ? n[0] : n;
}
function vv(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = qN(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qN(n, e) {
  if (n) {
    if (typeof n == "string")
      return yv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return yv(n, e);
  }
}
function yv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function GN(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function bv(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function JN(n, e, t) {
  return e && bv(n.prototype, e), t && bv(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var ZN = /* @__PURE__ */ function() {
  function n(e) {
    GN(this, n), this.matchTree = new HN().parse(e);
  }
  return JN(n, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var i = Ah(t.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !o))
        return i;
    }
  }]), n;
}();
function Ah(n, e, t) {
  if (typeof e == "string") {
    var r = n.join("");
    return e.indexOf(r) === 0 ? n.length === e.length ? {
      match: !0,
      matchedChars: n
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(e) === 0 ? t && n.length > e.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, e.length)
    } : void 0;
  }
  if (Array.isArray(e)) {
    for (var o = n.slice(), i = 0; i < e.length; ) {
      var a = e[i], s = Ah(o, a, t && i === e.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (o = o.slice(s.matchedChars.length), o.length === 0)
            return i === e.length - 1 ? {
              match: !0,
              matchedChars: n
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else
        return;
      i++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, n.length - o.length)
    };
  }
  switch (e.op) {
    case "|":
      for (var l, d = vv(e.args), u; !(u = d()).done; ) {
        var f = u.value, p = Ah(n, f, t);
        if (p) {
          if (p.overflow)
            return p;
          if (p.match)
            return {
              match: !0,
              matchedChars: p.matchedChars
            };
          if (p.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(p, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var h = vv(e.args), m; !(m = h()).done; ) {
        var g = m.value;
        if (n[0] === g)
          return n.length === 1 ? {
            match: !0,
            matchedChars: n
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [g]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(e));
  }
}
function $v(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = YN(n)) || e && n && typeof n.length == "number") {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YN(n, e) {
  if (n) {
    if (typeof n == "string")
      return wv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return wv(n, e);
  }
}
function wv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function XN(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function xv(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function QN(n, e, t) {
  return e && xv(n.prototype, e), t && xv(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Mh = "9", eP = 15, tP = iu(Mh, eP), nP = /[- ]/, rP = function() {
  return /\[([^\[\]])*\]/g;
}, oP = function() {
  return /\d(?=[^,}][^,}])/g;
}, iP = new RegExp("[" + fr + "]*\\$1[" + fr + "]*(\\$\\d[" + fr + "]*)*$"), Cv = 3, aP = /* @__PURE__ */ function() {
  function n(e) {
    e.state;
    var t = e.metadata;
    XN(this, n), this.metadata = t, this.resetFormat();
  }
  return QN(n, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var o = this;
      if (LN(r.nationalSignificantNumber, this.metadata))
        for (var i = $v(this.matchingFormats), a; !(a = i()).done; ) {
          var s = a.value, l = BN(r, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return o.shouldTryNationalPrefixFormattingRule(u, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return o.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(l.replace(/\d/g, ir), r), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(ir), l;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var o = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === o ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, o = t.nationalSignificantNumber, i = t.nationalPrefix, a = t.international, s = o, l = s.length - Cv;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(d) {
        return r.formatSuits(d, a, i) && r.formatMatches(d, s, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, o) {
      return !(o && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !o && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, o) {
      var i = t.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      o = Math.min(o, i - 1);
      var a = t.leadingDigitsPatterns()[o];
      if (r.length < Cv)
        try {
          return new ZN(a).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(a, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, o = function() {
        var d = a.value;
        return r.chosenFormat === d ? "break" : iP.test(r.getFormatFormat(d, t.international)) ? r.createTemplateForFormat(d, t) ? (r.chosenFormat = d, "break") : (r.matchingFormats = r.matchingFormats.filter(function(u) {
          return u !== d;
        }), "continue") : "continue";
      }, i = $v(this.matchingFormats.slice()), a; !(a = i()).done; ) {
        var s = o();
        if (s === "break")
          break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var o = this.getTemplateForFormat(t, r);
        if (o)
          return this.setNationalNumberTemplate(o, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && nP.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var o = t.IDDPrefix, i = t.missingPlus;
      return o ? r && r.spacing === !1 ? o : o + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, o = 0, i = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; o < i.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(ir, r + 1), o++;
        return hv(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, ir) + iu(ir, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var o = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, s = r.complexPrefixBeforeNationalSignificantNumber, l = t.pattern();
      l = l.replace(rP(), "\\d").replace(oP(), "\\d");
      var d = tP.match(l)[0];
      if (!(o.length > d.length)) {
        var u = new RegExp("^" + l + "$"), f = o.replace(/\d/g, Mh);
        u.test(f) && (d = f);
        var p = this.getFormatFormat(t, i), h;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: i,
          nationalPrefix: a
        })) {
          var m = p.replace(f$, t.nationalPrefixFormattingRule());
          if (Fu(t.nationalPrefixFormattingRule()) === (a || "") + Fu("$1") && (p = m, h = !0, a))
            for (var g = a.length; g > 0; )
              p = p.replace(/\d/, ir), g--;
        }
        var v = d.replace(new RegExp(l), p).replace(new RegExp(Mh, "g"), ir);
        return h || (s ? v = iu(ir, s.length) + " " + v : a && (v = iu(ir, a.length) + this.getSeparatorAfterNationalPrefix(t) + v)), i && (v = c$(v)), v;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = RN(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], hv(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var o = r.international, i = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var a = t.usesNationalPrefix();
        if (a && i || !a && !o)
          return !0;
      }
    }
  }]), n;
}();
function w$(n, e) {
  return uP(n) || dP(n, e) || lP(n, e) || sP();
}
function sP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lP(n, e) {
  if (n) {
    if (typeof n == "string")
      return kv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return kv(n, e);
  }
}
function kv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function dP(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], o = !0, i = !1, a, s;
    try {
      for (t = t.call(n); !(o = (a = t.next()).done) && (r.push(a.value), !(e && r.length === e)); o = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return r;
  }
}
function uP(n) {
  if (Array.isArray(n))
    return n;
}
function cP(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _v(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function fP(n, e, t) {
  return e && _v(n.prototype, e), t && _v(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var pP = "[" + fr + mn + "]+", hP = new RegExp("^" + pP + "$", "i"), mP = "(?:[" + pf + "][" + fr + mn + "]*|[" + fr + mn + "]+)", gP = new RegExp("[^" + fr + mn + "]+.*$"), vP = /[^\d\[\]]/, yP = /* @__PURE__ */ function() {
  function n(e) {
    var t = e.defaultCountry, r = e.defaultCallingCode, o = e.metadata, i = e.onNationalSignificantNumberChange;
    cP(this, n), this.defaultCountry = t, this.defaultCallingCode = r, this.metadata = o, this.onNationalSignificantNumberChange = i;
  }
  return fP(n, [{
    key: "input",
    value: function(t, r) {
      var o = wP(t), i = w$(o, 2), a = i[0], s = i[1], l = Fu(a), d;
      return s && (r.digits || (r.startInternationalNumber(), l || (d = !0))), l && this.inputDigits(l, r), {
        digits: l,
        justLeadingPlus: d
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var o = r.digits, i = o.length < 3 && o.length + t.length >= 3;
      if (r.appendDigits(t), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
        return r.update(a);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, o = t.callingCode;
      return r && !o;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = v$("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode, i = r.number;
      if (o)
        return t.setCallingCode(o), t.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && vP.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var o = Sh(t, this.metadata), i = o.nationalPrefix, a = o.nationalNumber, s = o.carrierCode;
        if (a !== t)
          return this.onExtractedNationalNumber(i, s, a, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, o) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, o);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = Sh(t, this.metadata), a = i.nationalPrefix, s = i.nationalNumber, l = i.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(a, l, s, t, o), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, o, i, a) {
      var s, l, d = i.lastIndexOf(o);
      if (d >= 0 && d === i.length - o.length) {
        l = !0;
        var u = i.slice(0, d);
        u !== t && (s = u);
      }
      a({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: o,
        nationalSignificantNumberMatchesInput: l,
        complexPrefixBeforeNationalSignificantNumber: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, o = t.IDDPrefix, i = t.digits;
      if (t.nationalSignificantNumber, !(r || o)) {
        var a = m$(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (a !== void 0 && a !== i)
          return t.update({
            IDDPrefix: i.slice(0, i.length - a.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = g$(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode;
        if (r.number, o)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: o
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var o = r.country, i = r.callingCode;
      t.startInternationalNumber(o, i), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]), n;
}();
function bP(n) {
  var e = n.search(mP);
  if (!(e < 0)) {
    n = n.slice(e);
    var t;
    return n[0] === "+" && (t = !0, n = n.slice(1)), n = n.replace(gP, ""), t && (n = "+" + n), n;
  }
}
function $P(n) {
  var e = bP(n) || "";
  return e[0] === "+" ? [e.slice(1), !0] : [e];
}
function wP(n) {
  var e = $P(n), t = w$(e, 2), r = t[0], o = t[1];
  return hP.test(r) || (r = ""), [r, o];
}
function xP(n, e) {
  return SP(n) || _P(n, e) || kP(n, e) || CP();
}
function CP() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kP(n, e) {
  if (n) {
    if (typeof n == "string")
      return Sv(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Sv(n, e);
  }
}
function Sv(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function _P(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], o = !0, i = !1, a, s;
    try {
      for (t = t.call(n); !(o = (a = t.next()).done) && (r.push(a.value), !(e && r.length === e)); o = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return r;
  }
}
function SP(n) {
  if (Array.isArray(n))
    return n;
}
function EP(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ev(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function OP(n, e, t) {
  return e && Ev(n.prototype, e), t && Ev(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var x$ = /* @__PURE__ */ function() {
  function n(e, t) {
    EP(this, n), this.metadata = new en(t);
    var r = this.getCountryAndCallingCode(e), o = xP(r, 2), i = o[0], a = o[1];
    this.defaultCountry = i, this.defaultCallingCode = a, this.reset();
  }
  return OP(n, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, o;
      return t && (el(t) ? (r = t.defaultCountry, o = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, o];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), o = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (o) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var a;
        if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(o, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (a = this.formatter.format(s, this.state));
        }
        this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new NN({
        onCountryChange: function(o) {
          t.country = o;
        },
        onCallingCodeChange: function(o, i) {
          t.metadata.selectNumberingPlan(i, o), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new aP({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new yP({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var o = function(s) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!s
          }) + s;
        }, i = this.state.callingCode;
        return o(i ? t ? "".concat(i, " ").concat(t) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, o = t.complexPrefixBeforeNationalSignificantNumber, i = t.nationalPrefix, a = r, s = o || i;
      return s && (a = s + a), a;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, ir);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(b$(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, o = t.callingCode, i = t.country, a = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return o ? "+" + o + a : "+" + r;
        if (i || o) {
          var s = i ? this.metadata.countryCallingCode() : o;
          return "+" + s + a;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, o = t.carrierCode, i = t.callingCode, a = this._getCountry();
      if (r && !(!a && !i)) {
        if (a && a === this.defaultCountry) {
          var s = new en(this.metadata.metadata);
          s.selectNumberingPlan(a);
          var l = s.numberingPlan.callingCode(), d = this.metadata.getCountryCodesForCallingCode(l);
          if (d.length > 1) {
            var u = y$(r, {
              countries: d,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            u && (a = u);
          }
        }
        var f = new h$(a || i, r, this.metadata.metadata);
        return o && (f.carrierCode = o), f;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), n;
}();
function TP() {
  return IA(TN, arguments);
}
function zu(n) {
  return x$.call(this, n, r$);
}
zu.prototype = Object.create(x$.prototype, {});
zu.prototype.constructor = zu;
const wJ = /* @__PURE__ */ _({
  __name: "FormPhoneInput",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return De(() => e.value, (t) => {
      if (!t)
        return;
      const r = TP(t, "CH");
      r?.isValid && (e.value = r.formatInternational());
      const o = new zu("CH");
      e.value = o.input(t);
    }, {
      immediate: !0
    }), (t, r) => (b(), k(c(yr), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      name: t.name
    }, {
      default: y(({ componentField: o }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            x(c(Fr), null, {
              default: y(() => [
                x(c(Rt), j({
                  label: t.label,
                  type: "tel"
                }, o), null, 16, ["label"])
              ]),
              _: 2
            }, 1024),
            x(c(_o), null, {
              default: y(() => [
                K(U(t.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue", "name"]));
  }
}), C$ = /* @__PURE__ */ _({
  __name: "RadioGroup",
  props: {
    value: {},
    class: {},
    modelValue: {},
    defaultValue: {},
    disabled: { type: Boolean },
    name: {},
    required: { type: Boolean },
    orientation: {},
    dir: {},
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(qk), j({
      class: c(G)("grid gap-4", t.class)
    }, c(i)), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), AP = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function MP(n, e) {
  return b(), D("svg", AP, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7"
    }, null, -1)
  ]));
}
const ju = { name: "streamline-circle-solid", render: MP }, k$ = /* @__PURE__ */ _({
  __name: "RadioGroupItem",
  props: {
    value: {},
    class: {},
    id: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(Xk), j(c(r), {
      class: c(G)(
        `
          peer aspect-square size-8 rounded-full border border-primary
          text-primary ring-offset-background
          disabled:cursor-not-allowed disabled:opacity-50
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2
          focus:outline-none
        `,
        e.class
      )
    }), {
      default: y(() => [
        x(c(Qk), { class: "relative flex size-full items-center justify-center rounded-full border border-primary bg-primary" }, {
          default: y(() => [
            x(c(ju), { class: "absolute size-2 text-primary-foreground" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), NP = ["aria-label"], PP = {
  key: 0,
  class: "mb-2"
}, xJ = /* @__PURE__ */ _({
  __name: "FormRadioGroup",
  props: /* @__PURE__ */ Mt({
    id: {},
    name: {},
    items: {},
    layout: { default: "vertical" },
    label: {},
    description: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue"), t = tn(
      ["gap-4"],
      {
        variants: {
          layout: {
            grid: `
          grid grid-cols-1 gap-4
          md:grid-cols-2
        `,
            horizontal: `
          flex flex-col flex-wrap items-start space-y-0
          sm:flex-row sm:items-center
        `,
            vertical: "flex flex-col items-start"
          }
        },
        defaultVariants: {
          layout: "vertical"
        }
      }
    );
    return (r, o) => (b(), D("fieldset", {
      "aria-label": r.label ? void 0 : "Gruppe von Radio Elementen, Einfachauswahl möglich"
    }, [
      r.label ? (b(), D("legend", PP, [
        x(c(Oe), {
          tag: "span",
          paragraph: "label"
        }, {
          default: y(() => [
            K(U(r.label), 1)
          ]),
          _: 1
        })
      ])) : X("", !0),
      x(c(yr), {
        modelValue: e.value,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => e.value = i),
        type: "radio",
        name: r.name
      }, {
        default: y(({ componentField: i }) => [
          x(c(br), null, {
            default: y(() => [
              x(c(So)),
              x(c(Fr), null, {
                default: y(() => [
                  x(c(C$), j(i, {
                    class: c(G)(c(t)({ layout: r.layout }))
                  }), {
                    default: y(() => [
                      (b(!0), D(Me, null, it(r.items, (a) => (b(), k(c(br), {
                        key: a.label,
                        class: "flex min-w-fit flex-row items-center space-x-4 space-y-0"
                      }, {
                        default: y(() => [
                          x(c(Fr), null, {
                            default: y(() => [
                              x(c(k$), {
                                value: a.value
                              }, null, 8, ["value"])
                            ]),
                            _: 2
                          }, 1024),
                          x(c(m0), null, {
                            default: y(() => [
                              K(U(a.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))), 128))
                    ]),
                    _: 2
                  }, 1040, ["class"])
                ]),
                _: 2
              }, 1024),
              x(c(_o), null, {
                default: y(() => [
                  K(U(r.description), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["modelValue", "name"])
    ], 8, NP));
  }
}), DP = /* @__PURE__ */ _({
  __name: "DropdownMenu",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    dir: {},
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(wk), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), IP = /* @__PURE__ */ _({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Ck), null, {
      default: y(() => [
        x(c(kk), j(c(i), {
          class: c(G)(`
        z-50 min-w-[200px] space-y-4 overflow-hidden rounded-sm bg-popover px-8
        py-6 text-popover-foreground shadow-md
        dark:border dark:shadow-none
        data-[side=bottom]:slide-in-from-top-2
        data-[side=left]:slide-in-from-right-2
        data-[side=right]:slide-in-from-left-2
        data-[side=top]:slide-in-from-bottom-2
        data-[state=closed]:animate-out data-[state=closed]:fade-out-0
        data-[state=closed]:zoom-out-95
        data-[state=open]:animate-in data-[state=open]:fade-in-0
        data-[state=open]:zoom-in-95
      `, t.class)
        }), {
          default: y(() => [
            E(a.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), CJ = /* @__PURE__ */ _({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {},
    class: {},
    inset: { type: Boolean }
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(_k), j(c(r), {
      class: c(G)(
        `
        relative flex cursor-pointer select-none items-center rounded-xs
        font-bold text-primary outline-none transition-colors
        dark:hover:text-white dark:focus:text-white
        data-[disabled]:pointer-events-none data-[disabled]:opacity-50
        focus:text-accent focus:underline focus:underline-offset-4
        hover:text-accent hover:underline hover:underline-offset-4
      `,
        o.inset && "pl-8",
        e.class
      )
    }), {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), RP = /* @__PURE__ */ _({
  __name: "DropdownMenuRadioGroup",
  props: {
    modelValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(Ok), j({ class: "space-y-4" }, c(o)), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), BP = { class: "absolute -left-5 flex size-3.5 items-center justify-center" }, up = /* @__PURE__ */ _({
  __name: "DropdownMenuRadioItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Tk), j(c(i), {
      class: c(G)(
        `
        relative flex cursor-pointer select-none items-center rounded-xs
        font-bold text-primary outline-none transition-colors
        dark:hover:text-white dark:focus:text-white
        data-[disabled]:pointer-events-none data-[disabled]:opacity-50
        focus:text-accent focus:underline focus:underline-offset-4
        hover:text-accent hover:underline hover:underline-offset-4
      `,
        t.class
      )
    }), {
      default: y(() => [
        O("span", BP, [
          x(c(Ek), null, {
            default: y(() => [
              x(c(ju), { class: "size-2 fill-current" })
            ]),
            _: 1
          })
        ]),
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), kJ = /* @__PURE__ */ _({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(Sk), j(t.value, {
      class: c(G)("h-px bg-border", e.class)
    }), null, 16, ["class"]));
  }
}), LP = /* @__PURE__ */ _({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const t = pt(n);
    return (r, o) => (b(), k(c(xk), j({ class: "outline-none" }, c(t)), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), FP = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function VP(n, e) {
  return b(), D("svg", FP, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4 6.49L.79 9.67a1 1 0 0 0 0 1.42l2.12 2.12a1 1 0 0 0 1.42 0L7.51 10M10 7.51l3.18-3.18a1 1 0 0 0 0-1.42L11.09.79a1 1 0 0 0-1.42 0L6.49 4M9 5L5 9"
    }, null, -1)
  ]));
}
const zP = { name: "streamline-interface-link-create-hyperlink-link-make-unlink", render: VP }, Nh = /* @__PURE__ */ _({
  __name: "Toggle",
  props: {
    defaultValue: { type: Boolean },
    pressed: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {},
    class: {},
    variant: { default: "default" },
    size: { default: "default" }
  },
  emits: ["update:pressed"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, size: s, variant: l, ...d } = t;
      return d;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(v3), j(c(i), {
      class: c(G)(c(_$)({ variant: a.variant, size: a.size }), t.class)
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), _$ = tn(
  `
    inline-flex aspect-square items-center justify-center rounded-[12px] text-sm
    font-medium ring-offset-background transition-colors
    aria-[pressed=true]:bg-accent aria-[pressed=true]:text-accent-foreground
    disabled:pointer-events-none disabled:opacity-50
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
    focus-visible:ring-offset-2
    hover:bg-muted hover:text-muted-foreground
  `,
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: `
          border-input border bg-transparent
          hover:bg-accent hover:text-accent-foreground
        `
      },
      size: {
        default: "h-10 px-3",
        sm: "h-9 px-2.5",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), S$ = /* @__PURE__ */ _({
  __name: "ActionButton",
  props: /* @__PURE__ */ Mt({
    label: {},
    disabled: { type: Boolean },
    class: {},
    action: { type: Function }
  }, {
    pressed: { type: Boolean },
    pressedModifiers: {}
  }),
  emits: ["update:pressed"],
  setup(n) {
    const e = St(n, "pressed");
    return (t, r) => (b(), k(c(Nh), {
      pressed: e.value,
      "onUpdate:pressed": r[0] || (r[0] = (o) => e.value = o),
      size: "sm",
      disabled: t.disabled,
      class: fe(c(G)(t.$props.class)),
      "aria-label": t.label,
      onClick: r[1] || (r[1] = (o) => t.action?.())
    }, {
      default: y(() => [
        E(t.$slots, "icon", {
          size: "3",
          ariaHidden: !0
        })
      ]),
      _: 3
    }, 8, ["pressed", "disabled", "class", "aria-label"]));
  }
}), jP = { class: "relative w-full items-center" }, HP = { class: "relative w-full items-center" }, UP = { class: "mt-2 flex gap-2" }, KP = /* @__PURE__ */ _({
  __name: "LinkEditForm",
  props: {
    editor: {}
  },
  emits: ["setLink", "unsetLink"],
  setup(n, { emit: e }) {
    const t = e;
    let r = Zo({
      text: "",
      link: ""
    });
    const o = B(null), { focused: i } = V5(o);
    vt(() => {
      if (!n.editor)
        return;
      const { href: s } = n.editor.getAttributes("link"), { from: l, to: d } = n.editor.state.selection, u = n.editor.state.doc.textBetween(l, d, " ");
      r = {
        link: s,
        text: u
      };
    });
    function a() {
      t("setLink", r.link, r.text);
    }
    return Ge(() => {
      i.value = !0;
    }), (s, l) => (b(), D("form", {
      class: "flex w-80 flex-col gap-3",
      onSubmit: At(a, ["prevent"])
    }, [
      O("div", jP, [
        x(c(Rt), {
          modelValue: c(r).text,
          "onUpdate:modelValue": l[0] || (l[0] = (d) => c(r).text = d),
          label: "Text"
        }, null, 8, ["modelValue"])
      ]),
      O("div", HP, [
        x(c(Rt), {
          ref_key: "inputRef",
          ref: o,
          modelValue: c(r).link,
          "onUpdate:modelValue": l[1] || (l[1] = (d) => c(r).link = d),
          label: "URL"
        }, null, 8, ["modelValue"])
      ]),
      O("div", UP, [
        x(c(Re), {
          type: "submit",
          size: "small"
        }, {
          default: y(() => l[3] || (l[3] = [
            K(" Link setzen ")
          ])),
          _: 1
        }),
        x(c(Re), {
          type: "button",
          variant: "ghost",
          size: "small",
          onClick: l[2] || (l[2] = (d) => t("unsetLink"))
        }, {
          default: y(() => l[4] || (l[4] = [
            K(" Link entfernen ")
          ])),
          _: 1
        })
      ])
    ], 32));
  }
}), WP = /* @__PURE__ */ _({
  __name: "LinkEditPopover",
  props: {
    editor: {}
  },
  setup(n) {
    const e = M(() => n.editor?.isActive("link")), t = M(() => !n.editor?.isEditable);
    function r(i, a) {
      !n.editor || !i || n.editor.chain().extendMarkRange("link").insertContent({
        type: "text",
        text: a,
        marks: [
          {
            type: "link",
            attrs: {
              href: i
            }
          }
        ]
      }).setLink({ href: i }).focus().run();
    }
    function o() {
      n.editor && e.value && n.editor.chain().focus().extendMarkRange("link").unsetLink().run();
    }
    return (i, a) => (b(), k(c(uf), null, {
      default: y(() => [
        x(c(ff), {
          "as-child": "",
          disabled: t.value
        }, {
          default: y(() => [
            x(S$, {
              pressed: e.value,
              disabled: t.value,
              label: "Link bearbeiten oder hinzufügen"
            }, {
              icon: y((s) => [
                x(c(zP), Le(Ve(s)), null, 16)
              ]),
              _: 1
            }, 8, ["pressed", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        x(c(cf), {
          "hide-when-detached": "",
          "as-child": "",
          class: "w-full",
          align: "start",
          side: "bottom"
        }, {
          default: y(() => [
            x(KP, {
              editor: i.editor,
              onSetLink: r,
              onUnsetLink: o
            }, null, 8, ["editor"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), qP = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function GP(n, e) {
  return b(), D("svg", qP, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.764 3.122A33 33 0 0 1 7.5 3c.94 0 1.868.049 2.736.122c1.044.088 1.72.148 2.236.27c.47.111.733.258.959.489c.024.025.06.063.082.09c.2.23.33.518.405 1.062c.08.583.082 1.343.082 2.492c0 1.135-.002 1.885-.082 2.46c-.074.536-.204.821-.405 1.054l-.083.09c-.23.234-.49.379-.948.487c-.507.12-1.168.178-2.194.264c-.869.072-1.812.12-2.788.12s-1.92-.048-2.788-.12c-1.026-.086-1.687-.144-2.194-.264c-.459-.108-.719-.253-.948-.487l-.083-.09c-.2-.233-.33-.518-.405-1.054C1.002 9.41 1 8.66 1 7.525c0-1.149.002-1.91.082-2.492c.075-.544.205-.832.405-1.062c.023-.027.058-.065.082-.09c.226-.231.489-.378.959-.489c.517-.122 1.192-.182 2.236-.27M0 7.525c0-2.242 0-3.363.73-4.208c.036-.042.085-.095.124-.135c.78-.799 1.796-.885 3.826-1.056C5.57 2.05 6.527 2 7.5 2s1.93.05 2.82.126c2.03.171 3.046.257 3.826 1.056c.039.04.087.093.124.135c.73.845.73 1.966.73 4.208c0 2.215 0 3.323-.731 4.168a3 3 0 0 1-.125.135c-.781.799-1.778.882-3.773 1.048C9.48 12.951 8.508 13 7.5 13s-1.98-.05-2.87-.124c-1.996-.166-2.993-.25-3.774-1.048a3 3 0 0 1-.125-.135C0 10.848 0 9.74 0 7.525m5.25-2.142a.25.25 0 0 1 .35-.23l4.828 2.118c.2.088.2.37 0 .458L5.6 9.846a.25.25 0 0 1-.35-.229z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const JP = { name: "radix-icons-video", render: GP }, ZP = { class: "relative w-full items-center" }, YP = { class: "mt-2 flex w-full gap-2" }, XP = /* @__PURE__ */ _({
  __name: "YoutubeAddPopover",
  props: {
    editor: {}
  },
  setup(n) {
    const e = B("");
    function t() {
      n.editor && n.editor.chain().setYoutubeVideo({ src: e.value }).run();
    }
    return (r, o) => (b(), k(c(uf), null, {
      default: y(() => [
        x(c(ff), { "as-child": "" }, {
          default: y(() => [
            x(S$, { label: "YouTube Video hinzufügen" }, {
              icon: y((i) => [
                x(c(JP), Le(Ve(i)), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        x(c(cf), {
          "hide-when-detached": "",
          "as-child": "",
          class: "w-80",
          align: "start",
          side: "bottom"
        }, {
          default: y(() => [
            O("form", {
              class: "flex w-80 flex-col gap-3",
              onSubmit: At(t, ["prevent"])
            }, [
              O("div", ZP, [
                x(c(Rt), {
                  modelValue: e.value,
                  "onUpdate:modelValue": o[0] || (o[0] = (i) => e.value = i),
                  label: "YouTube Video URL"
                }, null, 8, ["modelValue"])
              ]),
              O("div", YP, [
                x(c(Re), {
                  type: "submit",
                  size: "small"
                }, {
                  default: y(() => o[1] || (o[1] = [
                    K(" Einfügen ")
                  ])),
                  _: 1
                })
              ])
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
function Wt(n) {
  this.content = n;
}
Wt.prototype = {
  constructor: Wt,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n)
        return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, o = r.find(n), i = r.content.slice();
    return o == -1 ? i.push(t || n, e) : (i[o + 1] = e, t && (i[o] = t)), new Wt(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1)
      return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Wt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Wt([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Wt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), o = r.content.slice(), i = r.find(n);
    return o.splice(i == -1 ? o.length : i, 0, e, t), new Wt(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Wt.from(n), n.size ? new Wt(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Wt.from(n), n.size ? new Wt(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Wt.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Wt.from = function(n) {
  if (n instanceof Wt)
    return n;
  var e = [];
  if (n)
    for (var t in n)
      e.push(t, n[t]);
  return new Wt(e);
};
function E$(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let o = n.child(r), i = e.child(r);
    if (o == i) {
      t += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return t;
    if (o.isText && o.text != i.text) {
      for (let a = 0; o.text[a] == i.text[a]; a++)
        t++;
      return t;
    }
    if (o.content.size || i.content.size) {
      let a = E$(o.content, i.content, t + 1);
      if (a != null)
        return a;
    }
    t += o.nodeSize;
  }
}
function O$(n, e, t, r) {
  for (let o = n.childCount, i = e.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: t, b: r };
    let a = n.child(--o), s = e.child(--i), l = a.nodeSize;
    if (a == s) {
      t -= l, r -= l;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: t, b: r };
    if (a.isText && a.text != s.text) {
      let d = 0, u = Math.min(a.text.length, s.text.length);
      for (; d < u && a.text[a.text.length - d - 1] == s.text[s.text.length - d - 1]; )
        d++, t--, r--;
      return { a: t, b: r };
    }
    if (a.content.size || s.content.size) {
      let d = O$(a.content, s.content, t - 1, r - 1);
      if (d)
        return d;
    }
    t -= l, r -= l;
  }
}
class W {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, o = 0, i) {
    for (let a = 0, s = 0; s < t; a++) {
      let l = this.content[a], d = s + l.nodeSize;
      if (d > e && r(l, o + s, i || null, a) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), r, o + u);
      }
      s = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, o) {
    let i = "", a = !0;
    return this.nodesBetween(e, t, (s, l) => {
      let d = s.isText ? s.text.slice(Math.max(e, l) - l, t - l) : s.isLeaf ? o ? typeof o == "function" ? o(s) : o : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && d || s.isTextblock) && r && (a ? a = !1 : i += r), i += d;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, o = this.content.slice(), i = 0;
    for (t.isText && t.sameMarkup(r) && (o[o.length - 1] = t.withText(t.text + r.text), i = 1); i < e.content.length; i++)
      o.push(e.content[i]);
    return new W(o, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], o = 0;
    if (t > e)
      for (let i = 0, a = 0; a < t; i++) {
        let s = this.content[i], l = a + s.nodeSize;
        l > e && ((a < e || l > t) && (s.isText ? s = s.cut(Math.max(0, e - a), Math.min(s.text.length, t - a)) : s = s.cut(Math.max(0, e - a - 1), Math.min(s.content.size, t - a - 1))), r.push(s), o += s.nodeSize), a = l;
      }
    return new W(r, o);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? W.empty : e == 0 && t == this.content.length ? this : new W(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let o = this.content.slice(), i = this.size + t.nodeSize - r.nodeSize;
    return o[e] = t, new W(o, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new W([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new W(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let o = this.content[t];
      e(o, r, t), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return E$(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return O$(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, t = -1) {
    if (e == 0)
      return Bd(0, e);
    if (e == this.size)
      return Bd(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let i = this.child(r), a = o + i.nodeSize;
      if (a >= e)
        return a == e || t > 0 ? Bd(r + 1, a) : Bd(r, o);
      o = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return W.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new W(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return W.empty;
    let t, r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      r += i.nodeSize, o && i.isText && e[o - 1].sameMarkup(i) ? (t || (t = e.slice(0, o)), t[t.length - 1] = i.withText(t[t.length - 1].text + i.text)) : t && t.push(i);
    }
    return new W(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return W.empty;
    if (e instanceof W)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new W([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
W.empty = new W([], 0);
const cp = { index: 0, offset: 0 };
function Bd(n, e) {
  return cp.index = n, cp.offset = e, cp;
}
function Hu(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Hu(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Hu(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let ft = class Ph {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      if (this.eq(i))
        return e;
      if (this.type.excludes(i.type))
        t || (t = e.slice(0, o));
      else {
        if (i.type.excludes(this.type))
          return e;
        !r && i.type.rank > this.type.rank && (t || (t = e.slice(0, o)), t.push(this), r = !0), t && t.push(i);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Hu(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let o = r.create(t.attrs);
    return r.checkAttrs(o.attrs), o;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Ph.none;
    if (e instanceof Ph)
      return [e];
    let t = e.slice();
    return t.sort((r, o) => r.type.rank - o.type.rank), t;
  }
};
ft.none = [];
class Vl extends Error {
}
class Y {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = A$(this.content, e + this.openStart, t);
    return r && new Y(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new Y(T$(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Y.empty;
    let r = t.openStart || 0, o = t.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Y(W.fromJSON(e, t.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, o = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (t || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = e.lastChild; i && !i.isLeaf && (t || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new Y(e, r, o);
  }
}
Y.empty = new Y(W.empty, 0, 0);
function T$(n, e, t) {
  let { index: r, offset: o } = n.findIndex(e), i = n.maybeChild(r), { index: a, offset: s } = n.findIndex(t);
  if (o == e || i.isText) {
    if (s != t && !n.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != a)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, i.copy(T$(i.content, e - o - 1, t - o - 1)));
}
function A$(n, e, t, r) {
  let { index: o, offset: i } = n.findIndex(e), a = n.maybeChild(o);
  if (i == e || a.isText)
    return r && !r.canReplace(o, o, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let s = A$(a.content, e - i - 1, t);
  return s && n.replaceChild(o, a.copy(s));
}
function QP(n, e, t) {
  if (t.openStart > n.depth)
    throw new Vl("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Vl("Inconsistent open depths");
  return M$(n, e, t, 0);
}
function M$(n, e, t, r) {
  let o = n.index(r), i = n.node(r);
  if (o == e.index(r) && r < n.depth - t.openStart) {
    let a = M$(n, e, t, r + 1);
    return i.copy(i.content.replaceChild(o, a));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let a = n.parent, s = a.content;
      return Mi(a, s.cut(0, n.parentOffset).append(t.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: a, end: s } = eD(t, n);
      return Mi(i, P$(n, a, s, e, r));
    }
  else
    return Mi(i, Uu(n, e, r));
}
function N$(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Vl("Cannot join " + e.type.name + " onto " + n.type.name);
}
function Dh(n, e, t) {
  let r = n.node(t);
  return N$(r, e.node(t)), r;
}
function Ai(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function tl(n, e, t, r) {
  let o = (e || n).node(t), i = 0, a = e ? e.index(t) : o.childCount;
  n && (i = n.index(t), n.depth > t ? i++ : n.textOffset && (Ai(n.nodeAfter, r), i++));
  for (let s = i; s < a; s++)
    Ai(o.child(s), r);
  e && e.depth == t && e.textOffset && Ai(e.nodeBefore, r);
}
function Mi(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function P$(n, e, t, r, o) {
  let i = n.depth > o && Dh(n, e, o + 1), a = r.depth > o && Dh(t, r, o + 1), s = [];
  return tl(null, n, o, s), i && a && e.index(o) == t.index(o) ? (N$(i, a), Ai(Mi(i, P$(n, e, t, r, o + 1)), s)) : (i && Ai(Mi(i, Uu(n, e, o + 1)), s), tl(e, t, o, s), a && Ai(Mi(a, Uu(t, r, o + 1)), s)), tl(r, null, o, s), new W(s);
}
function Uu(n, e, t) {
  let r = [];
  if (tl(null, n, t, r), n.depth > t) {
    let o = Dh(n, e, t + 1);
    Ai(Mi(o, Uu(n, e, t + 1)), r);
  }
  return tl(e, null, t, r), new W(r);
}
function eD(n, e) {
  let t = e.depth - n.openStart, o = e.node(t).copy(n.content);
  for (let i = t - 1; i >= 0; i--)
    o = e.node(i).copy(W.from(o));
  return {
    start: o.resolveNoCache(n.openStart + t),
    end: o.resolveNoCache(o.content.size - n.openEnd - t)
  };
}
class zl {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = e.child(t);
    return r ? e.child(t).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], o = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let i = 0; i < e; i++)
      o += r.child(i).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return ft.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), o = e.maybeChild(t);
    if (!r) {
      let s = r;
      r = o, o = s;
    }
    let i = r.marks;
    for (var a = 0; a < i.length; a++)
      i[a].type.spec.inclusive === !1 && (!o || !i[a].isInSet(o.marks)) && (i = i[a--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, o = e.parent.maybeChild(e.index());
    for (var i = 0; i < r.length; i++)
      r[i].type.spec.inclusive === !1 && (!o || !r[i].isInSet(o.marks)) && (r = r[i--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new Ku(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], o = 0, i = t;
    for (let a = e; ; ) {
      let { index: s, offset: l } = a.content.findIndex(i), d = i - l;
      if (r.push(a, s, o + l), !d || (a = a.child(s), a.isText))
        break;
      i = d - 1, o += l + 1;
    }
    return new zl(t, r, i);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = Ov.get(e);
    if (r)
      for (let i = 0; i < r.elts.length; i++) {
        let a = r.elts[i];
        if (a.pos == t)
          return a;
      }
    else
      Ov.set(e, r = new tD());
    let o = r.elts[r.i] = zl.resolve(e, t);
    return r.i = (r.i + 1) % nD, o;
  }
}
class tD {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const nD = 12, Ov = /* @__PURE__ */ new WeakMap();
class Ku {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const rD = /* @__PURE__ */ Object.create(null);
let Ko = class Ih {
  /**
  @internal
  */
  constructor(e, t, r, o = ft.none) {
    this.type = e, this.attrs = t, this.marks = o, this.content = r || W.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, o = 0) {
    this.content.nodesBetween(e, t, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, t, r, o) {
    return this.content.textBetween(e, t, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Hu(this.attrs, t || e.defaultAttrs || rD) && ft.sameSet(this.marks, r || ft.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Ih(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Ih(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return Y.empty;
    let o = this.resolve(e), i = this.resolve(t), a = r ? 0 : o.sharedDepth(t), s = o.start(a), d = o.node(a).content.cut(o.pos - s, i.pos - s);
    return new Y(d, o.depth - a, i.depth - a);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return QP(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: o } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (o == e || t.isText)
        return t;
      e -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let o = this.content.child(t - 1);
    return { node: o, index: t - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return zl.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return zl.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let o = !1;
    return t > e && this.nodesBetween(e, t, (i) => (r.isInSet(i.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), D$(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = W.empty, o = 0, i = r.childCount) {
    let a = this.contentMatchAt(e).matchFragment(r, o, i), s = a && a.matchFragment(this.content, t);
    if (!s || !s.validEnd)
      return !1;
    for (let l = o; l < i; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let i = this.contentMatchAt(e).matchType(r), a = i && i.matchFragment(this.content, t);
    return a ? a.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = ft.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!ft.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let o = W.fromJSON(e, t.content), i = e.nodeType(t.type).create(t.attrs, o, r);
    return i.type.checkAttrs(i.attrs), i;
  }
};
Ko.prototype.text = void 0;
class Wu extends Ko {
  /**
  @internal
  */
  constructor(e, t, r, o) {
    if (super(e, t, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : D$(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Wu(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Wu(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function D$(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class Hi {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new oD(e, t);
    if (r.next == null)
      return Hi.empty;
    let o = I$(r);
    r.next && r.err("Unexpected trailing text");
    let i = cD(uD(o));
    return fD(i, r), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let o = this;
    for (let i = t; o && i < r; i++)
      o = o.matchType(e.child(i).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let o = [this];
    function i(a, s) {
      let l = a.matchFragment(e, r);
      if (l && (!t || l.validEnd))
        return W.from(s.map((d) => d.createAndFill()));
      for (let d = 0; d < a.next.length; d++) {
        let { type: u, next: f } = a.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && o.indexOf(f) == -1) {
          o.push(f);
          let p = i(f, s.concat(u));
          if (p)
            return p;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), i = o.match;
      if (i.matchType(e)) {
        let a = [];
        for (let s = o; s.type; s = s.via)
          a.push(s.type);
        return a.reverse();
      }
      for (let a = 0; a < i.next.length; a++) {
        let { type: s, next: l } = i.next[a];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in t) && (!o.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: o }), t[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let o = 0; o < r.next.length; o++)
        e.indexOf(r.next[o].next) == -1 && t(r.next[o].next);
    }
    return t(this), e.map((r, o) => {
      let i = o + (r.validEnd ? "*" : " ") + " ";
      for (let a = 0; a < r.next.length; a++)
        i += (a ? ", " : "") + r.next[a].type.name + "->" + e.indexOf(r.next[a].next);
      return i;
    }).join(`
`);
  }
}
Hi.empty = new Hi(!0);
class oD {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function I$(n) {
  let e = [];
  do
    e.push(iD(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function iD(n) {
  let e = [];
  do
    e.push(aD(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function aD(n) {
  let e = dD(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = sD(n, e);
    else
      break;
  return e;
}
function Tv(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function sD(n, e) {
  let t = Tv(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = Tv(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function lD(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let o = [];
  for (let i in t) {
    let a = t[i];
    a.isInGroup(e) && o.push(a);
  }
  return o.length == 0 && n.err("No node type or group '" + e + "' found"), o;
}
function dD(n) {
  if (n.eat("(")) {
    let e = I$(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = lD(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function uD(n) {
  let e = [[]];
  return o(i(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(a, s, l) {
    let d = { term: l, to: s };
    return e[a].push(d), d;
  }
  function o(a, s) {
    a.forEach((l) => l.to = s);
  }
  function i(a, s) {
    if (a.type == "choice")
      return a.exprs.reduce((l, d) => l.concat(i(d, s)), []);
    if (a.type == "seq")
      for (let l = 0; ; l++) {
        let d = i(a.exprs[l], s);
        if (l == a.exprs.length - 1)
          return d;
        o(d, s = t());
      }
    else if (a.type == "star") {
      let l = t();
      return r(s, l), o(i(a.expr, l), l), [r(l)];
    } else if (a.type == "plus") {
      let l = t();
      return o(i(a.expr, s), l), o(i(a.expr, l), l), [r(l)];
    } else {
      if (a.type == "opt")
        return [r(s)].concat(i(a.expr, s));
      if (a.type == "range") {
        let l = s;
        for (let d = 0; d < a.min; d++) {
          let u = t();
          o(i(a.expr, l), u), l = u;
        }
        if (a.max == -1)
          o(i(a.expr, l), l);
        else
          for (let d = a.min; d < a.max; d++) {
            let u = t();
            r(l, u), o(i(a.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (a.type == "name")
          return [r(s, void 0, a.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function R$(n, e) {
  return e - n;
}
function Av(n, e) {
  let t = [];
  return r(e), t.sort(R$);
  function r(o) {
    let i = n[o];
    if (i.length == 1 && !i[0].term)
      return r(i[0].to);
    t.push(o);
    for (let a = 0; a < i.length; a++) {
      let { term: s, to: l } = i[a];
      !s && t.indexOf(l) == -1 && r(l);
    }
  }
}
function cD(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Av(n, 0));
  function t(r) {
    let o = [];
    r.forEach((a) => {
      n[a].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let d;
        for (let u = 0; u < o.length; u++)
          o[u][0] == s && (d = o[u][1]);
        Av(n, l).forEach((u) => {
          d || o.push([s, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let i = e[r.join(",")] = new Hi(r.indexOf(n.length - 1) > -1);
    for (let a = 0; a < o.length; a++) {
      let s = o[a][1].sort(R$);
      i.next.push({ type: o[a][0], next: e[s.join(",")] || t(s) });
    }
    return i;
  }
}
function fD(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let o = r[t], i = !o.validEnd, a = [];
    for (let s = 0; s < o.next.length; s++) {
      let { type: l, next: d } = o.next[s];
      a.push(l.name), i && !(l.isText || l.hasRequiredAttrs()) && (i = !1), r.indexOf(d) == -1 && r.push(d);
    }
    i && e.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function B$(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function L$(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let o = e && e[r];
    if (o === void 0) {
      let i = n[r];
      if (i.hasDefault)
        o = i.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = o;
  }
  return t;
}
function F$(n, e, t, r) {
  for (let o in e)
    if (!(o in n))
      throw new RangeError(`Unsupported attribute ${o} for ${t} of type ${o}`);
  for (let o in n) {
    let i = n[o];
    i.validate && i.validate(e[o]);
  }
}
function V$(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new hD(n, r, e[r]);
  return t;
}
let Mv = class z$ {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = V$(e, r.attrs), this.defaultAttrs = B$(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Hi.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : L$(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Ko(this, this.computeAttrs(e), W.from(t), ft.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = W.from(t), this.checkContent(t), new Ko(this, this.computeAttrs(e), t, ft.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = W.from(t), t.size) {
      let a = this.contentMatch.fillBefore(t);
      if (!a)
        return null;
      t = a.append(t);
    }
    let o = this.contentMatch.matchFragment(t), i = o && o.fillBefore(W.empty, !0);
    return i ? new Ko(this, e, t.append(i), ft.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    F$(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : ft.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((i, a) => r[i] = new z$(i, t, a));
    let o = t.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function pD(n, e, t) {
  let r = t.split("|");
  return (o) => {
    let i = o === null ? "null" : typeof o;
    if (r.indexOf(i) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${i}`);
  };
}
class hD {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? pD(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class vd {
  /**
  @internal
  */
  constructor(e, t, r, o) {
    this.name = e, this.rank = t, this.schema = r, this.spec = o, this.attrs = V$(e, o.attrs), this.excluded = null;
    let i = B$(this.attrs);
    this.instance = i ? new ft(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new ft(this, L$(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return e.forEach((i, a) => r[i] = new vd(i, o++, t, a)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    F$(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class j$ {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let o in e)
      t[o] = e[o];
    t.nodes = Wt.from(e.nodes), t.marks = Wt.from(e.marks || {}), this.nodes = Mv.compile(this.spec.nodes, this), this.marks = vd.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let i = this.nodes[o], a = i.spec.content || "", s = i.spec.marks;
      if (i.contentMatch = r[a] || (r[a] = Hi.parse(a, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = s == "_" ? null : s ? Nv(this, s.split(" ")) : s == "" || !i.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let i = this.marks[o], a = i.spec.excludes;
      i.excluded = a == null ? [i] : a == "" ? [] : Nv(this, a.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, o) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Mv) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else
      throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new Wu(r, r.defaultAttrs, e, ft.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return Ko.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return ft.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Nv(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r], i = n.marks[o], a = i;
    if (i)
      t.push(i);
    else
      for (let s in n.marks) {
        let l = n.marks[s];
        (o == "_" || l.spec.group && l.spec.group.split(" ").indexOf(o) > -1) && t.push(a = l);
      }
    if (!a)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function mD(n) {
  return n.tag != null;
}
function gD(n) {
  return n.style != null;
}
class Wo {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((o) => {
      if (mD(o))
        this.tags.push(o);
      else if (gD(o)) {
        let i = /[^=]*/.exec(o.style)[0];
        r.indexOf(i) < 0 && r.push(i), this.styles.push(o);
      }
    }), this.normalizeLists = !this.tags.some((o) => {
      if (!/^(ul|ol)\b/.test(o.tag) || !o.node)
        return !1;
      let i = e.nodes[o.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new Dv(this, t, !1);
    return r.addAll(e, ft.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new Dv(this, t, !0);
    return r.addAll(e, ft.none, t.from, t.to), Y.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let i = this.tags[o];
      if (bD(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || t.matchesContext(i.context))) {
        if (i.getAttrs) {
          let a = i.getAttrs(e);
          if (a === !1)
            continue;
          i.attrs = a || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, o) {
    for (let i = o ? this.styles.indexOf(o) + 1 : 0; i < this.styles.length; i++) {
      let a = this.styles[i], s = a.style;
      if (!(s.indexOf(e) != 0 || a.context && !r.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != t))) {
        if (a.getAttrs) {
          let l = a.getAttrs(t);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(o) {
      let i = o.priority == null ? 50 : o.priority, a = 0;
      for (; a < t.length; a++) {
        let s = t[a];
        if ((s.priority == null ? 50 : s.priority) < i)
          break;
      }
      t.splice(a, 0, o);
    }
    for (let o in e.marks) {
      let i = e.marks[o].spec.parseDOM;
      i && i.forEach((a) => {
        r(a = Iv(a)), a.mark || a.ignore || a.clearMark || (a.mark = o);
      });
    }
    for (let o in e.nodes) {
      let i = e.nodes[o].spec.parseDOM;
      i && i.forEach((a) => {
        r(a = Iv(a)), a.node || a.ignore || a.mark || (a.node = o);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Wo(e, Wo.schemaRules(e)));
  }
}
const H$ = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, vD = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, U$ = { ol: !0, ul: !0 }, jl = 1, Rh = 2, nl = 4;
function Pv(n, e, t) {
  return e != null ? (e ? jl : 0) | (e === "full" ? Rh : 0) : n && n.whitespace == "pre" ? jl | Rh : t & ~nl;
}
class Ld {
  constructor(e, t, r, o, i, a) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = o, this.options = a, this.content = [], this.activeMarks = ft.none, this.match = i || (a & nl ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(W.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & jl)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let i = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - o[0].length));
      }
    }
    let t = W.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(W.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !H$.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Dv {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let o = t.topNode, i, a = Pv(null, t.preserveWhitespace, 0) | (r ? nl : 0);
    o ? i = new Ld(o.type, o.attrs, ft.none, !0, t.topMatch || o.type.contentMatch, a) : r ? i = new Ld(null, null, ft.none, !0, null, a) : i = new Ld(e.schema.topNodeType, null, ft.none, !0, null, a), this.nodes = [i], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, o = this.top, i = o.options & Rh ? "full" : this.localPreserveWS || (o.options & jl) > 0;
    if (i === "full" || o.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (i)
        i !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let a = o.content[o.content.length - 1], s = e.previousSibling;
        (!a || s && s.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), t), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let o = this.localPreserveWS, i = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let a = e.nodeName.toLowerCase(), s;
    U$.hasOwnProperty(a) && this.parser.normalizeLists && yD(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, r));
    e:
      if (l ? l.ignore : vD.hasOwnProperty(a))
        this.findInside(e), this.ignoreFallback(e, t);
      else if (!l || l.skip || l.closeParent) {
        l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
        let d, u = this.needsBlock;
        if (H$.hasOwnProperty(a))
          i.content.length && i.content[0].isInline && this.open && (this.open--, i = this.top), d = !0, i.type || (this.needsBlock = !0);
        else if (!e.firstChild) {
          this.leafFallback(e, t);
          break e;
        }
        let f = l && l.skip ? t : this.readStyles(e, t);
        f && this.addAll(e, f), d && this.sync(i), this.needsBlock = u;
      } else {
        let d = this.readStyles(e, t);
        d && this.addElementByRule(e, l, d, l.consuming === !1 ? s : void 0);
      }
    this.localPreserveWS = o;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let o = 0; o < this.parser.matchedStyles.length; o++) {
        let i = this.parser.matchedStyles[o], a = r.getPropertyValue(i);
        if (a)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(i, a, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((d) => !l.clearMark(d)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, o) {
    let i, a;
    if (t.node)
      if (a = this.parser.schema.nodes[t.node], a.isLeaf)
        this.insertNode(a.create(t.attrs), r) || this.leafFallback(e, r);
      else {
        let l = this.enter(a, t.attrs || null, r, t.preserveWhitespace);
        l && (i = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      r = r.concat(l.create(t.attrs));
    }
    let s = this.top;
    if (a && a.isLeaf)
      this.findInside(e);
    else if (o)
      this.addElement(e, r, o);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    i && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, o) {
    let i = r || 0;
    for (let a = r ? e.childNodes[r] : e.firstChild, s = o == null ? null : e.childNodes[o]; a != s; a = a.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(a, t);
    this.findAtPoint(e, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t) {
    let r, o;
    for (let i = this.open; i >= 0; i--) {
      let a = this.nodes[i], s = a.findWrapping(e);
      if (s && (!r || r.length > s.length) && (r = s, o = a, !s.length) || a.solid)
        break;
    }
    if (!r)
      return null;
    this.sync(o);
    for (let i = 0; i < r.length; i++)
      t = this.enterInner(r[i], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (t = this.enterInner(o, null, t));
    }
    let r = this.findPlace(e, t);
    if (r) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(e.type));
      let i = ft.none;
      for (let a of r.concat(e.marks))
        (o.type ? o.type.allowsMarkType(a.type) : Rv(a.type, e.type)) && (i = a.addToSet(i));
      return o.content.push(e.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, o) {
    let i = this.findPlace(e.create(t), r);
    return i && (i = this.enterInner(e, t, r, !0, o)), i;
  }
  // Open a node of the given type
  enterInner(e, t, r, o = !1, i) {
    this.closeExtra();
    let a = this.top;
    a.match = a.match && a.match.matchType(e);
    let s = Pv(e, i, a.options);
    a.options & nl && a.content.length == 0 && (s |= nl);
    let l = ft.none;
    return r = r.filter((d) => (a.type ? a.type.allowsMarkType(d.type) : Rv(d.type, e)) ? (l = d.addToSet(l), !1) : !0), this.nodes.push(new Ld(e, t, l, o, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= jl);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && t.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), i = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), a = (s, l) => {
      for (; s >= 0; s--) {
        let d = t[s];
        if (d == "") {
          if (s == t.length - 1 || s == 0)
            continue;
          for (; l >= i; l--)
            if (a(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && o ? this.nodes[l].type : r && l >= i ? r.node(l - i).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return a(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function yD(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && U$.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function bD(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function Iv(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function Rv(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let o = t[r];
    if (!o.allowsMarkType(n))
      continue;
    let i = [], a = (s) => {
      i.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: d, next: u } = s.edge(l);
        if (d == e || i.indexOf(u) < 0 && a(u))
          return !0;
      }
    };
    if (a(o.contentMatch))
      return !0;
  }
}
class oa {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = fp(t).createDocumentFragment());
    let o = r, i = [];
    return e.forEach((a) => {
      if (i.length || a.marks.length) {
        let s = 0, l = 0;
        for (; s < i.length && l < a.marks.length; ) {
          let d = a.marks[l];
          if (!this.marks[d.type.name]) {
            l++;
            continue;
          }
          if (!d.eq(i[s][0]) || d.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < i.length; )
          o = i.pop()[1];
        for (; l < a.marks.length; ) {
          let d = a.marks[l++], u = this.serializeMark(d, a.isInline, t);
          u && (i.push([d, o]), o.appendChild(u.dom), o = u.contentDOM || u.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(a, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: o } = au(fp(t), this.nodes[e.type.name](e), null, e.attrs);
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let i = this.serializeMark(e.marks[o], e.isInline, t);
      i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let o = this.marks[e.type.name];
    return o && au(fp(r), o(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, o) {
    return au(e, t, r, o);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new oa(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = Bv(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return Bv(e.marks);
  }
}
function Bv(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function fp(n) {
  return n.document || window.document;
}
const Lv = /* @__PURE__ */ new WeakMap();
function $D(n) {
  let e = Lv.get(n);
  return e === void 0 && Lv.set(n, e = wD(n)), e;
}
function wD(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let o = 0; o < r.length; o++)
            t(r[o]);
      else
        for (let o in r)
          t(r[o]);
  }
  return t(n), e;
}
function au(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let o = e[0], i;
  if (typeof o != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (i = $D(r)) && i.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let a = o.indexOf(" ");
  a > 0 && (t = o.slice(0, a), o = o.slice(a + 1));
  let s, l = t ? n.createElementNS(t, o) : n.createElement(o), d = e[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let f in d)
      if (d[f] != null) {
        let p = f.indexOf(" ");
        p > 0 ? l.setAttributeNS(f.slice(0, p), f.slice(p + 1), d[f]) : l.setAttribute(f, d[f]);
      }
  }
  for (let f = u; f < e.length; f++) {
    let p = e[f];
    if (p === 0) {
      if (f < e.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: m } = au(n, p, t, r);
      if (l.appendChild(h), m) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = m;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const K$ = 65535, W$ = Math.pow(2, 16);
function xD(n, e) {
  return n + e * W$;
}
function Fv(n) {
  return n & K$;
}
function CD(n) {
  return (n - (n & K$)) / W$;
}
const q$ = 1, G$ = 2, su = 4, J$ = 8;
let Bh = class {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & J$) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (q$ | su)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (G$ | su)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & su) > 0;
  }
}, Ui = class ma {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && ma.empty)
      return ma.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = Fv(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        t += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + t + CD(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0, i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let d = this.ranges[s + i], u = this.ranges[s + a], f = l + d;
      if (e <= f) {
        let p = d ? e == l ? -1 : e == f ? 1 : t : t, h = l + o + (p < 0 ? 0 : u);
        if (r)
          return h;
        let m = e == (t < 0 ? l : f) ? null : xD(s / 3, e - l), g = e == l ? G$ : e == f ? q$ : su;
        return (t < 0 ? e != l : e != f) && (g |= J$), new Bh(h, g, m);
      }
      o += u - d;
    }
    return r ? e + o : new Bh(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, o = Fv(t), i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let d = this.ranges[s + i], u = l + d;
      if (e <= u && s == o * 3)
        return !0;
      r += this.ranges[s + a] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o], s = a - (this.inverted ? i : 0), l = a + (this.inverted ? 0 : i), d = this.ranges[o + t], u = this.ranges[o + r];
      e(s, s + d, l, l + u), i += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ma(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? ma.empty : new ma(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
};
Ui.empty = new Ui([]);
let kD = class lu {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], t, r = 0, o = e.length) {
    this.maps = e, this.mirror = t, this.from = r, this.to = o;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new lu(this.maps, this.mirror, e, t);
  }
  /**
  @internal
  */
  copy() {
    return new lu(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this.maps.length; t < e.maps.length; t++) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t], o != null && o < t ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this.maps.length + e.maps.length; t >= 0; t--) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), o != null && o > t ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new lu();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this.maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0;
    for (let i = this.from; i < this.to; i++) {
      let a = this.maps[i], s = a.mapResult(e, t);
      if (s.recover != null) {
        let l = this.getMirror(i);
        if (l != null && l > i && l < this.to) {
          i = l, e = this.maps[l].recover(s.recover);
          continue;
        }
      }
      o |= s.delInfo, e = s.pos;
    }
    return r ? e : new Bh(e, o, null);
  }
};
const pp = /* @__PURE__ */ Object.create(null);
let dn = class {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Ui.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = pp[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in pp)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return pp[e] = t, t.prototype.jsonID = e, t;
  }
}, fn = class Fs {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Fs(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Fs(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, o) {
    try {
      return Fs.ok(e.replace(t, r, o));
    } catch (i) {
      if (i instanceof Vl)
        return Fs.fail(i.message);
      throw i;
    }
  }
};
function w0(n, e, t) {
  let r = [];
  for (let o = 0; o < n.childCount; o++) {
    let i = n.child(o);
    i.content.size && (i = i.copy(w0(i.content, e, i))), i.isInline && (i = e(i, t, o)), r.push(i);
  }
  return W.fromArray(r);
}
let x0 = class Vs extends dn {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new Y(w0(t.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), o), t.openStart, t.openEnd);
    return fn.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new yd(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Vs(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Vs && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Vs(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Vs(t.from, t.to, e.markFromJSON(t.mark));
  }
};
dn.jsonID("addMark", x0);
let yd = class zs extends dn {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new Y(w0(t.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), t.openStart, t.openEnd);
    return fn.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new x0(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new zs(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof zs && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new zs(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new zs(t.from, t.to, e.markFromJSON(t.mark));
  }
};
dn.jsonID("removeMark", yd);
let C0 = class js extends dn {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return fn.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return fn.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let o = 0; o < t.marks.length; o++)
          if (!t.marks[o].isInSet(r))
            return new js(this.pos, t.marks[o]);
        return new js(this.pos, this.mark);
      }
    }
    return new k0(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new js(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new js(t.pos, e.markFromJSON(t.mark));
  }
};
dn.jsonID("addNodeMark", C0);
let k0 = class Lh extends dn {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return fn.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return fn.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new C0(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Lh(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Lh(t.pos, e.markFromJSON(t.mark));
  }
};
dn.jsonID("removeNodeMark", k0);
let wo = class yi extends dn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, o = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && Fh(e, this.from, this.to) ? fn.fail("Structure replace would overwrite content") : fn.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Ui([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new yi(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new yi(t.pos, Math.max(t.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof yi) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? Y.empty : new Y(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new yi(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? Y.empty : new Y(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new yi(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new yi(t.from, t.to, Y.fromJSON(e, t.slice), !!t.structure);
  }
};
dn.jsonID("replace", wo);
let ia = class du extends dn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, o, i, a, s = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = a, this.structure = s;
  }
  apply(e) {
    if (this.structure && (Fh(e, this.from, this.gapFrom) || Fh(e, this.gapTo, this.to)))
      return fn.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return fn.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? fn.fromReplace(e, this.from, this.to, r) : fn.fail("Content does not fit in gap");
  }
  getMap() {
    return new Ui([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new du(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || o < t.pos || i > r.pos ? null : new du(t.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new du(t.from, t.to, t.gapFrom, t.gapTo, Y.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
};
dn.jsonID("replaceAround", ia);
function Fh(n, e, t) {
  let r = n.resolve(e), o = t - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let a = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, o--;
    }
  }
  return !1;
}
function _D(n, e, t, r) {
  let o = [], i = [], a, s;
  n.doc.nodesBetween(e, t, (l, d, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!r.isInSet(f) && u.type.allowsMarkType(r.type)) {
      let p = Math.max(d, e), h = Math.min(d + l.nodeSize, t), m = r.addToSet(f);
      for (let g = 0; g < f.length; g++)
        f[g].isInSet(m) || (a && a.to == p && a.mark.eq(f[g]) ? a.to = h : o.push(a = new yd(p, h, f[g])));
      s && s.to == p ? s.to = h : i.push(s = new x0(p, h, r));
    }
  }), o.forEach((l) => n.step(l)), i.forEach((l) => n.step(l));
}
function SD(n, e, t, r) {
  let o = [], i = 0;
  n.doc.nodesBetween(e, t, (a, s) => {
    if (!a.isInline)
      return;
    i++;
    let l = null;
    if (r instanceof vd) {
      let d = a.marks, u;
      for (; u = r.isInSet(d); )
        (l || (l = [])).push(u), d = u.removeFromSet(d);
    } else
      r ? r.isInSet(a.marks) && (l = [r]) : l = a.marks;
    if (l && l.length) {
      let d = Math.min(s + a.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], p;
        for (let h = 0; h < o.length; h++) {
          let m = o[h];
          m.step == i - 1 && f.eq(o[h].style) && (p = m);
        }
        p ? (p.to = d, p.step = i) : o.push({ style: f, from: Math.max(s, e), to: d, step: i });
      }
    }
  }), o.forEach((a) => n.step(new yd(a.from, a.to, a.style)));
}
function Z$(n, e, t, r = t.contentMatch, o = !0) {
  let i = n.doc.nodeAt(e), a = [], s = e + 1;
  for (let l = 0; l < i.childCount; l++) {
    let d = i.child(l), u = s + d.nodeSize, f = r.matchType(d.type);
    if (!f)
      a.push(new wo(s, u, Y.empty));
    else {
      r = f;
      for (let p = 0; p < d.marks.length; p++)
        t.allowsMarkType(d.marks[p].type) || n.step(new yd(s, u, d.marks[p]));
      if (o && d.isText && t.whitespace != "pre") {
        let p, h = /\r?\n|\r/g, m;
        for (; p = h.exec(d.text); )
          m || (m = new Y(W.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), a.push(new wo(s + p.index, s + p.index + p[0].length, m));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(W.empty, !0);
    n.replace(s, s, new Y(l, 0, 0));
  }
  for (let l = a.length - 1; l >= 0; l--)
    n.step(a[l]);
}
function ED(n, e, t) {
  let { $from: r, $to: o, depth: i } = e, a = r.before(i + 1), s = o.after(i + 1), l = a, d = s, u = W.empty, f = 0;
  for (let m = i, g = !1; m > t; m--)
    g || r.index(m) > 0 ? (g = !0, u = W.from(r.node(m).copy(u)), f++) : l--;
  let p = W.empty, h = 0;
  for (let m = i, g = !1; m > t; m--)
    g || o.after(m + 1) < o.end(m) ? (g = !0, p = W.from(o.node(m).copy(p)), h++) : d++;
  n.step(new ia(l, d, a, s, new Y(u.append(p), f, h), u.size - f, !0));
}
function OD(n, e, t) {
  let r = W.empty;
  for (let a = t.length - 1; a >= 0; a--) {
    if (r.size) {
      let s = t[a].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = W.from(t[a].type.create(t[a].attrs, r));
  }
  let o = e.start, i = e.end;
  n.step(new ia(o, i, o, i, new Y(r, 0, 0), t.length, !0));
}
function TD(n, e, t, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = n.steps.length;
  n.doc.nodesBetween(e, t, (a, s) => {
    let l = typeof o == "function" ? o(a) : o;
    if (a.isTextblock && !a.hasMarkup(r, l) && ND(n.doc, n.mapping.slice(i).map(s), r)) {
      let d = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", m = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !m ? d = !1 : !h && m && (d = !0);
      }
      d === !1 && MD(n, a, s, i), Z$(n, n.mapping.slice(i).map(s, 1), r, void 0, d === null);
      let u = n.mapping.slice(i), f = u.map(s, 1), p = u.map(s + a.nodeSize, 1);
      return n.step(new ia(f, p, f + 1, p - 1, new Y(W.from(r.create(l, null, a.marks)), 0, 0), 1, !0)), d === !0 && AD(n, a, s, i), !1;
    }
  });
}
function AD(n, e, t, r) {
  e.forEach((o, i) => {
    if (o.isText) {
      let a, s = /\r?\n|\r/g;
      for (; a = s.exec(o.text); ) {
        let l = n.mapping.slice(r).map(t + 1 + i + a.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function MD(n, e, t, r) {
  e.forEach((o, i) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let a = n.mapping.slice(r).map(t + 1 + i);
      n.replaceWith(a, a + 1, e.type.schema.text(`
`));
    }
  });
}
function ND(n, e, t) {
  let r = n.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, t);
}
function PD(n, e, t, r, o) {
  let i = n.doc.nodeAt(e);
  if (!i)
    throw new RangeError("No node at given position");
  t || (t = i.type);
  let a = t.create(r, null, o || i.marks);
  if (i.isLeaf)
    return n.replaceWith(e, e + i.nodeSize, a);
  if (!t.validContent(i.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new ia(e, e + i.nodeSize, e + 1, e + i.nodeSize - 1, new Y(W.from(a), 0, 0), 1, !0));
}
function DD(n, e, t = 1, r) {
  let o = n.doc.resolve(e), i = W.empty, a = W.empty;
  for (let s = o.depth, l = o.depth - t, d = t - 1; s > l; s--, d--) {
    i = W.from(o.node(s).copy(i));
    let u = r && r[d];
    a = W.from(u ? u.type.create(u.attrs, a) : o.node(s).copy(a));
  }
  n.step(new wo(e, e, new Y(i.append(a), t, t), !0));
}
function ID(n, e, t) {
  let r = new wo(e - t, e + t, Y.empty, !0);
  n.step(r);
}
function RD(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.index(o);
      if (r.node(o).canReplaceWith(i, i, t))
        return r.before(o + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.indexAfter(o);
      if (r.node(o).canReplaceWith(i, i, t))
        return r.after(o + 1);
      if (i < r.node(o).childCount)
        return null;
    }
  return null;
}
function BD(n, e, t = e, r = Y.empty) {
  if (e == t && !r.size)
    return null;
  let o = n.resolve(e), i = n.resolve(t);
  return Y$(o, i, r) ? new wo(e, t, r) : new LD(o, i, r).fit();
}
function Y$(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
let LD = class {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = W.empty;
    for (let o = 0; o <= e.depth; o++) {
      let i = e.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = W.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let i = this.placed, a = r.depth, s = o.depth;
    for (; a && s && i.childCount == 1; )
      i = i.firstChild.content, a--, s--;
    let l = new Y(i, a, s);
    return e > -1 ? new ia(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new wo(r.pos, o.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let i = t.firstChild;
      if (t.childCount > 1 && (o = 0), i.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      t = i.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, i = null;
        r ? (i = hp(this.unplaced.content, r - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let a = o.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: d } = this.frontier[s], u, f = null;
          if (t == 1 && (a ? d.matchType(a.type) || (f = d.fillBefore(W.from(a), !1)) : i && l.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, inject: f };
          if (t == 2 && a && (u = d.findWrapping(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, wrap: u };
          if (i && d.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = hp(e, t);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Y(e, t + 1, Math.max(r, o.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = hp(e, t);
    if (o.childCount <= 1 && t > 0) {
      let i = e.size - t <= t + o.size;
      this.unplaced = new Y(Hs(e, t - 1, 1), t - 1, i ? t - 1 : r);
    } else
      this.unplaced = new Y(Hs(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: o, wrap: i }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (i)
      for (let g = 0; g < i.length; g++)
        this.openFrontierNode(i[g]);
    let a = this.unplaced, s = r ? r.content : a.content, l = a.openStart - e, d = 0, u = [], { match: f, type: p } = this.frontier[t];
    if (o) {
      for (let g = 0; g < o.childCount; g++)
        u.push(o.child(g));
      f = f.matchFragment(o);
    }
    let h = s.size + e - (a.content.size - a.openEnd);
    for (; d < s.childCount; ) {
      let g = s.child(d), v = f.matchType(g.type);
      if (!v)
        break;
      d++, (d > 1 || l == 0 || g.content.size) && (f = v, u.push(X$(g.mark(p.allowedMarks(g.marks)), d == 1 ? l : 0, d == s.childCount ? h : -1)));
    }
    let m = d == s.childCount;
    m || (h = -1), this.placed = Us(this.placed, t, W.from(u)), this.frontier[t].match = f, m && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, v = s; g < h; g++) {
      let $ = v.lastChild;
      this.frontier.push({ type: $.type, match: $.contentMatchAt($.childCount) }), v = $.content;
    }
    this.unplaced = m ? e == 0 ? Y.empty : new Y(Hs(a.content, e - 1, 1), e - 1, h < 0 ? a.openEnd : e - 1) : new Y(Hs(a.content, e, d), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !mp(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: r, type: o } = this.frontier[t], i = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), a = mp(e, t, o, r, i);
        if (a) {
          for (let s = t - 1; s >= 0; s--) {
            let { match: l, type: d } = this.frontier[s], u = mp(e, s, d, l, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: t, fit: a, move: i ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Us(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), i = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = Us(this.placed, this.depth, W.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(W.empty, !0);
    t.childCount && (this.placed = Us(this.placed, this.frontier.length, t));
  }
};
function Hs(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Hs(n.firstChild.content, e - 1, t)));
}
function Us(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Us(n.lastChild.content, e - 1, t)));
}
function hp(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function X$(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, X$(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(W.empty, !0)))), n.copy(r);
}
function mp(n, e, t, r, o) {
  let i = n.node(e), a = o ? n.indexAfter(e) : n.index(e);
  if (a == i.childCount && !t.compatibleContent(i.type))
    return null;
  let s = r.fillBefore(i.content, !0, a);
  return s && !FD(t, i.content, a) ? s : null;
}
function FD(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function VD(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function zD(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let o = n.doc.resolve(e), i = n.doc.resolve(t);
  if (Y$(o, i, r))
    return n.step(new wo(e, t, r));
  let a = e4(o, n.doc.resolve(t));
  a[a.length - 1] == 0 && a.pop();
  let s = -(o.depth + 1);
  a.unshift(s);
  for (let p = o.depth, h = o.pos - 1; p > 0; p--, h--) {
    let m = o.node(p).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    a.indexOf(p) > -1 ? s = p : o.before(p) == h && a.splice(1, 0, -p);
  }
  let l = a.indexOf(s), d = [], u = r.openStart;
  for (let p = r.content, h = 0; ; h++) {
    let m = p.firstChild;
    if (d.push(m), h == r.openStart)
      break;
    p = m.content;
  }
  for (let p = u - 1; p >= 0; p--) {
    let h = d[p], m = VD(h.type);
    if (m && !h.sameMarkup(o.node(Math.abs(s) - 1)))
      u = p;
    else if (m || !h.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let h = (p + u + 1) % (r.openStart + 1), m = d[h];
    if (m)
      for (let g = 0; g < a.length; g++) {
        let v = a[(g + l) % a.length], $ = !0;
        v < 0 && ($ = !1, v = -v);
        let C = o.node(v - 1), S = o.index(v - 1);
        if (C.canReplaceWith(S, S, m.type, m.marks))
          return n.replace(o.before(v), $ ? i.after(v) : t, new Y(Q$(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let f = n.steps.length;
  for (let p = a.length - 1; p >= 0 && (n.replace(e, t, r), !(n.steps.length > f)); p--) {
    let h = a[p];
    h < 0 || (e = o.before(h), t = i.after(h));
  }
}
function Q$(n, e, t, r, o) {
  if (e < t) {
    let i = n.firstChild;
    n = n.replaceChild(0, i.copy(Q$(i.content, e + 1, t, r, i)));
  }
  if (e > r) {
    let i = o.contentMatchAt(0), a = i.fillBefore(n).append(n);
    n = a.append(i.matchFragment(a).fillBefore(W.empty, !0));
  }
  return n;
}
function jD(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let o = RD(n.doc, e, r.type);
    o != null && (e = t = o);
  }
  n.replaceRange(e, t, new Y(W.from(r), 0, 0));
}
function HD(n, e, t) {
  let r = n.doc.resolve(e), o = n.doc.resolve(t), i = e4(r, o);
  for (let a = 0; a < i.length; a++) {
    let s = i[a], l = a == i.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return n.delete(r.start(s), o.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), o.indexAfter(s - 1))))
      return n.delete(r.before(s), o.after(s));
  }
  for (let a = 1; a <= r.depth && a <= o.depth; a++)
    if (e - r.start(a) == r.depth - a && t > r.end(a) && o.end(a) - t != o.depth - a)
      return n.delete(r.before(a), t);
  n.delete(e, t);
}
function e4(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let i = n.start(o);
    if (i < n.pos - (n.depth - o) || e.end(o) > e.pos + (e.depth - o) || n.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (i == e.start(o) || o == n.depth && o == e.depth && n.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == i - 1) && t.push(o);
  }
  return t;
}
let t4 = class uu extends dn {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return fn.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      r[i] = t.attrs[i];
    r[this.attr] = this.value;
    let o = t.type.create(r, null, t.marks);
    return fn.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(o), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Ui.empty;
  }
  invert(e) {
    return new uu(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new uu(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new uu(t.pos, t.attr, t.value);
  }
};
dn.jsonID("attr", t4);
let n4 = class Vh extends dn {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      t[o] = e.attrs[o];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return fn.ok(r);
  }
  getMap() {
    return Ui.empty;
  }
  invert(e) {
    return new Vh(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Vh(t.attr, t.value);
  }
};
dn.jsonID("docAttr", n4);
let Xa = class extends Error {
};
Xa = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
Xa.prototype = Object.create(Error.prototype);
Xa.prototype.constructor = Xa;
Xa.prototype.name = "TransformError";
let UD = class {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new kD();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new Xa(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = Y.empty) {
    let o = BD(this.doc, e, t, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new Y(W.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, Y.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return zD(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return jD(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return HD(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return ED(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return ID(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return OD(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, o = null) {
    return TD(this, e, t, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, o) {
    return PD(this, e, t, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new t4(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new n4(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new C0(e, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    if (!(t instanceof ft)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(r.marks), !t)
        return this;
    }
    return this.step(new k0(e, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, t = 1, r) {
    return DD(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return _D(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return SD(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return Z$(this, e, t, r), this;
  }
};
const gp = /* @__PURE__ */ Object.create(null);
class Ue {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new KD(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = Y.empty) {
    let r = t.content.lastChild, o = null;
    for (let s = 0; s < t.openEnd; s++)
      o = r, r = r.lastChild;
    let i = e.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: l, $to: d } = a[s], u = e.mapping.slice(i);
      e.replaceRange(u.map(l.pos), u.map(d.pos), s ? Y.empty : t), s == 0 && jv(e, i, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: a, $to: s } = o[i], l = e.mapping.slice(r), d = l.map(a.pos), u = l.map(s.pos);
      i ? e.deleteRange(d, u) : (e.replaceRangeWith(d, u, t), jv(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let o = e.parent.inlineContent ? new Fe(e) : ga(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (o)
      return o;
    for (let i = e.depth - 1; i >= 0; i--) {
      let a = t < 0 ? ga(e.node(0), e.node(i), e.before(i + 1), e.index(i), t, r) : ga(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, t, r);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new Wn(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return ga(e, e, 0, 0, 1) || new Wn(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return ga(e, e, e.content.size, e.childCount, -1) || new Wn(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = gp[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in gp)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return gp[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Fe.between(this.$anchor, this.$head).getBookmark();
  }
}
Ue.prototype.visible = !0;
class KD {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Vv = !1;
function zv(n) {
  !Vv && !n.parent.inlineContent && (Vv = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Fe extends Ue {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    zv(e), zv(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return Ue.near(r);
    let o = e.resolve(t.map(this.anchor));
    return new Fe(o.parent.inlineContent ? o : r, r);
  }
  replace(e, t = Y.empty) {
    if (super.replace(e, t), t == Y.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Fe && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new vf(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Fe(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let o = e.resolve(t);
    return new this(o, r == t ? o : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let o = e.pos - t.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let i = Ue.findFrom(t, r, !0) || Ue.findFrom(t, -r, !0);
      if (i)
        t = i.$head;
      else
        return Ue.near(t, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = t : (e = (Ue.findFrom(e, -r, !0) || Ue.findFrom(e, r, !0)).$anchor, e.pos < t.pos != o < 0 && (e = t))), new Fe(e, t);
  }
}
Ue.jsonID("text", Fe);
class vf {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new vf(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Fe.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Te extends Ue {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: o } = t.mapResult(this.anchor), i = e.resolve(o);
    return r ? Ue.near(i) : new Te(i);
  }
  content() {
    return new Y(W.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Te && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new _0(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Te(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new Te(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Te.prototype.visible = !1;
Ue.jsonID("node", Te);
class _0 {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new vf(r, r) : new _0(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && Te.isSelectable(r) ? new Te(t) : Ue.near(t);
  }
}
class Wn extends Ue {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = Y.empty) {
    if (t == Y.empty) {
      e.delete(0, e.doc.content.size);
      let r = Ue.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Wn(e);
  }
  map(e) {
    return new Wn(e);
  }
  eq(e) {
    return e instanceof Wn;
  }
  getBookmark() {
    return WD;
  }
}
Ue.jsonID("all", Wn);
const WD = {
  map() {
    return this;
  },
  resolve(n) {
    return new Wn(n);
  }
};
function ga(n, e, t, r, o, i = !1) {
  if (e.inlineContent)
    return Fe.create(n, t);
  for (let a = r - (o > 0 ? 0 : 1); o > 0 ? a < e.childCount : a >= 0; a += o) {
    let s = e.child(a);
    if (s.isAtom) {
      if (!i && Te.isSelectable(s))
        return Te.create(n, t - (o < 0 ? s.nodeSize : 0));
    } else {
      let l = ga(n, s, t + o, o < 0 ? s.childCount : 0, o, i);
      if (l)
        return l;
    }
    t += s.nodeSize * o;
  }
  return null;
}
function jv(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let o = n.steps[r];
  if (!(o instanceof wo || o instanceof ia))
    return;
  let i = n.mapping.maps[r], a;
  i.forEach((s, l, d, u) => {
    a == null && (a = u);
  }), n.setSelection(Ue.near(n.doc.resolve(a), t));
}
const Hv = 1, Fd = 2, Uv = 4;
class qD extends UD {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Hv) & ~Fd, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Hv) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Fd, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return ft.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Fd) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Fd, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || ft.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let o = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(o.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), r = r ?? t, !e)
        return this.deleteRange(t, r);
      let i = this.storedMarks;
      if (!i) {
        let a = this.doc.resolve(t);
        i = r == t ? a.marks() : a.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, o.text(e, i)), this.selection.empty || this.setSelection(Ue.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Uv, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Uv) > 0;
  }
}
function Kv(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Ks {
  constructor(e, t, r) {
    this.name = e, this.init = Kv(t.init, r), this.apply = Kv(t.apply, r);
  }
}
const GD = [
  new Ks("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Ks("selection", {
    init(n, e) {
      return n.selection || Ue.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Ks("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Ks("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class vp {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = GD.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Ks(r.key, r.spec.state, r));
    });
  }
}
class xa {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), o = null;
    for (; ; ) {
      let i = !1;
      for (let a = 0; a < this.config.plugins.length; a++) {
        let s = this.config.plugins[a];
        if (s.spec.appendTransaction) {
          let l = o ? o[a].n : 0, d = o ? o[a].state : this, u = l < t.length && s.spec.appendTransaction.call(s, l ? t.slice(l) : t, d, r);
          if (u && r.filterTransaction(u, a)) {
            if (u.setMeta("appendedTransaction", e), !o) {
              o = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                o.push(f < a ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), r = r.applyInner(u), i = !0;
          }
          o && (o[a] = { state: r, n: t.length });
        }
      }
      if (!i)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new xa(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let i = r[o];
      t[i.name] = i.apply(e, this[i.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new qD(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new vp(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new xa(t);
    for (let o = 0; o < t.fields.length; o++)
      r[t.fields[o].name] = t.fields[o].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new vp(this.schema, e.plugins), r = t.fields, o = new xa(t);
    for (let i = 0; i < r.length; i++) {
      let a = r[i].name;
      o[a] = this.hasOwnProperty(a) ? this[a] : r[i].init(e, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = e[r], i = o.spec.state;
        i && i.toJSON && (t[r] = i.toJSON.call(o, this[o.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new vp(e.schema, e.plugins), i = new xa(o);
    return o.fields.forEach((a) => {
      if (a.name == "doc")
        i.doc = Ko.fromJSON(e.schema, t.doc);
      else if (a.name == "selection")
        i.selection = Ue.fromJSON(i.doc, t.selection);
      else if (a.name == "storedMarks")
        t.storedMarks && (i.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], d = l.spec.state;
            if (l.key == a.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, s)) {
              i[a.name] = d.fromJSON.call(l, e, t[s], i);
              return;
            }
          }
        i[a.name] = a.init(e, i);
      }
    }), i;
  }
}
function r4(n, e, t) {
  for (let r in n) {
    let o = n[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = r4(o, e, {})), t[r] = o;
  }
  return t;
}
class Ct {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && r4(e.props, this, this.props), this.key = e.key ? e.key.key : o4("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const yp = /* @__PURE__ */ Object.create(null);
function o4(n) {
  return n in yp ? n + "$" + ++yp[n] : (yp[n] = 0, n + "$");
}
class Lt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = o4(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const i4 = 65535, a4 = Math.pow(2, 16);
function JD(n, e) {
  return n + e * a4;
}
function Wv(n) {
  return n & i4;
}
function ZD(n) {
  return (n - (n & i4)) / a4;
}
const s4 = 1, l4 = 2, cu = 4, d4 = 8;
class zh {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & d4) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (s4 | cu)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (l4 | cu)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & cu) > 0;
  }
}
class Nn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && Nn.empty)
      return Nn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = Wv(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        t += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + t + ZD(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0, i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? o : 0);
      if (l > e)
        break;
      let d = this.ranges[s + i], u = this.ranges[s + a], f = l + d;
      if (e <= f) {
        let p = d ? e == l ? -1 : e == f ? 1 : t : t, h = l + o + (p < 0 ? 0 : u);
        if (r)
          return h;
        let m = e == (t < 0 ? l : f) ? null : JD(s / 3, e - l), g = e == l ? l4 : e == f ? s4 : cu;
        return (t < 0 ? e != l : e != f) && (g |= d4), new zh(h, g, m);
      }
      o += u - d;
    }
    return r ? e + o : new zh(e + o, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, o = Wv(t), i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let d = this.ranges[s + i], u = l + d;
      if (e <= u && s == o * 3)
        return !0;
      r += this.ranges[s + a] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o], s = a - (this.inverted ? i : 0), l = a + (this.inverted ? 0 : i), d = this.ranges[o + t], u = this.ranges[o + r];
      e(s, s + d, l, l + u), i += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Nn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? Nn.empty : new Nn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
Nn.empty = new Nn([]);
class Aa {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], t, r = 0, o = e.length) {
    this.maps = e, this.mirror = t, this.from = r, this.to = o;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new Aa(this.maps, this.mirror, e, t);
  }
  /**
  @internal
  */
  copy() {
    return new Aa(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this.maps.length; t < e.maps.length; t++) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t], o != null && o < t ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this.maps.length + e.maps.length; t >= 0; t--) {
      let o = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), o != null && o > t ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new Aa();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this.maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let o = 0;
    for (let i = this.from; i < this.to; i++) {
      let a = this.maps[i], s = a.mapResult(e, t);
      if (s.recover != null) {
        let l = this.getMirror(i);
        if (l != null && l > i && l < this.to) {
          i = l, e = this.maps[l].recover(s.recover);
          continue;
        }
      }
      o |= s.delInfo, e = s.pos;
    }
    return r ? e : new zh(e, o, null);
  }
}
const bp = /* @__PURE__ */ Object.create(null);
class un {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Nn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = bp[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in bp)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return bp[e] = t, t.prototype.jsonID = e, t;
  }
}
class It {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new It(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new It(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, o) {
    try {
      return It.ok(e.replace(t, r, o));
    } catch (i) {
      if (i instanceof Vl)
        return It.fail(i.message);
      throw i;
    }
  }
}
function S0(n, e, t) {
  let r = [];
  for (let o = 0; o < n.childCount; o++) {
    let i = n.child(o);
    i.content.size && (i = i.copy(S0(i.content, e, i))), i.isInline && (i = e(i, t, o)), r.push(i);
  }
  return W.fromArray(r);
}
class jo extends un {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new Y(S0(t.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), o), t.openStart, t.openEnd);
    return It.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new Dr(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new jo(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof jo && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new jo(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new jo(t.from, t.to, e.markFromJSON(t.mark));
  }
}
un.jsonID("addMark", jo);
class Dr extends un {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new Y(S0(t.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), t.openStart, t.openEnd);
    return It.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new jo(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Dr(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Dr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Dr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Dr(t.from, t.to, e.markFromJSON(t.mark));
  }
}
un.jsonID("removeMark", Dr);
class Ho extends un {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return It.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return It.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let o = 0; o < t.marks.length; o++)
          if (!t.marks[o].isInSet(r))
            return new Ho(this.pos, t.marks[o]);
        return new Ho(this.pos, this.mark);
      }
    }
    return new Qa(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ho(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ho(t.pos, e.markFromJSON(t.mark));
  }
}
un.jsonID("addNodeMark", Ho);
class Qa extends un {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return It.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return It.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Ho(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Qa(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Qa(t.pos, e.markFromJSON(t.mark));
  }
}
un.jsonID("removeNodeMark", Qa);
class qt extends un {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, o = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && jh(e, this.from, this.to) ? It.fail("Structure replace would overwrite content") : It.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new Nn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new qt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new qt(t.pos, Math.max(t.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof qt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? Y.empty : new Y(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new qt(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? Y.empty : new Y(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new qt(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new qt(t.from, t.to, Y.fromJSON(e, t.slice), !!t.structure);
  }
}
un.jsonID("replace", qt);
class Xt extends un {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, o, i, a, s = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = a, this.structure = s;
  }
  apply(e) {
    if (this.structure && (jh(e, this.from, this.gapFrom) || jh(e, this.gapTo, this.to)))
      return It.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return It.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? It.fromReplace(e, this.from, this.to, r) : It.fail("Content does not fit in gap");
  }
  getMap() {
    return new Nn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new Xt(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || o < t.pos || i > r.pos ? null : new Xt(t.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Xt(t.from, t.to, t.gapFrom, t.gapTo, Y.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
un.jsonID("replaceAround", Xt);
function jh(n, e, t) {
  let r = n.resolve(e), o = t - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let a = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, o--;
    }
  }
  return !1;
}
function YD(n, e, t, r) {
  let o = [], i = [], a, s;
  n.doc.nodesBetween(e, t, (l, d, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!r.isInSet(f) && u.type.allowsMarkType(r.type)) {
      let p = Math.max(d, e), h = Math.min(d + l.nodeSize, t), m = r.addToSet(f);
      for (let g = 0; g < f.length; g++)
        f[g].isInSet(m) || (a && a.to == p && a.mark.eq(f[g]) ? a.to = h : o.push(a = new Dr(p, h, f[g])));
      s && s.to == p ? s.to = h : i.push(s = new jo(p, h, r));
    }
  }), o.forEach((l) => n.step(l)), i.forEach((l) => n.step(l));
}
function XD(n, e, t, r) {
  let o = [], i = 0;
  n.doc.nodesBetween(e, t, (a, s) => {
    if (!a.isInline)
      return;
    i++;
    let l = null;
    if (r instanceof vd) {
      let d = a.marks, u;
      for (; u = r.isInSet(d); )
        (l || (l = [])).push(u), d = u.removeFromSet(d);
    } else
      r ? r.isInSet(a.marks) && (l = [r]) : l = a.marks;
    if (l && l.length) {
      let d = Math.min(s + a.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], p;
        for (let h = 0; h < o.length; h++) {
          let m = o[h];
          m.step == i - 1 && f.eq(o[h].style) && (p = m);
        }
        p ? (p.to = d, p.step = i) : o.push({ style: f, from: Math.max(s, e), to: d, step: i });
      }
    }
  }), o.forEach((a) => n.step(new Dr(a.from, a.to, a.style)));
}
function E0(n, e, t, r = t.contentMatch, o = !0) {
  let i = n.doc.nodeAt(e), a = [], s = e + 1;
  for (let l = 0; l < i.childCount; l++) {
    let d = i.child(l), u = s + d.nodeSize, f = r.matchType(d.type);
    if (!f)
      a.push(new qt(s, u, Y.empty));
    else {
      r = f;
      for (let p = 0; p < d.marks.length; p++)
        t.allowsMarkType(d.marks[p].type) || n.step(new Dr(s, u, d.marks[p]));
      if (o && d.isText && t.whitespace != "pre") {
        let p, h = /\r?\n|\r/g, m;
        for (; p = h.exec(d.text); )
          m || (m = new Y(W.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), a.push(new qt(s + p.index, s + p.index + p[0].length, m));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(W.empty, !0);
    n.replace(s, s, new Y(l, 0, 0));
  }
  for (let l = a.length - 1; l >= 0; l--)
    n.step(a[l]);
}
function QD(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function $s(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let o = n.$from.node(r), i = n.$from.index(r), a = n.$to.indexAfter(r);
    if (r < n.depth && o.canReplace(i, a, t))
      return r;
    if (r == 0 || o.type.spec.isolating || !QD(o, i, a))
      break;
  }
  return null;
}
function eI(n, e, t) {
  let { $from: r, $to: o, depth: i } = e, a = r.before(i + 1), s = o.after(i + 1), l = a, d = s, u = W.empty, f = 0;
  for (let m = i, g = !1; m > t; m--)
    g || r.index(m) > 0 ? (g = !0, u = W.from(r.node(m).copy(u)), f++) : l--;
  let p = W.empty, h = 0;
  for (let m = i, g = !1; m > t; m--)
    g || o.after(m + 1) < o.end(m) ? (g = !0, p = W.from(o.node(m).copy(p)), h++) : d++;
  n.step(new Xt(l, d, a, s, new Y(u.append(p), f, h), u.size - f, !0));
}
function O0(n, e, t = null, r = n) {
  let o = tI(n, e), i = o && nI(r, e);
  return i ? o.map(qv).concat({ type: e, attrs: t }).concat(i.map(qv)) : null;
}
function qv(n) {
  return { type: n, attrs: null };
}
function tI(n, e) {
  let { parent: t, startIndex: r, endIndex: o } = n, i = t.contentMatchAt(r).findWrapping(e);
  if (!i)
    return null;
  let a = i.length ? i[0] : e;
  return t.canReplaceWith(r, o, a) ? i : null;
}
function nI(n, e) {
  let { parent: t, startIndex: r, endIndex: o } = n, i = t.child(r), a = e.contentMatch.findWrapping(i.type);
  if (!a)
    return null;
  let l = (a.length ? a[a.length - 1] : e).contentMatch;
  for (let d = r; l && d < o; d++)
    l = l.matchType(t.child(d).type);
  return !l || !l.validEnd ? null : a;
}
function rI(n, e, t) {
  let r = W.empty;
  for (let a = t.length - 1; a >= 0; a--) {
    if (r.size) {
      let s = t[a].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = W.from(t[a].type.create(t[a].attrs, r));
  }
  let o = e.start, i = e.end;
  n.step(new Xt(o, i, o, i, new Y(r, 0, 0), t.length, !0));
}
function oI(n, e, t, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = n.steps.length;
  n.doc.nodesBetween(e, t, (a, s) => {
    let l = typeof o == "function" ? o(a) : o;
    if (a.isTextblock && !a.hasMarkup(r, l) && iI(n.doc, n.mapping.slice(i).map(s), r)) {
      let d = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", m = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !m ? d = !1 : !h && m && (d = !0);
      }
      d === !1 && c4(n, a, s, i), E0(n, n.mapping.slice(i).map(s, 1), r, void 0, d === null);
      let u = n.mapping.slice(i), f = u.map(s, 1), p = u.map(s + a.nodeSize, 1);
      return n.step(new Xt(f, p, f + 1, p - 1, new Y(W.from(r.create(l, null, a.marks)), 0, 0), 1, !0)), d === !0 && u4(n, a, s, i), !1;
    }
  });
}
function u4(n, e, t, r) {
  e.forEach((o, i) => {
    if (o.isText) {
      let a, s = /\r?\n|\r/g;
      for (; a = s.exec(o.text); ) {
        let l = n.mapping.slice(r).map(t + 1 + i + a.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function c4(n, e, t, r) {
  e.forEach((o, i) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let a = n.mapping.slice(r).map(t + 1 + i);
      n.replaceWith(a, a + 1, e.type.schema.text(`
`));
    }
  });
}
function iI(n, e, t) {
  let r = n.resolve(e), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, t);
}
function aI(n, e, t, r, o) {
  let i = n.doc.nodeAt(e);
  if (!i)
    throw new RangeError("No node at given position");
  t || (t = i.type);
  let a = t.create(r, null, o || i.marks);
  if (i.isLeaf)
    return n.replaceWith(e, e + i.nodeSize, a);
  if (!t.validContent(i.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new Xt(e, e + i.nodeSize, e + 1, e + i.nodeSize - 1, new Y(W.from(a), 0, 0), 1, !0));
}
function Ma(n, e, t = 1, r) {
  let o = n.resolve(e), i = o.depth - t, a = r && r[r.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !a.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let d = o.depth - 1, u = t - 2; d > i; d--, u--) {
    let f = o.node(d), p = o.index(d);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(p, f.childCount), m = r && r[u + 1];
    m && (h = h.replaceChild(0, m.type.create(m.attrs)));
    let g = r && r[u] || f;
    if (!f.canReplace(p + 1, f.childCount) || !g.type.validContent(h))
      return !1;
  }
  let s = o.indexAfter(i), l = r && r[0];
  return o.node(i).canReplaceWith(s, s, l ? l.type : o.node(i + 1).type);
}
function sI(n, e, t = 1, r) {
  let o = n.doc.resolve(e), i = W.empty, a = W.empty;
  for (let s = o.depth, l = o.depth - t, d = t - 1; s > l; s--, d--) {
    i = W.from(o.node(s).copy(i));
    let u = r && r[d];
    a = W.from(u ? u.type.create(u.attrs, a) : o.node(s).copy(a));
  }
  n.step(new qt(e, e, new Y(i.append(a), t, t), !0));
}
function si(n, e) {
  let t = n.resolve(e), r = t.index();
  return f4(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function lI(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o), a = i.type == r ? n.type.schema.nodes.text : i.type;
    if (t = t.matchType(a), !t || !n.type.allowsMarks(i.marks))
      return !1;
  }
  return t.validEnd;
}
function f4(n, e) {
  return !!(n && e && !n.isLeaf && lI(n, e));
}
function yf(n, e, t = -1) {
  let r = n.resolve(e);
  for (let o = r.depth; ; o--) {
    let i, a, s = r.index(o);
    if (o == r.depth ? (i = r.nodeBefore, a = r.nodeAfter) : t > 0 ? (i = r.node(o + 1), s++, a = r.node(o).maybeChild(s)) : (i = r.node(o).maybeChild(s - 1), a = r.node(o + 1)), i && !i.isTextblock && f4(i, a) && r.node(o).canReplace(s, s + 1))
      return e;
    if (o == 0)
      break;
    e = t < 0 ? r.before(o) : r.after(o);
  }
}
function dI(n, e, t) {
  let r = null, { linebreakReplacement: o } = n.doc.type.schema, i = n.doc.resolve(e - t), a = i.node().type;
  if (o && a.inlineContent) {
    let u = a.whitespace == "pre", f = !!a.contentMatch.matchType(o);
    u && !f ? r = !1 : !u && f && (r = !0);
  }
  let s = n.steps.length;
  if (r === !1) {
    let u = n.doc.resolve(e + t);
    c4(n, u.node(), u.before(), s);
  }
  a.inlineContent && E0(n, e + t - 1, a, i.node().contentMatchAt(i.index()), r == null);
  let l = n.mapping.slice(s), d = l.map(e - t);
  if (n.step(new qt(d, l.map(e + t, -1), Y.empty, !0)), r === !0) {
    let u = n.doc.resolve(d);
    u4(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function uI(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.index(o);
      if (r.node(o).canReplaceWith(i, i, t))
        return r.before(o + 1);
      if (i > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let i = r.indexAfter(o);
      if (r.node(o).canReplaceWith(i, i, t))
        return r.after(o + 1);
      if (i < r.node(o).childCount)
        return null;
    }
  return null;
}
function p4(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let o = t.content;
  for (let i = 0; i < t.openStart; i++)
    o = o.firstChild.content;
  for (let i = 1; i <= (t.openStart == 0 && t.size ? 2 : 1); i++)
    for (let a = r.depth; a >= 0; a--) {
      let s = a == r.depth ? 0 : r.pos <= (r.start(a + 1) + r.end(a + 1)) / 2 ? -1 : 1, l = r.index(a) + (s > 0 ? 1 : 0), d = r.node(a), u = !1;
      if (i == 1)
        u = d.canReplace(l, l, o);
      else {
        let f = d.contentMatchAt(l).findWrapping(o.firstChild.type);
        u = f && d.canReplaceWith(l, l, f[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(a + 1) : r.after(a + 1);
    }
  return null;
}
function bf(n, e, t = e, r = Y.empty) {
  if (e == t && !r.size)
    return null;
  let o = n.resolve(e), i = n.resolve(t);
  return h4(o, i, r) ? new qt(e, t, r) : new cI(o, i, r).fit();
}
function h4(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class cI {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = W.empty;
    for (let o = 0; o <= e.depth; o++) {
      let i = e.node(o);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(o))
      });
    }
    for (let o = e.depth; o > 0; o--)
      this.placed = W.from(e.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!o)
      return null;
    let i = this.placed, a = r.depth, s = o.depth;
    for (; a && s && i.childCount == 1; )
      i = i.firstChild.content, a--, s--;
    let l = new Y(i, a, s);
    return e > -1 ? new Xt(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new qt(r.pos, o.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < e; r++) {
      let i = t.firstChild;
      if (t.childCount > 1 && (o = 0), i.type.spec.isolating && o <= r) {
        e = r;
        break;
      }
      t = i.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let o, i = null;
        r ? (i = $p(this.unplaced.content, r - 1).firstChild, o = i.content) : o = this.unplaced.content;
        let a = o.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: d } = this.frontier[s], u, f = null;
          if (t == 1 && (a ? d.matchType(a.type) || (f = d.fillBefore(W.from(a), !1)) : i && l.compatibleContent(i.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, inject: f };
          if (t == 2 && a && (u = d.findWrapping(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: i, wrap: u };
          if (i && d.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = $p(e, t);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Y(e, t + 1, Math.max(r, o.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, o = $p(e, t);
    if (o.childCount <= 1 && t > 0) {
      let i = e.size - t <= t + o.size;
      this.unplaced = new Y(Ws(e, t - 1, 1), t - 1, i ? t - 1 : r);
    } else
      this.unplaced = new Y(Ws(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: o, wrap: i }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (i)
      for (let g = 0; g < i.length; g++)
        this.openFrontierNode(i[g]);
    let a = this.unplaced, s = r ? r.content : a.content, l = a.openStart - e, d = 0, u = [], { match: f, type: p } = this.frontier[t];
    if (o) {
      for (let g = 0; g < o.childCount; g++)
        u.push(o.child(g));
      f = f.matchFragment(o);
    }
    let h = s.size + e - (a.content.size - a.openEnd);
    for (; d < s.childCount; ) {
      let g = s.child(d), v = f.matchType(g.type);
      if (!v)
        break;
      d++, (d > 1 || l == 0 || g.content.size) && (f = v, u.push(m4(g.mark(p.allowedMarks(g.marks)), d == 1 ? l : 0, d == s.childCount ? h : -1)));
    }
    let m = d == s.childCount;
    m || (h = -1), this.placed = qs(this.placed, t, W.from(u)), this.frontier[t].match = f, m && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, v = s; g < h; g++) {
      let $ = v.lastChild;
      this.frontier.push({ type: $.type, match: $.contentMatchAt($.childCount) }), v = $.content;
    }
    this.unplaced = m ? e == 0 ? Y.empty : new Y(Ws(a.content, e - 1, 1), e - 1, h < 0 ? a.openEnd : e - 1) : new Y(Ws(a.content, e, d), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !wp(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: r, type: o } = this.frontier[t], i = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), a = wp(e, t, o, r, i);
        if (a) {
          for (let s = t - 1; s >= 0; s--) {
            let { match: l, type: d } = this.frontier[s], u = wp(e, s, d, l, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: t, fit: a, move: i ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = qs(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let o = e.node(r), i = o.type.contentMatch.fillBefore(o.content, !0, e.index(r));
      this.openFrontierNode(o.type, o.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(e), this.placed = qs(this.placed, this.depth, W.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(W.empty, !0);
    t.childCount && (this.placed = qs(this.placed, this.frontier.length, t));
  }
}
function Ws(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Ws(n.firstChild.content, e - 1, t)));
}
function qs(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(qs(n.lastChild.content, e - 1, t)));
}
function $p(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function m4(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, m4(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(W.empty, !0)))), n.copy(r);
}
function wp(n, e, t, r, o) {
  let i = n.node(e), a = o ? n.indexAfter(e) : n.index(e);
  if (a == i.childCount && !t.compatibleContent(i.type))
    return null;
  let s = r.fillBefore(i.content, !0, a);
  return s && !fI(t, i.content, a) ? s : null;
}
function fI(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function pI(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function hI(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let o = n.doc.resolve(e), i = n.doc.resolve(t);
  if (h4(o, i, r))
    return n.step(new qt(e, t, r));
  let a = v4(o, n.doc.resolve(t));
  a[a.length - 1] == 0 && a.pop();
  let s = -(o.depth + 1);
  a.unshift(s);
  for (let p = o.depth, h = o.pos - 1; p > 0; p--, h--) {
    let m = o.node(p).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    a.indexOf(p) > -1 ? s = p : o.before(p) == h && a.splice(1, 0, -p);
  }
  let l = a.indexOf(s), d = [], u = r.openStart;
  for (let p = r.content, h = 0; ; h++) {
    let m = p.firstChild;
    if (d.push(m), h == r.openStart)
      break;
    p = m.content;
  }
  for (let p = u - 1; p >= 0; p--) {
    let h = d[p], m = pI(h.type);
    if (m && !h.sameMarkup(o.node(Math.abs(s) - 1)))
      u = p;
    else if (m || !h.type.isTextblock)
      break;
  }
  for (let p = r.openStart; p >= 0; p--) {
    let h = (p + u + 1) % (r.openStart + 1), m = d[h];
    if (m)
      for (let g = 0; g < a.length; g++) {
        let v = a[(g + l) % a.length], $ = !0;
        v < 0 && ($ = !1, v = -v);
        let C = o.node(v - 1), S = o.index(v - 1);
        if (C.canReplaceWith(S, S, m.type, m.marks))
          return n.replace(o.before(v), $ ? i.after(v) : t, new Y(g4(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let f = n.steps.length;
  for (let p = a.length - 1; p >= 0 && (n.replace(e, t, r), !(n.steps.length > f)); p--) {
    let h = a[p];
    h < 0 || (e = o.before(h), t = i.after(h));
  }
}
function g4(n, e, t, r, o) {
  if (e < t) {
    let i = n.firstChild;
    n = n.replaceChild(0, i.copy(g4(i.content, e + 1, t, r, i)));
  }
  if (e > r) {
    let i = o.contentMatchAt(0), a = i.fillBefore(n).append(n);
    n = a.append(i.matchFragment(a).fillBefore(W.empty, !0));
  }
  return n;
}
function mI(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let o = uI(n.doc, e, r.type);
    o != null && (e = t = o);
  }
  n.replaceRange(e, t, new Y(W.from(r), 0, 0));
}
function gI(n, e, t) {
  let r = n.doc.resolve(e), o = n.doc.resolve(t), i = v4(r, o);
  for (let a = 0; a < i.length; a++) {
    let s = i[a], l = a == i.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return n.delete(r.start(s), o.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), o.indexAfter(s - 1))))
      return n.delete(r.before(s), o.after(s));
  }
  for (let a = 1; a <= r.depth && a <= o.depth; a++)
    if (e - r.start(a) == r.depth - a && t > r.end(a) && o.end(a) - t != o.depth - a && r.start(a - 1) == o.start(a - 1) && r.node(a - 1).canReplace(r.index(a - 1), o.index(a - 1)))
      return n.delete(r.before(a), t);
  n.delete(e, t);
}
function v4(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let o = r; o >= 0; o--) {
    let i = n.start(o);
    if (i < n.pos - (n.depth - o) || e.end(o) > e.pos + (e.depth - o) || n.node(o).type.spec.isolating || e.node(o).type.spec.isolating)
      break;
    (i == e.start(o) || o == n.depth && o == e.depth && n.parent.inlineContent && e.parent.inlineContent && o && e.start(o - 1) == i - 1) && t.push(o);
  }
  return t;
}
class Na extends un {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return It.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      r[i] = t.attrs[i];
    r[this.attr] = this.value;
    let o = t.type.create(r, null, t.marks);
    return It.fromReplace(e, this.pos, this.pos + 1, new Y(W.from(o), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Nn.empty;
  }
  invert(e) {
    return new Na(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Na(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Na(t.pos, t.attr, t.value);
  }
}
un.jsonID("attr", Na);
class Hl extends un {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let o in e.attrs)
      t[o] = e.attrs[o];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return It.ok(r);
  }
  getMap() {
    return Nn.empty;
  }
  invert(e) {
    return new Hl(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new Hl(t.attr, t.value);
  }
}
un.jsonID("docAttr", Hl);
let es = class extends Error {
};
es = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
es.prototype = Object.create(Error.prototype);
es.prototype.constructor = es;
es.prototype.name = "TransformError";
class vI {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new Aa();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new es(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = Y.empty) {
    let o = bf(this.doc, e, t, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new Y(W.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, Y.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return hI(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return mI(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return gI(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return eI(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return dI(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return rI(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, o = null) {
    return oI(this, e, t, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, o) {
    return aI(this, e, t, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new Na(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new Hl(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Ho(e, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    if (!(t instanceof ft)) {
      let r = this.doc.nodeAt(e);
      if (!r)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(r.marks), !t)
        return this;
    }
    return this.step(new Qa(e, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, t = 1, r) {
    return sI(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return YD(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return XD(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return E0(this, e, t, r), this;
  }
}
const Gt = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, ts = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Hh = null;
const to = function(n, e, t) {
  let r = Hh || (Hh = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, yI = function() {
  Hh = null;
}, Ki = function(n, e, t, r) {
  return t && (Gv(n, e, t, r, -1) || Gv(n, e, t, r, 1));
}, bI = /^(img|br|input|textarea|hr)$/i;
function Gv(n, e, t, r, o) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (o < 0 ? 0 : Un(n))) {
      let i = n.parentNode;
      if (!i || i.nodeType != 1 || bd(n) || bI.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Gt(n) + (o < 0 ? 0 : 1), n = i;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (o < 0 ? -1 : 0)], n.contentEditable == "false")
        return !1;
      e = o < 0 ? Un(n) : 0;
    } else
      return !1;
  }
}
function Un(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function $I(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Un(n);
    } else if (n.parentNode && !bd(n))
      e = Gt(n), n = n.parentNode;
    else
      return null;
  }
}
function wI(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !bd(n))
      e = Gt(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function xI(n, e, t) {
  for (let r = e == 0, o = e == Un(n); r || o; ) {
    if (n == t)
      return !0;
    let i = Gt(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && i == 0, o = o && i == Un(n);
  }
}
function bd(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const $f = function(n) {
  return n.focusNode && Ki(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function wi(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function CI(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function kI(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Un(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(Un(r.startContainer), r.startOffset) };
  }
}
const jr = typeof navigator < "u" ? navigator : null, Jv = typeof document < "u" ? document : null, li = jr && jr.userAgent || "", Uh = /Edge\/(\d+)/.exec(li), y4 = /MSIE \d/.exec(li), Kh = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(li), _n = !!(y4 || Kh || Uh), qo = y4 ? document.documentMode : Kh ? +Kh[1] : Uh ? +Uh[1] : 0, wr = !_n && /gecko\/(\d+)/i.test(li);
wr && +(/Firefox\/(\d+)/.exec(li) || [0, 0])[1];
const Wh = !_n && /Chrome\/(\d+)/.exec(li), on = !!Wh, b4 = Wh ? +Wh[1] : 0, gn = !_n && !!jr && /Apple Computer/.test(jr.vendor), ns = gn && (/Mobile\/\w+/.test(li) || !!jr && jr.maxTouchPoints > 2), Hn = ns || (jr ? /Mac/.test(jr.platform) : !1), _I = jr ? /Win/.test(jr.platform) : !1, fo = /Android \d/.test(li), $d = !!Jv && "webkitFontSmoothing" in Jv.documentElement.style, SI = $d ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function EI(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Jr(n, e) {
  return typeof n == "number" ? n : n[e];
}
function OI(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function Zv(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, o = n.someProp("scrollMargin") || 5, i = n.dom.ownerDocument;
  for (let a = t || n.dom; a; ) {
    if (a.nodeType != 1) {
      a = ts(a);
      continue;
    }
    let s = a, l = s == i.body, d = l ? EI(i) : OI(s), u = 0, f = 0;
    if (e.top < d.top + Jr(r, "top") ? f = -(d.top - e.top + Jr(o, "top")) : e.bottom > d.bottom - Jr(r, "bottom") && (f = e.bottom - e.top > d.bottom - d.top ? e.top + Jr(o, "top") - d.top : e.bottom - d.bottom + Jr(o, "bottom")), e.left < d.left + Jr(r, "left") ? u = -(d.left - e.left + Jr(o, "left")) : e.right > d.right - Jr(r, "right") && (u = e.right - d.right + Jr(o, "right")), u || f)
      if (l)
        i.defaultView.scrollBy(u, f);
      else {
        let h = s.scrollLeft, m = s.scrollTop;
        f && (s.scrollTop += f), u && (s.scrollLeft += u);
        let g = s.scrollLeft - h, v = s.scrollTop - m;
        e = { left: e.left - g, top: e.top - v, right: e.right - g, bottom: e.bottom - v };
      }
    let p = l ? "fixed" : getComputedStyle(a).position;
    if (/^(fixed|sticky)$/.test(p))
      break;
    a = p == "absolute" ? a.offsetParent : ts(a);
  }
}
function TI(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, o;
  for (let i = (e.left + e.right) / 2, a = t + 1; a < Math.min(innerHeight, e.bottom); a += 5) {
    let s = n.root.elementFromPoint(i, a);
    if (!s || s == n.dom || !n.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= t - 20) {
      r = s, o = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: $4(n.dom) };
}
function $4(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = ts(r))
    ;
  return e;
}
function AI({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  w4(t, r == 0 ? 0 : r - e);
}
function w4(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: o, left: i } = n[t];
    r.scrollTop != o + e && (r.scrollTop = o + e), r.scrollLeft != i && (r.scrollLeft = i);
  }
}
let ua = null;
function MI(n) {
  if (n.setActive)
    return n.setActive();
  if (ua)
    return n.focus(ua);
  let e = $4(n);
  n.focus(ua == null ? {
    get preventScroll() {
      return ua = { preventScroll: !0 }, !0;
    }
  } : void 0), ua || (ua = !1, w4(e, 0));
}
function x4(n, e) {
  let t, r = 2e8, o, i = 0, a = e.top, s = e.top, l, d;
  for (let u = n.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let p;
    if (u.nodeType == 1)
      p = u.getClientRects();
    else if (u.nodeType == 3)
      p = to(u).getClientRects();
    else
      continue;
    for (let h = 0; h < p.length; h++) {
      let m = p[h];
      if (m.top <= a && m.bottom >= s) {
        a = Math.max(m.bottom, a), s = Math.min(m.top, s);
        let g = m.left > e.left ? m.left - e.left : m.right < e.left ? e.left - m.right : 0;
        if (g < r) {
          t = u, r = g, o = g && t.nodeType == 3 ? {
            left: m.right < e.left ? m.right : m.left,
            top: e.top
          } : e, u.nodeType == 1 && g && (i = f + (e.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else
        m.top > e.top && !l && m.left <= e.left && m.right >= e.left && (l = u, d = { left: Math.max(m.left, Math.min(m.right, e.left)), top: m.top });
      !t && (e.left >= m.right && e.top >= m.top || e.left >= m.left && e.top >= m.bottom) && (i = f + 1);
    }
  }
  return !t && l && (t = l, o = d, r = 0), t && t.nodeType == 3 ? NI(t, o) : !t || r && t.nodeType == 1 ? { node: n, offset: i } : x4(t, o);
}
function NI(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let o = 0; o < t; o++) {
    r.setEnd(n, o + 1), r.setStart(n, o);
    let i = No(r, 1);
    if (i.top != i.bottom && T0(e, i))
      return { node: n, offset: o + (e.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function T0(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function PI(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function DI(n, e, t) {
  let { node: r, offset: o } = x4(e, t), i = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let a = r.getBoundingClientRect();
    i = a.left != a.right && t.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, o, i);
}
function II(n, e, t, r) {
  let o = -1;
  for (let i = e, a = !1; i != n.dom; ) {
    let s = n.docView.nearestDesc(i, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && (!a && l.left > r.left || l.top > r.top ? o = s.posBefore : (!a && l.right < r.left || l.bottom < r.top) && (o = s.posAfter), a = !0), !s.contentDOM && o < 0 && !s.node.isText))
      return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    i = s.dom.parentNode;
  }
  return o > -1 ? o : n.docView.posFromDOM(e, t, -1);
}
function C4(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), i = o; ; ) {
      let a = n.childNodes[i];
      if (a.nodeType == 1) {
        let s = a.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let d = s[l];
          if (T0(e, d))
            return C4(a, e, d);
        }
      }
      if ((i = (i + 1) % r) == o)
        break;
    }
  return n;
}
function RI(n, e) {
  let t = n.dom.ownerDocument, r, o = 0, i = kI(t, e.left, e.top);
  i && ({ node: r, offset: o } = i);
  let a = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), s;
  if (!a || !n.dom.contains(a.nodeType != 1 ? a.parentNode : a)) {
    let d = n.dom.getBoundingClientRect();
    if (!T0(e, d) || (a = C4(n.dom, e, d), !a))
      return null;
  }
  if (gn)
    for (let d = a; r && d; d = ts(d))
      d.draggable && (r = void 0);
  if (a = PI(a, e), r) {
    if (wr && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let u = r.childNodes[o], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= e.left && f.bottom > e.top && o++;
    }
    let d;
    $d && o && r.nodeType == 1 && (d = r.childNodes[o - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= e.top && o--, r == n.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? s = n.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (s = II(n, r, o, e));
  }
  s == null && (s = DI(n, a, e));
  let l = n.docView.nearestDesc(a, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function Yv(n) {
  return n.top < n.bottom || n.left < n.right;
}
function No(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (Yv(r))
      return r;
  }
  return Array.prototype.find.call(t, Yv) || n.getBoundingClientRect();
}
const BI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function k4(n, e, t) {
  let { node: r, offset: o, atom: i } = n.docView.domFromPos(e, t < 0 ? -1 : 1), a = $d || wr;
  if (r.nodeType == 3)
    if (a && (BI.test(r.nodeValue) || (t < 0 ? !o : o == r.nodeValue.length))) {
      let l = No(to(r, o, o), t);
      if (wr && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let d = No(to(r, o - 1, o - 1), -1);
        if (d.top == l.top) {
          let u = No(to(r, o, o + 1), -1);
          if (u.top != l.top)
            return Ss(u, u.left < d.left);
        }
      }
      return l;
    } else {
      let l = o, d = o, u = t < 0 ? 1 : -1;
      return t < 0 && !o ? (d++, u = -1) : t >= 0 && o == r.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : d++, Ss(No(to(r, l, d), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (i || 0)).parent.inlineContent) {
    if (i == null && o && (t < 0 || o == Un(r))) {
      let l = r.childNodes[o - 1];
      if (l.nodeType == 1)
        return xp(l.getBoundingClientRect(), !1);
    }
    if (i == null && o < Un(r)) {
      let l = r.childNodes[o];
      if (l.nodeType == 1)
        return xp(l.getBoundingClientRect(), !0);
    }
    return xp(r.getBoundingClientRect(), t >= 0);
  }
  if (i == null && o && (t < 0 || o == Un(r))) {
    let l = r.childNodes[o - 1], d = l.nodeType == 3 ? to(l, Un(l) - (a ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (d)
      return Ss(No(d, 1), !1);
  }
  if (i == null && o < Un(r)) {
    let l = r.childNodes[o];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let d = l ? l.nodeType == 3 ? to(l, 0, a ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (d)
      return Ss(No(d, -1), !0);
  }
  return Ss(No(r.nodeType == 3 ? to(r) : r, -t), t >= 0);
}
function Ss(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function xp(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function _4(n, e, t) {
  let r = n.state, o = n.root.activeElement;
  r != e && n.updateState(e), o != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), o != n.dom && o && o.focus();
  }
}
function LI(n, e, t) {
  let r = e.selection, o = t == "up" ? r.$from : r.$to;
  return _4(n, e, () => {
    let { node: i } = n.docView.domFromPos(o.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let s = n.docView.nearestDesc(i, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        i = s.contentDOM || s.dom;
        break;
      }
      i = s.dom.parentNode;
    }
    let a = k4(n, o.pos, 1);
    for (let s = i.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = to(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < l.length; d++) {
        let u = l[d];
        if (u.bottom > u.top + 1 && (t == "up" ? a.top - u.top > (u.bottom - a.top) * 2 : u.bottom - a.bottom > (a.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const FI = /[\u0590-\u08ac]/;
function VI(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, i = !o, a = o == r.parent.content.size, s = n.domSelection();
  return s ? !FI.test(r.parent.textContent) || !s.modify ? t == "left" || t == "backward" ? i : a : _4(n, e, () => {
    let { focusNode: l, focusOffset: d, anchorNode: u, anchorOffset: f } = n.domSelectionRange(), p = s.caretBidiLevel;
    s.modify("move", t, "character");
    let h = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: m, focusOffset: g } = n.domSelectionRange(), v = m && !h.contains(m.nodeType == 1 ? m : m.parentNode) || l == m && d == g;
    try {
      s.collapse(u, f), l && (l != u || d != f) && s.extend && s.extend(l, d);
    } catch {
    }
    return p != null && (s.caretBidiLevel = p), v;
  }) : r.pos == r.start() || r.pos == r.end();
}
let Xv = null, Qv = null, ey = !1;
function zI(n, e, t) {
  return Xv == e && Qv == t ? ey : (Xv = e, Qv = t, ey = t == "up" || t == "down" ? LI(n, e, t) : VI(n, e, t));
}
const qn = 0, ty = 1, Si = 2, Hr = 3;
class wd {
  constructor(e, t, r, o) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = o, this.dirty = qn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let o = this.children[t];
      if (o == e)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let i, a;
        if (e == this.contentDOM)
          i = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.previousSibling;
        }
        for (; i && !((a = i.pmViewDesc) && a.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(a) + a.size : this.posAtStart;
      } else {
        let i, a;
        if (e == this.contentDOM)
          i = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.nextSibling;
        }
        for (; i && !((a = i.pmViewDesc) && a.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(a) : this.posAtEnd;
      }
    let o;
    if (e == this.dom && this.contentDOM)
      o = t > Gt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (o == null && t == e.childNodes.length)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            o = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, o = e; o; o = o.parentNode) {
      let i = this.getDesc(o), a;
      if (i && (!t || i.node))
        if (r && (a = i.nodeDOM) && !(a.nodeType == 1 ? a.contains(e.nodeType == 1 ? e : e.parentNode) : a == e))
          r = !1;
        else
          return i;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let o = e; o; o = o.parentNode) {
      let i = this.getDesc(o);
      if (i)
        return i.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let o = this.children[t], i = r + o.size;
      if (r == e && i != r) {
        for (; !o.border && o.children.length; )
          for (let a = 0; a < o.children.length; a++) {
            let s = o.children[a];
            if (s.size) {
              o = s;
              break;
            }
          }
        return o;
      }
      if (e < i)
        return o.descAt(e - r - o.border);
      r = i;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, o = 0;
    for (let i = 0; r < this.children.length; r++) {
      let a = this.children[r], s = i + a.size;
      if (s > e || a instanceof E4) {
        o = e - i;
        break;
      }
      i = s;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, t);
    for (let i; r && !(i = this.children[r - 1]).size && i instanceof S4 && i.side >= 0; r--)
      ;
    if (t <= 0) {
      let i, a = !0;
      for (; i = r ? this.children[r - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); r--, a = !1)
        ;
      return i && t && a && !i.border && !i.domAtom ? i.domFromPos(i.size, t) : { node: this.contentDOM, offset: i ? Gt(i.dom) + 1 : 0 };
    } else {
      let i, a = !0;
      for (; i = r < this.children.length ? this.children[r] : null, !(!i || i.dom.parentNode == this.contentDOM); r++, a = !1)
        ;
      return i && a && !i.border && !i.domAtom ? i.domFromPos(0, t) : { node: this.contentDOM, offset: i ? Gt(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, i = -1;
    for (let a = r, s = 0; ; s++) {
      let l = this.children[s], d = a + l.size;
      if (o == -1 && e <= d) {
        let u = a + l.border;
        if (e >= u && t <= d - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = a;
        for (let f = s; f > 0; f--) {
          let p = this.children[f - 1];
          if (p.size && p.dom.parentNode == this.contentDOM && !p.emptyChildAt(1)) {
            o = Gt(p.dom) + 1;
            break;
          }
          e -= p.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (d > t || s == this.children.length - 1)) {
        t = d;
        for (let u = s + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            i = Gt(f.dom);
            break;
          }
          t += f.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      a = d;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: o, toOffset: i };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, o = !1) {
    let i = Math.min(e, t), a = Math.max(e, t);
    for (let h = 0, m = 0; h < this.children.length; h++) {
      let g = this.children[h], v = m + g.size;
      if (i > m && a < v)
        return g.setSelection(e - m - g.border, t - m - g.border, r, o);
      m = v;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = t == e ? s : this.domFromPos(t, t ? -1 : 1), d = r.root.getSelection(), u = r.domSelectionRange(), f = !1;
    if ((wr || gn) && e == t) {
      let { node: h, offset: m } = s;
      if (h.nodeType == 3) {
        if (f = !!(m && h.nodeValue[m - 1] == `
`), f && m == h.nodeValue.length)
          for (let g = h, v; g; g = g.parentNode) {
            if (v = g.nextSibling) {
              v.nodeName == "BR" && (s = l = { node: v.parentNode, offset: Gt(v) + 1 });
              break;
            }
            let $ = g.pmViewDesc;
            if ($ && $.node && $.node.isBlock)
              break;
          }
      } else {
        let g = h.childNodes[m - 1];
        f = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if (wr && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (o = !0);
    }
    if (!(o || f && gn) && Ki(s.node, s.offset, u.anchorNode, u.anchorOffset) && Ki(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let p = !1;
    if ((d.extend || e == t) && !f) {
      d.collapse(s.node, s.offset);
      try {
        e != t && d.extend(l.node, l.offset), p = !0;
      } catch {
      }
    }
    if (!p) {
      if (e > t) {
        let m = s;
        s = l, l = m;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let i = this.children[o], a = r + i.size;
      if (r == a ? e <= a && t >= r : e < a && t > r) {
        let s = r + i.border, l = a - i.border;
        if (e >= s && t <= l) {
          this.dirty = e == r || t == a ? Si : ty, e == s && t == l && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = Hr : i.markDirty(e - s, t - s);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? Si : Hr;
      }
      r = a;
    }
    this.dirty = Si;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? Si : ty;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class S4 extends wd {
  constructor(e, t, r, o) {
    let i, a = t.type.toDOM;
    if (typeof a == "function" && (a = a(r, () => {
      if (!i)
        return o;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !t.type.spec.raw) {
      if (a.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(a), a = s;
      }
      a.contentEditable = "false", a.classList.add("ProseMirror-widget");
    }
    super(e, [], a, null), this.widget = t, this.widget = t, i = this;
  }
  matchesWidget(e) {
    return this.dirty == qn && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class jI extends wd {
  constructor(e, t, r, o) {
    super(e, [], t, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Wi extends wd {
  constructor(e, t, r, o, i) {
    super(e, [], r, o), this.mark = t, this.spec = i;
  }
  static create(e, t, r, o) {
    let i = o.nodeViews[t.type.name], a = i && i(t, o, r);
    return (!a || !a.dom) && (a = oa.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new Wi(e, t, a.dom, a.contentDOM || a.dom, a);
  }
  parseRule() {
    return this.dirty & Hr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Hr && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != qn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = qn;
    }
  }
  slice(e, t, r) {
    let o = Wi.create(this.parent, this.mark, !0, r), i = this.children, a = this.size;
    t < a && (i = Gh(i, t, a, r)), e > 0 && (i = Gh(i, 0, e, r));
    for (let s = 0; s < i.length; s++)
      i[s].parent = o;
    return o.children = i, o;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Go extends wd {
  constructor(e, t, r, o, i, a, s, l, d) {
    super(e, [], i, a), this.node = t, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, o, i, a) {
    let s = i.nodeViews[t.type.name], l, d = s && s(t, i, () => {
      if (!l)
        return a;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, o), u = d && d.dom, f = d && d.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      u || ({ dom: u, contentDOM: f } = oa.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !f && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let p = u;
    return u = A4(u, r, t), d ? l = new HI(e, t, r, o, u, f || null, p, d, i, a + 1) : t.isText ? new wf(e, t, r, o, u, p, i) : new Go(e, t, r, o, u, f || null, p, i, a + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => W.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == qn && e.eq(this.node) && qu(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, o = t, i = e.composing ? this.localCompositionInfo(e, t) : null, a = i && i.pos > -1 ? i : null, s = i && i.pos < 0, l = new KI(this, a && a.node, e);
    GI(this.node, this.innerDeco, (d, u, f) => {
      d.spec.marks ? l.syncToMarks(d.spec.marks, r, e) : d.type.side >= 0 && !f && l.syncToMarks(u == this.node.childCount ? ft.none : this.node.child(u).marks, r, e), l.placeWidget(d, e, o);
    }, (d, u, f, p) => {
      l.syncToMarks(d.marks, r, e);
      let h;
      l.findNodeMatch(d, u, f, p) || s && e.state.selection.from > o && e.state.selection.to < o + d.nodeSize && (h = l.findIndexWithChild(i.node)) > -1 && l.updateNodeAt(d, u, f, h, e) || l.updateNextNode(d, u, f, e, p, o) || l.addNode(d, u, f, e, o), o += d.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Si) && (a && this.protectLocalComposition(e, a), O4(this.contentDOM, this.children, e), ns && JI(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: o } = e.state.selection;
    if (!(e.state.selection instanceof Fe) || r < t || o > t + this.node.content.size)
      return null;
    let i = e.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let a = i.nodeValue, s = ZI(this.node.content, a, r - t, o - t);
      return s < 0 ? null : { node: i, pos: s, text: a };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: o }) {
    if (this.getDesc(t))
      return;
    let i = t;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let a = new jI(this, i, t, o);
    e.input.compositionNodes.push(a), this.children = Gh(this.children, r, r + o.length, e, a);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, o) {
    return this.dirty == Hr || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, o), !0);
  }
  updateInner(e, t, r, o) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = qn;
  }
  updateOuterDeco(e) {
    if (qu(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = T4(this.dom, this.nodeDOM, qh(this.outerDeco, this.node, t), qh(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function ny(n, e, t, r, o) {
  A4(r, e, n);
  let i = new Go(void 0, n, e, t, r, r, r, o, 0);
  return i.contentDOM && i.updateChildren(o, 0), i;
}
class wf extends Go {
  constructor(e, t, r, o, i, a, s) {
    super(e, t, r, o, i, null, a, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, o) {
    return this.dirty == Hr || this.dirty != qn && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != qn || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = e, this.dirty = qn, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let o = this.node.cut(e, t), i = document.createTextNode(o.text);
    return new wf(this.parent, o, this.outerDeco, this.innerDeco, i, i, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Hr);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class E4 extends wd {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == qn && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class HI extends Go {
  constructor(e, t, r, o, i, a, s, l, d, u) {
    super(e, t, r, o, i, a, s, d, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, o) {
    if (this.dirty == Hr)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let i = this.spec.update(e, t, r);
      return i && this.updateInner(e, t, r, o), i;
    } else
      return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, o) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function O4(n, e, t) {
  let r = n.firstChild, o = !1;
  for (let i = 0; i < e.length; i++) {
    let a = e[i], s = a.dom;
    if (s.parentNode == n) {
      for (; s != r; )
        r = ry(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, n.insertBefore(s, r);
    if (a instanceof Wi) {
      let l = r ? r.previousSibling : n.lastChild;
      O4(a.contentDOM, a.children, t), r = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = ry(r), o = !0;
  o && t.trackWrites == n && (t.trackWrites = null);
}
const rl = function(n) {
  n && (this.nodeName = n);
};
rl.prototype = /* @__PURE__ */ Object.create(null);
const Ei = [new rl()];
function qh(n, e, t) {
  if (n.length == 0)
    return Ei;
  let r = t ? Ei[0] : new rl(), o = [r];
  for (let i = 0; i < n.length; i++) {
    let a = n[i].type.attrs;
    if (a) {
      a.nodeName && o.push(r = new rl(a.nodeName));
      for (let s in a) {
        let l = a[s];
        l != null && (t && o.length == 1 && o.push(r = new rl(e.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return o;
}
function T4(n, e, t, r) {
  if (t == Ei && r == Ei)
    return e;
  let o = e;
  for (let i = 0; i < r.length; i++) {
    let a = r[i], s = t[i];
    if (i) {
      let l;
      s && s.nodeName == a.nodeName && o != n && (l = o.parentNode) && l.nodeName.toLowerCase() == a.nodeName || (l = document.createElement(a.nodeName), l.pmIsDeco = !0, l.appendChild(o), s = Ei[0]), o = l;
    }
    UI(o, s || Ei[0], a);
  }
  return o;
}
function UI(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], o = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < r.length; i++)
      o.indexOf(r[i]) == -1 && n.classList.remove(r[i]);
    for (let i = 0; i < o.length; i++)
      r.indexOf(o[i]) == -1 && n.classList.add(o[i]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(e.style); )
        n.style.removeProperty(o[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function A4(n, e, t) {
  return T4(n, n, Ei, qh(e, t, n.nodeType != 1));
}
function qu(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function ry(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class KI {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = WI(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r) {
    let o = 0, i = this.stack.length >> 1, a = Math.min(i, e.length);
    for (; o < a && (o == i - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(e[o]) && e[o].type.spec.spanning !== !1; )
      o++;
    for (; o < i; )
      this.destroyRest(), this.top.dirty = qn, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let d = this.top.children[l];
        if (d.matchesMark(e[i]) && !this.isLocked(d.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = Wi.create(this.top, e[i], t, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, o) {
    let i = -1, a;
    if (o >= this.preMatch.index && (a = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && a.matchesNode(e, t, r))
      i = this.top.children.indexOf(a, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let d = this.top.children[s];
        if (d.matchesNode(e, t, r) && !this.preMatch.matched.has(d)) {
          i = s;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(e, t, r, o, i) {
    let a = this.top.children[o];
    return a.dirty == Hr && a.dom == a.contentDOM && (a.dirty = Si), a.update(e, t, r, i) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, o, i, a) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof Go) {
        let d = this.preMatch.matched.get(l);
        if (d != null && d != i)
          return !1;
        let u = l.dom, f, p = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Hr && qu(t, l.outerDeco));
        if (!p && l.update(e, t, r, o))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!p && (f = this.recreateWrapper(l, e, t, r, o, a)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = f, f.contentDOM && (f.dirty = Si, f.updateChildren(o, a + 1), f.dirty = qn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, o, i, a) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !qu(r, e.outerDeco) || !o.eq(e.innerDeco))
      return null;
    let s = Go.create(this.top, t, r, o, i, a);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, o, i) {
    let a = Go.create(this.top, e, t, r, o, i);
    a.contentDOM && a.updateChildren(o, i + 1), this.top.children.splice(this.index++, 0, a), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(e) && (e == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new S4(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Wi; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof wf) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((gn || on) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new E4(this.top, [], r, null);
      t != this.top ? t.children.push(o) : t.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function WI(n, e) {
  let t = e, r = t.children.length, o = n.childCount, i = /* @__PURE__ */ new Map(), a = [];
  e:
    for (; o > 0; ) {
      let s;
      for (; ; )
        if (r) {
          let d = t.children[r - 1];
          if (d instanceof Wi)
            t = d, r = d.children.length;
          else {
            s = d, r--;
            break;
          }
        } else {
          if (t == e)
            break e;
          r = t.parent.children.indexOf(t), t = t.parent;
        }
      let l = s.node;
      if (l) {
        if (l != n.child(o - 1))
          break;
        --o, i.set(s, o), a.push(s);
      }
    }
  return { index: o, matched: i, matches: a.reverse() };
}
function qI(n, e) {
  return n.type.side - e.type.side;
}
function GI(n, e, t, r) {
  let o = e.locals(n), i = 0;
  if (o.length == 0) {
    for (let d = 0; d < n.childCount; d++) {
      let u = n.child(d);
      r(u, o, e.forChild(i, u), d), i += u.nodeSize;
    }
    return;
  }
  let a = 0, s = [], l = null;
  for (let d = 0; ; ) {
    let u, f;
    for (; a < o.length && o[a].to == i; ) {
      let v = o[a++];
      v.widget && (u ? (f || (f = [u])).push(v) : u = v);
    }
    if (u)
      if (f) {
        f.sort(qI);
        for (let v = 0; v < f.length; v++)
          t(f[v], d, !!l);
      } else
        t(u, d, !!l);
    let p, h;
    if (l)
      h = -1, p = l, l = null;
    else if (d < n.childCount)
      h = d, p = n.child(d++);
    else
      break;
    for (let v = 0; v < s.length; v++)
      s[v].to <= i && s.splice(v--, 1);
    for (; a < o.length && o[a].from <= i && o[a].to > i; )
      s.push(o[a++]);
    let m = i + p.nodeSize;
    if (p.isText) {
      let v = m;
      a < o.length && o[a].from < v && (v = o[a].from);
      for (let $ = 0; $ < s.length; $++)
        s[$].to < v && (v = s[$].to);
      v < m && (l = p.cut(v - i), p = p.cut(0, v - i), m = v, h = -1);
    } else
      for (; a < o.length && o[a].to < m; )
        a++;
    let g = p.isInline && !p.isLeaf ? s.filter((v) => !v.inline) : s.slice();
    r(p, g, e.forChild(i, p), h), i = m;
  }
}
function JI(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function ZI(n, e, t, r) {
  for (let o = 0, i = 0; o < n.childCount && i <= r; ) {
    let a = n.child(o++), s = i;
    if (i += a.nodeSize, !a.isText)
      continue;
    let l = a.text;
    for (; o < n.childCount; ) {
      let d = n.child(o++);
      if (i += d.nodeSize, !d.isText)
        break;
      l += d.text;
    }
    if (i >= t) {
      if (i >= r && l.slice(r - e.length - s, r - s) == e)
        return r - e.length;
      let d = s < r ? l.lastIndexOf(e, r - s - 1) : -1;
      if (d >= 0 && d + e.length + s >= t)
        return s + d;
      if (t == r && l.length >= r + e.length - s && l.slice(r - s, r - s + e.length) == e)
        return r;
    }
  }
  return -1;
}
function Gh(n, e, t, r, o) {
  let i = [];
  for (let a = 0, s = 0; a < n.length; a++) {
    let l = n[a], d = s, u = s += l.size;
    d >= t || u <= e ? i.push(l) : (d < e && i.push(l.slice(0, e - d, r)), o && (i.push(o), o = void 0), u > t && i.push(l.slice(t - d, l.size, r)));
  }
  return i;
}
function A0(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let o = n.docView.nearestDesc(t.focusNode), i = o && o.size == 0, a = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (a < 0)
    return null;
  let s = r.resolve(a), l, d;
  if ($f(t)) {
    for (l = a; o && !o.node; )
      o = o.parent;
    let f = o.node;
    if (o && f.isAtom && Te.isSelectable(f) && o.parent && !(f.isInline && xI(t.focusNode, t.focusOffset, o.dom))) {
      let p = o.posBefore;
      d = new Te(a == p ? s : r.resolve(p));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let f = a, p = a;
      for (let h = 0; h < t.rangeCount; h++) {
        let m = t.getRangeAt(h);
        f = Math.min(f, n.docView.posFromDOM(m.startContainer, m.startOffset, 1)), p = Math.max(p, n.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (f < 0)
        return null;
      [l, a] = p == n.state.selection.anchor ? [p, f] : [f, p], s = r.resolve(a);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = r.resolve(l);
  if (!d) {
    let f = e == "pointer" || n.state.selection.head < s.pos && !i ? 1 : -1;
    d = M0(n, u, s, f);
  }
  return d;
}
function M4(n) {
  return n.editable ? n.hasFocus() : P4(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function go(n, e = !1) {
  let t = n.state.selection;
  if (N4(n, t), !!M4(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && on) {
      let r = n.domSelectionRange(), o = n.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && Ki(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      XI(n);
    else {
      let { anchor: r, head: o } = t, i, a;
      oy && !(t instanceof Fe) && (t.$from.parent.inlineContent || (i = iy(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (a = iy(n, t.to))), n.docView.setSelection(r, o, n, e), oy && (i && ay(i), a && ay(a)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && YI(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const oy = gn || on && b4 < 63;
function iy(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), o = r < t.childNodes.length ? t.childNodes[r] : null, i = r ? t.childNodes[r - 1] : null;
  if (gn && o && o.contentEditable == "false")
    return Cp(o);
  if ((!o || o.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (o)
      return Cp(o);
    if (i)
      return Cp(i);
  }
}
function Cp(n) {
  return n.contentEditable = "true", gn && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function ay(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function YI(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, o = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != o) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!M4(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function XI(n) {
  let e = n.domSelection(), t = document.createRange();
  if (!e)
    return;
  let r = n.cursorWrapper.dom, o = r.nodeName == "IMG";
  o ? t.setStart(r.parentNode, Gt(r) + 1) : t.setStart(r, 0), t.collapse(!0), e.removeAllRanges(), e.addRange(t), !o && !n.state.selection.visible && _n && qo <= 11 && (r.disabled = !0, r.disabled = !1);
}
function N4(n, e) {
  if (e instanceof Te) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (sy(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    sy(n);
}
function sy(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function M0(n, e, t, r) {
  return n.someProp("createSelectionBetween", (o) => o(n, e, t)) || Fe.between(e, t, r);
}
function ly(n) {
  return n.editable && !n.hasFocus() ? !1 : P4(n);
}
function P4(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function QI(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Ki(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Jh(n, e) {
  let { $anchor: t, $head: r } = n.selection, o = e > 0 ? t.max(r) : t.min(r), i = o.parent.inlineContent ? o.depth ? n.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return i && Ue.findFrom(i, e);
}
function Do(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function dy(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Fe)
    if (t.indexOf("s") > -1) {
      let { $head: o } = r, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let a = n.state.doc.resolve(o.pos + i.nodeSize * (e < 0 ? -1 : 1));
      return Do(n, new Fe(r.$anchor, a));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let o = Jh(n.state, e);
        return o && o instanceof Te ? Do(n, o) : !1;
      } else if (!(Hn && t.indexOf("m") > -1)) {
        let o = r.$head, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, a;
        if (!i || i.isText)
          return !1;
        let s = e < 0 ? o.pos - i.nodeSize : o.pos;
        return i.isAtom || (a = n.docView.descAt(s)) && !a.contentDOM ? Te.isSelectable(i) ? Do(n, new Te(e < 0 ? n.state.doc.resolve(o.pos - i.nodeSize) : o)) : $d ? Do(n, new Fe(n.state.doc.resolve(e < 0 ? s : s + i.nodeSize))) : !1 : !1;
      }
    } else
      return !1;
  else {
    if (r instanceof Te && r.node.isInline)
      return Do(n, new Fe(e > 0 ? r.$to : r.$from));
    {
      let o = Jh(n.state, e);
      return o ? Do(n, o) : !1;
    }
  }
}
function Gu(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function ol(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function ca(n, e) {
  return e < 0 ? eR(n) : tR(n);
}
function eR(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o, i, a = !1;
  for (wr && t.nodeType == 1 && r < Gu(t) && ol(t.childNodes[r], -1) && (a = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let s = t.childNodes[r - 1];
        if (ol(s, -1))
          o = t, i = --r;
        else if (s.nodeType == 3)
          t = s, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (D4(t))
        break;
      {
        let s = t.previousSibling;
        for (; s && ol(s, -1); )
          o = t.parentNode, i = Gt(s), s = s.previousSibling;
        if (s)
          t = s, r = Gu(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  a ? Zh(n, t, r) : o && Zh(n, o, i);
}
function tR(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o = Gu(t), i, a;
  for (; ; )
    if (r < o) {
      if (t.nodeType != 1)
        break;
      let s = t.childNodes[r];
      if (ol(s, 1))
        i = t, a = ++r;
      else
        break;
    } else {
      if (D4(t))
        break;
      {
        let s = t.nextSibling;
        for (; s && ol(s, 1); )
          i = s.parentNode, a = Gt(s) + 1, s = s.nextSibling;
        if (s)
          t = s, r = 0, o = Gu(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = o = 0;
        }
      }
    }
  i && Zh(n, i, a);
}
function D4(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function nR(n, e) {
  for (; n && e == n.childNodes.length && !bd(n); )
    e = Gt(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function rR(n, e) {
  for (; n && !e && !bd(n); )
    e = Gt(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function Zh(n, e, t) {
  if (e.nodeType != 3) {
    let i, a;
    (a = nR(e, t)) ? (e = a, t = 0) : (i = rR(e, t)) && (e = i, t = i.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if ($f(r)) {
    let i = document.createRange();
    i.setEnd(e, t), i.setStart(e, t), r.removeAllRanges(), r.addRange(i);
  } else
    r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: o } = n;
  setTimeout(() => {
    n.state == o && go(n);
  }, 50);
}
function uy(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(on || _I) && t.parent.inlineContent) {
    let o = n.coordsAtPos(e);
    if (e > t.start()) {
      let i = n.coordsAtPos(e - 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left < o.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let i = n.coordsAtPos(e + 1), a = (i.top + i.bottom) / 2;
      if (a > o.top && a < o.bottom && Math.abs(i.left - o.left) > 1)
        return i.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function cy(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Fe && !r.empty || t.indexOf("s") > -1 || Hn && t.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: i } = r;
  if (!o.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let a = Jh(n.state, e);
    if (a && a instanceof Te)
      return Do(n, a);
  }
  if (!o.parent.inlineContent) {
    let a = e < 0 ? o : i, s = r instanceof Wn ? Ue.near(a, e) : Ue.findFrom(a, e);
    return s ? Do(n, s) : !1;
  }
  return !1;
}
function fy(n, e) {
  if (!(n.state.selection instanceof Fe))
    return !0;
  let { $head: t, $anchor: r, empty: o } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let i = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (i && !i.isText) {
    let a = n.state.tr;
    return e < 0 ? a.delete(t.pos - i.nodeSize, t.pos) : a.delete(t.pos, t.pos + i.nodeSize), n.dispatch(a), !0;
  }
  return !1;
}
function py(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function oR(n) {
  if (!gn || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    py(n, r, "true"), setTimeout(() => py(n, r, "false"), 20);
  }
  return !1;
}
function iR(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function aR(n, e) {
  let t = e.keyCode, r = iR(e);
  if (t == 8 || Hn && t == 72 && r == "c")
    return fy(n, -1) || ca(n, -1);
  if (t == 46 && !e.shiftKey || Hn && t == 68 && r == "c")
    return fy(n, 1) || ca(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Hn && t == 66 && r == "c") {
    let o = t == 37 ? uy(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return dy(n, o, r) || ca(n, o);
  } else if (t == 39 || Hn && t == 70 && r == "c") {
    let o = t == 39 ? uy(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return dy(n, o, r) || ca(n, o);
  } else {
    if (t == 38 || Hn && t == 80 && r == "c")
      return cy(n, -1, r) || ca(n, -1);
    if (t == 40 || Hn && t == 78 && r == "c")
      return oR(n) || cy(n, 1, r) || ca(n, 1);
    if (r == (Hn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function N0(n, e) {
  n.someProp("transformCopied", (h) => {
    e = h(e, n);
  });
  let t = [], { content: r, openStart: o, openEnd: i } = e;
  for (; o > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, i--;
    let h = r.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let a = n.someProp("clipboardSerializer") || oa.fromSchema(n.state.schema), s = V4(), l = s.createElement("div");
  l.appendChild(a.serializeFragment(r, { document: s }));
  let d = l.firstChild, u, f = 0;
  for (; d && d.nodeType == 1 && (u = F4[d.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let m = s.createElement(u[h]);
      for (; l.firstChild; )
        m.appendChild(l.firstChild);
      l.appendChild(m), f++;
    }
    d = l.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${o} ${i}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let p = n.someProp("clipboardTextSerializer", (h) => h(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: p, slice: e };
}
function I4(n, e, t, r, o) {
  let i = o.parent.type.spec.code, a, s;
  if (!t && !e)
    return null;
  let l = e && (r || i || !t);
  if (l) {
    if (n.someProp("transformPastedText", (p) => {
      e = p(e, i || r, n);
    }), i)
      return e ? new Y(W.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : Y.empty;
    let f = n.someProp("clipboardTextParser", (p) => p(e, o, r, n));
    if (f)
      s = f;
    else {
      let p = o.marks(), { schema: h } = n.state, m = oa.fromSchema(h);
      a = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let v = a.appendChild(document.createElement("p"));
        g && v.appendChild(m.serializeNode(h.text(g, p)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (f) => {
      t = f(t, n);
    }), a = uR(t), $d && cR(a);
  let d = a && a.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let p = a.firstChild;
      for (; p && p.nodeType != 1; )
        p = p.nextSibling;
      if (!p)
        break;
      a = p;
    }
  if (s || (s = (n.someProp("clipboardParser") || n.someProp("domParser") || Wo.fromSchema(n.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(l || u),
    context: o,
    ruleFromNode(p) {
      return p.nodeName == "BR" && !p.nextSibling && p.parentNode && !sR.test(p.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = fR(hy(s, +u[1], +u[2]), u[4]);
  else if (s = Y.maxOpen(lR(s.content, o), !0), s.openStart || s.openEnd) {
    let f = 0, p = 0;
    for (let h = s.content.firstChild; f < s.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; p < s.openEnd && !h.type.spec.isolating; p++, h = h.lastChild)
      ;
    s = hy(s, f, p);
  }
  return n.someProp("transformPasted", (f) => {
    s = f(s, n);
  }), s;
}
const sR = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function lR(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let o = e.node(t).contentMatchAt(e.index(t)), i, a = [];
    if (n.forEach((s) => {
      if (!a)
        return;
      let l = o.findWrapping(s.type), d;
      if (!l)
        return a = null;
      if (d = a.length && i.length && B4(l, i, s, a[a.length - 1], 0))
        a[a.length - 1] = d;
      else {
        a.length && (a[a.length - 1] = L4(a[a.length - 1], i.length));
        let u = R4(s, l);
        a.push(u), o = o.matchType(u.type), i = l;
      }
    }), a)
      return W.from(a);
  }
  return n;
}
function R4(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, W.from(n));
  return n;
}
function B4(n, e, t, r, o) {
  if (o < n.length && o < e.length && n[o] == e[o]) {
    let i = B4(n, e, t, r.lastChild, o + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(o == n.length - 1 ? t.type : n[o + 1]))
      return r.copy(r.content.append(W.from(R4(t, n, o + 1))));
  }
}
function L4(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, L4(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(W.empty, !0);
  return n.copy(t.append(r));
}
function Yh(n, e, t, r, o, i) {
  let a = e < 0 ? n.firstChild : n.lastChild, s = a.content;
  return n.childCount > 1 && (i = 0), o < r - 1 && (s = Yh(s, e, t, r, o + 1, i)), o >= t && (s = e < 0 ? a.contentMatchAt(0).fillBefore(s, i <= o).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(W.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, a.copy(s));
}
function hy(n, e, t) {
  return e < n.openStart && (n = new Y(Yh(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new Y(Yh(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const F4 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let my = null;
function V4() {
  return my || (my = document.implementation.createHTMLDocument("title"));
}
let kp = null;
function dR(n) {
  let e = window.trustedTypes;
  return e ? (kp || (kp = e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), kp.createHTML(n)) : n;
}
function uR(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = V4().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), o;
  if ((o = r && F4[r[1].toLowerCase()]) && (n = o.map((i) => "<" + i + ">").join("") + n + o.map((i) => "</" + i + ">").reverse().join("")), t.innerHTML = dR(n), o)
    for (let i = 0; i < o.length; i++)
      t = t.querySelector(o[i]) || t;
  return t;
}
function cR(n) {
  let e = n.querySelectorAll(on ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function fR(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: o, openStart: i, openEnd: a } = n;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = t.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    o = W.from(l.create(r[s + 1], o)), i++, a++;
  }
  return new Y(o, i, a);
}
const vn = {}, yn = {}, pR = { touchstart: !0, touchmove: !0 };
class hR {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function mR(n) {
  for (let e in vn) {
    let t = vn[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      vR(n, r) && !P0(n, r) && (n.editable || !(r.type in yn)) && t(n, r);
    }, pR[e] ? { passive: !0 } : void 0);
  }
  gn && n.dom.addEventListener("input", () => null), Xh(n);
}
function Uo(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function gR(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function Xh(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => P0(n, r));
  });
}
function P0(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function vR(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function yR(n, e) {
  !P0(n, e) && vn[e.type] && (n.editable || !(e.type in yn)) && vn[e.type](n, e);
}
yn.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !j4(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(fo && on && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), ns && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (o) => o(n, wi(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else
      n.someProp("handleKeyDown", (r) => r(n, t)) || aR(n, t) ? t.preventDefault() : Uo(n, "key");
};
yn.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
yn.keypress = (n, e) => {
  let t = e;
  if (j4(n, t) || !t.charCode || t.ctrlKey && !t.altKey || Hn && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (o) => o(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof Fe) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(o) && !n.someProp("handleTextInput", (i) => i(n, r.$from.pos, r.$to.pos, o)) && n.dispatch(n.state.tr.insertText(o).scrollIntoView()), t.preventDefault();
  }
};
function xf(n) {
  return { left: n.clientX, top: n.clientY };
}
function bR(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function D0(n, e, t, r, o) {
  if (r == -1)
    return !1;
  let i = n.state.doc.resolve(r);
  for (let a = i.depth + 1; a > 0; a--)
    if (n.someProp(e, (s) => a > i.depth ? s(n, t, i.nodeAfter, i.before(a), o, !0) : s(n, t, i.node(a), i.before(a), o, !1)))
      return !0;
  return !1;
}
function Pa(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  t == "pointer" && r.setMeta("pointer", !0), n.dispatch(r);
}
function $R(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && Te.isSelectable(r) ? (Pa(n, new Te(t), "pointer"), !0) : !1;
}
function wR(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, o;
  t instanceof Te && (r = t.node);
  let i = n.state.doc.resolve(e);
  for (let a = i.depth + 1; a > 0; a--) {
    let s = a > i.depth ? i.nodeAfter : i.node(a);
    if (Te.isSelectable(s)) {
      r && t.$from.depth > 0 && a >= t.$from.depth && i.before(t.$from.depth + 1) == t.$from.pos ? o = i.before(t.$from.depth) : o = i.before(a);
      break;
    }
  }
  return o != null ? (Pa(n, Te.create(n.state.doc, o), "pointer"), !0) : !1;
}
function xR(n, e, t, r, o) {
  return D0(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (i) => i(n, e, r)) || (o ? wR(n, t) : $R(n, t));
}
function CR(n, e, t, r) {
  return D0(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (o) => o(n, e, r));
}
function kR(n, e, t, r) {
  return D0(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (o) => o(n, e, r)) || _R(n, t, r);
}
function _R(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (Pa(n, Fe.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let o = r.resolve(e);
  for (let i = o.depth + 1; i > 0; i--) {
    let a = i > o.depth ? o.nodeAfter : o.node(i), s = o.before(i);
    if (a.inlineContent)
      Pa(n, Fe.create(r, s + 1, s + 1 + a.content.size), "pointer");
    else if (Te.isSelectable(a))
      Pa(n, Te.create(r, s), "pointer");
    else
      continue;
    return !0;
  }
}
function I0(n) {
  return Ju(n);
}
const z4 = Hn ? "metaKey" : "ctrlKey";
vn.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = I0(n), o = Date.now(), i = "singleClick";
  o - n.input.lastClick.time < 500 && bR(t, n.input.lastClick) && !t[z4] && (n.input.lastClick.type == "singleClick" ? i = "doubleClick" : n.input.lastClick.type == "doubleClick" && (i = "tripleClick")), n.input.lastClick = { time: o, x: t.clientX, y: t.clientY, type: i };
  let a = n.posAtCoords(xf(t));
  a && (i == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new SR(n, a, t, !!r)) : (i == "doubleClick" ? CR : kR)(n, a.pos, a.inside, t) ? t.preventDefault() : Uo(n, "pointer"));
};
class SR {
  constructor(e, t, r, o) {
    this.view = e, this.pos = t, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[z4], this.allowDefault = r.shiftKey;
    let i, a;
    if (t.inside > -1)
      i = e.state.doc.nodeAt(t.inside), a = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      i = u.parent, a = u.depth ? u.before() : 0;
    }
    const s = o ? null : r.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: d } = e.state;
    (r.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || d instanceof Te && d.from <= a && d.to > a) && (this.mightDrag = {
      node: i,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && wr && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Uo(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => go(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(xf(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Uo(this.view, "pointer") : xR(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    gn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    on && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (Pa(this.view, Ue.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : Uo(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Uo(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
vn.touchstart = (n) => {
  n.input.lastTouch = Date.now(), I0(n), Uo(n, "pointer");
};
vn.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Uo(n, "pointer");
};
vn.contextmenu = (n) => I0(n);
function j4(n, e) {
  return n.composing ? !0 : gn && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const ER = fo ? 5e3 : -1;
yn.compositionstart = yn.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Fe && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Ju(n, !0), n.markCursor = null;
    else if (Ju(n, !e.selection.empty), wr && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let o = r.focusNode, i = r.focusOffset; o && o.nodeType == 1 && i != 0; ) {
        let a = i < 0 ? o.lastChild : o.childNodes[i - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          let s = n.domSelection();
          s && s.collapse(a, a.nodeValue.length);
          break;
        } else
          o = a, i = -1;
      }
    }
    n.input.composing = !0;
  }
  H4(n, ER);
};
yn.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, H4(n, 20));
};
function H4(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Ju(n), e));
}
function U4(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = TR()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function OR(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = $I(e.focusNode, e.focusOffset), r = wI(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let o = r.pmViewDesc, i = n.domObserver.lastChangedTextNode;
    if (t == i || r == i)
      return i;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let a = t.pmViewDesc;
      if (!(!a || !a.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function TR() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Ju(n, e = !1) {
  if (!(fo && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), U4(n), e || n.docView && n.docView.dirty) {
      let t = A0(n);
      return t && !t.eq(n.state.selection) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !n.state.selection.empty ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function AR(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const Ul = _n && qo < 15 || ns && SI < 604;
vn.copy = yn.cut = (n, e) => {
  let t = e, r = n.state.selection, o = t.type == "cut";
  if (r.empty)
    return;
  let i = Ul ? null : t.clipboardData, a = r.content(), { dom: s, text: l } = N0(n, a);
  i ? (t.preventDefault(), i.clearData(), i.setData("text/html", s.innerHTML), i.setData("text/plain", l)) : AR(n, s), o && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function MR(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function NR(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? Kl(n, r.value, null, o, e) : Kl(n, r.textContent, r.innerHTML, o, e);
  }, 50);
}
function Kl(n, e, t, r, o) {
  let i = I4(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, o, i || Y.empty)))
    return !0;
  if (!i)
    return !1;
  let a = MR(i), s = a ? n.state.tr.replaceSelectionWith(a, r) : n.state.tr.replaceSelection(i);
  return n.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function K4(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
yn.paste = (n, e) => {
  let t = e;
  if (n.composing && !fo)
    return;
  let r = Ul ? null : t.clipboardData, o = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && Kl(n, K4(r), r.getData("text/html"), o, t) ? t.preventDefault() : NR(n, t);
};
class W4 {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const PR = Hn ? "altKey" : "ctrlKey";
function q4(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[PR];
}
vn.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let o = n.state.selection, i = o.empty ? null : n.posAtCoords(xf(t)), a;
  if (!(i && i.pos >= o.from && i.pos <= (o instanceof Te ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      a = Te.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let f = n.docView.nearestDesc(t.target, !0);
      f && f.node.type.spec.draggable && f != n.docView && (a = Te.create(n.state.doc, f.posBefore));
    }
  }
  let s = (a || n.state.selection).content(), { dom: l, text: d, slice: u } = N0(n, s);
  (!t.dataTransfer.files.length || !on || b4 > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(Ul ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", Ul || t.dataTransfer.setData("text/plain", d), n.dragging = new W4(u, q4(n, t), a);
};
vn.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
yn.dragover = yn.dragenter = (n, e) => e.preventDefault();
yn.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let o = n.posAtCoords(xf(t));
  if (!o)
    return;
  let i = n.state.doc.resolve(o.pos), a = r && r.slice;
  a ? n.someProp("transformPasted", (m) => {
    a = m(a, n);
  }) : a = I4(n, K4(t.dataTransfer), Ul ? null : t.dataTransfer.getData("text/html"), !1, i);
  let s = !!(r && q4(n, t));
  if (n.someProp("handleDrop", (m) => m(n, t, a || Y.empty, s))) {
    t.preventDefault();
    return;
  }
  if (!a)
    return;
  t.preventDefault();
  let l = a ? p4(n.state.doc, i.pos, a) : i.pos;
  l == null && (l = i.pos);
  let d = n.state.tr;
  if (s) {
    let { node: m } = r;
    m ? m.replace(d) : d.deleteSelection();
  }
  let u = d.mapping.map(l), f = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, p = d.doc;
  if (f ? d.replaceRangeWith(u, u, a.content.firstChild) : d.replaceRange(u, u, a), d.doc.eq(p))
    return;
  let h = d.doc.resolve(u);
  if (f && Te.isSelectable(a.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(a.content.firstChild))
    d.setSelection(new Te(h));
  else {
    let m = d.mapping.map(l);
    d.mapping.maps[d.mapping.maps.length - 1].forEach((g, v, $, C) => m = C), d.setSelection(M0(n, h, d.doc.resolve(m)));
  }
  n.focus(), n.dispatch(d.setMeta("uiEvent", "drop"));
};
vn.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && go(n);
  }, 20));
};
vn.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
vn.beforeinput = (n, e) => {
  if (on && fo && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (i) => i(n, wi(8, "Backspace")))))
        return;
      let { $cursor: o } = n.state.selection;
      o && o.pos > 0 && n.dispatch(n.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in yn)
  vn[n] = yn[n];
function Wl(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class Zu {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Ni, this.side = this.spec.side || 0;
  }
  map(e, t, r, o) {
    let { pos: i, deleted: a } = e.mapResult(t.from + o, this.side < 0 ? -1 : 1);
    return a ? null : new an(i - r, i - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Zu && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Wl(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Jo {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Ni;
  }
  map(e, t, r, o) {
    let i = e.map(t.from + o, this.spec.inclusiveStart ? -1 : 1) - r, a = e.map(t.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return i >= a ? null : new an(i, a, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof Jo && Wl(this.attrs, e.attrs) && Wl(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Jo;
  }
  destroy() {
  }
}
class R0 {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Ni;
  }
  map(e, t, r, o) {
    let i = e.mapResult(t.from + o, 1);
    if (i.deleted)
      return null;
    let a = e.mapResult(t.to + o, -1);
    return a.deleted || a.pos <= i.pos ? null : new an(i.pos - r, a.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: o } = e.content.findIndex(t.from), i;
    return o == t.from && !(i = e.child(r)).isText && o + i.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof R0 && Wl(this.attrs, e.attrs) && Wl(this.spec, e.spec);
  }
  destroy() {
  }
}
class an {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new an(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new an(e, e, new Zu(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, o) {
    return new an(e, t, new Jo(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, o) {
    return new an(e, t, new R0(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Jo;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Zu;
  }
}
const va = [], Ni = {};
class kt {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : va, this.children = t.length ? t : va;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? Yu(t, e, 0, Ni) : rn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let o = [];
    return this.findInner(e ?? 0, t ?? 1e9, o, 0, r), o;
  }
  findInner(e, t, r, o, i) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= t && s.to >= e && (!i || i(s.spec)) && r.push(s.copy(s.from + o, s.to + o));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < t && this.children[a + 1] > e) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(e - s, t - s, r, o + s, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == rn || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || Ni);
  }
  /**
  @internal
  */
  mapInner(e, t, r, o, i) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, r, o);
      l && l.type.valid(t, l) ? (a || (a = [])).push(l) : i.onRemove && i.onRemove(this.local[s].spec);
    }
    return this.children.length ? DR(this.children, a || [], e, t, r, o, i) : a ? new kt(a.sort(Pi), va) : rn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == rn ? kt.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let o, i = 0;
    e.forEach((s, l) => {
      let d = l + r, u;
      if (u = J4(t, s, d)) {
        for (o || (o = this.children.slice()); i < o.length && o[i] < l; )
          i += 3;
        o[i] == l ? o[i + 2] = o[i + 2].addInner(s, u, d + 1) : o.splice(i, 0, l, l + s.nodeSize, Yu(u, s, d + 1, Ni)), i += 3;
      }
    });
    let a = G4(i ? Z4(t) : t, -r);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(e, a[s]) || a.splice(s--, 1);
    return new kt(a.length ? this.local.concat(a).sort(Pi) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == rn ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, o = this.local;
    for (let i = 0; i < r.length; i += 3) {
      let a, s = r[i] + t, l = r[i + 1] + t;
      for (let u = 0, f; u < e.length; u++)
        (f = e[u]) && f.from > s && f.to < l && (e[u] = null, (a || (a = [])).push(f));
      if (!a)
        continue;
      r == this.children && (r = this.children.slice());
      let d = r[i + 2].removeInner(a, s + 1);
      d != rn ? r[i + 2] = d : (r.splice(i, 3), i -= 3);
    }
    if (o.length) {
      for (let i = 0, a; i < e.length; i++)
        if (a = e[i])
          for (let s = 0; s < o.length; s++)
            o[s].eq(a, t) && (o == this.local && (o = this.local.slice()), o.splice(s--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new kt(o, r) : rn;
  }
  forChild(e, t) {
    if (this == rn)
      return this;
    if (t.isLeaf)
      return kt.empty;
    let r, o;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (r = this.children[s + 2]);
        break;
      }
    let i = e + 1, a = i + t.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < a && l.to > i && l.type instanceof Jo) {
        let d = Math.max(i, l.from) - i, u = Math.min(a, l.to) - i;
        d < u && (o || (o = [])).push(l.copy(d, u));
      }
    }
    if (o) {
      let s = new kt(o.sort(Pi), va);
      return r ? new Fo([s, r]) : s;
    }
    return r || rn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof kt) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return B0(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == rn)
      return va;
    if (e.inlineContent || !this.local.some(Jo.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Jo || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
kt.empty = new kt([], []);
kt.removeOverlap = B0;
const rn = kt.empty;
class Fo {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((o) => o.map(e, t, Ni));
    return Fo.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return kt.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].forChild(e, t);
      i != rn && (i instanceof Fo ? r = r.concat(i.members) : r.push(i));
    }
    return Fo.from(r);
  }
  eq(e) {
    if (!(e instanceof Fo) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].localsInner(e);
      if (i.length)
        if (!t)
          t = i;
        else {
          r && (t = t.slice(), r = !1);
          for (let a = 0; a < i.length; a++)
            t.push(i[a]);
        }
    }
    return t ? B0(r ? t : t.sort(Pi)) : va;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return rn;
      case 1:
        return e[0];
      default:
        return new Fo(e.every((t) => t instanceof kt) ? e : e.reduce((t, r) => t.concat(r instanceof kt ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function DR(n, e, t, r, o, i, a) {
  let s = n.slice();
  for (let d = 0, u = i; d < t.maps.length; d++) {
    let f = 0;
    t.maps[d].forEach((p, h, m, g) => {
      let v = g - m - (h - p);
      for (let $ = 0; $ < s.length; $ += 3) {
        let C = s[$ + 1];
        if (C < 0 || p > C + u - f)
          continue;
        let S = s[$] + u - f;
        h >= S ? s[$ + 1] = p <= S ? -2 : -1 : p >= u && v && (s[$] += v, s[$ + 1] += v);
      }
      f += v;
    }), u = t.maps[d].map(u, -1);
  }
  let l = !1;
  for (let d = 0; d < s.length; d += 3)
    if (s[d + 1] < 0) {
      if (s[d + 1] == -2) {
        l = !0, s[d + 1] = -1;
        continue;
      }
      let u = t.map(n[d] + i), f = u - o;
      if (f < 0 || f >= r.content.size) {
        l = !0;
        continue;
      }
      let p = t.map(n[d + 1] + i, -1), h = p - o, { index: m, offset: g } = r.content.findIndex(f), v = r.maybeChild(m);
      if (v && g == f && g + v.nodeSize == h) {
        let $ = s[d + 2].mapInner(t, v, u + 1, n[d] + i + 1, a);
        $ != rn ? (s[d] = f, s[d + 1] = h, s[d + 2] = $) : (s[d + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let d = IR(s, n, e, t, o, i, a), u = Yu(d, r, 0, a);
    e = u.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, p = 0; f < u.children.length; f += 3) {
      let h = u.children[f];
      for (; p < s.length && s[p] < h; )
        p += 3;
      s.splice(p, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new kt(e.sort(Pi), s);
}
function G4(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let o = n[r];
    t.push(new an(o.from + e, o.to + e, o.type));
  }
  return t;
}
function IR(n, e, t, r, o, i, a) {
  function s(l, d) {
    for (let u = 0; u < l.local.length; u++) {
      let f = l.local[u].map(r, o, d);
      f ? t.push(f) : a.onRemove && a.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + d + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && s(n[l + 2], e[l] + i + 1);
  return t;
}
function J4(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, o = null;
  for (let i = 0, a; i < n.length; i++)
    (a = n[i]) && a.from > t && a.to < r && ((o || (o = [])).push(a), n[i] = null);
  return o;
}
function Z4(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Yu(n, e, t, r) {
  let o = [], i = !1;
  e.forEach((s, l) => {
    let d = J4(n, s, l + t);
    if (d) {
      i = !0;
      let u = Yu(d, s, t + l + 1, r);
      u != rn && o.push(l, l + s.nodeSize, u);
    }
  });
  let a = G4(i ? Z4(n) : n, -t).sort(Pi);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(e, a[s]) || (r.onRemove && r.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || o.length ? new kt(a, o) : rn;
}
function Pi(n, e) {
  return n.from - e.from || n.to - e.to;
}
function B0(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let o = t + 1; o < e.length; o++) {
        let i = e[o];
        if (i.from == r.from) {
          i.to != r.to && (e == n && (e = n.slice()), e[o] = i.copy(i.from, r.to), gy(e, o + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, i.from), gy(e, o, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function gy(n, e, t) {
  for (; e < n.length && Pi(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function _p(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != rn && e.push(r);
  }), n.cursorWrapper && e.push(kt.create(n.state.doc, [n.cursorWrapper.deco])), Fo.from(e);
}
const RR = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, BR = _n && qo <= 11;
class LR {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class FR {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new LR(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      _n && qo <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), BR && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, RR)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (ly(this.view)) {
      if (this.suppressingSelectionUpdates)
        return go(this.view);
      if (_n && qo <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Ki(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let i = e.focusNode; i; i = ts(i))
      t.add(i);
    for (let i = e.anchorNode; i; i = ts(i))
      if (t.has(i)) {
        r = i;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && ly(e) && !this.ignoreSelectionChange(r), i = -1, a = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let f = this.registerMutation(t[u], l);
        f && (i = i < 0 ? f.from : Math.min(f.from, i), a = a < 0 ? f.to : Math.max(f.to, a), f.typeOver && (s = !0));
      }
    if (wr && l.length) {
      let u = l.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, p] = u;
        f.parentNode && f.parentNode.parentNode == p.parentNode ? p.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let p of u) {
          let h = p.parentNode;
          h && h.nodeName == "LI" && (!f || jR(e, f) != h) && p.remove();
        }
      }
    }
    let d = null;
    i < 0 && o && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && $f(r) && (d = A0(e)) && d.eq(Ue.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, go(e), this.currentSelection.set(r), e.scrollToSelection()) : (i > -1 || o) && (i > -1 && (e.docView.markDirty(i, a), VR(e)), this.handleDOMChange(i, a, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || go(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let f = e.addedNodes[u];
        t.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = e.previousSibling, i = e.nextSibling;
      if (_n && qo <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: p } = e.addedNodes[u];
          (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (o = f), (!p || Array.prototype.indexOf.call(e.addedNodes, p) < 0) && (i = p);
        }
      let a = o && o.parentNode == e.target ? Gt(o) + 1 : 0, s = r.localPosFromDOM(e.target, a, -1), l = i && i.parentNode == e.target ? Gt(i) : e.target.childNodes.length, d = r.localPosFromDOM(e.target, l, 1);
      return { from: s, to: d };
    } else
      return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
        from: r.posAtStart,
        to: r.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: e.target.nodeValue == e.oldValue
      });
  }
}
let vy = /* @__PURE__ */ new WeakMap(), yy = !1;
function VR(n) {
  if (!vy.has(n) && (vy.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = wr, yy)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), yy = !0;
  }
}
function by(n, e) {
  let t = e.startContainer, r = e.startOffset, o = e.endContainer, i = e.endOffset, a = n.domAtPos(n.state.selection.anchor);
  return Ki(a.node, a.offset, o, i) && ([t, r, o, i] = [o, i, t, r]), { anchorNode: t, anchorOffset: r, focusNode: o, focusOffset: i };
}
function zR(n, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(n.root)[0];
    if (o)
      return by(n, o);
  }
  let t;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), t = o.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? by(n, t) : null;
}
function jR(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function HR(n, e, t) {
  let { node: r, fromOffset: o, toOffset: i, from: a, to: s } = n.docView.parseRange(e, t), l = n.domSelectionRange(), d, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: l.anchorOffset }], $f(l) || d.push({ node: l.focusNode, offset: l.focusOffset })), on && n.input.lastKeyCode === 8)
    for (let v = i; v > o; v--) {
      let $ = r.childNodes[v - 1], C = $.pmViewDesc;
      if ($.nodeName == "BR" && !C) {
        i = v;
        break;
      }
      if (!C || C.size)
        break;
    }
  let f = n.state.doc, p = n.someProp("domParser") || Wo.fromSchema(n.state.schema), h = f.resolve(a), m = null, g = p.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: o,
    to: i,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: UR,
    context: h
  });
  if (d && d[0].pos != null) {
    let v = d[0].pos, $ = d[1] && d[1].pos;
    $ == null && ($ = v), m = { anchor: v + a, head: $ + a };
  }
  return { doc: g, sel: m, from: a, to: s };
}
function UR(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (gn && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || gn && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const KR = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function WR(n, e, t, r, o) {
  let i = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let I = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, P = A0(n, I);
    if (P && !n.state.selection.eq(P)) {
      if (on && fo && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (H) => H(n, wi(13, "Enter"))))
        return;
      let L = n.state.tr.setSelection(P);
      I == "pointer" ? L.setMeta("pointer", !0) : I == "key" && L.scrollIntoView(), i && L.setMeta("composition", i), n.dispatch(L);
    }
    return;
  }
  let a = n.state.doc.resolve(e), s = a.sharedDepth(t);
  e = a.before(s + 1), t = n.state.doc.resolve(t).after(s + 1);
  let l = n.state.selection, d = HR(n, e, t), u = n.state.doc, f = u.slice(d.from, d.to), p, h;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (p = n.state.selection.to, h = "end") : (p = n.state.selection.from, h = "start"), n.input.lastKeyCode = null;
  let m = JR(f.content, d.doc.content, d.from, p, h);
  if (m && n.input.domChangeCount++, (ns && n.input.lastIOSEnter > Date.now() - 225 || fo) && o.some((I) => I.nodeType == 1 && !KR.test(I.nodeName)) && (!m || m.endA >= m.endB) && n.someProp("handleKeyDown", (I) => I(n, wi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (r && l instanceof Fe && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(d.sel && d.sel.anchor != d.sel.head))
      m = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (d.sel) {
        let I = $y(n, n.state.doc, d.sel);
        if (I && !I.eq(n.state.selection)) {
          let P = n.state.tr.setSelection(I);
          i && P.setMeta("composition", i), n.dispatch(P);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && m.start == m.endB && n.state.selection instanceof Fe && (m.start > n.state.selection.from && m.start <= n.state.selection.from + 2 && n.state.selection.from >= d.from ? m.start = n.state.selection.from : m.endA < n.state.selection.to && m.endA >= n.state.selection.to - 2 && n.state.selection.to <= d.to && (m.endB += n.state.selection.to - m.endA, m.endA = n.state.selection.to)), _n && qo <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > d.from && d.doc.textBetween(m.start - d.from - 1, m.start - d.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let g = d.doc.resolveNoCache(m.start - d.from), v = d.doc.resolveNoCache(m.endB - d.from), $ = u.resolve(m.start), C = g.sameParent(v) && g.parent.inlineContent && $.end() >= m.endA, S;
  if ((ns && n.input.lastIOSEnter > Date.now() - 225 && (!C || o.some((I) => I.nodeName == "DIV" || I.nodeName == "P")) || !C && g.pos < d.doc.content.size && (!g.sameParent(v) || !g.parent.inlineContent) && (S = Ue.findFrom(d.doc.resolve(g.pos + 1), 1, !0)) && S.head > g.pos) && n.someProp("handleKeyDown", (I) => I(n, wi(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > m.start && GR(u, m.start, m.endA, g, v) && n.someProp("handleKeyDown", (I) => I(n, wi(8, "Backspace")))) {
    fo && on && n.domObserver.suppressSelectionUpdates();
    return;
  }
  on && m.endB == m.start && (n.input.lastChromeDelete = Date.now()), fo && !C && g.start() != v.start() && v.parentOffset == 0 && g.depth == v.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == m.endA && (m.endB -= 2, v = d.doc.resolveNoCache(m.endB - d.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(I) {
      return I(n, wi(13, "Enter"));
    });
  }, 20));
  let w = m.start, T = m.endA, A, N, z;
  if (C) {
    if (g.pos == v.pos)
      _n && qo <= 11 && g.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => go(n), 20)), A = n.state.tr.delete(w, T), N = u.resolve(m.start).marksAcross(u.resolve(m.endA));
    else if (
      // Adding or removing a mark
      m.endA == m.endB && (z = qR(g.parent.content.cut(g.parentOffset, v.parentOffset), $.parent.content.cut($.parentOffset, m.endA - $.start())))
    )
      A = n.state.tr, z.type == "add" ? A.addMark(w, T, z.mark) : A.removeMark(w, T, z.mark);
    else if (g.parent.child(g.index()).isText && g.index() == v.index() - (v.textOffset ? 0 : 1)) {
      let I = g.parent.textBetween(g.parentOffset, v.parentOffset);
      if (n.someProp("handleTextInput", (P) => P(n, w, T, I)))
        return;
      A = n.state.tr.insertText(I, w, T);
    }
  }
  if (A || (A = n.state.tr.replace(w, T, d.doc.slice(m.start - d.from, m.endB - d.from))), d.sel) {
    let I = $y(n, A.doc, d.sel);
    I && !(on && n.composing && I.empty && (m.start != m.endB || n.input.lastChromeDelete < Date.now() - 100) && (I.head == w || I.head == A.mapping.map(T) - 1) || _n && I.empty && I.head == w) && A.setSelection(I);
  }
  N && A.ensureMarks(N), i && A.setMeta("composition", i), n.dispatch(A.scrollIntoView());
}
function $y(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : M0(n, e.resolve(t.anchor), e.resolve(t.head));
}
function qR(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, o = t, i = r, a, s, l;
  for (let u = 0; u < r.length; u++)
    o = r[u].removeFromSet(o);
  for (let u = 0; u < t.length; u++)
    i = t[u].removeFromSet(i);
  if (o.length == 1 && i.length == 0)
    s = o[0], a = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (o.length == 0 && i.length == 1)
    s = i[0], a = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < e.childCount; u++)
    d.push(l(e.child(u)));
  if (W.from(d).eq(n))
    return { mark: s, type: a };
}
function GR(n, e, t, r, o) {
  if (
    // The content must have shrunk
    t - e <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Sp(r, !0, !1) < o.pos
  )
    return !1;
  let i = n.resolve(e);
  if (!r.parent.isTextblock) {
    let s = i.nodeAfter;
    return s != null && t == e + s.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let a = n.resolve(Sp(i, !0, !0));
  return !a.parent.isTextblock || a.pos > t || Sp(a, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(a.parent.content);
}
function Sp(n, e, t) {
  let r = n.depth, o = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, o++, e = !1;
  if (t) {
    let i = n.node(r).maybeChild(n.indexAfter(r));
    for (; i && !i.isLeaf; )
      i = i.firstChild, o++;
  }
  return o;
}
function JR(n, e, t, r, o) {
  let i = n.findDiffStart(e, t);
  if (i == null)
    return null;
  let { a, b: s } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (o == "end") {
    let l = Math.max(0, i - Math.min(a, s));
    r -= a + l - i;
  }
  if (a < i && n.size < e.size) {
    let l = r <= i && r >= a ? i - r : 0;
    i -= l, i && i < e.size && wy(e.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), s = i + (s - a), a = i;
  } else if (s < i) {
    let l = r <= i && r >= s ? i - r : 0;
    i -= l, i && i < n.size && wy(n.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), a = i + (a - s), s = i;
  }
  return { start: i, endA: a, endB: s };
}
function wy(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class ZR {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new hR(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Sy), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = ky(this), Cy(this), this.nodeViews = _y(this), this.docView = ny(this.state.doc, xy(this), _p(this), this.dom, this), this.domObserver = new FR(this, (r, o, i, a) => WR(this, r, o, i, a)), this.domObserver.start(), mR(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Xh(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Sy), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let o = this.state, i = !1, a = !1;
    e.storedMarks && this.composing && (U4(this), a = !0), this.state = e;
    let s = o.plugins != e.plugins || this._props.plugins != t.plugins;
    if (s || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = _y(this);
      XR(h, this.nodeViews) && (this.nodeViews = h, i = !0);
    }
    (s || t.handleDOMEvents != this._props.handleDOMEvents) && Xh(this), this.editable = ky(this), Cy(this);
    let l = _p(this), d = xy(this), u = o.plugins != e.plugins && !o.doc.eq(e.doc) ? "reset" : e.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", f = i || !this.docView.matchesNode(e.doc, d, l);
    (f || !e.selection.eq(o.selection)) && (a = !0);
    let p = u == "preserve" && a && this.dom.style.overflowAnchor == null && TI(this);
    if (a) {
      this.domObserver.stop();
      let h = f && (_n || on) && !this.composing && !o.selection.empty && !e.selection.empty && YR(o.selection, e.selection);
      if (f) {
        let m = on ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = OR(this)), (i || !this.docView.update(e.doc, d, l, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = ny(e.doc, d, l, this.dom, this)), m && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && QI(this)) ? go(this, h) : (N4(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, o), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : p && AI(p);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this)))
        if (this.state.selection instanceof Te) {
          let t = this.docView.domAfterPos(this.state.selection.from);
          t.nodeType == 1 && Zv(this, t.getBoundingClientRect(), e);
        } else
          Zv(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, o = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let i = r.from + (this.state.doc.content.size - t.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == r.node && (o = i);
    }
    this.dragging = new W4(e.slice, e.move, o < 0 ? void 0 : Te.create(this.state.doc, o));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], o;
    if (r != null && (o = t ? t(r) : r))
      return o;
    for (let a = 0; a < this.directPlugins.length; a++) {
      let s = this.directPlugins[a].props[e];
      if (s != null && (o = t ? t(s) : s))
        return o;
    }
    let i = this.state.plugins;
    if (i)
      for (let a = 0; a < i.length; a++) {
        let s = i[a].props[e];
        if (s != null && (o = t ? t(s) : s))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (_n) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && MI(this.dom), go(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return RI(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return k4(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let o = this.docView.posFromDOM(e, t, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return zI(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return Kl(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return Kl(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return N0(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (gR(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], _p(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, yI());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return yR(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? gn && this.root.nodeType === 11 && CI(this.dom.ownerDocument) == this.dom && zR(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function xy(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [an.node(0, n.state.doc.content.size, e)];
}
function Cy(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: an.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function ky(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function YR(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function _y(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(e, o) || (e[o] = r[o]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function XR(n, e) {
  let t = 0, r = 0;
  for (let o in n) {
    if (n[o] != e[o])
      return !0;
    t++;
  }
  for (let o in e)
    r++;
  return t != r;
}
function Sy(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var ai = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Xu = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, QR = typeof navigator < "u" && /Mac/.test(navigator.platform), eB = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Jt = 0; Jt < 10; Jt++)
  ai[48 + Jt] = ai[96 + Jt] = String(Jt);
for (var Jt = 1; Jt <= 24; Jt++)
  ai[Jt + 111] = "F" + Jt;
for (var Jt = 65; Jt <= 90; Jt++)
  ai[Jt] = String.fromCharCode(Jt + 32), Xu[Jt] = String.fromCharCode(Jt);
for (var Ep in ai)
  Xu.hasOwnProperty(Ep) || (Xu[Ep] = ai[Ep]);
function tB(n) {
  var e = QR && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || eB && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? Xu : ai)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const nB = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function rB(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, o, i, a;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      nB ? a = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (t = "Alt-" + t), o && (t = "Ctrl-" + t), a && (t = "Meta-" + t), i && (t = "Shift-" + t), t;
}
function oB(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[rB(t)] = n[t];
  return e;
}
function Op(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function iB(n) {
  return new Ct({ props: { handleKeyDown: Y4(n) } });
}
function Y4(n) {
  let e = oB(n);
  return function(t, r) {
    let o = tB(r), i, a = e[Op(o, r)];
    if (a && a(t.state, t.dispatch, t))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let s = e[Op(o, r, !1)];
        if (s && s(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || o.charCodeAt(0) > 127) && (i = ai[r.keyCode]) && i != o) {
        let s = e[Op(i, r)];
        if (s && s(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const aB = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function X4(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const sB = (n, e, t) => {
  let r = X4(n, t);
  if (!r)
    return !1;
  let o = L0(r);
  if (!o) {
    let a = r.blockRange(), s = a && $s(a);
    return s == null ? !1 : (e && e(n.tr.lift(a, s).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (nw(n, o, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (rs(i, "end") || Te.isSelectable(i)))
    for (let a = r.depth; ; a--) {
      let s = bf(n.doc, r.before(a), r.after(a), Y.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = n.tr.step(s);
          l.setSelection(rs(i, "end") ? Ue.findFrom(l.doc.resolve(l.mapping.map(o.pos, -1)), -1) : Te.create(l.doc, o.pos - i.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (a == 1 || r.node(a - 1).childCount > 1)
        break;
    }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(n.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, lB = (n, e, t) => {
  let r = X4(n, t);
  if (!r)
    return !1;
  let o = L0(r);
  return o ? Q4(n, o, e) : !1;
}, dB = (n, e, t) => {
  let r = ew(n, t);
  if (!r)
    return !1;
  let o = F0(r);
  return o ? Q4(n, o, e) : !1;
};
function Q4(n, e, t) {
  let r = e.nodeBefore, o = r, i = e.pos - 1;
  for (; !o.isTextblock; i--) {
    if (o.type.spec.isolating)
      return !1;
    let u = o.lastChild;
    if (!u)
      return !1;
    o = u;
  }
  let a = e.nodeAfter, s = a, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let d = bf(n.doc, i, l, Y.empty);
  if (!d || d.from != i || d instanceof qt && d.slice.size >= l - i)
    return !1;
  if (t) {
    let u = n.tr.step(d);
    u.setSelection(Fe.create(u.doc, i)), t(u.scrollIntoView());
  }
  return !0;
}
function rs(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const uB = (n, e, t) => {
  let { $head: r, empty: o } = n.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    i = L0(r);
  }
  let a = i && i.nodeBefore;
  return !a || !Te.isSelectable(a) ? !1 : (e && e(n.tr.setSelection(Te.create(n.doc, i.pos - a.nodeSize)).scrollIntoView()), !0);
};
function L0(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function ew(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const cB = (n, e, t) => {
  let r = ew(n, t);
  if (!r)
    return !1;
  let o = F0(r);
  if (!o)
    return !1;
  let i = o.nodeAfter;
  if (nw(n, o, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (rs(i, "start") || Te.isSelectable(i))) {
    let a = bf(n.doc, r.before(), r.after(), Y.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (e) {
        let s = n.tr.step(a);
        s.setSelection(rs(i, "start") ? Ue.findFrom(s.doc.resolve(s.mapping.map(o.pos)), 1) : Te.create(s.doc, s.mapping.map(o.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && o.depth == r.depth - 1 ? (e && e(n.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, fB = (n, e, t) => {
  let { $head: r, empty: o } = n.selection, i = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    i = F0(r);
  }
  let a = i && i.nodeAfter;
  return !a || !Te.isSelectable(a) ? !1 : (e && e(n.tr.setSelection(Te.create(n.doc, i.pos)).scrollIntoView()), !0);
};
function F0(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const pB = (n, e) => {
  let t = n.selection, r = t instanceof Te, o;
  if (r) {
    if (t.node.isTextblock || !si(n.doc, t.from))
      return !1;
    o = t.from;
  } else if (o = yf(n.doc, t.from, -1), o == null)
    return !1;
  if (e) {
    let i = n.tr.join(o);
    r && i.setSelection(Te.create(i.doc, o - n.doc.resolve(o).nodeBefore.nodeSize)), e(i.scrollIntoView());
  }
  return !0;
}, hB = (n, e) => {
  let t = n.selection, r;
  if (t instanceof Te) {
    if (t.node.isTextblock || !si(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = yf(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, mB = (n, e) => {
  let { $from: t, $to: r } = n.selection, o = t.blockRange(r), i = o && $s(o);
  return i == null ? !1 : (e && e(n.tr.lift(o, i).scrollIntoView()), !0);
}, gB = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function tw(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const vB = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let o = t.node(-1), i = t.indexAfter(-1), a = tw(o.contentMatchAt(i));
  if (!a || !o.canReplaceWith(i, i, a))
    return !1;
  if (e) {
    let s = t.after(), l = n.tr.replaceWith(s, s, a.createAndFill());
    l.setSelection(Ue.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, yB = (n, e) => {
  let t = n.selection, { $from: r, $to: o } = t;
  if (t instanceof Wn || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let i = tw(o.parent.contentMatchAt(o.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let a = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, s = n.tr.insert(a, i.createAndFill());
    s.setSelection(Fe.create(s.doc, a + 1)), e(s.scrollIntoView());
  }
  return !0;
}, bB = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let i = t.before();
    if (Ma(n.doc, i))
      return e && e(n.tr.split(i).scrollIntoView()), !0;
  }
  let r = t.blockRange(), o = r && $s(r);
  return o == null ? !1 : (e && e(n.tr.lift(r, o).scrollIntoView()), !0);
}, $B = (n, e) => {
  let { $from: t, to: r } = n.selection, o, i = t.sharedDepth(r);
  return i == 0 ? !1 : (o = t.before(i), e && e(n.tr.setSelection(Te.create(n.doc, o))), !0);
};
function wB(n, e, t) {
  let r = e.nodeBefore, o = e.nodeAfter, i = e.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && e.parent.canReplace(i - 1, i) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(o.isTextblock || si(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function nw(n, e, t, r) {
  let o = e.nodeBefore, i = e.nodeAfter, a, s, l = o.type.spec.isolating || i.type.spec.isolating;
  if (!l && wB(n, e, t))
    return !0;
  let d = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (d && (a = (s = o.contentMatchAt(o.childCount)).findWrapping(i.type)) && s.matchType(a[0] || i.type).validEnd) {
    if (t) {
      let h = e.pos + i.nodeSize, m = W.empty;
      for (let $ = a.length - 1; $ >= 0; $--)
        m = W.from(a[$].create(null, m));
      m = W.from(o.copy(m));
      let g = n.tr.step(new Xt(e.pos - 1, h, e.pos, h, new Y(m, 1, 0), a.length, !0)), v = g.doc.resolve(h + 2 * a.length);
      v.nodeAfter && v.nodeAfter.type == o.type && si(g.doc, v.pos) && g.join(v.pos), t(g.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || r > 0 && l ? null : Ue.findFrom(e, 1), f = u && u.$from.blockRange(u.$to), p = f && $s(f);
  if (p != null && p >= e.depth)
    return t && t(n.tr.lift(f, p).scrollIntoView()), !0;
  if (d && rs(i, "start", !0) && rs(o, "end")) {
    let h = o, m = [];
    for (; m.push(h), !h.isTextblock; )
      h = h.lastChild;
    let g = i, v = 1;
    for (; !g.isTextblock; g = g.firstChild)
      v++;
    if (h.canReplace(h.childCount, h.childCount, g.content)) {
      if (t) {
        let $ = W.empty;
        for (let S = m.length - 1; S >= 0; S--)
          $ = W.from(m[S].copy($));
        let C = n.tr.step(new Xt(e.pos - m.length, e.pos + i.nodeSize, e.pos + v, e.pos + i.nodeSize - v, new Y($, m.length, 0), 0, !0));
        t(C.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function rw(n) {
  return function(e, t) {
    let r = e.selection, o = n < 0 ? r.$from : r.$to, i = o.depth;
    for (; o.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return o.node(i).isTextblock ? (t && t(e.tr.setSelection(Fe.create(e.doc, n < 0 ? o.start(i) : o.end(i)))), !0) : !1;
  };
}
const xB = rw(-1), CB = rw(1);
function kB(n, e = null) {
  return function(t, r) {
    let { $from: o, $to: i } = t.selection, a = o.blockRange(i), s = a && O0(a, n, e);
    return s ? (r && r(t.tr.wrap(a, s).scrollIntoView()), !0) : !1;
  };
}
function Ey(n, e = null) {
  return function(t, r) {
    let o = !1;
    for (let i = 0; i < t.selection.ranges.length && !o; i++) {
      let { $from: { pos: a }, $to: { pos: s } } = t.selection.ranges[i];
      t.doc.nodesBetween(a, s, (l, d) => {
        if (o)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            o = !0;
          else {
            let u = t.doc.resolve(d), f = u.index();
            o = u.parent.canReplaceWith(f, f + 1, n);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let i = t.tr;
      for (let a = 0; a < t.selection.ranges.length; a++) {
        let { $from: { pos: s }, $to: { pos: l } } = t.selection.ranges[a];
        i.setBlockType(s, l, n, e);
      }
      r(i.scrollIntoView());
    }
    return !0;
  };
}
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function _B(n, e = null) {
  return function(t, r) {
    let { $from: o, $to: i } = t.selection, a = o.blockRange(i), s = !1, l = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && o.node(a.depth - 1).type.compatibleContent(n) && a.startIndex == 0) {
      if (o.index(a.depth - 1) == 0)
        return !1;
      let u = t.doc.resolve(a.start - 2);
      l = new Ku(u, u, a.depth), a.endIndex < a.parent.childCount && (a = new Ku(o, t.doc.resolve(i.end(a.depth)), a.depth)), s = !0;
    }
    let d = O0(l, n, e, a);
    return d ? (r && r(SB(t.tr, a, d, s, n).scrollIntoView()), !0) : !1;
  };
}
function SB(n, e, t, r, o) {
  let i = W.empty;
  for (let u = t.length - 1; u >= 0; u--)
    i = W.from(t[u].type.create(t[u].attrs, i));
  n.step(new Xt(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Y(i, 0, 0), t.length, !0));
  let a = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == o && (a = u + 1);
  let s = t.length - a, l = e.start + t.length - (r ? 2 : 0), d = e.parent;
  for (let u = e.startIndex, f = e.endIndex, p = !0; u < f; u++, p = !1)
    !p && Ma(n.doc, l, s) && (n.split(l, s), l += 2 * s), l += d.child(u).nodeSize;
  return n;
}
function EB(n) {
  return function(e, t) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (a) => a.childCount > 0 && a.firstChild.type == n);
    return i ? t ? r.node(i.depth - 1).type == n ? OB(e, t, n, i) : TB(e, t, i) : !0 : !1;
  };
}
function OB(n, e, t, r) {
  let o = n.tr, i = r.end, a = r.$to.end(r.depth);
  i < a && (o.step(new Xt(i - 1, a, i, a, new Y(W.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Ku(o.doc.resolve(r.$from.pos), o.doc.resolve(a), r.depth));
  const s = $s(r);
  if (s == null)
    return !1;
  o.lift(r, s);
  let l = o.mapping.map(i, -1) - 1;
  return si(o.doc, l) && o.join(l), e(o.scrollIntoView()), !0;
}
function TB(n, e, t) {
  let r = n.tr, o = t.parent;
  for (let h = t.end, m = t.endIndex - 1, g = t.startIndex; m > g; m--)
    h -= o.child(m).nodeSize, r.delete(h - 1, h + 1);
  let i = r.doc.resolve(t.start), a = i.nodeAfter;
  if (r.mapping.map(t.end) != t.start + i.nodeAfter.nodeSize)
    return !1;
  let s = t.startIndex == 0, l = t.endIndex == o.childCount, d = i.node(-1), u = i.index(-1);
  if (!d.canReplace(u + (s ? 0 : 1), u + 1, a.content.append(l ? W.empty : W.from(o))))
    return !1;
  let f = i.pos, p = f + a.nodeSize;
  return r.step(new Xt(f - (s ? 1 : 0), p + (l ? 1 : 0), f + 1, p - 1, new Y((s ? W.empty : W.from(o.copy(W.empty))).append(l ? W.empty : W.from(o.copy(W.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function AB(n) {
  return function(e, t) {
    let { $from: r, $to: o } = e.selection, i = r.blockRange(o, (d) => d.childCount > 0 && d.firstChild.type == n);
    if (!i)
      return !1;
    let a = i.startIndex;
    if (a == 0)
      return !1;
    let s = i.parent, l = s.child(a - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let d = l.lastChild && l.lastChild.type == s.type, u = W.from(d ? n.create() : null), f = new Y(W.from(n.create(null, W.from(s.type.create(null, u)))), d ? 3 : 1, 0), p = i.start, h = i.end;
      t(e.tr.step(new Xt(p - (d ? 3 : 1), h, p, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Cf(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: o } = t, { storedMarks: i } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = t.selection, o = t.doc, i = t.storedMarks, t;
    }
  };
}
class kf {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: r } = this, { view: o } = t, { tr: i } = r, a = this.buildProps(i);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const f = l(...u)(a);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(i), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: a } = o, s = [], l = !!e, d = e || i.tr, u = () => (!l && t && !d.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(d), s.every((p) => p === !0)), f = {
      ...Object.fromEntries(Object.entries(r).map(([p, h]) => [p, (...g) => {
        const v = this.buildProps(d, t), $ = h(...g)(v);
        return s.push($), f;
      }])),
      run: u
    };
    return f;
  }
  createCan(e) {
    const { rawCommands: t, state: r } = this, o = !1, i = e || r.tr, a = this.buildProps(i, o);
    return {
      ...Object.fromEntries(Object.entries(t).map(([l, d]) => [l, (...u) => d(...u)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(i, o)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: r, editor: o, state: i } = this, { view: a } = o, s = {
      tr: e,
      editor: o,
      view: a,
      state: Cf({
        state: i,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, d]) => [l, (...u) => d(...u)(s)]));
      }
    };
    return s;
  }
}
class MB {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const r = this.callbacks[e];
    return r && r.forEach((o) => o.apply(this, t)), this;
  }
  off(e, t) {
    const r = this.callbacks[e];
    return r && (t ? this.callbacks[e] = r.filter((o) => o !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const r = (...o) => {
      this.off(e, r), t.apply(this, o);
    };
    return this.on(e, r);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function $e(n, e, t) {
  return n.config[e] === void 0 && n.parent ? $e(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? $e(n.parent, e, t) : null
  }) : n.config[e];
}
function _f(n) {
  const e = n.filter((o) => o.type === "extension"), t = n.filter((o) => o.type === "node"), r = n.filter((o) => o.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function ow(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = _f(n), o = [...t, ...r], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      extensions: o
    }, l = $e(a, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((f) => {
        Object.entries(u.attributes).forEach(([p, h]) => {
          e.push({
            type: f,
            name: p,
            attribute: {
              ...i,
              ...h
            }
          });
        });
      });
    });
  }), o.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, l = $e(a, "addAttributes", s);
    if (!l)
      return;
    const d = l();
    Object.entries(d).forEach(([u, f]) => {
      const p = {
        ...i,
        ...f
      };
      typeof p?.default == "function" && (p.default = p.default()), p?.isRequired && p?.default === void 0 && delete p.default, e.push({
        type: a.name,
        name: u,
        attribute: p
      });
    });
  }), e;
}
function jt(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function Ht(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([o, i]) => {
      if (!r[o]) {
        r[o] = i;
        return;
      }
      if (o === "class") {
        const s = i ? String(i).split(" ") : [], l = r[o] ? r[o].split(" ") : [], d = s.filter((u) => !l.includes(u));
        r[o] = [...l, ...d].join(" ");
      } else if (o === "style") {
        const s = i ? i.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[o] ? r[o].split(";").map((u) => u.trim()).filter(Boolean) : [], d = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [f, p] = u.split(":").map((h) => h.trim());
          d.set(f, p);
        }), s.forEach((u) => {
          const [f, p] = u.split(":").map((h) => h.trim());
          d.set(f, p);
        }), r[o] = Array.from(d.entries()).map(([u, f]) => `${u}: ${f}`).join("; ");
      } else
        r[o] = i;
    }), r;
  }, {});
}
function Qh(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => Ht(t, r), {});
}
function iw(n) {
  return typeof n == "function";
}
function Ye(n, e = void 0, ...t) {
  return iw(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function NB(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function PB(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function Oy(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const o = e.reduce((i, a) => {
        const s = a.attribute.parseHTML ? a.attribute.parseHTML(t) : PB(t.getAttribute(a.name));
        return s == null ? i : {
          ...i,
          [a.name]: s
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function Ty(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && NB(t) ? !1 : t != null)
  );
}
function DB(n, e) {
  var t;
  const r = ow(n), { nodeExtensions: o, markExtensions: i } = _f(n), a = (t = o.find((d) => $e(d, "topNode"))) === null || t === void 0 ? void 0 : t.name, s = Object.fromEntries(o.map((d) => {
    const u = r.filter(($) => $.type === d.name), f = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: e
    }, p = n.reduce(($, C) => {
      const S = $e(C, "extendNodeSchema", f);
      return {
        ...$,
        ...S ? S(d) : {}
      };
    }, {}), h = Ty({
      ...p,
      content: Ye($e(d, "content", f)),
      marks: Ye($e(d, "marks", f)),
      group: Ye($e(d, "group", f)),
      inline: Ye($e(d, "inline", f)),
      atom: Ye($e(d, "atom", f)),
      selectable: Ye($e(d, "selectable", f)),
      draggable: Ye($e(d, "draggable", f)),
      code: Ye($e(d, "code", f)),
      whitespace: Ye($e(d, "whitespace", f)),
      linebreakReplacement: Ye($e(d, "linebreakReplacement", f)),
      defining: Ye($e(d, "defining", f)),
      isolating: Ye($e(d, "isolating", f)),
      attrs: Object.fromEntries(u.map(($) => {
        var C;
        return [$.name, { default: (C = $?.attribute) === null || C === void 0 ? void 0 : C.default }];
      }))
    }), m = Ye($e(d, "parseHTML", f));
    m && (h.parseDOM = m.map(($) => Oy($, u)));
    const g = $e(d, "renderHTML", f);
    g && (h.toDOM = ($) => g({
      node: $,
      HTMLAttributes: Qh($, u)
    }));
    const v = $e(d, "renderText", f);
    return v && (h.toText = v), [d.name, h];
  })), l = Object.fromEntries(i.map((d) => {
    const u = r.filter((v) => v.type === d.name), f = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      editor: e
    }, p = n.reduce((v, $) => {
      const C = $e($, "extendMarkSchema", f);
      return {
        ...v,
        ...C ? C(d) : {}
      };
    }, {}), h = Ty({
      ...p,
      inclusive: Ye($e(d, "inclusive", f)),
      excludes: Ye($e(d, "excludes", f)),
      group: Ye($e(d, "group", f)),
      spanning: Ye($e(d, "spanning", f)),
      code: Ye($e(d, "code", f)),
      attrs: Object.fromEntries(u.map((v) => {
        var $;
        return [v.name, { default: ($ = v?.attribute) === null || $ === void 0 ? void 0 : $.default }];
      }))
    }), m = Ye($e(d, "parseHTML", f));
    m && (h.parseDOM = m.map((v) => Oy(v, u)));
    const g = $e(d, "renderHTML", f);
    return g && (h.toDOM = (v) => g({
      mark: v,
      HTMLAttributes: Qh(v, u)
    })), [d.name, h];
  }));
  return new j$({
    topNode: a,
    nodes: s,
    marks: l
  });
}
function Tp(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Ay(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function V0(n, e) {
  const t = oa.fromSchema(e).serializeFragment(n), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(t), o.innerHTML;
}
const IB = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (o, i, a, s) => {
    var l, d;
    const u = ((d = (l = o.type.spec).toText) === null || d === void 0 ? void 0 : d.call(l, {
      node: o,
      pos: i,
      parent: a,
      index: s
    })) || o.textContent || "%leaf%";
    t += o.isAtom && !o.isText ? u : u.slice(0, Math.max(0, r - i));
  }), t;
};
function z0(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
class Sf {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const RB = (n, e) => {
  if (z0(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function Vd(n) {
  var e;
  const { editor: t, from: r, to: o, text: i, rules: a, plugin: s } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const d = l.state.doc.resolve(r);
  if (
    // check for code node
    d.parent.type.spec.code || !((e = d.nodeBefore || d.nodeAfter) === null || e === void 0) && e.marks.find((p) => p.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = IB(d) + i;
  return a.forEach((p) => {
    if (u)
      return;
    const h = RB(f, p.find);
    if (!h)
      return;
    const m = l.state.tr, g = Cf({
      state: l.state,
      transaction: m
    }), v = {
      from: r - (h[0].length - i.length),
      to: o
    }, { commands: $, chain: C, can: S } = new kf({
      editor: t,
      state: g
    });
    p.handler({
      state: g,
      range: v,
      match: h,
      commands: $,
      chain: C,
      can: S
    }) === null || !m.steps.length || (m.setMeta(s, {
      transform: m,
      from: r,
      to: o,
      text: i
    }), l.dispatch(m), u = !0);
  }), u;
}
function BB(n) {
  const { editor: e, rules: t } = n, r = new Ct({
    state: {
      init() {
        return null;
      },
      apply(o, i, a) {
        const s = o.getMeta(r);
        if (s)
          return s;
        const l = o.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = V0(W.from(u), a.schema);
          const { from: f } = l, p = f + u.length;
          Vd({
            editor: e,
            from: f,
            to: p,
            text: u,
            rules: t,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(o, i, a, s) {
        return Vd({
          editor: e,
          from: i,
          to: a,
          text: s,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: i } = o.state.selection;
          i && Vd({
            editor: e,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: a } = o.state.selection;
        return a ? Vd({
          editor: e,
          from: a.pos,
          to: a.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function LB(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function zd(n) {
  return LB(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function Ef(n, e) {
  const t = { ...n };
  return zd(n) && zd(e) && Object.keys(e).forEach((r) => {
    zd(e[r]) && zd(n[r]) ? t[r] = Ef(n[r], e[r]) : t[r] = e[r];
  }), t;
}
class xo {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ye($e(this, "addOptions", {
      name: this.name
    }))), this.storage = Ye($e(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new xo(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ef(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new xo(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ye($e(t, "addOptions", {
      name: t.name
    })), t.storage = Ye($e(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, o = e.state.selection.$from;
    if (o.pos === o.end()) {
      const a = o.marks();
      if (!!!a.find((d) => d?.type.name === t.name))
        return !1;
      const l = a.find((d) => d?.type.name === t.name);
      return l && r.removeStoredMark(l), r.insertText(" ", o.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
}
function FB(n) {
  return typeof n == "number";
}
class VB {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const zB = (n, e, t) => {
  if (z0(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((o) => {
    const i = [o.text];
    return i.index = o.index, i.input = n, i.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(o.replaceWith)), i;
  }) : [];
};
function jB(n) {
  const { editor: e, state: t, from: r, to: o, rule: i, pasteEvent: a, dropEvent: s } = n, { commands: l, chain: d, can: u } = new kf({
    editor: e,
    state: t
  }), f = [];
  return t.doc.nodesBetween(r, o, (h, m) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const g = Math.max(r, m), v = Math.min(o, m + h.content.size), $ = h.textBetween(g - m, v - m, void 0, "￼");
    zB($, i.find, a).forEach((S) => {
      if (S.index === void 0)
        return;
      const w = g + S.index + 1, T = w + S[0].length, A = {
        from: t.tr.mapping.map(w),
        to: t.tr.mapping.map(T)
      }, N = i.handler({
        state: t,
        range: A,
        match: S,
        commands: l,
        chain: d,
        can: u,
        pasteEvent: a,
        dropEvent: s
      });
      f.push(N);
    });
  }), f.every((h) => h !== null);
}
let jd = null;
const HB = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) === null || e === void 0 || e.setData("text/html", n), t;
};
function UB(n) {
  const { editor: e, rules: t } = n;
  let r = null, o = !1, i = !1, a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const l = ({ state: u, from: f, to: p, rule: h, pasteEvt: m }) => {
    const g = u.tr, v = Cf({
      state: u,
      transaction: g
    });
    if (!(!jB({
      editor: e,
      state: v,
      from: Math.max(f - 1, 0),
      to: p.b - 1,
      rule: h,
      pasteEvent: m,
      dropEvent: s
    }) || !g.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
    }
  };
  return t.map((u) => new Ct({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const p = (m) => {
        var g;
        r = !((g = f.dom.parentElement) === null || g === void 0) && g.contains(m.target) ? f.dom.parentElement : null, r && (jd = e);
      }, h = () => {
        jd && (jd = null);
      };
      return window.addEventListener("dragstart", p), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", p), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, p) => {
          if (i = r === f.dom.parentElement, s = p, !i) {
            const h = jd;
            h && setTimeout(() => {
              const m = h.state.selection;
              m && h.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, p) => {
          var h;
          const m = (h = p.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return a = p, o = !!m?.includes("data-pm-slice"), !1;
        }
      }
    },
    appendTransaction: (f, p, h) => {
      const m = f[0], g = m.getMeta("uiEvent") === "paste" && !o, v = m.getMeta("uiEvent") === "drop" && !i, $ = m.getMeta("applyPasteRules"), C = !!$;
      if (!g && !v && !C)
        return;
      if (C) {
        let { text: T } = $;
        typeof T == "string" ? T = T : T = V0(W.from(T), h.schema);
        const { from: A } = $, N = A + T.length, z = HB(T);
        return l({
          rule: u,
          state: h,
          from: A,
          to: { b: N },
          pasteEvt: z
        });
      }
      const S = p.doc.content.findDiffStart(h.doc.content), w = p.doc.content.findDiffEnd(h.doc.content);
      if (!(!FB(S) || !w || S === w.b))
        return l({
          rule: u,
          state: h,
          from: S,
          to: w,
          pasteEvt: a
        });
    }
  }));
}
function KB(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
class Ca {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = Ca.resolve(e), this.schema = DB(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const t = Ca.sort(Ca.flatten(e)), r = KB(t.map((o) => o.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((o) => `'${o}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, o = $e(t, "addExtensions", r);
      return o ? [t, ...this.flatten(o())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((r, o) => {
      const i = $e(r, "priority") || 100, a = $e(o, "priority") || 100;
      return i > a ? -1 : i < a ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Tp(t.name, this.schema)
      }, o = $e(t, "addCommands", r);
      return o ? {
        ...e,
        ...o()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, t = Ca.sort([...this.extensions].reverse()), r = [], o = [], i = t.map((a) => {
      const s = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: e,
        type: Tp(a.name, this.schema)
      }, l = [], d = $e(a, "addKeyboardShortcuts", s);
      let u = {};
      if (a.type === "mark" && $e(a, "exitable", s) && (u.ArrowRight = () => xo.handleExit({ editor: e, mark: a })), d) {
        const g = Object.fromEntries(Object.entries(d()).map(([v, $]) => [v, () => $({ editor: e })]));
        u = { ...u, ...g };
      }
      const f = iB(u);
      l.push(f);
      const p = $e(a, "addInputRules", s);
      Ay(a, e.options.enableInputRules) && p && r.push(...p());
      const h = $e(a, "addPasteRules", s);
      Ay(a, e.options.enablePasteRules) && h && o.push(...h());
      const m = $e(a, "addProseMirrorPlugins", s);
      if (m) {
        const g = m();
        l.push(...g);
      }
      return l;
    }).flat();
    return [
      BB({
        editor: e,
        rules: r
      }),
      ...UB({
        editor: e,
        rules: o
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return ow(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = _f(this.extensions);
    return Object.fromEntries(t.filter((r) => !!$e(r, "addNodeView")).map((r) => {
      const o = this.attributes.filter((l) => l.type === r.name), i = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: e,
        type: jt(r.name, this.schema)
      }, a = $e(r, "addNodeView", i);
      if (!a)
        return [];
      const s = (l, d, u, f, p) => {
        const h = Qh(l, o);
        return a()({
          // pass-through
          node: l,
          view: d,
          getPos: u,
          decorations: f,
          innerDecorations: p,
          // tiptap-specific
          editor: e,
          extension: r,
          HTMLAttributes: h
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const r = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Tp(e.name, this.schema)
      };
      e.type === "mark" && (!((t = Ye($e(e, "keepOnSplit", r))) !== null && t !== void 0) || t) && this.splittableMarks.push(e.name);
      const o = $e(e, "onBeforeCreate", r), i = $e(e, "onCreate", r), a = $e(e, "onUpdate", r), s = $e(e, "onSelectionUpdate", r), l = $e(e, "onTransaction", r), d = $e(e, "onFocus", r), u = $e(e, "onBlur", r), f = $e(e, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), i && this.editor.on("create", i), a && this.editor.on("update", a), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), d && this.editor.on("focus", d), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
}
class Ut {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ye($e(this, "addOptions", {
      name: this.name
    }))), this.storage = Ye($e(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Ut(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ef(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new Ut({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ye($e(t, "addOptions", {
      name: t.name
    })), t.storage = Ye($e(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function aw(n, e, t) {
  const { from: r, to: o } = e, { blockSeparator: i = `

`, textSerializers: a = {} } = t || {};
  let s = "";
  return n.nodesBetween(r, o, (l, d, u, f) => {
    var p;
    l.isBlock && d > r && (s += i);
    const h = a?.[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: d,
        parent: u,
        index: f,
        range: e
      })), !1;
    l.isText && (s += (p = l?.text) === null || p === void 0 ? void 0 : p.slice(Math.max(r, d) - d, o - d));
  }), s;
}
function j0(n) {
  return Object.fromEntries(Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
const WB = Ut.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: o } = e, { ranges: i } = o, a = Math.min(...i.map((u) => u.$from.pos)), s = Math.max(...i.map((u) => u.$to.pos)), l = j0(t);
            return aw(r, { from: a, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), qB = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window?.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), GB = (n = !1) => ({ commands: e }) => e.setContent("", n), JB = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: o } = r;
  return t && o.forEach(({ $from: i, $to: a }) => {
    n.doc.nodesBetween(i.pos, a.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: d, mapping: u } = e, f = d.resolve(u.map(l)), p = d.resolve(u.map(l + s.nodeSize)), h = f.blockRange(p);
      if (!h)
        return;
      const m = $s(h);
      if (s.type.isTextblock) {
        const { defaultType: g } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(h.start, g);
      }
      (m || m === 0) && e.lift(h, m);
    });
  }), !0;
}, ZB = (n) => (e) => n(e), YB = () => ({ state: n, dispatch: e }) => yB(n, e), XB = (n, e) => ({ editor: t, tr: r }) => {
  const { state: o } = t, i = o.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const a = r.mapping.map(e);
  return r.insert(a, i.content), r.setSelection(new Fe(r.doc.resolve(a - 1))), !0;
}, QB = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = n.selection.$anchor;
  for (let i = o.depth; i > 0; i -= 1)
    if (o.node(i).type === r.type) {
      if (e) {
        const s = o.before(i), l = o.after(i);
        n.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, eL = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const o = jt(n, t.schema), i = e.selection.$anchor;
  for (let a = i.depth; a > 0; a -= 1)
    if (i.node(a).type === o) {
      if (r) {
        const l = i.before(a), d = i.after(a);
        e.delete(l, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, tL = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: o } = n;
  return t && e.delete(r, o), !0;
}, nL = () => ({ state: n, dispatch: e }) => aB(n, e), rL = () => ({ commands: n }) => n.keyboardShortcut("Enter"), oL = () => ({ state: n, dispatch: e }) => vB(n, e);
function Qu(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((o) => t.strict ? e[o] === n[o] : z0(e[o]) ? e[o].test(n[o]) : e[o] === n[o]) : !0;
}
function sw(n, e, t = {}) {
  return n.find((r) => r.type === e && Qu(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((o) => [o, r.attrs[o]])),
    t
  ));
}
function My(n, e, t = {}) {
  return !!sw(n, e, t);
}
function Of(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let o = n.parent.childAfter(n.parentOffset);
  if ((!o.node || !o.node.marks.some((u) => u.type === e)) && (o = n.parent.childBefore(n.parentOffset)), !o.node || !o.node.marks.some((u) => u.type === e) || (t = t || ((r = o.node.marks[0]) === null || r === void 0 ? void 0 : r.attrs), !sw([...o.node.marks], e, t)))
    return;
  let a = o.index, s = n.start() + o.offset, l = a + 1, d = s + o.node.nodeSize;
  for (; a > 0 && My([...n.parent.child(a - 1).marks], e, t); )
    a -= 1, s -= n.parent.child(a).nodeSize;
  for (; l < n.parent.childCount && My([...n.parent.child(l).marks], e, t); )
    d += n.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: d
  };
}
function di(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
const iL = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  const i = di(n, r.schema), { doc: a, selection: s } = t, { $from: l, from: d, to: u } = s;
  if (o) {
    const f = Of(l, i, e);
    if (f && f.from <= d && f.to >= u) {
      const p = Fe.create(a, f.from, f.to);
      t.setSelection(p);
    }
  }
  return !0;
}, aL = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function H0(n) {
  return n instanceof Fe;
}
function po(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function lw(n, e = null) {
  if (!e)
    return null;
  const t = Ue.atStart(n), r = Ue.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const o = t.from, i = r.to;
  return e === "all" ? Fe.create(n, po(0, o, i), po(n.content.size, o, i)) : Fe.create(n, po(e, o, i), po(e, o, i));
}
function dw() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Tf() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const sL = (n = null, e = {}) => ({ editor: t, view: r, tr: o, dispatch: i }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const a = () => {
    (Tf() || dw()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e?.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (i && n === null && !H0(t.state.selection))
    return a(), !0;
  const s = lw(o.doc, n) || t.state.selection, l = t.state.selection.eq(s);
  return i && (l || o.setSelection(s), l && o.storedMarks && o.setStoredMarks(o.storedMarks), a()), !0;
}, lL = (n, e) => (t) => n.every((r, o) => e(r, { ...t, index: o })), dL = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), uw = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && uw(r);
  }
  return n;
};
function Hd(n) {
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return uw(t);
}
function ec(n, e, t) {
  if (n instanceof Ko || n instanceof W)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, o = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return W.fromArray(n.map((s) => e.nodeFromJSON(s)));
      const a = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && a.check(), a;
    } catch (i) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", i), ec("", e, t);
    }
  if (o) {
    if (t.errorOnInvalidContent) {
      let a = !1, s = "";
      const l = new j$({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (a = !0, s = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Wo.fromSchema(l).parseSlice(Hd(n), t.parseOptions) : Wo.fromSchema(l).parse(Hd(n), t.parseOptions), t.errorOnInvalidContent && a)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const i = Wo.fromSchema(e);
    return t.slice ? i.parseSlice(Hd(n), t.parseOptions).content : i.parse(Hd(n), t.parseOptions);
  }
  return ec("", e, t);
}
function uL(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const o = n.steps[r];
  if (!(o instanceof qt || o instanceof Xt))
    return;
  const i = n.mapping.maps[r];
  let a = 0;
  i.forEach((s, l, d, u) => {
    a === 0 && (a = u);
  }), n.setSelection(Ue.near(n.doc.resolve(a), t));
}
const cL = (n) => !("type" in n), fL = (n, e, t) => ({ tr: r, dispatch: o, editor: i }) => {
  var a;
  if (o) {
    t = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let s;
    try {
      s = ec(e, i.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...t.parseOptions
        },
        errorOnInvalidContent: (a = t.errorOnInvalidContent) !== null && a !== void 0 ? a : i.options.enableContentCheck
      });
    } catch (m) {
      return i.emit("contentError", {
        editor: i,
        error: m,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: d } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, u = !0, f = !0;
    if ((cL(s) ? s : [s]).forEach((m) => {
      m.check(), u = u ? m.isText && m.marks.length === 0 : !1, f = f ? m.isBlock : !1;
    }), l === d && f) {
      const { parent: m } = r.doc.resolve(l);
      m.isTextblock && !m.type.spec.code && !m.childCount && (l -= 1, d += 1);
    }
    let h;
    if (u) {
      if (Array.isArray(e))
        h = e.map((m) => m.text || "").join("");
      else if (e instanceof W) {
        let m = "";
        e.forEach((g) => {
          g.text && (m += g.text);
        }), h = m;
      } else
        typeof e == "object" && e && e.text ? h = e.text : h = e;
      r.insertText(h, l, d);
    } else
      h = s, r.replaceWith(l, d, h);
    t.updateSelection && uL(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: l, text: h }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: h });
  }
  return !0;
}, pL = () => ({ state: n, dispatch: e }) => pB(n, e), hL = () => ({ state: n, dispatch: e }) => hB(n, e), mL = () => ({ state: n, dispatch: e }) => sB(n, e), gL = () => ({ state: n, dispatch: e }) => cB(n, e), vL = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = yf(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, yL = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = yf(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, bL = () => ({ state: n, dispatch: e }) => lB(n, e), $L = () => ({ state: n, dispatch: e }) => dB(n, e);
function cw() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function wL(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, o, i, a;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      o = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      Tf() || cw() ? a = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (t = `Alt-${t}`), o && (t = `Ctrl-${t}`), a && (t = `Meta-${t}`), i && (t = `Shift-${t}`), t;
}
const xL = (n) => ({ editor: e, view: t, tr: r, dispatch: o }) => {
  const i = wL(n).split(/-(?!$)/), a = i.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), s = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, s));
  });
  return l?.steps.forEach((d) => {
    const u = d.map(r.mapping);
    u && o && r.maybeStep(u);
  }), !0;
};
function ql(n, e, t = {}) {
  const { from: r, to: o, empty: i } = n.selection, a = e ? jt(e, n.schema) : null, s = [];
  n.doc.nodesBetween(r, o, (f, p) => {
    if (f.isText)
      return;
    const h = Math.max(r, p), m = Math.min(o, p + f.nodeSize);
    s.push({
      node: f,
      from: h,
      to: m
    });
  });
  const l = o - r, d = s.filter((f) => a ? a.name === f.node.type.name : !0).filter((f) => Qu(f.node.attrs, t, { strict: !1 }));
  return i ? !!d.length : d.reduce((f, p) => f + p.to - p.from, 0) >= l;
}
const CL = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = jt(n, t.schema);
  return ql(t, o, e) ? mB(t, r) : !1;
}, kL = () => ({ state: n, dispatch: e }) => bB(n, e), _L = (n) => ({ state: e, dispatch: t }) => {
  const r = jt(n, e.schema);
  return EB(r)(e, t);
}, SL = () => ({ state: n, dispatch: e }) => gB(n, e);
function Af(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function Ny(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, o) => (t.includes(o) || (r[o] = n[o]), r), {});
}
const EL = (n, e) => ({ tr: t, state: r, dispatch: o }) => {
  let i = null, a = null;
  const s = Af(typeof n == "string" ? n : n.name, r.schema);
  return s ? (s === "node" && (i = jt(n, r.schema)), s === "mark" && (a = di(n, r.schema)), o && t.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (d, u) => {
      i && i === d.type && t.setNodeMarkup(u, void 0, Ny(d.attrs, e)), a && d.marks.length && d.marks.forEach((f) => {
        a === f.type && t.addMark(u, u + d.nodeSize, a.create(Ny(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, OL = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), TL = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new Wn(n.doc);
    n.setSelection(t);
  }
  return !0;
}, AL = () => ({ state: n, dispatch: e }) => uB(n, e), ML = () => ({ state: n, dispatch: e }) => fB(n, e), NL = () => ({ state: n, dispatch: e }) => $B(n, e), PL = () => ({ state: n, dispatch: e }) => CB(n, e), DL = () => ({ state: n, dispatch: e }) => xB(n, e);
function em(n, e, t = {}, r = {}) {
  return ec(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const IL = (n, e = !1, t = {}, r = {}) => ({ editor: o, tr: i, dispatch: a, commands: s }) => {
  var l, d;
  const { doc: u } = i;
  if (t.preserveWhitespace !== "full") {
    const f = em(n, o.schema, t, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : o.options.enableContentCheck
    });
    return a && i.replaceWith(0, u.content.size, f).setMeta("preventUpdate", !e), !0;
  }
  return a && i.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, n, {
    parseOptions: t,
    errorOnInvalidContent: (d = r.errorOnInvalidContent) !== null && d !== void 0 ? d : o.options.enableContentCheck
  });
};
function fw(n, e) {
  const t = di(e, n.schema), { from: r, to: o, empty: i } = n.selection, a = [];
  i ? (n.storedMarks && a.push(...n.storedMarks), a.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, o, (l) => {
    a.push(...l.marks);
  });
  const s = a.find((l) => l.type.name === t.name);
  return s ? { ...s.attrs } : {};
}
function RL(n, e) {
  const t = new vI(n);
  return e.forEach((r) => {
    r.steps.forEach((o) => {
      t.step(o);
    });
  }), t;
}
function BL(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function LL(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (o, i) => {
    t(o) && r.push({
      node: o,
      pos: i
    });
  }), r;
}
function FL(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function U0(n) {
  return (e) => FL(e.$from, n);
}
function pw(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return aw(n, t, e);
}
function VL(n, e) {
  const t = jt(e, n.schema), { from: r, to: o } = n.selection, i = [];
  n.doc.nodesBetween(r, o, (s) => {
    i.push(s);
  });
  const a = i.reverse().find((s) => s.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function hw(n, e) {
  const t = Af(typeof e == "string" ? e : e.name, n.schema);
  return t === "node" ? VL(n, e) : t === "mark" ? fw(n, e) : {};
}
function zL(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const o = e(r);
    return Object.prototype.hasOwnProperty.call(t, o) ? !1 : t[o] = !0;
  });
}
function jL(n) {
  const e = zL(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((i, a) => a !== r).some((i) => t.oldRange.from >= i.oldRange.from && t.oldRange.to <= i.oldRange.to && t.newRange.from >= i.newRange.from && t.newRange.to <= i.newRange.to));
}
function HL(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((o, i) => {
    const a = [];
    if (o.ranges.length)
      o.forEach((s, l) => {
        a.push({ from: s, to: l });
      });
    else {
      const { from: s, to: l } = t[i];
      if (s === void 0 || l === void 0)
        return;
      a.push({ from: s, to: l });
    }
    a.forEach(({ from: s, to: l }) => {
      const d = e.slice(i).map(s, -1), u = e.slice(i).map(l), f = e.invert().map(d, -1), p = e.invert().map(u);
      r.push({
        oldRange: {
          from: f,
          to: p
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), jL(r);
}
function K0(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((o) => {
    const i = t.resolve(n), a = Of(i, o.type);
    a && r.push({
      mark: o,
      ...a
    });
  }) : t.nodesBetween(n, e, (o, i) => {
    !o || o?.nodeSize === void 0 || r.push(...o.marks.map((a) => ({
      from: i,
      to: i + o.nodeSize,
      mark: a
    })));
  }), r;
}
function fu(n, e, t) {
  return Object.fromEntries(Object.entries(t).filter(([r]) => {
    const o = n.find((i) => i.type === e && i.name === r);
    return o ? o.attribute.keepOnSplit : !1;
  }));
}
function tm(n, e, t = {}) {
  const { empty: r, ranges: o } = n.selection, i = e ? di(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((f) => i ? i.name === f.type.name : !0).find((f) => Qu(f.attrs, t, { strict: !1 }));
  let a = 0;
  const s = [];
  if (o.forEach(({ $from: f, $to: p }) => {
    const h = f.pos, m = p.pos;
    n.doc.nodesBetween(h, m, (g, v) => {
      if (!g.isText && !g.marks.length)
        return;
      const $ = Math.max(h, v), C = Math.min(m, v + g.nodeSize), S = C - $;
      a += S, s.push(...g.marks.map((w) => ({
        mark: w,
        from: $,
        to: C
      })));
    });
  }), a === 0)
    return !1;
  const l = s.filter((f) => i ? i.name === f.mark.type.name : !0).filter((f) => Qu(f.mark.attrs, t, { strict: !1 })).reduce((f, p) => f + p.to - p.from, 0), d = s.filter((f) => i ? f.mark.type !== i && f.mark.type.excludes(i) : !0).reduce((f, p) => f + p.to - p.from, 0);
  return (l > 0 ? l + d : l) >= a;
}
function UL(n, e, t = {}) {
  if (!e)
    return ql(n, null, t) || tm(n, null, t);
  const r = Af(e, n.schema);
  return r === "node" ? ql(n, e, t) : r === "mark" ? tm(n, e, t) : !1;
}
function Py(n, e) {
  const { nodeExtensions: t } = _f(e), r = t.find((a) => a.name === n);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, i = Ye($e(r, "group", o));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function Mf(n, { checkChildren: e = !0, ignoreWhitespace: t = !1 } = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) !== null && r !== void 0 ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let o = !0;
    return n.content.forEach((i) => {
      o !== !1 && (Mf(i, { ignoreWhitespace: t, checkChildren: e }) || (o = !1));
    }), o;
  }
  return !1;
}
function mw(n) {
  return n instanceof Te;
}
function gw(n, e, t) {
  const o = n.state.doc.content.size, i = po(e, 0, o), a = po(t, 0, o), s = n.coordsAtPos(i), l = n.coordsAtPos(a, -1), d = Math.min(s.top, l.top), u = Math.max(s.bottom, l.bottom), f = Math.min(s.left, l.left), p = Math.max(s.right, l.right), h = p - f, m = u - d, $ = {
    top: d,
    bottom: u,
    left: f,
    right: p,
    width: h,
    height: m,
    x: f,
    y: d
  };
  return {
    ...$,
    toJSON: () => $
  };
}
function KL(n, e, t) {
  var r;
  const { selection: o } = e;
  let i = null;
  if (H0(o) && (i = o.$cursor), i) {
    const s = (r = n.storedMarks) !== null && r !== void 0 ? r : i.marks();
    return !!t.isInSet(s) || !s.some((l) => l.type.excludes(t));
  }
  const { ranges: a } = o;
  return a.some(({ $from: s, $to: l }) => {
    let d = s.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(s.pos, l.pos, (u, f, p) => {
      if (d)
        return !1;
      if (u.isInline) {
        const h = !p || p.type.allowsMarkType(t), m = !!t.isInSet(u.marks) || !u.marks.some((g) => g.type.excludes(t));
        d = h && m;
      }
      return !d;
    }), d;
  });
}
const WL = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  const { selection: i } = t, { empty: a, ranges: s } = i, l = di(n, r.schema);
  if (o)
    if (a) {
      const d = fw(r, l);
      t.addStoredMark(l.create({
        ...d,
        ...e
      }));
    } else
      s.forEach((d) => {
        const u = d.$from.pos, f = d.$to.pos;
        r.doc.nodesBetween(u, f, (p, h) => {
          const m = Math.max(h, u), g = Math.min(h + p.nodeSize, f);
          p.marks.find(($) => $.type === l) ? p.marks.forEach(($) => {
            l === $.type && t.addMark(m, g, l.create({
              ...$.attrs,
              ...e
            }));
          }) : t.addMark(m, g, l.create(e));
        });
      });
  return KL(r, t, l);
}, qL = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), GL = (n, e = {}) => ({ state: t, dispatch: r, chain: o }) => {
  const i = jt(n, t.schema);
  let a;
  return t.selection.$anchor.sameParent(t.selection.$head) && (a = t.selection.$anchor.parent.attrs), i.isTextblock ? o().command(({ commands: s }) => Ey(i, { ...a, ...e })(t) ? !0 : s.clearNodes()).command(({ state: s }) => Ey(i, { ...a, ...e })(s, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, JL = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, o = po(n, 0, r.content.size), i = Te.create(r, o);
    e.setSelection(i);
  }
  return !0;
}, ZL = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: o, to: i } = typeof n == "number" ? { from: n, to: n } : n, a = Fe.atStart(r).from, s = Fe.atEnd(r).to, l = po(o, a, s), d = po(i, a, s), u = Fe.create(r, l, d);
    e.setSelection(u);
  }
  return !0;
}, YL = (n) => ({ state: e, dispatch: t }) => {
  const r = jt(n, e.schema);
  return AB(r)(e, t);
};
function Dy(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((o) => e?.includes(o.type.name));
    n.tr.ensureMarks(r);
  }
}
const XL = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: o }) => {
  const { selection: i, doc: a } = e, { $from: s, $to: l } = i, d = o.extensionManager.attributes, u = fu(d, s.node().type.name, s.node().attrs);
  if (i instanceof Te && i.node.isBlock)
    return !s.parentOffset || !Ma(a, s.pos) ? !1 : (r && (n && Dy(t, o.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, p = s.depth === 0 ? void 0 : BL(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = f && p ? [
    {
      type: p,
      attrs: u
    }
  ] : void 0, m = Ma(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !m && Ma(e.doc, e.mapping.map(s.pos), 1, p ? [{ type: p }] : void 0) && (m = !0, h = p ? [
    {
      type: p,
      attrs: u
    }
  ] : void 0), r) {
    if (m && (i instanceof Fe && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), p && !f && !s.parentOffset && s.parent.type !== p)) {
      const g = e.mapping.map(s.before()), v = e.doc.resolve(g);
      s.node(-1).canReplaceWith(v.index(), v.index() + 1, p) && e.setNodeMarkup(e.mapping.map(s.before()), p);
    }
    n && Dy(t, o.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return m;
}, QL = (n, e = {}) => ({ tr: t, state: r, dispatch: o, editor: i }) => {
  var a;
  const s = jt(n, r.schema), { $from: l, $to: d } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(d))
    return !1;
  const f = l.node(-1);
  if (f.type !== s)
    return !1;
  const p = i.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (o) {
      let $ = W.empty;
      const C = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let z = l.depth - C; z >= l.depth - 3; z -= 1)
        $ = W.from(l.node(z).copy($));
      const S = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, w = {
        ...fu(p, l.node().type.name, l.node().attrs),
        ...e
      }, T = ((a = s.contentMatch.defaultType) === null || a === void 0 ? void 0 : a.createAndFill(w)) || void 0;
      $ = $.append(W.from(s.createAndFill(null, T) || void 0));
      const A = l.before(l.depth - (C - 1));
      t.replace(A, l.after(-S), new Y($, 4 - C, 0));
      let N = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (z, I) => {
        if (N > -1)
          return !1;
        z.isTextblock && z.content.size === 0 && (N = I + 1);
      }), N > -1 && t.setSelection(Fe.near(t.doc.resolve(N))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === l.end() ? f.contentMatchAt(0).defaultType : null, m = {
    ...fu(p, f.type.name, f.attrs),
    ...e
  }, g = {
    ...fu(p, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, d.pos);
  const v = h ? [
    { type: s, attrs: m },
    { type: h, attrs: g }
  ] : [{ type: s, attrs: m }];
  if (!Ma(t.doc, l.pos, 2))
    return !1;
  if (o) {
    const { selection: $, storedMarks: C } = r, { splittableMarks: S } = i.extensionManager, w = C || $.$to.parentOffset && $.$from.marks();
    if (t.split(l.pos, 2, v).scrollIntoView(), !w || !o)
      return !0;
    const T = w.filter((A) => S.includes(A.type.name));
    t.ensureMarks(T);
  }
  return !0;
}, Ap = (n, e) => {
  const t = U0((a) => a.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const o = n.doc.nodeAt(r);
  return t.node.type === o?.type && si(n.doc, t.pos) && n.join(t.pos), !0;
}, Mp = (n, e) => {
  const t = U0((a) => a.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const o = n.doc.nodeAt(r);
  return t.node.type === o?.type && si(n.doc, r) && n.join(r), !0;
}, eF = (n, e, t, r = {}) => ({ editor: o, tr: i, state: a, dispatch: s, chain: l, commands: d, can: u }) => {
  const { extensions: f, splittableMarks: p } = o.extensionManager, h = jt(n, a.schema), m = jt(e, a.schema), { selection: g, storedMarks: v } = a, { $from: $, $to: C } = g, S = $.blockRange(C), w = v || g.$to.parentOffset && g.$from.marks();
  if (!S)
    return !1;
  const T = U0((A) => Py(A.type.name, f))(g);
  if (S.depth >= 1 && T && S.depth - T.depth <= 1) {
    if (T.node.type === h)
      return d.liftListItem(m);
    if (Py(T.node.type.name, f) && h.validContent(T.node.content) && s)
      return l().command(() => (i.setNodeMarkup(T.pos, h), !0)).command(() => Ap(i, h)).command(() => Mp(i, h)).run();
  }
  return !t || !w || !s ? l().command(() => u().wrapInList(h, r) ? !0 : d.clearNodes()).wrapInList(h, r).command(() => Ap(i, h)).command(() => Mp(i, h)).run() : l().command(() => {
    const A = u().wrapInList(h, r), N = w.filter((z) => p.includes(z.type.name));
    return i.ensureMarks(N), A ? !0 : d.clearNodes();
  }).wrapInList(h, r).command(() => Ap(i, h)).command(() => Mp(i, h)).run();
}, tF = (n, e = {}, t = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: i = !1 } = t, a = di(n, r.schema);
  return tm(r, a, e) ? o.unsetMark(a, { extendEmptyMarkRange: i }) : o.setMark(a, e);
}, nF = (n, e, t = {}) => ({ state: r, commands: o }) => {
  const i = jt(n, r.schema), a = jt(e, r.schema), s = ql(r, i, t);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? o.setNode(a, l) : o.setNode(i, { ...l, ...t });
}, rF = (n, e = {}) => ({ state: t, commands: r }) => {
  const o = jt(n, t.schema);
  return ql(t, o, e) ? r.lift(o) : r.wrapIn(o, e);
}, oF = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const o = t[r];
    let i;
    if (o.spec.isInputRules && (i = o.getState(n))) {
      if (e) {
        const a = n.tr, s = i.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          a.step(s.steps[l].invert(s.docs[l]));
        if (i.text) {
          const l = a.doc.resolve(i.from).marks();
          a.replaceWith(i.from, i.to, n.schema.text(i.text, l));
        } else
          a.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, iF = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: o } = t;
  return r || e && o.forEach((i) => {
    n.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, aF = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  var i;
  const { extendEmptyMarkRange: a = !1 } = e, { selection: s } = t, l = di(n, r.schema), { $from: d, empty: u, ranges: f } = s;
  if (!o)
    return !0;
  if (u && a) {
    let { from: p, to: h } = s;
    const m = (i = d.marks().find((v) => v.type === l)) === null || i === void 0 ? void 0 : i.attrs, g = Of(d, l, m);
    g && (p = g.from, h = g.to), t.removeMark(p, h, l);
  } else
    f.forEach((p) => {
      t.removeMark(p.$from.pos, p.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, sF = (n, e = {}) => ({ tr: t, state: r, dispatch: o }) => {
  let i = null, a = null;
  const s = Af(typeof n == "string" ? n : n.name, r.schema);
  return s ? (s === "node" && (i = jt(n, r.schema)), s === "mark" && (a = di(n, r.schema)), o && t.selection.ranges.forEach((l) => {
    const d = l.$from.pos, u = l.$to.pos;
    let f, p, h, m;
    t.selection.empty ? r.doc.nodesBetween(d, u, (g, v) => {
      i && i === g.type && (h = Math.max(v, d), m = Math.min(v + g.nodeSize, u), f = v, p = g);
    }) : r.doc.nodesBetween(d, u, (g, v) => {
      v < d && i && i === g.type && (h = Math.max(v, d), m = Math.min(v + g.nodeSize, u), f = v, p = g), v >= d && v <= u && (i && i === g.type && t.setNodeMarkup(v, void 0, {
        ...g.attrs,
        ...e
      }), a && g.marks.length && g.marks.forEach(($) => {
        if (a === $.type) {
          const C = Math.max(v, d), S = Math.min(v + g.nodeSize, u);
          t.addMark(C, S, a.create({
            ...$.attrs,
            ...e
          }));
        }
      }));
    }), p && (f !== void 0 && t.setNodeMarkup(f, void 0, {
      ...p.attrs,
      ...e
    }), a && p.marks.length && p.marks.forEach((g) => {
      a === g.type && t.addMark(h, m, a.create({
        ...g.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, lF = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = jt(n, t.schema);
  return kB(o, e)(t, r);
}, dF = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const o = jt(n, t.schema);
  return _B(o, e)(t, r);
};
var uF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: qB,
  clearContent: GB,
  clearNodes: JB,
  command: ZB,
  createParagraphNear: YB,
  cut: XB,
  deleteCurrentNode: QB,
  deleteNode: eL,
  deleteRange: tL,
  deleteSelection: nL,
  enter: rL,
  exitCode: oL,
  extendMarkRange: iL,
  first: aL,
  focus: sL,
  forEach: lL,
  insertContent: dL,
  insertContentAt: fL,
  joinBackward: mL,
  joinDown: hL,
  joinForward: gL,
  joinItemBackward: vL,
  joinItemForward: yL,
  joinTextblockBackward: bL,
  joinTextblockForward: $L,
  joinUp: pL,
  keyboardShortcut: xL,
  lift: CL,
  liftEmptyBlock: kL,
  liftListItem: _L,
  newlineInCode: SL,
  resetAttributes: EL,
  scrollIntoView: OL,
  selectAll: TL,
  selectNodeBackward: AL,
  selectNodeForward: ML,
  selectParentNode: NL,
  selectTextblockEnd: PL,
  selectTextblockStart: DL,
  setContent: IL,
  setMark: WL,
  setMeta: qL,
  setNode: GL,
  setNodeSelection: JL,
  setTextSelection: ZL,
  sinkListItem: YL,
  splitBlock: XL,
  splitListItem: QL,
  toggleList: eF,
  toggleMark: tF,
  toggleNode: nF,
  toggleWrap: rF,
  undoInputRule: oF,
  unsetAllMarks: iF,
  unsetMark: aF,
  updateAttributes: sF,
  wrapIn: lF,
  wrapInList: dF
});
const cF = Ut.create({
  name: "commands",
  addCommands() {
    return {
      ...uF
    };
  }
}), fF = Ut.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), pF = Ut.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), hF = Ut.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new Ct({
        key: new Lt("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), mF = Ut.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: s }) => {
        const { selection: l, doc: d } = s, { empty: u, $anchor: f } = l, { pos: p, parent: h } = f, m = f.parent.isTextblock && p > 0 ? s.doc.resolve(p - 1) : f, g = m.parent.type.spec.isolating, v = f.pos - f.parentOffset, $ = g && m.parent.childCount === 1 ? v === f.pos : Ue.atStart(d).from === p;
        return !u || !h.type.isTextblock || h.textContent.length || !$ || $ && f.parent.type.name === "paragraph" ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, i = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Tf() || cw() ? i : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ct({
        key: new Lt("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((g) => g.getMeta("composition")))
            return;
          const r = n.some((g) => g.docChanged) && !e.doc.eq(t.doc), o = n.some((g) => g.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: i, from: a, to: s } = e.selection, l = Ue.atStart(e.doc).from, d = Ue.atEnd(e.doc).to;
          if (i || !(a === l && s === d) || !Mf(t.doc))
            return;
          const p = t.tr, h = Cf({
            state: t,
            transaction: p
          }), { commands: m } = new kf({
            editor: this.editor,
            state: h
          });
          if (m.clearNodes(), !!p.steps.length)
            return p;
        }
      })
    ];
  }
}), gF = Ut.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), vF = Ut.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class xi {
  get name() {
    return this.node.type.name;
  }
  constructor(e, t, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = o;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new xi(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new xi(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new xi(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const o = t.isBlock && !t.isTextblock, i = t.isAtom && !t.isText, a = this.pos + r + (i ? 0 : 1), s = this.resolvedPos.doc.resolve(a);
      if (!o && s.depth <= this.depth)
        return;
      const l = new xi(s, this.editor, o, o ? t : null);
      o && (l.actualDepth = this.depth + 1), e.push(new xi(s, this.editor, o, o ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const i = o.node.attrs, a = Object.keys(t);
          for (let s = 0; s < a.length; s += 1) {
            const l = a[s];
            if (i[l] !== t[l])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const i = Object.keys(t);
    return this.children.forEach((a) => {
      r && o.length > 0 || (a.node.type.name === e && i.every((l) => t[l] === a.node.attrs[l]) && o.push(a), !(r && o.length > 0) && (o = o.concat(a.querySelectorAll(e, t, r))));
    }), o;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}
const yF = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function bF(n, e, t) {
  const r = document.querySelector(`style[data-tiptap-style${t ? `-${t}` : ""}]`);
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return e && o.setAttribute("nonce", e), o.setAttribute(`data-tiptap-style${t ? `-${t}` : ""}`, ""), o.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(o), o;
}
let $F = class extends MB {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: r, moved: o }) => this.options.onDrop(t, r, o)), this.on("paste", ({ event: t, slice: r }) => this.options.onPaste(t, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = bF(yF, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const r = iw(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], o = this.state.reconfigure({ plugins: r });
    return this.view.updateState(o), o;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let r = t;
    if ([].concat(e).forEach((i) => {
      const a = typeof i == "string" ? `${i}$` : i.key;
      r = t.filter((s) => !s.key.startsWith(a));
    }), t.length === r.length)
      return;
    const o = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(o), o;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const o = [...this.options.enableCoreExtensions ? [
      pF,
      WB.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      cF,
      hF,
      mF,
      vF,
      fF,
      gF
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i?.type));
    this.extensionManager = new Ca(o, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new kf({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let t;
    try {
      t = em(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (a) {
      if (!(a instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(a.message))
        throw a;
      this.emit("contentError", {
        editor: this,
        error: a,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((s) => s.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = em(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const r = lw(t, this.options.autofocus);
    this.view = new ZR(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: xa.create({
        doc: t,
        selection: r || void 0
      })
    });
    const o = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(o), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((a) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(a);
      });
      return;
    }
    const t = this.state.apply(e), r = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = e.getMeta("focus"), i = e.getMeta("blur");
    o && this.emit("focus", {
      editor: this,
      event: o.event,
      transaction: e
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return hw(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, o = typeof e == "string" ? t : e;
    return UL(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return V0(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return pw(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...j0(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Mf(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new xi(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function is(n) {
  return new Sf({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = Ye(n.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: i } = e, a = r[r.length - 1], s = r[0];
      if (a) {
        const l = s.search(/\S/), d = t.from + s.indexOf(a), u = d + a.length;
        if (K0(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === n.type && g !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        u < t.to && i.delete(u, t.to), d > t.from && i.delete(t.from + l, d);
        const p = t.from + l + a.length;
        i.addMark(t.from + l, p, n.type.create(o || {})), i.removeStoredMark(n.type);
      }
    }
  });
}
function vw(n) {
  return new Sf({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = Ye(n.getAttributes, void 0, r) || {}, { tr: i } = e, a = t.from;
      let s = t.to;
      const l = n.type.create(o);
      if (r[1]) {
        const d = r[0].lastIndexOf(r[1]);
        let u = a + d;
        u > s ? u = s : s = u + r[1].length;
        const f = r[0][r[0].length - 1];
        i.insertText(f, a + r[0].length - 1), i.replaceWith(u, s, l);
      } else if (r[0]) {
        const d = n.type.isInline ? a : a - 1;
        i.insert(d, n.type.create(o)).delete(i.mapping.map(a), i.mapping.map(s));
      }
      i.scrollIntoView();
    }
  });
}
function nm(n) {
  return new Sf({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const o = e.doc.resolve(t.from), i = Ye(n.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, i);
    }
  });
}
function Gl(n) {
  return new Sf({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: o }) => {
      const i = Ye(n.getAttributes, void 0, r) || {}, a = e.tr.delete(t.from, t.to), l = a.doc.resolve(t.from).blockRange(), d = l && O0(l, n.type, i);
      if (!d)
        return null;
      if (a.wrap(l, d), n.keepMarks && n.editor) {
        const { selection: f, storedMarks: p } = e, { splittableMarks: h } = n.editor.extensionManager, m = p || f.$to.parentOffset && f.$from.marks();
        if (m) {
          const g = m.filter((v) => h.includes(v.type.name));
          a.ensureMarks(g);
        }
      }
      if (n.keepAttributes) {
        const f = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(f, i).run();
      }
      const u = a.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && si(a.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, u)) && a.join(t.from - 1);
    }
  });
}
let er = class rm {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ye($e(this, "addOptions", {
      name: this.name
    }))), this.storage = Ye($e(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new rm(e);
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => Ef(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(e = {}) {
    const t = new rm(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Ye($e(t, "addOptions", {
      name: t.name
    })), t.storage = Ye($e(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
};
class wF {
  constructor(e, t, r) {
    this.isDragging = !1, this.component = e, this.editor = t.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...r
    }, this.extension = t.extension, this.node = t.node, this.decorations = t.decorations, this.innerDecorations = t.innerDecorations, this.view = t.view, this.HTMLAttributes = t.HTMLAttributes, this.getPos = t.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var t, r, o, i, a, s, l;
    const { view: d } = this.editor, u = e.target, f = u.nodeType === 3 ? (t = u.parentElement) === null || t === void 0 ? void 0 : t.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((r = this.contentDOM) === null || r === void 0) && r.contains(u) || !f)
      return;
    let p = 0, h = 0;
    if (this.dom !== f) {
      const $ = this.dom.getBoundingClientRect(), C = f.getBoundingClientRect(), S = (o = e.offsetX) !== null && o !== void 0 ? o : (i = e.nativeEvent) === null || i === void 0 ? void 0 : i.offsetX, w = (a = e.offsetY) !== null && a !== void 0 ? a : (s = e.nativeEvent) === null || s === void 0 ? void 0 : s.offsetY;
      p = C.x - $.x + S, h = C.y - $.y + w;
    }
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(this.dom, p, h);
    const m = this.getPos();
    if (typeof m != "number")
      return;
    const g = Te.create(d.state.doc, m), v = d.state.tr.setSelection(g);
    d.dispatch(v);
  }
  stopEvent(e) {
    var t;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const r = e.target;
    if (!(this.dom.contains(r) && !(!((t = this.contentDOM) === null || t === void 0) && t.contains(r))))
      return !1;
    const i = e.type.startsWith("drag"), a = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(r.tagName) || r.isContentEditable) && !a && !i)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: d } = this, u = !!this.node.type.spec.draggable, f = Te.isSelectable(this.node), p = e.type === "copy", h = e.type === "paste", m = e.type === "cut", g = e.type === "mousedown";
    if (!u && f && i && e.target === this.dom && e.preventDefault(), u && i && !d && e.target === this.dom)
      return e.preventDefault(), !1;
    if (u && l && !d && g) {
      const v = r.closest("[data-drag-handle]");
      v && (this.dom === v || this.dom.contains(v)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(d || a || p || h || m || g && f);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (Tf() || dw()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((r) => r.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(e) {
    this.editor.commands.command(({ tr: t }) => {
      const r = this.getPos();
      return typeof r != "number" ? !1 : (t.setNodeMarkup(r, void 0, {
        ...this.node.attrs,
        ...e
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const e = this.getPos();
    if (typeof e != "number")
      return;
    const t = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: t });
  }
}
function qi(n) {
  return new VB({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: o }) => {
      const i = Ye(n.getAttributes, void 0, r, o);
      if (i === !1 || i === null)
        return null;
      const { tr: a } = e, s = r[r.length - 1], l = r[0];
      let d = t.to;
      if (s) {
        const u = l.search(/\S/), f = t.from + l.indexOf(s), p = f + s.length;
        if (K0(t.from, t.to, e.doc).filter((m) => m.mark.type.excluded.find((v) => v === n.type && v !== m.mark.type)).filter((m) => m.to > f).length)
          return null;
        p < t.to && a.delete(p, t.to), f > t.from && a.delete(t.from + u, f), d = t.from + u + s.length, a.addMark(t.from + u, d, n.type.create(i || {})), a.removeStoredMark(n.type);
      }
    }
  });
}
const xF = Ut.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ct({
        key: new Lt("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, o = [];
            if (!t)
              return null;
            const i = this.editor.isEmpty;
            return n.descendants((a, s) => {
              const l = r >= s && r <= s + a.nodeSize, d = !a.isLeaf && Mf(a);
              if ((l || !this.options.showOnlyCurrent) && d) {
                const u = [this.options.emptyNodeClass];
                i && u.push(this.options.emptyEditorClass);
                const f = an.node(s, s + a.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: a,
                    pos: s,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                o.push(f);
              }
              return this.options.includeChildren;
            }), kt.create(n, o);
          }
        }
      })
    ];
  }
}), CF = /^\s*>\s$/, kF = er.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["blockquote", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Gl({
        find: CF,
        type: this.type
      })
    ];
  }
}), _F = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, SF = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, EF = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, OF = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, TF = xo.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["strong", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      is({
        find: _F,
        type: this.type
      }),
      is({
        find: EF,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qi({
        find: SF,
        type: this.type
      }),
      qi({
        find: OF,
        type: this.type
      })
    ];
  }
}), AF = "listItem", Iy = "textStyle", Ry = /^\s*([-+*])\s$/, yw = er.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(AF, this.editor.getAttributes(Iy)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Gl({
      find: Ry,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Gl({
      find: Ry,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Iy),
      editor: this.editor
    })), [
      n
    ];
  }
}), MF = /(^|[^`])`([^`]+)`(?!`)/, NF = /(^|[^`])`([^`]+)`(?!`)/g, PF = xo.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      is({
        find: MF,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qi({
        find: NF,
        type: this.type
      })
    ];
  }
}), DF = /^```([a-z]+)?[\s\n]$/, IF = /^~~~([a-z]+)?[\s\n]$/, RF = er.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, i = [...((e = n.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((a) => a.startsWith(t)).map((a) => a.replace(t, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      Ht(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: o } = t;
        if (!o || r.parent.type !== this.type)
          return !1;
        const i = r.parentOffset === r.parent.nodeSize - 2, a = r.parent.textContent.endsWith(`

`);
        return !i || !a ? !1 : n.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: o, empty: i } = t;
        if (!i || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const s = o.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? n.commands.command(({ tr: d }) => (d.setSelection(Ue.near(r.resolve(s))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      nm({
        find: DF,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      nm({
        find: IF,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Ct({
        key: new Lt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, i = o?.mode;
            if (!t || !i)
              return !1;
            const { tr: a, schema: s } = n.state, l = s.text(t.replace(/\r\n?/g, `
`));
            return a.replaceSelectionWith(this.type.create({ language: i }, l)), a.selection.$from.parent.type !== this.type && a.setSelection(Fe.near(a.doc.resolve(Math.max(0, a.selection.from - 2)))), a.setMeta("paste", !0), n.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), BF = er.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function LF(n = {}) {
  return new Ct({
    view(e) {
      return new FF(e, n);
    }
  });
}
class FF {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let i = (a) => {
        this[o](a);
      };
      return e.dom.addEventListener(o, i), { name: o, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r;
    if (t) {
      let s = e.nodeBefore, l = e.nodeAfter;
      if (s || l) {
        let d = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (d) {
          let u = d.getBoundingClientRect(), f = s ? u.bottom : u.top;
          s && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: u.left, right: u.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!r) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let o = this.editorView.dom.offsetParent;
    this.element || (this.element = o.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let i, a;
    if (!o || o == document.body && getComputedStyle(o).position == "static")
      i = -pageXOffset, a = -pageYOffset;
    else {
      let s = o.getBoundingClientRect();
      i = s.left - o.scrollLeft, a = s.top - o.scrollTop;
    }
    this.element.style.left = r.left - i + "px", this.element.style.top = r.top - a + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), o = r && r.type.spec.disableDropCursor, i = typeof o == "function" ? o(this.editorView, t, e) : o;
    if (t && !i) {
      let a = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = p4(this.editorView.state.doc, a, this.editorView.dragging.slice);
        s != null && (a = s);
      }
      this.setCursor(a), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const VF = Ut.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      LF(this.options)
    ];
  }
});
class Tt extends Ue {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return Tt.valid(r) ? new Tt(r) : Ue.near(r);
  }
  content() {
    return Y.empty;
  }
  eq(e) {
    return e instanceof Tt && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Tt(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new W0(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !zF(e) || !jF(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = t.contentMatchAt(e.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e:
      for (; ; ) {
        if (!r && Tt.valid(e))
          return e;
        let o = e.pos, i = null;
        for (let a = e.depth; ; a--) {
          let s = e.node(a);
          if (t > 0 ? e.indexAfter(a) < s.childCount : e.index(a) > 0) {
            i = s.child(t > 0 ? e.indexAfter(a) : e.index(a) - 1);
            break;
          } else if (a == 0)
            return null;
          o += t;
          let l = e.doc.resolve(o);
          if (Tt.valid(l))
            return l;
        }
        for (; ; ) {
          let a = t > 0 ? i.firstChild : i.lastChild;
          if (!a) {
            if (i.isAtom && !i.isText && !Te.isSelectable(i)) {
              e = e.doc.resolve(o + i.nodeSize * t), r = !1;
              continue e;
            }
            break;
          }
          i = a, o += t;
          let s = e.doc.resolve(o);
          if (Tt.valid(s))
            return s;
        }
        return null;
      }
  }
}
Tt.prototype.visible = !1;
Tt.findFrom = Tt.findGapCursorFrom;
Ue.jsonID("gapcursor", Tt);
class W0 {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new W0(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return Tt.valid(t) ? new Tt(t) : Ue.near(t);
  }
}
function zF(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(t - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function jF(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(t); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || o.isAtom || o.type.spec.isolating)
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function HF() {
  return new Ct({
    props: {
      decorations: qF,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && Tt.valid(t) ? new Tt(t) : null;
      },
      handleClick: KF,
      handleKeyDown: UF,
      handleDOMEvents: { beforeinput: WF }
    }
  });
}
const UF = Y4({
  ArrowLeft: Ud("horiz", -1),
  ArrowRight: Ud("horiz", 1),
  ArrowUp: Ud("vert", -1),
  ArrowDown: Ud("vert", 1)
});
function Ud(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, o, i) {
    let a = r.selection, s = e > 0 ? a.$to : a.$from, l = a.empty;
    if (a instanceof Fe) {
      if (!i.endOfTextblock(t) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let d = Tt.findGapCursorFrom(s, e, l);
    return d ? (o && o(r.tr.setSelection(new Tt(d))), !0) : !1;
  };
}
function KF(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!Tt.valid(r))
    return !1;
  let o = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return o && o.inside > -1 && Te.isSelectable(n.state.doc.nodeAt(o.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new Tt(r))), !0);
}
function WF(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof Tt))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = W.empty;
  for (let a = r.length - 1; a >= 0; a--)
    o = W.from(r[a].createAndFill(null, o));
  let i = n.state.tr.replace(t.pos, t.pos, new Y(o, 0, 0));
  return i.setSelection(Fe.near(i.doc.resolve(t.pos + 1))), n.dispatch(i), !1;
}
function qF(n) {
  if (!(n.selection instanceof Tt))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", kt.create(n.doc, [an.widget(n.selection.head, e, { key: "gapcursor" })]);
}
const GF = Ut.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      HF()
    ];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = Ye($e(n, "allowGapCursor", t))) !== null && e !== void 0 ? e : null
    };
  }
}), JF = er.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", Ht(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: o, storedMarks: i } = t;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: s } = r.extensionManager, l = i || o.$to.parentOffset && o.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && l && a) {
              const f = l.filter((p) => s.includes(p.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), bw = er.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, Ht(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((n, e) => ({
      ...n,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((n) => nm({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
});
var tc = 200, Vt = function() {
};
Vt.prototype.append = function(e) {
  return e.length ? (e = Vt.from(e), !this.length && e || e.length < tc && this.leafAppend(e) || this.length < tc && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Vt.prototype.prepend = function(e) {
  return e.length ? Vt.from(e).append(this) : this;
};
Vt.prototype.appendInner = function(e) {
  return new ZF(this, e);
};
Vt.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Vt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Vt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Vt.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Vt.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(i, a) {
    return o.push(e(i, a));
  }, t, r), o;
};
Vt.from = function(e) {
  return e instanceof Vt ? e : e && e.length ? new $w(e) : Vt.empty;
};
var $w = /* @__PURE__ */ function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(o, i) {
    return o == 0 && i == this.length ? this : new e(this.values.slice(o, i));
  }, e.prototype.getInner = function(o) {
    return this.values[o];
  }, e.prototype.forEachInner = function(o, i, a, s) {
    for (var l = i; l < a; l++)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(o, i, a, s) {
    for (var l = i - 1; l >= a; l--)
      if (o(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(o) {
    if (this.length + o.length <= tc)
      return new e(this.values.concat(o.flatten()));
  }, e.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= tc)
      return new e(o.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(Vt);
Vt.empty = new $w([]);
var ZF = /* @__PURE__ */ function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, o, i, a) {
    var s = this.left.length;
    if (o < s && this.left.forEachInner(r, o, Math.min(i, s), a) === !1 || i > s && this.right.forEachInner(r, Math.max(o - s, 0), Math.min(this.length, i) - s, a + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, o, i, a) {
    var s = this.left.length;
    if (o > s && this.right.forEachInvertedInner(r, o - s, Math.max(i, s) - s, a + s) === !1 || i < s && this.left.forEachInvertedInner(r, Math.min(o, s), i, a) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var i = this.left.length;
    return o <= i ? this.left.slice(r, o) : r >= i ? this.right.slice(r - i, o - i) : this.left.slice(r, i).append(this.right.slice(0, o - i));
  }, e.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new e(this.left, o);
  }, e.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new e(o, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
}(Vt);
const YF = 500;
class sr {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, i;
    t && (o = this.remapping(r, this.items.length), i = o.maps.length);
    let a = e.tr, s, l, d = [], u = [];
    return this.items.forEach((f, p) => {
      if (!f.step) {
        o || (o = this.remapping(r, p + 1), i = o.maps.length), i--, u.push(f);
        return;
      }
      if (o) {
        u.push(new Or(f.map));
        let h = f.step.map(o.slice(i)), m;
        h && a.maybeStep(h).doc && (m = a.mapping.maps[a.mapping.maps.length - 1], d.push(new Or(m, void 0, void 0, d.length + u.length))), i--, m && o.appendMap(m, i);
      } else
        a.maybeStep(f.step);
      if (f.selection)
        return s = o ? f.selection.map(o.slice(i)) : f.selection, l = new sr(this.items.slice(0, r).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: a, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, o) {
    let i = [], a = this.eventCount, s = this.items, l = !o && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let f = e.steps[u].invert(e.docs[u]), p = new Or(e.mapping.maps[u], f, t), h;
      (h = l && l.merge(p)) && (p = h, u ? i.pop() : s = s.slice(0, s.length - 1)), i.push(p), t && (a++, t = void 0), o || (l = p);
    }
    let d = a - r.depth;
    return d > QF && (s = XF(s, d), a -= d), new sr(s.append(i), a);
  }
  remapping(e, t) {
    let r = new Aa();
    return this.items.forEach((o, i) => {
      let a = o.mirrorOffset != null && i - o.mirrorOffset >= e ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, a);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new sr(this.items.append(e.map((t) => new Or(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - t), i = e.mapping, a = e.steps.length, s = this.eventCount;
    this.items.forEach((p) => {
      p.selection && s--;
    }, o);
    let l = t;
    this.items.forEach((p) => {
      let h = i.getMirror(--l);
      if (h == null)
        return;
      a = Math.min(a, h);
      let m = i.maps[h];
      if (p.step) {
        let g = e.steps[h].invert(e.docs[h]), v = p.selection && p.selection.map(i.slice(l + 1, h));
        v && s++, r.push(new Or(m, g, v));
      } else
        r.push(new Or(m));
    }, o);
    let d = [];
    for (let p = t; p < a; p++)
      d.push(new Or(i.maps[p]));
    let u = this.items.slice(0, o).append(d).append(r), f = new sr(u, s);
    return f.emptyItemCount() > YF && (f = f.compress(this.items.length - r.length)), f;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, o = [], i = 0;
    return this.items.forEach((a, s) => {
      if (s >= e)
        o.push(a), a.selection && i++;
      else if (a.step) {
        let l = a.step.map(t.slice(r)), d = l && l.getMap();
        if (r--, d && t.appendMap(d, r), l) {
          let u = a.selection && a.selection.map(t.slice(r));
          u && i++;
          let f = new Or(d.invert(), l, u), p, h = o.length - 1;
          (p = o.length && o[h].merge(f)) ? o[h] = p : o.push(f);
        }
      } else
        a.map && r--;
    }, this.items.length, 0), new sr(Vt.from(o.reverse()), i);
  }
}
sr.empty = new sr(Vt.empty, 0);
function XF(n, e) {
  let t;
  return n.forEach((r, o) => {
    if (r.selection && e-- == 0)
      return t = o, !1;
  }), n.slice(t);
}
class Or {
  constructor(e, t, r, o) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = o;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Or(t.getMap().invert(), t, this.selection);
    }
  }
}
class Io {
  constructor(e, t, r, o, i) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = o, this.prevComposition = i;
  }
}
const QF = 20;
function eV(n, e, t, r) {
  let o = t.getMeta(Di), i;
  if (o)
    return o.historyState;
  t.getMeta(rV) && (n = new Io(n.done, n.undone, null, 0, -1));
  let a = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (a && a.getMeta(Di))
    return a.getMeta(Di).redo ? new Io(n.done.addTransform(t, void 0, r, pu(e)), n.undone, By(t.mapping.maps), n.prevTime, n.prevComposition) : new Io(n.done, n.undone.addTransform(t, void 0, r, pu(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(a && a.getMeta("addToHistory") === !1)) {
    let s = t.getMeta("composition"), l = n.prevTime == 0 || !a && n.prevComposition != s && (n.prevTime < (t.time || 0) - r.newGroupDelay || !tV(t, n.prevRanges)), d = a ? Np(n.prevRanges, t.mapping) : By(t.mapping.maps);
    return new Io(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, r, pu(e)), sr.empty, d, t.time, s ?? n.prevComposition);
  } else
    return (i = t.getMeta("rebased")) ? new Io(n.done.rebased(t, i), n.undone.rebased(t, i), Np(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Io(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Np(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function tV(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, o) => {
    for (let i = 0; i < e.length; i += 2)
      r <= e[i + 1] && o >= e[i] && (t = !0);
  }), t;
}
function By(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, o, i, a) => e.push(i, a));
  return e;
}
function Np(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let o = e.map(n[r], 1), i = e.map(n[r + 1], -1);
    o <= i && t.push(o, i);
  }
  return t;
}
function nV(n, e, t) {
  let r = pu(e), o = Di.get(e).spec.config, i = (t ? n.undone : n.done).popEvent(e, r);
  if (!i)
    return null;
  let a = i.selection.resolve(i.transform.doc), s = (t ? n.done : n.undone).addTransform(i.transform, e.selection.getBookmark(), o, r), l = new Io(t ? s : i.remaining, t ? i.remaining : s, null, 0, -1);
  return i.transform.setSelection(a).setMeta(Di, { redo: t, historyState: l });
}
let Pp = !1, Ly = null;
function pu(n) {
  let e = n.plugins;
  if (Ly != e) {
    Pp = !1, Ly = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Pp = !0;
        break;
      }
  }
  return Pp;
}
const Di = new Lt("history"), rV = new Lt("closeHistory");
function oV(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new Ct({
    key: Di,
    state: {
      init() {
        return new Io(sr.empty, sr.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return eV(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, o = r == "historyUndo" ? xw : r == "historyRedo" ? Cw : null;
          return o ? (t.preventDefault(), o(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function ww(n, e) {
  return (t, r) => {
    let o = Di.getState(t);
    if (!o || (n ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let i = nV(o, t, n);
      i && r(e ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const xw = ww(!1, !0), Cw = ww(!0, !0), iV = Ut.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => xw(n, e),
      redo: () => ({ state: n, dispatch: e }) => Cw(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      oV(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), aV = er.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", Ht(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        const { selection: t } = e, { $from: r, $to: o } = t, i = n();
        return r.parentOffset === 0 ? i.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: o.pos
        }, {
          type: this.name
        }) : mw(t) ? i.insertContentAt(o.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ tr: a, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: d } = a.selection, u = d.end();
            if (d.nodeAfter)
              d.nodeAfter.isTextblock ? a.setSelection(Fe.create(a.doc, d.pos + 1)) : d.nodeAfter.isBlock ? a.setSelection(Te.create(a.doc, d.pos)) : a.setSelection(Fe.create(a.doc, d.pos));
            else {
              const f = (l = d.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              f && (a.insert(u, f), a.setSelection(Fe.create(a.doc, u + 1)));
            }
            a.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      vw({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), sV = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, lV = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, dV = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, uV = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, cV = xo.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      is({
        find: sV,
        type: this.type
      }),
      is({
        find: dV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qi({
        find: lV,
        type: this.type
      }),
      qi({
        find: uV,
        type: this.type
      })
    ];
  }
}), kw = er.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Ht(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), fV = "listItem", Fy = "textStyle", Vy = /^(\d+)\.\s$/, pV = er.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", Ht(this.options.HTMLAttributes, t), 0] : ["ol", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(fV, this.editor.getAttributes(Fy)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Gl({
      find: Vy,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Gl({
      find: Vy,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(Fy) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [
      n
    ];
  }
}), _w = er.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), hV = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, mV = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, gV = xo.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", Ht(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      is({
        find: hV,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      qi({
        find: mV,
        type: this.type
      })
    ];
  }
}), vV = er.create({
  name: "text",
  group: "inline"
}), yV = Ut.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, r, o, i, a, s, l, d, u, f, p, h, m, g, v, $;
    const C = [];
    return this.options.bold !== !1 && C.push(TF.configure((n = this.options) === null || n === void 0 ? void 0 : n.bold)), this.options.blockquote !== !1 && C.push(kF.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bulletList !== !1 && C.push(yw.configure((t = this.options) === null || t === void 0 ? void 0 : t.bulletList)), this.options.code !== !1 && C.push(PF.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && C.push(RF.configure((o = this.options) === null || o === void 0 ? void 0 : o.codeBlock)), this.options.document !== !1 && C.push(BF.configure((i = this.options) === null || i === void 0 ? void 0 : i.document)), this.options.dropcursor !== !1 && C.push(VF.configure((a = this.options) === null || a === void 0 ? void 0 : a.dropcursor)), this.options.gapcursor !== !1 && C.push(GF.configure((s = this.options) === null || s === void 0 ? void 0 : s.gapcursor)), this.options.hardBreak !== !1 && C.push(JF.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && C.push(bw.configure((d = this.options) === null || d === void 0 ? void 0 : d.heading)), this.options.history !== !1 && C.push(iV.configure((u = this.options) === null || u === void 0 ? void 0 : u.history)), this.options.horizontalRule !== !1 && C.push(aV.configure((f = this.options) === null || f === void 0 ? void 0 : f.horizontalRule)), this.options.italic !== !1 && C.push(cV.configure((p = this.options) === null || p === void 0 ? void 0 : p.italic)), this.options.listItem !== !1 && C.push(kw.configure((h = this.options) === null || h === void 0 ? void 0 : h.listItem)), this.options.orderedList !== !1 && C.push(pV.configure((m = this.options) === null || m === void 0 ? void 0 : m.orderedList)), this.options.paragraph !== !1 && C.push(_w.configure((g = this.options) === null || g === void 0 ? void 0 : g.paragraph)), this.options.strike !== !1 && C.push(gV.configure((v = this.options) === null || v === void 0 ? void 0 : v.strike)), this.options.text !== !1 && C.push(vV.configure(($ = this.options) === null || $ === void 0 ? void 0 : $.text)), C;
  }
});
var Sn = "top", Yn = "bottom", Xn = "right", En = "left", q0 = "auto", xd = [Sn, Yn, Xn, En], as = "start", Jl = "end", bV = "clippingParents", Sw = "viewport", Es = "popper", $V = "reference", zy = /* @__PURE__ */ xd.reduce(function(n, e) {
  return n.concat([e + "-" + as, e + "-" + Jl]);
}, []), Ew = /* @__PURE__ */ [].concat(xd, [q0]).reduce(function(n, e) {
  return n.concat([e, e + "-" + as, e + "-" + Jl]);
}, []), wV = "beforeRead", xV = "read", CV = "afterRead", kV = "beforeMain", _V = "main", SV = "afterMain", EV = "beforeWrite", OV = "write", TV = "afterWrite", AV = [wV, xV, CV, kV, _V, SV, EV, OV, TV];
function Ur(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function Rn(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function Gi(n) {
  var e = Rn(n).Element;
  return n instanceof e || n instanceof Element;
}
function Gn(n) {
  var e = Rn(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function G0(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Rn(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function MV(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, o = e.attributes[t] || {}, i = e.elements[t];
    !Gn(i) || !Ur(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function NV(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, a = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), s = a.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !Gn(o) || !Ur(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const Ow = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: MV,
  effect: NV,
  requires: ["computeStyles"]
};
function Rr(n) {
  return n.split("-")[0];
}
var Ii = Math.max, nc = Math.min, ss = Math.round;
function om() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Tw() {
  return !/^((?!chrome|android).)*safari/i.test(om());
}
function ls(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = n.getBoundingClientRect(), o = 1, i = 1;
  e && Gn(n) && (o = n.offsetWidth > 0 && ss(r.width) / n.offsetWidth || 1, i = n.offsetHeight > 0 && ss(r.height) / n.offsetHeight || 1);
  var a = Gi(n) ? Rn(n) : window, s = a.visualViewport, l = !Tw() && t, d = (r.left + (l && s ? s.offsetLeft : 0)) / o, u = (r.top + (l && s ? s.offsetTop : 0)) / i, f = r.width / o, p = r.height / i;
  return {
    width: f,
    height: p,
    top: u,
    right: d + f,
    bottom: u + p,
    left: d,
    x: d,
    y: u
  };
}
function J0(n) {
  var e = ls(n), t = n.offsetWidth, r = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: r
  };
}
function Aw(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && G0(t)) {
    var r = e;
    do {
      if (r && n.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Co(n) {
  return Rn(n).getComputedStyle(n);
}
function PV(n) {
  return ["table", "td", "th"].indexOf(Ur(n)) >= 0;
}
function ui(n) {
  return ((Gi(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function Nf(n) {
  return Ur(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (G0(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ui(n)
  );
}
function jy(n) {
  return !Gn(n) || // https://github.com/popperjs/popper-core/issues/837
  Co(n).position === "fixed" ? null : n.offsetParent;
}
function DV(n) {
  var e = /firefox/i.test(om()), t = /Trident/i.test(om());
  if (t && Gn(n)) {
    var r = Co(n);
    if (r.position === "fixed")
      return null;
  }
  var o = Nf(n);
  for (G0(o) && (o = o.host); Gn(o) && ["html", "body"].indexOf(Ur(o)) < 0; ) {
    var i = Co(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Cd(n) {
  for (var e = Rn(n), t = jy(n); t && PV(t) && Co(t).position === "static"; )
    t = jy(t);
  return t && (Ur(t) === "html" || Ur(t) === "body" && Co(t).position === "static") ? e : t || DV(n) || e;
}
function Z0(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function il(n, e, t) {
  return Ii(n, nc(e, t));
}
function IV(n, e, t) {
  var r = il(n, e, t);
  return r > t ? t : r;
}
function Mw() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Nw(n) {
  return Object.assign({}, Mw(), n);
}
function Pw(n, e) {
  return e.reduce(function(t, r) {
    return t[r] = n, t;
  }, {});
}
var RV = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, Nw(typeof e != "number" ? e : Pw(e, xd));
};
function BV(n) {
  var e, t = n.state, r = n.name, o = n.options, i = t.elements.arrow, a = t.modifiersData.popperOffsets, s = Rr(t.placement), l = Z0(s), d = [En, Xn].indexOf(s) >= 0, u = d ? "height" : "width";
  if (!(!i || !a)) {
    var f = RV(o.padding, t), p = J0(i), h = l === "y" ? Sn : En, m = l === "y" ? Yn : Xn, g = t.rects.reference[u] + t.rects.reference[l] - a[l] - t.rects.popper[u], v = a[l] - t.rects.reference[l], $ = Cd(i), C = $ ? l === "y" ? $.clientHeight || 0 : $.clientWidth || 0 : 0, S = g / 2 - v / 2, w = f[h], T = C - p[u] - f[m], A = C / 2 - p[u] / 2 + S, N = il(w, A, T), z = l;
    t.modifiersData[r] = (e = {}, e[z] = N, e.centerOffset = N - A, e);
  }
}
function LV(n) {
  var e = n.state, t = n.options, r = t.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || Aw(e.elements.popper, o) && (e.elements.arrow = o));
}
const FV = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: BV,
  effect: LV,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ds(n) {
  return n.split("-")[1];
}
var VV = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function zV(n, e) {
  var t = n.x, r = n.y, o = e.devicePixelRatio || 1;
  return {
    x: ss(t * o) / o || 0,
    y: ss(r * o) / o || 0
  };
}
function Hy(n) {
  var e, t = n.popper, r = n.popperRect, o = n.placement, i = n.variation, a = n.offsets, s = n.position, l = n.gpuAcceleration, d = n.adaptive, u = n.roundOffsets, f = n.isFixed, p = a.x, h = p === void 0 ? 0 : p, m = a.y, g = m === void 0 ? 0 : m, v = typeof u == "function" ? u({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = v.x, g = v.y;
  var $ = a.hasOwnProperty("x"), C = a.hasOwnProperty("y"), S = En, w = Sn, T = window;
  if (d) {
    var A = Cd(t), N = "clientHeight", z = "clientWidth";
    if (A === Rn(t) && (A = ui(t), Co(A).position !== "static" && s === "absolute" && (N = "scrollHeight", z = "scrollWidth")), A = A, o === Sn || (o === En || o === Xn) && i === Jl) {
      w = Yn;
      var I = f && A === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[N]
      );
      g -= I - r.height, g *= l ? 1 : -1;
    }
    if (o === En || (o === Sn || o === Yn) && i === Jl) {
      S = Xn;
      var P = f && A === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[z]
      );
      h -= P - r.width, h *= l ? 1 : -1;
    }
  }
  var L = Object.assign({
    position: s
  }, d && VV), H = u === !0 ? zV({
    x: h,
    y: g
  }, Rn(t)) : {
    x: h,
    y: g
  };
  if (h = H.x, g = H.y, l) {
    var q;
    return Object.assign({}, L, (q = {}, q[w] = C ? "0" : "", q[S] = $ ? "0" : "", q.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", q));
  }
  return Object.assign({}, L, (e = {}, e[w] = C ? g + "px" : "", e[S] = $ ? h + "px" : "", e.transform = "", e));
}
function jV(n) {
  var e = n.state, t = n.options, r = t.gpuAcceleration, o = r === void 0 ? !0 : r, i = t.adaptive, a = i === void 0 ? !0 : i, s = t.roundOffsets, l = s === void 0 ? !0 : s, d = {
    placement: Rr(e.placement),
    variation: ds(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Hy(Object.assign({}, d, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Hy(Object.assign({}, d, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const HV = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: jV,
  data: {}
};
var Kd = {
  passive: !0
};
function UV(n) {
  var e = n.state, t = n.instance, r = n.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, s = a === void 0 ? !0 : a, l = Rn(e.elements.popper), d = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && d.forEach(function(u) {
    u.addEventListener("scroll", t.update, Kd);
  }), s && l.addEventListener("resize", t.update, Kd), function() {
    i && d.forEach(function(u) {
      u.removeEventListener("scroll", t.update, Kd);
    }), s && l.removeEventListener("resize", t.update, Kd);
  };
}
const KV = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: UV,
  data: {}
};
var WV = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function hu(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return WV[e];
  });
}
var qV = {
  start: "end",
  end: "start"
};
function Uy(n) {
  return n.replace(/start|end/g, function(e) {
    return qV[e];
  });
}
function Y0(n) {
  var e = Rn(n), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function X0(n) {
  return ls(ui(n)).left + Y0(n).scrollLeft;
}
function GV(n, e) {
  var t = Rn(n), r = ui(n), o = t.visualViewport, i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    var d = Tw();
    (d || !d && e === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + X0(n),
    y: l
  };
}
function JV(n) {
  var e, t = ui(n), r = Y0(n), o = (e = n.ownerDocument) == null ? void 0 : e.body, i = Ii(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Ii(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + X0(n), l = -r.scrollTop;
  return Co(o || t).direction === "rtl" && (s += Ii(t.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function Q0(n) {
  var e = Co(n), t = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + r);
}
function Dw(n) {
  return ["html", "body", "#document"].indexOf(Ur(n)) >= 0 ? n.ownerDocument.body : Gn(n) && Q0(n) ? n : Dw(Nf(n));
}
function al(n, e) {
  var t;
  e === void 0 && (e = []);
  var r = Dw(n), o = r === ((t = n.ownerDocument) == null ? void 0 : t.body), i = Rn(r), a = o ? [i].concat(i.visualViewport || [], Q0(r) ? r : []) : r, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(al(Nf(a)))
  );
}
function im(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function ZV(n, e) {
  var t = ls(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Ky(n, e, t) {
  return e === Sw ? im(GV(n, t)) : Gi(e) ? ZV(e, t) : im(JV(ui(n)));
}
function YV(n) {
  var e = al(Nf(n)), t = ["absolute", "fixed"].indexOf(Co(n).position) >= 0, r = t && Gn(n) ? Cd(n) : n;
  return Gi(r) ? e.filter(function(o) {
    return Gi(o) && Aw(o, r) && Ur(o) !== "body";
  }) : [];
}
function XV(n, e, t, r) {
  var o = e === "clippingParents" ? YV(n) : [].concat(e), i = [].concat(o, [t]), a = i[0], s = i.reduce(function(l, d) {
    var u = Ky(n, d, r);
    return l.top = Ii(u.top, l.top), l.right = nc(u.right, l.right), l.bottom = nc(u.bottom, l.bottom), l.left = Ii(u.left, l.left), l;
  }, Ky(n, a, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Iw(n) {
  var e = n.reference, t = n.element, r = n.placement, o = r ? Rr(r) : null, i = r ? ds(r) : null, a = e.x + e.width / 2 - t.width / 2, s = e.y + e.height / 2 - t.height / 2, l;
  switch (o) {
    case Sn:
      l = {
        x: a,
        y: e.y - t.height
      };
      break;
    case Yn:
      l = {
        x: a,
        y: e.y + e.height
      };
      break;
    case Xn:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case En:
      l = {
        x: e.x - t.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var d = o ? Z0(o) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (i) {
      case as:
        l[d] = l[d] - (e[u] / 2 - t[u] / 2);
        break;
      case Jl:
        l[d] = l[d] + (e[u] / 2 - t[u] / 2);
        break;
    }
  }
  return l;
}
function Zl(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, o = r === void 0 ? n.placement : r, i = t.strategy, a = i === void 0 ? n.strategy : i, s = t.boundary, l = s === void 0 ? bV : s, d = t.rootBoundary, u = d === void 0 ? Sw : d, f = t.elementContext, p = f === void 0 ? Es : f, h = t.altBoundary, m = h === void 0 ? !1 : h, g = t.padding, v = g === void 0 ? 0 : g, $ = Nw(typeof v != "number" ? v : Pw(v, xd)), C = p === Es ? $V : Es, S = n.rects.popper, w = n.elements[m ? C : p], T = XV(Gi(w) ? w : w.contextElement || ui(n.elements.popper), l, u, a), A = ls(n.elements.reference), N = Iw({
    reference: A,
    element: S,
    strategy: "absolute",
    placement: o
  }), z = im(Object.assign({}, S, N)), I = p === Es ? z : A, P = {
    top: T.top - I.top + $.top,
    bottom: I.bottom - T.bottom + $.bottom,
    left: T.left - I.left + $.left,
    right: I.right - T.right + $.right
  }, L = n.modifiersData.offset;
  if (p === Es && L) {
    var H = L[o];
    Object.keys(P).forEach(function(q) {
      var Q = [Xn, Yn].indexOf(q) >= 0 ? 1 : -1, ae = [Sn, Yn].indexOf(q) >= 0 ? "y" : "x";
      P[q] += H[ae] * Q;
    });
  }
  return P;
}
function QV(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, o = t.boundary, i = t.rootBoundary, a = t.padding, s = t.flipVariations, l = t.allowedAutoPlacements, d = l === void 0 ? Ew : l, u = ds(r), f = u ? s ? zy : zy.filter(function(m) {
    return ds(m) === u;
  }) : xd, p = f.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  p.length === 0 && (p = f);
  var h = p.reduce(function(m, g) {
    return m[g] = Zl(n, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Rr(g)], m;
  }, {});
  return Object.keys(h).sort(function(m, g) {
    return h[m] - h[g];
  });
}
function ez(n) {
  if (Rr(n) === q0)
    return [];
  var e = hu(n);
  return [Uy(n), e, Uy(e)];
}
function tz(n) {
  var e = n.state, t = n.options, r = n.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = t.mainAxis, i = o === void 0 ? !0 : o, a = t.altAxis, s = a === void 0 ? !0 : a, l = t.fallbackPlacements, d = t.padding, u = t.boundary, f = t.rootBoundary, p = t.altBoundary, h = t.flipVariations, m = h === void 0 ? !0 : h, g = t.allowedAutoPlacements, v = e.options.placement, $ = Rr(v), C = $ === v, S = l || (C || !m ? [hu(v)] : ez(v)), w = [v].concat(S).reduce(function(Ne, st) {
      return Ne.concat(Rr(st) === q0 ? QV(e, {
        placement: st,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : st);
    }, []), T = e.rects.reference, A = e.rects.popper, N = /* @__PURE__ */ new Map(), z = !0, I = w[0], P = 0; P < w.length; P++) {
      var L = w[P], H = Rr(L), q = ds(L) === as, Q = [Sn, Yn].indexOf(H) >= 0, ae = Q ? "width" : "height", de = Zl(e, {
        placement: L,
        boundary: u,
        rootBoundary: f,
        altBoundary: p,
        padding: d
      }), ne = Q ? q ? Xn : En : q ? Yn : Sn;
      T[ae] > A[ae] && (ne = hu(ne));
      var ke = hu(ne), ee = [];
      if (i && ee.push(de[H] <= 0), s && ee.push(de[ne] <= 0, de[ke] <= 0), ee.every(function(Ne) {
        return Ne;
      })) {
        I = L, z = !1;
        break;
      }
      N.set(L, ee);
    }
    if (z)
      for (var be = m ? 3 : 1, Ee = function(st) {
        var ce = w.find(function(he) {
          var ve = N.get(he);
          if (ve)
            return ve.slice(0, st).every(function(_e) {
              return _e;
            });
        });
        if (ce)
          return I = ce, "break";
      }, nt = be; nt > 0; nt--) {
        var ct = Ee(nt);
        if (ct === "break")
          break;
      }
    e.placement !== I && (e.modifiersData[r]._skip = !0, e.placement = I, e.reset = !0);
  }
}
const nz = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: tz,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Wy(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function qy(n) {
  return [Sn, Xn, Yn, En].some(function(e) {
    return n[e] >= 0;
  });
}
function rz(n) {
  var e = n.state, t = n.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, a = Zl(e, {
    elementContext: "reference"
  }), s = Zl(e, {
    altBoundary: !0
  }), l = Wy(a, r), d = Wy(s, o, i), u = qy(l), f = qy(d);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const oz = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: rz
};
function iz(n, e, t) {
  var r = Rr(n), o = [En, Sn].indexOf(r) >= 0 ? -1 : 1, i = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [En, Xn].indexOf(r) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function az(n) {
  var e = n.state, t = n.options, r = n.name, o = t.offset, i = o === void 0 ? [0, 0] : o, a = Ew.reduce(function(u, f) {
    return u[f] = iz(f, e.rects, i), u;
  }, {}), s = a[e.placement], l = s.x, d = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += d), e.modifiersData[r] = a;
}
const sz = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: az
};
function lz(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = Iw({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const dz = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: lz,
  data: {}
};
function uz(n) {
  return n === "x" ? "y" : "x";
}
function cz(n) {
  var e = n.state, t = n.options, r = n.name, o = t.mainAxis, i = o === void 0 ? !0 : o, a = t.altAxis, s = a === void 0 ? !1 : a, l = t.boundary, d = t.rootBoundary, u = t.altBoundary, f = t.padding, p = t.tether, h = p === void 0 ? !0 : p, m = t.tetherOffset, g = m === void 0 ? 0 : m, v = Zl(e, {
    boundary: l,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), $ = Rr(e.placement), C = ds(e.placement), S = !C, w = Z0($), T = uz(w), A = e.modifiersData.popperOffsets, N = e.rects.reference, z = e.rects.popper, I = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, P = typeof I == "number" ? {
    mainAxis: I,
    altAxis: I
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, I), L = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, H = {
    x: 0,
    y: 0
  };
  if (A) {
    if (i) {
      var q, Q = w === "y" ? Sn : En, ae = w === "y" ? Yn : Xn, de = w === "y" ? "height" : "width", ne = A[w], ke = ne + v[Q], ee = ne - v[ae], be = h ? -z[de] / 2 : 0, Ee = C === as ? N[de] : z[de], nt = C === as ? -z[de] : -N[de], ct = e.elements.arrow, Ne = h && ct ? J0(ct) : {
        width: 0,
        height: 0
      }, st = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Mw(), ce = st[Q], he = st[ae], ve = il(0, N[de], Ne[de]), _e = S ? N[de] / 2 - be - ve - ce - P.mainAxis : Ee - ve - ce - P.mainAxis, ye = S ? -N[de] / 2 + be + ve + he + P.mainAxis : nt + ve + he + P.mainAxis, Se = e.elements.arrow && Cd(e.elements.arrow), se = Se ? w === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, Ke = (q = L?.[w]) != null ? q : 0, ut = ne + _e - Ke - se, me = ne + ye - Ke, Pe = il(h ? nc(ke, ut) : ke, ne, h ? Ii(ee, me) : ee);
      A[w] = Pe, H[w] = Pe - ne;
    }
    if (s) {
      var Qe, Je = w === "x" ? Sn : En, rt = w === "x" ? Yn : Xn, et = A[T], ht = T === "y" ? "height" : "width", nn = et + v[Je], Pt = et - v[rt], cn = [Sn, En].indexOf($) !== -1, Ln = (Qe = L?.[T]) != null ? Qe : 0, Kt = cn ? nn : et - N[ht] - z[ht] - Ln + P.altAxis, Fn = cn ? et + N[ht] + z[ht] - Ln - P.altAxis : Pt, kr = h && cn ? IV(Kt, et, Fn) : il(h ? Kt : nn, et, h ? Fn : Pt);
      A[T] = kr, H[T] = kr - et;
    }
    e.modifiersData[r] = H;
  }
}
const fz = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: cz,
  requiresIfExists: ["offset"]
};
function pz(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function hz(n) {
  return n === Rn(n) || !Gn(n) ? Y0(n) : pz(n);
}
function mz(n) {
  var e = n.getBoundingClientRect(), t = ss(e.width) / n.offsetWidth || 1, r = ss(e.height) / n.offsetHeight || 1;
  return t !== 1 || r !== 1;
}
function gz(n, e, t) {
  t === void 0 && (t = !1);
  var r = Gn(e), o = Gn(e) && mz(e), i = ui(e), a = ls(n, o, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !t) && ((Ur(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Q0(i)) && (s = hz(e)), Gn(e) ? (l = ls(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = X0(i))), {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function vz(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  n.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    t.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!t.has(s)) {
        var l = e.get(s);
        l && o(l);
      }
    }), r.push(i);
  }
  return n.forEach(function(i) {
    t.has(i.name) || o(i);
  }), r;
}
function yz(n) {
  var e = vz(n);
  return AV.reduce(function(t, r) {
    return t.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function bz(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function $z(n) {
  var e = n.reduce(function(t, r) {
    var o = t[r.name];
    return t[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var Gy = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Jy() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function wz(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, r = t === void 0 ? [] : t, o = e.defaultOptions, i = o === void 0 ? Gy : o;
  return function(s, l, d) {
    d === void 0 && (d = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Gy, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, h = {
      state: u,
      setOptions: function($) {
        var C = typeof $ == "function" ? $(u.options) : $;
        g(), u.options = Object.assign({}, i, u.options, C), u.scrollParents = {
          reference: Gi(s) ? al(s) : s.contextElement ? al(s.contextElement) : [],
          popper: al(l)
        };
        var S = yz($z([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = S.filter(function(w) {
          return w.enabled;
        }), m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var $ = u.elements, C = $.reference, S = $.popper;
          if (Jy(C, S)) {
            u.rects = {
              reference: gz(C, Cd(S), u.options.strategy === "fixed"),
              popper: J0(S)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(P) {
              return u.modifiersData[P.name] = Object.assign({}, P.data);
            });
            for (var w = 0; w < u.orderedModifiers.length; w++) {
              if (u.reset === !0) {
                u.reset = !1, w = -1;
                continue;
              }
              var T = u.orderedModifiers[w], A = T.fn, N = T.options, z = N === void 0 ? {} : N, I = T.name;
              typeof A == "function" && (u = A({
                state: u,
                options: z,
                name: I,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: bz(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(u);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!Jy(s, l))
      return h;
    h.setOptions(d).then(function(v) {
      !p && d.onFirstUpdate && d.onFirstUpdate(v);
    });
    function m() {
      u.orderedModifiers.forEach(function(v) {
        var $ = v.name, C = v.options, S = C === void 0 ? {} : C, w = v.effect;
        if (typeof w == "function") {
          var T = w({
            state: u,
            name: $,
            instance: h,
            options: S
          }), A = function() {
          };
          f.push(T || A);
        }
      });
    }
    function g() {
      f.forEach(function(v) {
        return v();
      }), f = [];
    }
    return h;
  };
}
var xz = [KV, dz, HV, Ow, sz, nz, fz, FV, oz], Cz = /* @__PURE__ */ wz({
  defaultModifiers: xz
}), kz = "tippy-box", Rw = "tippy-content", _z = "tippy-backdrop", Bw = "tippy-arrow", Lw = "tippy-svg-arrow", bi = {
  passive: !0,
  capture: !0
}, Fw = function() {
  return document.body;
};
function Sz(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function Dp(n, e, t) {
  if (Array.isArray(n)) {
    var r = n[e];
    return r ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function e1(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function Vw(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function Zy(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      n(r);
    }, e);
  };
}
function Ez(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function Oz(n) {
  return n.split(/\s+/).filter(Boolean);
}
function ya(n) {
  return [].concat(n);
}
function Yy(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function Tz(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function Az(n) {
  return n.split("-")[0];
}
function rc(n) {
  return [].slice.call(n);
}
function Xy(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function sl() {
  return document.createElement("div");
}
function Yl(n) {
  return ["Element", "Fragment"].some(function(e) {
    return e1(n, e);
  });
}
function Mz(n) {
  return e1(n, "NodeList");
}
function Nz(n) {
  return e1(n, "MouseEvent");
}
function Pz(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function Dz(n) {
  return Yl(n) ? [n] : Mz(n) ? rc(n) : Array.isArray(n) ? n : rc(document.querySelectorAll(n));
}
function Ip(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function Qy(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function Iz(n) {
  var e, t = ya(n), r = t[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function Rz(n, e) {
  var t = e.clientX, r = e.clientY;
  return n.every(function(o) {
    var i = o.popperRect, a = o.popperState, s = o.props, l = s.interactiveBorder, d = Az(a.placement), u = a.modifiersData.offset;
    if (!u)
      return !0;
    var f = d === "bottom" ? u.top.y : 0, p = d === "top" ? u.bottom.y : 0, h = d === "right" ? u.left.x : 0, m = d === "left" ? u.right.x : 0, g = i.top - r + f > l, v = r - i.bottom - p > l, $ = i.left - t + h > l, C = t - i.right - m > l;
    return g || v || $ || C;
  });
}
function Rp(n, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    n[r](o, t);
  });
}
function e2(n, e) {
  for (var t = e; t; ) {
    var r;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (r = t.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var Mr = {
  isTouch: !1
}, t2 = 0;
function Bz() {
  Mr.isTouch || (Mr.isTouch = !0, window.performance && document.addEventListener("mousemove", zw));
}
function zw() {
  var n = performance.now();
  n - t2 < 20 && (Mr.isTouch = !1, document.removeEventListener("mousemove", zw)), t2 = n;
}
function Lz() {
  var n = document.activeElement;
  if (Pz(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function Fz() {
  document.addEventListener("touchstart", Bz, bi), window.addEventListener("blur", Lz);
}
var Vz = typeof window < "u" && typeof document < "u", zz = Vz ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function fa(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function n2(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function jz(n) {
  return n2(`
  %ctippy.js

  %c` + n2(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function jw(n) {
  return [
    jz(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Xl;
process.env.NODE_ENV !== "production" && Hz();
function Hz() {
  Xl = /* @__PURE__ */ new Set();
}
function no(n, e) {
  if (n && !Xl.has(e)) {
    var t;
    Xl.add(e), (t = console).warn.apply(t, jw(e));
  }
}
function am(n, e) {
  if (n && !Xl.has(e)) {
    var t;
    Xl.add(e), (t = console).error.apply(t, jw(e));
  }
}
function Uz(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  am(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), am(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Hw = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Kz = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Pn = Object.assign({
  appendTo: Fw,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Hw, Kz), Wz = Object.keys(Pn), qz = function(e) {
  process.env.NODE_ENV !== "production" && Kw(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    Pn[r] = e[r];
  });
};
function Uw(n) {
  var e = n.plugins || [], t = e.reduce(function(r, o) {
    var i = o.name, a = o.defaultValue;
    if (i) {
      var s;
      r[i] = n[i] !== void 0 ? n[i] : (s = Pn[i]) != null ? s : a;
    }
    return r;
  }, {});
  return Object.assign({}, n, t);
}
function Gz(n, e) {
  var t = e ? Object.keys(Uw(Object.assign({}, Pn, {
    plugins: e
  }))) : Wz, r = t.reduce(function(o, i) {
    var a = (n.getAttribute("data-tippy-" + i) || "").trim();
    if (!a)
      return o;
    if (i === "content")
      o[i] = a;
    else
      try {
        o[i] = JSON.parse(a);
      } catch {
        o[i] = a;
      }
    return o;
  }, {});
  return r;
}
function r2(n, e) {
  var t = Object.assign({}, e, {
    content: Vw(e.content, [n])
  }, e.ignoreAttributes ? {} : Gz(n, e.plugins));
  return t.aria = Object.assign({}, Pn.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function Kw(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(r) {
    var o = Ez(Pn, Object.keys(Hw)), i = !Sz(o, r);
    i && (i = e.filter(function(a) {
      return a.name === r;
    }).length === 0), no(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Jz = function() {
  return "innerHTML";
};
function sm(n, e) {
  n[Jz()] = e;
}
function o2(n) {
  var e = sl();
  return n === !0 ? e.className = Bw : (e.className = Lw, Yl(n) ? e.appendChild(n) : sm(e, n)), e;
}
function i2(n, e) {
  Yl(e.content) ? (sm(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? sm(n, e.content) : n.textContent = e.content);
}
function lm(n) {
  var e = n.firstElementChild, t = rc(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(Rw);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(Bw) || r.classList.contains(Lw);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(_z);
    })
  };
}
function Ww(n) {
  var e = sl(), t = sl();
  t.className = kz, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = sl();
  r.className = Rw, r.setAttribute("data-state", "hidden"), i2(r, n.props), e.appendChild(t), t.appendChild(r), o(n.props, n.props);
  function o(i, a) {
    var s = lm(e), l = s.box, d = s.content, u = s.arrow;
    a.theme ? l.setAttribute("data-theme", a.theme) : l.removeAttribute("data-theme"), typeof a.animation == "string" ? l.setAttribute("data-animation", a.animation) : l.removeAttribute("data-animation"), a.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth, a.role ? l.setAttribute("role", a.role) : l.removeAttribute("role"), (i.content !== a.content || i.allowHTML !== a.allowHTML) && i2(d, n.props), a.arrow ? u ? i.arrow !== a.arrow && (l.removeChild(u), l.appendChild(o2(a.arrow))) : l.appendChild(o2(a.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
Ww.$$tippy = !0;
var Zz = 1, Wd = [], Bp = [];
function Yz(n, e) {
  var t = r2(n, Object.assign({}, Pn, Uw(Xy(e)))), r, o, i, a = !1, s = !1, l = !1, d = !1, u, f, p, h = [], m = Zy(ut, t.interactiveDebounce), g, v = Zz++, $ = null, C = Tz(t.plugins), S = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, w = {
    // properties
    id: v,
    reference: n,
    popper: sl(),
    popperInstance: $,
    props: t,
    state: S,
    plugins: C,
    // methods
    clearDelayTimeouts: Kt,
    setProps: Fn,
    setContent: kr,
    show: tr,
    hide: On,
    hideWithInteractivity: V,
    enable: cn,
    disable: Ln,
    unmount: F,
    destroy: Z
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && am(!0, "render() function has not been supplied."), w;
  var T = t.render(w), A = T.popper, N = T.onUpdate;
  A.setAttribute("data-tippy-root", ""), A.id = "tippy-" + w.id, w.popper = A, n._tippy = w, A._tippy = w;
  var z = C.map(function(R) {
    return R.fn(w);
  }), I = n.hasAttribute("aria-expanded");
  return Se(), be(), ne(), ke("onCreate", [w]), t.showOnCreate && nn(), A.addEventListener("mouseenter", function() {
    w.props.interactive && w.state.isVisible && w.clearDelayTimeouts();
  }), A.addEventListener("mouseleave", function() {
    w.props.interactive && w.props.trigger.indexOf("mouseenter") >= 0 && Q().addEventListener("mousemove", m);
  }), w;
  function P() {
    var R = w.props.touch;
    return Array.isArray(R) ? R : [R, 0];
  }
  function L() {
    return P()[0] === "hold";
  }
  function H() {
    var R;
    return !!((R = w.props.render) != null && R.$$tippy);
  }
  function q() {
    return g || n;
  }
  function Q() {
    var R = q().parentNode;
    return R ? Iz(R) : document;
  }
  function ae() {
    return lm(A);
  }
  function de(R) {
    return w.state.isMounted && !w.state.isVisible || Mr.isTouch || u && u.type === "focus" ? 0 : Dp(w.props.delay, R ? 0 : 1, Pn.delay);
  }
  function ne(R) {
    R === void 0 && (R = !1), A.style.pointerEvents = w.props.interactive && !R ? "" : "none", A.style.zIndex = "" + w.props.zIndex;
  }
  function ke(R, J, oe) {
    if (oe === void 0 && (oe = !0), z.forEach(function(xe) {
      xe[R] && xe[R].apply(xe, J);
    }), oe) {
      var ue;
      (ue = w.props)[R].apply(ue, J);
    }
  }
  function ee() {
    var R = w.props.aria;
    if (R.content) {
      var J = "aria-" + R.content, oe = A.id, ue = ya(w.props.triggerTarget || n);
      ue.forEach(function(xe) {
        var Ze = xe.getAttribute(J);
        if (w.state.isVisible)
          xe.setAttribute(J, Ze ? Ze + " " + oe : oe);
        else {
          var lt = Ze && Ze.replace(oe, "").trim();
          lt ? xe.setAttribute(J, lt) : xe.removeAttribute(J);
        }
      });
    }
  }
  function be() {
    if (!(I || !w.props.aria.expanded)) {
      var R = ya(w.props.triggerTarget || n);
      R.forEach(function(J) {
        w.props.interactive ? J.setAttribute("aria-expanded", w.state.isVisible && J === q() ? "true" : "false") : J.removeAttribute("aria-expanded");
      });
    }
  }
  function Ee() {
    Q().removeEventListener("mousemove", m), Wd = Wd.filter(function(R) {
      return R !== m;
    });
  }
  function nt(R) {
    if (!(Mr.isTouch && (l || R.type === "mousedown"))) {
      var J = R.composedPath && R.composedPath()[0] || R.target;
      if (!(w.props.interactive && e2(A, J))) {
        if (ya(w.props.triggerTarget || n).some(function(oe) {
          return e2(oe, J);
        })) {
          if (Mr.isTouch || w.state.isVisible && w.props.trigger.indexOf("click") >= 0)
            return;
        } else
          ke("onClickOutside", [w, R]);
        w.props.hideOnClick === !0 && (w.clearDelayTimeouts(), w.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), w.state.isMounted || ce());
      }
    }
  }
  function ct() {
    l = !0;
  }
  function Ne() {
    l = !1;
  }
  function st() {
    var R = Q();
    R.addEventListener("mousedown", nt, !0), R.addEventListener("touchend", nt, bi), R.addEventListener("touchstart", Ne, bi), R.addEventListener("touchmove", ct, bi);
  }
  function ce() {
    var R = Q();
    R.removeEventListener("mousedown", nt, !0), R.removeEventListener("touchend", nt, bi), R.removeEventListener("touchstart", Ne, bi), R.removeEventListener("touchmove", ct, bi);
  }
  function he(R, J) {
    _e(R, function() {
      !w.state.isVisible && A.parentNode && A.parentNode.contains(A) && J();
    });
  }
  function ve(R, J) {
    _e(R, J);
  }
  function _e(R, J) {
    var oe = ae().box;
    function ue(xe) {
      xe.target === oe && (Rp(oe, "remove", ue), J());
    }
    if (R === 0)
      return J();
    Rp(oe, "remove", f), Rp(oe, "add", ue), f = ue;
  }
  function ye(R, J, oe) {
    oe === void 0 && (oe = !1);
    var ue = ya(w.props.triggerTarget || n);
    ue.forEach(function(xe) {
      xe.addEventListener(R, J, oe), h.push({
        node: xe,
        eventType: R,
        handler: J,
        options: oe
      });
    });
  }
  function Se() {
    L() && (ye("touchstart", Ke, {
      passive: !0
    }), ye("touchend", me, {
      passive: !0
    })), Oz(w.props.trigger).forEach(function(R) {
      if (R !== "manual")
        switch (ye(R, Ke), R) {
          case "mouseenter":
            ye("mouseleave", me);
            break;
          case "focus":
            ye(zz ? "focusout" : "blur", Pe);
            break;
          case "focusin":
            ye("focusout", Pe);
            break;
        }
    });
  }
  function se() {
    h.forEach(function(R) {
      var J = R.node, oe = R.eventType, ue = R.handler, xe = R.options;
      J.removeEventListener(oe, ue, xe);
    }), h = [];
  }
  function Ke(R) {
    var J, oe = !1;
    if (!(!w.state.isEnabled || Qe(R) || s)) {
      var ue = ((J = u) == null ? void 0 : J.type) === "focus";
      u = R, g = R.currentTarget, be(), !w.state.isVisible && Nz(R) && Wd.forEach(function(xe) {
        return xe(R);
      }), R.type === "click" && (w.props.trigger.indexOf("mouseenter") < 0 || a) && w.props.hideOnClick !== !1 && w.state.isVisible ? oe = !0 : nn(R), R.type === "click" && (a = !oe), oe && !ue && Pt(R);
    }
  }
  function ut(R) {
    var J = R.target, oe = q().contains(J) || A.contains(J);
    if (!(R.type === "mousemove" && oe)) {
      var ue = ht().concat(A).map(function(xe) {
        var Ze, lt = xe._tippy, tt = (Ze = lt.popperInstance) == null ? void 0 : Ze.state;
        return tt ? {
          popperRect: xe.getBoundingClientRect(),
          popperState: tt,
          props: t
        } : null;
      }).filter(Boolean);
      Rz(ue, R) && (Ee(), Pt(R));
    }
  }
  function me(R) {
    var J = Qe(R) || w.props.trigger.indexOf("click") >= 0 && a;
    if (!J) {
      if (w.props.interactive) {
        w.hideWithInteractivity(R);
        return;
      }
      Pt(R);
    }
  }
  function Pe(R) {
    w.props.trigger.indexOf("focusin") < 0 && R.target !== q() || w.props.interactive && R.relatedTarget && A.contains(R.relatedTarget) || Pt(R);
  }
  function Qe(R) {
    return Mr.isTouch ? L() !== R.type.indexOf("touch") >= 0 : !1;
  }
  function Je() {
    rt();
    var R = w.props, J = R.popperOptions, oe = R.placement, ue = R.offset, xe = R.getReferenceClientRect, Ze = R.moveTransition, lt = H() ? lm(A).arrow : null, tt = xe ? {
      getBoundingClientRect: xe,
      contextElement: xe.contextElement || q()
    } : n, Et = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Tn) {
        var An = Tn.state;
        if (H()) {
          var ci = ae(), fi = ci.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Eo) {
            Eo === "placement" ? fi.setAttribute("data-placement", An.placement) : An.attributes.popper["data-popper-" + Eo] ? fi.setAttribute("data-" + Eo, "") : fi.removeAttribute("data-" + Eo);
          }), An.attributes.popper = {};
        }
      }
    }, yt = [{
      name: "offset",
      options: {
        offset: ue
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Ze
      }
    }, Et];
    H() && lt && yt.push({
      name: "arrow",
      options: {
        element: lt,
        padding: 3
      }
    }), yt.push.apply(yt, J?.modifiers || []), w.popperInstance = Cz(tt, A, Object.assign({}, J, {
      placement: oe,
      onFirstUpdate: p,
      modifiers: yt
    }));
  }
  function rt() {
    w.popperInstance && (w.popperInstance.destroy(), w.popperInstance = null);
  }
  function et() {
    var R = w.props.appendTo, J, oe = q();
    w.props.interactive && R === Fw || R === "parent" ? J = oe.parentNode : J = Vw(R, [oe]), J.contains(A) || J.appendChild(A), w.state.isMounted = !0, Je(), process.env.NODE_ENV !== "production" && no(w.props.interactive && R === Pn.appendTo && oe.nextElementSibling !== A, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function ht() {
    return rc(A.querySelectorAll("[data-tippy-root]"));
  }
  function nn(R) {
    w.clearDelayTimeouts(), R && ke("onTrigger", [w, R]), st();
    var J = de(!0), oe = P(), ue = oe[0], xe = oe[1];
    Mr.isTouch && ue === "hold" && xe && (J = xe), J ? r = setTimeout(function() {
      w.show();
    }, J) : w.show();
  }
  function Pt(R) {
    if (w.clearDelayTimeouts(), ke("onUntrigger", [w, R]), !w.state.isVisible) {
      ce();
      return;
    }
    if (!(w.props.trigger.indexOf("mouseenter") >= 0 && w.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(R.type) >= 0 && a)) {
      var J = de(!1);
      J ? o = setTimeout(function() {
        w.state.isVisible && w.hide();
      }, J) : i = requestAnimationFrame(function() {
        w.hide();
      });
    }
  }
  function cn() {
    w.state.isEnabled = !0;
  }
  function Ln() {
    w.hide(), w.state.isEnabled = !1;
  }
  function Kt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function Fn(R) {
    if (process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("setProps")), !w.state.isDestroyed) {
      ke("onBeforeUpdate", [w, R]), se();
      var J = w.props, oe = r2(n, Object.assign({}, J, Xy(R), {
        ignoreAttributes: !0
      }));
      w.props = oe, Se(), J.interactiveDebounce !== oe.interactiveDebounce && (Ee(), m = Zy(ut, oe.interactiveDebounce)), J.triggerTarget && !oe.triggerTarget ? ya(J.triggerTarget).forEach(function(ue) {
        ue.removeAttribute("aria-expanded");
      }) : oe.triggerTarget && n.removeAttribute("aria-expanded"), be(), ne(), N && N(J, oe), w.popperInstance && (Je(), ht().forEach(function(ue) {
        requestAnimationFrame(ue._tippy.popperInstance.forceUpdate);
      })), ke("onAfterUpdate", [w, R]);
    }
  }
  function kr(R) {
    w.setProps({
      content: R
    });
  }
  function tr() {
    process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("show"));
    var R = w.state.isVisible, J = w.state.isDestroyed, oe = !w.state.isEnabled, ue = Mr.isTouch && !w.props.touch, xe = Dp(w.props.duration, 0, Pn.duration);
    if (!(R || J || oe || ue) && !q().hasAttribute("disabled") && (ke("onShow", [w], !1), w.props.onShow(w) !== !1)) {
      if (w.state.isVisible = !0, H() && (A.style.visibility = "visible"), ne(), st(), w.state.isMounted || (A.style.transition = "none"), H()) {
        var Ze = ae(), lt = Ze.box, tt = Ze.content;
        Ip([lt, tt], 0);
      }
      p = function() {
        var yt;
        if (!(!w.state.isVisible || d)) {
          if (d = !0, A.offsetHeight, A.style.transition = w.props.moveTransition, H() && w.props.animation) {
            var Ft = ae(), Tn = Ft.box, An = Ft.content;
            Ip([Tn, An], xe), Qy([Tn, An], "visible");
          }
          ee(), be(), Yy(Bp, w), (yt = w.popperInstance) == null || yt.forceUpdate(), ke("onMount", [w]), w.props.animation && H() && ve(xe, function() {
            w.state.isShown = !0, ke("onShown", [w]);
          });
        }
      }, et();
    }
  }
  function On() {
    process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("hide"));
    var R = !w.state.isVisible, J = w.state.isDestroyed, oe = !w.state.isEnabled, ue = Dp(w.props.duration, 1, Pn.duration);
    if (!(R || J || oe) && (ke("onHide", [w], !1), w.props.onHide(w) !== !1)) {
      if (w.state.isVisible = !1, w.state.isShown = !1, d = !1, a = !1, H() && (A.style.visibility = "hidden"), Ee(), ce(), ne(!0), H()) {
        var xe = ae(), Ze = xe.box, lt = xe.content;
        w.props.animation && (Ip([Ze, lt], ue), Qy([Ze, lt], "hidden"));
      }
      ee(), be(), w.props.animation ? H() && he(ue, w.unmount) : w.unmount();
    }
  }
  function V(R) {
    process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("hideWithInteractivity")), Q().addEventListener("mousemove", m), Yy(Wd, m), m(R);
  }
  function F() {
    process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("unmount")), w.state.isVisible && w.hide(), w.state.isMounted && (rt(), ht().forEach(function(R) {
      R._tippy.unmount();
    }), A.parentNode && A.parentNode.removeChild(A), Bp = Bp.filter(function(R) {
      return R !== w;
    }), w.state.isMounted = !1, ke("onHidden", [w]));
  }
  function Z() {
    process.env.NODE_ENV !== "production" && no(w.state.isDestroyed, fa("destroy")), !w.state.isDestroyed && (w.clearDelayTimeouts(), w.unmount(), se(), delete n._tippy, w.state.isDestroyed = !0, ke("onDestroy", [w]));
  }
}
function ws(n, e) {
  e === void 0 && (e = {});
  var t = Pn.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (Uz(n), Kw(e, t)), Fz();
  var r = Object.assign({}, e, {
    plugins: t
  }), o = Dz(n);
  if (process.env.NODE_ENV !== "production") {
    var i = Yl(r.content), a = o.length > 1;
    no(i && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = o.reduce(function(l, d) {
    var u = d && Yz(d, r);
    return u && l.push(u), l;
  }, []);
  return Yl(n) ? s[0] : s;
}
ws.defaultProps = Pn;
ws.setDefaultProps = qz;
ws.currentInput = Mr;
Object.assign({}, Ow, {
  effect: function(e) {
    var t = e.state, r = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow);
  }
});
ws.setDefaultProps({
  render: Ww
});
class Xz {
  constructor({ editor: e, element: t, view: r, tippyOptions: o = {}, updateDelay: i = 250, shouldShow: a }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: d, to: u }) => {
      const { doc: f, selection: p } = l, { empty: h } = p, m = !f.textBetween(d, u).length && H0(l.selection), g = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || g) || h || m || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s?.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || s?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const d = !l?.selection.eq(s.state.selection), u = !l?.doc.eq(s.state.doc);
      !d && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, d, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, d, u) => {
      var f, p, h;
      const { state: m, composing: g } = s, { selection: v } = m;
      if (g || !l && !d)
        return;
      this.createTooltip();
      const { ranges: C } = v, S = Math.min(...C.map((A) => A.$from.pos)), w = Math.max(...C.map((A) => A.$to.pos));
      if (!((f = this.shouldShow) === null || f === void 0 ? void 0 : f.call(this, {
        editor: this.editor,
        element: this.element,
        view: s,
        state: m,
        oldState: u,
        from: S,
        to: w
      }))) {
        this.hide();
        return;
      }
      (p = this.tippy) === null || p === void 0 || p.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (mw(m.selection)) {
            let A = s.nodeDOM(S);
            if (A) {
              const N = A.dataset.nodeViewWrapper ? A : A.querySelector("[data-node-view-wrapper]");
              if (N && (A = N.firstChild), A)
                return A.getBoundingClientRect();
            }
          }
          return gw(s, S, w);
        })
      }), this.show();
    }, this.editor = e, this.element = t, this.view = r, this.updateDelay = i, a && (this.shouldShow = a), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = ws(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    const { state: r } = e, o = r.selection.from !== r.selection.to;
    if (this.updateDelay > 0 && o) {
      this.handleDebouncedUpdate(e, t);
      return;
    }
    const i = !t?.selection.eq(e.state.selection), a = !t?.doc.eq(e.state.doc);
    this.updateHandler(e, i, a, t);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const qw = (n) => new Ct({
  key: typeof n.pluginKey == "string" ? new Lt(n.pluginKey) : n.pluginKey,
  view: (e) => new Xz({ view: e, ...n })
});
Ut.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      qw({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
class Qz {
  getTextContent(e) {
    return pw(e, { textSerializers: j0(this.editor.schema) });
  }
  constructor({ editor: e, element: t, view: r, tippyOptions: o = {}, shouldShow: i }) {
    this.preventHide = !1, this.shouldShow = ({ view: a, state: s }) => {
      const { selection: l } = s, { $anchor: d, empty: u } = l, f = d.depth === 1, p = d.parent.isTextblock && !d.parent.type.spec.code && !d.parent.textContent && d.parent.childCount === 0 && !this.getTextContent(d.parent);
      return !(!a.hasFocus() || !u || !f || !p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: a }) => {
      var s;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      a?.relatedTarget && (!((s = this.element.parentNode) === null || s === void 0) && s.contains(a.relatedTarget)) || a?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (a) => {
      this.blurHandler({ event: a });
    }, this.editor = e, this.element = t, this.view = r, i && (this.shouldShow = i), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = o, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, t = !!e.parentElement;
    this.tippy || !t || (this.tippy = ws(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "right",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, t) {
    var r, o, i;
    const { state: a } = e, { doc: s, selection: l } = a, { from: d, to: u } = l;
    if (t && t.doc.eq(s) && t.selection.eq(l))
      return;
    if (this.createTooltip(), !((r = this.shouldShow) === null || r === void 0 ? void 0 : r.call(this, {
      editor: this.editor,
      view: e,
      state: a,
      oldState: t
    }))) {
      this.hide();
      return;
    }
    (o = this.tippy) === null || o === void 0 || o.setProps({
      getReferenceClientRect: ((i = this.tippyOptions) === null || i === void 0 ? void 0 : i.getReferenceClientRect) || (() => gw(e, d, u))
    }), this.show();
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, t;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (t = this.tippy) === null || t === void 0 || t.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const Gw = (n) => new Ct({
  key: typeof n.pluginKey == "string" ? new Lt(n.pluginKey) : n.pluginKey,
  view: (e) => new Qz({ view: e, ...n })
});
Ut.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "floatingMenu",
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Gw({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
_({
  name: "BubbleMenu",
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = B(null);
    return Ge(() => {
      const { updateDelay: r, editor: o, pluginKey: i, shouldShow: a, tippyOptions: s } = n;
      o.registerPlugin(qw({
        updateDelay: r,
        editor: o,
        element: t.value,
        pluginKey: i,
        shouldShow: a,
        tippyOptions: s
      }));
    }), xr(() => {
      const { pluginKey: r, editor: o } = n;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Yt("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
function a2(n) {
  return T2((e, t) => ({
    get() {
      return e(), n;
    },
    set(r) {
      n = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
class ej extends $F {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = a2(this.view.state), this.reactiveExtensionStorage = a2(this.extensionStorage), this.on("beforeTransaction", ({ nextState: t }) => {
      this.reactiveState.value = t, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), wm(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, t) {
    const r = super.registerPlugin(e, t);
    return this.reactiveState && (this.reactiveState.value = r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const t = super.unregisterPlugin(e);
    return this.reactiveState && t && (this.reactiveState.value = t), t;
  }
}
const tj = _({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(n) {
    const e = B(), t = sn();
    return vt(() => {
      const r = n.editor;
      r && r.options.element && e.value && Be(() => {
        if (!e.value || !r.options.element.firstChild)
          return;
        const o = c(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = t.ctx._, t && (r.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), r.setOptions({
          element: o
        }), r.createNodeViews();
      });
    }), xr(() => {
      const r = n.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return Yt("div", {
      ref: (n) => {
        this.rootEl = n;
      }
    });
  }
});
_({
  name: "FloatingMenu",
  props: {
    pluginKey: {
      // TODO: TypeScript breaks :(
      // type: [String, Object as PropType<Exclude<FloatingMenuPluginProps['pluginKey'], string>>],
      type: null,
      default: "floatingMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    tippyOptions: {
      type: Object,
      default: () => ({})
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  setup(n, { slots: e }) {
    const t = B(null);
    return Ge(() => {
      const { pluginKey: r, editor: o, tippyOptions: i, shouldShow: a } = n;
      o.registerPlugin(Gw({
        pluginKey: r,
        editor: o,
        element: t.value,
        tippyOptions: i,
        shouldShow: a
      }));
    }), xr(() => {
      const { pluginKey: r, editor: o } = n;
      o.unregisterPlugin(r);
    }), () => {
      var r;
      return Yt("div", { ref: t }, (r = e.default) === null || r === void 0 ? void 0 : r.call(e));
    };
  }
});
const t1 = _({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return Yt(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
}), n1 = _({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var n, e;
    return Yt(this.as, {
      // @ts-ignore
      class: this.decorationClasses,
      style: {
        whiteSpace: "normal"
      },
      "data-node-view-wrapper": "",
      // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
      onDragstart: this.onDragStart
    }, (e = (n = this.$slots).default) === null || e === void 0 ? void 0 : e.call(n));
  }
}), nj = (n = {}) => {
  const e = Da();
  return Ge(() => {
    e.value = new ej(n);
  }), xr(() => {
    var t, r, o;
    const i = (t = e.value) === null || t === void 0 ? void 0 : t.options.element, a = i?.cloneNode(!0);
    (r = i?.parentNode) === null || r === void 0 || r.replaceChild(a, i), (o = e.value) === null || o === void 0 || o.destroy();
  }), e;
};
class rj {
  constructor(e, { props: t = {}, editor: r }) {
    this.editor = r, this.component = wm(e), this.el = document.createElement("div"), this.props = Zo(t), this.renderedComponent = this.renderComponent();
  }
  get element() {
    return this.renderedComponent.el;
  }
  get ref() {
    var e, t, r, o;
    return !((t = (e = this.renderedComponent.vNode) === null || e === void 0 ? void 0 : e.component) === null || t === void 0) && t.exposed ? this.renderedComponent.vNode.component.exposed : (o = (r = this.renderedComponent.vNode) === null || r === void 0 ? void 0 : r.component) === null || o === void 0 ? void 0 : o.proxy;
  }
  renderComponent() {
    let e = Yt(this.component, this.props);
    return this.editor.appContext && (e.appContext = this.editor.appContext), typeof document < "u" && this.el && C1(e, this.el), { vNode: e, destroy: () => {
      this.el && C1(null, this.el), this.el = null, e = null;
    }, el: this.el ? this.el.firstElementChild : null };
  }
  updateProps(e = {}) {
    Object.entries(e).forEach(([t, r]) => {
      this.props[t] = r;
    }), this.renderComponent();
  }
  destroy() {
    this.renderedComponent.destroy();
  }
}
const r1 = {
  editor: {
    type: Object,
    required: !0
  },
  node: {
    type: Object,
    required: !0
  },
  decorations: {
    type: Object,
    required: !0
  },
  selected: {
    type: Boolean,
    required: !0
  },
  extension: {
    type: Object,
    required: !0
  },
  getPos: {
    type: Function,
    required: !0
  },
  updateAttributes: {
    type: Function,
    required: !0
  },
  deleteNode: {
    type: Function,
    required: !0
  },
  view: {
    type: Object,
    required: !0
  },
  innerDecorations: {
    type: Object,
    required: !0
  },
  HTMLAttributes: {
    type: Object,
    required: !0
  }
};
class oj extends wF {
  mount() {
    const e = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (o = {}) => this.updateAttributes(o),
      deleteNode: () => this.deleteNode()
    }, t = this.onDragStart.bind(this);
    this.decorationClasses = B(this.getDecorationClasses());
    const r = _({
      extends: { ...this.component },
      props: Object.keys(e),
      template: this.component.template,
      setup: (o) => {
        var i, a;
        return Jn("onDragStart", t), Jn("decorationClasses", this.decorationClasses), (a = (i = this.component).setup) === null || a === void 0 ? void 0 : a.call(i, o, {
          expose: () => {
          }
        });
      },
      // add support for scoped styles
      // @ts-ignore
      // eslint-disable-next-line
      __scopeId: this.component.__scopeId,
      // add support for CSS Modules
      // @ts-ignore
      // eslint-disable-next-line
      __cssModules: this.component.__cssModules,
      // add support for vue devtools
      // @ts-ignore
      // eslint-disable-next-line
      __name: this.component.__name,
      // @ts-ignore
      // eslint-disable-next-line
      __file: this.component.__file
    });
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.renderer = new rj(r, {
      editor: this.editor,
      props: e
    });
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    if (!this.renderer.element || !this.renderer.element.hasAttribute("data-node-view-wrapper"))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.dom.querySelector("[data-node-view-content]");
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: e, to: t } = this.editor.state.selection, r = this.getPos();
    if (typeof r == "number")
      if (e <= r && t >= r + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(e, t, r) {
    const o = (i) => {
      this.decorationClasses.value = this.getDecorationClasses(), this.renderer.updateProps(i);
    };
    if (typeof this.options.update == "function") {
      const i = this.node, a = this.decorations, s = this.innerDecorations;
      return this.node = e, this.decorations = t, this.innerDecorations = r, this.options.update({
        oldNode: i,
        oldDecorations: a,
        newNode: e,
        newDecorations: t,
        oldInnerDecorations: s,
        innerDecorations: r,
        updateProps: () => o({ node: e, decorations: t, innerDecorations: r })
      });
    }
    return e.type !== this.node.type ? !1 : (e === this.node && this.decorations === t && this.innerDecorations === r || (this.node = e, this.decorations = t, this.innerDecorations = r, o({ node: e, decorations: t, innerDecorations: r })), !0);
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element && this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element && this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  getDecorationClasses() {
    return this.decorations.map((e) => e.type.attrs.class).flat().join(" ");
  }
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate);
  }
}
function o1(n, e) {
  return (t) => {
    if (!t.editor.contentComponent)
      return {};
    const r = typeof n == "function" && "__vccOpts" in n ? n.__vccOpts : n;
    return new oj(r, t, e);
  };
}
const ij = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, aj = er.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", Ht(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  addInputRules() {
    return [
      vw({
        find: ij,
        type: this.type,
        getAttributes: (n) => {
          const [, , e, t, r] = n;
          return { src: t, alt: e, title: r };
        }
      })
    ];
  }
});
function sj(n, e, t, r) {
  function o(i) {
    return i instanceof t ? i : new t(function(a) {
      a(i);
    });
  }
  return new (t || (t = Promise))(function(i, a) {
    function s(u) {
      try {
        d(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      try {
        d(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function d(u) {
      u.done ? i(u.value) : o(u.value).then(s, l);
    }
    d((r = r.apply(n, e || [])).next());
  });
}
let Jw, Zw = "";
const lj = aj.extend({
  name: "uploadImage",
  onCreate() {
    if (typeof this.options.uploadFn != "function") {
      console.warn("uploadFn should be a function");
      return;
    }
    Jw = this.options.uploadFn;
  },
  addOptions() {
    var n;
    return Object.assign(Object.assign({}, (n = this.parent) === null || n === void 0 ? void 0 : n.call(this)), { uploadFn: () => sj(this, void 0, void 0, function* () {
      return "";
    }) });
  },
  addProseMirrorPlugins() {
    return [ll];
  },
  addCommands() {
    var n;
    return Object.assign(Object.assign({}, (n = this.parent) === null || n === void 0 ? void 0 : n.call(this)), { addImage: () => () => {
      let e = document.createElement("input");
      e.setAttribute("type", "file"), e.setAttribute("accept", "image/*"), e.setAttribute("style", "visibility:hidden"), document.body.appendChild(e);
      const t = this.editor.view, r = this.editor.schema;
      return e.addEventListener("change", (o) => {
        var i, a, s;
        t.state.selection.$from.parent.inlineContent && (!((a = (i = o.target) === null || i === void 0 ? void 0 : i.files) === null || a === void 0) && a.length) && uj(t, (s = o.target) === null || s === void 0 ? void 0 : s.files[0], r), t.focus();
      }), e.click(), !0;
    } });
  }
}), ll = new Ct({
  state: {
    init() {
      return kt.empty;
    },
    apply(n, e) {
      e = e.map(n.mapping, n.doc);
      let t = n.getMeta(this);
      if (t && t.add) {
        let r = document.createElement("div"), o = document.createElement("img");
        r.classList.value = "image-uploading", o.src = Zw, r.appendChild(o);
        let i = an.widget(t.add.pos, r, {
          id: t.add.id
        });
        e = e.add(n.doc, [i]);
      } else
        t && t.remove && (e = e.remove(e.find(void 0, void 0, (r) => r.id == t.remove.id)));
      return e;
    }
  },
  props: {
    decorations(n) {
      return this.getState(n);
    }
  }
});
function dj(n, e) {
  let t = ll.getState(n), r = t?.find(void 0, void 0, (o) => o.id == e);
  return r?.length ? r[0].from : null;
}
function uj(n, e, t) {
  Zw = URL.createObjectURL(e);
  let r = {}, o = n.state.tr;
  o.selection.empty || o.deleteSelection(), o.setMeta(ll, { add: { id: r, pos: o.selection.from } }), n.dispatch(o), Jw(e).then((i) => {
    let a = dj(n.state, r);
    a != null && n.dispatch(n.state.tr.replaceWith(a, a, t.nodes.uploadImage.create({ src: i })).setMeta(ll, { remove: { id: r } }));
  }, (i) => {
    n.dispatch(o.setMeta(ll, { remove: { id: r } }));
  });
}
const cj = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function fj(n, e) {
  return b(), D("svg", cj, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.135 6.158a.5.5 0 0 1 .707-.023L7.5 9.565l3.658-3.43a.5.5 0 0 1 .684.73l-4 3.75a.5.5 0 0 1-.684 0l-4-3.75a.5.5 0 0 1-.023-.707",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const xs = { name: "radix-icons-chevron-down", render: fj }, pj = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function hj(n, e) {
  return b(), D("svg", pj, e[0] || (e[0] = [
    O("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      O("path", { d: "m13.5 8.5l-4.71 4.71l-2.13.29l.3-2.13l4.7-4.71zm-9.219 5H1.8a1.3 1.3 0 0 1-1.3-1.3V1.8A1.3 1.3 0 0 1 1.8.5h10.4a1.3 1.3 0 0 1 1.3 1.3v2.95" }),
      O("path", { d: "M9.014 4.795a1.25 1.25 0 1 0 0-2.5a1.25 1.25 0 0 0 0 2.5M.5 7.164a10.3 10.3 0 0 1 6.5.961" })
    ], -1)
  ]));
}
const mj = { name: "streamline-edit-image-photo", render: hj }, gj = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function vj(n, e) {
  return b(), D("svg", gj, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11 3.5a3 3 0 0 0-3-3H4a1 1 0 0 0-1 1v5h5a3 3 0 0 0 3-3Zm1 6.5a3.5 3.5 0 0 1-3.5 3.5H4a1 1 0 0 1-1-1v-6h5.5A3.5 3.5 0 0 1 12 10Z"
    }, null, -1)
  ]));
}
const yj = { name: "streamline-interface-text-formatting-bold-text-bold-formatting-format", render: vj }, bj = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function $j(n, e) {
  return b(), D("svg", bj, e[0] || (e[0] = [
    Cm('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="1" cy="2.5" r=".5"></circle><path d="M4.5 2.5h9"></path><circle cx="1" cy="7" r=".5"></circle><path d="M4.5 7h9"></path><circle cx="1" cy="11.5" r=".5"></circle><path d="M4.5 11.5h9"></path></g>', 1)
  ]));
}
const wj = { name: "streamline-interface-text-formatting-list-bullets-points-bullet-unordered-list-lists-bullets", render: $j }, xj = yw.extend({
  addProseMirrorPlugins() {
    const n = this.parent?.() || [], e = new Ct({
      key: new Lt("bulletListDecorations"),
      props: {
        decorations: (t) => {
          const { doc: r } = t, o = [];
          return r.descendants((i, a) => {
            i.type.name === "bulletList" && o.push(
              an.node(a, a + i.nodeSize, {
                class: "pl-0.5"
              })
            );
          }), kt.create(r, o);
        }
      }
    });
    return [...n, e];
  }
}), Cj = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", kj = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", us = (n, e) => {
  for (const t in e)
    n[t] = e[t];
  return n;
}, dm = "numeric", um = "ascii", cm = "alpha", dl = "asciinumeric", Gs = "alphanumeric", fm = "domain", Yw = "emoji", _j = "scheme", Sj = "slashscheme", Lp = "whitespace";
function Ej(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Oi(n, e, t) {
  e[dm] && (e[dl] = !0, e[Gs] = !0), e[um] && (e[dl] = !0, e[cm] = !0), e[dl] && (e[Gs] = !0), e[cm] && (e[Gs] = !0), e[Gs] && (e[fm] = !0), e[Yw] && (e[fm] = !0);
  for (const r in e) {
    const o = Ej(r, t);
    o.indexOf(n) < 0 && o.push(n);
  }
}
function Oj(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function wn(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
wn.groups = {};
wn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const o = e.jr[r][0], i = e.jr[r][1];
      if (i && o.test(n))
        return i;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let o = 0; o < n.length; o++)
      this.tt(n[o], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || wn.groups;
    let o;
    return e && e.j ? o = e : (o = new wn(e), t && r && Oi(e, t, r)), this.jr.push([n, o]), o;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let o = this;
    const i = n.length;
    if (!i)
      return o;
    for (let a = 0; a < i - 1; a++)
      o = o.tt(n[a]);
    return o.tt(n[i - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || wn.groups;
    const o = this;
    if (e && e.j)
      return o.j[n] = e, e;
    const i = e;
    let a, s = o.go(n);
    if (s ? (a = new wn(), us(a.j, s.j), a.jr.push.apply(a.jr, s.jr), a.jd = s.jd, a.t = s.t) : a = new wn(), i) {
      if (r)
        if (a.t && typeof a.t == "string") {
          const l = us(Oj(a.t, r), t);
          Oi(i, l, r);
        } else
          t && Oi(i, t, r);
      a.t = i;
    }
    return o.j[n] = a, a;
  }
};
const We = (n, e, t, r, o) => n.ta(e, t, r, o), Ot = (n, e, t, r, o) => n.tr(e, t, r, o), s2 = (n, e, t, r, o) => n.ts(e, t, r, o), re = (n, e, t, r, o) => n.tt(e, t, r, o), eo = "WORD", pm = "UWORD", Xw = "ASCIINUMERICAL", Qw = "ALPHANUMERICAL", Ql = "LOCALHOST", hm = "TLD", mm = "UTLD", mu = "SCHEME", ba = "SLASH_SCHEME", i1 = "NUM", gm = "WS", a1 = "NL", ul = "OPENBRACE", cl = "CLOSEBRACE", oc = "OPENBRACKET", ic = "CLOSEBRACKET", ac = "OPENPAREN", sc = "CLOSEPAREN", lc = "OPENANGLEBRACKET", dc = "CLOSEANGLEBRACKET", uc = "FULLWIDTHLEFTPAREN", cc = "FULLWIDTHRIGHTPAREN", fc = "LEFTCORNERBRACKET", pc = "RIGHTCORNERBRACKET", hc = "LEFTWHITECORNERBRACKET", mc = "RIGHTWHITECORNERBRACKET", gc = "FULLWIDTHLESSTHAN", vc = "FULLWIDTHGREATERTHAN", yc = "AMPERSAND", s1 = "APOSTROPHE", bc = "ASTERISK", Ro = "AT", $c = "BACKSLASH", wc = "BACKTICK", xc = "CARET", Vo = "COLON", l1 = "COMMA", Cc = "DOLLAR", Tr = "DOT", kc = "EQUALS", d1 = "EXCLAMATION", zn = "HYPHEN", fl = "PERCENT", _c = "PIPE", Sc = "PLUS", Ec = "POUND", pl = "QUERY", u1 = "QUOTE", e5 = "FULLWIDTHMIDDLEDOT", c1 = "SEMI", Ar = "SLASH", hl = "TILDE", Oc = "UNDERSCORE", t5 = "EMOJI", Tc = "SYM";
var n5 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: eo,
  UWORD: pm,
  ASCIINUMERICAL: Xw,
  ALPHANUMERICAL: Qw,
  LOCALHOST: Ql,
  TLD: hm,
  UTLD: mm,
  SCHEME: mu,
  SLASH_SCHEME: ba,
  NUM: i1,
  WS: gm,
  NL: a1,
  OPENBRACE: ul,
  CLOSEBRACE: cl,
  OPENBRACKET: oc,
  CLOSEBRACKET: ic,
  OPENPAREN: ac,
  CLOSEPAREN: sc,
  OPENANGLEBRACKET: lc,
  CLOSEANGLEBRACKET: dc,
  FULLWIDTHLEFTPAREN: uc,
  FULLWIDTHRIGHTPAREN: cc,
  LEFTCORNERBRACKET: fc,
  RIGHTCORNERBRACKET: pc,
  LEFTWHITECORNERBRACKET: hc,
  RIGHTWHITECORNERBRACKET: mc,
  FULLWIDTHLESSTHAN: gc,
  FULLWIDTHGREATERTHAN: vc,
  AMPERSAND: yc,
  APOSTROPHE: s1,
  ASTERISK: bc,
  AT: Ro,
  BACKSLASH: $c,
  BACKTICK: wc,
  CARET: xc,
  COLON: Vo,
  COMMA: l1,
  DOLLAR: Cc,
  DOT: Tr,
  EQUALS: kc,
  EXCLAMATION: d1,
  HYPHEN: zn,
  PERCENT: fl,
  PIPE: _c,
  PLUS: Sc,
  POUND: Ec,
  QUERY: pl,
  QUOTE: u1,
  FULLWIDTHMIDDLEDOT: e5,
  SEMI: c1,
  SLASH: Ar,
  TILDE: hl,
  UNDERSCORE: Oc,
  EMOJI: t5,
  SYM: Tc
});
const Zr = /[a-z]/, Os = /\p{L}/u, Fp = /\p{Emoji}/u, Yr = /\d/, Vp = /\s/, l2 = "\r", zp = `
`, Tj = "️", Aj = "‍", jp = "￼";
let qd = null, Gd = null;
function Mj(n = []) {
  const e = {};
  wn.groups = e;
  const t = new wn();
  qd == null && (qd = d2(Cj)), Gd == null && (Gd = d2(kj)), re(t, "'", s1), re(t, "{", ul), re(t, "}", cl), re(t, "[", oc), re(t, "]", ic), re(t, "(", ac), re(t, ")", sc), re(t, "<", lc), re(t, ">", dc), re(t, "（", uc), re(t, "）", cc), re(t, "「", fc), re(t, "」", pc), re(t, "『", hc), re(t, "』", mc), re(t, "＜", gc), re(t, "＞", vc), re(t, "&", yc), re(t, "*", bc), re(t, "@", Ro), re(t, "`", wc), re(t, "^", xc), re(t, ":", Vo), re(t, ",", l1), re(t, "$", Cc), re(t, ".", Tr), re(t, "=", kc), re(t, "!", d1), re(t, "-", zn), re(t, "%", fl), re(t, "|", _c), re(t, "+", Sc), re(t, "#", Ec), re(t, "?", pl), re(t, '"', u1), re(t, "/", Ar), re(t, ";", c1), re(t, "~", hl), re(t, "_", Oc), re(t, "\\", $c), re(t, "・", e5);
  const r = Ot(t, Yr, i1, {
    [dm]: !0
  });
  Ot(r, Yr, r);
  const o = Ot(r, Zr, Xw, {
    [dl]: !0
  }), i = Ot(r, Os, Qw, {
    [Gs]: !0
  }), a = Ot(t, Zr, eo, {
    [um]: !0
  });
  Ot(a, Yr, o), Ot(a, Zr, a), Ot(o, Yr, o), Ot(o, Zr, o);
  const s = Ot(t, Os, pm, {
    [cm]: !0
  });
  Ot(s, Zr), Ot(s, Yr, i), Ot(s, Os, s), Ot(i, Yr, i), Ot(i, Zr), Ot(i, Os, i);
  const l = re(t, zp, a1, {
    [Lp]: !0
  }), d = re(t, l2, gm, {
    [Lp]: !0
  }), u = Ot(t, Vp, gm, {
    [Lp]: !0
  });
  re(t, jp, u), re(d, zp, l), re(d, jp, u), Ot(d, Vp, u), re(u, l2), re(u, zp), Ot(u, Vp, u), re(u, jp, u);
  const f = Ot(t, Fp, t5, {
    [Yw]: !0
  });
  re(f, "#"), Ot(f, Fp, f), re(f, Tj, f);
  const p = re(f, Aj);
  re(p, "#"), Ot(p, Fp, f);
  const h = [[Zr, a], [Yr, o]], m = [[Zr, null], [Os, s], [Yr, i]];
  for (let g = 0; g < qd.length; g++)
    Ao(t, qd[g], hm, eo, h);
  for (let g = 0; g < Gd.length; g++)
    Ao(t, Gd[g], mm, pm, m);
  Oi(hm, {
    tld: !0,
    ascii: !0
  }, e), Oi(mm, {
    utld: !0,
    alpha: !0
  }, e), Ao(t, "file", mu, eo, h), Ao(t, "mailto", mu, eo, h), Ao(t, "http", ba, eo, h), Ao(t, "https", ba, eo, h), Ao(t, "ftp", ba, eo, h), Ao(t, "ftps", ba, eo, h), Oi(mu, {
    scheme: !0,
    ascii: !0
  }, e), Oi(ba, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((g, v) => g[0] > v[0] ? 1 : -1);
  for (let g = 0; g < n.length; g++) {
    const v = n[g][0], C = n[g][1] ? {
      [_j]: !0
    } : {
      [Sj]: !0
    };
    v.indexOf("-") >= 0 ? C[fm] = !0 : Zr.test(v) ? Yr.test(v) ? C[dl] = !0 : C[um] = !0 : C[dm] = !0, s2(t, v, v, C);
  }
  return s2(t, "localhost", Ql, {
    ascii: !0
  }), t.jd = new wn(Tc), {
    start: t,
    tokens: us({
      groups: e
    }, n5)
  };
}
function r5(n, e) {
  const t = Nj(e.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = t.length, o = [];
  let i = 0, a = 0;
  for (; a < r; ) {
    let s = n, l = null, d = 0, u = null, f = -1, p = -1;
    for (; a < r && (l = s.go(t[a])); )
      s = l, s.accepts() ? (f = 0, p = 0, u = s) : f >= 0 && (f += t[a].length, p++), d += t[a].length, i += t[a].length, a++;
    i -= f, a -= p, d -= f, o.push({
      t: u.t,
      // token type/name
      v: e.slice(i - d, i),
      // string value
      s: i - d,
      // start index
      e: i
      // end index (excluding)
    });
  }
  return o;
}
function Nj(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let o = n.charCodeAt(r), i, a = o < 55296 || o > 56319 || r + 1 === t || (i = n.charCodeAt(r + 1)) < 56320 || i > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(a), r += a.length;
  }
  return e;
}
function Ao(n, e, t, r, o) {
  let i;
  const a = e.length;
  for (let s = 0; s < a - 1; s++) {
    const l = e[s];
    n.j[l] ? i = n.j[l] : (i = new wn(r), i.jr = o.slice(), n.j[l] = i), n = i;
  }
  return i = new wn(t), i.jr = o.slice(), n.j[e[a - 1]] = i, i;
}
function d2(n) {
  const e = [], t = [];
  let r = 0, o = "0123456789";
  for (; r < n.length; ) {
    let i = 0;
    for (; o.indexOf(n[r + i]) >= 0; )
      i++;
    if (i > 0) {
      e.push(t.join(""));
      for (let a = parseInt(n.substring(r, r + i), 10); a > 0; a--)
        t.pop();
      r += i;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const ed = {
  defaultProtocol: "http",
  events: null,
  format: u2,
  formatHref: u2,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function f1(n, e = null) {
  let t = us({}, ed);
  n && (t = us(t, n instanceof f1 ? n.o : n));
  const r = t.ignoreTags, o = [];
  for (let i = 0; i < r.length; i++)
    o.push(r[i].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = o;
}
f1.prototype = {
  o: ed,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let o = this.o[n];
    return o && (typeof o == "object" ? (o = t.t in o ? o[t.t] : ed[n], typeof o == "function" && r && (o = o(e, t))) : typeof o == "function" && r && (o = o(e, t.t, t)), o);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function u2(n) {
  return n;
}
function o5(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
o5.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = ed.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), o = n.get("tagName", t, e), i = this.toFormattedString(n), a = {}, s = n.get("className", t, e), l = n.get("target", t, e), d = n.get("rel", t, e), u = n.getObj("attributes", t, e), f = n.getObj("events", t, e);
    return a.href = r, s && (a.class = s), l && (a.target = l), d && (a.rel = d), u && us(a, u), {
      tagName: o,
      attributes: a,
      content: i,
      eventListeners: f
    };
  }
};
function Pf(n, e) {
  class t extends o5 {
    constructor(o, i) {
      super(o, i), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const c2 = Pf("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), f2 = Pf("text"), Pj = Pf("nl"), Jd = Pf("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = ed.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== Ql && n[1].t === Vo;
  }
}), Vn = (n) => new wn(n);
function Dj({
  groups: n
}) {
  const e = n.domain.concat([yc, bc, Ro, $c, wc, xc, Cc, kc, zn, i1, fl, _c, Sc, Ec, Ar, Tc, hl, Oc]), t = [Vo, l1, Tr, d1, fl, pl, u1, c1, lc, dc, ul, cl, ic, oc, ac, sc, uc, cc, fc, pc, hc, mc, gc, vc], r = [yc, s1, bc, $c, wc, xc, Cc, kc, zn, ul, cl, fl, _c, Sc, Ec, pl, Ar, Tc, hl, Oc], o = Vn(), i = re(o, hl);
  We(i, r, i), We(i, n.domain, i);
  const a = Vn(), s = Vn(), l = Vn();
  We(o, n.domain, a), We(o, n.scheme, s), We(o, n.slashscheme, l), We(a, r, i), We(a, n.domain, a);
  const d = re(a, Ro);
  re(i, Ro, d), re(s, Ro, d), re(l, Ro, d);
  const u = re(i, Tr);
  We(u, r, i), We(u, n.domain, i);
  const f = Vn();
  We(d, n.domain, f), We(f, n.domain, f);
  const p = re(f, Tr);
  We(p, n.domain, f);
  const h = Vn(c2);
  We(p, n.tld, h), We(p, n.utld, h), re(d, Ql, h);
  const m = re(f, zn);
  re(m, zn, m), We(m, n.domain, f), We(h, n.domain, f), re(h, Tr, p), re(h, zn, m);
  const g = re(h, Vo);
  We(g, n.numeric, c2);
  const v = re(a, zn), $ = re(a, Tr);
  re(v, zn, v), We(v, n.domain, a), We($, r, i), We($, n.domain, a);
  const C = Vn(Jd);
  We($, n.tld, C), We($, n.utld, C), We(C, n.domain, a), We(C, r, i), re(C, Tr, $), re(C, zn, v), re(C, Ro, d);
  const S = re(C, Vo), w = Vn(Jd);
  We(S, n.numeric, w);
  const T = Vn(Jd), A = Vn();
  We(T, e, T), We(T, t, A), We(A, e, T), We(A, t, A), re(C, Ar, T), re(w, Ar, T);
  const N = re(s, Vo), z = re(l, Vo), I = re(z, Ar), P = re(I, Ar);
  We(s, n.domain, a), re(s, Tr, $), re(s, zn, v), We(l, n.domain, a), re(l, Tr, $), re(l, zn, v), We(N, n.domain, T), re(N, Ar, T), re(N, pl, T), We(P, n.domain, T), We(P, e, T), re(P, Ar, T);
  const L = [
    [ul, cl],
    // {}
    [oc, ic],
    // []
    [ac, sc],
    // ()
    [lc, dc],
    // <>
    [uc, cc],
    // （）
    [fc, pc],
    // 「」
    [hc, mc],
    // 『』
    [gc, vc]
    // ＜＞
  ];
  for (let H = 0; H < L.length; H++) {
    const [q, Q] = L[H], ae = re(T, q);
    re(A, q, ae), re(ae, Q, T);
    const de = Vn(Jd);
    We(ae, e, de);
    const ne = Vn();
    We(ae, t), We(de, e, de), We(de, t, ne), We(ne, e, de), We(ne, t, ne), re(de, Q, T), re(ne, Q, T);
  }
  return re(o, Ql, C), re(o, a1, Pj), {
    start: o,
    tokens: n5
  };
}
function Ij(n, e, t) {
  let r = t.length, o = 0, i = [], a = [];
  for (; o < r; ) {
    let s = n, l = null, d = null, u = 0, f = null, p = -1;
    for (; o < r && !(l = s.go(t[o].t)); )
      a.push(t[o++]);
    for (; o < r && (d = l || s.go(t[o].t)); )
      l = null, s = d, s.accepts() ? (p = 0, f = s) : p >= 0 && p++, o++, u++;
    if (p < 0)
      o -= u, o < r && (a.push(t[o]), o++);
    else {
      a.length > 0 && (i.push(Hp(f2, e, a)), a = []), o -= p, u -= p;
      const h = f.t, m = t.slice(o - u, o);
      i.push(Hp(h, e, m));
    }
  }
  return a.length > 0 && i.push(Hp(f2, e, a)), i;
}
function Hp(n, e, t) {
  const r = t[0].s, o = t[t.length - 1].e, i = e.slice(r, o);
  return new n(i, t);
}
const Rj = typeof console < "u" && console && console.warn || (() => {
}), Bj = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", $t = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function Lj() {
  return wn.groups = {}, $t.scanner = null, $t.parser = null, $t.tokenQueue = [], $t.pluginQueue = [], $t.customSchemes = [], $t.initialized = !1, $t;
}
function p2(n, e = !1) {
  if ($t.initialized && Rj(`linkifyjs: already initialized - will not register custom scheme "${n}" ${Bj}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  $t.customSchemes.push([n, e]);
}
function Fj() {
  $t.scanner = Mj($t.customSchemes);
  for (let n = 0; n < $t.tokenQueue.length; n++)
    $t.tokenQueue[n][1]({
      scanner: $t.scanner
    });
  $t.parser = Dj($t.scanner.tokens);
  for (let n = 0; n < $t.pluginQueue.length; n++)
    $t.pluginQueue[n][1]({
      scanner: $t.scanner,
      parser: $t.parser
    });
  return $t.initialized = !0, $t;
}
function p1(n) {
  return $t.initialized || Fj(), Ij($t.parser.start, n, r5($t.scanner.start, n));
}
p1.scan = r5;
function i5(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new f1(t), o = p1(n), i = [];
  for (let a = 0; a < o.length; a++) {
    const s = o[a];
    s.isLink && (!e || s.t === e) && r.check(s) && i.push(s.toFormattedObject(r));
  }
  return i;
}
function Vj(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function zj(n) {
  return new Ct({
    key: new Lt("autolink"),
    appendTransaction: (e, t, r) => {
      const o = e.some((d) => d.docChanged) && !t.doc.eq(r.doc), i = e.some((d) => d.getMeta("preventAutolink"));
      if (!o || i)
        return;
      const { tr: a } = r, s = RL(t.doc, [...e]);
      if (HL(s).forEach(({ newRange: d }) => {
        const u = LL(r.doc, d, (h) => h.isTextblock);
        let f, p;
        if (u.length > 1 ? (f = u[0], p = r.doc.textBetween(f.pos, f.pos + f.node.nodeSize, void 0, " ")) : u.length && r.doc.textBetween(d.from, d.to, " ", " ").endsWith(" ") && (f = u[0], p = r.doc.textBetween(f.pos, d.to, void 0, " ")), f && p) {
          const h = p.split(" ").filter(($) => $ !== "");
          if (h.length <= 0)
            return !1;
          const m = h[h.length - 1], g = f.pos + p.lastIndexOf(m);
          if (!m)
            return !1;
          const v = p1(m).map(($) => $.toObject(n.defaultProtocol));
          if (!Vj(v))
            return !1;
          v.filter(($) => $.isLink).map(($) => ({
            ...$,
            from: g + $.start + 1,
            to: g + $.end + 1
          })).filter(($) => r.schema.marks.code ? !r.doc.rangeHasMark($.from, $.to, r.schema.marks.code) : !0).filter(($) => n.validate($.value)).filter(($) => n.shouldAutoLink($.value)).forEach(($) => {
            K0($.from, $.to, r.doc).some((C) => C.mark.type === n.type) || a.addMark($.from, $.to, n.type.create({
              href: $.href
            }));
          });
        }
      }), !!a.steps.length)
        return a;
    }
  });
}
function jj(n) {
  return new Ct({
    key: new Lt("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var o, i;
        if (r.button !== 0 || !e.editable)
          return !1;
        let a = r.target;
        const s = [];
        for (; a.nodeName !== "DIV"; )
          s.push(a), a = a.parentNode;
        if (!s.find((p) => p.nodeName === "A"))
          return !1;
        const l = hw(e.state, n.type.name), d = r.target, u = (o = d?.href) !== null && o !== void 0 ? o : l.href, f = (i = d?.target) !== null && i !== void 0 ? i : l.target;
        return d && u ? (window.open(u, f), !0) : !1;
      }
    }
  });
}
function Hj(n) {
  return new Ct({
    key: new Lt("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { state: o } = e, { selection: i } = o, { empty: a } = i;
        if (a)
          return !1;
        let s = "";
        r.content.forEach((d) => {
          s += d.textContent;
        });
        const l = i5(s, { defaultProtocol: n.defaultProtocol }).find((d) => d.isLink && d.value === s);
        return !s || !l ? !1 : n.editor.commands.setMark(n.type, {
          href: l.href
        });
      }
    }
  });
}
const Uj = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function mi(n, e) {
  const t = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((r) => {
    const o = typeof r == "string" ? r : r.scheme;
    o && t.push(o);
  }), !n || n.replace(Uj, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const Kj = xo.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        p2(n);
        return;
      }
      p2(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    Lj();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!mi(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!mi(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!mi(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Ht(this.options.HTMLAttributes, n), 0] : [
      "a",
      Ht(this.options.HTMLAttributes, { ...n, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!mi(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!mi(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      qi({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, o = i5(n).filter((i) => i.isLink && this.options.isAllowedUri(i.value, {
              defaultValidate: (a) => !!mi(a, t),
              protocols: t,
              defaultProtocol: r
            }));
            o.length && o.forEach((i) => e.push({
              text: i.value,
              data: {
                href: i.href
              },
              index: i.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(zj({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (r) => this.options.isAllowedUri(r, {
        defaultValidate: (o) => !!mi(o, e),
        protocols: e,
        defaultProtocol: t
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && n.push(jj({
      type: this.type
    })), this.options.linkOnPaste && n.push(Hj({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), n;
  }
}), Wj = Kj.configure({
  openOnClick: !1,
  defaultProtocol: "https"
}).extend({
  addProseMirrorPlugins() {
    const n = this.parent?.() || [], e = Gj(), t = Jj();
    return [
      ...n,
      e,
      t
    ];
  }
});
function qj() {
  const n = `
    relative z-[1] break-words text-primary underline transition
    focus-visible:text-foreground focus-visible:outline-none
    hover:text-foreground
  `, e = Ic({
    tag: "span",
    paragraph: "default"
  });
  return G(
    n,
    e
  );
}
function Gj() {
  return new Ct({
    key: new Lt("linkDecorations"),
    props: {
      decorations: (n) => {
        const { doc: e } = n, t = [];
        return e.descendants((r, o) => {
          r.marks.forEach((i) => {
            i.type.name === "link" && t.push(
              an.inline(o, o + r.nodeSize, {
                class: qj()
              })
            );
          });
        }), kt.create(e, t);
      }
    }
  });
}
function Jj() {
  return new Ct({
    key: new Lt("linkSelectionOnClick"),
    props: {
      handleClick: (n, e) => {
        const { schema: t, doc: r, tr: o } = n.state, i = Of(r.resolve(e), t.marks.link);
        if (!i)
          return !1;
        const a = r.resolve(i.from), s = r.resolve(i.to), l = o.setSelection(new Fe(a, s));
        n.dispatch(l);
      }
    }
  });
}
const Zj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BulletList: xj,
  Link: Wj
}, Symbol.toStringTag, { value: "Module" })), Yj = /* @__PURE__ */ _({
  __name: "HeadingNodeViewWrapper",
  props: r1,
  setup(n) {
    const e = M(() => n.node.attrs.level ? `h${n.node.attrs.level}` : "p");
    return (t, r) => (b(), k(c(n1), { class: "vue-component" }, {
      default: y(() => [
        x(c(Oe), { tag: e.value }, {
          default: y(() => [
            x(c(t1), { as: "span" })
          ]),
          _: 1
        }, 8, ["tag"])
      ]),
      _: 1
    }));
  }
}), Xj = /* @__PURE__ */ _({
  __name: "ListItemNodeViewWrapper",
  props: r1,
  setup(n) {
    const e = M(() => Ic({
      tag: "li",
      paragraph: "default"
    }));
    return (t, r) => (b(), k(c(n1), {
      as: "li",
      class: fe(["ml-4", e.value])
    }, {
      default: y(() => [
        x(c(Oe), { tag: "span" }, {
          default: y(() => [
            x(c(t1), { as: "span" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Qj = /* @__PURE__ */ _({
  __name: "ParagraphNodeViewWrapper",
  props: r1,
  setup(n) {
    const e = M(() => Ic({
      tag: "p",
      paragraph: "default"
    }));
    return (t, r) => (b(), k(c(n1), {
      as: "p",
      class: fe(e.value)
    }, {
      default: y(() => [
        x(c(Oe), { tag: "span" }, {
          default: y(() => [
            x(c(t1), { as: "span" })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), eH = _w.extend({
  addNodeView() {
    return o1(Qj);
  }
}), a5 = bw.extend({
  addNodeView() {
    return o1(Yj);
  }
}), s5 = kw.extend({
  addNodeView() {
    return o1(Xj);
  }
}), tH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Heading: a5,
  ListItem: s5,
  Paragraph: eH
}, Symbol.toStringTag, { value: "Module" }));
const nH = { class: "p-2 text-primary" }, rH = { class: "flex items-center gap-x-0.5" }, oH = ["name", "value"], iH = /* @__PURE__ */ _({
  __name: "RichTextEditor",
  props: {
    modelValue: {},
    placeholder: {},
    name: {},
    id: {},
    ariaInvalid: { type: Boolean },
    ariaDescribedby: {},
    ariaLabel: {},
    class: {},
    disabled: { type: Boolean },
    imageUpload: {}
  },
  emits: ["update:modelValue", "blur", "input", "change"],
  setup(n, { emit: e }) {
    const t = n, r = e, { modelValue: o, imageUpload: i, disabled: a } = at(t);
    a5.configure({
      levels: [2, 3]
    }), s5.configure({
      HTMLAttributes: {
        class: "[&>*]:inline-block"
      }
    });
    const s = nj({
      // editable: disabled.value,
      extensions: [
        yV.configure({
          heading: !1,
          paragraph: !1,
          listItem: !1,
          bulletList: !1
        }),
        lj.configure({
          uploadFn: i?.value?.uploadFn
        }),
        ...Object.values(tH),
        ...Object.values(Zj),
        xF.configure({
          placeholder: t.placeholder ?? "Schreib etwas..."
        })
      ],
      editorProps: {
        attributes: {
          class: "min-h-[300px] max-h-[70dvh] overflow-y-scroll p-4 text-foreground outline-none focus:outline-none",
          "aria-label": t.ariaLabel || "Rich text editor",
          role: "textbox"
        }
      },
      content: o.value,
      onUpdate: ({ editor: d }) => {
        r("update:modelValue", d.getHTML());
      },
      onBlur: () => {
        s?.value?.view.dom.textContent !== "" && r("blur", new Event("blur"));
      }
    }), l = M({
      get() {
        if (!s)
          return "0";
        const u = s.value?.getAttributes("heading")?.level;
        return u === 1 ? "2" : u ? String(u) : "0";
      },
      set(d) {
        if (d === "0") {
          s?.value?.commands.setParagraph();
          return;
        }
        const u = Number(d);
        s?.value?.chain().focus().setHeading({ level: u }).run();
      }
    });
    return vt(() => {
      !o.value || s.value?.getHTML() === o.value || s.value?.commands.setContent(o.value || "", !1);
    }), xr(() => {
      s.value?.destroy();
    }), (d, u) => (b(), D("div", {
      class: fe(["overflow-hiddden min-h-[150px] divide-y rounded-sm border", c(a) ? "opacity-50" : ""])
    }, [
      O("div", nH, [
        O("div", rH, [
          x(c(Nh), {
            size: "sm",
            "aria-label": "Text fett auszeichnen",
            pressed: c(s)?.isActive("bold"),
            onClick: u[0] || (u[0] = (f) => c(s)?.chain().focus().toggleBold().run())
          }, {
            default: y(() => [
              x(c(yj), {
                class: "size-3",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }, 8, ["pressed"]),
          x(c(Nh), {
            size: "sm",
            "aria-label": "Aufzählungsliste auszeichnen",
            pressed: c(s)?.isActive("bulletList"),
            onClick: u[1] || (u[1] = (f) => c(s)?.chain().focus().toggleBulletList().run())
          }, {
            default: y(() => [
              x(c(wj), {
                class: "size-3",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }, 8, ["pressed"]),
          x(WP, { editor: c(s) }, null, 8, ["editor"]),
          x(c(Re), {
            variant: "ghost",
            size: "icon",
            "aria-label": "Bild hinzufügen",
            class: "h-10 rounded-[12px] px-3 py-0 text-sm hover:bg-muted hover:text-muted-foreground",
            onClick: u[2] || (u[2] = (f) => c(s)?.chain().focus().addImage().run())
          }, {
            default: y(() => [
              x(c(mj), {
                size: "3",
                "aria-hidden": !0
              })
            ]),
            _: 1
          }),
          x(XP, { editor: c(s) }, null, 8, ["editor"]),
          x(c(DP), null, {
            default: y(() => [
              x(c(LP), { "as-child": "" }, {
                default: y(() => [
                  x(tf, {
                    variant: "outline",
                    as: "button",
                    class: "relative px-3 py-0.5"
                  }, {
                    default: y(() => [
                      x(c(xs), {
                        "aria-hidden": "true",
                        class: "mr-2"
                      }),
                      O("span", null, U(l.value === "0" ? "Fliesstext" : l.value === "2" ? "Haupttitel" : "Untertitel"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              x(c(IP), {
                class: "w-56",
                "side-offset": 2,
                align: "start"
              }, {
                default: y(() => [
                  x(c(RP), {
                    modelValue: l.value,
                    "onUpdate:modelValue": u[3] || (u[3] = (f) => l.value = f)
                  }, {
                    default: y(() => [
                      x(c(up), { value: "0" }, {
                        default: y(() => u[6] || (u[6] = [
                          K(" Fliesstext ")
                        ])),
                        _: 1
                      }),
                      x(c(up), { value: "2" }, {
                        default: y(() => u[7] || (u[7] = [
                          K(" Haupttitel ")
                        ])),
                        _: 1
                      }),
                      x(c(up), { value: "3" }, {
                        default: y(() => u[8] || (u[8] = [
                          K(" Untertitel ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      x(c(tj), { editor: c(s) }, null, 8, ["editor"]),
      O("input", {
        hidden: "",
        name: d.name,
        type: "text",
        value: c(o),
        onChange: u[4] || (u[4] = (f) => r("change", f)),
        onInput: u[5] || (u[5] = (f) => r("input", f))
      }, null, 40, oH)
    ], 2));
  }
}), MJ = /* @__PURE__ */ _({
  __name: "FormRichTextEditor",
  props: /* @__PURE__ */ Mt({
    name: {},
    placeholder: {},
    description: {},
    ariaDescribedby: {},
    ariaLabel: {},
    imageUpload: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = B(null), t = St(n, "modelValue");
    return (r, o) => (b(), k(c(yr), {
      modelValue: t.value,
      "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
      name: r.name
    }, {
      default: y(({ componentField: i }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            x(c(Fr), null, {
              default: y(() => [
                x(c(iH), j({
                  ref_key: "richTextComponent",
                  ref: e
                }, i, {
                  "image-upload": r.imageUpload,
                  placeholder: r.placeholder,
                  "aria-describedby": r.ariaDescribedby,
                  "aria-label": r.ariaLabel,
                  disabled: r.disabled
                }), null, 16, ["image-upload", "placeholder", "aria-describedby", "aria-label", "disabled"])
              ]),
              _: 2
            }, 1024),
            x(c(_o), null, {
              default: y(() => [
                K(U(r.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue", "name"]));
  }
}), h1 = /* @__PURE__ */ _({
  __name: "Command",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: { type: Function },
    displayValue: { type: Function },
    resetSearchTermOnBlur: { type: Boolean },
    resetSearchTermOnSelect: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(M7), j(c(i), {
      class: c(G)("", t.class)
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), NJ = /* @__PURE__ */ _({
  __name: "ConfirmDialog",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean },
    class: {},
    title: {},
    description: {},
    disabled: { type: Boolean },
    buttonCancelLabel: {},
    buttonConfirmLabel: {},
    buttonConfirmType: {}
  },
  emits: ["update:open", "cancel", "confirm"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Wc), Le(Ve(c(i))), {
      default: y(() => [
        x(c(Df), {
          onInteractOutside: s[2] || (s[2] = (l) => {
            l.preventDefault(), r("cancel");
          })
        }, {
          default: y(() => [
            x(c(g1), null, {
              default: y(() => [
                x(c(c5), null, {
                  default: y(() => [
                    K(U(a.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            a.description ? (b(), k(c(d5), { key: 0 }, {
              default: y(() => [
                K(U(a.description), 1)
              ]),
              _: 1
            })) : X("", !0),
            x(c(u5), null, {
              default: y(() => [
                x(c(Re), {
                  disabled: a.disabled,
                  variant: "ghost",
                  onClick: s[0] || (s[0] = (l) => r("cancel"))
                }, {
                  default: y(() => [
                    K(U(a.buttonCancelLabel || "Abbrechen"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                x(c(Re), {
                  disabled: a.disabled,
                  variant: a.buttonConfirmType,
                  onClick: s[1] || (s[1] = (l) => r("confirm"))
                }, {
                  default: y(() => [
                    K(U(a.buttonConfirmLabel || "Bestätigen"), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "variant"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16));
  }
}), m1 = /* @__PURE__ */ _({
  __name: "Dialog",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean },
    class: {}
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Wc), Le(Ve(c(i))), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), l5 = /* @__PURE__ */ _({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(GC), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Df = /* @__PURE__ */ _({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    to: {},
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Wm), { to: a.to }, {
      default: y(() => [
        x(c(Jm), { class: "fixed inset-0 z-50 bg-black/80 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0" }),
        x(c(Gm), j(c(i), {
          class: c(G)(
            `
            fixed left-1/2 top-1/2 z-50 grid w-full max-w-xl -translate-x-1/2
            -translate-y-1/2 gap-4 border bg-background p-6 shadow-lg
            duration-200
            data-[state=closed]:animate-out data-[state=closed]:fade-out-0
            data-[state=closed]:zoom-out-95
            data-[state=closed]:slide-out-to-left-1/2
            data-[state=closed]:slide-out-to-top-[48%]
            data-[state=open]:animate-in data-[state=open]:fade-in-0
            data-[state=open]:zoom-in-95
            data-[state=open]:slide-in-from-left-1/2
            data-[state=open]:slide-in-from-top-[48%]
            sm:rounded-lg
          `,
            t.class
          )
        }), {
          default: y(() => [
            E(a.$slots, "default"),
            E(a.$slots, "close")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["to"]));
  }
}), d5 = /* @__PURE__ */ _({
  __name: "DialogDescription",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(ZC), j(c(r), {
      class: e.class
    }), {
      default: y(() => [
        x(c(Tx), null, {
          default: y(() => [
            E(o.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), u5 = /* @__PURE__ */ _({
  __name: "DialogFooter",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(
        c(G)(
          `
          flex flex-col-reverse
          sm:flex-row sm:justify-end sm:gap-x-2
        `,
          e.class
        )
      )
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), g1 = /* @__PURE__ */ _({
  __name: "DialogHeader",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(c(G)(`
      flex flex-col gap-y-1.5 text-center
      sm:text-left
    `, e.class))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), PJ = /* @__PURE__ */ _({
  __name: "DialogRoot",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(Wc), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), DJ = /* @__PURE__ */ _({
  __name: "DialogScrollContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    to: {},
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Wm), null, {
      default: y(() => [
        x(c(Jm), { class: "fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-black/80 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0" }, {
          default: y(() => [
            x(c(Gm), j({
              class: c(G)(
                `
              relative z-50 my-8 grid w-full max-w-lg gap-4 border border-border
              bg-background p-6 shadow-lg duration-200
              md:w-full
              sm:rounded-lg
            `,
                t.class
              )
            }, c(i), {
              onPointerDownOutside: s[0] || (s[0] = (l) => {
                const d = l.detail.originalEvent, u = d.target;
                (d.offsetX > u.clientWidth || d.offsetY > u.clientHeight) && l.preventDefault();
              })
            }), {
              default: y(() => [
                E(a.$slots, "default")
              ]),
              _: 3
            }, 16, ["class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), c5 = /* @__PURE__ */ _({
  __name: "DialogTitle",
  props: {
    asChild: { type: Boolean },
    as: {},
    heading: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(JC), Le(Ve(c(r))), {
      default: y(() => [
        x(c(Oe), {
          tag: o.heading ?? "h2",
          class: fe(o.$props.class)
        }, {
          default: y(() => [
            E(o.$slots, "default")
          ]),
          _: 3
        }, 8, ["tag", "class"])
      ]),
      _: 3
    }, 16));
  }
}), aH = /* @__PURE__ */ _({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(_C), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), sH = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function lH(n, e) {
  return b(), D("svg", sH, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7 .5v13M.5 6.96h13"
    }, null, -1)
  ]));
}
const f5 = { name: "streamline-add-1", render: lH }, IJ = /* @__PURE__ */ _({
  __name: "SimpleDialog",
  props: {
    title: {},
    description: {},
    heading: {},
    to: {},
    class: {}
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const r = ea(e);
    return (o, i) => (b(), k(c(m1), Le(Ve(c(r))), {
      default: y(() => [
        x(c(aH), { "as-child": "" }, {
          default: y(() => [
            E(o.$slots, "trigger")
          ]),
          _: 3
        }),
        x(c(Df), {
          class: fe(o.$props.class),
          to: o.to
        }, {
          default: y(() => [
            x(c(l5), { class: "absolute right-4 top-4 rounded-sm disabled:pointer-events-none focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2" }, {
              default: y(() => [
                E(o.$slots, "close-icon", {}, () => [
                  x(c(f5), { class: "rotate-45" })
                ]),
                i[0] || (i[0] = O("span", { class: "sr-only" }, "Close", -1))
              ]),
              _: 3
            }),
            o.title || o.description ? (b(), k(c(g1), { key: 0 }, {
              default: y(() => [
                o.title ? (b(), k(c(c5), {
                  key: 0,
                  heading: o.heading,
                  "as-child": ""
                }, {
                  default: y(() => [
                    K(U(o.title), 1)
                  ]),
                  _: 1
                }, 8, ["heading"])) : X("", !0),
                o.description ? (b(), k(c(d5), {
                  key: 1,
                  "as-child": ""
                }, {
                  default: y(() => [
                    K(U(o.description), 1)
                  ]),
                  _: 1
                })) : X("", !0)
              ]),
              _: 1
            })) : X("", !0),
            o.$slots.content ? E(o.$slots, "content", { key: 1 }) : X("", !0),
            o.$slots.footer ? (b(), k(c(u5), { key: 2 }, {
              default: y(() => [
                E(o.$slots, "footer")
              ]),
              _: 3
            })) : X("", !0)
          ]),
          _: 3
        }, 8, ["class", "to"])
      ]),
      _: 3
    }, 16));
  }
}), RJ = /* @__PURE__ */ _({
  __name: "CommandDialog",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(m1), Le(Ve(c(o))), {
      default: y(() => [
        x(c(Df), { class: "overflow-hidden p-0 shadow-lg" }, {
          default: y(() => [
            x(h1, { class: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]_svg]:size-5 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3" }, {
              default: y(() => [
                E(i.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), p5 = /* @__PURE__ */ _({
  __name: "CommandEmpty",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(F7), j(t.value, {
      class: c(G)("py-6 text-center text-sm", e.class)
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), dH = /* @__PURE__ */ _({
  __name: "CommandGroup",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {},
    heading: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(D7), j(t.value, {
      class: c(G)(`
      overflow-hidden p-1
      [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5
      [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium
      [&_[cmdk-group-heading]]:text-muted-foreground
    `, e.class)
    }), {
      default: y(() => [
        r.heading ? (b(), k(c(I7), {
          key: 0,
          class: "px-2 py-1.5 text-xs font-medium text-muted-foreground"
        }, {
          default: y(() => [
            K(U(r.heading), 1)
          ]),
          _: 1
        })) : X("", !0),
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), h5 = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CommandInput",
  props: {
    type: {},
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const t = pt(n);
    return (r, o) => (b(), k(c(N7), j({ ...c(t), ...r.$attrs }, {
      class: r.$attrs.class
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), m5 = /* @__PURE__ */ _({
  __name: "CommandItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["select"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(H7), j(c(i), {
      class: c(G)(`
      relative my-0.5 flex cursor-default select-none items-center rounded-xs
      px-2 py-1.5 text-sm outline-none
      data-[disabled]:pointer-events-none data-[disabled]:opacity-50
      data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground
      data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground
    `, t.class)
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), uH = { role: "presentation" }, g5 = /* @__PURE__ */ _({
  __name: "CommandList",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean },
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(L7), j(c(i), {
      class: c(G)(`
      mt-2 max-h-72 overflow-y-auto overflow-x-hidden rounded-sm border
      bg-popover p-2
    `, t.class)
    }), {
      default: y(() => [
        O("div", uH, [
          E(a.$slots, "default")
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), BJ = /* @__PURE__ */ _({
  __name: "CommandSeparator",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(U7), j(t.value, {
      class: c(G)("-mx-1 h-px bg-border", e.class)
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), LJ = /* @__PURE__ */ _({
  __name: "CommandShortcut",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("span", {
      class: fe(c(G)("ml-auto text-xs tracking-widest text-muted-foreground", e.class))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), FJ = /* @__PURE__ */ _({
  __name: "SimpleCommand",
  props: /* @__PURE__ */ Mt({
    label: {},
    items: {},
    emptyText: {}
  }, {
    modelValue: { type: [String, Number, Boolean, Object] },
    modelModifiers: {},
    searchTerm: {},
    searchTermModifiers: {},
    open: { type: Boolean },
    openModifiers: {}
  }),
  emits: ["update:modelValue", "update:searchTerm", "update:open"],
  setup(n) {
    const e = n, t = St(n, "modelValue"), r = St(n, "searchTerm"), o = St(n, "open"), i = M(() => t.value ? `${e.label}: ${t.value.label}` : e.label);
    function a(s, l) {
      return s.filter((d) => d.label.toLowerCase().includes(l.toLowerCase()));
    }
    return (s, l) => (b(), k(c(h1), {
      modelValue: t.value,
      "onUpdate:modelValue": l[3] || (l[3] = (d) => t.value = d),
      "search-term": r.value,
      "onUpdate:searchTerm": l[4] || (l[4] = (d) => r.value = d),
      open: o.value,
      "onUpdate:open": l[5] || (l[5] = (d) => o.value = d),
      "filter-function": a,
      "as-child": ""
    }, {
      default: y(() => [
        x(c(h5), { "as-child": "" }, {
          default: y(() => [
            x(c(Rt), {
              modelValue: r.value,
              "onUpdate:modelValue": l[0] || (l[0] = (d) => r.value = d),
              class: "w-full",
              label: i.value,
              onFocus: l[1] || (l[1] = (d) => o.value = !o.value)
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }),
        x(c(g5), null, {
          default: y(() => [
            x(c(p5), null, {
              default: y(() => [
                K(U(s.emptyText), 1)
              ]),
              _: 1
            }),
            (b(!0), D(Me, null, it(s.items, (d) => (b(), k(c(m5), {
              key: d.value,
              value: d,
              "aria-label": d.label,
              onSelect: l[2] || (l[2] = (u) => {
                typeof u.detail.value == "string" && u.detail.value;
              })
            }, {
              default: y(() => [
                K(U(d.label), 1)
              ]),
              _: 2
            }, 1032, ["value", "aria-label"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "search-term", "open"]));
  }
}), cH = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function fH(n, e) {
  return b(), D("svg", cH, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.467 3.727c.289.189.37.576.181.865l-4.25 6.5a.625.625 0 0 1-.944.12l-2.75-2.5a.625.625 0 0 1 .841-.925l2.208 2.007l3.849-5.886a.625.625 0 0 1 .865-.181",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v5 = { name: "radix-icons-check", render: fH }, VJ = /* @__PURE__ */ _({
  __name: "FormSearchableSelect",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    commandEmpty: {},
    description: {},
    placeholder: {},
    items: {},
    modelKey: {},
    labelKey: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {},
    query: {},
    queryModifiers: {}
  }),
  emits: ["update:modelValue", "update:query"],
  setup(n, { expose: e }) {
    const t = B(!1);
    e({
      closeCommand: () => {
        t.value = !1;
      }
    });
    const r = St(n, "modelValue"), o = St(n, "query");
    function i(a) {
      if (!a)
        return "";
      const s = n.labelKey || n.modelKey, l = a[s];
      return Array.isArray(l) ? l.toString() : String(l);
    }
    return (a, s) => (b(), k(c(yr), {
      modelValue: r.value,
      "onUpdate:modelValue": s[2] || (s[2] = (l) => r.value = l),
      name: a.name
    }, {
      default: y(({ componentField: l }) => [
        x(c(br), { class: "flex flex-col" }, {
          default: y(() => [
            x(c(uf), {
              open: t.value,
              "onUpdate:open": s[1] || (s[1] = (d) => t.value = d)
            }, {
              default: y(() => [
                x(c(ff), { "as-child": "" }, {
                  default: y(() => [
                    x(c(Fr), null, {
                      default: y(() => [
                        x(c(Rt), j({
                          label: a.label,
                          "aria-label": a.label,
                          type: "button",
                          role: "combobox",
                          class: c(G)("text-left", c(v0)({ type: "text" })),
                          disabled: a.disabled
                        }, l), {
                          "inline-button": y(() => [
                            x(c(xs), { class: "ml-2 size-4 shrink-0 opacity-50" })
                          ]),
                          _: 2
                        }, 1040, ["label", "aria-label", "class", "disabled"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                x(c(cf), {
                  class: "p-0",
                  align: "start"
                }, {
                  default: y(() => [
                    x(c(h1), {
                      "search-term": o.value,
                      "onUpdate:searchTerm": s[0] || (s[0] = (d) => o.value = d),
                      "reset-search-term-on-blur": !0
                    }, {
                      default: y(() => [
                        x(c(h5), {
                          class: "border-none bg-transparent px-2.5 pb-0 pt-3 focus:outline-none",
                          placeholder: a.placeholder
                        }, null, 8, ["placeholder"]),
                        x(c(p5), null, {
                          default: y(() => [
                            K(U(a.commandEmpty), 1)
                          ]),
                          _: 1
                        }),
                        x(c(g5), { class: "border-none p-0" }, {
                          default: y(() => [
                            x(c(dH), { align: "start" }, {
                              default: y(() => [
                                (b(!0), D(Me, null, it(a.items, (d) => (b(), k(c(m5), {
                                  key: d.toString(),
                                  value: d[a.labelKey || a.modelKey],
                                  onSelect: () => {
                                    r.value = d[a.modelKey];
                                  }
                                }, {
                                  default: y(() => [
                                    K(U(i(d)) + " ", 1),
                                    x(c(v5), {
                                      class: fe(c(G)("ml-auto size-4", String(d[a.modelKey]) === String(r.value) ? `
                      opacity-100
                    ` : "opacity-0"))
                                    }, null, 8, ["class"])
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onSelect"]))), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["search-term"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["open"]),
            a.description ? (b(), k(c(_o), { key: 0 }, {
              default: y(() => [
                K(U(a.description), 1)
              ]),
              _: 1
            })) : X("", !0),
            x(c(So))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue", "name"]));
  }
}), pH = /* @__PURE__ */ _({
  __name: "Select",
  props: /* @__PURE__ */ Mt({
    id: {},
    label: {},
    items: {},
    groups: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = St(n, "modelValue");
    return (r, o) => (b(), k(c(gH), j(e, {
      modelValue: t.value,
      "onUpdate:modelValue": o[0] || (o[0] = (i) => t.value = i),
      "aria-label": r.label
    }), {
      default: y(() => [
        x(c(CH), {
          id: r.id,
          label: r.label
        }, {
          default: y(() => [
            x(c(kH), {
              placeholder: r.label,
              class: "group-data-[placeholder]:text-transparent"
            }, null, 8, ["placeholder"])
          ]),
          _: 1
        }, 8, ["id", "label"]),
        r.groups ? (b(), k(c(h2), { key: 0 }, {
          default: y(() => [
            (b(!0), D(Me, null, it(r.groups, (i) => (b(), k(c(hH), {
              key: i.groupLabel
            }, {
              default: y(() => [
                x(c(mH), null, {
                  default: y(() => [
                    K(U(i.groupLabel), 1)
                  ]),
                  _: 2
                }, 1024),
                (b(!0), D(Me, null, it(i.items, (a) => (b(), k(c(m2), {
                  key: a.value,
                  value: a.value
                }, {
                  default: y(() => [
                    K(U(a.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          _: 1
        })) : r.items ? (b(), k(c(h2), { key: 1 }, {
          default: y(() => [
            (b(!0), D(Me, null, it(r.items, (i) => (b(), k(c(m2), {
              key: i.value,
              value: i.value
            }, {
              default: y(() => [
                K(U(i.label), 1)
              ]),
              _: 2
            }, 1032, ["value"]))), 128))
          ]),
          _: 1
        })) : X("", !0)
      ]),
      _: 1
    }, 16, ["modelValue", "aria-label"]));
  }
}), h2 = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectContent",
  props: {
    forceMount: { type: Boolean },
    position: { default: "popper" },
    bodyLock: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["closeAutoFocus", "escapeKeyDown", "pointerDownOutside"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(l_), null, {
      default: y(() => [
        x(c(g_), j({ ...c(i), ...a.$attrs }, {
          class: c(G)(
            `
          relative z-50 max-h-96 min-w-32 overflow-hidden rounded-sm border
          bg-popover text-popover-foreground shadow-md
          data-[side=bottom]:slide-in-from-top-2
          data-[side=left]:slide-in-from-right-2
          data-[side=right]:slide-in-from-left-2
          data-[side=top]:slide-in-from-bottom-2
          data-[state=closed]:animate-out data-[state=closed]:fade-out-0
          data-[state=closed]:zoom-out-95
          data-[state=open]:animate-in data-[state=open]:fade-in-0
          data-[state=open]:zoom-in-95
        `,
            a.position === "popper" && `
            data-[side=bottom]:translate-y-1
            data-[side=left]:-translate-x-1
            data-[side=right]:translate-x-1
            data-[side=top]:-translate-y-1
          `,
            t.class
          )
        }), {
          default: y(() => [
            x(c(wH), { class: "py-4" }),
            x(c(__), {
              class: fe(c(G)("p-1", a.position === "popper" && `
          h-[--radix-select-trigger-height] w-full
          min-w-[--radix-select-trigger-width]
        `))
            }, {
              default: y(() => [
                E(a.$slots, "default")
              ]),
              _: 3
            }, 8, ["class"]),
            x(c(vH), { class: "py-4" })
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), hH = /* @__PURE__ */ _({
  __name: "SelectGroup",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(x_), j({
      class: c(G)("w-full p-1", e.class)
    }, t.value), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), m2 = /* @__PURE__ */ _({
  __name: "SelectItem",
  props: {
    value: {},
    class: {},
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(b_), j(c(r), {
      class: c(G)(
        `
          relative my-0.5 flex w-full cursor-default select-none items-center
          rounded-sm p-2 text-sm outline-none
          data-[disabled]:pointer-events-none data-[disabled]:opacity-50
          data-[state=checked]:bg-accent
          data-[state=checked]:text-accent-foreground
          focus:bg-accent focus:text-accent-foreground
        `,
        e.class
      )
    }), {
      default: y(() => [
        x(c(k_), null, {
          default: y(() => [
            E(o.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), mH = /* @__PURE__ */ _({
  __name: "SelectLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(C_), {
      class: fe(c(G)("px-2 py-1.5 text-sm font-semibold", e.class))
    }, {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), zJ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectMiniTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    id: {},
    label: {},
    class: {}
  },
  setup(n) {
    const e = n, t = Dc(), r = M(() => {
      const { class: i, id: a, ...s } = e;
      return {
        ...t,
        ...s
      };
    }), o = M(() => e.id ?? e.label.toLowerCase().replace(/[^a-z0-9]/g, ""));
    return (i, a) => (b(), k(c(e3), j({
      id: o.value,
      "aria-label": i.label
    }, r.value, {
      class: c(G)(`
      group relative flex w-full items-center justify-between rounded-sm border
      border-border bg-background p-2 text-base transition-all
      data-[state=open]:outline-none data-[state=open]:outline-2
      data-[state=open]:outline-offset-2 data-[state=open]:outline-primary
      focus:outline-none
    `, e.class)
    }), {
      default: y(() => [
        E(i.$slots, "default", {}, () => [
          x(c(n3), {
            class: "group-data-[placeholder]:text-muted-foreground",
            placeholder: i.label
          }, null, 8, ["placeholder"])
        ]),
        x(c(xs), { class: "float-right" })
      ]),
      _: 3
    }, 16, ["id", "aria-label", "class"]));
  }
}), gH = /* @__PURE__ */ _({
  __name: "SelectRoot",
  props: {
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    defaultValue: {},
    modelValue: {},
    dir: {},
    name: {},
    autocomplete: {},
    disabled: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["update:modelValue", "update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(i_), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), vH = /* @__PURE__ */ _({
  __name: "SelectScrollDownButton",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(E_), j(c(r), {
      class: c(G)("flex cursor-default items-center justify-center py-3", e.class)
    }), {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          x(c(xs), { class: "size-4" })
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), yH = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function bH(n, e) {
  return b(), D("svg", yH, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.135 8.842a.5.5 0 0 0 .707.023L7.5 5.435l3.658 3.43a.5.5 0 0 0 .684-.73l-4-3.75a.5.5 0 0 0-.684 0l-4 3.75a.5.5 0 0 0-.023.707",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $H = { name: "radix-icons-chevron-up", render: bH }, wH = /* @__PURE__ */ _({
  __name: "SelectScrollUpButton",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(S_), j(c(r), {
      class: c(G)("flex cursor-default items-center justify-center py-3", e.class)
    }), {
      default: y(() => [
        E(o.$slots, "default", {}, () => [
          x(c($H), { class: "size-4" })
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), xH = ["for"], CH = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "SelectTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    id: {},
    label: {},
    class: {}
  },
  setup(n) {
    const e = n;
    Ia.push(
      "data-[state=open]:outline",
      "data-[state=open]:outline-2",
      "data-[state=open]:outline-offset-2",
      "data-[state=open]:outline-primary",
      "data-[state=open]:outline-none"
    );
    const t = Dc(), r = M(() => {
      const { class: o, id: i, ...a } = e;
      return {
        ...t,
        ...a
      };
    });
    return (o, i) => (b(), k(c(e3), j(r.value, {
      "aria-label": o.label,
      class: c(G)(`
      group relative flex w-full items-center justify-between rounded-sm border
      border-border bg-background px-4 pb-2 pt-6 text-base transition-all
      @lg:pb-3 @lg:pt-7 @lg:data-[placeholder]:py-5
      data-[placeholder]:py-5
      focus:outline-none
    `, c(Ia), e.class)
    }), {
      default: y(() => [
        O("label", {
          for: o.id,
          class: "absolute left-4 top-2 text-xs text-muted-foreground transition-all @lg:group-data-[placeholder]:text-base group-data-[placeholder]:top-5 group-data-[placeholder]:text-sm hover:cursor-pointer"
        }, U(o.label), 9, xH),
        E(o.$slots, "default"),
        x(c(xs), { class: "absolute right-4 top-5 @lg:top-6 @lg:group-data-[placeholder]:top-6" })
      ]),
      _: 3
    }, 16, ["aria-label", "class"]));
  }
}), kH = /* @__PURE__ */ _({
  __name: "SelectValue",
  props: {
    placeholder: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(n3), j(e, { class: "float-left text-left text-foreground" }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), jJ = /* @__PURE__ */ _({
  __name: "FormSelect",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {},
    groups: {},
    items: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return (t, r) => (b(), k(c(yr), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      name: t.name
    }, {
      default: y(({ componentField: o }) => [
        x(c(br), null, {
          default: y(() => [
            x(c(So)),
            x(c(Fr), null, {
              default: y(() => [
                x(c(pH), j({ label: t.label }, o, {
                  groups: t.groups,
                  items: t.items
                }), null, 16, ["label", "groups", "items"])
              ]),
              _: 2
            }, 1024),
            x(c(_o), null, {
              default: y(() => [
                t.$slots.description ? E(t.$slots, "description", { key: 0 }, () => [
                  K(U(t.description), 1)
                ]) : X("", !0)
              ]),
              _: 3
            })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["modelValue", "name"]));
  }
}), _H = { class: "relative @container" }, SH = ["id", "placeholder"], EH = ["for"], OH = /* @__PURE__ */ _({
  __name: "Textarea",
  props: /* @__PURE__ */ Mt({
    id: {},
    name: {},
    class: {},
    label: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = St(n, "modelValue"), r = Dc(), o = M(() => {
      const { class: a, id: s, ...l } = e;
      return {
        ...r,
        ...l
      };
    }), i = M(() => e.id ?? e.label.toLowerCase().replace(/[^a-z0-9]/g, ""));
    return (a, s) => (b(), D("div", _H, [
      hr(O("textarea", j(o.value, {
        id: i.value,
        "onUpdate:modelValue": s[0] || (s[0] = (l) => t.value = l),
        placeholder: a.label,
        rows: "4",
        class: c(G)(c(v0)({ type: "text" }), e.class ?? "")
      }), null, 16, SH), [
        [P2, t.value]
      ]),
      O("label", {
        class: fe(c(G)(c(t$))),
        for: i.value
      }, U(a.label), 11, EH)
    ]));
  }
}), HJ = /* @__PURE__ */ _({
  __name: "FormTextarea",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return (t, r) => (b(), k(c(n$), {
      modelValue: e.value,
      "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
      name: t.name,
      label: t.label
    }, {
      input: y(({ componentField: o }) => [
        x(c(OH), j({ label: t.label }, o), null, 16, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue", "name", "label"]));
  }
}), UJ = /* @__PURE__ */ _({
  __name: "InlineFormInput",
  props: /* @__PURE__ */ Mt({
    name: {},
    label: {},
    description: {},
    type: {},
    disabled: { type: Boolean },
    buttonLabel: {},
    buttonClass: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = n, t = St(n, "modelValue");
    return (r, o) => (b(), k(c(n$), Le(Ve(e)), {
      input: y(({ componentField: i }) => [
        x(c(Rt), j({
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (a) => t.value = a),
          label: r.label,
          type: r.type ?? "text"
        }, i), {
          inlineButton: y(() => [
            x(c(Re), {
              class: fe(c(G)("absolute inset-y-0 right-0 rounded-tl-none", r.buttonClass)),
              type: "submit"
            }, {
              default: y(() => [
                K(U(r.buttonLabel), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 2
        }, 1040, ["modelValue", "label", "type"])
      ]),
      _: 1
    }, 16));
  }
}), TH = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function AH(n, e) {
  return b(), D("svg", TH, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.854 3.146a.5.5 0 0 1 0 .708L3.707 7H12.5a.5.5 0 0 1 0 1H3.707l3.147 3.146a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const kd = { name: "radix-icons-arrow-left", render: AH }, MH = /* @__PURE__ */ _({
  __name: "Alert",
  props: {
    class: {},
    variant: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(c(G)(c(PH)({ variant: t.variant }), e.class)),
      role: "alert"
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), NH = /* @__PURE__ */ _({
  __name: "AlertDescription",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(c(G)(`
      text-sm
      [&_p]:leading-relaxed
    `, e.class))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), KJ = /* @__PURE__ */ _({
  __name: "AlertTitle",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("p", {
      class: fe(c(G)("text-sm font-bold", e.class))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), PH = tn(
  `
    relative w-full rounded-md border p-8
    [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground
    [&>svg+div]:translate-y-[-3px]
    [&>svg~*]:pl-7
  `,
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: `
            border-destructive/50 text-destructive
            [&>svg]:text-destructive
            dark:border-destructive
          `,
        success: `
          bg-success/50 text-foreground
          [&>svg]:text-success
          dark:border-success dark:bg-success/20
        `,
        warning: `
          bg-warning/50 text-foreground
          [&>svg]:text-warning
          dark:border-warning dark:bg-warning/20
        `
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), DH = ["data-theme"], Ac = /* @__PURE__ */ _({
  __name: "Logo",
  props: {
    class: {},
    theme: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 139 39",
      fill: "none",
      "data-theme": t.theme ? t.theme : "",
      class: fe(c(G)(e.class))
    }, r[0] || (r[0] = [
      Cm('<path class="text-primary" fill="currentColor" d="M22.8449 0H18.5291C12.7455 0 8.0459 4.7291 8.0459 10.0669V15.9599H13.7083V10.4214C13.7083 7.55853 16.0648 5.61873 18.5829 5.61873H22.8516V0H22.8449Z"></path><path d="M-0.000102998 21.6255V27.1238C-0.000102998 32.8696 4.76009 37.5385 10.133 37.5385H21.0673V31.9131H10.4898C7.60812 31.9131 5.65557 29.572 5.65557 27.0703V21.6188H-0.00683594L-0.000102998 21.6255Z" fill="currentColor" class="text-primary"></path><path d="M43.596 33.8528C43.6297 34.3077 43.8182 34.709 44.1616 35.0702C44.505 35.4314 45.0234 35.612 45.7169 35.612C46.2353 35.612 46.6191 35.4983 46.875 35.2709C47.1241 35.0435 47.252 34.7759 47.252 34.4615C47.252 34.194 47.1577 33.9665 46.9692 33.7726C46.7807 33.5786 46.4575 33.4314 45.9997 33.3378L44.4646 32.9833C43.3334 32.7358 42.5053 32.301 41.9868 31.6856C41.4684 31.0702 41.2058 30.3545 41.2058 29.5451C41.2058 29.0301 41.3135 28.5418 41.5357 28.0802C41.7579 27.6187 42.0609 27.2241 42.4447 26.8829C42.8285 26.5485 43.2863 26.2809 43.8115 26.0736C44.3366 25.8729 44.9157 25.7659 45.5418 25.7659C46.3565 25.7659 47.05 25.8796 47.6156 26.107C48.1811 26.3344 48.639 26.6221 48.9958 26.9632C49.3527 27.3043 49.6153 27.6722 49.7836 28.0535C49.9586 28.4348 50.0596 28.7826 50.0933 29.097L47.4742 29.6856C47.4405 29.5117 47.3934 29.3378 47.3193 29.1572C47.2453 28.9766 47.1375 28.8093 46.9759 28.6555C46.8211 28.5017 46.6258 28.3746 46.3969 28.2809C46.168 28.1873 45.8919 28.1405 45.562 28.1405C45.1513 28.1405 44.8012 28.2475 44.5117 28.4682C44.2222 28.6889 44.074 28.9632 44.074 29.291C44.074 29.5719 44.175 29.7993 44.3703 29.9732C44.5656 30.1471 44.8214 30.2609 45.1379 30.3277L46.7874 30.6823C47.932 30.9164 48.7938 31.3512 49.3661 31.9933C49.9384 32.6354 50.228 33.3779 50.228 34.2207C50.228 34.6889 50.1404 35.1505 49.9586 35.6053C49.7768 36.0602 49.5008 36.4615 49.1238 36.8227C48.7467 37.1839 48.2754 37.4716 47.7098 37.6923C47.1443 37.913 46.4844 38.02 45.7303 38.02C44.8483 38.02 44.1144 37.893 43.5152 37.6455C42.916 37.398 42.4312 37.0903 42.0542 36.7291C41.6771 36.3679 41.4011 35.9866 41.2193 35.5719C41.0375 35.1572 40.9298 34.7893 40.9028 34.4615L43.5893 33.8729L43.596 33.8528Z" fill="currentColor" class="text-primary"></path><path d="M57.4656 25.7726C58.3274 25.7726 59.1354 25.9264 59.8827 26.2274C60.6301 26.5351 61.2764 26.9565 61.8151 27.4916C62.3537 28.0335 62.7846 28.6756 63.0876 29.4248C63.3906 30.1739 63.5454 30.9967 63.5454 31.8863C63.5454 32.7759 63.3906 33.592 63.0876 34.3345C62.7779 35.0769 62.3537 35.7191 61.8151 36.2676C61.2697 36.8161 60.6301 37.2375 59.8827 37.5452C59.1354 37.8529 58.3274 38 57.4656 38C56.6038 38 55.7958 37.8462 55.0485 37.5452C54.3011 37.2375 53.6547 36.8161 53.1161 36.2676C52.5707 35.7191 52.1466 35.0769 51.8436 34.3345C51.5339 33.592 51.3857 32.7759 51.3857 31.8863C51.3857 30.9967 51.5406 30.1739 51.8436 29.4248C52.1533 28.6756 52.5707 28.0335 53.1161 27.4916C53.6615 26.9498 54.3011 26.5284 55.0485 26.2274C55.7958 25.9197 56.597 25.7726 57.4656 25.7726ZM57.4656 35.1639C57.8426 35.1639 58.2129 35.0903 58.5765 34.9498C58.9401 34.8094 59.2498 34.602 59.5191 34.3278C59.7885 34.0535 60.0039 33.7124 60.1655 33.311C60.3271 32.9097 60.4146 32.4281 60.4146 31.8796C60.4146 31.3311 60.3338 30.8562 60.1655 30.4482C59.9972 30.0401 59.7817 29.7057 59.5191 29.4314C59.2498 29.1572 58.9401 28.9498 58.5765 28.8094C58.2129 28.6689 57.8426 28.602 57.4656 28.602C57.0885 28.602 56.7182 28.6689 56.3547 28.8094C55.9911 28.9498 55.6814 29.1572 55.412 29.4314C55.1427 29.7057 54.9273 30.0468 54.7657 30.4482C54.5974 30.8562 54.5166 31.3311 54.5166 31.8796C54.5166 32.4281 54.5974 32.903 54.7657 33.311C54.934 33.7191 55.1495 34.0535 55.412 34.3278C55.6814 34.602 55.9911 34.8094 56.3547 34.9498C56.7182 35.0903 57.0885 35.1639 57.4656 35.1639Z" fill="currentColor" class="text-primary"></path><path d="M64.7035 37.6455V34.9031L70.1976 28.8094H64.8449V26.1138H74.2037V28.7158L68.5413 34.9231H74.2912V37.6389H64.6968L64.7035 37.6455Z" fill="currentColor" class="text-primary"></path><path d="M75.9946 22.3546C75.9946 21.8061 76.1831 21.3445 76.5602 20.97C76.9372 20.5954 77.3951 20.4081 77.927 20.4081C78.4589 20.4081 78.9369 20.5954 79.3072 20.97C79.6775 21.3445 79.8593 21.8061 79.8593 22.3546C79.8593 22.8696 79.6775 23.3178 79.3072 23.6924C78.9369 24.0669 78.4791 24.2542 77.927 24.2542C77.3749 24.2542 76.9372 24.0669 76.5602 23.6924C76.1831 23.3178 75.9946 22.8696 75.9946 22.3546ZM76.3717 37.6455V26.1205H79.5092V37.6455H76.3717Z" fill="currentColor" class="text-primary"></path><path d="M81.6772 34.5083C81.6772 33.9933 81.7648 33.5384 81.9466 33.1371C82.1284 32.7357 82.3775 32.3946 82.6872 32.0936C83.0036 31.7993 83.3672 31.5652 83.7847 31.3913C84.2021 31.2174 84.6532 31.0969 85.138 31.0167L87.9927 30.5953C88.3227 30.5485 88.5516 30.4481 88.6795 30.301C88.8074 30.1538 88.868 29.9799 88.868 29.7725C88.868 29.3645 88.7064 29.0167 88.3833 28.7157C88.0601 28.4214 87.5686 28.2675 86.9087 28.2675C86.2489 28.2675 85.6833 28.4548 85.3198 28.8294C84.9495 29.204 84.7407 29.6388 84.6936 30.1404L81.9129 29.5518C81.96 29.0969 82.1014 28.6488 82.3371 28.1939C82.5727 27.7391 82.8959 27.3378 83.3066 26.9765C83.7173 26.6153 84.2156 26.3277 84.8148 26.1003C85.414 25.8729 86.1008 25.7592 86.8885 25.7592C87.7975 25.7592 88.5785 25.8796 89.2249 26.1204C89.8712 26.3612 90.3897 26.6822 90.7937 27.0836C91.1976 27.4849 91.4871 27.9464 91.6689 28.4749C91.8507 29.0033 91.9382 29.5585 91.9382 30.1404V35.8127C91.9382 36.1271 91.9517 36.4548 91.9854 36.8093C92.019 37.1638 92.046 37.4381 92.0796 37.6388H89.2047C89.171 37.4849 89.1441 37.2709 89.1239 36.9966C89.0969 36.7224 89.0902 36.4749 89.0902 36.2608C88.794 36.7157 88.3631 37.1103 87.8042 37.4582C87.2454 37.7993 86.5317 37.9732 85.6699 37.9732C85.0572 37.9732 84.5051 37.8729 84.0068 37.6789C83.5086 37.4849 83.0912 37.224 82.7478 36.903C82.4044 36.5819 82.1351 36.214 81.96 35.7993C81.7782 35.3846 81.6907 34.9498 81.6907 34.5016L81.6772 34.5083ZM86.323 35.6588C86.6529 35.6588 86.9693 35.6187 87.2791 35.5317C87.5888 35.4448 87.8581 35.2976 88.0937 35.0836C88.3294 34.8695 88.5179 34.602 88.6593 34.2608C88.8007 33.9264 88.8748 33.4983 88.8748 32.9832V32.4682L86.2556 32.8695C85.8449 32.9297 85.5016 33.0769 85.2322 33.3043C84.9629 33.5317 84.8215 33.8729 84.8215 34.321C84.8215 34.6622 84.9495 34.9765 85.1986 35.2441C85.4477 35.5184 85.8247 35.6521 86.3297 35.6521L86.323 35.6588Z" fill="currentColor" class="text-primary"></path><path d="M94.6245 37.6455V20.689H97.7621V37.6455H94.6245Z" fill="currentColor" class="text-primary"></path><path d="M100.26 22.3546C100.26 21.8061 100.449 21.3445 100.826 20.97C101.203 20.5954 101.661 20.4081 102.193 20.4081C102.725 20.4081 103.203 20.5954 103.573 20.97C103.943 21.3445 104.125 21.8061 104.125 22.3546C104.125 22.8696 103.943 23.3178 103.573 23.6924C103.203 24.0669 102.745 24.2542 102.193 24.2542C101.641 24.2542 101.203 24.0669 100.826 23.6924C100.449 23.3178 100.26 22.8696 100.26 22.3546ZM100.637 37.6455V26.1205H103.775V37.6455H100.637Z" fill="currentColor" class="text-primary"></path><path d="M109.781 37.6454H106.643V26.1203H109.686V27.5518C110.05 26.9565 110.541 26.5217 111.161 26.2407C111.78 25.9598 112.406 25.8193 113.033 25.8193C113.753 25.8193 114.379 25.9397 114.904 26.1805C115.43 26.4213 115.867 26.7491 116.211 27.1504C116.554 27.5585 116.81 28.0401 116.978 28.6019C117.146 29.1638 117.227 29.7591 117.227 30.3812V37.6454H114.09V30.923C114.09 30.2675 113.921 29.719 113.585 29.2842C113.248 28.8494 112.703 28.6287 111.949 28.6287C111.255 28.6287 110.723 28.8561 110.346 29.3177C109.969 29.7792 109.781 30.3478 109.781 31.0167V37.6454Z" fill="currentColor" class="text-primary"></path><path d="M125.32 23.2642C125.145 23.2642 124.963 23.291 124.768 23.3311C124.573 23.3779 124.391 23.4582 124.236 23.5786C124.081 23.699 123.947 23.8595 123.846 24.0602C123.745 24.2609 123.691 24.5284 123.691 24.8562V26.1204H126.31V28.7893H123.691V37.6455H120.533V28.7893H118.601V26.1204H120.533V24.8094C120.533 24.1538 120.634 23.5652 120.829 23.0435C121.024 22.5217 121.307 22.0736 121.678 21.699C122.048 21.3244 122.492 21.0368 123.011 20.8294C123.529 20.6288 124.108 20.5217 124.754 20.5217C125.084 20.5217 125.394 20.5485 125.684 20.5886C125.973 20.6288 126.182 20.689 126.31 20.7558V23.3779C126.229 23.3445 126.115 23.3177 125.96 23.2976C125.805 23.2709 125.589 23.2642 125.32 23.2642Z" fill="currentColor" class="text-primary"></path><path d="M132.821 25.7726C133.682 25.7726 134.49 25.9264 135.238 26.2274C135.985 26.5351 136.631 26.9565 137.17 27.4916C137.709 28.0335 138.14 28.6756 138.443 29.4248C138.746 30.1739 138.9 30.9967 138.9 31.8863C138.9 32.7759 138.746 33.592 138.443 34.3345C138.133 35.0769 137.709 35.7191 137.17 36.2676C136.625 36.8161 135.985 37.2375 135.238 37.5452C134.49 37.8529 133.682 38 132.821 38C131.959 38 131.151 37.8462 130.403 37.5452C129.656 37.2375 129.01 36.8161 128.471 36.2676C127.926 35.7191 127.502 35.0769 127.199 34.3345C126.889 33.592 126.741 32.7759 126.741 31.8863C126.741 30.9967 126.896 30.1739 127.199 29.4248C127.508 28.6756 127.926 28.0335 128.471 27.4916C129.016 26.9498 129.656 26.5284 130.403 26.2274C131.151 25.9197 131.952 25.7726 132.821 25.7726ZM132.821 35.1639C133.198 35.1639 133.568 35.0903 133.931 34.9498C134.295 34.8094 134.605 34.602 134.874 34.3278C135.143 34.0535 135.359 33.7124 135.52 33.311C135.682 32.9097 135.77 32.4281 135.77 31.8796C135.77 31.3311 135.689 30.8562 135.52 30.4482C135.352 30.0401 135.137 29.7057 134.874 29.4314C134.605 29.1572 134.295 28.9498 133.931 28.8094C133.568 28.6689 133.198 28.602 132.821 28.602C132.444 28.602 132.073 28.6689 131.71 28.8094C131.346 28.9498 131.036 29.1572 130.767 29.4314C130.498 29.7057 130.282 30.0468 130.121 30.4482C129.952 30.8562 129.872 31.3311 129.872 31.8796C129.872 32.4281 129.952 32.903 130.121 33.311C130.289 33.7191 130.504 34.0535 130.767 34.3278C131.036 34.602 131.346 34.8094 131.71 34.9498C132.073 35.0903 132.444 35.1639 132.821 35.1639Z" fill="currentColor" class="text-primary"></path><path d="M16.5361 15.9064V21.6321H25.4775V37.6522H32.0556V15.9599L16.5361 15.9064Z" fill="currentColor" class="text-secondary dark:text-primary"></path><path d="M28.4802 13.699C30.7113 13.699 32.52 11.9021 32.52 9.68562C32.52 7.46909 30.7113 5.67224 28.4802 5.67224C26.2491 5.67224 24.4404 7.46909 24.4404 9.68562C24.4404 11.9021 26.2491 13.699 28.4802 13.699Z" fill="currentColor" class="text-secondary dark:text-primary"></path>', 14)
    ]), 10, DH));
  }
}), IH = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function RH(n, e) {
  return b(), D("svg", IH, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.854 3.854a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L3.207 7.5zm6 0a.5.5 0 0 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L9.207 7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const BH = { name: "radix-icons-double-arrow-left", render: RH }, LH = { class: "min-h-dvh min-w-full bg-muted p-8 pb-16" }, FH = { class: "mx-auto max-w-screen-xl" }, VH = { class: "flex flex-col gap-4 md:grid md:grid-cols-12" }, zH = { class: "flex md:col-span-3 md:col-start-1 md:justify-center md:pb-4" }, jH = {
  href: "https://www.sozialinfo.ch",
  "aria-label": "zurück zu Sozialinfo.ch"
}, HH = { class: "flex pb-4 md:col-span-6 md:col-start-4 md:justify-start md:pb-0" }, UH = { class: "pb-8 md:col-span-6 md:col-start-4" }, KH = ["action"], WH = {
  key: 0,
  class: "pb-8 pt-16 md:col-span-6 md:col-start-4"
}, qH = {
  key: 1,
  class: "pt-16 md:col-span-6 md:col-start-4"
}, qr = /* @__PURE__ */ _({
  __name: "Keycloak",
  props: {
    title: {},
    secondaryTitle: {},
    formAction: {},
    alert: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", LH, [
      O("div", FH, [
        O("div", VH, [
          O("div", zH, [
            O("a", jH, [
              x(c(Ac), {
                class: "h-8",
                "aria-label": "Sozialinfo Logo"
              })
            ])
          ]),
          O("div", HH, [
            x(c(Re), {
              as: "a",
              href: "https://www.sozialinfo.ch",
              variant: "link",
              class: "flex items-center gap-2 p-0"
            }, {
              default: y(() => [
                x(c(BH)),
                r[0] || (r[0] = O("span", null, "zurück zu www.sozialinfo.ch", -1))
              ]),
              _: 1
            })
          ]),
          O("div", UH, [
            x(c(vl), null, {
              default: y(() => [
                x(c(yl), null, {
                  default: y(() => [
                    x(c(gu), null, {
                      default: y(() => [
                        K(U(e.title), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                e.alert ? (b(), k(c(Lo), { key: 0 }, {
                  default: y(() => [
                    x(c(MH), { variant: "warning" }, {
                      default: y(() => [
                        x(c(NH), null, {
                          default: y(() => [
                            K(U(e.alert), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })) : X("", !0),
                t.$slots.default ? (b(), k(c(Lo), { key: 1 }, {
                  default: y(() => [
                    E(t.$slots, "default")
                  ]),
                  _: 3
                })) : X("", !0),
                t.$slots.form ? (b(), D(Me, { key: 2 }, [
                  e.formAction ? (b(), k(c(Lo), { key: 0 }, {
                    default: y(() => [
                      O("form", {
                        method: "POST",
                        action: e.formAction,
                        class: "flex flex-col",
                        "aria-label": "form"
                      }, [
                        E(t.$slots, "form")
                      ], 8, KH)
                    ]),
                    _: 3
                  })) : (b(), k(c(Lo), { key: 1 }, {
                    default: y(() => [
                      x(c(Oe), {
                        tag: "h1",
                        class: "text-red-500"
                      }, {
                        default: y(() => r[1] || (r[1] = [
                          K(" Missing form action ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                ], 64)) : X("", !0)
              ]),
              _: 3
            })
          ]),
          t.$slots.secondary ? (b(), D("div", WH, [
            x(c(vl), null, {
              default: y(() => [
                x(c(yl), null, {
                  default: y(() => [
                    x(c(gu), null, {
                      default: y(() => [
                        K(U(t.secondaryTitle || "Missing Title"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                x(c(Lo), null, {
                  default: y(() => [
                    E(t.$slots, "secondary")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ])) : X("", !0),
          t.$slots.footer ? (b(), D("div", qH, [
            E(t.$slots, "footer")
          ])) : X("", !0)
        ])
      ])
    ]));
  }
}), WJ = /* @__PURE__ */ _({
  __name: "KeycloakError",
  props: {
    title: {},
    summary: {},
    alert: {},
    labelBack: {},
    urlBase: {},
    showWarning: { type: Boolean }
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title || "Error",
      alert: e.alert
    }, {
      default: y(() => [
        e.showWarning ? (b(), k(c(Oe), {
          key: 0,
          tag: "p"
        }, {
          default: y(() => t[0] || (t[0] = [
            K(" The loaded template has no Vue equivalent ")
          ])),
          _: 1
        })) : e.summary ? (b(), k(c(Oe), {
          key: 1,
          tag: "p",
          class: "pb-8 text-fluid-xs"
        }, {
          default: y(() => [
            K(U(e.summary), 1)
          ]),
          _: 1
        })) : X("", !0),
        e.urlBase ? (b(), k(c(Re), {
          key: 2,
          as: "a",
          size: "full",
          href: e.urlBase,
          class: "flex items-center gap-2",
          "aria-label": e.labelBack || "zurück"
        }, {
          default: y(() => [
            x(c(kd)),
            K(" " + U(e.labelBack || "zurück"), 1)
          ]),
          _: 1
        }, 8, ["href", "aria-label"])) : X("", !0)
      ]),
      _: 1
    }, 8, ["title", "alert"]));
  }
}), GH = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function JH(n, e) {
  return b(), D("svg", GH, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.146 3.146a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L11.293 8H2.5a.5.5 0 0 1 0-1h8.793L8.146 3.854a.5.5 0 0 1 0-.708",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const If = { name: "radix-icons-arrow-right", render: JH }, ZH = { class: "py-4 text-fluid-xxs" }, qJ = /* @__PURE__ */ _({
  __name: "KeycloakInfo",
  props: {
    title: {},
    summary: {},
    alert: {},
    actionHref: {},
    actionLabel: {},
    actionDisplayNames: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title || e.summary,
      alert: e.alert
    }, {
      default: y(() => [
        e.title ? (b(), k(c(Oe), {
          key: 0,
          tag: "p",
          class: "text-fluid-xs"
        }, {
          default: y(() => [
            K(U(e.summary), 1)
          ]),
          _: 1
        })) : X("", !0),
        O("ul", ZH, [
          (b(!0), D(Me, null, it(e.actionDisplayNames, (r) => (b(), D("li", {
            key: r.alias,
            class: ""
          }, U(r.displayName), 1))), 128))
        ]),
        x(c(Re), {
          as: "a",
          size: "full",
          href: e.actionHref,
          class: "flex items-center gap-2"
        }, {
          default: y(() => [
            K(U(e.actionLabel) + " ", 1),
            x(c(If))
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _: 1
    }, 8, ["title", "alert"]));
  }
}), so = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "ValidationMessage",
  props: {
    message: {},
    id: {}
  },
  setup(n) {
    const e = {
      id: `${n.id}-validation-message`
    };
    return (t, r) => (b(), D("div", {
      "aria-live": "polite",
      class: fe(t.$attrs.class ?? "")
    }, [
      t.message ? (b(), D("span", j({ key: 0 }, e, {
        class: c(G)(`
        mb-2 inline-flex items-center justify-center rounded-xs bg-destructive
        px-4 py-1.5 text-xs text-destructive-foreground
      `)
      }), U(t.message), 17)) : X("", !0)
    ], 2));
  }
}), YH = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function XH(n, e) {
  return b(), D("svg", YH, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.5 12.5v-11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3V8.76h.71a.61.61 0 0 0 .61-.61v-.77a.61.61 0 0 0-.61-.61h-.67v-.94c0-.84.38-.84.76-.84h.49a.55.55 0 0 0 .43-.18a.58.58 0 0 0 .18-.43v-.74a.62.62 0 0 0-.6-.64H9.65a2.32 2.32 0 0 0-2.39 2.6v1.17h-.64a.61.61 0 0 0-.62.61v.77a.61.61 0 0 0 .62.61h.64v4.74H1.5a1 1 0 0 1-1-1"
    }, null, -1)
  ]));
}
const QH = { name: "streamline-facebook-1", render: XH }, eU = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function tU(n, e) {
  return b(), D("svg", eU, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.36 5.83H7.87a.51.51 0 0 0-.51.52v1.41a.51.51 0 0 0 .51.51h2.29a2.75 2.75 0 0 1-3 2.79c-2.24 0-3.32-1.9-3.32-4.06S5 2.94 7.16 2.94a4.07 4.07 0 0 1 2.64.86a.49.49 0 0 0 .72-.22l.63-1.44a.51.51 0 0 0-.15-.63a7.07 7.07 0 0 0-3.8-1C3.56.5 1.08 3.33 1.08 7s2.49 6.5 6.08 6.5s5.76-2.56 5.76-6c0-1.1-.44-1.67-1.56-1.67"
    }, null, -1)
  ]));
}
const nU = { name: "streamline-google", render: tU }, rU = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function oU(n, e) {
  return b(), D("svg", rU, e[0] || (e[0] = [
    O("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      O("path", { d: "M7 13.5a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13" }),
      O("path", { d: "M7 7.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m0 0v2" })
    ], -1)
  ]));
}
const iU = { name: "streamline-keyhole-lock-circle", render: oU }, aU = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function sU(n, e) {
  return b(), D("svg", aU, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.574 1.767a1.316 1.316 0 0 1-1.287 1.326A1.346 1.346 0 0 1 .99 1.767A1.326 1.326 0 0 1 2.287.5a1.316 1.316 0 0 1 1.287 1.267M1.129 5.449c0-.762.485-.643 1.158-.643s1.148-.119 1.148.643v7.424c0 .772-.485.614-1.148.614s-1.158.158-1.158-.614zm4.306.001c0-.426.158-.585.405-.634s1.099 0 1.396 0s.416.485.406.851a2.49 2.49 0 0 1 2.217-.99a2.97 2.97 0 0 1 3.148 3.098v5.068c0 .772-.475.614-1.149.614c-.673 0-1.148.158-1.148-.614V8.884A1.425 1.425 0 0 0 9.206 7.34A1.435 1.435 0 0 0 7.74 8.914v3.959c0 .772-.485.614-1.158.614s-1.148.158-1.148-.614V5.449Z"
    }, null, -1)
  ]));
}
const lU = { name: "streamline-linkedin", render: sU }, dU = { class: "flex flex-col gap-2 py-4" }, uU = {
  key: 0,
  class: "flex items-center py-4"
}, cU = { class: "flex items-center gap-2" }, fU = {
  class: "inline-block text-sm",
  for: "rememberMe"
}, pU = ["value"], hU = { class: "flex flex-col gap-4 md:flex-row-reverse md:items-center" }, mU = {
  key: 0,
  class: "flex h-fit justify-center"
}, gU = {
  key: 1,
  class: "flex flex-col items-center py-6"
}, vU = { class: "flex flex-col justify-center gap-4 pt-4" }, yU = { class: "text-sm" }, bU = { class: "flex justify-end" }, GJ = /* @__PURE__ */ _({
  __name: "KeycloakLogin",
  props: {
    title: {},
    alert: {},
    validation: {},
    labelUsername: {},
    labelPassword: {},
    labelRememberMe: {},
    labelForgotPassword: {},
    labelLogin: {},
    labelRegistration: {},
    labelNoAccount: {},
    labelNoAccountExplanation: {},
    labelIdentityProviderLogin: {},
    canRegister: { type: Boolean },
    canRemember: { type: Boolean },
    canResetPassword: { type: Boolean },
    typeLogin: {},
    typeAutocomplete: {},
    urlReset: {},
    urlRegister: {},
    urlRedirect: {},
    urlFormAction: {},
    urlTempPortal: {},
    socialSupported: { type: Boolean },
    socialProviders: {},
    selectedCredential: {},
    dateRememberMe: { type: Boolean },
    toggleRememberMe: { type: Function }
  },
  setup(n) {
    const e = {
      "linkedin-openid-connect": lU,
      google: nU,
      facebook: QH
    };
    return (t, r) => (b(), k(qr, {
      title: t.title || "Anmelden",
      "secondary-title": t.labelNoAccount || "Noch kein Konto?",
      "form-action": t.urlFormAction,
      alert: t.alert
    }, k2({
      form: y(() => [
        O("div", dU, [
          O("div", null, [
            t.validation ? (b(), k(c(so), {
              key: 0,
              id: "validation",
              message: t.validation
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              id: "username",
              label: t.labelUsername || "Benutzername",
              type: t.typeLogin,
              name: "username",
              required: "",
              autocomplete: t.typeAutocomplete,
              "aria-describedby": t.validation && "validation-validation-message",
              "aria-invalid": !!t.validation
            }, null, 8, ["label", "type", "autocomplete", "aria-describedby", "aria-invalid"])
          ]),
          x(c(Rt), {
            id: "password",
            label: t.labelPassword || "Passwort",
            type: "password",
            name: "password",
            required: "",
            autocomplete: "current-password",
            "aria-describedby": t.validation && "validation-validation-message",
            "aria-invalid": !!t.validation
          }, null, 8, ["label", "aria-describedby", "aria-invalid"])
        ]),
        t.canRemember ? (b(), D("div", uU, [
          O("label", cU, [
            x(c(nf), {
              id: "rememberMe",
              name: "rememberMe",
              onAction: t.toggleRememberMe
            }, null, 8, ["onAction"]),
            O("span", fU, U(t.labelRememberMe || "Angemeldet bleiben"), 1)
          ])
        ])) : X("", !0),
        O("input", {
          type: "hidden",
          name: "credentialId",
          value: t.selectedCredential
        }, null, 8, pU),
        O("div", hU, [
          x(c(Re), {
            class: "h-fit",
            type: "submit"
          }, {
            default: y(() => [
              K(U(t.labelLogin || "Anmelden"), 1)
            ]),
            _: 1
          }),
          t.canResetPassword ? (b(), D("div", mU, [
            x(c(Re), {
              as: "a",
              href: t.urlReset,
              variant: "link"
            }, {
              default: y(() => [
                K(U(t.labelForgotPassword || "Passwort vergessen"), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])) : X("", !0)
        ]),
        t.socialProviders?.length && t.socialSupported ? (b(), D("div", gU, [
          x(c(Oe), {
            tag: "span",
            class: "text-sm text-muted-foreground"
          }, {
            default: y(() => [
              K(U(t.labelIdentityProviderLogin), 1)
            ]),
            _: 1
          }),
          O("div", vU, [
            (b(!0), D(Me, null, it(t.socialProviders, (o) => (b(), k(c(Re), {
              key: o.alias,
              variant: "outline",
              as: "a",
              href: o.loginUrl,
              class: "flex items-center gap-2"
            }, {
              default: y(() => [
                e[o.alias] ? (b(), k(Qt(e[o.alias] || c(iU)), {
                  key: 0,
                  role: "img",
                  "aria-hidden": "true",
                  size: "5"
                })) : X("", !0),
                O("span", yU, U(o.displayName), 1)
              ]),
              _: 2
            }, 1032, ["href"]))), 128))
          ])
        ])) : X("", !0)
      ]),
      _: 2
    }, [
      t.canRegister ? {
        name: "secondary",
        fn: y(() => [
          x(c(Oe), {
            tag: "p",
            class: "pb-4 text-fluid-xs"
          }, {
            default: y(() => [
              K(U(t.labelNoAccountExplanation || "Du hast noch kein Benutzerkonto? Du kannst einfach eines erstellen."), 1)
            ]),
            _: 1
          }),
          O("div", bU, [
            x(c(Re), {
              variant: "outline",
              as: "a",
              href: t.urlTempPortal,
              class: "text-primary"
            }, {
              default: y(() => [
                K(U(t.labelRegistration || "Registrieren"), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["title", "secondary-title", "form-action", "alert"]));
  }
}), JJ = /* @__PURE__ */ _({
  __name: "KeycloakLoginExpired",
  props: {
    title: {},
    labelClickHere: {},
    alert: {},
    messageRestartFlow: {},
    messageLogin: {},
    urlRestartFlow: {},
    urlLoginAction: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title || "Deine Sitzung ist abgelaufen",
      alert: e.alert
    }, {
      default: y(() => [
        E(e.$slots, "default", {}, () => [
          O("div", null, [
            x(c(Re), {
              as: "a",
              href: e.urlRestartFlow,
              size: "full"
            }, {
              default: y(() => [
                K(U(e.messageRestartFlow || "Anmeldevorgang neu starten"), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          O("div", null, [
            x(c(Re), {
              as: "a",
              href: e.urlLoginAction,
              size: "full"
            }, {
              default: y(() => [
                K(U(e.messageLogin || "Anmeldevorgang fortsetzen"), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ]),
      _: 3
    }, 8, ["title", "alert"]));
  }
}), $U = ["value"], wU = { class: "flex justify-start" }, ZJ = /* @__PURE__ */ _({
  __name: "KeycloakLogoutConfirm",
  props: {
    title: {},
    alert: {},
    urlFormAction: {},
    urlBack: {},
    labelDoLogout: {},
    labelBackToLogin: {},
    confirmationCode: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title,
      alert: e.alert,
      "form-action": e.urlFormAction
    }, {
      form: y(() => [
        O("input", {
          type: "hidden",
          name: "session_code",
          value: e.confirmationCode
        }, null, 8, $U),
        x(c(Re), {
          size: "full",
          type: "submit"
        }, {
          default: y(() => [
            K(U(e.labelDoLogout), 1)
          ]),
          _: 1
        })
      ]),
      footer: y(() => [
        O("div", wU, [
          x(c(Re), {
            as: "a",
            href: e.urlBack,
            variant: "link",
            class: "flex items-center gap-2"
          }, {
            default: y(() => [
              x(c(kd)),
              K(" " + U(e.labelBackToLogin), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _: 1
    }, 8, ["title", "alert", "form-action"]));
  }
}), xU = { class: "py-4" }, CU = { class: "flex justify-start" }, YJ = /* @__PURE__ */ _({
  __name: "KeycloakPasswordReset",
  props: {
    title: {},
    alert: {},
    urlFormAction: {},
    urlLogin: {},
    labelUsername: {},
    labelSubmit: {},
    labelBackToLogin: {},
    labelEmailInstructions: {},
    labelEmailInstructionsUsername: {},
    typeLogin: {},
    typeAutocomplete: {},
    validation: {},
    allowDuplicateEmails: { type: Boolean }
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title,
      "form-action": e.urlFormAction,
      alert: e.alert
    }, {
      form: y(() => [
        e.validation ? (b(), k(c(so), {
          key: 0,
          id: "validation",
          role: "alert",
          message: e.validation
        }, null, 8, ["message"])) : X("", !0),
        x(c(Rt), {
          id: "username",
          label: e.labelUsername,
          type: e.typeLogin,
          name: "username",
          required: "",
          autocomplete: e.typeAutocomplete,
          "aria-describedby": e.validation && "validation-validation-message",
          "aria-invalid": !!e.validation
        }, null, 8, ["label", "type", "autocomplete", "aria-describedby", "aria-invalid"]),
        O("div", xU, [
          e.allowDuplicateEmails ? (b(), k(c(Oe), {
            key: 0,
            tag: "p",
            class: "text-fluid-xs"
          }, {
            default: y(() => [
              K(U(e.labelEmailInstructionsUsername), 1)
            ]),
            _: 1
          })) : (b(), k(c(Oe), {
            key: 1,
            tag: "p",
            class: "text-fluid-xs"
          }, {
            default: y(() => [
              K(U(e.labelEmailInstructions), 1)
            ]),
            _: 1
          }))
        ]),
        x(c(Re), {
          size: "full",
          type: "submit"
        }, {
          default: y(() => [
            K(U(e.labelSubmit), 1)
          ]),
          _: 1
        })
      ]),
      footer: y(() => [
        O("div", CU, [
          x(c(Re), {
            as: "a",
            href: e.urlLogin,
            variant: "link",
            class: "flex items-center gap-2"
          }, {
            default: y(() => [
              x(c(kd)),
              K(" " + U(e.labelBackToLogin), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _: 1
    }, 8, ["title", "form-action", "alert"]));
  }
}), kU = ["value"], _U = { class: "flex flex-col gap-4" }, SU = { class: "flex w-full items-center justify-center pt-4" }, EU = {
  class: "flex items-center",
  for: "logout-sessions"
}, OU = {
  class: "inline-block pl-2 text-sm",
  for: "rememberMe"
}, TU = ["value"], AU = { class: "flex flex-row gap-4 pt-4" }, XJ = /* @__PURE__ */ _({
  __name: "KeycloakPasswordUpdate",
  props: {
    title: {},
    alert: {},
    urlFormAction: {},
    labelSubmit: {},
    labelCancel: {},
    labelPasswordNew: {},
    labelPasswordConfirm: {},
    labelLogoutOtherSessions: {},
    validationPassword: {},
    validationPasswordConfirm: {},
    isAppInitiatedAction: { type: Boolean },
    selectedCredential: {},
    username: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title,
      "form-action": e.urlFormAction,
      alert: e.alert
    }, {
      form: y(() => [
        O("input", {
          type: "hidden",
          name: "credentialId",
          value: e.username
        }, null, 8, kU),
        O("div", _U, [
          O("div", null, [
            e.validationPassword ? (b(), k(c(so), {
              key: 0,
              id: "input-error-password",
              class: "text-error",
              "aria-live": "polite",
              message: e.validationPassword
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              id: "password-new",
              type: "password",
              name: "password-new",
              label: e.labelPasswordNew,
              autofocus: "",
              required: "",
              autocomplete: "new-password",
              "aria-describedby": e.validationPassword && "input-error-password-validation-message",
              "aria-invalid": !!e.validationPassword
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ]),
          O("div", null, [
            e.validationPasswordConfirm ? (b(), k(c(so), {
              key: 0,
              id: "input-error-password-confirm",
              class: "text-error",
              "aria-live": "polite",
              message: e.validationPasswordConfirm
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              id: "password-confirm",
              type: "password",
              name: "password-confirm",
              label: e.labelPasswordConfirm,
              required: "",
              autocomplete: "new-password",
              "aria-describedby": e.validationPasswordConfirm && "input-error-password-confirm-validation-message",
              "aria-invalid": !!e.validationPasswordConfirm
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ])
        ]),
        O("div", SU, [
          O("label", EU, [
            x(c(nf), {
              id: "logout-sessions",
              name: "logout-sessions"
            }),
            O("span", OU, U(e.labelLogoutOtherSessions), 1)
          ])
        ]),
        O("input", {
          type: "hidden",
          name: "credentialId",
          value: e.selectedCredential
        }, null, 8, TU),
        O("div", AU, [
          e.isAppInitiatedAction ? (b(), k(c(Re), {
            key: 0,
            size: "full",
            type: "submit",
            value: "true",
            variant: "destructive",
            name: "cancel-aia",
            formnovalidate: ""
          }, {
            default: y(() => [
              K(U(e.labelCancel), 1)
            ]),
            _: 1
          })) : X("", !0),
          x(c(Re), {
            size: "full",
            type: "submit"
          }, {
            default: y(() => [
              K(U(e.labelSubmit), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "form-action", "alert"]));
  }
}), MU = { class: "flex flex-col gap-4" }, NU = { key: 0 }, PU = ["value"], DU = { class: "flex flex-col gap-2 pt-4" }, QJ = /* @__PURE__ */ _({
  __name: "KeycloakRegister",
  props: /* @__PURE__ */ Mt({
    title: {},
    alert: {},
    labelBackToLogin: {},
    labelDoRegister: {},
    labelFirstName: {},
    labelLastName: {},
    labelEmail: {},
    labelPassword: {},
    labelPasswordConfirm: {},
    labelTermsAndConditions: {},
    labelTermsAndConditionsLink: {},
    dataFirstName: {},
    dataLastName: {},
    dataEmail: {},
    urlFormAction: {},
    urlLogin: {},
    validationFirstName: {},
    validationLastName: {},
    validationEmail: {},
    validationPassword: {},
    validationPasswordConfirm: {},
    isPasswordRequired: { type: Boolean },
    selectedCredential: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue");
    return (t, r) => (b(), k(qr, {
      title: t.title,
      alert: t.alert,
      "form-action": t.urlFormAction
    }, {
      form: y(() => [
        O("div", MU, [
          O("div", null, [
            t.validationFirstName ? (b(), k(c(so), {
              key: 0,
              id: "firstnameerror",
              message: t.validationFirstName
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              label: t.labelFirstName,
              name: "firstName",
              type: "text",
              autocomplete: "given-name",
              "aria-describedby": t.validationFirstName && "firstnameerror-validation-message",
              "aria-invalid": !!t.validationFirstName,
              required: ""
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ]),
          O("div", null, [
            t.validationLastName ? (b(), k(c(so), {
              key: 0,
              id: "lastnameerror",
              message: t.validationLastName
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              label: t.labelLastName,
              name: "lastName",
              type: "text",
              autocomplete: "family-name",
              "aria-describedby": t.validationLastName && "lastnameerror-validation-message",
              "aria-invalid": !!t.validationLastName,
              required: ""
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ]),
          O("div", null, [
            t.validationEmail ? (b(), k(c(so), {
              key: 0,
              id: "emailerror",
              message: t.validationEmail
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              modelValue: e.value,
              "onUpdate:modelValue": r[0] || (r[0] = (o) => e.value = o),
              label: t.labelEmail,
              name: "email",
              type: "email",
              autocomplete: "email",
              "aria-describedby": t.validationEmail && "emailerror-validation-message",
              "aria-invalid": !!t.validationEmail,
              required: ""
            }, null, 8, ["modelValue", "label", "aria-describedby", "aria-invalid"])
          ]),
          t.isPasswordRequired ? (b(), D("div", NU, [
            t.validationPassword ? (b(), k(c(so), {
              key: 0,
              id: "passworderror",
              message: t.validationPassword
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              label: t.labelPassword || "Passwort",
              name: "password",
              type: "password",
              autocomplete: "new-password",
              "aria-describedby": t.validationPassword && "passworderror-validation-message",
              "aria-invalid": !!t.validationPassword,
              required: ""
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ])) : X("", !0),
          O("div", null, [
            t.validationPasswordConfirm ? (b(), k(c(so), {
              key: 0,
              id: "passwordconfirmerror",
              message: t.validationPasswordConfirm
            }, null, 8, ["message"])) : X("", !0),
            x(c(Rt), {
              label: t.labelPasswordConfirm || "Passwort wiederholen",
              name: "password-confirm",
              type: "password",
              autocomplete: "new-password",
              "aria-describedby": t.validationPasswordConfirm && "passwordconfirmerror-validation-message",
              "aria-invalid": !!t.validationPasswordConfirm,
              required: ""
            }, null, 8, ["label", "aria-describedby", "aria-invalid"])
          ]),
          O("input", {
            type: "hidden",
            name: "credentialId",
            value: t.selectedCredential
          }, null, 8, PU),
          hr(O("input", {
            "onUpdate:modelValue": r[1] || (r[1] = (o) => e.value = o),
            type: "hidden",
            name: "username"
          }, null, 512), [
            [P2, e.value]
          ]),
          O("div", DU, [
            x(c(Re), {
              size: "full",
              type: "submit"
            }, {
              default: y(() => [
                K(U(t.labelDoRegister), 1)
              ]),
              _: 1
            }),
            x(c(Re), {
              as: "a",
              href: t.urlLogin,
              variant: "outline",
              class: "flex items-center gap-2"
            }, {
              default: y(() => [
                K(U(t.labelBackToLogin), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ]),
      footer: y(() => [
        x(c(Re), {
          as: "a",
          href: t.urlLogin,
          variant: "link",
          class: "flex items-center gap-2"
        }, {
          default: y(() => [
            x(c(kd)),
            K(" " + U(t.labelBackToLogin), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _: 1
    }, 8, ["title", "alert", "form-action"]));
  }
}), IU = { class: "flex justify-center p-8" }, RU = { class: "flex items-center gap-1" }, BU = { class: "flex flex-col gap-2" }, eZ = /* @__PURE__ */ _({
  __name: "KeycloakTerms",
  props: {
    title: {},
    alert: {},
    text: {},
    urlFormAction: {},
    urlTerms: {},
    labelAccept: {},
    labelDecline: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title || "Nutzungsbedinungen akzeptieren",
      "form-action": e.urlFormAction
    }, {
      default: y(() => [
        x(c(Oe), {
          tag: "p",
          class: "text-fluid-xs"
        }, {
          default: y(() => [
            K(U(e.text), 1)
          ]),
          _: 1
        }),
        O("div", IU, [
          x(c(Re), {
            as: "a",
            href: e.urlTerms,
            variant: "link",
            target: "_blank"
          }, {
            default: y(() => [
              O("div", RU, [
                t[0] || (t[0] = K(" Nutzungsbedingungen lesen ")),
                x(c(If))
              ])
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      form: y(() => [
        O("div", BU, [
          x(c(Re), {
            size: "full",
            type: "submit"
          }, {
            default: y(() => [
              K(U(e.labelAccept || "Akzeptieren"), 1)
            ]),
            _: 1
          }),
          x(c(Re), {
            size: "full",
            type: "submit",
            variant: "outline"
          }, {
            default: y(() => [
              K(U(e.labelDecline || "Ablehnen"), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "form-action"]));
  }
}), LU = { class: "flex flex-col gap-4" }, tZ = /* @__PURE__ */ _({
  __name: "KeycloakVerifyEmail",
  props: {
    title: {},
    alert: {},
    labelClickHere: {},
    instructionsPrimary: {},
    instructionsSecondary: {},
    instructionsTertiary: {},
    urlLogin: {}
  },
  setup(n) {
    return (e, t) => (b(), k(qr, {
      title: e.title || "Error",
      alert: e.alert
    }, {
      default: y(() => [
        O("div", LU, [
          x(c(Oe), {
            tag: "p",
            class: "text-fluid-xs"
          }, {
            default: y(() => [
              K(U(e.instructionsPrimary), 1)
            ]),
            _: 1
          }),
          x(c(Oe), {
            tag: "p",
            class: "text-fluid-xxs"
          }, {
            default: y(() => [
              K(U(e.instructionsSecondary), 1)
            ]),
            _: 1
          }),
          x(c(Re), {
            as: "a",
            href: e.urlLogin
          }, {
            default: y(() => [
              K(U(e.labelClickHere), 1)
            ]),
            _: 1
          }, 8, ["href"]),
          e.instructionsTertiary.trim().length ? (b(), k(c(Oe), {
            key: 0,
            tag: "p",
            class: "pb-4 text-fluid-xxs"
          }, {
            default: y(() => [
              K(U(e.instructionsTertiary), 1)
            ]),
            _: 1
          })) : X("", !0)
        ])
      ]),
      _: 1
    }, 8, ["title", "alert"]));
  }
}), FU = {
  class: "hidden items-center justify-between gap-x-6 bg-background py-14 lg:flex print:hidden",
  "aria-label": "Hauptnavigation"
}, VU = { class: "-mt-[24px] flex lg:flex-none" }, zU = {
  href: "/",
  class: "-m-1.5 p-1.5"
}, jU = { class: "flex flex-1 justify-center gap-x-12" }, HU = ["href"], UU = { class: "flex items-center justify-end gap-x-2" }, nZ = /* @__PURE__ */ _({
  __name: "MainNavigation",
  props: {
    navigation: {},
    currentPathSegments: {},
    portalUrl: {}
  },
  setup(n) {
    function e(o) {
      return n.currentPathSegments.includes(o);
    }
    function t(o) {
      const i = o.target;
      if (i.tagName !== "A")
        return;
      const a = i.closest("ul");
      a.style.setProperty("--underline-width", `${i.offsetWidth}px`), a.style.setProperty("--underline-offset-x", `${i.offsetLeft}px`);
    }
    function r(o) {
      o.target.closest("ul").style.setProperty("--underline-width", "0");
    }
    return (o, i) => (b(), D("nav", FU, [
      O("div", VU, [
        O("a", zU, [
          i[0] || (i[0] = O("span", { class: "sr-only" }, "Startseite", -1)),
          x(c(Ac), { class: "h-8 w-auto lg:h-10" })
        ])
      ]),
      O("div", jU, [
        O("ul", {
          class: "relative flex space-x-6 transition-all duration-300 before:absolute before:bottom-[-4px] before:h-[3px] before:w-[var(--underline-width)] before:translate-x-[var(--underline-offset-x)] before:bg-secondary before:transition-all before:content-['']",
          style: { "--underline-width": "0", "--underline-offset-x": "0" },
          onMouseover: t,
          onMouseleave: r
        }, [
          (b(!0), D(Me, null, it(o.navigation, (a, s) => (b(), D("li", {
            key: s,
            class: "list-none"
          }, [
            O("a", {
              href: a.path,
              class: fe(["text-lg font-bold text-primary", {
                "no-underline": !e(a.label.toLocaleLowerCase()),
                "underline decoration-secondary decoration-[3px] underline-offset-8": e(a.label.toLocaleLowerCase())
              }])
            }, U(a.label), 11, HU)
          ]))), 128))
        ], 32)
      ]),
      O("div", UU, [
        x(c(Re), {
          as: "a",
          href: "/fuer-organisationen",
          variant: "outline",
          class: "min-w-fit flex-none py-2"
        }, {
          default: y(() => i[1] || (i[1] = [
            K(" Für Organisationen ")
          ])),
          _: 1
        }),
        x(c(Re), {
          as: "a",
          href: o.portalUrl,
          variant: "outline",
          class: "min-w-fit flex-none py-2"
        }, {
          default: y(() => i[2] || (i[2] = [
            K(" Login ")
          ])),
          _: 1
        }, 8, ["href"])
      ])
    ]));
  }
}), KU = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function WU(n, e) {
  return b(), D("svg", KU, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5.875a3.625 3.625 0 0 0-1.006 7.109c-1.194.145-2.218.567-2.99 1.328c-.982.967-1.479 2.408-1.479 4.288a.475.475 0 1 0 .95 0c0-1.72.453-2.88 1.196-3.612c.744-.733 1.856-1.113 3.329-1.113s2.585.38 3.33 1.113c.742.733 1.195 1.892 1.195 3.612a.475.475 0 1 0 .95 0c0-1.88-.497-3.32-1.48-4.288c-.77-.76-1.795-1.183-2.989-1.328A3.627 3.627 0 0 0 7.5.875M4.825 4.5a2.675 2.675 0 1 1 5.35 0a2.675 2.675 0 0 1-5.35 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const y5 = { name: "radix-icons-person", render: WU }, qU = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function GU(n, e) {
  return b(), D("svg", qU, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.854 2.854a.5.5 0 0 0-.708-.708L7.5 6.793L2.854 2.146a.5.5 0 1 0-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 0 0 .708.708L7.5 8.207l4.646 4.647a.5.5 0 0 0 .708-.708L8.207 7.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const JU = { name: "radix-icons-cross-1", render: GU }, ZU = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function YU(n, e) {
  return b(), D("svg", ZU, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 3a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1zM1 7.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1-.5-.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const XU = { name: "radix-icons-hamburger-menu", render: YU }, QU = { class: "flex items-center justify-between gap-x-6 py-4" }, eK = {
  href: "/",
  class: "-m-1.5 p-1.5"
}, tK = { class: "flex gap-1 print:hidden" }, nK = { class: "flex items-center justify-between gap-x-6" }, rK = {
  href: "#",
  class: "-m-1.5 p-1.5"
}, oK = { class: "flex" }, iK = { class: "grid gap-4 overflow-y-auto px-5 py-4" }, aK = { class: "flex flex-col justify-between" }, sK = /* @__PURE__ */ _({
  __name: "BaseMobileNavigation",
  props: {
    portalUrl: {}
  },
  setup(n) {
    const e = B(!1);
    function t() {
      e.value = !0;
    }
    return (r, o) => (b(), D(Me, null, [
      O("div", {
        class: fe(c(G)("", r.$attrs.class ?? ""))
      }, [
        O("div", QU, [
          O("a", eK, [
            o[1] || (o[1] = O("span", { class: "sr-only" }, "Sozialinfo", -1)),
            x(c(Ac), {
              class: "h-7",
              theme: "light"
            })
          ]),
          O("div", tK, [
            r.portalUrl ? (b(), k(c(Re), {
              key: 0,
              variant: "ghost",
              size: "icon",
              as: "a",
              href: r.portalUrl
            }, {
              default: y(() => [
                o[2] || (o[2] = O("span", { class: "sr-only" }, "Login", -1)),
                x(c(y5), {
                  class: "size-5",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["href"])) : X("", !0),
            x(c(Re), {
              variant: "ghost",
              size: "icon",
              onClick: t
            }, {
              default: y(() => [
                o[3] || (o[3] = O("span", { class: "sr-only" }, "Menu öffnen", -1)),
                x(c(XU), {
                  class: "size-6",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            })
          ])
        ])
      ], 2),
      x(c(m1), {
        open: e.value,
        "onUpdate:open": o[0] || (o[0] = (i) => e.value = i)
      }, {
        default: y(() => [
          x(c(Df), { class: "max-h-dvh grid-rows-[auto_minmax(0,1fr)_auto] bg-background p-0 text-background sm:max-w-[425px]" }, {
            default: y(() => [
              x(c(g1), { class: "p-6 pb-0" }, {
                default: y(() => [
                  O("div", nK, [
                    O("a", rK, [
                      o[4] || (o[4] = O("span", { class: "sr-only" }, "Sozialinfo", -1)),
                      x(c(Ac), {
                        class: "h-7",
                        theme: "light"
                      })
                    ]),
                    O("div", oK, [
                      x(c(l5), { "as-child": "" }, {
                        default: y(() => [
                          x(c(Re), {
                            variant: "ghost",
                            size: "icon"
                          }, {
                            default: y(() => [
                              o[5] || (o[5] = O("span", { class: "sr-only" }, "Close menu", -1)),
                              x(c(JU), {
                                class: "size-6",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              O("div", iK, [
                O("div", aK, [
                  E(r.$slots, "default")
                ])
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["open"])
    ], 64));
  }
}), lK = { "aria-label": "Hauptnavigation" }, dK = { class: "space-y-10" }, uK = ["href"], cK = { class: "mt-4 flex flex-wrap gap-2" }, fK = { class: "mt-6" }, rZ = /* @__PURE__ */ _({
  __name: "MobileNavigation",
  props: {
    portalUrl: {},
    navigationData: {}
  },
  setup(n) {
    return (e, t) => (b(), k(sK, { "portal-url": e.portalUrl }, {
      default: y(() => [
        O("nav", lK, [
          O("ul", dK, [
            (b(!0), D(Me, null, it(e.navigationData, (r) => (b(), D("li", {
              key: r.name
            }, [
              O("a", {
                href: r.href,
                class: "text-[28px] font-bold text-foreground"
              }, U(r.name), 9, uK),
              O("ul", cK, [
                (b(!0), D(Me, null, it(r.subs, (o) => (b(), D("li", {
                  key: o.name
                }, [
                  x(c(tf), {
                    as: "a",
                    href: o.href,
                    target: o.target,
                    variant: "outline"
                  }, {
                    default: y(() => [
                      K(U(o.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["href", "target"])
                ]))), 128))
              ])
            ]))), 128))
          ])
        ]),
        O("div", fK, [
          x(c(Re), {
            as: "a",
            href: e.portalUrl,
            size: "full",
            class: "flex gap-2"
          }, {
            default: y(() => [
              x(c(y5)),
              t[0] || (t[0] = K(" Zu meinem Kundenportal "))
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _: 1
    }, 8, ["portal-url"]));
  }
}), pK = {}, hK = {
  class: "flex",
  "aria-label": "Brotkrumen Pfad"
}, mK = {
  role: "list",
  class: "flex flex-wrap items-center space-x-2"
};
function gK(n, e) {
  return b(), D("nav", hK, [
    O("ol", mK, [
      E(n.$slots, "default")
    ])
  ]);
}
const vK = /* @__PURE__ */ Yi(pK, [["render", gK]]), yK = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function bK(n, e) {
  return b(), D("svg", yK, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.625 7.5a1.125 1.125 0 1 1-2.25 0a1.125 1.125 0 0 1 2.25 0m5 0a1.125 1.125 0 1 1-2.25 0a1.125 1.125 0 0 1 2.25 0M12.5 8.625a1.125 1.125 0 1 0 0-2.25a1.125 1.125 0 0 0 0 2.25",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const $K = { name: "radix-icons-dots-horizontal", render: bK }, wK = /* @__PURE__ */ _({
  __name: "BreadcrumbEllipsis",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("span", {
      role: "presentation",
      "aria-hidden": "true",
      class: fe(c(G)("flex size-9 items-center justify-center", e.class))
    }, [
      E(t.$slots, "default", {}, () => [
        x(c($K), { class: "size-4 text-primary" })
      ])
    ], 2));
  }
}), xK = { class: "group" }, CK = { class: "flex items-center text-primary" }, Up = /* @__PURE__ */ _({
  __name: "BreadcrumbItem",
  props: {
    href: {},
    current: { type: Boolean },
    class: {}
  },
  setup(n) {
    return (e, t) => (b(), D("li", xK, [
      O("div", CK, [
        O("span", {
          class: fe(c(G)(`
          self-stretch text-2xl text-primary
          group-[:nth-of-type(1)]:hidden
        `, e.$props.class ?? ""))
        }, "›", 2),
        x(c(tf), {
          variant: "ghost",
          as: e.current ? "span" : "a",
          class: fe(c(G)(`
          text-sm
          group-[:not(:nth-of-type(1))]:ml-2
          hover:underline
        `, e.$props.class ?? "")),
          href: e.current ? void 0 : e.href,
          "aria-current": e.current ? "page" : void 0
        }, {
          default: y(() => [
            E(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "class", "href", "aria-current"])
      ])
    ]));
  }
});
function kK(n) {
  const t = new URL(n).pathname.split("/").filter(Boolean);
  return t.pop(), t.map((o, i) => ({
    href: `/${t.slice(0, i + 1).join("/")}`,
    label: o.charAt(0).toUpperCase() + o.slice(1),
    // current: index === pathSegments.length - 1,
    current: !1
    // we never show the current page in the breadcrumb
  }));
}
function oZ() {
  return {
    computeBreadcrumbItems: kK
  };
}
const _K = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function SK(n, e) {
  return b(), D("svg", _K, e[0] || (e[0] = [
    O("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      O("path", { d: "M.5 8L7 1.5L13.5 8" }),
      O("path", { d: "M2.5 6v6.5h9V6" })
    ], -1)
  ]));
}
const EK = { name: "streamline-home-4", render: SK }, OK = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function TK(n, e) {
  return b(), D("svg", OK, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.707 1.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L2 8.414V13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.414l.293.293a1 1 0 1 0 1.414-1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const AK = { name: "streamline-home-4-solid", render: TK }, MK = { class: "rounded-tr-[80px] bg-muted lg:rounded-tr-[190px]" }, NK = { class: "space-y-6 lg:space-y-8" }, PK = {
  key: 0,
  class: "self-stretch text-2xl text-primary group-[:nth-of-type(1)]:hidden sm:hidden"
}, DK = {
  key: 0,
  class: "relative -order-1 mx-[calc(var(--pad-inner)*-1)] lg:absolute lg:inset-0 lg:left-[59%] lg:order-none lg:mx-0"
}, iZ = /* @__PURE__ */ _({
  __name: "PageHeader",
  props: {
    title: {},
    showBreadcrumb: { type: Boolean, default: !1 },
    publishedAt: {},
    readingTime: {},
    breadcrumb: {},
    image: {},
    fullwidth: { type: Boolean, default: !1 },
    tightSibling: { type: Boolean, default: !1 },
    pageBackground: { default: "background" }
  },
  setup(n) {
    const e = M(() => Array.from(n.breadcrumb || []).pop());
    return (t, r) => (b(), D("div", {
      class: fe(["pb-8 lg:pb-20", [
        t.tightSibling && t.image ? "pb-20" : "",
        t.pageBackground === "muted" ? "bg-muted" : "bg-background"
      ]])
    }, [
      O("div", {
        class: fe(["relative bg-background", [
          t.image && t.pageBackground === "background" ? "lg:pb-20" : ""
        ]])
      }, [
        O("div", MK, [
          x(c(Ri), {
            class: fe(["flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8", t.image && `
            lg:min-h-[500px]
            xl:min-h-[650px]
          `])
          }, {
            default: y(() => [
              O("div", {
                class: fe(["", c(G)([
                  t.showBreadcrumb ? "lg:pt-12" : "lg:pt-20",
                  t.tightSibling && !t.image ? `
                pb-6 pt-8
                lg:pb-8
              ` : `
                py-8
                lg:pb-20
              `,
                  t.image ? "lg:col-span-6" : "lg:col-span-8",
                  t.fullwidth && `
                lg:col-span-10 lg:col-start-2
                xl:col-span-8 xl:col-start-3
              `
                ])])
              }, [
                O("div", NK, [
                  t.showBreadcrumb ? (b(), k(c(vK), {
                    key: 0,
                    class: "-ml-4 print:hidden"
                  }, {
                    default: y(() => [
                      x(c(Up), { href: "/" }, {
                        default: y(() => [
                          x(c(EK), { class: "group-hover:hidden" }),
                          x(c(AK), { class: "hidden group-hover:inline-block group-hover:text-primary" }),
                          r[0] || (r[0] = O("span", { class: "sr-only" }, "Startseite", -1))
                        ]),
                        _: 1
                      }),
                      t.breadcrumb?.length && t.breadcrumb.length > 1 ? (b(), D("span", PK, "›")) : X("", !0),
                      t.breadcrumb?.length && t.breadcrumb.length > 1 ? (b(), k(c(wK), {
                        key: 1,
                        class: "sm:hidden"
                      })) : X("", !0),
                      x(c(Up), {
                        class: "sm:hidden",
                        href: e.value?.href,
                        current: e.value?.current
                      }, {
                        default: y(() => [
                          K(U(e.value?.label), 1)
                        ]),
                        _: 1
                      }, 8, ["href", "current"]),
                      (b(!0), D(Me, null, it(t.breadcrumb, (o, i) => (b(), k(c(Up), {
                        key: i,
                        class: "hidden sm:block",
                        href: o.href,
                        current: o.current
                      }, {
                        default: y(() => [
                          K(U(o.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["href", "current"]))), 128))
                    ]),
                    _: 1
                  })) : X("", !0),
                  E(t.$slots, "title", {}, () => [
                    x(c(Oe), { tag: "h1" }, {
                      default: y(() => [
                        K(U(t.title), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  E(t.$slots, "default")
                ])
              ], 2),
              t.image ? (b(), D("div", DK, [
                x(c(ar), {
                  image: t.image,
                  width: 800,
                  height: 750,
                  loading: "eager",
                  fetchpriority: "high",
                  class: "min-h-[200px] w-full rounded-none rounded-tr-[80px] object-cover lg:absolute lg:inset-0 lg:ml-0 lg:aspect-auto lg:h-full lg:max-h-none lg:rounded-bl-[190px] lg:rounded-tr-[190px]",
                  "art-direction": [
                    {
                      image: t.image,
                      media_condition: "(max-width: 639px)",
                      width: 640,
                      height: 200
                    },
                    {
                      image: t.image,
                      media_condition: "(max-width: 1023px)",
                      width: 1023,
                      height: 200
                    },
                    {
                      image: t.image,
                      media_condition: "(min-width: 1600px)",
                      width: 1e3,
                      height: 650
                    }
                  ]
                }, null, 8, ["image", "art-direction"])
              ])) : X("", !0)
            ]),
            _: 3
          }, 8, ["class"])
        ])
      ], 2)
    ], 2));
  }
}), gi = [
  {
    tier: "free",
    shortTitle: "Ohne Mitgliedschaft",
    longTitle: "Ohne Mitgliedschaft",
    description: "Unsere Leistungen zum Normalpreis",
    price: 0,
    orderLink: void 0,
    orderLinkTitle: "mehr dazu"
  },
  {
    tier: "basic",
    shortTitle: "Basic",
    longTitle: "Basic Mitgliedschaft",
    description: "Unser erweitertes Angebot mit 15% Mitgliedschaftsrabatt",
    price: 200,
    orderLink: "/fuer-organisationen/verein/mitgliedschaft#mitgliedschaft-beantragen",
    orderLinkTitle: "Beantragen"
  },
  {
    tier: "plus",
    shortTitle: "JobPlus",
    longTitle: "JobPlus Mitgliedschaft",
    description: "Für Organisationen mit hohem Bedarf und zusätzlichen 10% Rabatt im Stellenportal",
    price: 700,
    orderLink: "/fuer-organisationen/verein/mitgliedschaft#mitgliedschaft-beantragen",
    orderLinkTitle: "Beantragen"
  }
], Ts = [
  {
    id: "jobs",
    title: "Arbeitsmarkt",
    link: "/arbeitsmarkt",
    linkTitle: "Zum Arbeitsmarkt",
    services: [
      {
        id: "basiswissen",
        title: "Basiswissen",
        description: "Fokusartikel für den Sozialbereich zu arbeitsmarktbezogenen Themen: News, Trends, und Erkenntnisse aus der Entwicklung unseres Stellenportals.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "bildungsangebote",
        title: "Bildungsangebote",
        description: "Mitglieder von Sozialinfo publizieren kostenlos ihr Angebot an Weiterbildungen und Fachveranstaltungen für Fachpersonen der Sozialen Arbeit.",
        tiers: [
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "stelleninserat-classic",
        title: "Stelleninserat Classic",
        description: "Inserat im Stellenportal und auf Partnerseiten, Laufzeit 30 Tage, Einmaliger Versand an alle Suchabonnent*innen.",
        tiers: [
          { tier: "free", value: 275, unit: "price" },
          { tier: "basic", value: 235, unit: "price" },
          { tier: "plus", value: 205, unit: "price" }
        ]
      },
      {
        id: "stelleninserat-top",
        title: "Stelleninserat Top",
        description: "Analog “Classic” plus erneute Publikation nach 5 Tagen (inkl. Suchabos).",
        tiers: [
          { tier: "free", value: 390, unit: "price" },
          { tier: "basic", value: 335, unit: "price" },
          { tier: "plus", value: 300, unit: "price" }
        ]
      },
      {
        id: "solidaritätsrabatt",
        title: "Solidaritätsrabatt auf Stelleninserate",
        description: "Nur gültig für die Funktionen Praktikum, Ausbildungsplatz, priv. Assistenz, Zivildienst, Freiwilligenarbeit/Ehrenamt",
        tiers: [
          { tier: "free", value: 50, unit: "discount" },
          { tier: "basic", value: 50, unit: "discount" },
          { tier: "plus", value: 50, unit: "discount" }
        ]
      },
      {
        id: "inserierungs-service",
        title: "Inserierungsservice",
        description: "Auf Wunsch übernimmt Sozialinfo die Publikation des Stelleninserates.",
        tiers: [
          { tier: "free", value: 100, unit: "price" },
          { tier: "basic", value: 85, unit: "price" },
          { tier: "plus", value: 85, unit: "price" }
        ]
      }
    ]
  },
  {
    id: "digitalisation",
    title: "Digitalisierung",
    link: "/digitalisierung",
    linkTitle: "Zur Digitalisierung",
    services: [
      {
        id: "basiswissen",
        title: "Basiswissen",
        description: "Fokusartikel zur Digitalisierung im Sozialbereich und verwandten Themengebieten.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "digital-check",
        title: "DigitalCheck",
        description: "Kostenloser Online-Check, um den Stand der digitalen Transformation in der eigenen sozialen Organisation einzuschätzen.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "digital-check-plus",
        title: "DigitalCheck Plus",
        description: "Individuelle Kurzberatung zu den Ergebnissen aus dem DigitalCheck, inkl. Aufzeigen von konkreten Handlungsoptionen.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "beratung-und-begleitung",
        title: "Beratung, Coaching und Kompetenzvermittlung",
        description: "Beratung und Coaching in der digitalen Transformation sowie Kompetenzvermittlung zu fachschpezifischen Themen. Eine Offertstellung erfolgt nach individueller Absprache und gemeinsamer Auftragsklärung.",
        tiers: [
          { tier: "free", value: 180, unit: "hourlyRate" },
          { tier: "basic", value: 155, unit: "hourlyRate" },
          { tier: "plus", value: 155, unit: "hourlyRate" }
        ]
      }
    ]
  },
  {
    id: "legal",
    title: "Sozialrecht",
    link: "/sozialrecht",
    linkTitle: "Zum Sozialrecht",
    services: [
      {
        id: "basiswissen",
        title: "Basiswissen",
        description: "Fokusartikel zu sozialrechtlichen Themen.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "wissensdatenbank",
        title: "Wissensdatenbank",
        description: "Zugang zu mehr als 1600 anonymen Rechtsberatungen aus allen sechs Fachgebieten des Sozialrechts.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "rechtsberatung-kostenlos",
        title: "kostenlose Rechtsberatung",
        description: "Mitglieder erhalten eine kostenlose Rechtsberatung pro Kalenderjahr (Wert CHF 180.-)",
        tiers: [
          { tier: "basic" },
          { tier: "plus" }
        ]
      },
      {
        id: "rechtsberatung",
        title: "Rechtsberatung",
        description: "Expert*innen aus sechs Fachgebieten beantworten deine Fragen aus der Praxis. Preis pro Anfrage.",
        tiers: [
          { tier: "free", value: 180, unit: "price" },
          { tier: "basic", value: 155, unit: "price" },
          { tier: "plus", value: 155, unit: "price" }
        ]
      },
      {
        id: "rechtsberatung-5er",
        title: "Rechtsberatung im 5-er Abo",
        description: "Expert*innen aus sechs Fachgebieten beantworten deine Fragen aus der Praxis. Preis für fünf Anfragen.",
        tiers: [
          { tier: "free", value: 750, unit: "price" },
          { tier: "basic", value: 645, unit: "price" },
          { tier: "plus", value: 645, unit: "price" }
        ]
      }
    ]
  },
  {
    id: "education",
    title: "Wissen",
    link: "/wissen",
    linkTitle: "Zu den Fachinformationen",
    services: [
      {
        id: "fokusartikel",
        title: "Fokusartikel",
        description: "Fachartikel vom Redaktionsteam und von Gastautoren zu Themen, die den Sozialbereich betreffen und bewegen.",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      }
    ]
  },
  {
    id: "advertising",
    title: "Werbung auf sozialinfo.ch",
    link: "/fuer-organisationen/werbeschaltungen",
    linkTitle: "Zur Werbeschaltung",
    services: [
      {
        id: "werbeschaltungen",
        title: "Werbeschaltungen",
        description: "Kostenpflichtige Werbebanner auf sozialinfo.ch oder im Newsletter. ",
        tiers: [
          { tier: "free" },
          { tier: "basic" },
          { tier: "plus" }
        ]
      }
    ]
  }
];
function b5(n, e, t = "valueAndUnit") {
  switch (e) {
    case "price":
      return n === 0 ? "Kostenlos" : `${n}.-${t === "valueAndUnit" ? " CHF" : ""} `;
    case "discount":
      return `${n}%`;
    case "hourlyRate":
      return `${n}.-/h`;
  }
}
const IK = { class: "flex flex-row" }, RK = { class: "flex w-full flex-row lg:w-3/4" }, BK = { class: "h-full pb-5" }, LK = { class: "flex flex-row" }, FK = { class: "flex flex-1 flex-row lg:w-3/4" }, VK = { class: "flex h-full flex-col items-start justify-between gap-4 px-0 pb-4" }, zK = { class: "flex flex-col items-start" }, jK = {
  key: 1,
  class: "h-10"
}, HK = /* @__PURE__ */ _({
  __name: "PriceListFooter",
  props: {
    tiers: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D(Me, null, [
      O("div", IK, [
        r[0] || (r[0] = O("div", { class: "hidden lg:block lg:w-1/4" }, null, -1)),
        O("div", RK, [
          (b(!0), D(Me, null, it(e.tiers, (o) => (b(), D("div", {
            key: o.tier,
            class: "flex h-full flex-1 flex-col items-center justify-between border-l border-border px-1 pt-4 last:border-r"
          }, [
            O("div", BK, [
              x(c(Oe), {
                tag: "h3",
                class: "!m-0 pb-2 text-sm lg:text-xl"
              }, {
                default: y(() => [
                  K(U(o.longTitle), 1)
                ]),
                _: 2
              }, 1024),
              x(c(Oe), {
                tag: "p",
                paragraph: "label",
                class: "hyphens-auto break-words text-[12px] text-primary lg:text-xl"
              }, {
                default: y(() => [
                  K(U(o.description), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]))), 128))
        ])
      ]),
      O("div", LK, [
        r[1] || (r[1] = O("div", { class: "hidden lg:block lg:w-1/4" }, null, -1)),
        O("div", FK, [
          (b(!0), D(Me, null, it(e.tiers, (o) => (b(), D("div", {
            key: o.tier,
            class: "flex-1 border-b border-r border-border p-2 text-center first:border-l"
          }, [
            O("div", VK, [
              O("div", zK, [
                x(c(Oe), {
                  tag: "h3",
                  class: "text-sm lg:text-xl"
                }, {
                  default: y(() => [
                    K(U(c(b5)(o.price, "price", "valueAndUnit")), 1)
                  ]),
                  _: 2
                }, 1024),
                x(c(Oe), {
                  tag: "p",
                  paragraph: "label",
                  class: "text-sm text-primary lg:text-lg"
                }, {
                  default: y(() => [
                    K(U(o.price > 0 ? "pro Jahr" : " "), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              o.orderLink ? (b(), k(c(Re), {
                key: 0,
                as: "a",
                size: "full",
                href: o.orderLink,
                class: "!m-0 !p-2 text-xs lg:text-lg"
              }, {
                default: y(() => [
                  K(U(o.orderLinkTitle), 1)
                ]),
                _: 2
              }, 1032, ["href"])) : (b(), D("div", jK, "   "))
            ])
          ]))), 128))
        ])
      ])
    ], 64));
  }
}), UK = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function KK(n, e) {
  return b(), D("svg", UK, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m13.5.5l-13 13m0-13l13 13"
    }, null, -1)
  ]));
}
const WK = { name: "streamline-delete-1", render: KK }, qK = { class: "flex size-full items-center justify-center" }, GK = {
  key: 1,
  class: "flex size-[30px] items-center justify-center rounded-full border border-border bg-background",
  tabindex: "0",
  role: "img",
  "aria-label": "Service verfügbar"
}, JK = {
  key: 1,
  class: "flex size-[30px] items-center justify-center rounded-full border border-border bg-background",
  tabindex: "0",
  role: "img",
  "aria-label": "Service nicht verfügbar"
}, ZK = /* @__PURE__ */ _({
  __name: "PriceListServiceCell",
  props: {
    service: {},
    tier: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const r = e.service.tiers.find((o) => o.tier === e.tier);
      return {
        serviceTier: r,
        value: r?.value,
        unit: r?.unit || "price"
      };
    });
    return (r, o) => (b(), D("div", qK, [
      t.value.serviceTier ? (b(), D(Me, { key: 0 }, [
        t.value.value ? (b(), k(c(Oe), {
          key: 0,
          tag: "p",
          class: "!m-0 text-fluid-xxs text-primary"
        }, {
          default: y(() => [
            K(U(c(b5)(t.value.value, t.value.unit, "value")), 1)
          ]),
          _: 1
        })) : (b(), D("div", GK, [
          x(c(v5), { class: "size-6 text-primary" })
        ]))
      ], 64)) : (b(), D("div", JK, [
        x(c(WK), { class: "size-3 text-primary" })
      ]))
    ]));
  }
}), YK = /* @__PURE__ */ _({
  __name: "Collapsible",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(Mb), Le(Ve(c(o))), {
      default: y(({ open: s }) => [
        E(i.$slots, "default", { open: s })
      ]),
      _: 3
    }, 16));
  }
}), XK = /* @__PURE__ */ _({
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(Pb), j(e, { class: "overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down" }), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), QK = /* @__PURE__ */ _({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(Nb), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), eW = { class: "flex h-full flex-col lg:flex-row" }, tW = { class: "h-full border-x border-border py-4 pr-3 lg:w-1/4 lg:border-b lg:border-r-0" }, nW = { class: "flex flex-row justify-start gap-4" }, rW = {
  class: "group w-full pl-3",
  role: "button",
  "aria-label": "`Mehr Informationen zum Service ${props.service.title}`"
}, oW = { class: "flex items-center gap-2" }, iW = {
  class: "flex size-8 min-h-8 min-w-8 items-center justify-center rounded-full border border-border bg-background font-medium text-primary",
  tabindex: "-1",
  "aria-hidden": "true"
}, aW = { class: "flex flex-row lg:w-3/4" }, sW = { class: "border-x border-b border-border p-4" }, lW = /* @__PURE__ */ _({
  __name: "PriceListService",
  props: {
    service: {},
    tiers: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(YK), null, {
      default: y(() => [
        O("div", eW, [
          O("div", tW, [
            O("div", nW, [
              x(c(QK), {
                tabindex: "0",
                "as-child": ""
              }, {
                default: y(() => [
                  O("div", rW, [
                    O("div", oW, [
                      O("div", iW, [
                        x(c(xs), {
                          class: "size-5 select-none focus:outline-none group-data-[state=open]:rotate-180",
                          tabindex: "-1",
                          "aria-hidden": "true"
                        })
                      ]),
                      x(c(Oe), {
                        tag: "h3",
                        class: "!mt-0 text-fluid-sm"
                      }, {
                        default: y(() => [
                          K(U(e.service.title), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          O("div", aW, [
            (b(!0), D(Me, null, it(e.tiers, (o) => (b(), D("div", {
              key: o.tier,
              class: "flex-1 border-b border-border pb-4 first:border-l last:border-r lg:border-r lg:pb-0"
            }, [
              x(ZK, {
                tier: o.tier,
                service: t.service
              }, null, 8, ["tier", "service"])
            ]))), 128))
          ])
        ]),
        x(c(XK), null, {
          default: y(() => [
            O("div", sW, [
              x(c(Oe), {
                tag: "p",
                class: "text-fluid-xs text-foreground"
              }, {
                default: y(() => [
                  K(U(t.service.description), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), dW = ["href"], uW = {
  id: "group.id",
  class: "flex items-center justify-between bg-primary p-4",
  tabindex: "0"
}, cW = { class: "flex items-center gap-1 text-background" }, As = /* @__PURE__ */ _({
  __name: "PriceListGroup",
  props: {
    group: {},
    tiers: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D(Me, null, [
      O("a", {
        href: t.group.link
      }, [
        O("div", uW, [
          x(c(Oe), {
            tag: "h3",
            class: "text-fluid-base text-background"
          }, {
            default: y(() => [
              K(U(t.group.title), 1)
            ]),
            _: 1
          }),
          O("div", cW, [
            x(c(Oe), {
              tag: "p",
              class: "!m-0 hidden text-sm lg:block lg:text-base"
            }, {
              default: y(() => [
                K(U(t.group.linkTitle), 1)
              ]),
              _: 1
            }),
            x(c(If), { class: "text-sm lg:text-base" })
          ])
        ])
      ], 8, dW),
      (b(!0), D(Me, null, it(e.group?.services || [], (o) => (b(), k(lW, {
        key: o.id,
        service: o,
        tiers: e.tiers
      }, null, 8, ["service", "tiers"]))), 128))
    ], 64));
  }
}), fW = {
  key: 0,
  class: "sticky top-0 flex flex-row bg-background"
}, pW = { class: "flex w-full flex-row lg:w-3/4" }, hW = { class: "flex flex-row" }, mW = { class: "flex flex-1 flex-row lg:w-3/4" }, gW = /* @__PURE__ */ _({
  __name: "PriceListHeader",
  props: {
    tiers: {}
  },
  setup(n) {
    const e = n;
    function t(a, s = "priceOnly") {
      switch (s) {
        case "priceAndCurrency":
          return a.price === 0 ? "kostenlos" : `CHF ${a.price}.-`;
        case "priceAndPeriod":
          return a.price === 0 ? a.shortTitle : `${a.shortTitle}: ${a.price}.-/Jahr`;
        case "priceOnly":
        default:
          return a.price === 0 ? "Kostenlos" : `${a.price}.-`;
      }
    }
    const { isSticky: r, scrollWatcher: o } = i();
    function i() {
      const a = B(null), s = B(!1), l = () => {
        if (a.value === null)
          return;
        const d = a.value.getBoundingClientRect();
        s.value = d.top <= 0;
      };
      return Ge(() => {
        window.addEventListener("scroll", l);
      }), xr(() => {
        window.removeEventListener("scroll", l);
      }), { isSticky: s, scrollWatcher: a };
    }
    return (a, s) => (b(), D(Me, null, [
      c(r) ? (b(), D("div", fW, [
        s[0] || (s[0] = O("div", { class: "hidden border-b border-border lg:block lg:w-1/4" }, null, -1)),
        O("div", pW, [
          (b(!0), D(Me, null, it(e.tiers, (l) => (b(), D("div", {
            key: l.tier,
            class: "flex flex-1 flex-col items-center justify-between gap-2 border-y border-r border-border px-2 py-4 text-center first:border-l lg:flex-row"
          }, [
            x(c(Oe), {
              tag: "h3",
              class: "!m-0 hyphens-none text-fluid-xxxs",
              paragraph: "label"
            }, {
              default: y(() => [
                K(U(t(l, "priceAndPeriod")), 1)
              ]),
              _: 2
            }, 1024),
            l.orderLink ? (b(), k(c(Re), {
              key: 0,
              as: "a",
              href: l.orderLink,
              class: "!m-0 !p-2 text-xs lg:text-lg"
            }, {
              default: y(() => [
                K(U(l.orderLinkTitle), 1)
              ]),
              _: 2
            }, 1032, ["href"])) : X("", !0)
          ]))), 128))
        ])
      ])) : X("", !0),
      O("div", {
        ref_key: "scrollWatcher",
        ref: o
      }, null, 512),
      O("div", hW, [
        s[1] || (s[1] = O("div", { class: "hidden lg:block lg:w-1/4" }, null, -1)),
        O("div", mW, [
          (b(!0), D(Me, null, it(e.tiers, (l) => (b(), D("div", {
            key: l.tier,
            class: "flex-1 border-r border-t border-border p-2 text-center first:border-l"
          }, [
            x(c(Oe), {
              tag: "h4",
              class: "!m-0 text-fluid-xxxs"
            }, {
              default: y(() => [
                K(U(l.shortTitle), 1)
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ])
      ])
    ], 64));
  }
}), vW = { class: "bg-background" }, aZ = /* @__PURE__ */ _({
  __name: "PriceList",
  props: {
    jobs: { type: Boolean, default: !0 },
    digitalisation: { type: Boolean, default: !0 },
    legal: { type: Boolean, default: !0 },
    education: { type: Boolean, default: !0 },
    advertising: { type: Boolean, default: !0 },
    footer: { type: Boolean, default: !0 }
  },
  setup(n) {
    return (e, t) => (b(), D("div", vW, [
      x(gW, { tiers: c(gi) }, null, 8, ["tiers"]),
      e.jobs ? (b(), k(As, {
        key: 0,
        group: c(Ts).find((r) => r.id === "jobs"),
        tiers: c(gi)
      }, null, 8, ["group", "tiers"])) : X("", !0),
      e.digitalisation ? (b(), k(As, {
        key: 1,
        group: c(Ts).find((r) => r.id === "digitalisation"),
        tiers: c(gi)
      }, null, 8, ["group", "tiers"])) : X("", !0),
      e.legal ? (b(), k(As, {
        key: 2,
        group: c(Ts).find((r) => r.id === "legal"),
        tiers: c(gi)
      }, null, 8, ["group", "tiers"])) : X("", !0),
      e.education ? (b(), k(As, {
        key: 3,
        group: c(Ts).find((r) => r.id === "education"),
        tiers: c(gi)
      }, null, 8, ["group", "tiers"])) : X("", !0),
      e.advertising ? (b(), k(As, {
        key: 4,
        group: c(Ts).find((r) => r.id === "advertising"),
        tiers: c(gi)
      }, null, 8, ["group", "tiers"])) : X("", !0),
      e.footer === !0 ? (b(), k(HK, {
        key: 5,
        tiers: c(gi)
      }, null, 8, ["tiers"])) : X("", !0)
    ]));
  }
}), yW = { class: "flex flex-col gap-8 sm:flex-row sm:gap-11" }, bW = {
  key: 1,
  class: "aspect-video w-full flex-none rounded bg-primary/30 sm:aspect-square sm:w-1/2"
}, $W = { class: "max-w-xl flex-auto space-y-5 lg:space-y-10 sm:w-1/2" }, wW = { key: 0 }, xW = { key: 1 }, CW = { key: 2 }, kW = { key: 3 }, _W = { key: 4 }, SW = ["href"], EW = ["href"], sZ = /* @__PURE__ */ _({
  __name: "TeamMember",
  props: {
    name: {},
    pronoun: {},
    contact: {},
    image: {},
    jobTitle: {},
    employer: {},
    education: {},
    quote: {}
  },
  setup(n) {
    return (e, t) => (b(), D("li", yW, [
      e.image ? (b(), k(c(ar), {
        key: 0,
        class: "aspect-video w-full flex-none overflow-hidden rounded object-cover sm:aspect-square",
        wrapper_classes: "w-full sm:w-1/2",
        image: e.image,
        width: 450,
        height: 450
      }, null, 8, ["image"])) : (b(), D("div", bW)),
      O("div", $W, [
        O("div", null, [
          x(c(Oe), { tag: "h2" }, {
            default: y(() => [
              K(U(e.name), 1)
            ]),
            _: 1
          }),
          e.pronoun ? (b(), k(c(Oe), {
            key: 0,
            tag: "p",
            paragraph: "label",
            class: "!mt-0"
          }, {
            default: y(() => [
              K(U(e.pronoun.replace(/_/g, "/")), 1)
            ]),
            _: 1
          })) : X("", !0)
        ]),
        e.jobTitle || e.employer ? (b(), D("div", wW, [
          e.jobTitle ? (b(), k(c(Oe), {
            key: 0,
            tag: "p"
          }, {
            default: y(() => [
              K(U(e.jobTitle), 1)
            ]),
            _: 1
          })) : X("", !0),
          e.employer ? (b(), k(c(Oe), {
            key: 1,
            tag: "p",
            class: "font-bold"
          }, {
            default: y(() => t[0] || (t[0] = [
              K(" Arbeitgeber*in ")
            ])),
            _: 1
          })) : X("", !0),
          e.employer ? (b(), k(c(Oe), {
            key: 2,
            tag: "p",
            class: "!mt-0"
          }, {
            default: y(() => [
              K(U(e.employer), 1)
            ]),
            _: 1
          })) : X("", !0)
        ])) : X("", !0),
        e.education ? (b(), D("div", xW, [
          x(c(Oe), {
            tag: "p",
            class: "font-bold"
          }, {
            default: y(() => t[1] || (t[1] = [
              K(" Ausbildung ")
            ])),
            _: 1
          }),
          x(c(Oe), {
            tag: "p",
            class: "!mt-0"
          }, {
            default: y(() => [
              K(U(e.education), 1)
            ]),
            _: 1
          })
        ])) : X("", !0),
        e.$slots.description ? (b(), D("div", CW, [
          x(c(Oe), {
            tag: "p",
            class: "font-bold"
          }, {
            default: y(() => t[2] || (t[2] = [
              K(" Weiteres ")
            ])),
            _: 1
          }),
          E(e.$slots, "description")
        ])) : X("", !0),
        e.quote ? (b(), D("div", kW, [
          x(c(Oe), {
            tag: "p",
            class: "font-bold"
          }, {
            default: y(() => t[3] || (t[3] = [
              K(" Leitsatz ")
            ])),
            _: 1
          }),
          x(c(Oe), {
            tag: "p",
            class: "!mt-0"
          }, {
            default: y(() => [
              K(U(e.quote), 1)
            ]),
            _: 1
          })
        ])) : X("", !0),
        e.contact?.email || e.contact?.phone ? (b(), D("div", _W, [
          x(c(Oe), {
            tag: "p",
            class: "font-bold"
          }, {
            default: y(() => t[4] || (t[4] = [
              K(" Kontakt ")
            ])),
            _: 1
          }),
          x(c(Oe), {
            tag: "p",
            class: "!mt-0"
          }, {
            default: y(() => [
              O("a", {
                href: `mailto:${e.contact.email}`,
                class: "text-primary"
              }, U(e.contact.email), 9, SW)
            ]),
            _: 1
          }),
          x(c(Oe), {
            tag: "p",
            class: "!mt-0"
          }, {
            default: y(() => [
              O("a", {
                href: `tel:${e.contact.phone}`,
                class: "text-primary"
              }, U(e.contact.phone), 9, EW)
            ]),
            _: 1
          })
        ])) : X("", !0)
      ])
    ]));
  }
}), vm = [];
function OW(n, e) {
  let t, r = !1;
  return () => {
    t && clearTimeout(t), r ? t = setTimeout(n, e) : (n(), (r = !0) && setTimeout(() => r = !1, e));
  };
}
function TW(n, e) {
  if (e === !1)
    return [];
  const t = (typeof e == "object" && !Array.isArray(e) ? e.level : e) || 2, [r, o] = typeof t == "number" ? [t, t] : t === "deep" ? [2, 6] : t;
  n = n.filter((a) => a.level >= r && a.level <= o), vm.length = 0;
  for (const { element: a, link: s } of n)
    vm.push({ element: a, link: s });
  const i = [];
  e:
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      if (a === 0)
        i.push(s);
      else {
        for (let l = a - 1; l >= 0; l--) {
          const d = n[l];
          if (d.level < s.level) {
            (d.children || (d.children = [])).push(s);
            continue e;
          }
        }
        i.push(s);
      }
    }
  return i;
}
function AW() {
  const n = [
    ...document.querySelectorAll(":where(h1,h2,h3,h4,h5,h6)")
  ].filter((e) => e.id && e.hasChildNodes()).filter((e) => e.querySelector(".ignore-header") === null).map((e) => {
    const t = Number(e.tagName[1]);
    return {
      element: e,
      title: MW(e),
      link: `#${e.id}`,
      level: t
    };
  });
  return TW(n, [2, 3]);
}
function MW(n) {
  let e = "";
  for (const t of n.childNodes)
    if (t.nodeType === 1) {
      if (t.classList.contains("header-anchor") || t.classList.contains("ignore-header"))
        continue;
      e += t.textContent;
    } else
      t.nodeType === 3 && (e += t.textContent);
  return e.trim();
}
function NW(n, e) {
  const t = OW(o, 100);
  let r = null;
  Ge(() => {
    requestAnimationFrame(o), window.addEventListener("scroll", t);
  }), A2(() => {
    i(location.hash);
  }), Qn(() => {
    window.removeEventListener("scroll", t);
  });
  function o() {
    const a = window.scrollY, s = window.innerHeight, l = document.body.offsetHeight, d = Math.abs(a + s - l) < 1, u = vm.map(({ element: p, link: h }) => ({
      link: h,
      top: PW(p)
    })).filter(({ top: p }) => !Number.isNaN(p)).sort((p, h) => p.top - h.top);
    if (!u.length) {
      i(null);
      return;
    }
    if (a < 1) {
      i(null);
      return;
    }
    if (d) {
      i(u[u.length - 1].link);
      return;
    }
    let f = null;
    for (const { link: p, top: h } of u) {
      if (h > a + 0 + 4)
        break;
      f = p;
    }
    i(f);
  }
  function i(a) {
    r && r.classList.remove("active"), a == null ? r = null : r = n.value.querySelector(
      `a[href="${decodeURIComponent(a)}"]`
    );
    const s = r;
    s ? (s.classList.add("active"), e.value.style.top = `${s.offsetTop + 39}px`, e.value.style.opacity = "1") : (e.value.style.top = "33px", e.value.style.opacity = "0");
  }
}
function PW(n) {
  let e = 0;
  for (; n !== document.body; ) {
    if (n === null)
      return Number.NaN;
    e += n.offsetTop, n = n.offsetParent;
  }
  return e;
}
const DW = ["href", "title"], IW = /* @__PURE__ */ _({
  __name: "TOCNavItem",
  props: {
    headers: {},
    root: { type: Boolean }
  },
  setup(n) {
    function e({ target: t }) {
      const r = t.href.split("#")[1];
      document.getElementById(decodeURIComponent(r))?.focus({ preventScroll: !0 });
    }
    return (t, r) => {
      const o = F5("TOCNavItem", !0);
      return b(), D("ul", {
        class: fe(t.root ? "relative z-10" : "pl-2")
      }, [
        (b(!0), D(Me, null, it(t.headers, ({ children: i, link: a, title: s }) => (b(), D("li", { key: a }, [
          O("a", {
            class: "block leading-7 transition-colors [&.active]:font-bold [&.active]:text-primary hover:text-primary hover:active:font-bold hover:active:transition",
            href: a,
            title: s,
            onClick: e
          }, U(s), 9, DW),
          i?.length ? (b(), k(o, {
            key: 0,
            headers: i
          }, null, 8, ["headers"])) : X("", !0)
        ]))), 128))
      ], 2);
    };
  }
}), RW = { class: "relative pl-2 text-sm font-medium" }, BW = { "aria-labelledby": "doc-outline-aria-label" }, lZ = /* @__PURE__ */ _({
  __name: "TOCNav",
  setup(n) {
    const e = M(() => AW()), t = B(), r = B();
    return NW(t, r), (o, i) => (b(), D("div", {
      ref_key: "container",
      ref: t,
      class: fe(["rounded rounded-br-none rounded-tl-none bg-muted p-4", { hidden: e.value.length === 0 }]),
      role: "navigation"
    }, [
      O("div", RW, [
        O("div", {
          ref_key: "marker",
          ref: r,
          class: "absolute -left-1.5 top-[32px] z-0 size-1.5 rounded-full bg-primary opacity-0 transition-all duration-200 [transition-timing-function:cubic-bezier(0,1,0.5,1)]"
        }, null, 512),
        i[1] || (i[1] = O("div", {
          class: "text-sm font-bold leading-7",
          role: "heading",
          "aria-level": "2"
        }, " Auf dieser Seite ", -1)),
        O("nav", BW, [
          i[0] || (i[0] = O("span", {
            id: "doc-outline-aria-label",
            class: "sr-only"
          }, " Inhaltsverzeichnis für die aktuelle Seite ", -1)),
          x(IW, {
            headers: e.value,
            root: !0
          }, null, 8, ["headers"])
        ])
      ])
    ], 2));
  }
}), dZ = /* @__PURE__ */ _({
  __name: "Accordion",
  props: {
    collapsible: { type: Boolean },
    disabled: { type: Boolean },
    dir: {},
    orientation: {},
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(yC), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), LW = { class: "pb-14 pt-4" }, FW = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(wC), j(e, {
      class: c(G)(
        `
          overflow-hidden transition-all
          data-[state=closed]:animate-accordion-up
          data-[state=open]:animate-accordion-down
        `,
        t.$attrs.class
      )
    }), {
      default: y(() => [
        O("div", LW, [
          E(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), VW = /* @__PURE__ */ _({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c($C), j(c(r), {
      class: c(G)(`
      border-b
      first:border-t
    `, e.class ?? "")
    }), {
      default: y(({ open: a }) => [
        E(o.$slots, "default", { open: a })
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), uZ = /* @__PURE__ */ _({
  __name: "AccordionItemContainer",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {},
    class: {},
    itemTitle: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(VW), j(e, {
      class: c(G)("border-b", t.$attrs.class ?? "")
    }), {
      default: y(({ open: o }) => [
        x(c(jW), { open: o }, {
          default: y(() => [
            K(U(t.itemTitle), 1)
          ]),
          _: 2
        }, 1032, ["open"]),
        x(c(FW), null, {
          default: y(() => [
            E(t.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), zW = { class: "mr-4 flex size-12 flex-none items-center justify-center rounded-full bg-background text-primary @lg:size-14 group-hover:bg-accent group-hover:text-accent-foreground" }, jW = /* @__PURE__ */ _({
  __name: "AccordionTrigger",
  props: {
    open: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(xC), {
      as: "div",
      class: "@container"
    }, {
      default: y(() => [
        x(c(CC), j(e, {
          class: c(G)(
            `
            group flex w-full flex-1 items-center justify-between py-4 text-left
            transition-all
            [&[data-state=open]_svg]:rotate-45
            focus-visible:bg-accent focus-visible:text-accent-foreground
            focus:outline-none
          `,
            t.$attrs.class
          )
        }), {
          default: y(() => [
            E(t.$slots, "fullContent", {}, () => [
              x(c(Oe), { tag: "span" }, {
                default: y(() => [
                  E(t.$slots, "default")
                ]),
                _: 3
              }),
              E(t.$slots, "icon", {}, () => [
                O("span", zW, [
                  x(c(f5), { class: "size-5 transition-transform duration-200 @lg:size-6" })
                ])
              ])
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
});
function HW() {
  const n = B([]), e = (r) => n.value.length > 0 && !!n.value.find((o) => o && o.id === r.id), t = (r) => {
    e(r) ? n.value = n.value.filter((o) => !(o && o.id === r.id)) : n.value.push(r), localStorage.setItem("favorites", JSON.stringify(n.value));
  };
  return Ge(() => {
    const r = localStorage.getItem("favorites");
    r && (n.value = JSON.parse(r));
  }), {
    favorites: n,
    isFavorite: e,
    toggleFavorite: t
  };
}
const UW = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function KW(n, e) {
  return b(), D("svg", UW, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11 13.5l-4-4l-4 4v-12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"
    }, null, -1)
  ]));
}
const WW = { name: "streamline-bookmark", render: KW }, qW = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function GW(n, e) {
  return b(), D("svg", qW, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      d: "M4 0a1.5 1.5 0 0 0-1.5 1.5v12a.5.5 0 0 0 .854.354L7 10.207l3.646 3.647a.5.5 0 0 0 .854-.354v-12A1.5 1.5 0 0 0 10 0z"
    }, null, -1)
  ]));
}
const JW = { name: "streamline-bookmark-solid", render: GW }, ZW = { class: "sr-only" }, cZ = /* @__PURE__ */ _({
  __name: "BookmarkButton",
  props: {
    item: {},
    screenReaderTitle: { default: "Diesen Artikel in den Favoriten speichern" }
  },
  emits: ["toggleBookmark"],
  setup(n) {
    const { toggleFavorite: e, isFavorite: t } = HW();
    return (r, o) => (b(), k(c(Re), {
      class: "relative z-10",
      variant: "ghost",
      size: "icon",
      onClick: o[0] || (o[0] = (i) => c(e)(r.item))
    }, {
      default: y(() => [
        O("span", ZW, U(r.screenReaderTitle), 1),
        c(t)(r.item) ? (b(), k(c(JW), {
          key: 0,
          role: "img",
          "aria-hidden": "true"
        })) : (b(), k(c(WW), {
          key: 1,
          role: "img",
          "aria-hidden": "true"
        }))
      ]),
      _: 1
    }));
  }
}), YW = /* @__PURE__ */ _({
  __name: "Skeleton",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(c(G)("animate-pulse rounded-xs bg-muted", e.class))
    }, null, 2));
  }
}), XW = { class: "flex flex-col" }, QW = { class: "flex justify-between text-muted-foreground" }, fZ = /* @__PURE__ */ _({
  __name: "CardTeaser",
  props: {
    title: {},
    href: {},
    level: {},
    variant: {},
    isLoading: { type: Boolean },
    titleClass: {},
    linkComponent: { default: "a" }
  },
  setup(n) {
    const e = Nc();
    return (t, r) => (b(), k(c(vl), {
      class: "group relative flex h-full flex-col transition-shadow brutal:border has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-primary has-[.card-link:focus-visible]:outline hover:shadow hover:transition-shadow",
      as: "article",
      variant: t.variant
    }, {
      default: y(() => [
        O("div", XW, [
          x(c(yl), { class: "flex flex-none flex-col px-6 pt-6" }, {
            default: y(() => [
              O("div", QW, [
                E(t.$slots, "meta")
              ]),
              t.isLoading ? X("", !0) : (b(), k(Qt(t.linkComponent), {
                key: 0,
                href: t.href,
                class: "cursor-pointer card-link after:absolute after:inset-0 focus-visible:outline-none",
                "aria-label": t.title
              }, {
                default: y(() => [
                  x(c(gu), {
                    level: t.level || 3,
                    class: fe(t.titleClass)
                  }, {
                    default: y(() => [
                      K(U(t.title), 1)
                    ]),
                    _: 1
                  }, 8, ["level", "class"])
                ]),
                _: 1
              }, 8, ["href", "aria-label"])),
              t.isLoading ? (b(), k(c(YW), {
                key: 1,
                class: "!mt-7 block h-5 w-4/5 bg-primary"
              })) : X("", !0),
              c(e).header ? (b(), D("div", {
                key: 2,
                class: fe(c(e).header ? "mt-2" : "")
              }, [
                E(t.$slots, "header")
              ], 2)) : X("", !0)
            ]),
            _: 3
          })
        ]),
        c(e).content ? (b(), k(c(Lo), {
          key: 0,
          class: "px-6"
        }, {
          default: y(() => [
            E(t.$slots, "content")
          ]),
          _: 3
        })) : X("", !0),
        c(e).footer ? (b(), k(c(z2), {
          key: 1,
          class: "flex grow flex-col justify-end px-6"
        }, {
          default: y(() => [
            E(t.$slots, "footer")
          ]),
          _: 3
        })) : X("", !0)
      ]),
      _: 3
    }, 8, ["variant"]));
  }
});
(function() {
  try {
    if (typeof document < "u") {
      var n = document.createElement("style");
      n.appendChild(document.createTextNode('[vaul-drawer]{touch-action:none;transform:translate3d(0,100%,0);transition:transform .5s cubic-bezier(.32,.72,0,1)}.vaul-dragging .vaul-scrollable{overflow-y:hidden!important}[vaul-drawer][vaul-drawer-visible=true]{transform:translate3d(0,var(--snap-point-height, 0),0)}[vaul-overlay]{opacity:0;transition:opacity .5s cubic-bezier(.32,.72,0,1)}[vaul-overlay][vaul-drawer-visible=true]{opacity:1}[vaul-drawer]:after{content:"";position:absolute;top:100%;background:inherit;background-color:inherit;left:0;right:0;height:200%}[vaul-overlay][vaul-snap-points=true]:not([vaul-snap-points-overlay=true]):not([data-state=closed]){opacity:0}[vaul-overlay][vaul-snap-points-overlay=true]:not([vaul-drawer-visible=false]){opacity:1}@keyframes fake-animation{}@media (hover: hover) and (pointer: fine){[vaul-drawer]{-webkit-user-select:none;user-select:none}}')), document.head.appendChild(n);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
const eq = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const tq = (n) => typeof n < "u";
function nq(n) {
  return JSON.parse(JSON.stringify(n));
}
function g2(n, e, t, r = {}) {
  var o, i, a;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: d,
    deep: u = !1,
    defaultValue: f,
    shouldEmit: p
  } = r, h = sn(), m = t || h?.emit || ((o = h?.$emit) == null ? void 0 : o.bind(h)) || ((a = (i = h?.proxy) == null ? void 0 : i.$emit) == null ? void 0 : a.bind(h?.proxy));
  let g = d;
  e || (e = "modelValue"), g = g || `update:${e.toString()}`;
  const v = (S) => s ? typeof s == "function" ? s(S) : nq(S) : S, $ = () => tq(n[e]) ? v(n[e]) : f, C = (S) => {
    p ? p(S) && m(g, S) : m(g, S);
  };
  if (l) {
    const S = $(), w = B(S);
    let T = !1;
    return De(
      () => n[e],
      (A) => {
        T || (T = !0, w.value = v(A), Be(() => T = !1));
      }
    ), De(
      w,
      (A) => {
        !T && (A !== n[e] || u) && C(A);
      },
      { deep: u }
    ), w;
  } else
    return M({
      get() {
        return $();
      },
      set(S) {
        C(S);
      }
    });
}
const [$5, rq] = Xe("DrawerRoot"), w5 = /* @__PURE__ */ new WeakMap();
function xt(n, e, t = !1) {
  if (!n || !(n instanceof HTMLElement) || !e)
    return;
  const r = {};
  Object.entries(e).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      n.style.setProperty(o, i);
      return;
    }
    r[o] = n.style[o], n.style[o] = i;
  }), !t && w5.set(n, r);
}
function Zd(n, e) {
  if (!n || !(n instanceof HTMLElement))
    return;
  const t = w5.get(n);
  t && (e ? n.style[e] = t[e] : Object.entries(t).forEach(([r, o]) => {
    n.style[r] = o;
  }));
}
function Yd(n) {
  const e = window.getComputedStyle(n), t = e.transform || e.webkitTransform || e.mozTransform;
  let r = t.match(/^matrix3d\((.+)\)$/);
  return r ? Number.parseFloat(r[1].split(", ")[13]) : (r = t.match(/^matrix\((.+)\)$/), r ? Number.parseFloat(r[1].split(", ")[5]) : null);
}
function oq(n) {
  return 8 * (Math.log(n + 1) - 2);
}
const mt = {
  DURATION: 0.5,
  EASE: [0.32, 0.72, 0, 1]
}, x5 = 0.4;
function iq({
  activeSnapPoint: n,
  snapPoints: e,
  drawerRef: t,
  overlayRef: r,
  fadeFromIndex: o,
  onSnapPointChange: i
}) {
  const a = M(
    () => (e.value && n.value === e.value[e.value.length - 1]) ?? null
  ), s = M(
    () => e.value && e.value.length > 0 && (o?.value || o?.value === 0) && !Number.isNaN(o?.value) && e.value[o?.value ?? -1] === n.value || !e.value
  ), l = M(
    () => {
      var g;
      return ((g = e.value) == null ? void 0 : g.findIndex((v) => v === n.value)) ?? null;
    }
  ), d = M(
    () => {
      var g;
      return ((g = e.value) == null ? void 0 : g.map((v) => {
        const $ = typeof window < "u", C = typeof v == "string";
        let S = 0;
        C && (S = Number.parseInt(v, 10));
        const w = C ? S : $ ? v * window.innerHeight : 0;
        return $ ? window.innerHeight - w : w;
      })) ?? [];
    }
  ), u = M(
    () => {
      var g;
      return l.value !== null ? (g = d.value) == null ? void 0 : g[l.value] : null;
    }
  ), f = (g) => {
    var v, $, C, S;
    const w = ((v = d.value) == null ? void 0 : v.findIndex((T) => T === g)) ?? null;
    Be(() => {
      var T;
      i(w, d.value), xt((T = t.value) == null ? void 0 : T.$el, {
        transition: `transform ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`,
        transform: `translate3d(0, ${g}px, 0)`
      });
    }), d.value && w !== d.value.length - 1 && w !== o?.value ? xt(($ = r.value) == null ? void 0 : $.$el, {
      transition: `opacity ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`,
      opacity: "0"
    }) : xt((C = r.value) == null ? void 0 : C.$el, {
      transition: `opacity ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`,
      opacity: "1"
    }), n.value = w !== null ? ((S = e.value) == null ? void 0 : S[w]) ?? null : null;
  };
  De(
    [n, d, e],
    () => {
      var g;
      if (n.value) {
        const v = ((g = e.value) == null ? void 0 : g.findIndex(($) => $ === n.value)) ?? -1;
        d.value && v !== -1 && typeof d.value[v] == "number" && f(d.value[v]);
      }
    },
    {
      immediate: !0
      // if you want to run the effect immediately as well
    }
  );
  function p({
    draggedDistance: g,
    closeDrawer: v,
    velocity: $,
    dismissible: C
  }) {
    var S, w, T;
    if (o === void 0)
      return;
    const A = (u.value ?? 0) - g, N = l.value === (o.value ?? 0) - 1, z = l.value === 0, I = g > 0;
    if (N && xt((S = r.value) == null ? void 0 : S.$el, {
      transition: `opacity ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`
    }), $ > 2 && !I) {
      C ? v() : f(d.value[0]);
      return;
    }
    if ($ > 2 && I && d && e.value) {
      f(d.value[e.value.length - 1]);
      return;
    }
    const P = (w = d.value) == null ? void 0 : w.reduce((L, H) => typeof L != "number" || typeof H != "number" ? L : Math.abs(H - A) < Math.abs(L - A) ? H : L);
    if ($ > x5 && Math.abs(g) < window.innerHeight * 0.4) {
      const L = I ? 1 : -1;
      if (L > 0 && a) {
        f(d.value[(((T = e.value) == null ? void 0 : T.length) ?? 0) - 1]);
        return;
      }
      if (z && L < 0 && C && v(), l.value === null)
        return;
      f(d.value[l.value + L]);
      return;
    }
    f(P);
  }
  function h({ draggedDistance: g }) {
    var v;
    if (u.value === null)
      return;
    const $ = u.value - g;
    xt((v = t.value) == null ? void 0 : v.$el, {
      transform: `translate3d(0, ${$}px, 0)`
    });
  }
  function m(g, v) {
    if (!e || typeof l.value != "number" || !d.value || o === void 0)
      return null;
    const $ = l.value === (o.value ?? 0) - 1;
    if (l.value >= (o.value ?? 0) && v)
      return 0;
    if ($ && !v)
      return 1;
    if (!s.value && !$)
      return null;
    const C = $ ? l.value + 1 : l.value - 1, S = $ ? d.value[C] - d.value[C - 1] : d.value[C + 1] - d.value[C], w = g / Math.abs(S);
    return $ ? 1 - w : w;
  }
  return {
    isLastSnapPoint: a,
    shouldFade: s,
    getPercentageDragged: m,
    activeSnapPointIndex: l,
    onRelease: p,
    onDrag: h,
    snapPointsOffset: d
  };
}
let Ms = null;
function aq(n) {
  const { isOpen: e, modal: t, nested: r, hasBeenOpened: o } = n, i = B(typeof window < "u" ? window.location.href : ""), a = B(0);
  function s() {
    if (Ms === null && e.value) {
      Ms = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height
      };
      const { scrollX: d, innerHeight: u } = window;
      document.body.style.position = "fixed", document.body.style.top = `-${a.value}px`, document.body.style.left = `-${d}px`, document.body.style.right = "0px", document.body.style.height = "auto", setTimeout(() => {
        requestAnimationFrame(() => {
          const f = u - window.innerHeight;
          f && a.value >= u && (document.body.style.top = `-${a.value + f}px`);
        });
      }, 300);
    }
  }
  function l() {
    if (Ms !== null) {
      const d = -Number.parseInt(document.body.style.top, 10), u = -Number.parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Ms), requestAnimationFrame(() => {
        if (i.value !== window.location.href) {
          i.value = window.location.href;
          return;
        }
        window.scrollTo(u, d);
      }), Ms = null;
    }
  }
  return Ge(() => {
    function d() {
      a.value = window.scrollY;
    }
    d(), window.addEventListener("scroll", d), Qn(() => {
      window.removeEventListener("scroll", d);
    });
  }), De([e, o, i], () => {
    r.value || !o.value || (e.value ? (s(), t || setTimeout(() => {
      l();
    }, 500)) : l());
  }), { restorePositionSetting: l };
}
const sq = 0.25, lq = 100, v2 = 8, vi = 16, dq = 26, y2 = "vaul-dragging";
function uq(n, e) {
  return n && n.value ? n : e;
}
function cq(n) {
  const {
    emitDrag: e,
    emitRelease: t,
    emitClose: r,
    emitOpenChange: o,
    open: i,
    dismissible: a,
    nested: s,
    fixed: l,
    modal: d,
    shouldScaleBackground: u,
    scrollLockTimeout: f,
    closeThreshold: p,
    activeSnapPoint: h,
    fadeFromIndex: m
  } = n, g = B(i.value ?? !1), v = B(!1), $ = B(!1), C = B(!1), S = B(!1), w = B(null), T = B(null), A = B(null), N = B(null), z = B(null), I = B(!0), P = B(null), L = B(0), H = B(!1);
  B(0);
  const q = B(null);
  B(0);
  const Q = M(() => {
    var me;
    return ((me = q.value) == null ? void 0 : me.$el.getBoundingClientRect().height) || 0;
  }), ae = uq(
    n.snapPoints,
    B(void 0)
  ), {
    activeSnapPointIndex: de,
    onRelease: ne,
    snapPointsOffset: ke,
    onDrag: ee,
    shouldFade: be,
    getPercentageDragged: Ee
  } = iq({
    snapPoints: ae,
    activeSnapPoint: h,
    drawerRef: q,
    fadeFromIndex: m,
    overlayRef: w,
    onSnapPointChange: nt
  });
  function nt(me, Pe) {
    ae.value && me === Pe.length - 1 && (T.value = /* @__PURE__ */ new Date());
  }
  const { restorePositionSetting: ct } = aq({
    isOpen: g,
    modal: d,
    nested: s,
    hasBeenOpened: v
  });
  function Ne() {
    return (window.innerWidth - dq) / window.innerWidth;
  }
  function st(me, Pe) {
    var Qe;
    if (!me)
      return !1;
    let Je = me;
    const rt = (Qe = window.getSelection()) == null ? void 0 : Qe.toString(), et = q.value ? Yd(q.value.$el) : null, ht = /* @__PURE__ */ new Date();
    if (Je.hasAttribute("data-vaul-no-drag") || Je.closest("[data-vaul-no-drag]") || T.value && ht.getTime() - T.value.getTime() < 500)
      return !1;
    if (et && et > 0)
      return !0;
    if (rt && rt.length > 0)
      return !1;
    if (z.value && ht.getTime() - z.value.getTime() < f.value && et === 0 || Pe)
      return z.value = ht, !1;
    for (; Je; ) {
      if (Je.scrollHeight > Je.clientHeight) {
        if (Je.scrollTop !== 0)
          return z.value = /* @__PURE__ */ new Date(), !1;
        if (Je.getAttribute("role") === "dialog")
          return !0;
      }
      Je = Je.parentNode;
    }
    return !0;
  }
  function ce(me) {
    !a.value && !ae.value || q.value && !q.value.$el.contains(me.target) || (C.value = !0, A.value = /* @__PURE__ */ new Date(), me.target.setPointerCapture(me.pointerId), L.value = me.screenY);
  }
  function he(me) {
    var Pe, Qe, Je, rt, et, ht;
    if (C.value) {
      const nn = L.value - me.screenY, Pt = nn > 0;
      if (ae.value && de.value === 0 && !a.value && !Pt || !I.value && !st(me.target, Pt))
        return;
      if ((Pe = q?.value) == null || Pe.$el.classList.add(y2), I.value = !0, xt((Qe = q.value) == null ? void 0 : Qe.$el, {
        transition: "none"
      }), xt((Je = w.value) == null ? void 0 : Je.$el, {
        transition: "none"
      }), ae.value && ee({ draggedDistance: nn }), Pt && !ae.value) {
        const tr = oq(nn);
        xt((rt = q.value) == null ? void 0 : rt.$el, {
          transform: `translate3d(0, ${Math.min(tr * -1, 0)}px, 0)`
        });
        return;
      }
      const cn = Math.abs(nn), Ln = document.querySelector("[vaul-drawer-wrapper]");
      let Kt = cn / Q.value;
      const Fn = Ee(
        cn,
        Pt
      );
      Fn !== null && (Kt = Fn);
      const kr = 1 - Kt;
      if ((be.value || m.value && de.value === m.value - 1) && (e(Kt), xt(
        (et = w.value) == null ? void 0 : et.$el,
        {
          opacity: `${kr}`,
          transition: "none"
        },
        !0
      )), Ln && w.value && u.value) {
        const tr = Math.min(Ne() + Kt * (1 - Ne()), 1), On = 8 - Kt * 8, V = Math.max(0, 14 - Kt * 14);
        xt(
          Ln,
          {
            borderRadius: `${On}px`,
            transform: `scale(${tr}) translate3d(0, ${V}px, 0)`,
            transition: "none"
          },
          !0
        );
      }
      ae.value || xt((ht = q.value) == null ? void 0 : ht.$el, {
        transform: `translate3d(0, ${cn}px, 0)`
      });
    }
  }
  function ve() {
    var me;
    if (!q.value)
      return;
    const Pe = document.querySelector("[vaul-drawer-wrapper]"), Qe = Yd(q.value.$el);
    xt(q.value.$el, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`
    }), xt((me = w.value) == null ? void 0 : me.$el, {
      transition: `opacity ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`,
      opacity: "1"
    }), u.value && Qe && Qe > 0 && g.value && xt(
      Pe,
      {
        borderRadius: `${v2}px`,
        overflow: "hidden",
        transform: `scale(${Ne()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${mt.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${mt.EASE.join(",")})`
      },
      !0
    );
  }
  function _e() {
    var me;
    q.value && (xt(q.value.$el, {
      transform: "translate3d(0, 100%, 0)",
      transition: `transform ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`
    }), xt((me = w.value) == null ? void 0 : me.$el, {
      opacity: "0",
      transition: `opacity ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`
    }), Se(!1), ct(), window.setTimeout(() => {
      $.value = !1, g.value = !1;
    }, 300), window.setTimeout(() => {
      ae.value && (h.value = ae.value[0]);
    }, mt.DURATION * 1e3));
  }
  vt(() => {
    if (!g.value && u.value && eq) {
      const me = setTimeout(() => {
        Zd(document.body);
      }, 200);
      return () => clearTimeout(me);
    }
  });
  function ye(me) {
    if (!C.value || !q.value)
      return;
    q.value.$el.classList.remove(y2), I.value = !1, C.value = !1, N.value = /* @__PURE__ */ new Date();
    const Pe = Yd(q.value.$el);
    if (!st(me.target, !1) || !Pe || Number.isNaN(Pe) || A.value === null)
      return;
    const Qe = N.value.getTime() - A.value.getTime(), Je = L.value - me.screenY, rt = Math.abs(Je) / Qe;
    if (rt > 0.05 && (S.value = !0, window.setTimeout(() => {
      S.value = !1;
    }, 200)), ae.value) {
      ne({
        draggedDistance: Je,
        closeDrawer: _e,
        velocity: rt,
        dismissible: a.value
      }), t(!0);
      return;
    }
    if (Je > 0) {
      ve(), t(!0);
      return;
    }
    if (rt > x5) {
      _e(), t(!1);
      return;
    }
    const et = Math.min(
      q.value.$el.getBoundingClientRect().height ?? 0,
      window.innerHeight
    );
    if (Pe >= et * p.value) {
      _e(), t(!1);
      return;
    }
    t(!0), ve();
  }
  De(g, (me) => {
    me && (T.value = /* @__PURE__ */ new Date(), Se(!0)), o(me);
  }, { immediate: !0 }), De(i, (me) => {
    me ? (g.value = me, v.value = !0) : _e();
  }, { immediate: !0 });
  function Se(me) {
    const Pe = document.querySelector("[vaul-drawer-wrapper]");
    !Pe || !u.value || (me ? (xt(document.body, {
      background: document.body.style.backgroundColor || document.body.style.background
    }), xt(
      document.body,
      {
        background: "black"
      },
      !0
    ), xt(Pe, {
      borderRadius: `${v2}px`,
      overflow: "hidden",
      transform: `scale(${Ne()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
      transformOrigin: "top",
      transitionProperty: "transform, border-radius",
      transitionDuration: `${mt.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${mt.EASE.join(",")})`
    })) : (Zd(Pe, "overflow"), Zd(Pe, "transform"), Zd(Pe, "borderRadius"), xt(Pe, {
      transitionProperty: "transform, border-radius",
      transitionDuration: `${mt.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${mt.EASE.join(",")})`
    })));
  }
  function se(me) {
    var Pe, Qe;
    const Je = me ? (window.innerWidth - vi) / window.innerWidth : 1, rt = me ? -vi : 0;
    P.value && window.clearTimeout(P.value), xt((Pe = q.value) == null ? void 0 : Pe.$el, {
      transition: `transform ${mt.DURATION}s cubic-bezier(${mt.EASE.join(",")})`,
      transform: `scale(${Je}) translate3d(0, ${rt}px, 0)`
    }), !me && (Qe = q.value) != null && Qe.$el && (P.value = window.setTimeout(() => {
      var et, ht;
      xt((et = q.value) == null ? void 0 : et.$el, {
        transition: "none",
        transform: `translate3d(0, ${Yd((ht = q.value) == null ? void 0 : ht.$el)}px, 0)`
      });
    }, 500));
  }
  function Ke(me) {
    var Pe;
    if (me < 0)
      return;
    const Qe = (window.innerWidth - vi) / window.innerWidth, Je = Qe + me * (1 - Qe), rt = -vi + me * vi;
    xt((Pe = q.value) == null ? void 0 : Pe.$el, {
      transform: `scale(${Je}) translate3d(0, ${rt}px, 0)`,
      transition: "none"
    });
  }
  function ut(me) {
    var Pe;
    const Qe = me ? (window.innerWidth - vi) / window.innerWidth : 1, Je = me ? -vi : 0;
    me && xt((Pe = q.value) == null ? void 0 : Pe.$el, {
      transition: `transform ${mt.DURATION}s cubic-bezier(${mt.EASE.join(
        ","
      )})`,
      transform: `scale(${Qe}) translate3d(0, ${Je}px, 0)`
    });
  }
  return {
    open: i,
    isOpen: g,
    modal: d,
    keyboardIsOpen: H,
    hasBeenOpened: v,
    isVisible: $,
    drawerRef: q,
    drawerHeightRef: Q,
    overlayRef: w,
    isDragging: C,
    dragStartTime: A,
    isAllowedToDrag: I,
    snapPoints: ae,
    activeSnapPoint: h,
    pointerStartY: L,
    dismissible: a,
    snapPointsOffset: ke,
    shouldFade: be,
    fadeFromIndex: m,
    shouldScaleBackground: u,
    onPress: ce,
    onDrag: he,
    onRelease: ye,
    closeDrawer: _e,
    onNestedDrag: Ke,
    onNestedRelease: ut,
    onNestedOpenChange: se,
    emitClose: r,
    emitDrag: e,
    emitRelease: t,
    emitOpenChange: o,
    nested: s
  };
}
const fq = /* @__PURE__ */ _({
  __name: "DrawerRoot",
  props: {
    activeSnapPoint: { default: void 0 },
    closeThreshold: { default: sq },
    shouldScaleBackground: { type: Boolean, default: void 0 },
    scrollLockTimeout: { default: lq },
    fixed: { type: Boolean, default: void 0 },
    dismissible: { type: Boolean, default: !0 },
    modal: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: void 0 },
    nested: { type: Boolean, default: !1 },
    snapPoints: { default: void 0 },
    fadeFromIndex: { default: void 0 }
  },
  emits: ["drag", "release", "close", "update:open", "update:activeSnapPoint"],
  setup(n, { expose: e, emit: t }) {
    const r = n, o = t;
    Nc();
    const i = M(() => r.fadeFromIndex ?? (r.snapPoints && r.snapPoints.length - 1)), a = g2(r, "open", o, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    }), s = g2(r, "activeSnapPoint", o, {
      passive: r.activeSnapPoint === void 0
    }), l = {
      emitDrag: (m) => o("drag", m),
      emitRelease: (m) => o("release", m),
      emitClose: () => o("close"),
      emitOpenChange: (m) => {
        o("update:open", m);
      }
    }, { closeDrawer: d, hasBeenOpened: u, modal: f, isOpen: p } = rq(
      cq({
        ...l,
        ...at(r),
        activeSnapPoint: s,
        fadeFromIndex: i,
        open: a
      })
    );
    function h(m) {
      if (a.value !== void 0) {
        l.emitOpenChange(m);
        return;
      }
      m ? (u.value = !0, p.value = m) : d();
    }
    return e({
      open: p
    }), (m, g) => (b(), k(c(Wc), {
      open: c(p),
      modal: c(f),
      "onUpdate:open": h
    }, {
      default: y(() => [
        E(m.$slots, "default", { open: c(p) })
      ]),
      _: 3
    }, 8, ["open", "modal"]));
  }
}), pq = /* @__PURE__ */ _({
  __name: "DrawerOverlay",
  setup(n) {
    const { overlayRef: e, snapPoints: t, isVisible: r, isOpen: o, shouldFade: i } = $5(), a = M(() => {
      var s;
      return t && (((s = t.value) == null ? void 0 : s.length) ?? 0) > 0;
    });
    return (s, l) => (b(), k(c(Jm), {
      ref_key: "overlayRef",
      ref: e,
      "vaul-drawer-visible": c(r) ? "true" : "false",
      "vaul-overlay": "",
      "vaul-snap-points": c(o) && a.value ? "true" : "false",
      "vaul-snap-points-overlay": c(o) && c(i) ? "true" : "false"
    }, null, 8, ["vaul-drawer-visible", "vaul-snap-points", "vaul-snap-points-overlay"]));
  }
}), hq = /* @__PURE__ */ _({
  __name: "DrawerContent",
  setup(n) {
    const {
      open: e,
      isOpen: t,
      isVisible: r,
      snapPointsOffset: o,
      drawerRef: i,
      onPress: a,
      onDrag: s,
      onRelease: l,
      modal: d,
      emitOpenChange: u,
      dismissible: f,
      keyboardIsOpen: p,
      closeDrawer: h
    } = $5(), m = M(() => o.value && o.value.length > 0 ? `${o.value[0]}px` : "0");
    function g(v) {
      if (!d.value || v.defaultPrevented) {
        v.preventDefault();
        return;
      }
      p.value && (p.value = !1), v.preventDefault(), f.value && u(!1), !(!f.value || e.value !== void 0) && h();
    }
    return De(
      t,
      (v) => {
        v && setTimeout(() => {
          r.value = !0;
        }, 1);
      },
      { immediate: !0 }
    ), (v, $) => (b(), k(c(Gm), {
      ref_key: "drawerRef",
      ref: i,
      "vaul-drawer": "",
      "vaul-drawer-visible": c(r) ? "true" : "false",
      style: Zi({ "--snap-point-height": m.value }),
      onPointerdown: c(a),
      onPointermove: c(s),
      onPointerup: c(l),
      onPointerDownOutside: g,
      onEscapeKeyDown: $[0] || ($[0] = (C) => {
        c(f) || C.preventDefault();
      })
    }, {
      default: y(() => [
        E(v.$slots, "default")
      ]),
      _: 3
    }, 8, ["vaul-drawer-visible", "style", "onPointerdown", "onPointermove", "onPointerup"]));
  }
}), pZ = /* @__PURE__ */ _({
  __name: "Drawer",
  props: {
    activeSnapPoint: {},
    closeThreshold: {},
    shouldScaleBackground: { type: Boolean, default: !0 },
    scrollLockTimeout: {},
    fixed: { type: Boolean },
    dismissible: { type: Boolean },
    modal: { type: Boolean },
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    nested: { type: Boolean },
    snapPoints: {},
    fadeFromIndex: {}
  },
  emits: ["drag", "release", "close", "update:open", "update:activeSnapPoint"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(fq), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), mq = /* @__PURE__ */ _({
  __name: "DrawerOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(pq), j(t.value, {
      class: c(G)("fixed inset-0 z-50 bg-black/80", e.class)
    }), null, 16, ["class"]));
  }
}), hZ = /* @__PURE__ */ _({
  __name: "DrawerContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(n, { emit: e }) {
    const t = n, o = je(t, e);
    return (i, a) => (b(), k(c(Wm), null, {
      default: y(() => [
        x(mq),
        x(c(hq), j(c(o), {
          class: c(G)(
            `
          fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col
          rounded-t-[10px] border bg-background
        `,
            t.class
          )
        }), {
          default: y(() => [
            a[0] || (a[0] = O("div", { class: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }, null, -1)),
            E(i.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), mZ = /* @__PURE__ */ _({
  __name: "DrawerFooter",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("div", {
      class: fe(c(G)("mt-auto flex flex-col gap-2 p-4", e.class))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), gq = ["multiple", "accept", "disabled"], gZ = /* @__PURE__ */ _({
  __name: "FileSelector",
  props: {
    modelValue: {},
    multiple: { type: Boolean },
    accept: {},
    maxSize: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = B(null);
    function i() {
      o.value?.click();
    }
    function a(l) {
      return t?.maxSize === void 0 ? l : l.filter((d) => d.size <= t.maxSize);
    }
    Jn("openDialog", i), Jn("addFiles", (l) => {
      t.disabled || r("update:modelValue", t?.multiple ? [...t.modelValue, ...a(l)] : a(l));
    });
    function s() {
      const l = Array.from(o.value?.files || []);
      r("update:modelValue", t?.multiple ? [...a(l), ...t.modelValue] : a(l));
    }
    return (l, d) => (b(), D(Me, null, [
      O("input", {
        ref_key: "inputRef",
        ref: o,
        style: { display: "none" },
        type: "file",
        multiple: l.multiple,
        accept: l.accept?.join(", "),
        "aria-label": "Datei auswählen",
        disabled: l.disabled,
        onChange: s
      }, null, 40, gq),
      E(l.$slots, "default", { openDialog: i })
    ], 64));
  }
}), vZ = /* @__PURE__ */ _({
  __name: "FileSelectorDialogButton",
  setup(n) {
    const e = Kn("openDialog");
    return (t, r) => (b(), D("button", {
      onClick: r[0] || (r[0] = //@ts-ignore
      (...o) => c(e) && c(e)(...o))
    }, [
      E(t.$slots, "default")
    ]));
  }
}), yZ = /* @__PURE__ */ _({
  __name: "FileSelectorDropzone",
  setup(n) {
    const e = B(!1), t = Kn("addFiles");
    function r(a) {
      if (e.value = !1, !a.dataTransfer?.files)
        return;
      const s = Array.from(a.dataTransfer?.files || []);
      t && t(s);
    }
    function o(a) {
      a.preventDefault(), e.value = !0;
    }
    function i() {
      e.value = !1;
    }
    return (a, s) => (b(), D("div", {
      onDragover: o,
      onDrop: At(r, ["stop", "prevent"]),
      onDragleave: i
    }, [
      E(a.$slots, "default", { hovered: e.value })
    ], 32));
  }
}), bZ = /* @__PURE__ */ _({
  __name: "HoverCard",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    openDelay: {},
    closeDelay: {}
  },
  emits: ["update:open"],
  setup(n, { emit: e }) {
    const o = je(n, e);
    return (i, a) => (b(), k(c(Mk), Le(Ve(c(o))), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), $Z = /* @__PURE__ */ _({
  __name: "HoverCardContent",
  props: {
    forceMount: { type: Boolean },
    side: {},
    sideOffset: { default: 4 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {},
    to: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(Dk), { to: o.to }, {
      default: y(() => [
        x(c(Rk), j(c(r), {
          class: c(G)(
            `
            z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground
            shadow-md outline-none
            data-[side=bottom]:slide-in-from-top-2
            data-[side=left]:slide-in-from-right-2
            data-[side=right]:slide-in-from-left-2
            data-[side=top]:slide-in-from-bottom-2
            data-[state=closed]:animate-out data-[state=closed]:fade-out-0
            data-[state=closed]:zoom-out-95
            data-[state=open]:animate-in data-[state=open]:fade-in-0
            data-[state=open]:zoom-in-95
          `,
            e.class
          )
        }), {
          default: y(() => [
            E(o.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["to"]));
  }
}), wZ = /* @__PURE__ */ _({
  __name: "HoverCardTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(Pk), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xZ = /* @__PURE__ */ _({
  __name: "LegacyTitleText",
  props: {
    class: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), D("h2", {
      class: fe(c(G)("text-fluid-xl font-bold text-primary", e.class ?? ""))
    }, [
      E(t.$slots, "default")
    ], 2));
  }
}), CZ = /* @__PURE__ */ _({
  __name: "RadioCardGroup",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(n) {
    const e = St(n, "modelValue"), t = M(() => e.value === null ? "" : String(e.value)), r = B(String(t.value));
    return De(r, (o) => {
      o === "" ? e.value = null : e.value = o;
    }, {
      immediate: !0
    }), (o, i) => (b(), k(c(C$), {
      modelValue: r.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => r.value = a),
      class: "space-y-4"
    }, {
      default: y(() => [
        E(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), vq = ["aria-label"], yq = { class: "mt-4 flex items-center sm:mt-0" }, bq = { class: "flex flex-col gap-y-4" }, $q = { class: "block sm:inline" }, kZ = /* @__PURE__ */ _({
  __name: "RadioCardGroupItem",
  props: {
    id: {},
    label: {},
    value: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (e, t) => (b(), D("label", {
      "aria-label": e.label,
      class: "relative block cursor-pointer items-center rounded-sm border border-border bg-background px-6 py-7 transition-shadow focus:outline-none has-[[disabled]]:cursor-not-allowed has-[[disabled]]:opacity-50 has-[[disabled]]:shadow-none hover:shadow-lg sm:flex sm:gap-x-8"
    }, [
      x(c(k$), {
        id: e.id,
        value: e.value,
        disabled: e.disabled
      }, null, 8, ["id", "value", "disabled"]),
      O("span", yq, [
        O("span", bq, [
          x(c(Oe), { tag: "h3" }, {
            default: y(() => [
              E(e.$slots, "title")
            ]),
            _: 3
          }),
          x(c(Oe), {
            tag: "span",
            paragraph: "label"
          }, {
            default: y(() => [
              O("span", $q, [
                E(e.$slots, "content")
              ])
            ]),
            _: 3
          })
        ])
      ])
    ], 8, vq));
  }
}), _Z = /* @__PURE__ */ _({
  __name: "Slider",
  props: {
    name: {},
    defaultValue: {},
    modelValue: {},
    disabled: { type: Boolean },
    orientation: {},
    dir: {},
    inverted: { type: Boolean },
    min: {},
    max: {},
    step: {},
    minStepsBetweenThumbs: {},
    asChild: { type: Boolean },
    as: {},
    id: {},
    class: {},
    variant: {}
  },
  emits: ["update:modelValue", "valueCommit"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(V_), j({
      class: c(G)(
        "relative flex w-full touch-none select-none items-center",
        t.class
      )
    }, c(i)), {
      default: y(() => [
        x(c(H_), {
          class: fe(c(G)(c(wq)({ variant: a.variant })))
        }, {
          default: y(() => [
            x(c(U_), {
              class: fe(c(G)(c(xq)({ variant: a.variant })))
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["class"]),
        (b(!0), D(Me, null, it(a.modelValue, (l, d) => (b(), k(c(j_), {
          key: d,
          class: fe(c(G)(c(Cq)({ variant: a.variant }))),
          "aria-label": `${a.id}-${d}`
        }, null, 8, ["class", "aria-label"]))), 128))
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), wq = tn(
  ["relative h-0.5 w-full grow overflow-hidden rounded-full"],
  {
    variants: {
      variant: {
        primary: "bg-primary/20",
        outline: "bg-primary/20"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), xq = tn(
  ["absolute h-full"],
  {
    variants: {
      variant: {
        primary: "bg-primary",
        outline: "bg-primary"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), Cq = tn(
  [`
    block size-8 rounded-full border border-primary bg-primary
    ring-offset-background transition-colors
    disabled:pointer-events-none disabled:opacity-50
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
    focus-visible:ring-offset-2
  `],
  {
    variants: {
      variant: {
        primary: "bg-primary",
        outline: `
          bg-background
          hover:border-primary
        `
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), kq = {}, _q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
};
function Sq(n, e) {
  return b(), D("svg", _q, e[0] || (e[0] = [
    Cm('<g><circle cx="12" cy="3" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate0" attributeName="r" begin="0;svgSpinners12DotsScaleRotate2.end-0.5s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="16.5" cy="4.21" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate1" attributeName="r" begin="svgSpinners12DotsScaleRotate0.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="7.5" cy="4.21" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate2" attributeName="r" begin="svgSpinners12DotsScaleRotate4.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="19.79" cy="7.5" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate3" attributeName="r" begin="svgSpinners12DotsScaleRotate1.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="4.21" cy="7.5" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate4" attributeName="r" begin="svgSpinners12DotsScaleRotate6.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="21" cy="12" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate5" attributeName="r" begin="svgSpinners12DotsScaleRotate3.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="3" cy="12" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate6" attributeName="r" begin="svgSpinners12DotsScaleRotate8.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="19.79" cy="16.5" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate7" attributeName="r" begin="svgSpinners12DotsScaleRotate5.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="4.21" cy="16.5" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate8" attributeName="r" begin="svgSpinners12DotsScaleRotatea.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="16.5" cy="19.79" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotate9" attributeName="r" begin="svgSpinners12DotsScaleRotate7.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="7.5" cy="19.79" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotatea" attributeName="r" begin="svgSpinners12DotsScaleRotateb.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><circle cx="12" cy="21" r="1" fill="currentColor"><animate id="svgSpinners12DotsScaleRotateb" attributeName="r" begin="svgSpinners12DotsScaleRotate9.begin+0.1s" calcMode="spline" dur="0.6s" keySplines=".27,.42,.37,.99;.53,0,.61,.73" values="1;2;1"></animate></circle><animateTransform attributeName="transform" dur="6s" repeatCount="indefinite" type="rotate" values="360 12 12;0 12 12"></animateTransform></g>', 1)
  ]));
}
const SZ = /* @__PURE__ */ Yi(kq, [["render", Sq]]), Eq = {}, Oq = {
  role: "list",
  class: "divide-y divide-border @container"
};
function Tq(n, e) {
  return b(), D("ul", Oq, [
    E(n.$slots, "default")
  ]);
}
const EZ = /* @__PURE__ */ Yi(Eq, [["render", Tq]]), Aq = {}, Mq = { class: "p-6 @lg:p-10" };
function Nq(n, e) {
  return b(), D("li", Mq, [
    E(n.$slots, "default")
  ]);
}
const OZ = /* @__PURE__ */ Yi(Aq, [["render", Nq]]), Pq = { class: "flex items-center" }, TZ = /* @__PURE__ */ _({
  __name: "StatusLabel",
  props: {
    indicator: {},
    color: {},
    class: {}
  },
  setup(n) {
    return (e, t) => (b(), D("dl", {
      class: fe(["flex items-center", c(G)(c(Dq)({ color: e.color }), e.$props.class ?? "")])
    }, [
      t[0] || (t[0] = O("dt", { class: "sr-only" }, " Status ", -1)),
      O("dd", Pq, [
        E(e.$slots, "indicator-pre", {}, () => [
          e.indicator === "pre" ? (b(), k(c(ju), {
            key: 0,
            class: "mr-1 size-4"
          })) : X("", !0)
        ]),
        x(c(Oe), {
          tag: "span",
          paragraph: "label"
        }),
        E(e.$slots, "default"),
        E(e.$slots, "indicator-post", {}, () => [
          e.indicator === "post" ? (b(), k(c(ju), {
            key: 0,
            class: "ml-1 size-4"
          })) : X("", !0)
        ])
      ])
    ], 2));
  }
}), Dq = tn(
  [""],
  {
    variants: {
      color: {
        green: "text-success",
        red: "text-destructive",
        yellow: "text-warning",
        neutral: "text-muted-foreground"
      }
    },
    defaultVariants: {
      color: "neutral"
    }
  }
), AZ = /* @__PURE__ */ _({
  __name: "Tabs",
  props: {
    defaultValue: {},
    orientation: {},
    dir: {},
    activationMode: {},
    modelValue: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(Z_), j(c(i), {
      class: c(G)(
        `
        overflow-hidden rounded-md bg-background
        md:rounded-lg
      `,
        t.class
      )
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), MZ = /* @__PURE__ */ _({
  __name: "TabsContent",
  props: {
    value: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(X_), j({
      class: c(G)(`
      mt-5 space-y-4 p-6 ring-offset-background
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
      focus-visible:ring-offset-2
    `, e.class)
    }, t.value), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), NZ = /* @__PURE__ */ _({
  __name: "TabsList",
  props: {
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(Y_), j(t.value, {
      class: c(G)(
        `
        inline-flex items-center justify-between divide-x-2 divide-background
        bg-muted text-muted-foreground
      `,
        e.class
      )
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Iq = {
  key: 0,
  class: "transition-color grid size-8 place-items-center rounded-full text-sm text-primary-foreground md:mr-4"
}, Rq = { class: "hidden md:block" }, PZ = /* @__PURE__ */ _({
  __name: "TabsTrigger",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {},
    number: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: o, ...i } = e;
      return i;
    }), r = pt(t);
    return (o, i) => (b(), k(c(Q_), j(c(r), {
      class: c(G)(
        `
        transition-color inline-flex w-full items-center justify-center
        whitespace-nowrap bg-background/60 py-4 text-sm font-medium
        text-foreground ring-offset-background transition-all
        [&>span]:bg-foreground [&>span]:data-[state=active]:bg-primary
        dark:data-[state=active]:text-primary
        data-[state=active]:bg-background data-[state=active]:text-foreground
        disabled:pointer-events-none disabled:opacity-50
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
        focus-visible:ring-offset-2
        md:py-8
      `,
        e.class
      )
    }), {
      default: y(() => [
        o.number ? (b(), D("span", Iq, U(o.number), 1)) : X("", !0),
        O("div", Rq, [
          E(o.$slots, "default")
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), DZ = /* @__PURE__ */ _({
  __name: "Toast",
  props: {
    class: {},
    variant: {},
    onOpenChange: { type: Function },
    defaultOpen: { type: Boolean },
    forceMount: { type: Boolean },
    type: {},
    open: { type: Boolean },
    duration: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pause", "resume", "swipeStart", "swipeMove", "swipeCancel", "swipeEnd", "update:open"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(cS), j(c(i), {
      class: c(G)(c(zq)({ variant: a.variant }), t.class),
      "onUpdate:open": a.onOpenChange
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "onUpdate:open"]));
  }
}), IZ = /* @__PURE__ */ _({
  __name: "ToastAction",
  props: {
    altText: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(fS), j(t.value, {
      class: c(G)(`
      inline-flex h-8 shrink-0 items-center justify-center rounded-md border
      bg-transparent px-3 text-sm font-medium ring-offset-background
      transition-colors
      disabled:pointer-events-none disabled:opacity-50
      focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
      group-[.destructive]:border-muted/40
      group-[.destructive]:hover:border-destructive/30
      group-[.destructive]:hover:bg-destructive
      group-[.destructive]:hover:text-destructive-foreground
      group-[.destructive]:focus:ring-destructive
      hover:bg-secondary
    `, e.class)
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), RZ = /* @__PURE__ */ _({
  __name: "ToastClose",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(g3), j(t.value, {
      class: c(G)(`
      absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0
      transition-opacity
      focus:opacity-100 focus:outline-none focus:ring-2
      group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50
      group-[.destructive]:focus:ring-red-400
      group-[.destructive]:focus:ring-offset-red-600
      group-hover:opacity-100
      hover:text-foreground
    `, e.class)
    }), {
      default: y(() => [
        E(r.$slots, "icon")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), BZ = /* @__PURE__ */ _({
  __name: "ToastDescription",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(mS), j({
      class: c(G)("text-sm opacity-90", e.class)
    }, t.value), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), LZ = /* @__PURE__ */ _({
  __name: "ToastProvider",
  props: {
    label: {},
    duration: {},
    swipeDirection: {},
    swipeThreshold: {}
  },
  setup(n) {
    const e = n;
    return (t, r) => (b(), k(c(tS), Le(Ve(e)), {
      default: y(() => [
        E(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), FZ = /* @__PURE__ */ _({
  __name: "ToastTitle",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(hS), j(t.value, {
      class: c(G)("text-sm font-semibold", e.class)
    }), {
      default: y(() => [
        E(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), VZ = /* @__PURE__ */ _({
  __name: "ToastViewport",
  props: {
    hotkey: {},
    label: { type: [String, Function] },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(n) {
    const e = n, t = M(() => {
      const { class: r, ...o } = e;
      return o;
    });
    return (r, o) => (b(), k(c(pS), j(t.value, {
      class: c(G)(`
      fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4
      md:max-w-[420px]
      sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col
    `, e.class)
    }), null, 16, ["class"]));
  }
}), Bq = 5, Lq = 1e6, ho = {
  ADD_TOAST: "ADD_TOAST",
  UPDATE_TOAST: "UPDATE_TOAST",
  DISMISS_TOAST: "DISMISS_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST"
};
let Kp = 0;
function Fq() {
  return Kp = (Kp + 1) % Number.MAX_VALUE, Kp.toString();
}
const Wp = /* @__PURE__ */ new Map();
function b2(n) {
  if (Wp.has(n))
    return;
  const e = setTimeout(() => {
    Wp.delete(n), ml({
      type: ho.REMOVE_TOAST,
      toastId: n
    });
  }, Lq);
  Wp.set(n, e);
}
const nr = B({
  toasts: []
});
function ml(n) {
  switch (n.type) {
    case ho.ADD_TOAST:
      nr.value.toasts = [n.toast, ...nr.value.toasts].slice(0, Bq);
      break;
    case ho.UPDATE_TOAST:
      nr.value.toasts = nr.value.toasts.map(
        (e) => e.id === n.toast.id ? { ...e, ...n.toast } : e
      );
      break;
    case ho.DISMISS_TOAST: {
      const { toastId: e } = n;
      e ? b2(e) : nr.value.toasts.forEach((t) => {
        b2(t.id);
      }), nr.value.toasts = nr.value.toasts.map(
        (t) => t.id === e || e === void 0 ? {
          ...t,
          open: !1
        } : t
      );
      break;
    }
    case ho.REMOVE_TOAST:
      n.toastId === void 0 ? nr.value.toasts = [] : nr.value.toasts = nr.value.toasts.filter((e) => e.id !== n.toastId);
      break;
  }
}
function Vq(n) {
  const e = Fq(), t = (o) => ml({
    type: ho.UPDATE_TOAST,
    toast: { ...o, id: e }
  }), r = () => ml({ type: ho.DISMISS_TOAST, toastId: e });
  return ml({
    type: ho.ADD_TOAST,
    toast: {
      ...n,
      id: e,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: e,
    dismiss: r,
    update: t
  };
}
function zZ() {
  return {
    toasts: M(() => nr.value.toasts),
    toast: Vq,
    dismiss: (n) => ml({ type: ho.DISMISS_TOAST, toastId: n })
  };
}
const zq = tn(
  `
    group pointer-events-auto relative flex w-full items-center justify-between
    space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg
    transition-all
    data-[state=closed]:animate-out data-[state=closed]:fade-out-80
    data-[state=closed]:slide-out-to-right-full
    data-[state=open]:animate-in data-[state=open]:slide-in-from-top-full
    data-[state=open]:sm:slide-in-from-bottom-full
    data-[swipe=cancel]:translate-x-0
    data-[swipe=end]:translate-x-[--reka-toast-swipe-end-x]
    data-[swipe=end]:animate-out
    data-[swipe=move]:translate-x-[--reka-toast-swipe-move-x]
    data-[swipe=move]:transition-none
  `,
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: `
                      destructive group border-destructive bg-destructive
                      text-destructive-foreground
                    `
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), jZ = /* @__PURE__ */ _({
  __name: "ToggleGroup",
  props: {
    rovingFocus: { type: Boolean },
    disabled: { type: Boolean },
    orientation: {},
    dir: {},
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    type: { default: "multiple" },
    modelValue: {},
    defaultValue: {},
    class: {},
    variant: {},
    size: {}
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e;
    Jn("toggleGroup", {
      variant: t.variant,
      size: t.size
    });
    const o = M(() => {
      const { class: a, ...s } = t;
      return s;
    }), i = je(o, r);
    return (a, s) => (b(), k(c(yS), j(c(i), {
      class: c(G)("flex items-center gap-1", t.class)
    }), {
      default: y(() => [
        E(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), HZ = /* @__PURE__ */ _({
  __name: "ToggleGroupItem",
  props: {
    value: {},
    defaultValue: { type: Boolean },
    pressed: { type: Boolean },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {},
    variant: {},
    size: {},
    styleLess: { type: Boolean }
  },
  setup(n) {
    const e = n, t = Kn("toggleGroup"), r = M(() => {
      const { class: i, variant: a, size: s, styleLess: l, ...d } = e;
      return d;
    }), o = pt(r);
    return (i, a) => (b(), k(c(bS), j(c(o), {
      class: i.styleLess ? "" : c(G)(c(_$)({
        variant: c(t)?.variant || i.variant,
        size: c(t)?.size || i.size
      }), e.class)
    }), {
      default: y(() => [
        E(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), jq = {}, Hq = { class: "grid grid-cols-[1fr_minmax(0,_75ch)_1fr] gap-4" }, Uq = { class: "relative col-start-1 col-end-2 flex justify-end @container" }, Kq = { class: "col-start-2 col-end-3" }, Wq = { class: "col-start-3 col-end-4" };
function qq(n, e, t, r, o, i) {
  return b(), D("div", Hq, [
    O("div", Uq, [
      E(n.$slots, "left")
    ]),
    O("div", Kq, [
      E(n.$slots, "default")
    ]),
    O("div", Wq, [
      E(n.$slots, "right")
    ])
  ]);
}
const UZ = /* @__PURE__ */ Yi(jq, [["render", qq]]), Gq = { class: "mx-auto max-w-8xl space-y-20 lg:space-y-40" }, Jq = {}, KZ = /* @__PURE__ */ _({
  ...Jq,
  __name: "Wrapper",
  setup(n) {
    return (e, t) => (b(), D("div", {
      class: fe(c(G)(`
      px-4
      lg:px-14
      md:px-6
    `, e.$attrs.class ?? ""))
    }, [
      O("div", Gq, [
        E(e.$slots, "default")
      ])
    ], 2));
  }
}), WZ = [
  "Button",
  "Card",
  "Input"
];
function Zq(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Yq(n, e) {
  for (; n.length < e; )
    n = "0" + n;
  return n;
}
function Xr(n, e) {
  var t, r, o;
  if (e.length === 0)
    return n;
  for (t = 0, o = e.length; t < o; t++)
    r = e.charCodeAt(t), n = (n << 5) - n + r, n |= 0;
  return n < 0 ? n * -2 : n;
}
function Xq(n, e, t) {
  return Object.keys(e).sort().reduce(r, n);
  function r(o, i) {
    return C5(o, e[i], i, t);
  }
}
function C5(n, e, t, r) {
  var o = Xr(Xr(Xr(n, t), Qq(e)), typeof e);
  if (e === null)
    return Xr(o, "null");
  if (e === void 0)
    return Xr(o, "undefined");
  if (typeof e == "object" || typeof e == "function") {
    if (r.indexOf(e) !== -1)
      return Xr(o, "[Circular]" + t);
    r.push(e);
    var i = Xq(o, e, r);
    if (!("valueOf" in e) || typeof e.valueOf != "function")
      return i;
    try {
      return Xr(i, String(e.valueOf()));
    } catch (a) {
      return Xr(i, "[valueOf exception]" + (a.stack || a.message));
    }
  }
  return Xr(o, e.toString());
}
function Qq(n) {
  return Object.prototype.toString.call(n);
}
function eG(n) {
  return Yq(C5(0, n, "", []).toString(16), 8);
}
var tG = eG;
const nG = /* @__PURE__ */ Zq(tG), Xd = () => nG(String(Date.now() / Math.random())), qZ = {
  created(n, { arg: e, value: t }) {
    if (!n.id && e === "prefix") {
      n.id = `${t}-${Xd()}`;
      return;
    }
    n.id || (n.id = Xd());
  },
  getSSRProps({ arg: n, value: e }) {
    return { id: n === "prefix" ? `${e}-${Xd}` : Xd() };
  }
};
function rG(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function $2(n) {
  return rG(n) || Array.isArray(n);
}
function oG() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function v1(n, e) {
  const t = Object.keys(n), r = Object.keys(e);
  if (t.length !== r.length)
    return !1;
  const o = JSON.stringify(Object.keys(n.breakpoints || {})), i = JSON.stringify(Object.keys(e.breakpoints || {}));
  return o !== i ? !1 : t.every((a) => {
    const s = n[a], l = e[a];
    return typeof s == "function" ? `${s}` == `${l}` : !$2(s) || !$2(l) ? s === l : v1(s, l);
  });
}
function w2(n) {
  return n.concat().sort((e, t) => e.name > t.name ? 1 : -1).map((e) => e.options);
}
function iG(n, e) {
  if (n.length !== e.length)
    return !1;
  const t = w2(n), r = w2(e);
  return t.every((o, i) => {
    const a = r[i];
    return v1(o, a);
  });
}
function y1(n) {
  return typeof n == "number";
}
function ym(n) {
  return typeof n == "string";
}
function Rf(n) {
  return typeof n == "boolean";
}
function x2(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function _t(n) {
  return Math.abs(n);
}
function b1(n) {
  return Math.sign(n);
}
function gl(n, e) {
  return _t(n - e);
}
function aG(n, e) {
  if (n === 0 || e === 0 || _t(n) <= _t(e))
    return 0;
  const t = gl(_t(n), _t(e));
  return _t(t / n);
}
function sG(n) {
  return Math.round(n * 100) / 100;
}
function td(n) {
  return nd(n).map(Number);
}
function pr(n) {
  return n[_d(n)];
}
function _d(n) {
  return Math.max(0, n.length - 1);
}
function $1(n, e) {
  return e === _d(n);
}
function C2(n, e = 0) {
  return Array.from(Array(n), (t, r) => e + r);
}
function nd(n) {
  return Object.keys(n);
}
function k5(n, e) {
  return [n, e].reduce((t, r) => (nd(r).forEach((o) => {
    const i = t[o], a = r[o], s = x2(i) && x2(a);
    t[o] = s ? k5(i, a) : a;
  }), t), {});
}
function bm(n, e) {
  return typeof e.MouseEvent < "u" && n instanceof e.MouseEvent;
}
function lG(n, e) {
  const t = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(l) {
    return i(l) / 2;
  }
  function i(l) {
    return e - l;
  }
  function a(l, d) {
    return ym(n) ? t[n](l) : n(e, l, d);
  }
  return {
    measure: a
  };
}
function rd() {
  let n = [];
  function e(o, i, a, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(i, a, s), l = () => o.removeEventListener(i, a, s);
    else {
      const d = o;
      d.addListener(a), l = () => d.removeListener(a);
    }
    return n.push(l), r;
  }
  function t() {
    n = n.filter((o) => o());
  }
  const r = {
    add: e,
    clear: t
  };
  return r;
}
function dG(n, e, t, r) {
  const o = rd(), i = 1e3 / 60;
  let a = null, s = 0, l = 0;
  function d() {
    o.add(n, "visibilitychange", () => {
      n.hidden && m();
    });
  }
  function u() {
    h(), o.clear();
  }
  function f(v) {
    if (!l)
      return;
    a || (a = v, t(), t());
    const $ = v - a;
    for (a = v, s += $; s >= i; )
      t(), s -= i;
    const C = s / i;
    r(C), l && (l = e.requestAnimationFrame(f));
  }
  function p() {
    l || (l = e.requestAnimationFrame(f));
  }
  function h() {
    e.cancelAnimationFrame(l), a = null, s = 0, l = 0;
  }
  function m() {
    a = null, s = 0;
  }
  return {
    init: d,
    destroy: u,
    start: p,
    stop: h,
    update: t,
    render: r
  };
}
function uG(n, e) {
  const t = e === "rtl", r = n === "y", o = r ? "y" : "x", i = r ? "x" : "y", a = !r && t ? -1 : 1, s = u(), l = f();
  function d(m) {
    const {
      height: g,
      width: v
    } = m;
    return r ? g : v;
  }
  function u() {
    return r ? "top" : t ? "right" : "left";
  }
  function f() {
    return r ? "bottom" : t ? "left" : "right";
  }
  function p(m) {
    return m * a;
  }
  return {
    scroll: o,
    cross: i,
    startEdge: s,
    endEdge: l,
    measureSize: d,
    direction: p
  };
}
function Ji(n = 0, e = 0) {
  const t = _t(n - e);
  function r(d) {
    return d < n;
  }
  function o(d) {
    return d > e;
  }
  function i(d) {
    return r(d) || o(d);
  }
  function a(d) {
    return i(d) ? r(d) ? n : e : d;
  }
  function s(d) {
    return t ? d - t * Math.ceil((d - e) / t) : d;
  }
  return {
    length: t,
    max: e,
    min: n,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function _5(n, e, t) {
  const {
    constrain: r
  } = Ji(0, n), o = n + 1;
  let i = a(e);
  function a(p) {
    return t ? _t((o + p) % o) : r(p);
  }
  function s() {
    return i;
  }
  function l(p) {
    return i = a(p), f;
  }
  function d(p) {
    return u().set(s() + p);
  }
  function u() {
    return _5(n, s(), t);
  }
  const f = {
    get: s,
    set: l,
    add: d,
    clone: u
  };
  return f;
}
function cG(n, e, t, r, o, i, a, s, l, d, u, f, p, h, m, g, v, $, C) {
  const {
    cross: S,
    direction: w
  } = n, T = ["INPUT", "SELECT", "TEXTAREA"], A = {
    passive: !1
  }, N = rd(), z = rd(), I = Ji(50, 225).constrain(h.measure(20)), P = {
    mouse: 300,
    touch: 400
  }, L = {
    mouse: 500,
    touch: 600
  }, H = m ? 43 : 25;
  let q = !1, Q = 0, ae = 0, de = !1, ne = !1, ke = !1, ee = !1;
  function be(se) {
    if (!C)
      return;
    function Ke(me) {
      (Rf(C) || C(se, me)) && ce(me);
    }
    const ut = e;
    N.add(ut, "dragstart", (me) => me.preventDefault(), A).add(ut, "touchmove", () => {
    }, A).add(ut, "touchend", () => {
    }).add(ut, "touchstart", Ke).add(ut, "mousedown", Ke).add(ut, "touchcancel", ve).add(ut, "contextmenu", ve).add(ut, "click", _e, !0);
  }
  function Ee() {
    N.clear(), z.clear();
  }
  function nt() {
    const se = ee ? t : e;
    z.add(se, "touchmove", he, A).add(se, "touchend", ve).add(se, "mousemove", he, A).add(se, "mouseup", ve);
  }
  function ct(se) {
    const Ke = se.nodeName || "";
    return T.includes(Ke);
  }
  function Ne() {
    return (m ? L : P)[ee ? "mouse" : "touch"];
  }
  function st(se, Ke) {
    const ut = f.add(b1(se) * -1), me = u.byDistance(se, !m).distance;
    return m || _t(se) < I ? me : v && Ke ? me * 0.5 : u.byIndex(ut.get(), 0).distance;
  }
  function ce(se) {
    const Ke = bm(se, r);
    ee = Ke, ke = m && Ke && !se.buttons && q, q = gl(o.get(), a.get()) >= 2, !(Ke && se.button !== 0) && (ct(se.target) || (de = !0, i.pointerDown(se), d.useFriction(0).useDuration(0), o.set(a), nt(), Q = i.readPoint(se), ae = i.readPoint(se, S), p.emit("pointerDown")));
  }
  function he(se) {
    if (!bm(se, r) && se.touches.length >= 2)
      return ve(se);
    const ut = i.readPoint(se), me = i.readPoint(se, S), Pe = gl(ut, Q), Qe = gl(me, ae);
    if (!ne && !ee && (!se.cancelable || (ne = Pe > Qe, !ne)))
      return ve(se);
    const Je = i.pointerMove(se);
    Pe > g && (ke = !0), d.useFriction(0.3).useDuration(0.75), s.start(), o.add(w(Je)), se.preventDefault();
  }
  function ve(se) {
    const ut = u.byDistance(0, !1).index !== f.get(), me = i.pointerUp(se) * Ne(), Pe = st(w(me), ut), Qe = aG(me, Pe), Je = H - 10 * Qe, rt = $ + Qe / 50;
    ne = !1, de = !1, z.clear(), d.useDuration(Je).useFriction(rt), l.distance(Pe, !m), ee = !1, p.emit("pointerUp");
  }
  function _e(se) {
    ke && (se.stopPropagation(), se.preventDefault(), ke = !1);
  }
  function ye() {
    return de;
  }
  return {
    init: be,
    destroy: Ee,
    pointerDown: ye
  };
}
function fG(n, e) {
  let r, o;
  function i(f) {
    return f.timeStamp;
  }
  function a(f, p) {
    const m = `client${(p || n.scroll) === "x" ? "X" : "Y"}`;
    return (bm(f, e) ? f : f.touches[0])[m];
  }
  function s(f) {
    return r = f, o = f, a(f);
  }
  function l(f) {
    const p = a(f) - a(o), h = i(f) - i(r) > 170;
    return o = f, h && (r = f), p;
  }
  function d(f) {
    if (!r || !o)
      return 0;
    const p = a(o) - a(r), h = i(f) - i(r), m = i(f) - i(o) > 170, g = p / h;
    return h && !m && _t(g) > 0.1 ? g : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: d,
    readPoint: a
  };
}
function pG() {
  function n(t) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: i,
      offsetHeight: a
    } = t;
    return {
      top: r,
      right: o + i,
      bottom: r + a,
      left: o,
      width: i,
      height: a
    };
  }
  return {
    measure: n
  };
}
function hG(n) {
  function e(r) {
    return n * (r / 100);
  }
  return {
    measure: e
  };
}
function mG(n, e, t, r, o, i, a) {
  const s = [n].concat(r);
  let l, d, u = [], f = !1;
  function p(v) {
    return o.measureSize(a.measure(v));
  }
  function h(v) {
    if (!i)
      return;
    d = p(n), u = r.map(p);
    function $(C) {
      for (const S of C) {
        if (f)
          return;
        const w = S.target === n, T = r.indexOf(S.target), A = w ? d : u[T], N = p(w ? n : r[T]);
        if (_t(N - A) >= 0.5) {
          v.reInit(), e.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((C) => {
      (Rf(i) || i(v, C)) && $(C);
    }), t.requestAnimationFrame(() => {
      s.forEach((C) => l.observe(C));
    });
  }
  function m() {
    f = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: m
  };
}
function gG(n, e, t, r, o, i) {
  let a = 0, s = 0, l = o, d = i, u = n.get(), f = 0;
  function p() {
    const A = r.get() - n.get(), N = !l;
    let z = 0;
    return N ? (a = 0, t.set(r), n.set(r), z = A) : (t.set(n), a += A / l, a *= d, u += a, n.add(a), z = u - f), s = b1(z), f = u, T;
  }
  function h() {
    const A = r.get() - e.get();
    return _t(A) < 1e-3;
  }
  function m() {
    return l;
  }
  function g() {
    return s;
  }
  function v() {
    return a;
  }
  function $() {
    return S(o);
  }
  function C() {
    return w(i);
  }
  function S(A) {
    return l = A, T;
  }
  function w(A) {
    return d = A, T;
  }
  const T = {
    direction: g,
    duration: m,
    velocity: v,
    seek: p,
    settled: h,
    useBaseFriction: C,
    useBaseDuration: $,
    useFriction: w,
    useDuration: S
  };
  return T;
}
function vG(n, e, t, r, o) {
  const i = o.measure(10), a = o.measure(50), s = Ji(0.1, 0.99);
  let l = !1;
  function d() {
    return !(l || !n.reachedAny(t.get()) || !n.reachedAny(e.get()));
  }
  function u(h) {
    if (!d())
      return;
    const m = n.reachedMin(e.get()) ? "min" : "max", g = _t(n[m] - e.get()), v = t.get() - e.get(), $ = s.constrain(g / a);
    t.subtract(v * $), !h && _t(v) < i && (t.set(n.constrain(t.get())), r.useDuration(25).useBaseFriction());
  }
  function f(h) {
    l = !h;
  }
  return {
    shouldConstrain: d,
    constrain: u,
    toggleActive: f
  };
}
function yG(n, e, t, r, o) {
  const i = Ji(-e + n, 0), a = f(), s = u(), l = p();
  function d(m, g) {
    return gl(m, g) <= 1;
  }
  function u() {
    const m = a[0], g = pr(a), v = a.lastIndexOf(m), $ = a.indexOf(g) + 1;
    return Ji(v, $);
  }
  function f() {
    return t.map((m, g) => {
      const {
        min: v,
        max: $
      } = i, C = i.constrain(m), S = !g, w = $1(t, g);
      return S ? $ : w || d(v, C) ? v : d($, C) ? $ : C;
    }).map((m) => parseFloat(m.toFixed(3)));
  }
  function p() {
    if (e <= n + o)
      return [i.max];
    if (r === "keepSnaps")
      return a;
    const {
      min: m,
      max: g
    } = s;
    return a.slice(m, g);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function bG(n, e, t) {
  const r = e[0], o = t ? r - n : pr(e);
  return {
    limit: Ji(o, r)
  };
}
function $G(n, e, t, r) {
  const i = e.min + 0.1, a = e.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = Ji(i, a);
  function d(p) {
    return p === 1 ? l(t.get()) : p === -1 ? s(t.get()) : !1;
  }
  function u(p) {
    if (!d(p))
      return;
    const h = n * (p * -1);
    r.forEach((m) => m.add(h));
  }
  return {
    loop: u
  };
}
function wG(n) {
  const {
    max: e,
    length: t
  } = n;
  function r(i) {
    const a = i - e;
    return t ? a / -t : 0;
  }
  return {
    get: r
  };
}
function xG(n, e, t, r, o) {
  const {
    startEdge: i,
    endEdge: a
  } = n, {
    groupSlides: s
  } = o, l = f().map(e.measure), d = p(), u = h();
  function f() {
    return s(r).map((g) => pr(g)[a] - g[0][i]).map(_t);
  }
  function p() {
    return r.map((g) => t[i] - g[i]).map((g) => -_t(g));
  }
  function h() {
    return s(d).map((g) => g[0]).map((g, v) => g + l[v]);
  }
  return {
    snaps: d,
    snapsAligned: u
  };
}
function CG(n, e, t, r, o, i) {
  const {
    groupSlides: a
  } = o, {
    min: s,
    max: l
  } = r, d = u();
  function u() {
    const p = a(i), h = !n || e === "keepSnaps";
    return t.length === 1 ? [i] : h ? p : p.slice(s, l).map((m, g, v) => {
      const $ = !g, C = $1(v, g);
      if ($) {
        const S = pr(v[0]) + 1;
        return C2(S);
      }
      if (C) {
        const S = _d(i) - pr(v)[0] + 1;
        return C2(S, pr(v)[0]);
      }
      return m;
    });
  }
  return {
    slideRegistry: d
  };
}
function kG(n, e, t, r, o) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: s
  } = r;
  function l(m) {
    return m.concat().sort((g, v) => _t(g) - _t(v))[0];
  }
  function d(m) {
    const g = n ? a(m) : s(m), v = e.map((C, S) => ({
      diff: u(C - g, 0),
      index: S
    })).sort((C, S) => _t(C.diff) - _t(S.diff)), {
      index: $
    } = v[0];
    return {
      index: $,
      distance: g
    };
  }
  function u(m, g) {
    const v = [m, m + t, m - t];
    if (!n)
      return m;
    if (!g)
      return l(v);
    const $ = v.filter((C) => b1(C) === g);
    return $.length ? l($) : pr(v) - t;
  }
  function f(m, g) {
    const v = e[m] - o.get(), $ = u(v, g);
    return {
      index: m,
      distance: $
    };
  }
  function p(m, g) {
    const v = o.get() + m, {
      index: $,
      distance: C
    } = d(v), S = !n && i(v);
    if (!g || S)
      return {
        index: $,
        distance: m
      };
    const w = e[$] - C, T = m + u(w, 0);
    return {
      index: $,
      distance: T
    };
  }
  return {
    byDistance: p,
    byIndex: f,
    shortcut: u
  };
}
function _G(n, e, t, r, o, i, a) {
  function s(f) {
    const p = f.distance, h = f.index !== e.get();
    i.add(p), p && (r.duration() ? n.start() : (n.update(), n.render(1), n.update())), h && (t.set(e.get()), e.set(f.index), a.emit("select"));
  }
  function l(f, p) {
    const h = o.byDistance(f, p);
    s(h);
  }
  function d(f, p) {
    const h = e.clone().set(f), m = o.byIndex(h.get(), p);
    s(m);
  }
  return {
    distance: l,
    index: d
  };
}
function SG(n, e, t, r, o, i, a, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let d = 0;
  function u(h) {
    if (!s)
      return;
    function m(g) {
      if ((/* @__PURE__ */ new Date()).getTime() - d > 10)
        return;
      a.emit("slideFocusStart"), n.scrollLeft = 0;
      const C = t.findIndex((S) => S.includes(g));
      y1(C) && (o.useDuration(0), r.index(C, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", f, !1), e.forEach((g, v) => {
      i.add(g, "focus", ($) => {
        (Rf(s) || s(h, $)) && m(v);
      }, l);
    });
  }
  function f(h) {
    h.code === "Tab" && (d = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function Js(n) {
  let e = n;
  function t() {
    return e;
  }
  function r(l) {
    e = a(l);
  }
  function o(l) {
    e += a(l);
  }
  function i(l) {
    e -= a(l);
  }
  function a(l) {
    return y1(l) ? l : l.get();
  }
  return {
    get: t,
    set: r,
    add: o,
    subtract: i
  };
}
function S5(n, e) {
  const t = n.scroll === "x" ? a : s, r = e.style;
  let o = null, i = !1;
  function a(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function s(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function l(p) {
    if (i)
      return;
    const h = sG(n.direction(p));
    h !== o && (r.transform = t(h), o = h);
  }
  function d(p) {
    i = !p;
  }
  function u() {
    i || (r.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
  }
  return {
    clear: u,
    to: l,
    toggleActive: d
  };
}
function EG(n, e, t, r, o, i, a, s, l) {
  const u = td(o), f = td(o).reverse(), p = $().concat(C());
  function h(N, z) {
    return N.reduce((I, P) => I - o[P], z);
  }
  function m(N, z) {
    return N.reduce((I, P) => h(I, z) > 0 ? I.concat([P]) : I, []);
  }
  function g(N) {
    return i.map((z, I) => ({
      start: z - r[I] + 0.5 + N,
      end: z + e - 0.5 + N
    }));
  }
  function v(N, z, I) {
    const P = g(z);
    return N.map((L) => {
      const H = I ? 0 : -t, q = I ? t : 0, Q = I ? "end" : "start", ae = P[L][Q];
      return {
        index: L,
        loopPoint: ae,
        slideLocation: Js(-1),
        translate: S5(n, l[L]),
        target: () => s.get() > ae ? H : q
      };
    });
  }
  function $() {
    const N = a[0], z = m(f, N);
    return v(z, t, !1);
  }
  function C() {
    const N = e - a[0] - 1, z = m(u, N);
    return v(z, -t, !0);
  }
  function S() {
    return p.every(({
      index: N
    }) => {
      const z = u.filter((I) => I !== N);
      return h(z, e) <= 0.1;
    });
  }
  function w() {
    p.forEach((N) => {
      const {
        target: z,
        translate: I,
        slideLocation: P
      } = N, L = z();
      L !== P.get() && (I.to(L), P.set(L));
    });
  }
  function T() {
    p.forEach((N) => N.translate.clear());
  }
  return {
    canLoop: S,
    clear: T,
    loop: w,
    loopPoints: p
  };
}
function OG(n, e, t) {
  let r, o = !1;
  function i(l) {
    if (!t)
      return;
    function d(u) {
      for (const f of u)
        if (f.type === "childList") {
          l.reInit(), e.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((u) => {
      o || (Rf(t) || t(l, u)) && d(u);
    }), r.observe(n, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function TG(n, e, t, r) {
  const o = {};
  let i = null, a = null, s, l = !1;
  function d() {
    s = new IntersectionObserver((m) => {
      l || (m.forEach((g) => {
        const v = e.indexOf(g.target);
        o[v] = g;
      }), i = null, a = null, t.emit("slidesInView"));
    }, {
      root: n.parentElement,
      threshold: r
    }), e.forEach((m) => s.observe(m));
  }
  function u() {
    s && s.disconnect(), l = !0;
  }
  function f(m) {
    return nd(o).reduce((g, v) => {
      const $ = parseInt(v), {
        isIntersecting: C
      } = o[$];
      return (m && C || !m && !C) && g.push($), g;
    }, []);
  }
  function p(m = !0) {
    if (m && i)
      return i;
    if (!m && a)
      return a;
    const g = f(m);
    return m && (i = g), m || (a = g), g;
  }
  return {
    init: d,
    destroy: u,
    get: p
  };
}
function AG(n, e, t, r, o, i) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: l
  } = n, d = t[0] && o, u = m(), f = g(), p = t.map(a), h = v();
  function m() {
    if (!d)
      return 0;
    const C = t[0];
    return _t(e[s] - C[s]);
  }
  function g() {
    if (!d)
      return 0;
    const C = i.getComputedStyle(pr(r));
    return parseFloat(C.getPropertyValue(`margin-${l}`));
  }
  function v() {
    return t.map((C, S, w) => {
      const T = !S, A = $1(w, S);
      return T ? p[S] + u : A ? p[S] + f : w[S + 1][s] - C[s];
    }).map(_t);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: h,
    startGap: u,
    endGap: f
  };
}
function MG(n, e, t, r, o, i, a, s, l) {
  const {
    startEdge: d,
    endEdge: u,
    direction: f
  } = n, p = y1(t);
  function h($, C) {
    return td($).filter((S) => S % C === 0).map((S) => $.slice(S, S + C));
  }
  function m($) {
    return $.length ? td($).reduce((C, S, w) => {
      const T = pr(C) || 0, A = T === 0, N = S === _d($), z = o[d] - i[T][d], I = o[d] - i[S][u], P = !r && A ? f(a) : 0, L = !r && N ? f(s) : 0, H = _t(I - L - (z + P));
      return w && H > e + l && C.push(S), N && C.push($.length), C;
    }, []).map((C, S, w) => {
      const T = Math.max(w[S - 1] || 0);
      return $.slice(T, C);
    }) : [];
  }
  function g($) {
    return p ? h($, t) : m($);
  }
  return {
    groupSlides: g
  };
}
function NG(n, e, t, r, o, i, a) {
  const {
    align: s,
    axis: l,
    direction: d,
    startIndex: u,
    loop: f,
    duration: p,
    dragFree: h,
    dragThreshold: m,
    inViewThreshold: g,
    slidesToScroll: v,
    skipSnaps: $,
    containScroll: C,
    watchResize: S,
    watchSlides: w,
    watchDrag: T,
    watchFocus: A
  } = i, N = 2, z = pG(), I = z.measure(e), P = t.map(z.measure), L = uG(l, d), H = L.measureSize(I), q = hG(H), Q = lG(s, H), ae = !f && !!C, de = f || !!C, {
    slideSizes: ne,
    slideSizesWithGaps: ke,
    startGap: ee,
    endGap: be
  } = AG(L, I, P, t, de, o), Ee = MG(L, H, v, f, I, P, ee, be, N), {
    snaps: nt,
    snapsAligned: ct
  } = xG(L, Q, I, P, Ee), Ne = -pr(nt) + pr(ke), {
    snapsContained: st,
    scrollContainLimit: ce
  } = yG(H, Ne, ct, C, N), he = ae ? st : ct, {
    limit: ve
  } = bG(Ne, he, f), _e = _5(_d(he), u, f), ye = _e.clone(), Se = td(t), se = ({
    dragHandler: On,
    scrollBody: V,
    scrollBounds: F,
    options: {
      loop: Z
    }
  }) => {
    Z || F.constrain(On.pointerDown()), V.seek();
  }, Ke = ({
    scrollBody: On,
    translate: V,
    location: F,
    offsetLocation: Z,
    previousLocation: R,
    scrollLooper: J,
    slideLooper: oe,
    dragHandler: ue,
    animation: xe,
    eventHandler: Ze,
    scrollBounds: lt,
    options: {
      loop: tt
    }
  }, Et) => {
    const yt = On.settled(), Ft = !lt.shouldConstrain(), Tn = tt ? yt : yt && Ft, An = Tn && !ue.pointerDown();
    An && xe.stop();
    const ci = F.get() * Et + R.get() * (1 - Et);
    Z.set(ci), tt && (J.loop(On.direction()), oe.loop()), V.to(Z.get()), An && Ze.emit("settle"), Tn || Ze.emit("scroll");
  }, ut = dG(r, o, () => se(tr), (On) => Ke(tr, On)), me = 0.68, Pe = he[_e.get()], Qe = Js(Pe), Je = Js(Pe), rt = Js(Pe), et = Js(Pe), ht = gG(Qe, rt, Je, et, p, me), nn = kG(f, he, Ne, ve, et), Pt = _G(ut, _e, ye, ht, nn, et, a), cn = wG(ve), Ln = rd(), Kt = TG(e, t, a, g), {
    slideRegistry: Fn
  } = CG(ae, C, he, ce, Ee, Se), kr = SG(n, t, Fn, Pt, ht, Ln, a, A), tr = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: a,
    containerRect: I,
    slideRects: P,
    animation: ut,
    axis: L,
    dragHandler: cG(L, n, r, o, et, fG(L, o), Qe, ut, Pt, ht, nn, _e, a, q, h, m, $, me, T),
    eventStore: Ln,
    percentOfView: q,
    index: _e,
    indexPrevious: ye,
    limit: ve,
    location: Qe,
    offsetLocation: rt,
    previousLocation: Je,
    options: i,
    resizeHandler: mG(e, a, o, t, L, S, z),
    scrollBody: ht,
    scrollBounds: vG(ve, rt, et, ht, q),
    scrollLooper: $G(Ne, ve, rt, [Qe, rt, Je, et]),
    scrollProgress: cn,
    scrollSnapList: he.map(cn.get),
    scrollSnaps: he,
    scrollTarget: nn,
    scrollTo: Pt,
    slideLooper: EG(L, H, Ne, ne, ke, nt, he, rt, t),
    slideFocus: kr,
    slidesHandler: OG(e, a, w),
    slidesInView: Kt,
    slideIndexes: Se,
    slideRegistry: Fn,
    slidesToScroll: Ee,
    target: et,
    translate: S5(L, e)
  };
  return tr;
}
function PG() {
  let n = {}, e;
  function t(d) {
    e = d;
  }
  function r(d) {
    return n[d] || [];
  }
  function o(d) {
    return r(d).forEach((u) => u(e, d)), l;
  }
  function i(d, u) {
    return n[d] = r(d).concat([u]), l;
  }
  function a(d, u) {
    return n[d] = r(d).filter((f) => f !== u), l;
  }
  function s() {
    n = {};
  }
  const l = {
    init: t,
    emit: o,
    off: a,
    on: i,
    clear: s
  };
  return l;
}
const DG = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function IG(n) {
  function e(i, a) {
    return k5(i, a || {});
  }
  function t(i) {
    const a = i.breakpoints || {}, s = nd(a).filter((l) => n.matchMedia(l).matches).map((l) => a[l]).reduce((l, d) => e(l, d), {});
    return e(i, s);
  }
  function r(i) {
    return i.map((a) => nd(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(n.matchMedia);
  }
  return {
    mergeOptions: e,
    optionsAtMedia: t,
    optionsMediaQueries: r
  };
}
function RG(n) {
  let e = [];
  function t(i, a) {
    return e = a.filter(({
      options: s
    }) => n.optionsAtMedia(s).active !== !1), e.forEach((s) => s.init(i, n)), a.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    e = e.filter((i) => i.destroy());
  }
  return {
    init: t,
    destroy: r
  };
}
function Mc(n, e, t) {
  const r = n.ownerDocument, o = r.defaultView, i = IG(o), a = RG(i), s = rd(), l = PG(), {
    mergeOptions: d,
    optionsAtMedia: u,
    optionsMediaQueries: f
  } = i, {
    on: p,
    off: h,
    emit: m
  } = l, g = L;
  let v = !1, $, C = d(DG, Mc.globalOptions), S = d(C), w = [], T, A, N;
  function z() {
    const {
      container: Se,
      slides: se
    } = S;
    A = (ym(Se) ? n.querySelector(Se) : Se) || n.children[0];
    const ut = ym(se) ? A.querySelectorAll(se) : se;
    N = [].slice.call(ut || A.children);
  }
  function I(Se) {
    const se = NG(n, A, N, r, o, Se, l);
    if (Se.loop && !se.slideLooper.canLoop()) {
      const Ke = Object.assign({}, Se, {
        loop: !1
      });
      return I(Ke);
    }
    return se;
  }
  function P(Se, se) {
    v || (C = d(C, Se), S = u(C), w = se || w, z(), $ = I(S), f([C, ...w.map(({
      options: Ke
    }) => Ke)]).forEach((Ke) => s.add(Ke, "change", L)), S.active && ($.translate.to($.location.get()), $.animation.init(), $.slidesInView.init(), $.slideFocus.init(ye), $.eventHandler.init(ye), $.resizeHandler.init(ye), $.slidesHandler.init(ye), $.options.loop && $.slideLooper.loop(), A.offsetParent && N.length && $.dragHandler.init(ye), T = a.init(ye, w)));
  }
  function L(Se, se) {
    const Ke = Ee();
    H(), P(d({
      startIndex: Ke
    }, Se), se), l.emit("reInit");
  }
  function H() {
    $.dragHandler.destroy(), $.eventStore.clear(), $.translate.clear(), $.slideLooper.clear(), $.resizeHandler.destroy(), $.slidesHandler.destroy(), $.slidesInView.destroy(), $.animation.destroy(), a.destroy(), s.clear();
  }
  function q() {
    v || (v = !0, s.clear(), H(), l.emit("destroy"), l.clear());
  }
  function Q(Se, se, Ke) {
    !S.active || v || ($.scrollBody.useBaseFriction().useDuration(se === !0 ? 0 : S.duration), $.scrollTo.index(Se, Ke || 0));
  }
  function ae(Se) {
    const se = $.index.add(1).get();
    Q(se, Se, -1);
  }
  function de(Se) {
    const se = $.index.add(-1).get();
    Q(se, Se, 1);
  }
  function ne() {
    return $.index.add(1).get() !== Ee();
  }
  function ke() {
    return $.index.add(-1).get() !== Ee();
  }
  function ee() {
    return $.scrollSnapList;
  }
  function be() {
    return $.scrollProgress.get($.offsetLocation.get());
  }
  function Ee() {
    return $.index.get();
  }
  function nt() {
    return $.indexPrevious.get();
  }
  function ct() {
    return $.slidesInView.get();
  }
  function Ne() {
    return $.slidesInView.get(!1);
  }
  function st() {
    return T;
  }
  function ce() {
    return $;
  }
  function he() {
    return n;
  }
  function ve() {
    return A;
  }
  function _e() {
    return N;
  }
  const ye = {
    canScrollNext: ne,
    canScrollPrev: ke,
    containerNode: ve,
    internalEngine: ce,
    destroy: q,
    off: h,
    on: p,
    emit: m,
    plugins: st,
    previousScrollSnap: nt,
    reInit: g,
    rootNode: he,
    scrollNext: ae,
    scrollPrev: de,
    scrollProgress: be,
    scrollSnapList: ee,
    scrollTo: Q,
    selectedScrollSnap: Ee,
    slideNodes: _e,
    slidesInView: ct,
    slidesNotInView: Ne
  };
  return P(e, t), setTimeout(() => l.emit("init"), 0), ye;
}
Mc.globalOptions = void 0;
function w1(n = {}, e = []) {
  const t = Br(n), r = Br(e);
  let o = t ? n.value : n, i = r ? e.value : e;
  const a = Da(), s = Da();
  function l() {
    s.value && s.value.reInit(o, i);
  }
  return Ge(() => {
    !oG() || !a.value || (Mc.globalOptions = w1.globalOptions, s.value = Mc(a.value, o, i));
  }), xr(() => {
    s.value && s.value.destroy();
  }), t && De(n, (d) => {
    v1(o, d) || (o = d, l());
  }), r && De(e, (d) => {
    iG(i, d) || (i = d, l());
  }), [a, s];
}
w1.globalOptions = void 0;
const [BG, LG] = z5(
  ({
    opts: n,
    orientation: e,
    plugins: t
  }, r) => {
    const [o, i] = w1({
      ...n,
      axis: e === "horizontal" ? "x" : "y"
    }, t);
    function a() {
      i.value?.scrollPrev();
    }
    function s() {
      i.value?.scrollNext();
    }
    const l = B(!1), d = B(!1);
    function u(f) {
      l.value = f?.canScrollNext() || !1, d.value = f?.canScrollPrev() || !1;
    }
    return Ge(() => {
      i.value && (i.value?.on("init", u), i.value?.on("reInit", u), i.value?.on("select", u), r("init-api", i.value));
    }), { carouselRef: o, carouselApi: i, canScrollPrev: d, canScrollNext: l, scrollPrev: a, scrollNext: s, orientation: e };
  }
);
function Bf() {
  const n = LG();
  if (!n)
    throw new Error("useCarousel must be used within a <Carousel />");
  return n;
}
const GZ = /* @__PURE__ */ _({
  __name: "Carousel",
  props: {
    opts: {},
    plugins: {},
    orientation: { default: "horizontal" },
    class: {}
  },
  emits: ["init-api"],
  setup(n, { expose: e, emit: t }) {
    const r = n, o = t, { canScrollNext: i, canScrollPrev: a, carouselApi: s, carouselRef: l, orientation: d, scrollNext: u, scrollPrev: f } = BG(r, o);
    e({
      canScrollNext: i,
      canScrollPrev: a,
      carouselApi: s,
      carouselRef: l,
      orientation: d,
      scrollNext: u,
      scrollPrev: f
    });
    function p(h) {
      const m = r.orientation === "vertical" ? "ArrowUp" : "ArrowLeft", g = r.orientation === "vertical" ? "ArrowDown" : "ArrowRight";
      if (h.key === m) {
        h.preventDefault(), f();
        return;
      }
      h.key === g && (h.preventDefault(), u());
    }
    return (h, m) => (b(), D("div", {
      class: fe(c(G)("relative", r.class)),
      role: "region",
      "aria-roledescription": "carousel",
      tabindex: "0",
      onKeydown: p
    }, [
      E(h.$slots, "default", {
        canScrollNext: c(i),
        canScrollPrev: c(a),
        carouselApi: c(s),
        carouselRef: c(l),
        orientation: c(d),
        scrollNext: c(u),
        scrollPrev: c(f)
      })
    ], 34));
  }
}), JZ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CarouselContent",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, { carouselRef: t, orientation: r } = Bf();
    return (o, i) => (b(), D("div", {
      ref_key: "carouselRef",
      ref: t,
      class: "overflow-hidden"
    }, [
      O("div", j({
        class: c(G)(
          "flex",
          c(r) === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
          e.class
        )
      }, o.$attrs), [
        E(o.$slots, "default")
      ], 16)
    ], 512));
  }
}), ZZ = /* @__PURE__ */ _({
  __name: "CarouselItem",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, { orientation: t } = Bf();
    return (r, o) => (b(), D("div", {
      role: "group",
      "aria-roledescription": "slide",
      class: fe(c(G)(
        "min-w-0 shrink-0 grow-0 basis-full",
        c(t) === "horizontal" ? "pl-4" : "pt-4",
        e.class
      ))
    }, [
      E(r.$slots, "default")
    ], 2));
  }
}), YZ = /* @__PURE__ */ _({
  __name: "CarouselNext",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, { orientation: t, canScrollNext: r, scrollNext: o } = Bf();
    return (i, a) => (b(), k(c(Re), {
      disabled: !c(r),
      class: fe(c(G)(
        "absolute h-8 w-8 touch-manipulation rounded-full p-0",
        c(t) === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        e.class
      )),
      variant: "outline",
      onClick: c(o)
    }, {
      default: y(() => [
        E(i.$slots, "default", {}, () => [
          x(c(If), { class: "h-4 w-4 text-current" }),
          a[0] || (a[0] = O("span", { class: "sr-only" }, "Next Slide", -1))
        ])
      ]),
      _: 3
    }, 8, ["disabled", "class", "onClick"]));
  }
}), XZ = /* @__PURE__ */ _({
  __name: "CarouselPrevious",
  props: {
    class: {}
  },
  setup(n) {
    const e = n, { orientation: t, canScrollPrev: r, scrollPrev: o } = Bf();
    return (i, a) => (b(), k(c(Re), {
      disabled: !c(r),
      class: fe(c(G)(
        "absolute h-8 w-8 touch-manipulation rounded-full p-0",
        c(t) === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
        e.class
      )),
      variant: "outline",
      onClick: c(o)
    }, {
      default: y(() => [
        E(i.$slots, "default", {}, () => [
          x(c(kd), { class: "h-4 w-4 text-current" }),
          a[0] || (a[0] = O("span", { class: "sr-only" }, "Previous Slide", -1))
        ])
      ]),
      _: 3
    }, 8, ["disabled", "class", "onClick"]));
  }
}), QZ = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "Switch",
  props: /* @__PURE__ */ Mt({
    variant: {},
    defaultChecked: { type: Boolean },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    id: {},
    value: {},
    asChild: { type: Boolean },
    as: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Mt(["update:checked"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const o = je(n, e), i = St(n, "modelValue");
    return (a, s) => (b(), D("div", {
      class: fe(c(G)(c(FG)({ variant: a.variant })))
    }, [
      E(a.$slots, "default"),
      x(c(u3), j(c(o), {
        modelValue: i.value,
        "onUpdate:modelValue": s[0] || (s[0] = (l) => i.value = l),
        class: c(G)(
          c(VG)({ variant: a.variant }),
          a.$attrs.class ?? ""
        )
      }), {
        default: y(() => [
          x(c(c3), {
            class: fe(
              c(G)(
                c(zG)({ variant: a.variant })
              )
            )
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 16, ["modelValue", "class"])
    ], 2));
  }
}), FG = tn(
  [`
    inline-flex items-center space-x-16 rounded-sm px-4 py-2
    has-[:disabled]:border has-[:disabled]:border-muted-foreground
    has-[:disabled]:bg-transparent
  `],
  {
    variants: {
      variant: {
        primary: `
          bg-primary
          has-[:enabled]:text-primary-foreground
        `,
        outline: "border border-muted-foreground bg-transparent",
        ghost: "bg-transparent"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), VG = tn(
  [`
    group peer inline-flex h-8 w-16 shrink-0 cursor-pointer items-center
    rounded-full border transition-colors
    disabled:cursor-not-allowed disabled:border-muted-foreground
    disabled:bg-muted disabled:opacity-50
    disabled:focus-visible:outline-muted-foreground
  `, ...Ia],
  {
    variants: {
      variant: {
        primary: `
          border-background
          data-[state=checked]:bg-primary
          data-[state=unchecked]:bg-background/30
          focus-visible:outline-background
        `,
        outline: `
          border-foreground
          data-[state=checked]:bg-transparent
          data-[state=unchecked]:bg-foreground/20
          focus-visible:outline-foreground
        `,
        ghost: `
          border-transparent
          data-[state=checked]:border-primary data-[state=checked]:bg-primary
          data-[state=unchecked]:bg-foreground/20
        `
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), zG = tn(
  [`
    pointer-events-none block size-6 rounded-full shadow-lg ring-0
    transition-transform
    data-[state=checked]:translate-x-8.5
    data-[state=unchecked]:translate-x-1
    group-disabled:bg-muted-foreground
  `],
  {
    variants: {
      variant: {
        primary: "bg-background",
        outline: "bg-foreground",
        ghost: "bg-background"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), jG = {
  viewBox: "0 0 15 15",
  width: "1.2em",
  height: "1.2em"
};
function HG(n, e) {
  return b(), D("svg", jG, e[0] || (e[0] = [
    O("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.5 3a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3M3 5l.05-.002a2.5 2.5 0 0 0 4.9 0L8 5h5.5a.5.5 0 0 0 0-1H8l-.05.002a2.5 2.5 0 0 0-4.9 0L3 4H1.5a.5.5 0 0 0 0 1zm8.95 5.998a2.5 2.5 0 0 1-4.9 0L7 11H1.5a.5.5 0 0 1 0-1H7l.05.002a2.5 2.5 0 0 1 4.9 0L12 10h1.5a.5.5 0 0 1 0 1H12zM8 10.5a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const eY = { name: "radix-icons-mixer-horizontal", render: HG }, UG = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function KG(n, e) {
  return b(), D("svg", UG, e[0] || (e[0] = [
    O("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      O("path", { d: "M11.5 5c0 3-4.5 6.5-4.5 6.5S2.5 8 2.5 5C2.5 2.549 4.549.5 7 .5s4.5 2.049 4.5 4.5" }),
      O("path", { d: "M7 6.5a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3m4.077 3.5H12l1.5 3.5H.5L2 10h.923" })
    ], -1)
  ]));
}
const tY = { name: "streamline-location-pin-3", render: KG }, WG = {
  viewBox: "0 0 14 14",
  width: "1.2em",
  height: "1.2em"
};
function qG(n, e) {
  return b(), D("svg", WG, e[0] || (e[0] = [
    O("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 11.5a5.5 5.5 0 1 0 0-11a5.5 5.5 0 0 0 0 11m7.5 2L10 10"
    }, null, -1)
  ]));
}
const nY = { name: "streamline-magnifying-glass", render: qG };
export {
  dZ as Accordion,
  FW as AccordionContent,
  VW as AccordionItem,
  uZ as AccordionItemContainer,
  jW as AccordionTrigger,
  f5 as Add,
  MH as Alert,
  NH as AlertDescription,
  KJ as AlertTitle,
  tf as Badge,
  cZ as BookmarkButton,
  vK as Breadcrumb,
  wK as BreadcrumbEllipsis,
  Up as BreadcrumbItem,
  Re as Button,
  aA as Calendar,
  vl as Card,
  QG as CardComment,
  Lo as CardContent,
  z2 as CardFooter,
  eJ as CardGrid,
  yl as CardHeader,
  j2 as CardImageTeaser,
  tJ as CardPageTeaser,
  uJ as CardPostTeaser,
  fZ as CardTeaser,
  gu as CardTitle,
  GZ as Carousel,
  JZ as CarouselContent,
  ZZ as CarouselItem,
  YZ as CarouselNext,
  XZ as CarouselPrevious,
  mE as Check,
  nf as Checkbox,
  xs as ChevronDown,
  YK as Collapsible,
  XK as CollapsibleContent,
  QK as CollapsibleTrigger,
  h1 as Command,
  RJ as CommandDialog,
  p5 as CommandEmpty,
  dH as CommandGroup,
  h5 as CommandInput,
  m5 as CommandItem,
  g5 as CommandList,
  BJ as CommandSeparator,
  LJ as CommandShortcut,
  WZ as Components,
  NJ as ConfirmDialog,
  nJ as ContentLayout,
  UZ as ContentWrapper,
  DA as DatePicker,
  m1 as Dialog,
  l5 as DialogClose,
  Df as DialogContent,
  d5 as DialogDescription,
  u5 as DialogFooter,
  g1 as DialogHeader,
  PJ as DialogRoot,
  DJ as DialogScrollContent,
  c5 as DialogTitle,
  aH as DialogTrigger,
  pZ as Drawer,
  GC as DrawerClose,
  hZ as DrawerContent,
  mZ as DrawerFooter,
  _C as DrawerTrigger,
  DP as DropdownMenu,
  IP as DropdownMenuContent,
  CJ as DropdownMenuItem,
  kJ as DropdownMenuSeparator,
  LP as DropdownMenuTrigger,
  gZ as FileSelector,
  vZ as FileSelectorDialogButton,
  yZ as FileSelectorDropzone,
  cJ as Footer,
  tp as FooterBlock,
  gg as FooterContact,
  fJ as FooterSecondary,
  hJ as Form,
  yJ as FormCheckboxGroup,
  bJ as FormCheckboxSingle,
  Fr as FormControl,
  $J as FormDatePicker,
  _o as FormDescription,
  yr as FormField,
  mJ as FormFieldGroup,
  n$ as FormInput,
  br as FormItem,
  m0 as FormLabel,
  So as FormMessage,
  wJ as FormPhoneInput,
  xJ as FormRadioGroup,
  MJ as FormRichTextEditor,
  VJ as FormSearchableSelect,
  jJ as FormSelect,
  HJ as FormTextarea,
  Bx as Grid,
  bZ as HoverCard,
  $Z as HoverCardContent,
  wZ as HoverCardTrigger,
  ar as Image,
  oJ as ImageLeftRightTeaser,
  UJ as InlineFormInput,
  Rt as Input,
  dZ as KAccordion,
  FW as KAccordionContent,
  VW as KAccordionItem,
  uZ as KAccordionItemContainer,
  jW as KAccordionTrigger,
  MH as KAlert,
  NH as KAlertDescription,
  KJ as KAlertTitle,
  tf as KBadge,
  cZ as KBookmarkButton,
  vK as KBreadcrumb,
  wK as KBreadcrumbEllipsis,
  Up as KBreadcrumbItem,
  Re as KButton,
  aA as KCalendar,
  vl as KCard,
  Lo as KCardContent,
  z2 as KCardFooter,
  eJ as KCardGrid,
  yl as KCardHeader,
  uJ as KCardPostTeaser,
  fZ as KCardTeaser,
  gu as KCardTitle,
  GZ as KCarousel,
  JZ as KCarouselContent,
  ZZ as KCarouselItem,
  YZ as KCarouselNext,
  XZ as KCarouselPrevious,
  nf as KCheckbox,
  YK as KCollapsible,
  XK as KCollapsibleContent,
  QK as KCollapsibleTrigger,
  h1 as KCommand,
  RJ as KCommandDialog,
  p5 as KCommandEmpty,
  dH as KCommandGroup,
  h5 as KCommandInput,
  m5 as KCommandItem,
  g5 as KCommandList,
  BJ as KCommandSeparator,
  LJ as KCommandShortcut,
  NJ as KConfirmDialog,
  nJ as KContentLayout,
  DA as KDatePicker,
  m1 as KDialog,
  l5 as KDialogClose,
  Df as KDialogContent,
  d5 as KDialogDescription,
  u5 as KDialogFooter,
  g1 as KDialogHeader,
  PJ as KDialogRoot,
  DJ as KDialogScrollContent,
  c5 as KDialogTitle,
  aH as KDialogTrigger,
  pZ as KDrawer,
  GC as KDrawerClose,
  hZ as KDrawerContent,
  mZ as KDrawerFooter,
  _C as KDrawerTrigger,
  DP as KDropdownMenu,
  IP as KDropdownMenuContent,
  CJ as KDropdownMenuItem,
  kJ as KDropdownMenuSeparator,
  LP as KDropdownMenuTrigger,
  gZ as KFileSelector,
  vZ as KFileSelectorDialogButton,
  yZ as KFileSelectorDropzone,
  cJ as KFooter,
  fJ as KFooterSecondary,
  hJ as KForm,
  yJ as KFormCheckboxGroup,
  bJ as KFormCheckboxSingle,
  Fr as KFormControl,
  $J as KFormDatePicker,
  _o as KFormDescription,
  yr as KFormField,
  n$ as KFormInput,
  br as KFormItem,
  m0 as KFormLabel,
  So as KFormMessage,
  wJ as KFormPhoneInput,
  xJ as KFormRadioGroup,
  MJ as KFormRichTextEditor,
  VJ as KFormSearchableSelect,
  jJ as KFormSelect,
  HJ as KFormTextarea,
  Bx as KGrid,
  bZ as KHoverCard,
  $Z as KHoverCardContent,
  wZ as KHoverCardTrigger,
  ar as KImage,
  oJ as KImageLeftRightTeaser,
  UJ as KInlineFormInput,
  Rt as KInput,
  WJ as KKeycloakError,
  qJ as KKeycloakInfo,
  GJ as KKeycloakLogin,
  JJ as KKeycloakLoginExpired,
  ZJ as KKeycloakLogoutConfirm,
  YJ as KKeycloakPasswordReset,
  XJ as KKeycloakPasswordUpdate,
  QJ as KKeycloakRegister,
  eZ as KKeycloakTerms,
  tZ as KKeycloakVerifyEmail,
  HO as KLabel,
  rJ as KLayoutBlock,
  Ri as KLayoutInner,
  xZ as KLegacyTitleText,
  Ac as KLogo,
  nZ as KMainNavigation,
  iZ as KPageHeader,
  uf as KPopover,
  aZ as KPriceList,
  CZ as KRadioCardGroup,
  kZ as KRadioCardGroupItem,
  C$ as KRadioGroup,
  k$ as KRadioGroupItem,
  iH as KRichTextEditor,
  pH as KSelect,
  h2 as KSelectContent,
  hH as KSelectGroup,
  m2 as KSelectItem,
  mH as KSelectLabel,
  zJ as KSelectMiniTrigger,
  gH as KSelectRoot,
  CH as KSelectTrigger,
  kH as KSelectValue,
  FJ as KSimpleCommand,
  IJ as KSimpleDialog,
  YW as KSkeleton,
  _Z as KSlider,
  iJ as KSpecialPageTeaser,
  EZ as KStackedList,
  OZ as KStackedListItem,
  TZ as KStatusLabel,
  QZ as KSwitch,
  AZ as KTabs,
  MZ as KTabsContent,
  NZ as KTabsList,
  PZ as KTabsTrigger,
  sZ as KTeamMember,
  Oe as KText,
  OH as KTextarea,
  sE as KThemeSwitch,
  DZ as KToast,
  Nh as KToggle,
  jZ as KToggleGroup,
  HZ as KToggleGroupItem,
  SZ as KTwelveDotsScaleRotate,
  so as KValidationMessage,
  WJ as KeycloakError,
  qJ as KeycloakInfo,
  GJ as KeycloakLogin,
  JJ as KeycloakLoginExpired,
  ZJ as KeycloakLogoutConfirm,
  YJ as KeycloakPasswordReset,
  XJ as KeycloakPasswordUpdate,
  QJ as KeycloakRegister,
  eZ as KeycloakTerms,
  tZ as KeycloakVerifyEmail,
  HO as Label,
  rJ as LayoutBlock,
  Ri as LayoutInner,
  xZ as LegacyTitleText,
  tY as Location,
  tY as LocationPin,
  Ac as Logo,
  nZ as MainNavigation,
  eY as MixerHorizontal,
  rZ as MobileNavigation,
  iZ as PageHeader,
  uf as Popover,
  aZ as PriceList,
  CZ as RadioCardGroup,
  kZ as RadioCardGroupItem,
  C$ as RadioGroup,
  k$ as RadioGroupItem,
  iH as RichTextEditor,
  nY as Search,
  pH as Select,
  h2 as SelectContent,
  hH as SelectGroup,
  m2 as SelectItem,
  mH as SelectLabel,
  zJ as SelectMiniTrigger,
  gH as SelectRoot,
  CH as SelectTrigger,
  kH as SelectValue,
  FJ as SimpleCommand,
  IJ as SimpleDialog,
  YW as Skeleton,
  _Z as Slider,
  iJ as SpecialPageTeaser,
  EZ as StackedList,
  OZ as StackedListItem,
  TZ as StatusLabel,
  QZ as Switch,
  lZ as TOCNav,
  AZ as Tabs,
  MZ as TabsContent,
  NZ as TabsList,
  PZ as TabsTrigger,
  sZ as TeamMember,
  Oe as Text,
  OH as Textarea,
  sE as ThemeSwitch,
  DZ as Toast,
  IZ as ToastAction,
  RZ as ToastClose,
  BZ as ToastDescription,
  LZ as ToastProvider,
  FZ as ToastTitle,
  VZ as ToastViewport,
  Nh as Toggle,
  jZ as ToggleGroup,
  HZ as ToggleGroupItem,
  SZ as TwelveDotsScaleRotate,
  ZG as TypographyH1,
  YG as TypographyH2,
  XG as TypographyH3,
  Tx as TypographyP,
  so as ValidationMessage,
  KZ as Wrapper,
  G as cn,
  pJ as createFieldGroupSchema,
  vJ as createValidationSchema,
  Ic as textVariants,
  oZ as useBreadcrumb,
  Bf as useCarousel,
  fO as useForm,
  zZ as useToast,
  qZ as vId,
  gJ as z
};
//# sourceMappingURL=index.js.map
